/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: string;
  /** The day, does not include a time. */
  Date: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
};

export type ActiveModelInput = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  urn: Scalars['String'];
  version: Scalars['Int'];
};

export type AggregatedOrderAggregationType = {
  __typename?: 'AggregatedOrderAggregationType';
  aggregationValue?: Maybe<Scalars['String']>;
  columnName?: Maybe<Scalars['String']>;
  columnType?: Maybe<ColumnType>;
};

/** An input for mutations affecting `AggregatedOrderAggregationType` */
export type AggregatedOrderAggregationTypeInput = {
  aggregationValue?: InputMaybe<Scalars['String']>;
  columnName?: InputMaybe<Scalars['String']>;
  columnType?: InputMaybe<ColumnType>;
};

export type AggregatedOrderFilterType = {
  __typename?: 'AggregatedOrderFilterType';
  columnName?: Maybe<Scalars['String']>;
  columnType?: Maybe<ColumnType>;
  predicate?: Maybe<PredicateType>;
  predicateValues?: Maybe<Array<Scalars['String']>>;
};

/** An input for mutations affecting `AggregatedOrderFilterType` */
export type AggregatedOrderFilterTypeInput = {
  columnName?: InputMaybe<Scalars['String']>;
  columnType?: InputMaybe<ColumnType>;
  predicate?: InputMaybe<PredicateType>;
  predicateValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AggregatedOrderGroupingType = {
  __typename?: 'AggregatedOrderGroupingType';
  columnName?: Maybe<Scalars['String']>;
  columnType?: Maybe<ColumnType>;
};

/** An input for mutations affecting `AggregatedOrderGroupingType` */
export type AggregatedOrderGroupingTypeInput = {
  columnName?: InputMaybe<Scalars['String']>;
  columnType?: InputMaybe<ColumnType>;
};

export enum AggregatedOrderViewType {
  BarChart = 'BAR_CHART',
  DoughnutChart = 'DOUGHNUT_CHART',
  HorizontalBarChart = 'HORIZONTAL_BAR_CHART',
  LineChart = 'LINE_CHART',
  StackedBarChart = 'STACKED_BAR_CHART',
  StackedHorizontalBarChart = 'STACKED_HORIZONTAL_BAR_CHART',
  Table = 'TABLE'
}

/** A filter to be used against AggregatedOrderViewType fields. All fields are combined with a logical ‘and.’ */
export type AggregatedOrderViewTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AggregatedOrderViewType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AggregatedOrderViewType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AggregatedOrderViewType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AggregatedOrderViewType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AggregatedOrderViewType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AggregatedOrderViewType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AggregatedOrderViewType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AggregatedOrderViewType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AggregatedOrderViewType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AggregatedOrderViewType>>;
};

/** Plane equation coefficients (ax + by + cz + d = 0) */
export type AlgorithmGeometryPlane = {
  __typename?: 'AlgorithmGeometryPlane';
  a: Scalars['Float'];
  b: Scalars['Float'];
  c: Scalars['Float'];
  d: Scalars['Float'];
};

/** Geometry result for a single element */
export type AlgorithmGeometryResult = {
  __typename?: 'AlgorithmGeometryResult';
  /** The element dbId */
  dbId: Scalars['Int'];
  /** Polygon data for multipolygon results */
  multiPolygon?: Maybe<Scalars['JSON']>;
  /** Polyline data for multipolyline results */
  multiPolyline?: Maybe<Scalars['JSON']>;
  /** Plane equation for polygon results */
  plane?: Maybe<AlgorithmGeometryPlane>;
  /** Point data for coordinate results */
  point?: Maybe<Scalars['JSON']>;
  /** Triangles for mesh/triangulated surface results */
  triangles?: Maybe<Scalars['JSON']>;
  /** Result type (0=MULTIPOLYLINE, 1=TRIANGULATED_SURFACE, 2=MULTIPOLYGON, 3=MESH) */
  type: Scalars['Int'];
};

export type ApplyPromptLinkingInput = {
  activeModels?: InputMaybe<Array<ActiveModelInput>>;
  orderEntryIds: Array<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  prompt?: InputMaybe<Scalars['String']>;
  prompts?: InputMaybe<Array<Scalars['String']>>;
  usePromptForLinking: Scalars['Boolean'];
};

export type ApplyPromptLinkingPayload = {
  __typename?: 'ApplyPromptLinkingPayload';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AreaUnitSettingType = {
  __typename?: 'AreaUnitSettingType';
  rounding?: Maybe<RoundingEnum>;
  units?: Maybe<AreaUnitTypeEnum>;
};

/** A filter to be used against `AreaUnitSettingType` object types. All fields are combined with a logical ‘and.’ */
export type AreaUnitSettingTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaUnitSettingTypeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AreaUnitSettingTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaUnitSettingTypeFilter>>;
  /** Filter by the object’s `rounding` field. */
  rounding?: InputMaybe<RoundingEnumFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<AreaUnitTypeEnumFilter>;
};

/** An input for mutations affecting `AreaUnitSettingType` */
export type AreaUnitSettingTypeInput = {
  rounding?: InputMaybe<RoundingEnum>;
  units?: InputMaybe<AreaUnitTypeEnum>;
};

export enum AreaUnitTypeEnum {
  CentimetersSquared = 'CENTIMETERS_SQUARED',
  DecimalFeetSquared = 'DECIMAL_FEET_SQUARED',
  DecimalInchesSquared = 'DECIMAL_INCHES_SQUARED',
  DecimetersSquared = 'DECIMETERS_SQUARED',
  FeetAndFractionalInchesSquared = 'FEET_AND_FRACTIONAL_INCHES_SQUARED',
  FractionalInchesSquared = 'FRACTIONAL_INCHES_SQUARED',
  MetersSquared = 'METERS_SQUARED',
  MillimetersSquared = 'MILLIMETERS_SQUARED'
}

/** A filter to be used against AreaUnitTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type AreaUnitTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AreaUnitTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AreaUnitTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AreaUnitTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AreaUnitTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AreaUnitTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AreaUnitTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AreaUnitTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AreaUnitTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AreaUnitTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AreaUnitTypeEnum>>;
};

export type AutoShape = Node & {
  __typename?: 'AutoShape';
  algorithmInput: Scalars['JSON'];
  algorithmType?: Maybe<AutoShapeAlgorithmType>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `AutoShape`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  result?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Shape`. */
  shapes: Array<Shape>;
  /** Reads and enables pagination through a set of `Shape`. */
  shapesConnection: ShapesConnection;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapes: Array<SheetShape>;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapesConnection: SheetShapesConnection;
  startedAt?: Maybe<Scalars['Datetime']>;
  status: AutoShapeStatus;
  updatedAt: Scalars['Datetime'];
};


export type AutoShapeShapesArgs = {
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


export type AutoShapeShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


export type AutoShapeSheetShapesArgs = {
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


export type AutoShapeSheetShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};

export enum AutoShapeAlgorithmType {
  ExternalWallFinishes_3D = 'EXTERNAL_WALL_FINISHES_3D',
  InternalWallFinishes_3D = 'INTERNAL_WALL_FINISHES_3D',
  RoomDetection_2D = 'ROOM_DETECTION_2D',
  RoomDetection_3D = 'ROOM_DETECTION_3D',
  SymbolDetection_2D = 'SYMBOL_DETECTION_2D'
}

/** A filter to be used against AutoShapeAlgorithmType fields. All fields are combined with a logical ‘and.’ */
export type AutoShapeAlgorithmTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AutoShapeAlgorithmType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AutoShapeAlgorithmType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AutoShapeAlgorithmType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AutoShapeAlgorithmType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AutoShapeAlgorithmType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AutoShapeAlgorithmType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AutoShapeAlgorithmType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AutoShapeAlgorithmType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AutoShapeAlgorithmType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AutoShapeAlgorithmType>>;
};

/** The fields on `autoShape` to look up the row to connect. */
export type AutoShapeAutoShapesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `autoShape` to look up the row to delete. */
export type AutoShapeAutoShapesPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AutoShape` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AutoShapeCondition = {
  /** Checks for equality with the object’s `algorithmInput` field. */
  algorithmInput?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `algorithmType` field. */
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<AutoShapeStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AutoShape` object types. All fields are combined with a logical ‘and.’ */
export type AutoShapeFilter = {
  /** Filter by the object’s `algorithmInput` field. */
  algorithmInput?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `algorithmType` field. */
  algorithmType?: InputMaybe<AutoShapeAlgorithmTypeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AutoShapeFilter>>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AutoShapeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AutoShapeFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<AutoShapeStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AutoShape` */
export type AutoShapeInput = {
  algorithmInput: Scalars['JSON'];
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AutoShapeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `autoShape` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type AutoShapeNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `autoShape` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type AutoShapeOnAutoShapeForAutoShapesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `autoShape` to look up the row to update. */
export type AutoShapeOnAutoShapeForAutoShapesProjectIdFkeyUsingAutoShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `autoShape` being updated. */
  patch: UpdateAutoShapeOnAutoShapeForAutoShapesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type AutoShapeOnShapeForShapesAutoShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `autoShape` to look up the row to update. */
export type AutoShapeOnShapeForShapesAutoShapeIdFkeyUsingAutoShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `autoShape` being updated. */
  patch: UpdateAutoShapeOnShapeForShapesAutoShapeIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type AutoShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `autoShape` to look up the row to update. */
export type AutoShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyUsingAutoShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `autoShape` being updated. */
  patch: UpdateAutoShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyPatch;
};

/** Represents an update to a `AutoShape`. Fields that are set will be updated. */
export type AutoShapePatch = {
  algorithmInput?: InputMaybe<Scalars['JSON']>;
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type AutoShapeProcessingSubscriptionPayload = {
  __typename?: 'AutoShapeProcessingSubscriptionPayload';
  autoShape?: Maybe<AutoShape>;
};

export enum AutoShapeStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** A filter to be used against AutoShapeStatus fields. All fields are combined with a logical ‘and.’ */
export type AutoShapeStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AutoShapeStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AutoShapeStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AutoShapeStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AutoShapeStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AutoShapeStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AutoShapeStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AutoShapeStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AutoShapeStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AutoShapeStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AutoShapeStatus>>;
};

/** A connection to a list of `AutoShape` values. */
export type AutoShapesConnection = {
  __typename?: 'AutoShapesConnection';
  /** A list of edges which contains the `AutoShape` and cursor to aid in pagination. */
  edges: Array<AutoShapesEdge>;
  /** A list of `AutoShape` objects. */
  nodes: Array<AutoShape>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AutoShape` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AutoShape` edge in the connection. */
export type AutoShapesEdge = {
  __typename?: 'AutoShapesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AutoShape` at the end of the edge. */
  node: AutoShape;
};

/** Methods to use when ordering `AutoShape`. */
export enum AutoShapesOrderBy {
  AlgorithmInputAsc = 'ALGORITHM_INPUT_ASC',
  AlgorithmInputDesc = 'ALGORITHM_INPUT_DESC',
  AlgorithmTypeAsc = 'ALGORITHM_TYPE_ASC',
  AlgorithmTypeDesc = 'ALGORITHM_TYPE_DESC',
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ErrorMessageAsc = 'ERROR_MESSAGE_ASC',
  ErrorMessageDesc = 'ERROR_MESSAGE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The `autoShape` to be created by this mutation. */
export type AutoShapesProjectIdFkeyAutoShapesCreateInput = {
  algorithmInput: Scalars['JSON'];
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `project` in the `AutoShapeInput` mutation. */
export type AutoShapesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<AutoShapesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnAutoShapeForAutoShapesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AutoShapeOnAutoShapeForAutoShapesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `autoShape` in the `ProjectInput` mutation. */
export type AutoShapesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AutoShapeAutoShapesPkeyConnect>>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AutoShapeNodeIdConnect>>;
  /** A `AutoShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AutoShapesProjectIdFkeyAutoShapesCreateInput>>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AutoShapeAutoShapesPkeyDelete>>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AutoShapeNodeIdDelete>>;
  /** Flag indicating whether all other `autoShape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `autoShape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AutoShapeOnAutoShapeForAutoShapesProjectIdFkeyUsingAutoShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `autoShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnAutoShapeForAutoShapesProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type AutoShapesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type Breakdown = {
  __typename?: 'Breakdown';
  propertyName: Scalars['String'];
  propertySet: Scalars['String'];
};

/** All input for the `bulkCreateShapes` mutation. */
export type BulkCreateShapesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapesData: Scalars['JSON'];
};

/** The output of our `bulkCreateShapes` mutation. */
export type BulkCreateShapesPayload = {
  __typename?: 'BulkCreateShapesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shapes?: Maybe<Array<Shape>>;
};

/** All input for the `bulkCreateSheetShapes` mutation. */
export type BulkCreateSheetShapesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapesData: Scalars['JSON'];
};

/** The output of our `bulkCreateSheetShapes` mutation. */
export type BulkCreateSheetShapesPayload = {
  __typename?: 'BulkCreateSheetShapesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sheetShapes?: Maybe<Array<SheetShape>>;
};

/** All input for the `bulkDeleteShapes` mutation. */
export type BulkDeleteShapesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapeIds: Array<InputMaybe<Scalars['UUID']>>;
};

/** The output of our `bulkDeleteShapes` mutation. */
export type BulkDeleteShapesPayload = {
  __typename?: 'BulkDeleteShapesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shapes?: Maybe<Array<Shape>>;
};

/** All input for the `bulkDeleteSheetShapes` mutation. */
export type BulkDeleteSheetShapesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sheetShapeIds: Array<InputMaybe<Scalars['UUID']>>;
};

/** The output of our `bulkDeleteSheetShapes` mutation. */
export type BulkDeleteSheetShapesPayload = {
  __typename?: 'BulkDeleteSheetShapesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sheetShapes?: Maybe<Array<SheetShape>>;
};

/** All input for the `bulkDeleteSparkelProperties` mutation. */
export type BulkDeleteSparkelPropertiesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbIds: Array<InputMaybe<ElementIdentifierDbidTypeInput>>;
  projectId: Scalars['UUID'];
  thePropertySet: Scalars['String'];
};

/** The output of our `bulkDeleteSparkelProperties` mutation. */
export type BulkDeleteSparkelPropertiesPayload = {
  __typename?: 'BulkDeleteSparkelPropertiesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sparkelProperties?: Maybe<Array<SparkelProperty>>;
};

/** All input for the `bulkUpdateShapes` mutation. */
export type BulkUpdateShapesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapesData: Scalars['JSON'];
};

/** The output of our `bulkUpdateShapes` mutation. */
export type BulkUpdateShapesPayload = {
  __typename?: 'BulkUpdateShapesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shapes?: Maybe<Array<Shape>>;
};

/** All input for the `bulkUpdateSheetShapes` mutation. */
export type BulkUpdateSheetShapesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapesData: Scalars['JSON'];
};

/** The output of our `bulkUpdateSheetShapes` mutation. */
export type BulkUpdateSheetShapesPayload = {
  __typename?: 'BulkUpdateSheetShapesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sheetShapes?: Maybe<Array<SheetShape>>;
};

/** All input for the `bulkUpsertOrderEntryCache` mutation. */
export type BulkUpsertOrderEntryCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  items: Scalars['JSON'];
};

/** The output of our `bulkUpsertOrderEntryCache` mutation. */
export type BulkUpsertOrderEntryCachePayload = {
  __typename?: 'BulkUpsertOrderEntryCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<BulkUpsertOrderEntryCacheRecord>>;
};

/** The return type of our `bulkUpsertOrderEntryCache` mutation. */
export type BulkUpsertOrderEntryCacheRecord = {
  __typename?: 'BulkUpsertOrderEntryCacheRecord';
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  orderEntryId?: Maybe<Scalars['UUID']>;
};

/** All input for the `bulkUpsertSparkelProperties` mutation. */
export type BulkUpsertSparkelPropertiesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbIds: Array<InputMaybe<ElementIdentifierDbidTypeInput>>;
  projectId: Scalars['UUID'];
  thePropertySet: Scalars['String'];
  thePropertyValue: Scalars['String'];
};

/** The output of our `bulkUpsertSparkelProperties` mutation. */
export type BulkUpsertSparkelPropertiesPayload = {
  __typename?: 'BulkUpsertSparkelPropertiesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sparkelProperties?: Maybe<Array<SparkelProperty>>;
};

export type CalculationType = {
  __typename?: 'CalculationType';
  attribute?: Maybe<ForgeAttributeType>;
  operation: QuantityOperation;
};

/** A filter to be used against `CalculationType` object types. All fields are combined with a logical ‘and.’ */
export type CalculationTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CalculationTypeFilter>>;
  /** Filter by the object’s `attribute` field. */
  attribute?: InputMaybe<ForgeAttributeTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CalculationTypeFilter>;
  /** Filter by the object’s `operation` field. */
  operation?: InputMaybe<QuantityOperationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CalculationTypeFilter>>;
};

/** An input for mutations affecting `CalculationType` */
export type CalculationTypeInput = {
  attribute?: InputMaybe<ForgeAttributeTypeInput>;
  operation: QuantityOperation;
};

export enum CalibrationUnit {
  Feet = 'FEET',
  M = 'M',
  Mm = 'MM'
}

/** A filter to be used against CalibrationUnit fields. All fields are combined with a logical ‘and.’ */
export type CalibrationUnitFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CalibrationUnit>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CalibrationUnit>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CalibrationUnit>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CalibrationUnit>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CalibrationUnit>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CalibrationUnit>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CalibrationUnit>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CalibrationUnit>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CalibrationUnit>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CalibrationUnit>>;
};

export type CameraPositionType = {
  __typename?: 'CameraPositionType';
  applyGlobalOffset: Scalars['Boolean'];
  aspect: Scalars['Float'];
  fov: Scalars['Float'];
  isPerspective: Scalars['Boolean'];
  orthoScale: Scalars['Float'];
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  positionZ: Scalars['Float'];
  targetX: Scalars['Float'];
  targetY: Scalars['Float'];
  targetZ: Scalars['Float'];
  upX: Scalars['Float'];
  upY: Scalars['Float'];
  upZ: Scalars['Float'];
};

/** A filter to be used against `CameraPositionType` object types. All fields are combined with a logical ‘and.’ */
export type CameraPositionTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CameraPositionTypeFilter>>;
  /** Filter by the object’s `applyGlobalOffset` field. */
  applyGlobalOffset?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `aspect` field. */
  aspect?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `fov` field. */
  fov?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `isPerspective` field. */
  isPerspective?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CameraPositionTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CameraPositionTypeFilter>>;
  /** Filter by the object’s `orthoScale` field. */
  orthoScale?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `positionX` field. */
  positionX?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `positionY` field. */
  positionY?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `positionZ` field. */
  positionZ?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `targetX` field. */
  targetX?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `targetY` field. */
  targetY?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `targetZ` field. */
  targetZ?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `upX` field. */
  upX?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `upY` field. */
  upY?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `upZ` field. */
  upZ?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `CameraPositionType` */
export type CameraPositionTypeInput = {
  applyGlobalOffset: Scalars['Boolean'];
  aspect: Scalars['Float'];
  fov: Scalars['Float'];
  isPerspective: Scalars['Boolean'];
  orthoScale: Scalars['Float'];
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  positionZ: Scalars['Float'];
  targetX: Scalars['Float'];
  targetY: Scalars['Float'];
  targetZ: Scalars['Float'];
  upX: Scalars['Float'];
  upY: Scalars['Float'];
  upZ: Scalars['Float'];
};

export type ColumnFilterType = {
  __typename?: 'ColumnFilterType';
  columnName: Scalars['String'];
  filterValues: Array<Scalars['String']>;
};

/** An input for mutations affecting `ColumnFilterType` */
export type ColumnFilterTypeInput = {
  columnName: Scalars['String'];
  filterValues: Array<InputMaybe<Scalars['String']>>;
};

export enum ColumnType {
  Color = 'COLOR',
  Custom = 'CUSTOM',
  Description = 'DESCRIPTION',
  ItemGroup = 'ITEM_GROUP',
  LinkedCount = 'LINKED_COUNT',
  ParentOrder = 'PARENT_ORDER',
  ParentOrderLabel = 'PARENT_ORDER_LABEL',
  ParentOrderStatus = 'PARENT_ORDER_STATUS',
  Quantity = 'QUANTITY',
  Total = 'TOTAL',
  Unit = 'UNIT',
  UnitPrice = 'UNIT_PRICE'
}

/** A filter to be used against ColumnType fields. All fields are combined with a logical ‘and.’ */
export type ColumnTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ColumnType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ColumnType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ColumnType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ColumnType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ColumnType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ColumnType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ColumnType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ColumnType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ColumnType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ColumnType>>;
};

export type Comment = Node & {
  __typename?: 'Comment';
  anchorPoint2D?: Maybe<Point2Type>;
  anchorPoint3D?: Maybe<Point3Type>;
  /** Reads and enables pagination through a set of `Comment`. */
  childComments: Array<Comment>;
  /** Reads and enables pagination through a set of `Comment`. */
  childCommentsConnection: CommentsConnection;
  /** Reads a single `Comment` that is related to this `Comment`. */
  commentByReplies?: Maybe<Comment>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsByReplies: Array<Comment>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsByRepliesConnection: CommentsConnection;
  content: Scalars['String'];
  createdAtTz: Scalars['Datetime'];
  elementIdentifiers?: Maybe<Array<ElementIdentifierDbidType>>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Order` that is related to this `Comment`. */
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  parent?: Maybe<Comment>;
  parentId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Project` that is related to this `Comment`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  readBy?: Maybe<Array<Scalars['String']>>;
  replies?: Maybe<Scalars['UUID']>;
  /** Reads a single `SavedView` that is related to this `Comment`. */
  savedViews?: Maybe<SavedView>;
  savedViewsId?: Maybe<Scalars['UUID']>;
  username: Scalars['String'];
};


export type CommentChildCommentsArgs = {
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type CommentChildCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type CommentCommentsByRepliesArgs = {
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type CommentCommentsByRepliesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};

/** The fields on `comment` to look up the row to connect. */
export type CommentCommentsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `comment` to look up the row to delete. */
export type CommentCommentsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A condition to be used against `Comment` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CommentCondition = {
  /** Checks for equality with the object’s `anchorPoint2D` field. */
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  /** Checks for equality with the object’s `anchorPoint3D` field. */
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAtTz` field. */
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `elementIdentifiers` field. */
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `readBy` field. */
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `replies` field. */
  replies?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `savedViewsId` field. */
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Comment` object types. All fields are combined with a logical ‘and.’ */
export type CommentFilter = {
  /** Filter by the object’s `anchorPoint2D` field. */
  anchorPoint2D?: InputMaybe<Point2TypeFilter>;
  /** Filter by the object’s `anchorPoint3D` field. */
  anchorPoint3D?: InputMaybe<Point3TypeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommentFilter>>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAtTz` field. */
  createdAtTz?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommentFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `readBy` field. */
  readBy?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `replies` field. */
  replies?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `savedViewsId` field. */
  savedViewsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Comment` */
export type CommentInput = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content: Scalars['String'];
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type CommentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `comment` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CommentNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `comment` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CommentOnCommentForCommentsOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `order` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: OrderPatch;
};

/** The fields on `comment` to look up the row to update. */
export type CommentOnCommentForCommentsOrderIdFkeyUsingCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: UpdateCommentOnCommentForCommentsOrderIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CommentOnCommentForCommentsParentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `comment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: CommentPatch;
};

/** The fields on `comment` to look up the row to update. */
export type CommentOnCommentForCommentsParentIdFkeyUsingCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: UpdateCommentOnCommentForCommentsParentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CommentOnCommentForCommentsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `comment` to look up the row to update. */
export type CommentOnCommentForCommentsProjectIdFkeyUsingCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: UpdateCommentOnCommentForCommentsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CommentOnCommentForCommentsRepliesFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `comment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: CommentPatch;
};

/** The fields on `comment` to look up the row to update. */
export type CommentOnCommentForCommentsRepliesFkeyUsingCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: UpdateCommentOnCommentForCommentsRepliesFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CommentOnCommentForCommentsSavedViewsIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `savedView` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: SavedViewPatch;
};

/** The fields on `comment` to look up the row to update. */
export type CommentOnCommentForCommentsSavedViewsIdFkeyUsingCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: UpdateCommentOnCommentForCommentsSavedViewsIdFkeyPatch;
};

/** Represents an update to a `Comment`. Fields that are set will be updated. */
export type CommentPatch = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Comment` values. */
export type CommentsConnection = {
  __typename?: 'CommentsConnection';
  /** A list of edges which contains the `Comment` and cursor to aid in pagination. */
  edges: Array<CommentsEdge>;
  /** A list of `Comment` objects. */
  nodes: Array<Comment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Comment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Comment` edge in the connection. */
export type CommentsEdge = {
  __typename?: 'CommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Comment` at the end of the edge. */
  node: Comment;
};

/** Methods to use when ordering `Comment`. */
export enum CommentsOrderBy {
  AnchorPoint_2DAsc = 'ANCHOR_POINT_2D_ASC',
  AnchorPoint_2DDesc = 'ANCHOR_POINT_2D_DESC',
  AnchorPoint_3DAsc = 'ANCHOR_POINT_3D_ASC',
  AnchorPoint_3DDesc = 'ANCHOR_POINT_3D_DESC',
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  CreatedAtTzAsc = 'CREATED_AT_TZ_ASC',
  CreatedAtTzDesc = 'CREATED_AT_TZ_DESC',
  ElementIdentifiersAsc = 'ELEMENT_IDENTIFIERS_ASC',
  ElementIdentifiersDesc = 'ELEMENT_IDENTIFIERS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ReadByAsc = 'READ_BY_ASC',
  ReadByDesc = 'READ_BY_DESC',
  RepliesAsc = 'REPLIES_ASC',
  RepliesDesc = 'REPLIES_DESC',
  SavedViewsIdAsc = 'SAVED_VIEWS_ID_ASC',
  SavedViewsIdDesc = 'SAVED_VIEWS_ID_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC'
}

/** The `comment` to be created by this mutation. */
export type CommentsOrderIdFkeyCommentsCreateInput = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content: Scalars['String'];
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username: Scalars['String'];
};

/** Input for the nested mutation of `order` in the `CommentInput` mutation. */
export type CommentsOrderIdFkeyInput = {
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectById?: InputMaybe<OrderOrdersPkeyConnect>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderNodeIdConnect>;
  /** A `OrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommentsOrderIdFkeyOrdersCreateInput>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderOrdersPkeyDelete>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderNodeIdDelete>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateById?: InputMaybe<OrderOnCommentForCommentsOrderIdFkeyUsingOrdersPkeyUpdate>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CommentOnCommentForCommentsOrderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `comment` in the `OrderInput` mutation. */
export type CommentsOrderIdFkeyInverseInput = {
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommentCommentsPkeyConnect>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CommentNodeIdConnect>>;
  /** A `CommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CommentsOrderIdFkeyCommentsCreateInput>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommentCommentsPkeyDelete>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CommentNodeIdDelete>>;
  /** Flag indicating whether all other `comment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CommentOnCommentForCommentsOrderIdFkeyUsingCommentsPkeyUpdate>>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderOnCommentForCommentsOrderIdFkeyNodeIdUpdate>>;
};

/** The `order` to be created by this mutation. */
export type CommentsOrderIdFkeyOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `comment` to be created by this mutation. */
export type CommentsParentIdFkeyCommentsCreateInput = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content: Scalars['String'];
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username: Scalars['String'];
};

/** Input for the nested mutation of `comment` in the `CommentInput` mutation. */
export type CommentsParentIdFkeyInput = {
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectById?: InputMaybe<CommentCommentsPkeyConnect>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CommentNodeIdConnect>;
  /** A `CommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommentsParentIdFkeyCommentsCreateInput>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteById?: InputMaybe<CommentCommentsPkeyDelete>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CommentNodeIdDelete>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateById?: InputMaybe<CommentOnCommentForCommentsParentIdFkeyUsingCommentsPkeyUpdate>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CommentOnCommentForCommentsParentIdFkeyNodeIdUpdate>;
};

/** The `comment` to be created by this mutation. */
export type CommentsProjectIdFkeyCommentsCreateInput = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content: Scalars['String'];
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username: Scalars['String'];
};

/** Input for the nested mutation of `project` in the `CommentInput` mutation. */
export type CommentsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommentsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnCommentForCommentsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CommentOnCommentForCommentsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `comment` in the `ProjectInput` mutation. */
export type CommentsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommentCommentsPkeyConnect>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CommentNodeIdConnect>>;
  /** A `CommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CommentsProjectIdFkeyCommentsCreateInput>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommentCommentsPkeyDelete>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CommentNodeIdDelete>>;
  /** Flag indicating whether all other `comment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CommentOnCommentForCommentsProjectIdFkeyUsingCommentsPkeyUpdate>>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnCommentForCommentsProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type CommentsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `comment` to be created by this mutation. */
export type CommentsRepliesFkeyCommentsCreateInput = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content: Scalars['String'];
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username: Scalars['String'];
};

/** Input for the nested mutation of `comment` in the `CommentInput` mutation. */
export type CommentsRepliesFkeyInput = {
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectById?: InputMaybe<CommentCommentsPkeyConnect>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CommentNodeIdConnect>;
  /** A `CommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommentsRepliesFkeyCommentsCreateInput>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteById?: InputMaybe<CommentCommentsPkeyDelete>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CommentNodeIdDelete>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateById?: InputMaybe<CommentOnCommentForCommentsRepliesFkeyUsingCommentsPkeyUpdate>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CommentOnCommentForCommentsRepliesFkeyNodeIdUpdate>;
};

/** The `comment` to be created by this mutation. */
export type CommentsSavedViewsIdFkeyCommentsCreateInput = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content: Scalars['String'];
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username: Scalars['String'];
};

/** Input for the nested mutation of `savedView` in the `CommentInput` mutation. */
export type CommentsSavedViewsIdFkeyInput = {
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectById?: InputMaybe<SavedViewSavedViewsPkeyConnect>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectByNameAndProjectId?: InputMaybe<SavedViewSavedViewsNameProjectIdUniqueConnect>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SavedViewNodeIdConnect>;
  /** A `SavedViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommentsSavedViewsIdFkeySavedViewsCreateInput>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteById?: InputMaybe<SavedViewSavedViewsPkeyDelete>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteByNameAndProjectId?: InputMaybe<SavedViewSavedViewsNameProjectIdUniqueDelete>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SavedViewNodeIdDelete>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateById?: InputMaybe<SavedViewOnCommentForCommentsSavedViewsIdFkeyUsingSavedViewsPkeyUpdate>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateByNameAndProjectId?: InputMaybe<SavedViewOnCommentForCommentsSavedViewsIdFkeyUsingSavedViewsNameProjectIdUniqueUpdate>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CommentOnCommentForCommentsSavedViewsIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `comment` in the `SavedViewInput` mutation. */
export type CommentsSavedViewsIdFkeyInverseInput = {
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommentCommentsPkeyConnect>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CommentNodeIdConnect>>;
  /** A `CommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CommentsSavedViewsIdFkeyCommentsCreateInput>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommentCommentsPkeyDelete>>;
  /** The primary key(s) for `comment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CommentNodeIdDelete>>;
  /** Flag indicating whether all other `comment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CommentOnCommentForCommentsSavedViewsIdFkeyUsingCommentsPkeyUpdate>>;
  /** The primary key(s) and patch data for `comment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<SavedViewOnCommentForCommentsSavedViewsIdFkeyNodeIdUpdate>>;
};

/** The `savedView` to be created by this mutation. */
export type CommentsSavedViewsIdFkeySavedViewsCreateInput = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories: Array<InputMaybe<Scalars['String']>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses: Array<InputMaybe<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Cell values for company database rows */
export type CompanyDatabaseCell = Node & {
  __typename?: 'CompanyDatabaseCell';
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseCell`. */
  column?: Maybe<CompanyDatabaseColumn>;
  columnId: Scalars['UUID'];
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseCell`. */
  database?: Maybe<CompanyDatabasis>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseCell`. */
  row?: Maybe<CompanyDatabaseRow>;
  rowId: Scalars['UUID'];
  /** Value stored as text, parsed according to the column type */
  value?: Maybe<Scalars['String']>;
};

/** The fields on `companyDatabaseCell` to look up the row to connect. */
export type CompanyDatabaseCellCompanyDatabaseCellsPkeyConnect = {
  columnId: Scalars['UUID'];
  rowId: Scalars['UUID'];
};

/** The fields on `companyDatabaseCell` to look up the row to delete. */
export type CompanyDatabaseCellCompanyDatabaseCellsPkeyDelete = {
  columnId: Scalars['UUID'];
  rowId: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseCell` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseCellCondition = {
  /** Checks for equality with the object’s `columnId` field. */
  columnId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `databaseId` field. */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `CompanyDatabaseCell` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseCellFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseCellFilter>>;
  /** Filter by the object’s `columnId` field. */
  columnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseCellFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseCellFilter>>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CompanyDatabaseCell` */
export type CompanyDatabaseCellInput = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseCellNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseCell` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseCellNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseCell` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseColumn` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
  patch: CompanyDatabaseColumnPatch;
};

/** The fields on `companyDatabaseCell` to look up the row to update. */
export type CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyUsingCompanyDatabaseCellsPkeyUpdate = {
  columnId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
  patch: UpdateCompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyPatch;
  rowId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `companyDatabaseCell` to look up the row to update. */
export type CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyUsingCompanyDatabaseCellsPkeyUpdate = {
  columnId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
  patch: UpdateCompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyPatch;
  rowId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseRow` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
  patch: CompanyDatabaseRowPatch;
};

/** The fields on `companyDatabaseCell` to look up the row to update. */
export type CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyUsingCompanyDatabaseCellsPkeyUpdate = {
  columnId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
  patch: UpdateCompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyPatch;
  rowId: Scalars['UUID'];
};

/** Represents an update to a `CompanyDatabaseCell`. Fields that are set will be updated. */
export type CompanyDatabaseCellPatch = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** The `companyDatabaseCell` to be created by this mutation. */
export type CompanyDatabaseCellsColumnIdFkeyCompanyDatabaseCellsCreateInput = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** The `companyDatabaseColumn` to be created by this mutation. */
export type CompanyDatabaseCellsColumnIdFkeyCompanyDatabaseColumnsCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  /** Display order of columns in the UI (0-indexed) */
  orderIndex: Scalars['Int'];
  type: CompanyDatabaseColumnType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabaseColumn` in the `CompanyDatabaseCellInput` mutation. */
export type CompanyDatabaseCellsColumnIdFkeyInput = {
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabaseColumnCompanyDatabaseColumnsPkeyConnect>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabaseColumnNodeIdConnect>;
  /** A `CompanyDatabaseColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyCompanyDatabaseColumnsCreateInput>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabaseColumnCompanyDatabaseColumnsPkeyDelete>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabaseColumnNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabaseColumn` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabaseColumnOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyUsingCompanyDatabaseColumnsPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabaseColumn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseCell` in the `CompanyDatabaseColumnInput` mutation. */
export type CompanyDatabaseCellsColumnIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseCellNodeIdConnect>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  connectByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellCompanyDatabaseCellsPkeyConnect>>;
  /** A `CompanyDatabaseCellInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseCellsColumnIdFkeyCompanyDatabaseCellsCreateInput>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseCellNodeIdDelete>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  deleteByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellCompanyDatabaseCellsPkeyDelete>>;
  /** Flag indicating whether all other `companyDatabaseCell` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseCell` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseColumnOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseCell` for the far side of the relationship. */
  updateByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyUsingCompanyDatabaseCellsPkeyUpdate>>;
};

/** A connection to a list of `CompanyDatabaseCell` values. */
export type CompanyDatabaseCellsConnection = {
  __typename?: 'CompanyDatabaseCellsConnection';
  /** A list of edges which contains the `CompanyDatabaseCell` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseCellsEdge>;
  /** A list of `CompanyDatabaseCell` objects. */
  nodes: Array<CompanyDatabaseCell>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseCell` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `companyDatabaseCell` to be created by this mutation. */
export type CompanyDatabaseCellsDatabaseIdFkeyCompanyDatabaseCellsCreateInput = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabaseCellsDatabaseIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabasis` in the `CompanyDatabaseCellInput` mutation. */
export type CompanyDatabaseCellsDatabaseIdFkeyInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyConnect>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabasisNodeIdConnect>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyCompanyDatabasesCreateInput>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyDelete>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabasisNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabasisOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseCell` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabaseCellsDatabaseIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseCellNodeIdConnect>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  connectByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellCompanyDatabaseCellsPkeyConnect>>;
  /** A `CompanyDatabaseCellInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseCellsDatabaseIdFkeyCompanyDatabaseCellsCreateInput>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseCellNodeIdDelete>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  deleteByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellCompanyDatabaseCellsPkeyDelete>>;
  /** Flag indicating whether all other `companyDatabaseCell` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseCell` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseCell` for the far side of the relationship. */
  updateByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyUsingCompanyDatabaseCellsPkeyUpdate>>;
};

/** A `CompanyDatabaseCell` edge in the connection. */
export type CompanyDatabaseCellsEdge = {
  __typename?: 'CompanyDatabaseCellsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseCell` at the end of the edge. */
  node: CompanyDatabaseCell;
};

/** Methods to use when ordering `CompanyDatabaseCell`. */
export enum CompanyDatabaseCellsOrderBy {
  ColumnIdAsc = 'COLUMN_ID_ASC',
  ColumnIdDesc = 'COLUMN_ID_DESC',
  DatabaseIdAsc = 'DATABASE_ID_ASC',
  DatabaseIdDesc = 'DATABASE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIdAsc = 'ROW_ID_ASC',
  RowIdDesc = 'ROW_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The `companyDatabaseCell` to be created by this mutation. */
export type CompanyDatabaseCellsRowIdFkeyCompanyDatabaseCellsCreateInput = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** The `companyDatabaseRow` to be created by this mutation. */
export type CompanyDatabaseCellsRowIdFkeyCompanyDatabaseRowsCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex: Scalars['BigInt'];
};

/** Input for the nested mutation of `companyDatabaseRow` in the `CompanyDatabaseCellInput` mutation. */
export type CompanyDatabaseCellsRowIdFkeyInput = {
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabaseRowCompanyDatabaseRowsPkeyConnect>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabaseRowNodeIdConnect>;
  /** A `CompanyDatabaseRowInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseCellsRowIdFkeyCompanyDatabaseRowsCreateInput>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabaseRowCompanyDatabaseRowsPkeyDelete>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabaseRowNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabaseRow` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabaseRowOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyUsingCompanyDatabaseRowsPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabaseRow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseCell` in the `CompanyDatabaseRowInput` mutation. */
export type CompanyDatabaseCellsRowIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseCellNodeIdConnect>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  connectByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellCompanyDatabaseCellsPkeyConnect>>;
  /** A `CompanyDatabaseCellInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseCellsRowIdFkeyCompanyDatabaseCellsCreateInput>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseCellNodeIdDelete>>;
  /** The primary key(s) for `companyDatabaseCell` for the far side of the relationship. */
  deleteByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellCompanyDatabaseCellsPkeyDelete>>;
  /** Flag indicating whether all other `companyDatabaseCell` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseCell` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseRowOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseCell` for the far side of the relationship. */
  updateByRowIdAndColumnId?: InputMaybe<Array<CompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyUsingCompanyDatabaseCellsPkeyUpdate>>;
};

/** Column definitions for company databases */
export type CompanyDatabaseColumn = Node & {
  __typename?: 'CompanyDatabaseColumn';
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsByColumnId: Array<CompanyDatabaseCell>;
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsByColumnIdConnection: CompanyDatabaseCellsConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesBySearchColumnId: Array<CompanyDatabaseLookupCache>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesBySearchColumnIdConnection: CompanyDatabaseLookupCachesConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByValueColumnId: Array<CompanyDatabaseLookupCache>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByValueColumnIdConnection: CompanyDatabaseLookupCachesConnection;
  createdAt: Scalars['Datetime'];
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseColumn`. */
  database?: Maybe<CompanyDatabasis>;
  databaseId: Scalars['UUID'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Display order of columns in the UI (0-indexed) */
  orderIndex: Scalars['Int'];
  type: CompanyDatabaseColumnType;
  updatedAt: Scalars['Datetime'];
};


/** Column definitions for company databases */
export type CompanyDatabaseColumnCompanyDatabaseCellsByColumnIdArgs = {
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** Column definitions for company databases */
export type CompanyDatabaseColumnCompanyDatabaseCellsByColumnIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** Column definitions for company databases */
export type CompanyDatabaseColumnCompanyDatabaseLookupCachesBySearchColumnIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Column definitions for company databases */
export type CompanyDatabaseColumnCompanyDatabaseLookupCachesBySearchColumnIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Column definitions for company databases */
export type CompanyDatabaseColumnCompanyDatabaseLookupCachesByValueColumnIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Column definitions for company databases */
export type CompanyDatabaseColumnCompanyDatabaseLookupCachesByValueColumnIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};

/** The fields on `companyDatabaseColumn` to look up the row to connect. */
export type CompanyDatabaseColumnCompanyDatabaseColumnsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabaseColumn` to look up the row to delete. */
export type CompanyDatabaseColumnCompanyDatabaseColumnsPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseColumn` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseColumnCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `databaseId` field. */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `orderIndex` field. */
  orderIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<CompanyDatabaseColumnType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `CompanyDatabaseColumn` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseColumnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseColumnFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseColumnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseColumnFilter>>;
  /** Filter by the object’s `orderIndex` field. */
  orderIndex?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<CompanyDatabaseColumnTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CompanyDatabaseColumn` */
export type CompanyDatabaseColumnInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  /** Display order of columns in the UI (0-indexed) */
  orderIndex: Scalars['Int'];
  type: CompanyDatabaseColumnType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseColumnNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseColumn` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseColumnNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseColumn` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseCell` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
  patch: CompanyDatabaseCellPatch;
};

/** The fields on `companyDatabaseColumn` to look up the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyUsingCompanyDatabaseColumnsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
  patch: UpdateCompanyDatabaseColumnOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `companyDatabaseColumn` to look up the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyUsingCompanyDatabaseColumnsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
  patch: UpdateCompanyDatabaseColumnOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** The fields on `companyDatabaseColumn` to look up the row to update. */
export type CompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyUsingCompanyDatabaseColumnsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
  patch: UpdateCompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyPatch;
};

/** Represents an update to a `CompanyDatabaseColumn`. Fields that are set will be updated. */
export type CompanyDatabaseColumnPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Display order of columns in the UI (0-indexed) */
  orderIndex?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CompanyDatabaseColumnType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum CompanyDatabaseColumnType {
  Bool = 'BOOL',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT',
  Ts = 'TS'
}

/** A filter to be used against CompanyDatabaseColumnType fields. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseColumnTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CompanyDatabaseColumnType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CompanyDatabaseColumnType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CompanyDatabaseColumnType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CompanyDatabaseColumnType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CompanyDatabaseColumnType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CompanyDatabaseColumnType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CompanyDatabaseColumnType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CompanyDatabaseColumnType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CompanyDatabaseColumnType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CompanyDatabaseColumnType>>;
};

/** A connection to a list of `CompanyDatabaseColumn` values. */
export type CompanyDatabaseColumnsConnection = {
  __typename?: 'CompanyDatabaseColumnsConnection';
  /** A list of edges which contains the `CompanyDatabaseColumn` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseColumnsEdge>;
  /** A list of `CompanyDatabaseColumn` objects. */
  nodes: Array<CompanyDatabaseColumn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseColumn` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `companyDatabaseColumn` to be created by this mutation. */
export type CompanyDatabaseColumnsDatabaseIdFkeyCompanyDatabaseColumnsCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  /** Display order of columns in the UI (0-indexed) */
  orderIndex: Scalars['Int'];
  type: CompanyDatabaseColumnType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabaseColumnsDatabaseIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabasis` in the `CompanyDatabaseColumnInput` mutation. */
export type CompanyDatabaseColumnsDatabaseIdFkeyInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyConnect>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabasisNodeIdConnect>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyCompanyDatabasesCreateInput>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyDelete>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabasisNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabasisOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseColumnOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseColumn` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabaseColumnsDatabaseIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseColumnCompanyDatabaseColumnsPkeyConnect>>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseColumnNodeIdConnect>>;
  /** A `CompanyDatabaseColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseColumnsDatabaseIdFkeyCompanyDatabaseColumnsCreateInput>>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseColumnCompanyDatabaseColumnsPkeyDelete>>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseColumnNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseColumn` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseColumn` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseColumnOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyUsingCompanyDatabaseColumnsPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseColumn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyNodeIdUpdate>>;
};

/** A `CompanyDatabaseColumn` edge in the connection. */
export type CompanyDatabaseColumnsEdge = {
  __typename?: 'CompanyDatabaseColumnsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseColumn` at the end of the edge. */
  node: CompanyDatabaseColumn;
};

/** Methods to use when ordering `CompanyDatabaseColumn`. */
export enum CompanyDatabaseColumnsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DatabaseIdAsc = 'DATABASE_ID_ASC',
  DatabaseIdDesc = 'DATABASE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderIndexAsc = 'ORDER_INDEX_ASC',
  OrderIndexDesc = 'ORDER_INDEX_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type CompanyDatabaseImportColumnInput = {
  name: Scalars['String'];
  orderIndex: Scalars['Int'];
  type: CompanyDatabaseColumnType;
};

/** Tracks import jobs for company databases */
export type CompanyDatabaseImportJob = Node & {
  __typename?: 'CompanyDatabaseImportJob';
  /** Reads a single `Contractor` that is related to this `CompanyDatabaseImportJob`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseImportJob`. */
  database?: Maybe<CompanyDatabasis>;
  databaseId: Scalars['UUID'];
  errorCount: Scalars['Int'];
  errorSummary?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  /** S3 key for the uploaded import file */
  fileStorageKey: Scalars['String'];
  finishedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  insertedRows: Scalars['Int'];
  /** Import mode: replace (truncate then import) or append */
  mode: CompanyDatabaseImportMode;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: CompanyDatabaseImportJobStatus;
  totalRows?: Maybe<Scalars['Int']>;
};

/** The fields on `companyDatabaseImportJob` to look up the row to connect. */
export type CompanyDatabaseImportJobCompanyDatabaseImportJobsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabaseImportJob` to look up the row to delete. */
export type CompanyDatabaseImportJobCompanyDatabaseImportJobsPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseImportJob` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseImportJobCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `databaseId` field. */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `errorCount` field. */
  errorCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `errorSummary` field. */
  errorSummary?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fileName` field. */
  fileName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fileStorageKey` field. */
  fileStorageKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `insertedRows` field. */
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `mode` field. */
  mode?: InputMaybe<CompanyDatabaseImportMode>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Checks for equality with the object’s `totalRows` field. */
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `CompanyDatabaseImportJob` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseImportJobFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseImportJobFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `errorCount` field. */
  errorCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `errorSummary` field. */
  errorSummary?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileName` field. */
  fileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileStorageKey` field. */
  fileStorageKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `insertedRows` field. */
  insertedRows?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mode` field. */
  mode?: InputMaybe<CompanyDatabaseImportModeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseImportJobFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseImportJobFilter>>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CompanyDatabaseImportJobStatusFilter>;
  /** Filter by the object’s `totalRows` field. */
  totalRows?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CompanyDatabaseImportJob` */
export type CompanyDatabaseImportJobInput = {
  companyDatabasis?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInput>;
  contractor?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  errorCount?: InputMaybe<Scalars['Int']>;
  errorSummary?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  /** S3 key for the uploaded import file */
  fileStorageKey: Scalars['String'];
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Import mode: replace (truncate then import) or append */
  mode: CompanyDatabaseImportMode;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseImportJobNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseImportJob` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseImportJobNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseImportJob` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `companyDatabaseImportJob` to look up the row to update. */
export type CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyUsingCompanyDatabaseImportJobsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseImportJob` being updated. */
  patch: UpdateCompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `companyDatabaseImportJob` to look up the row to update. */
export type CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyUsingCompanyDatabaseImportJobsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseImportJob` being updated. */
  patch: UpdateCompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyPatch;
};

/** Represents an update to a `CompanyDatabaseImportJob`. Fields that are set will be updated. */
export type CompanyDatabaseImportJobPatch = {
  companyDatabasis?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInput>;
  contractor?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  errorCount?: InputMaybe<Scalars['Int']>;
  errorSummary?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  /** S3 key for the uploaded import file */
  fileStorageKey?: InputMaybe<Scalars['String']>;
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Import mode: replace (truncate then import) or append */
  mode?: InputMaybe<CompanyDatabaseImportMode>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  totalRows?: InputMaybe<Scalars['Int']>;
};

export enum CompanyDatabaseImportJobStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

/** A filter to be used against CompanyDatabaseImportJobStatus fields. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseImportJobStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CompanyDatabaseImportJobStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CompanyDatabaseImportJobStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CompanyDatabaseImportJobStatus>>;
};

/** A connection to a list of `CompanyDatabaseImportJob` values. */
export type CompanyDatabaseImportJobsConnection = {
  __typename?: 'CompanyDatabaseImportJobsConnection';
  /** A list of edges which contains the `CompanyDatabaseImportJob` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseImportJobsEdge>;
  /** A list of `CompanyDatabaseImportJob` objects. */
  nodes: Array<CompanyDatabaseImportJob>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseImportJob` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `companyDatabaseImportJob` to be created by this mutation. */
export type CompanyDatabaseImportJobsContractorIdFkeyCompanyDatabaseImportJobsCreateInput = {
  companyDatabasis?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInput>;
  contractor?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  errorCount?: InputMaybe<Scalars['Int']>;
  errorSummary?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  /** S3 key for the uploaded import file */
  fileStorageKey: Scalars['String'];
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Import mode: replace (truncate then import) or append */
  mode: CompanyDatabaseImportMode;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** The `contractor` to be created by this mutation. */
export type CompanyDatabaseImportJobsContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `CompanyDatabaseImportJobInput` mutation. */
export type CompanyDatabaseImportJobsContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `companyDatabaseImportJob` in the `ContractorInput` mutation. */
export type CompanyDatabaseImportJobsContractorIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseImportJobCompanyDatabaseImportJobsPkeyConnect>>;
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseImportJobNodeIdConnect>>;
  /** A `CompanyDatabaseImportJobInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseImportJobsContractorIdFkeyCompanyDatabaseImportJobsCreateInput>>;
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseImportJobCompanyDatabaseImportJobsPkeyDelete>>;
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseImportJobNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseImportJob` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseImportJob` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyUsingCompanyDatabaseImportJobsPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseImportJob` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyNodeIdUpdate>>;
};

/** The `companyDatabaseImportJob` to be created by this mutation. */
export type CompanyDatabaseImportJobsDatabaseIdFkeyCompanyDatabaseImportJobsCreateInput = {
  companyDatabasis?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInput>;
  contractor?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  errorCount?: InputMaybe<Scalars['Int']>;
  errorSummary?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  /** S3 key for the uploaded import file */
  fileStorageKey: Scalars['String'];
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Import mode: replace (truncate then import) or append */
  mode: CompanyDatabaseImportMode;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabaseImportJobsDatabaseIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabasis` in the `CompanyDatabaseImportJobInput` mutation. */
export type CompanyDatabaseImportJobsDatabaseIdFkeyInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyConnect>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabasisNodeIdConnect>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyCompanyDatabasesCreateInput>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyDelete>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabasisNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabasisOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseImportJob` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseImportJobCompanyDatabaseImportJobsPkeyConnect>>;
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseImportJobNodeIdConnect>>;
  /** A `CompanyDatabaseImportJobInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseImportJobsDatabaseIdFkeyCompanyDatabaseImportJobsCreateInput>>;
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseImportJobCompanyDatabaseImportJobsPkeyDelete>>;
  /** The primary key(s) for `companyDatabaseImportJob` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseImportJobNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseImportJob` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseImportJob` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyUsingCompanyDatabaseImportJobsPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseImportJob` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyNodeIdUpdate>>;
};

/** A `CompanyDatabaseImportJob` edge in the connection. */
export type CompanyDatabaseImportJobsEdge = {
  __typename?: 'CompanyDatabaseImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseImportJob` at the end of the edge. */
  node: CompanyDatabaseImportJob;
};

/** Methods to use when ordering `CompanyDatabaseImportJob`. */
export enum CompanyDatabaseImportJobsOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DatabaseIdAsc = 'DATABASE_ID_ASC',
  DatabaseIdDesc = 'DATABASE_ID_DESC',
  ErrorCountAsc = 'ERROR_COUNT_ASC',
  ErrorCountDesc = 'ERROR_COUNT_DESC',
  ErrorSummaryAsc = 'ERROR_SUMMARY_ASC',
  ErrorSummaryDesc = 'ERROR_SUMMARY_DESC',
  FileNameAsc = 'FILE_NAME_ASC',
  FileNameDesc = 'FILE_NAME_DESC',
  FileStorageKeyAsc = 'FILE_STORAGE_KEY_ASC',
  FileStorageKeyDesc = 'FILE_STORAGE_KEY_DESC',
  FinishedAtAsc = 'FINISHED_AT_ASC',
  FinishedAtDesc = 'FINISHED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InsertedRowsAsc = 'INSERTED_ROWS_ASC',
  InsertedRowsDesc = 'INSERTED_ROWS_DESC',
  ModeAsc = 'MODE_ASC',
  ModeDesc = 'MODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TotalRowsAsc = 'TOTAL_ROWS_ASC',
  TotalRowsDesc = 'TOTAL_ROWS_DESC'
}

export enum CompanyDatabaseImportMode {
  Append = 'APPEND',
  Replace = 'REPLACE'
}

/** A filter to be used against CompanyDatabaseImportMode fields. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseImportModeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CompanyDatabaseImportMode>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CompanyDatabaseImportMode>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CompanyDatabaseImportMode>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CompanyDatabaseImportMode>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CompanyDatabaseImportMode>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CompanyDatabaseImportMode>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CompanyDatabaseImportMode>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CompanyDatabaseImportMode>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CompanyDatabaseImportMode>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CompanyDatabaseImportMode>>;
};

export type CompanyDatabaseImportRowInput = {
  values: Array<InputMaybe<Scalars['String']>>;
};

export enum CompanyDatabaseImportStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

/** A filter to be used against CompanyDatabaseImportStatus fields. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseImportStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CompanyDatabaseImportStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CompanyDatabaseImportStatus>>;
};

/** Caches resolved lookup values to avoid redundant LLM calls */
export type CompanyDatabaseLookupCache = Node & {
  __typename?: 'CompanyDatabaseLookupCache';
  confidence?: Maybe<Scalars['BigFloat']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupCache`. */
  database?: Maybe<CompanyDatabasis>;
  databaseId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupCache`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  lookupProfileId?: Maybe<Scalars['UUID']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  reasoning?: Maybe<Scalars['String']>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseLookupCache`. */
  resolved?: Maybe<CompanyDatabaseRow>;
  resolvedRowId?: Maybe<Scalars['UUID']>;
  resolvedValue?: Maybe<Scalars['String']>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  searchColumn?: Maybe<CompanyDatabaseColumn>;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  valueColumn?: Maybe<CompanyDatabaseColumn>;
  valueColumnId: Scalars['UUID'];
};

/** The fields on `companyDatabaseLookupCache` to look up the row to connect. */
export type CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabaseLookupCache` to look up the row to delete. */
export type CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseLookupCache` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseLookupCacheCondition = {
  /** Checks for equality with the object’s `confidence` field. */
  confidence?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `databaseId` field. */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lookupProfileId` field. */
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reasoning` field. */
  reasoning?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `resolvedRowId` field. */
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `resolvedValue` field. */
  resolvedValue?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `searchColumnId` field. */
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `searchTerm` field. */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `valueColumnId` field. */
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** The `companyDatabaseLookupCache` to be created by this mutation. */
export type CompanyDatabaseLookupCacheDatabaseIdFkeyCompanyDatabaseLookupCacheCreateInput = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm: Scalars['String'];
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabaseLookupCacheDatabaseIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabasis` in the `CompanyDatabaseLookupCacheInput` mutation. */
export type CompanyDatabaseLookupCacheDatabaseIdFkeyInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyConnect>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabasisNodeIdConnect>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyCompanyDatabasesCreateInput>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyDelete>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabasisNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabasisOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseLookupCache` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdConnect>>;
  /** A `CompanyDatabaseLookupCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupCacheDatabaseIdFkeyCompanyDatabaseLookupCacheCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupCache` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyUsingUniqueLookupCacheKeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyNodeIdUpdate>>;
};

/** A filter to be used against `CompanyDatabaseLookupCache` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseLookupCacheFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseLookupCacheFilter>>;
  /** Filter by the object’s `confidence` field. */
  confidence?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lookupProfileId` field. */
  lookupProfileId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseLookupCacheFilter>>;
  /** Filter by the object’s `reasoning` field. */
  reasoning?: InputMaybe<StringFilter>;
  /** Filter by the object’s `resolvedRowId` field. */
  resolvedRowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `resolvedValue` field. */
  resolvedValue?: InputMaybe<StringFilter>;
  /** Filter by the object’s `searchColumnId` field. */
  searchColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `searchTerm` field. */
  searchTerm?: InputMaybe<StringFilter>;
  /** Filter by the object’s `valueColumnId` field. */
  valueColumnId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `CompanyDatabaseLookupCache` */
export type CompanyDatabaseLookupCacheInput = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm: Scalars['String'];
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** The `companyDatabaseLookupCache` to be created by this mutation. */
export type CompanyDatabaseLookupCacheLookupProfileIdFkeyCompanyDatabaseLookupCacheCreateInput = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm: Scalars['String'];
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** The `companyDatabaseLookupProfile` to be created by this mutation. */
export type CompanyDatabaseLookupCacheLookupProfileIdFkeyCompanyDatabaseLookupProfilesCreateInput = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name: Scalars['String'];
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabaseLookupProfile` in the `CompanyDatabaseLookupCacheInput` mutation. */
export type CompanyDatabaseLookupCacheLookupProfileIdFkeyInput = {
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyConnect>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabaseLookupProfileNodeIdConnect>;
  /** A `CompanyDatabaseLookupProfileInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyCompanyDatabaseLookupProfilesCreateInput>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyDelete>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabaseLookupProfileNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabaseLookupProfile` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabaseLookupProfileOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyUsingCompanyDatabaseLookupProfilesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabaseLookupProfile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseLookupCache` in the `CompanyDatabaseLookupProfileInput` mutation. */
export type CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdConnect>>;
  /** A `CompanyDatabaseLookupCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupCacheLookupProfileIdFkeyCompanyDatabaseLookupCacheCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupCache` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyUsingUniqueLookupCacheKeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseLookupProfileOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyNodeIdUpdate>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseLookupCacheNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseLookupCacheNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyUsingUniqueLookupCacheKeyUpdate = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyPatch;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupProfile` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
  patch: CompanyDatabaseLookupProfilePatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyUsingUniqueLookupCacheKeyUpdate = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyPatch;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseRow` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
  patch: CompanyDatabaseRowPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyUsingUniqueLookupCacheKeyUpdate = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyPatch;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyUsingUniqueLookupCacheKeyUpdate = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyPatch;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseColumn` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
  patch: CompanyDatabaseColumnPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyPatch;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to update. */
export type CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyUsingUniqueLookupCacheKeyUpdate = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyPatch;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** Represents an update to a `CompanyDatabaseLookupCache`. Fields that are set will be updated. */
export type CompanyDatabaseLookupCachePatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** The `companyDatabaseLookupCache` to be created by this mutation. */
export type CompanyDatabaseLookupCacheResolvedRowIdFkeyCompanyDatabaseLookupCacheCreateInput = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm: Scalars['String'];
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** The `companyDatabaseRow` to be created by this mutation. */
export type CompanyDatabaseLookupCacheResolvedRowIdFkeyCompanyDatabaseRowsCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex: Scalars['BigInt'];
};

/** Input for the nested mutation of `companyDatabaseRow` in the `CompanyDatabaseLookupCacheInput` mutation. */
export type CompanyDatabaseLookupCacheResolvedRowIdFkeyInput = {
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabaseRowCompanyDatabaseRowsPkeyConnect>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabaseRowNodeIdConnect>;
  /** A `CompanyDatabaseRowInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyCompanyDatabaseRowsCreateInput>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabaseRowCompanyDatabaseRowsPkeyDelete>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabaseRowNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabaseRow` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabaseRowOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyUsingCompanyDatabaseRowsPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabaseRow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseLookupCache` in the `CompanyDatabaseRowInput` mutation. */
export type CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdConnect>>;
  /** A `CompanyDatabaseLookupCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupCacheResolvedRowIdFkeyCompanyDatabaseLookupCacheCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupCache` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyUsingUniqueLookupCacheKeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseRowOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyNodeIdUpdate>>;
};

/** The `companyDatabaseLookupCache` to be created by this mutation. */
export type CompanyDatabaseLookupCacheSearchColumnIdFkeyCompanyDatabaseLookupCacheCreateInput = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm: Scalars['String'];
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `companyDatabaseLookupCache` in the `CompanyDatabaseColumnInput` mutation. */
export type CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdConnect>>;
  /** A `CompanyDatabaseLookupCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupCacheSearchColumnIdFkeyCompanyDatabaseLookupCacheCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupCache` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyUsingUniqueLookupCacheKeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyNodeIdUpdate>>;
};

/** The fields on `companyDatabaseLookupCache` to look up the row to connect. */
export type CompanyDatabaseLookupCacheUniqueLookupCacheKeyConnect = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** The fields on `companyDatabaseLookupCache` to look up the row to delete. */
export type CompanyDatabaseLookupCacheUniqueLookupCacheKeyDelete = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** The `companyDatabaseColumn` to be created by this mutation. */
export type CompanyDatabaseLookupCacheValueColumnIdFkeyCompanyDatabaseColumnsCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  /** Display order of columns in the UI (0-indexed) */
  orderIndex: Scalars['Int'];
  type: CompanyDatabaseColumnType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `companyDatabaseLookupCache` to be created by this mutation. */
export type CompanyDatabaseLookupCacheValueColumnIdFkeyCompanyDatabaseLookupCacheCreateInput = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm: Scalars['String'];
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `companyDatabaseColumn` in the `CompanyDatabaseLookupCacheInput` mutation. */
export type CompanyDatabaseLookupCacheValueColumnIdFkeyInput = {
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabaseColumnCompanyDatabaseColumnsPkeyConnect>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabaseColumnNodeIdConnect>;
  /** A `CompanyDatabaseColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyCompanyDatabaseColumnsCreateInput>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabaseColumnCompanyDatabaseColumnsPkeyDelete>;
  /** The primary key(s) for `companyDatabaseColumn` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabaseColumnNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabaseColumn` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyUsingCompanyDatabaseColumnsPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabaseColumn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseLookupCache` in the `CompanyDatabaseColumnInput` mutation. */
export type CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdConnect>>;
  /** A `CompanyDatabaseLookupCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupCacheValueColumnIdFkeyCompanyDatabaseLookupCacheCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheUniqueLookupCacheKeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupCacheCompanyDatabaseLookupCachePkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupCache` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupCacheNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupCache` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyUsingUniqueLookupCacheKeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyUsingCompanyDatabaseLookupCachePkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupCache` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyNodeIdUpdate>>;
};

/** A connection to a list of `CompanyDatabaseLookupCache` values. */
export type CompanyDatabaseLookupCachesConnection = {
  __typename?: 'CompanyDatabaseLookupCachesConnection';
  /** A list of edges which contains the `CompanyDatabaseLookupCache` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseLookupCachesEdge>;
  /** A list of `CompanyDatabaseLookupCache` objects. */
  nodes: Array<CompanyDatabaseLookupCache>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseLookupCache` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanyDatabaseLookupCache` edge in the connection. */
export type CompanyDatabaseLookupCachesEdge = {
  __typename?: 'CompanyDatabaseLookupCachesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseLookupCache` at the end of the edge. */
  node: CompanyDatabaseLookupCache;
};

/** Methods to use when ordering `CompanyDatabaseLookupCache`. */
export enum CompanyDatabaseLookupCachesOrderBy {
  ConfidenceAsc = 'CONFIDENCE_ASC',
  ConfidenceDesc = 'CONFIDENCE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DatabaseIdAsc = 'DATABASE_ID_ASC',
  DatabaseIdDesc = 'DATABASE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LookupProfileIdAsc = 'LOOKUP_PROFILE_ID_ASC',
  LookupProfileIdDesc = 'LOOKUP_PROFILE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasoningAsc = 'REASONING_ASC',
  ReasoningDesc = 'REASONING_DESC',
  ResolvedRowIdAsc = 'RESOLVED_ROW_ID_ASC',
  ResolvedRowIdDesc = 'RESOLVED_ROW_ID_DESC',
  ResolvedValueAsc = 'RESOLVED_VALUE_ASC',
  ResolvedValueDesc = 'RESOLVED_VALUE_DESC',
  SearchColumnIdAsc = 'SEARCH_COLUMN_ID_ASC',
  SearchColumnIdDesc = 'SEARCH_COLUMN_ID_DESC',
  SearchTermAsc = 'SEARCH_TERM_ASC',
  SearchTermDesc = 'SEARCH_TERM_DESC',
  ValueColumnIdAsc = 'VALUE_COLUMN_ID_ASC',
  ValueColumnIdDesc = 'VALUE_COLUMN_ID_DESC'
}

/** Tracks batch lookup resolution jobs processed by Step Functions */
export type CompanyDatabaseLookupJob = Node & {
  __typename?: 'CompanyDatabaseLookupJob';
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupJob`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  lookupProfileId?: Maybe<Scalars['UUID']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** The order entries to resolve lookups for */
  orderEntryIds: Array<Scalars['UUID']>;
  processedItems?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  status: LookupJobStatus;
  /** AWS Step Function execution ARN for debugging */
  stepFunctionExecutionArn?: Maybe<Scalars['String']>;
  totalItems?: Maybe<Scalars['Int']>;
};

/** The fields on `companyDatabaseLookupJob` to look up the row to connect. */
export type CompanyDatabaseLookupJobCompanyDatabaseLookupJobsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabaseLookupJob` to look up the row to delete. */
export type CompanyDatabaseLookupJobCompanyDatabaseLookupJobsPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseLookupJob` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseLookupJobCondition = {
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lookupProfileId` field. */
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `orderEntryIds` field. */
  orderEntryIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `processedItems` field. */
  processedItems?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LookupJobStatus>;
  /** Checks for equality with the object’s `stepFunctionExecutionArn` field. */
  stepFunctionExecutionArn?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `totalItems` field. */
  totalItems?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `CompanyDatabaseLookupJob` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseLookupJobFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseLookupJobFilter>>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lookupProfileId` field. */
  lookupProfileId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseLookupJobFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseLookupJobFilter>>;
  /** Filter by the object’s `orderEntryIds` field. */
  orderEntryIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `processedItems` field. */
  processedItems?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LookupJobStatusFilter>;
  /** Filter by the object’s `stepFunctionExecutionArn` field. */
  stepFunctionExecutionArn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `totalItems` field. */
  totalItems?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CompanyDatabaseLookupJob` */
export type CompanyDatabaseLookupJobInput = {
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInput>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  /** The order entries to resolve lookups for */
  orderEntryIds: Array<InputMaybe<Scalars['UUID']>>;
  processedItems?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<LookupJobStatus>;
  /** AWS Step Function execution ARN for debugging */
  stepFunctionExecutionArn?: InputMaybe<Scalars['String']>;
  totalItems?: InputMaybe<Scalars['Int']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseLookupJobNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupJob` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseLookupJobNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupJob` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupJobOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupProfile` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
  patch: CompanyDatabaseLookupProfilePatch;
};

/** The fields on `companyDatabaseLookupJob` to look up the row to update. */
export type CompanyDatabaseLookupJobOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyUsingCompanyDatabaseLookupJobsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupJob` being updated. */
  patch: UpdateCompanyDatabaseLookupJobOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyPatch;
};

/** Represents an update to a `CompanyDatabaseLookupJob`. Fields that are set will be updated. */
export type CompanyDatabaseLookupJobPatch = {
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInput>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  /** The order entries to resolve lookups for */
  orderEntryIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  processedItems?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<LookupJobStatus>;
  /** AWS Step Function execution ARN for debugging */
  stepFunctionExecutionArn?: InputMaybe<Scalars['String']>;
  totalItems?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `CompanyDatabaseLookupJob` values. */
export type CompanyDatabaseLookupJobsConnection = {
  __typename?: 'CompanyDatabaseLookupJobsConnection';
  /** A list of edges which contains the `CompanyDatabaseLookupJob` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseLookupJobsEdge>;
  /** A list of `CompanyDatabaseLookupJob` objects. */
  nodes: Array<CompanyDatabaseLookupJob>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseLookupJob` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanyDatabaseLookupJob` edge in the connection. */
export type CompanyDatabaseLookupJobsEdge = {
  __typename?: 'CompanyDatabaseLookupJobsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseLookupJob` at the end of the edge. */
  node: CompanyDatabaseLookupJob;
};

/** The `companyDatabaseLookupJob` to be created by this mutation. */
export type CompanyDatabaseLookupJobsLookupProfileIdFkeyCompanyDatabaseLookupJobsCreateInput = {
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInput>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  /** The order entries to resolve lookups for */
  orderEntryIds: Array<InputMaybe<Scalars['UUID']>>;
  processedItems?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<LookupJobStatus>;
  /** AWS Step Function execution ARN for debugging */
  stepFunctionExecutionArn?: InputMaybe<Scalars['String']>;
  totalItems?: InputMaybe<Scalars['Int']>;
};

/** The `companyDatabaseLookupProfile` to be created by this mutation. */
export type CompanyDatabaseLookupJobsLookupProfileIdFkeyCompanyDatabaseLookupProfilesCreateInput = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name: Scalars['String'];
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabaseLookupProfile` in the `CompanyDatabaseLookupJobInput` mutation. */
export type CompanyDatabaseLookupJobsLookupProfileIdFkeyInput = {
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyConnect>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabaseLookupProfileNodeIdConnect>;
  /** A `CompanyDatabaseLookupProfileInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyCompanyDatabaseLookupProfilesCreateInput>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyDelete>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabaseLookupProfileNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabaseLookupProfile` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabaseLookupProfileOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyUsingCompanyDatabaseLookupProfilesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabaseLookupProfile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseLookupJobOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseLookupJob` in the `CompanyDatabaseLookupProfileInput` mutation. */
export type CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupJobCompanyDatabaseLookupJobsPkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupJob` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupJobNodeIdConnect>>;
  /** A `CompanyDatabaseLookupJobInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupJobsLookupProfileIdFkeyCompanyDatabaseLookupJobsCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupJob` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupJobCompanyDatabaseLookupJobsPkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupJob` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupJobNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupJob` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupJob` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupJobOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyUsingCompanyDatabaseLookupJobsPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupJob` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabaseLookupProfileOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyNodeIdUpdate>>;
};

/** Methods to use when ordering `CompanyDatabaseLookupJob`. */
export enum CompanyDatabaseLookupJobsOrderBy {
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ErrorMessageAsc = 'ERROR_MESSAGE_ASC',
  ErrorMessageDesc = 'ERROR_MESSAGE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LookupProfileIdAsc = 'LOOKUP_PROFILE_ID_ASC',
  LookupProfileIdDesc = 'LOOKUP_PROFILE_ID_DESC',
  Natural = 'NATURAL',
  OrderEntryIdsAsc = 'ORDER_ENTRY_IDS_ASC',
  OrderEntryIdsDesc = 'ORDER_ENTRY_IDS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessedItemsAsc = 'PROCESSED_ITEMS_ASC',
  ProcessedItemsDesc = 'PROCESSED_ITEMS_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StepFunctionExecutionArnAsc = 'STEP_FUNCTION_EXECUTION_ARN_ASC',
  StepFunctionExecutionArnDesc = 'STEP_FUNCTION_EXECUTION_ARN_DESC',
  TotalItemsAsc = 'TOTAL_ITEMS_ASC',
  TotalItemsDesc = 'TOTAL_ITEMS_DESC'
}

/** Defines how intelligent lookups should behave for a database */
export type CompanyDatabaseLookupProfile = Node & {
  __typename?: 'CompanyDatabaseLookupProfile';
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByLookupProfileId: Array<CompanyDatabaseLookupCache>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByLookupProfileIdConnection: CompanyDatabaseLookupCachesConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupJob`. */
  companyDatabaseLookupJobsByLookupProfileId: Array<CompanyDatabaseLookupJob>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupJob`. */
  companyDatabaseLookupJobsByLookupProfileIdConnection: CompanyDatabaseLookupJobsConnection;
  createdAt: Scalars['Datetime'];
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupProfile`. */
  database?: Maybe<CompanyDatabasis>;
  databaseId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria: Array<MatchCriterion>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


/** Defines how intelligent lookups should behave for a database */
export type CompanyDatabaseLookupProfileCompanyDatabaseLookupCachesByLookupProfileIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Defines how intelligent lookups should behave for a database */
export type CompanyDatabaseLookupProfileCompanyDatabaseLookupCachesByLookupProfileIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Defines how intelligent lookups should behave for a database */
export type CompanyDatabaseLookupProfileCompanyDatabaseLookupJobsByLookupProfileIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupJobCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};


/** Defines how intelligent lookups should behave for a database */
export type CompanyDatabaseLookupProfileCompanyDatabaseLookupJobsByLookupProfileIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupJobCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};

/** The fields on `companyDatabaseLookupProfile` to look up the row to connect. */
export type CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabaseLookupProfile` to look up the row to delete. */
export type CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseLookupProfile` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseLookupProfileCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `databaseId` field. */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `matchCriteria` field. */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `systemPrompt` field. */
  systemPrompt?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `CompanyDatabaseLookupProfile` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseLookupProfileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseLookupProfileFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseLookupProfileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseLookupProfileFilter>>;
  /** Filter by the object’s `systemPrompt` field. */
  systemPrompt?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CompanyDatabaseLookupProfile` */
export type CompanyDatabaseLookupProfileInput = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name: Scalars['String'];
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseLookupProfileNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupProfile` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseLookupProfileNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupProfile` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupProfileOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** The fields on `companyDatabaseLookupProfile` to look up the row to update. */
export type CompanyDatabaseLookupProfileOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyUsingCompanyDatabaseLookupProfilesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
  patch: UpdateCompanyDatabaseLookupProfileOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupProfileOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupJob` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupJob` being updated. */
  patch: CompanyDatabaseLookupJobPatch;
};

/** The fields on `companyDatabaseLookupProfile` to look up the row to update. */
export type CompanyDatabaseLookupProfileOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyUsingCompanyDatabaseLookupProfilesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
  patch: UpdateCompanyDatabaseLookupProfileOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseLookupProfileOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `companyDatabaseLookupProfile` to look up the row to update. */
export type CompanyDatabaseLookupProfileOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyUsingCompanyDatabaseLookupProfilesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
  patch: UpdateCompanyDatabaseLookupProfileOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyPatch;
};

/** Represents an update to a `CompanyDatabaseLookupProfile`. Fields that are set will be updated. */
export type CompanyDatabaseLookupProfilePatch = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name?: InputMaybe<Scalars['String']>;
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `CompanyDatabaseLookupProfile` values. */
export type CompanyDatabaseLookupProfilesConnection = {
  __typename?: 'CompanyDatabaseLookupProfilesConnection';
  /** A list of edges which contains the `CompanyDatabaseLookupProfile` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseLookupProfilesEdge>;
  /** A list of `CompanyDatabaseLookupProfile` objects. */
  nodes: Array<CompanyDatabaseLookupProfile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseLookupProfile` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `companyDatabaseLookupProfile` to be created by this mutation. */
export type CompanyDatabaseLookupProfilesDatabaseIdFkeyCompanyDatabaseLookupProfilesCreateInput = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name: Scalars['String'];
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabaseLookupProfilesDatabaseIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabasis` in the `CompanyDatabaseLookupProfileInput` mutation. */
export type CompanyDatabaseLookupProfilesDatabaseIdFkeyInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyConnect>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabasisNodeIdConnect>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyCompanyDatabasesCreateInput>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyDelete>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabasisNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabasisOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseLookupProfileOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseLookupProfile` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyConnect>>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseLookupProfileNodeIdConnect>>;
  /** A `CompanyDatabaseLookupProfileInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseLookupProfilesDatabaseIdFkeyCompanyDatabaseLookupProfilesCreateInput>>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseLookupProfileCompanyDatabaseLookupProfilesPkeyDelete>>;
  /** The primary key(s) for `companyDatabaseLookupProfile` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseLookupProfileNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseLookupProfile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseLookupProfile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseLookupProfileOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyUsingCompanyDatabaseLookupProfilesPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseLookupProfile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyNodeIdUpdate>>;
};

/** A `CompanyDatabaseLookupProfile` edge in the connection. */
export type CompanyDatabaseLookupProfilesEdge = {
  __typename?: 'CompanyDatabaseLookupProfilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseLookupProfile` at the end of the edge. */
  node: CompanyDatabaseLookupProfile;
};

/** Methods to use when ordering `CompanyDatabaseLookupProfile`. */
export enum CompanyDatabaseLookupProfilesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DatabaseIdAsc = 'DATABASE_ID_ASC',
  DatabaseIdDesc = 'DATABASE_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MatchCriteriaAsc = 'MATCH_CRITERIA_ASC',
  MatchCriteriaDesc = 'MATCH_CRITERIA_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SystemPromptAsc = 'SYSTEM_PROMPT_ASC',
  SystemPromptDesc = 'SYSTEM_PROMPT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type CompanyDatabaseLookupResult = {
  __typename?: 'CompanyDatabaseLookupResult';
  /** Whether a matching row was found */
  found: Scalars['Boolean'];
  /** The row ID of the matched row (can be used for additional column lookups) */
  rowId?: Maybe<Scalars['UUID']>;
  /** The value from the value column (null if not found) */
  value?: Maybe<Scalars['String']>;
};

/** Row storage for company database data */
export type CompanyDatabaseRow = Node & {
  __typename?: 'CompanyDatabaseRow';
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsByRowId: Array<CompanyDatabaseCell>;
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsByRowIdConnection: CompanyDatabaseCellsConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByResolvedRowId: Array<CompanyDatabaseLookupCache>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByResolvedRowIdConnection: CompanyDatabaseLookupCachesConnection;
  createdAt: Scalars['Datetime'];
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseRow`. */
  database?: Maybe<CompanyDatabasis>;
  databaseId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Monotonic index for keyset pagination */
  rowIndex: Scalars['BigInt'];
};


/** Row storage for company database data */
export type CompanyDatabaseRowCompanyDatabaseCellsByRowIdArgs = {
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** Row storage for company database data */
export type CompanyDatabaseRowCompanyDatabaseCellsByRowIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** Row storage for company database data */
export type CompanyDatabaseRowCompanyDatabaseLookupCachesByResolvedRowIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Row storage for company database data */
export type CompanyDatabaseRowCompanyDatabaseLookupCachesByResolvedRowIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};

/** The fields on `companyDatabaseRow` to look up the row to connect. */
export type CompanyDatabaseRowCompanyDatabaseRowsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabaseRow` to look up the row to delete. */
export type CompanyDatabaseRowCompanyDatabaseRowsPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabaseRow` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabaseRowCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `databaseId` field. */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rowIndex` field. */
  rowIndex?: InputMaybe<Scalars['BigInt']>;
};

/** A filter to be used against `CompanyDatabaseRow` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabaseRowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabaseRowFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabaseRowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabaseRowFilter>>;
  /** Filter by the object’s `rowIndex` field. */
  rowIndex?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `CompanyDatabaseRow` */
export type CompanyDatabaseRowInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex: Scalars['BigInt'];
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabaseRowNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabaseRow` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabaseRowNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabaseRow` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseRowOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseCell` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
  patch: CompanyDatabaseCellPatch;
};

/** The fields on `companyDatabaseRow` to look up the row to update. */
export type CompanyDatabaseRowOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyUsingCompanyDatabaseRowsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
  patch: UpdateCompanyDatabaseRowOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseRowOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** The fields on `companyDatabaseRow` to look up the row to update. */
export type CompanyDatabaseRowOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyUsingCompanyDatabaseRowsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
  patch: UpdateCompanyDatabaseRowOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabaseRowOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `companyDatabaseRow` to look up the row to update. */
export type CompanyDatabaseRowOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyUsingCompanyDatabaseRowsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
  patch: UpdateCompanyDatabaseRowOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyPatch;
};

/** Represents an update to a `CompanyDatabaseRow`. Fields that are set will be updated. */
export type CompanyDatabaseRowPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `CompanyDatabaseRow` values. */
export type CompanyDatabaseRowsConnection = {
  __typename?: 'CompanyDatabaseRowsConnection';
  /** A list of edges which contains the `CompanyDatabaseRow` and cursor to aid in pagination. */
  edges: Array<CompanyDatabaseRowsEdge>;
  /** A list of `CompanyDatabaseRow` objects. */
  nodes: Array<CompanyDatabaseRow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabaseRow` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `companyDatabaseRow` to be created by this mutation. */
export type CompanyDatabaseRowsDatabaseIdFkeyCompanyDatabaseRowsCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex: Scalars['BigInt'];
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabaseRowsDatabaseIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `companyDatabasis` in the `CompanyDatabaseRowInput` mutation. */
export type CompanyDatabaseRowsDatabaseIdFkeyInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyConnect>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CompanyDatabasisNodeIdConnect>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyCompanyDatabasesCreateInput>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyDatabasisCompanyDatabasesPkeyDelete>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CompanyDatabasisNodeIdDelete>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyDatabasisOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabaseRowOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `companyDatabaseRow` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabaseRowsDatabaseIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabaseRowCompanyDatabaseRowsPkeyConnect>>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabaseRowNodeIdConnect>>;
  /** A `CompanyDatabaseRowInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabaseRowsDatabaseIdFkeyCompanyDatabaseRowsCreateInput>>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabaseRowCompanyDatabaseRowsPkeyDelete>>;
  /** The primary key(s) for `companyDatabaseRow` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabaseRowNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabaseRow` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabaseRow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabaseRowOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyUsingCompanyDatabaseRowsPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabaseRow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyNodeIdUpdate>>;
};

/** A `CompanyDatabaseRow` edge in the connection. */
export type CompanyDatabaseRowsEdge = {
  __typename?: 'CompanyDatabaseRowsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabaseRow` at the end of the edge. */
  node: CompanyDatabaseRow;
};

/** Methods to use when ordering `CompanyDatabaseRow`. */
export enum CompanyDatabaseRowsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DatabaseIdAsc = 'DATABASE_ID_ASC',
  DatabaseIdDesc = 'DATABASE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowIndexAsc = 'ROW_INDEX_ASC',
  RowIndexDesc = 'ROW_INDEX_DESC'
}

/** A connection to a list of `CompanyDatabasis` values. */
export type CompanyDatabasesConnection = {
  __typename?: 'CompanyDatabasesConnection';
  /** A list of edges which contains the `CompanyDatabasis` and cursor to aid in pagination. */
  edges: Array<CompanyDatabasesEdge>;
  /** A list of `CompanyDatabasis` objects. */
  nodes: Array<CompanyDatabasis>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyDatabasis` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `companyDatabasis` to be created by this mutation. */
export type CompanyDatabasesContractorIdFkeyCompanyDatabasesCreateInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `contractor` to be created by this mutation. */
export type CompanyDatabasesContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `CompanyDatabasisInput` mutation. */
export type CompanyDatabasesContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyDatabasesContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CompanyDatabasisOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `companyDatabasis` in the `ContractorInput` mutation. */
export type CompanyDatabasesContractorIdFkeyInverseInput = {
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanyDatabasisCompanyDatabasesPkeyConnect>>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CompanyDatabasisNodeIdConnect>>;
  /** A `CompanyDatabasisInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyDatabasesContractorIdFkeyCompanyDatabasesCreateInput>>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanyDatabasisCompanyDatabasesPkeyDelete>>;
  /** The primary key(s) for `companyDatabasis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CompanyDatabasisNodeIdDelete>>;
  /** Flag indicating whether all other `companyDatabasis` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanyDatabasisOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyUsingCompanyDatabasesPkeyUpdate>>;
  /** The primary key(s) and patch data for `companyDatabasis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyNodeIdUpdate>>;
};

/** A `CompanyDatabasis` edge in the connection. */
export type CompanyDatabasesEdge = {
  __typename?: 'CompanyDatabasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyDatabasis` at the end of the edge. */
  node: CompanyDatabasis;
};

/** Methods to use when ordering `CompanyDatabasis`. */
export enum CompanyDatabasesOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastImportAtAsc = 'LAST_IMPORT_AT_ASC',
  LastImportAtDesc = 'LAST_IMPORT_AT_DESC',
  LastImportStatusAsc = 'LAST_IMPORT_STATUS_ASC',
  LastImportStatusDesc = 'LAST_IMPORT_STATUS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowCountAsc = 'ROW_COUNT_ASC',
  RowCountDesc = 'ROW_COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Company-level custom databases for lookup tables */
export type CompanyDatabasis = Node & {
  __typename?: 'CompanyDatabasis';
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsByDatabaseId: Array<CompanyDatabaseCell>;
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsByDatabaseIdConnection: CompanyDatabaseCellsConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseColumn`. */
  companyDatabaseColumnsByDatabaseId: Array<CompanyDatabaseColumn>;
  /** Reads and enables pagination through a set of `CompanyDatabaseColumn`. */
  companyDatabaseColumnsByDatabaseIdConnection: CompanyDatabaseColumnsConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseImportJob`. */
  companyDatabaseImportJobsByDatabaseId: Array<CompanyDatabaseImportJob>;
  /** Reads and enables pagination through a set of `CompanyDatabaseImportJob`. */
  companyDatabaseImportJobsByDatabaseIdConnection: CompanyDatabaseImportJobsConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByDatabaseId: Array<CompanyDatabaseLookupCache>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesByDatabaseIdConnection: CompanyDatabaseLookupCachesConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupProfile`. */
  companyDatabaseLookupProfilesByDatabaseId: Array<CompanyDatabaseLookupProfile>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupProfile`. */
  companyDatabaseLookupProfilesByDatabaseIdConnection: CompanyDatabaseLookupProfilesConnection;
  /** Reads and enables pagination through a set of `CompanyDatabaseRow`. */
  companyDatabaseRowsByDatabaseId: Array<CompanyDatabaseRow>;
  /** Reads and enables pagination through a set of `CompanyDatabaseRow`. */
  companyDatabaseRowsByDatabaseIdConnection: CompanyDatabaseRowsConnection;
  /** Reads a single `Contractor` that is related to this `CompanyDatabasis`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  lastImportAt?: Maybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: Maybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Cached count of rows for display purposes */
  rowCount: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseCellsByDatabaseIdArgs = {
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseCellsByDatabaseIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseColumnsByDatabaseIdArgs = {
  condition?: InputMaybe<CompanyDatabaseColumnCondition>;
  filter?: InputMaybe<CompanyDatabaseColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseColumnsByDatabaseIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseColumnCondition>;
  filter?: InputMaybe<CompanyDatabaseColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseImportJobsByDatabaseIdArgs = {
  condition?: InputMaybe<CompanyDatabaseImportJobCondition>;
  filter?: InputMaybe<CompanyDatabaseImportJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseImportJobsByDatabaseIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseImportJobCondition>;
  filter?: InputMaybe<CompanyDatabaseImportJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseLookupCachesByDatabaseIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseLookupCachesByDatabaseIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseLookupProfilesByDatabaseIdArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupProfileCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseLookupProfilesByDatabaseIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupProfileCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseRowsByDatabaseIdArgs = {
  condition?: InputMaybe<CompanyDatabaseRowCondition>;
  filter?: InputMaybe<CompanyDatabaseRowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};


/** Company-level custom databases for lookup tables */
export type CompanyDatabasisCompanyDatabaseRowsByDatabaseIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseRowCondition>;
  filter?: InputMaybe<CompanyDatabaseRowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};

/** The fields on `companyDatabasis` to look up the row to connect. */
export type CompanyDatabasisCompanyDatabasesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyDatabasis` to look up the row to delete. */
export type CompanyDatabasisCompanyDatabasesPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyDatabasis` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompanyDatabasisCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastImportAt` field. */
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `lastImportStatus` field. */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `rowCount` field. */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `CompanyDatabasis` object types. All fields are combined with a logical ‘and.’ */
export type CompanyDatabasisFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyDatabasisFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastImportAt` field. */
  lastImportAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lastImportStatus` field. */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatusFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyDatabasisFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyDatabasisFilter>>;
  /** Filter by the object’s `rowCount` field. */
  rowCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CompanyDatabasis` */
export type CompanyDatabasisInput = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name: Scalars['String'];
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CompanyDatabasisNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CompanyDatabasisNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseCell` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
  patch: CompanyDatabaseCellPatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseColumn` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
  patch: CompanyDatabaseColumnPatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseImportJob` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseImportJob` being updated. */
  patch: CompanyDatabaseImportJobPatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupCache` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseLookupProfile` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
  patch: CompanyDatabaseLookupProfilePatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseRow` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
  patch: CompanyDatabaseRowPatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CompanyDatabasisOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `companyDatabasis` to look up the row to update. */
export type CompanyDatabasisOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyUsingCompanyDatabasesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: UpdateCompanyDatabasisOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyPatch;
};

/** Represents an update to a `CompanyDatabasis`. Fields that are set will be updated. */
export type CompanyDatabasisPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type Contractor = Node & {
  __typename?: 'Contractor';
  /** Reads and enables pagination through a set of `CompanyDatabaseImportJob`. */
  companyDatabaseImportJobs: Array<CompanyDatabaseImportJob>;
  /** Reads and enables pagination through a set of `CompanyDatabaseImportJob`. */
  companyDatabaseImportJobsConnection: CompanyDatabaseImportJobsConnection;
  /** Reads and enables pagination through a set of `CompanyDatabasis`. */
  companyDatabases: Array<CompanyDatabasis>;
  /** Reads and enables pagination through a set of `CompanyDatabasis`. */
  companyDatabasesConnection: CompanyDatabasesConnection;
  contractorTier: ContractorTierEnum;
  /** Reads and enables pagination through a set of `CopilotExchange`. */
  copilotExchanges: Array<CopilotExchange>;
  /** Reads and enables pagination through a set of `CopilotExchange`. */
  copilotExchangesConnection: CopilotExchangesConnection;
  createdAt: Scalars['Datetime'];
  /** Reads a single `FlowMailbox` that is related to this `Contractor`. */
  flowMailbox?: Maybe<FlowMailbox>;
  /** Reads and enables pagination through a set of `Flow`. */
  flows: Array<Flow>;
  /** Reads and enables pagination through a set of `Flow`. */
  flowsConnection: FlowsConnection;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OrderEntryTemplate`. */
  orderEntryTemplates: Array<OrderEntryTemplate>;
  /** Reads and enables pagination through a set of `OrderEntryTemplate`. */
  orderEntryTemplatesConnection: OrderEntryTemplatesConnection;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTags: Array<ProjectTag>;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTagsConnection: ProjectTagsConnection;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplates: Array<ProjectTemplate>;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplatesConnection: ProjectTemplatesConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: Array<Project>;
  /** Reads and enables pagination through a set of `Project`. */
  projectsConnection: ProjectsConnection;
  tenant: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type ContractorCompanyDatabaseImportJobsArgs = {
  condition?: InputMaybe<CompanyDatabaseImportJobCondition>;
  filter?: InputMaybe<CompanyDatabaseImportJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};


export type ContractorCompanyDatabaseImportJobsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseImportJobCondition>;
  filter?: InputMaybe<CompanyDatabaseImportJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};


export type ContractorCompanyDatabasesArgs = {
  condition?: InputMaybe<CompanyDatabasisCondition>;
  filter?: InputMaybe<CompanyDatabasisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};


export type ContractorCompanyDatabasesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabasisCondition>;
  filter?: InputMaybe<CompanyDatabasisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};


export type ContractorCopilotExchangesArgs = {
  condition?: InputMaybe<CopilotExchangeCondition>;
  filter?: InputMaybe<CopilotExchangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};


export type ContractorCopilotExchangesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CopilotExchangeCondition>;
  filter?: InputMaybe<CopilotExchangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};


export type ContractorFlowsArgs = {
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


export type ContractorFlowsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


export type ContractorOrderEntryTemplatesArgs = {
  condition?: InputMaybe<OrderEntryTemplateCondition>;
  filter?: InputMaybe<OrderEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};


export type ContractorOrderEntryTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryTemplateCondition>;
  filter?: InputMaybe<OrderEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};


export type ContractorProjectTagsArgs = {
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


export type ContractorProjectTagsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


export type ContractorProjectTemplatesArgs = {
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


export type ContractorProjectTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


export type ContractorProjectsArgs = {
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type ContractorProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/**
 * A condition to be used against `Contractor` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ContractorCondition = {
  /** Checks for equality with the object’s `contractorTier` field. */
  contractorTier?: InputMaybe<ContractorTierEnum>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenant` field. */
  tenant?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `contractor` to look up the row to connect. */
export type ContractorContractorsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `contractor` to look up the row to delete. */
export type ContractorContractorsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `contractor` to look up the row to connect. */
export type ContractorContractorsTenantKeyConnect = {
  tenant: Scalars['String'];
};

/** The fields on `contractor` to look up the row to delete. */
export type ContractorContractorsTenantKeyDelete = {
  tenant: Scalars['String'];
};

/** A filter to be used against `Contractor` object types. All fields are combined with a logical ‘and.’ */
export type ContractorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractorFilter>>;
  /** Filter by the object’s `contractorTier` field. */
  contractorTier?: InputMaybe<ContractorTierEnumFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractorFilter>>;
  /** Filter by the object’s `tenant` field. */
  tenant?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Contractor` */
export type ContractorInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ContractorNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ContractorNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `contractor` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabaseImportJob` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabaseImportJob` being updated. */
  patch: CompanyDatabaseImportJobPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `companyDatabasis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `companyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `copilotExchange` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `copilotExchange` being updated. */
  patch: CopilotExchangePatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnFlowForFlowsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flow` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flow` being updated. */
  patch: FlowPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnFlowForFlowsContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnFlowForFlowsContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnFlowForFlowsContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnFlowForFlowsContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowMailbox` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: FlowMailboxPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderEntryTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderEntryTemplate` being updated. */
  patch: OrderEntryTemplatePatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnProjectForProjectsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnProjectForProjectsContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnProjectForProjectsContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnProjectForProjectsContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnProjectForProjectsContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnProjectTagForProjectTagsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTag` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTag` being updated. */
  patch: ProjectTagPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnProjectTagForProjectTagsContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnProjectTagForProjectTagsContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnProjectTagForProjectTagsContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnProjectTagForProjectTagsContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: ProjectTemplatePatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyUsingContractorsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyPatch;
};

/** The fields on `contractor` to look up the row to update. */
export type ContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyUsingContractorsTenantKeyUpdate = {
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: UpdateContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyPatch;
  tenant: Scalars['String'];
};

/** Represents an update to a `Contractor`. Fields that are set will be updated. */
export type ContractorPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum ContractorTierEnum {
  Free = 'FREE',
  Paid = 'PAID',
  Pro = 'PRO'
}

/** A filter to be used against ContractorTierEnum fields. All fields are combined with a logical ‘and.’ */
export type ContractorTierEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ContractorTierEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ContractorTierEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ContractorTierEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ContractorTierEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ContractorTierEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ContractorTierEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ContractorTierEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ContractorTierEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ContractorTierEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ContractorTierEnum>>;
};

/** A connection to a list of `Contractor` values. */
export type ContractorsConnection = {
  __typename?: 'ContractorsConnection';
  /** A list of edges which contains the `Contractor` and cursor to aid in pagination. */
  edges: Array<ContractorsEdge>;
  /** A list of `Contractor` objects. */
  nodes: Array<Contractor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Contractor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Contractor` edge in the connection. */
export type ContractorsEdge = {
  __typename?: 'ContractorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Contractor` at the end of the edge. */
  node: Contractor;
};

/** Methods to use when ordering `Contractor`. */
export enum ContractorsOrderBy {
  ContractorTierAsc = 'CONTRACTOR_TIER_ASC',
  ContractorTierDesc = 'CONTRACTOR_TIER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type CopilotAnswer = {
  __typename?: 'CopilotAnswer';
  exchangeId: Scalars['UUID'];
  processingTime: Scalars['Int'];
  result: CopilotResult;
};

export type CopilotBadQueryResponse = {
  __typename?: 'CopilotBadQueryResponse';
  reason: Scalars['String'];
};

export enum CopilotError {
  ApiError = 'API_ERROR',
  ErrorResponse = 'ERROR_RESPONSE',
  UnexpectedError = 'UNEXPECTED_ERROR',
  ValidationError = 'VALIDATION_ERROR'
}

/** A filter to be used against CopilotError fields. All fields are combined with a logical ‘and.’ */
export type CopilotErrorFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CopilotError>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CopilotError>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CopilotError>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CopilotError>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CopilotError>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CopilotError>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CopilotError>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CopilotError>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CopilotError>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CopilotError>>;
};

export type CopilotExchange = Node & {
  __typename?: 'CopilotExchange';
  /** Reads a single `Contractor` that is related to this `CopilotExchange`. */
  contractor?: Maybe<Contractor>;
  contractorId?: Maybe<Scalars['UUID']>;
  /** Reads a single `CopilotExchangesFeedback` that is related to this `CopilotExchange`. */
  copilotExchangesFeedbackById?: Maybe<CopilotExchangesFeedback>;
  createdAt: Scalars['Datetime'];
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<CopilotError>;
  id: Scalars['UUID'];
  model: Scalars['String'];
  modelResponse?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `CopilotExchange`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['UUID']>;
  result?: Maybe<CopilotResult>;
  updatedAt: Scalars['Datetime'];
  userId?: Maybe<Scalars['String']>;
  userPrompt: Scalars['String'];
};

/**
 * A condition to be used against `CopilotExchange` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CopilotExchangeCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `errorType` field. */
  errorType?: InputMaybe<CopilotError>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `model` field. */
  model?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `modelResponse` field. */
  modelResponse?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userPrompt` field. */
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** The fields on `copilotExchange` to look up the row to connect. */
export type CopilotExchangeCopilotExchangesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `copilotExchange` to look up the row to delete. */
export type CopilotExchangeCopilotExchangesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `CopilotExchange` object types. All fields are combined with a logical ‘and.’ */
export type CopilotExchangeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CopilotExchangeFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `errorType` field. */
  errorType?: InputMaybe<CopilotErrorFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `model` field. */
  model?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modelResponse` field. */
  modelResponse?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CopilotExchangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CopilotExchangeFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userPrompt` field. */
  userPrompt?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CopilotExchange` */
export type CopilotExchangeInput = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model: Scalars['String'];
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type CopilotExchangeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `copilotExchange` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CopilotExchangeNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `copilotExchange` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CopilotExchangeOnCopilotExchangeForCopilotExchangesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `copilotExchange` to look up the row to update. */
export type CopilotExchangeOnCopilotExchangeForCopilotExchangesContractorIdFkeyUsingCopilotExchangesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `copilotExchange` being updated. */
  patch: UpdateCopilotExchangeOnCopilotExchangeForCopilotExchangesContractorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CopilotExchangeOnCopilotExchangeForCopilotExchangesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `copilotExchange` to look up the row to update. */
export type CopilotExchangeOnCopilotExchangeForCopilotExchangesProjectIdFkeyUsingCopilotExchangesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `copilotExchange` being updated. */
  patch: UpdateCopilotExchangeOnCopilotExchangeForCopilotExchangesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CopilotExchangeOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `copilotExchangesFeedback` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `copilotExchangesFeedback` being updated. */
  patch: CopilotExchangesFeedbackPatch;
};

/** The fields on `copilotExchange` to look up the row to update. */
export type CopilotExchangeOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyUsingCopilotExchangesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `copilotExchange` being updated. */
  patch: UpdateCopilotExchangeOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyPatch;
};

/** Represents an update to a `CopilotExchange`. Fields that are set will be updated. */
export type CopilotExchangePatch = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model?: InputMaybe<Scalars['String']>;
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `CopilotExchange` values. */
export type CopilotExchangesConnection = {
  __typename?: 'CopilotExchangesConnection';
  /** A list of edges which contains the `CopilotExchange` and cursor to aid in pagination. */
  edges: Array<CopilotExchangesEdge>;
  /** A list of `CopilotExchange` objects. */
  nodes: Array<CopilotExchange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CopilotExchange` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type CopilotExchangesContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `copilotExchange` to be created by this mutation. */
export type CopilotExchangesContractorIdFkeyCopilotExchangesCreateInput = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model: Scalars['String'];
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt: Scalars['String'];
};

/** Input for the nested mutation of `contractor` in the `CopilotExchangeInput` mutation. */
export type CopilotExchangesContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<CopilotExchangesContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CopilotExchangeOnCopilotExchangeForCopilotExchangesContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `copilotExchange` in the `ContractorInput` mutation. */
export type CopilotExchangesContractorIdFkeyInverseInput = {
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CopilotExchangeCopilotExchangesPkeyConnect>>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CopilotExchangeNodeIdConnect>>;
  /** A `CopilotExchangeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CopilotExchangesContractorIdFkeyCopilotExchangesCreateInput>>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CopilotExchangeCopilotExchangesPkeyDelete>>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CopilotExchangeNodeIdDelete>>;
  /** Flag indicating whether all other `copilotExchange` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `copilotExchange` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CopilotExchangeOnCopilotExchangeForCopilotExchangesContractorIdFkeyUsingCopilotExchangesPkeyUpdate>>;
  /** The primary key(s) and patch data for `copilotExchange` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyNodeIdUpdate>>;
};

/** A `CopilotExchange` edge in the connection. */
export type CopilotExchangesEdge = {
  __typename?: 'CopilotExchangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CopilotExchange` at the end of the edge. */
  node: CopilotExchange;
};

export type CopilotExchangesFeedback = Node & {
  __typename?: 'CopilotExchangesFeedback';
  approval: Scalars['Boolean'];
  /** Reads a single `CopilotExchange` that is related to this `CopilotExchangesFeedback`. */
  copilotExchangeById?: Maybe<CopilotExchange>;
  createdAt: Scalars['Datetime'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `CopilotExchangesFeedback` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CopilotExchangesFeedbackCondition = {
  /** Checks for equality with the object’s `approval` field. */
  approval?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `feedback` field. */
  feedback?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `copilotExchangesFeedback` to look up the row to connect. */
export type CopilotExchangesFeedbackCopilotExchangesFeedbackPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `copilotExchangesFeedback` to look up the row to delete. */
export type CopilotExchangesFeedbackCopilotExchangesFeedbackPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `CopilotExchangesFeedback` object types. All fields are combined with a logical ‘and.’ */
export type CopilotExchangesFeedbackFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CopilotExchangesFeedbackFilter>>;
  /** Filter by the object’s `approval` field. */
  approval?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `feedback` field. */
  feedback?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CopilotExchangesFeedbackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CopilotExchangesFeedbackFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The `copilotExchange` to be created by this mutation. */
export type CopilotExchangesFeedbackIdFkeyCopilotExchangesCreateInput = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model: Scalars['String'];
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt: Scalars['String'];
};

/** The `copilotExchangesFeedback` to be created by this mutation. */
export type CopilotExchangesFeedbackIdFkeyCopilotExchangesFeedbackCreateInput = {
  approval: Scalars['Boolean'];
  copilotExchange?: InputMaybe<CopilotExchangesFeedbackIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `copilotExchange` in the `CopilotExchangesFeedbackInput` mutation. */
export type CopilotExchangesFeedbackIdFkeyInput = {
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  connectById?: InputMaybe<CopilotExchangeCopilotExchangesPkeyConnect>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CopilotExchangeNodeIdConnect>;
  /** A `CopilotExchangeInput` object that will be created and connected to this object. */
  create?: InputMaybe<CopilotExchangesFeedbackIdFkeyCopilotExchangesCreateInput>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  deleteById?: InputMaybe<CopilotExchangeCopilotExchangesPkeyDelete>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CopilotExchangeNodeIdDelete>;
  /** The primary key(s) and patch data for `copilotExchange` for the far side of the relationship. */
  updateById?: InputMaybe<CopilotExchangeOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyUsingCopilotExchangesPkeyUpdate>;
  /** The primary key(s) and patch data for `copilotExchange` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CopilotExchangesFeedbackOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `copilotExchangesFeedback` in the `CopilotExchangeInput` mutation. */
export type CopilotExchangesFeedbackIdFkeyInverseInput = {
  /** The primary key(s) for `copilotExchangesFeedback` for the far side of the relationship. */
  connectById?: InputMaybe<CopilotExchangesFeedbackCopilotExchangesFeedbackPkeyConnect>;
  /** The primary key(s) for `copilotExchangesFeedback` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CopilotExchangesFeedbackNodeIdConnect>;
  /** A `CopilotExchangesFeedbackInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CopilotExchangesFeedbackIdFkeyCopilotExchangesFeedbackCreateInput>>;
  /** The primary key(s) for `copilotExchangesFeedback` for the far side of the relationship. */
  deleteById?: InputMaybe<CopilotExchangesFeedbackCopilotExchangesFeedbackPkeyDelete>;
  /** The primary key(s) for `copilotExchangesFeedback` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CopilotExchangesFeedbackNodeIdDelete>;
  /** Flag indicating whether all other `copilotExchangesFeedback` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `copilotExchangesFeedback` for the far side of the relationship. */
  updateById?: InputMaybe<CopilotExchangesFeedbackOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyUsingCopilotExchangesFeedbackPkeyUpdate>;
  /** The primary key(s) and patch data for `copilotExchangesFeedback` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CopilotExchangeOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyNodeIdUpdate>;
};

/** An input for mutations affecting `CopilotExchangesFeedback` */
export type CopilotExchangesFeedbackInput = {
  approval: Scalars['Boolean'];
  copilotExchange?: InputMaybe<CopilotExchangesFeedbackIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CopilotExchangesFeedbackNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `copilotExchangesFeedback` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CopilotExchangesFeedbackNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `copilotExchangesFeedback` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CopilotExchangesFeedbackOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `copilotExchange` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `copilotExchange` being updated. */
  patch: CopilotExchangePatch;
};

/** The fields on `copilotExchangesFeedback` to look up the row to update. */
export type CopilotExchangesFeedbackOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyUsingCopilotExchangesFeedbackPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `copilotExchangesFeedback` being updated. */
  patch: UpdateCopilotExchangesFeedbackOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyPatch;
};

/** Represents an update to a `CopilotExchangesFeedback`. Fields that are set will be updated. */
export type CopilotExchangesFeedbackPatch = {
  approval?: InputMaybe<Scalars['Boolean']>;
  copilotExchange?: InputMaybe<CopilotExchangesFeedbackIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `CopilotExchangesFeedback` values. */
export type CopilotExchangesFeedbacksConnection = {
  __typename?: 'CopilotExchangesFeedbacksConnection';
  /** A list of edges which contains the `CopilotExchangesFeedback` and cursor to aid in pagination. */
  edges: Array<CopilotExchangesFeedbacksEdge>;
  /** A list of `CopilotExchangesFeedback` objects. */
  nodes: Array<CopilotExchangesFeedback>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CopilotExchangesFeedback` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CopilotExchangesFeedback` edge in the connection. */
export type CopilotExchangesFeedbacksEdge = {
  __typename?: 'CopilotExchangesFeedbacksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CopilotExchangesFeedback` at the end of the edge. */
  node: CopilotExchangesFeedback;
};

/** Methods to use when ordering `CopilotExchangesFeedback`. */
export enum CopilotExchangesFeedbacksOrderBy {
  ApprovalAsc = 'APPROVAL_ASC',
  ApprovalDesc = 'APPROVAL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FeedbackAsc = 'FEEDBACK_ASC',
  FeedbackDesc = 'FEEDBACK_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Methods to use when ordering `CopilotExchange`. */
export enum CopilotExchangesOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ErrorMessageAsc = 'ERROR_MESSAGE_ASC',
  ErrorMessageDesc = 'ERROR_MESSAGE_DESC',
  ErrorTypeAsc = 'ERROR_TYPE_ASC',
  ErrorTypeDesc = 'ERROR_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  ModelResponseAsc = 'MODEL_RESPONSE_ASC',
  ModelResponseDesc = 'MODEL_RESPONSE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UserPromptAsc = 'USER_PROMPT_ASC',
  UserPromptDesc = 'USER_PROMPT_DESC'
}

/** The `copilotExchange` to be created by this mutation. */
export type CopilotExchangesProjectIdFkeyCopilotExchangesCreateInput = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model: Scalars['String'];
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt: Scalars['String'];
};

/** Input for the nested mutation of `project` in the `CopilotExchangeInput` mutation. */
export type CopilotExchangesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<CopilotExchangesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnCopilotExchangeForCopilotExchangesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CopilotExchangeOnCopilotExchangeForCopilotExchangesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `copilotExchange` in the `ProjectInput` mutation. */
export type CopilotExchangesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CopilotExchangeCopilotExchangesPkeyConnect>>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CopilotExchangeNodeIdConnect>>;
  /** A `CopilotExchangeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CopilotExchangesProjectIdFkeyCopilotExchangesCreateInput>>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CopilotExchangeCopilotExchangesPkeyDelete>>;
  /** The primary key(s) for `copilotExchange` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CopilotExchangeNodeIdDelete>>;
  /** Flag indicating whether all other `copilotExchange` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `copilotExchange` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CopilotExchangeOnCopilotExchangeForCopilotExchangesProjectIdFkeyUsingCopilotExchangesPkeyUpdate>>;
  /** The primary key(s) and patch data for `copilotExchange` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnCopilotExchangeForCopilotExchangesProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type CopilotExchangesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type CopilotResult = CopilotBadQueryResponse | CopilotResultData;

export type CopilotResultData = {
  __typename?: 'CopilotResultData';
  attributeQuery: ForgeAttributeQueryType;
  breakdown?: Maybe<Array<Breakdown>>;
  quantity_extraction?: Maybe<Array<QuantityExtraction>>;
};

/** All input for the `createApiClient` mutation. */
export type CreateApiClientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  contractorId: Scalars['UUID'];
};

/** The output of our `createApiClient` mutation. */
export type CreateApiClientPayload = {
  __typename?: 'CreateApiClientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<CreateApiClientRecord>>;
};

/** The return type of our `createApiClient` mutation. */
export type CreateApiClientRecord = {
  __typename?: 'CreateApiClientRecord';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
};

/** All input for the create `AutoShape` mutation. */
export type CreateAutoShapeInput = {
  /** The `AutoShape` to be created by this mutation. */
  autoShape: AutoShapeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AutoShape` mutation. */
export type CreateAutoShapePayload = {
  __typename?: 'CreateAutoShapePayload';
  /** The `AutoShape` that was created by this mutation. */
  autoShape?: Maybe<AutoShape>;
  /** An edge for our `AutoShape`. May be used by Relay 1. */
  autoShapeEdge?: Maybe<AutoShapesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `AutoShape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AutoShape` mutation. */
export type CreateAutoShapePayloadAutoShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};

/** All input for the create `Comment` mutation. */
export type CreateCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Comment` to be created by this mutation. */
  comment: CommentInput;
};

/** The output of our create `Comment` mutation. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` that was created by this mutation. */
  comment?: Maybe<Comment>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  commentByReplies?: Maybe<Comment>;
  /** An edge for our `Comment`. May be used by Relay 1. */
  commentEdge?: Maybe<CommentsEdge>;
  /** Reads a single `Order` that is related to this `Comment`. */
  order?: Maybe<Order>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  parent?: Maybe<Comment>;
  /** Reads a single `Project` that is related to this `Comment`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavedView` that is related to this `Comment`. */
  savedViews?: Maybe<SavedView>;
};


/** The output of our create `Comment` mutation. */
export type CreateCommentPayloadCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};

/** All input for the create `CompanyDatabaseCell` mutation. */
export type CreateCompanyDatabaseCellInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseCell` to be created by this mutation. */
  companyDatabaseCell: CompanyDatabaseCellInput;
};

/** The output of our create `CompanyDatabaseCell` mutation. */
export type CreateCompanyDatabaseCellPayload = {
  __typename?: 'CreateCompanyDatabaseCellPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseCell`. */
  column?: Maybe<CompanyDatabaseColumn>;
  /** The `CompanyDatabaseCell` that was created by this mutation. */
  companyDatabaseCell?: Maybe<CompanyDatabaseCell>;
  /** An edge for our `CompanyDatabaseCell`. May be used by Relay 1. */
  companyDatabaseCellEdge?: Maybe<CompanyDatabaseCellsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseCell`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseCell`. */
  row?: Maybe<CompanyDatabaseRow>;
};


/** The output of our create `CompanyDatabaseCell` mutation. */
export type CreateCompanyDatabaseCellPayloadCompanyDatabaseCellEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};

/** All input for the create `CompanyDatabaseColumn` mutation. */
export type CreateCompanyDatabaseColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseColumn` to be created by this mutation. */
  companyDatabaseColumn: CompanyDatabaseColumnInput;
};

/** The output of our create `CompanyDatabaseColumn` mutation. */
export type CreateCompanyDatabaseColumnPayload = {
  __typename?: 'CreateCompanyDatabaseColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseColumn` that was created by this mutation. */
  companyDatabaseColumn?: Maybe<CompanyDatabaseColumn>;
  /** An edge for our `CompanyDatabaseColumn`. May be used by Relay 1. */
  companyDatabaseColumnEdge?: Maybe<CompanyDatabaseColumnsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseColumn`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyDatabaseColumn` mutation. */
export type CreateCompanyDatabaseColumnPayloadCompanyDatabaseColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};

/** All input for the create `CompanyDatabaseImportJob` mutation. */
export type CreateCompanyDatabaseImportJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseImportJob` to be created by this mutation. */
  companyDatabaseImportJob: CompanyDatabaseImportJobInput;
};

/** The output of our create `CompanyDatabaseImportJob` mutation. */
export type CreateCompanyDatabaseImportJobPayload = {
  __typename?: 'CreateCompanyDatabaseImportJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseImportJob` that was created by this mutation. */
  companyDatabaseImportJob?: Maybe<CompanyDatabaseImportJob>;
  /** An edge for our `CompanyDatabaseImportJob`. May be used by Relay 1. */
  companyDatabaseImportJobEdge?: Maybe<CompanyDatabaseImportJobsEdge>;
  /** Reads a single `Contractor` that is related to this `CompanyDatabaseImportJob`. */
  contractor?: Maybe<Contractor>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseImportJob`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyDatabaseImportJob` mutation. */
export type CreateCompanyDatabaseImportJobPayloadCompanyDatabaseImportJobEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};

/** All input for the create `CompanyDatabaseLookupCache` mutation. */
export type CreateCompanyDatabaseLookupCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupCache` to be created by this mutation. */
  companyDatabaseLookupCache: CompanyDatabaseLookupCacheInput;
};

/** The output of our create `CompanyDatabaseLookupCache` mutation. */
export type CreateCompanyDatabaseLookupCachePayload = {
  __typename?: 'CreateCompanyDatabaseLookupCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupCache` that was created by this mutation. */
  companyDatabaseLookupCache?: Maybe<CompanyDatabaseLookupCache>;
  /** An edge for our `CompanyDatabaseLookupCache`. May be used by Relay 1. */
  companyDatabaseLookupCacheEdge?: Maybe<CompanyDatabaseLookupCachesEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupCache`. */
  database?: Maybe<CompanyDatabasis>;
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupCache`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseLookupCache`. */
  resolved?: Maybe<CompanyDatabaseRow>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  searchColumn?: Maybe<CompanyDatabaseColumn>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  valueColumn?: Maybe<CompanyDatabaseColumn>;
};


/** The output of our create `CompanyDatabaseLookupCache` mutation. */
export type CreateCompanyDatabaseLookupCachePayloadCompanyDatabaseLookupCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};

/** All input for the create `CompanyDatabaseLookupJob` mutation. */
export type CreateCompanyDatabaseLookupJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupJob` to be created by this mutation. */
  companyDatabaseLookupJob: CompanyDatabaseLookupJobInput;
};

/** The output of our create `CompanyDatabaseLookupJob` mutation. */
export type CreateCompanyDatabaseLookupJobPayload = {
  __typename?: 'CreateCompanyDatabaseLookupJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupJob` that was created by this mutation. */
  companyDatabaseLookupJob?: Maybe<CompanyDatabaseLookupJob>;
  /** An edge for our `CompanyDatabaseLookupJob`. May be used by Relay 1. */
  companyDatabaseLookupJobEdge?: Maybe<CompanyDatabaseLookupJobsEdge>;
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupJob`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyDatabaseLookupJob` mutation. */
export type CreateCompanyDatabaseLookupJobPayloadCompanyDatabaseLookupJobEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};

/** All input for the create `CompanyDatabaseLookupProfile` mutation. */
export type CreateCompanyDatabaseLookupProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupProfile` to be created by this mutation. */
  companyDatabaseLookupProfile: CompanyDatabaseLookupProfileInput;
};

/** The output of our create `CompanyDatabaseLookupProfile` mutation. */
export type CreateCompanyDatabaseLookupProfilePayload = {
  __typename?: 'CreateCompanyDatabaseLookupProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupProfile` that was created by this mutation. */
  companyDatabaseLookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** An edge for our `CompanyDatabaseLookupProfile`. May be used by Relay 1. */
  companyDatabaseLookupProfileEdge?: Maybe<CompanyDatabaseLookupProfilesEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupProfile`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyDatabaseLookupProfile` mutation. */
export type CreateCompanyDatabaseLookupProfilePayloadCompanyDatabaseLookupProfileEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};

/** All input for the create `CompanyDatabaseRow` mutation. */
export type CreateCompanyDatabaseRowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabaseRow` to be created by this mutation. */
  companyDatabaseRow: CompanyDatabaseRowInput;
};

/** The output of our create `CompanyDatabaseRow` mutation. */
export type CreateCompanyDatabaseRowPayload = {
  __typename?: 'CreateCompanyDatabaseRowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseRow` that was created by this mutation. */
  companyDatabaseRow?: Maybe<CompanyDatabaseRow>;
  /** An edge for our `CompanyDatabaseRow`. May be used by Relay 1. */
  companyDatabaseRowEdge?: Maybe<CompanyDatabaseRowsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseRow`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyDatabaseRow` mutation. */
export type CreateCompanyDatabaseRowPayloadCompanyDatabaseRowEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};

/** All input for the create `CompanyDatabasis` mutation. */
export type CreateCompanyDatabasisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyDatabasis` to be created by this mutation. */
  companyDatabasis: CompanyDatabasisInput;
};

/** The output of our create `CompanyDatabasis` mutation. */
export type CreateCompanyDatabasisPayload = {
  __typename?: 'CreateCompanyDatabasisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabasis` that was created by this mutation. */
  companyDatabasis?: Maybe<CompanyDatabasis>;
  /** An edge for our `CompanyDatabasis`. May be used by Relay 1. */
  companyDatabasisEdge?: Maybe<CompanyDatabasesEdge>;
  /** Reads a single `Contractor` that is related to this `CompanyDatabasis`. */
  contractor?: Maybe<Contractor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyDatabasis` mutation. */
export type CreateCompanyDatabasisPayloadCompanyDatabasisEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};

/** All input for the create `Contractor` mutation. */
export type CreateContractorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Contractor` to be created by this mutation. */
  contractor: ContractorInput;
};

/** The output of our create `Contractor` mutation. */
export type CreateContractorPayload = {
  __typename?: 'CreateContractorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contractor` that was created by this mutation. */
  contractor?: Maybe<Contractor>;
  /** An edge for our `Contractor`. May be used by Relay 1. */
  contractorEdge?: Maybe<ContractorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Contractor` mutation. */
export type CreateContractorPayloadContractorEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractorsOrderBy>>;
};

/** All input for the create `CopilotExchange` mutation. */
export type CreateCopilotExchangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CopilotExchange` to be created by this mutation. */
  copilotExchange: CopilotExchangeInput;
};

/** The output of our create `CopilotExchange` mutation. */
export type CreateCopilotExchangePayload = {
  __typename?: 'CreateCopilotExchangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `CopilotExchange`. */
  contractor?: Maybe<Contractor>;
  /** The `CopilotExchange` that was created by this mutation. */
  copilotExchange?: Maybe<CopilotExchange>;
  /** An edge for our `CopilotExchange`. May be used by Relay 1. */
  copilotExchangeEdge?: Maybe<CopilotExchangesEdge>;
  /** Reads a single `Project` that is related to this `CopilotExchange`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CopilotExchange` mutation. */
export type CreateCopilotExchangePayloadCopilotExchangeEdgeArgs = {
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};

/** All input for the create `CopilotExchangesFeedback` mutation. */
export type CreateCopilotExchangesFeedbackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CopilotExchangesFeedback` to be created by this mutation. */
  copilotExchangesFeedback: CopilotExchangesFeedbackInput;
};

/** The output of our create `CopilotExchangesFeedback` mutation. */
export type CreateCopilotExchangesFeedbackPayload = {
  __typename?: 'CreateCopilotExchangesFeedbackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CopilotExchange` that is related to this `CopilotExchangesFeedback`. */
  copilotExchangeById?: Maybe<CopilotExchange>;
  /** The `CopilotExchangesFeedback` that was created by this mutation. */
  copilotExchangesFeedback?: Maybe<CopilotExchangesFeedback>;
  /** An edge for our `CopilotExchangesFeedback`. May be used by Relay 1. */
  copilotExchangesFeedbackEdge?: Maybe<CopilotExchangesFeedbacksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CopilotExchangesFeedback` mutation. */
export type CreateCopilotExchangesFeedbackPayloadCopilotExchangesFeedbackEdgeArgs = {
  orderBy?: InputMaybe<Array<CopilotExchangesFeedbacksOrderBy>>;
};

/** All input for the create `CustomField` mutation. */
export type CreateCustomFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CustomField` to be created by this mutation. */
  customField: CustomFieldInput;
};

/** The output of our create `CustomField` mutation. */
export type CreateCustomFieldPayload = {
  __typename?: 'CreateCustomFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomField` that was created by this mutation. */
  customField?: Maybe<CustomField>;
  /** An edge for our `CustomField`. May be used by Relay 1. */
  customFieldEdge?: Maybe<CustomFieldsEdge>;
  /** Reads a single `OrderColumn` that is related to this `CustomField`. */
  orderColumn?: Maybe<OrderColumn>;
  /** Reads a single `OrderEntry` that is related to this `CustomField`. */
  orderEntry?: Maybe<OrderEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CustomField` mutation. */
export type CreateCustomFieldPayloadCustomFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};

/** All input for the create `CustomFieldTemplate` mutation. */
export type CreateCustomFieldTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CustomFieldTemplate` to be created by this mutation. */
  customFieldTemplate: CustomFieldTemplateInput;
};

/** The output of our create `CustomFieldTemplate` mutation. */
export type CreateCustomFieldTemplatePayload = {
  __typename?: 'CreateCustomFieldTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomFieldTemplate` that was created by this mutation. */
  customFieldTemplate?: Maybe<CustomFieldTemplate>;
  /** An edge for our `CustomFieldTemplate`. May be used by Relay 1. */
  customFieldTemplateEdge?: Maybe<CustomFieldTemplatesEdge>;
  /** Reads a single `OrderColumnTemplate` that is related to this `CustomFieldTemplate`. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** Reads a single `ProjectTemplateOrderEntry` that is related to this `CustomFieldTemplate`. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CustomFieldTemplate` mutation. */
export type CreateCustomFieldTemplatePayloadCustomFieldTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};

/** All input for the create `ExtrudedPolygon` mutation. */
export type CreateExtrudedPolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExtrudedPolygon` to be created by this mutation. */
  extrudedPolygon: ExtrudedPolygonInput;
};

/** The output of our create `ExtrudedPolygon` mutation. */
export type CreateExtrudedPolygonPayload = {
  __typename?: 'CreateExtrudedPolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExtrudedPolygon` that was created by this mutation. */
  extrudedPolygon?: Maybe<ExtrudedPolygon>;
  /** An edge for our `ExtrudedPolygon`. May be used by Relay 1. */
  extrudedPolygonEdge?: Maybe<ExtrudedPolygonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `ExtrudedPolygon`. */
  shape?: Maybe<Shape>;
};


/** The output of our create `ExtrudedPolygon` mutation. */
export type CreateExtrudedPolygonPayloadExtrudedPolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<ExtrudedPolygonsOrderBy>>;
};

/** All input for the create `FlowAction` mutation. */
export type CreateFlowActionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FlowAction` to be created by this mutation. */
  flowAction: FlowActionInput;
};

/** The output of our create `FlowAction` mutation. */
export type CreateFlowActionPayload = {
  __typename?: 'CreateFlowActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Flow` that is related to this `FlowAction`. */
  flow?: Maybe<Flow>;
  /** The `FlowAction` that was created by this mutation. */
  flowAction?: Maybe<FlowAction>;
  /** An edge for our `FlowAction`. May be used by Relay 1. */
  flowActionEdge?: Maybe<FlowActionsEdge>;
  /** Reads a single `FlowAction` that is related to this `FlowAction`. */
  parentLoopAction?: Maybe<FlowAction>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FlowAction` mutation. */
export type CreateFlowActionPayloadFlowActionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};

/** All input for the create `FlowExecution` mutation. */
export type CreateFlowExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FlowExecution` to be created by this mutation. */
  flowExecution: FlowExecutionInput;
};

/** The output of our create `FlowExecution` mutation. */
export type CreateFlowExecutionPayload = {
  __typename?: 'CreateFlowExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Flow` that is related to this `FlowExecution`. */
  flow?: Maybe<Flow>;
  /** The `FlowExecution` that was created by this mutation. */
  flowExecution?: Maybe<FlowExecution>;
  /** An edge for our `FlowExecution`. May be used by Relay 1. */
  flowExecutionEdge?: Maybe<FlowExecutionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FlowExecution` mutation. */
export type CreateFlowExecutionPayloadFlowExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};

/** All input for the create `Flow` mutation. */
export type CreateFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Flow` to be created by this mutation. */
  flow: FlowInput;
};

/** All input for the create `FlowMailbox` mutation. */
export type CreateFlowMailboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FlowMailbox` to be created by this mutation. */
  flowMailbox: FlowMailboxInput;
};

/** All input for the create `FlowMailboxMessage` mutation. */
export type CreateFlowMailboxMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FlowMailboxMessage` to be created by this mutation. */
  flowMailboxMessage: FlowMailboxMessageInput;
};

/** The output of our create `FlowMailboxMessage` mutation. */
export type CreateFlowMailboxMessagePayload = {
  __typename?: 'CreateFlowMailboxMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `FlowExecution` that is related to this `FlowMailboxMessage`. */
  flowExecution?: Maybe<FlowExecution>;
  /** The `FlowMailboxMessage` that was created by this mutation. */
  flowMailboxMessage?: Maybe<FlowMailboxMessage>;
  /** An edge for our `FlowMailboxMessage`. May be used by Relay 1. */
  flowMailboxMessageEdge?: Maybe<FlowMailboxMessagesEdge>;
  /** Reads a single `FlowMailbox` that is related to this `FlowMailboxMessage`. */
  mailbox?: Maybe<FlowMailbox>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FlowMailboxMessage` mutation. */
export type CreateFlowMailboxMessagePayloadFlowMailboxMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};

/** The output of our create `FlowMailbox` mutation. */
export type CreateFlowMailboxPayload = {
  __typename?: 'CreateFlowMailboxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `FlowMailbox`. */
  contractor?: Maybe<Contractor>;
  /** The `FlowMailbox` that was created by this mutation. */
  flowMailbox?: Maybe<FlowMailbox>;
  /** An edge for our `FlowMailbox`. May be used by Relay 1. */
  flowMailboxEdge?: Maybe<FlowMailboxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FlowMailbox` mutation. */
export type CreateFlowMailboxPayloadFlowMailboxEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowMailboxesOrderBy>>;
};

/** The output of our create `Flow` mutation. */
export type CreateFlowPayload = {
  __typename?: 'CreateFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Flow`. */
  contractor?: Maybe<Contractor>;
  /** The `Flow` that was created by this mutation. */
  flow?: Maybe<Flow>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Flow` mutation. */
export type CreateFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the create `HistoryEvent` mutation. */
export type CreateHistoryEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `HistoryEvent` to be created by this mutation. */
  historyEvent: HistoryEventInput;
};

/** The output of our create `HistoryEvent` mutation. */
export type CreateHistoryEventPayload = {
  __typename?: 'CreateHistoryEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `HistoryEvent` that was created by this mutation. */
  historyEvent?: Maybe<HistoryEvent>;
  /** An edge for our `HistoryEvent`. May be used by Relay 1. */
  historyEventEdge?: Maybe<HistoryEventsEdge>;
  /** Reads a single `Project` that is related to this `HistoryEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `HistoryEvent` mutation. */
export type CreateHistoryEventPayloadHistoryEventEdgeArgs = {
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};

/** All input for the create `InitialState` mutation. */
export type CreateInitialStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `InitialState` to be created by this mutation. */
  initialState: InitialStateInput;
};

/** The output of our create `InitialState` mutation. */
export type CreateInitialStatePayload = {
  __typename?: 'CreateInitialStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InitialState` that was created by this mutation. */
  initialState?: Maybe<InitialState>;
  /** An edge for our `InitialState`. May be used by Relay 1. */
  initialStateEdge?: Maybe<InitialStatesEdge>;
  /** Reads a single `Project` that is related to this `InitialState`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavedView` that is related to this `InitialState`. */
  view?: Maybe<SavedView>;
};


/** The output of our create `InitialState` mutation. */
export type CreateInitialStatePayloadInitialStateEdgeArgs = {
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};

/** All input for the create `IssueComment` mutation. */
export type CreateIssueCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `IssueComment` to be created by this mutation. */
  issueComment: IssueCommentInput;
};

/** The output of our create `IssueComment` mutation. */
export type CreateIssueCommentPayload = {
  __typename?: 'CreateIssueCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Issue` that is related to this `IssueComment`. */
  issue?: Maybe<Issue>;
  /** The `IssueComment` that was created by this mutation. */
  issueComment?: Maybe<IssueComment>;
  /** An edge for our `IssueComment`. May be used by Relay 1. */
  issueCommentEdge?: Maybe<IssueCommentsEdge>;
  /** Reads a single `Project` that is related to this `IssueComment`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IssueComment` mutation. */
export type CreateIssueCommentPayloadIssueCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};

/** All input for the create `Issue` mutation. */
export type CreateIssueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Issue` to be created by this mutation. */
  issue: IssueInput;
};

/** The output of our create `Issue` mutation. */
export type CreateIssuePayload = {
  __typename?: 'CreateIssuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Issue` that was created by this mutation. */
  issue?: Maybe<Issue>;
  /** An edge for our `Issue`. May be used by Relay 1. */
  issueEdge?: Maybe<IssuesEdge>;
  /** Reads a single `Project` that is related to this `Issue`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Issue` mutation. */
export type CreateIssuePayloadIssueEdgeArgs = {
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};

/** All input for the create `Line` mutation. */
export type CreateLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Line` to be created by this mutation. */
  line: LineInput;
};

/** The output of our create `Line` mutation. */
export type CreateLinePayload = {
  __typename?: 'CreateLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Line` that was created by this mutation. */
  line?: Maybe<Line>;
  /** An edge for our `Line`. May be used by Relay 1. */
  lineEdge?: Maybe<LinesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `Line`. */
  shape?: Maybe<Shape>;
};


/** The output of our create `Line` mutation. */
export type CreateLinePayloadLineEdgeArgs = {
  orderBy?: InputMaybe<Array<LinesOrderBy>>;
};

/** All input for the create `Model` mutation. */
export type CreateModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Model` to be created by this mutation. */
  model: ModelInput;
};

/** The output of our create `Model` mutation. */
export type CreateModelPayload = {
  __typename?: 'CreateModelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Model` that was created by this mutation. */
  model?: Maybe<Model>;
  /** An edge for our `Model`. May be used by Relay 1. */
  modelEdge?: Maybe<ModelsEdge>;
  /** Reads a single `Project` that is related to this `Model`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Model` mutation. */
export type CreateModelPayloadModelEdgeArgs = {
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};

/** All input for the create `OrderColumn` mutation. */
export type CreateOrderColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrderColumn` to be created by this mutation. */
  orderColumn: OrderColumnInput;
};

/** The output of our create `OrderColumn` mutation. */
export type CreateOrderColumnPayload = {
  __typename?: 'CreateOrderColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `OrderColumn`. */
  order?: Maybe<Order>;
  /** The `OrderColumn` that was created by this mutation. */
  orderColumn?: Maybe<OrderColumn>;
  /** An edge for our `OrderColumn`. May be used by Relay 1. */
  orderColumnEdge?: Maybe<OrderColumnsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderColumn` mutation. */
export type CreateOrderColumnPayloadOrderColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};

/** All input for the create `OrderColumnTemplate` mutation. */
export type CreateOrderColumnTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrderColumnTemplate` to be created by this mutation. */
  orderColumnTemplate: OrderColumnTemplateInput;
};

/** The output of our create `OrderColumnTemplate` mutation. */
export type CreateOrderColumnTemplatePayload = {
  __typename?: 'CreateOrderColumnTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OrderColumnTemplate` that was created by this mutation. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** An edge for our `OrderColumnTemplate`. May be used by Relay 1. */
  orderColumnTemplateEdge?: Maybe<OrderColumnTemplatesEdge>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `OrderColumnTemplate`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderColumnTemplate` mutation. */
export type CreateOrderColumnTemplatePayloadOrderColumnTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};

/** All input for the create `OrderEntryCache` mutation. */
export type CreateOrderEntryCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrderEntryCache` to be created by this mutation. */
  orderEntryCache: OrderEntryCacheInput;
};

/** The output of our create `OrderEntryCache` mutation. */
export type CreateOrderEntryCachePayload = {
  __typename?: 'CreateOrderEntryCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `OrderEntry` that is related to this `OrderEntryCache`. */
  orderEntry?: Maybe<OrderEntry>;
  /** The `OrderEntryCache` that was created by this mutation. */
  orderEntryCache?: Maybe<OrderEntryCache>;
  /** An edge for our `OrderEntryCache`. May be used by Relay 1. */
  orderEntryCacheEdge?: Maybe<OrderEntryCachesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderEntryCache` mutation. */
export type CreateOrderEntryCachePayloadOrderEntryCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryCachesOrderBy>>;
};

/** All input for the `createOrderEntryFromTemplate` mutation. */
export type CreateOrderEntryFromTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  dbids?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  orderEntryTemplateId: Scalars['UUID'];
  orderId: Scalars['UUID'];
  query?: InputMaybe<ForgeAttributeQueryInput>;
  title: Scalars['String'];
};

/** The output of our `createOrderEntryFromTemplate` mutation. */
export type CreateOrderEntryFromTemplatePayload = {
  __typename?: 'CreateOrderEntryFromTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `OrderEntry`. */
  order?: Maybe<Order>;
  orderEntry?: Maybe<OrderEntry>;
  /** An edge for our `OrderEntry`. May be used by Relay 1. */
  orderEntryEdge?: Maybe<OrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createOrderEntryFromTemplate` mutation. */
export type CreateOrderEntryFromTemplatePayloadOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};

/** All input for the create `OrderEntry` mutation. */
export type CreateOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrderEntry` to be created by this mutation. */
  orderEntry: OrderEntryInput;
};

/** The output of our create `OrderEntry` mutation. */
export type CreateOrderEntryPayload = {
  __typename?: 'CreateOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `OrderEntry`. */
  order?: Maybe<Order>;
  /** The `OrderEntry` that was created by this mutation. */
  orderEntry?: Maybe<OrderEntry>;
  /** An edge for our `OrderEntry`. May be used by Relay 1. */
  orderEntryEdge?: Maybe<OrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderEntry` mutation. */
export type CreateOrderEntryPayloadOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};

/** All input for the create `OrderEntryTemplate` mutation. */
export type CreateOrderEntryTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrderEntryTemplate` to be created by this mutation. */
  orderEntryTemplate: OrderEntryTemplateInput;
};

/** The output of our create `OrderEntryTemplate` mutation. */
export type CreateOrderEntryTemplatePayload = {
  __typename?: 'CreateOrderEntryTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `OrderEntryTemplate`. */
  contractor?: Maybe<Contractor>;
  /** The `OrderEntryTemplate` that was created by this mutation. */
  orderEntryTemplate?: Maybe<OrderEntryTemplate>;
  /** An edge for our `OrderEntryTemplate`. May be used by Relay 1. */
  orderEntryTemplateEdge?: Maybe<OrderEntryTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderEntryTemplate` mutation. */
export type CreateOrderEntryTemplatePayloadOrderEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};

/** All input for the create `OrderEntryView` mutation. */
export type CreateOrderEntryViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrderEntryView` to be created by this mutation. */
  orderEntryView: OrderEntryViewInput;
};

/** The output of our create `OrderEntryView` mutation. */
export type CreateOrderEntryViewPayload = {
  __typename?: 'CreateOrderEntryViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OrderEntryView` that was created by this mutation. */
  orderEntryView?: Maybe<OrderEntryView>;
  /** An edge for our `OrderEntryView`. May be used by Relay 1. */
  orderEntryViewEdge?: Maybe<OrderEntryViewsEdge>;
  /** Reads a single `Project` that is related to this `OrderEntryView`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderEntryView` mutation. */
export type CreateOrderEntryViewPayloadOrderEntryViewEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};

export type CreateOrderFromTableResult = {
  __typename?: 'CreateOrderFromTableResult';
  orderId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  rows: Array<ResolvedTableRow>;
};

/** All input for the create `Order` mutation. */
export type CreateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Order` to be created by this mutation. */
  order: OrderInput;
};

/** The output of our create `Order` mutation. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Order` that was created by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Project` that is related to this `Order`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Order` mutation. */
export type CreateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the create `Polygon` mutation. */
export type CreatePolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Polygon` to be created by this mutation. */
  polygon: PolygonInput;
};

/** The output of our create `Polygon` mutation. */
export type CreatePolygonPayload = {
  __typename?: 'CreatePolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Polygon` that was created by this mutation. */
  polygon?: Maybe<Polygon>;
  /** An edge for our `Polygon`. May be used by Relay 1. */
  polygonEdge?: Maybe<PolygonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `Polygon`. */
  shape?: Maybe<Shape>;
};


/** The output of our create `Polygon` mutation. */
export type CreatePolygonPayloadPolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<PolygonsOrderBy>>;
};

export type CreateProjectFromDocumentsInput = {
  documentKeys: Array<Scalars['String']>;
  projectName: Scalars['String'];
  tenant: Scalars['String'];
  userPrompt?: InputMaybe<Scalars['String']>;
};

export type CreateProjectFromDocumentsPayload = {
  __typename?: 'CreateProjectFromDocumentsPayload';
  jobId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateProjectFromDocumentsStatusPayload = {
  __typename?: 'CreateProjectFromDocumentsStatusPayload';
  projectId?: Maybe<Scalars['UUID']>;
  status: Scalars['String'];
};

/** All input for the `createProjectFromTemplate` mutation. */
export type CreateProjectFromTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectName: Scalars['String'];
  theProjectTemplateId: Scalars['UUID'];
};

/** The output of our `createProjectFromTemplate` mutation. */
export type CreateProjectFromTemplatePayload = {
  __typename?: 'CreateProjectFromTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Project`. */
  contractor?: Maybe<Contractor>;
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createProjectFromTemplate` mutation. */
export type CreateProjectFromTemplatePayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the create `Project` mutation. */
export type CreateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Project` to be created by this mutation. */
  project: ProjectInput;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Project`. */
  contractor?: Maybe<Contractor>;
  /** The `Project` that was created by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Project` mutation. */
export type CreateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the create `ProjectTag` mutation. */
export type CreateProjectTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectTag` to be created by this mutation. */
  projectTag: ProjectTagInput;
};

/** The output of our create `ProjectTag` mutation. */
export type CreateProjectTagPayload = {
  __typename?: 'CreateProjectTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTag`. */
  contractor?: Maybe<Contractor>;
  /** The `ProjectTag` that was created by this mutation. */
  projectTag?: Maybe<ProjectTag>;
  /** An edge for our `ProjectTag`. May be used by Relay 1. */
  projectTagEdge?: Maybe<ProjectTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectTag` mutation. */
export type CreateProjectTagPayloadProjectTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** All input for the create `ProjectTemplate` mutation. */
export type CreateProjectTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectTemplate` to be created by this mutation. */
  projectTemplate: ProjectTemplateInput;
};

/** All input for the create `ProjectTemplateOrderEntry` mutation. */
export type CreateProjectTemplateOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectTemplateOrderEntry` to be created by this mutation. */
  projectTemplateOrderEntry: ProjectTemplateOrderEntryInput;
};

/** The output of our create `ProjectTemplateOrderEntry` mutation. */
export type CreateProjectTemplateOrderEntryPayload = {
  __typename?: 'CreateProjectTemplateOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `ProjectTemplateOrderEntry`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** The `ProjectTemplateOrderEntry` that was created by this mutation. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** An edge for our `ProjectTemplateOrderEntry`. May be used by Relay 1. */
  projectTemplateOrderEntryEdge?: Maybe<ProjectTemplateOrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectTemplateOrderEntry` mutation. */
export type CreateProjectTemplateOrderEntryPayloadProjectTemplateOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};

/** All input for the create `ProjectTemplateOrderEntryView` mutation. */
export type CreateProjectTemplateOrderEntryViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectTemplateOrderEntryView` to be created by this mutation. */
  projectTemplateOrderEntryView: ProjectTemplateOrderEntryViewInput;
};

/** The output of our create `ProjectTemplateOrderEntryView` mutation. */
export type CreateProjectTemplateOrderEntryViewPayload = {
  __typename?: 'CreateProjectTemplateOrderEntryViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrderEntryView`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** The `ProjectTemplateOrderEntryView` that was created by this mutation. */
  projectTemplateOrderEntryView?: Maybe<ProjectTemplateOrderEntryView>;
  /** An edge for our `ProjectTemplateOrderEntryView`. May be used by Relay 1. */
  projectTemplateOrderEntryViewEdge?: Maybe<ProjectTemplateOrderEntryViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectTemplateOrderEntryView` mutation. */
export type CreateProjectTemplateOrderEntryViewPayloadProjectTemplateOrderEntryViewEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};

/** All input for the create `ProjectTemplateOrder` mutation. */
export type CreateProjectTemplateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectTemplateOrder` to be created by this mutation. */
  projectTemplateOrder: ProjectTemplateOrderInput;
};

/** The output of our create `ProjectTemplateOrder` mutation. */
export type CreateProjectTemplateOrderPayload = {
  __typename?: 'CreateProjectTemplateOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrder`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** The `ProjectTemplateOrder` that was created by this mutation. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** An edge for our `ProjectTemplateOrder`. May be used by Relay 1. */
  projectTemplateOrderEdge?: Maybe<ProjectTemplateOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectTemplateOrder` mutation. */
export type CreateProjectTemplateOrderPayloadProjectTemplateOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};

/** The output of our create `ProjectTemplate` mutation. */
export type CreateProjectTemplatePayload = {
  __typename?: 'CreateProjectTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTemplate`. */
  contractor?: Maybe<Contractor>;
  /** The `ProjectTemplate` that was created by this mutation. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** An edge for our `ProjectTemplate`. May be used by Relay 1. */
  projectTemplateEdge?: Maybe<ProjectTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectTemplate` mutation. */
export type CreateProjectTemplatePayloadProjectTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};

/** All input for the create `ProtanProjectStep` mutation. */
export type CreateProtanProjectStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProtanProjectStep` to be created by this mutation. */
  protanProjectStep: ProtanProjectStepInput;
};

/** The output of our create `ProtanProjectStep` mutation. */
export type CreateProtanProjectStepPayload = {
  __typename?: 'CreateProtanProjectStepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProtanProjectStep`. */
  project?: Maybe<Project>;
  /** The `ProtanProjectStep` that was created by this mutation. */
  protanProjectStep?: Maybe<ProtanProjectStep>;
  /** An edge for our `ProtanProjectStep`. May be used by Relay 1. */
  protanProjectStepEdge?: Maybe<ProtanProjectStepsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProtanProjectStep` mutation. */
export type CreateProtanProjectStepPayloadProtanProjectStepEdgeArgs = {
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};

/** All input for the create `PublicInitialState` mutation. */
export type CreatePublicInitialStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PublicInitialState` to be created by this mutation. */
  publicInitialState: PublicInitialStateInput;
};

/** The output of our create `PublicInitialState` mutation. */
export type CreatePublicInitialStatePayload = {
  __typename?: 'CreatePublicInitialStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PublicInitialState` that was created by this mutation. */
  publicInitialState?: Maybe<PublicInitialState>;
  /** An edge for our `PublicInitialState`. May be used by Relay 1. */
  publicInitialStateEdge?: Maybe<PublicInitialStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PublicInitialState` mutation. */
export type CreatePublicInitialStatePayloadPublicInitialStateEdgeArgs = {
  orderBy?: InputMaybe<Array<PublicInitialStatesOrderBy>>;
};

/** All input for the create `SavedView` mutation. */
export type CreateSavedViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SavedView` to be created by this mutation. */
  savedView: SavedViewInput;
};

/** The output of our create `SavedView` mutation. */
export type CreateSavedViewPayload = {
  __typename?: 'CreateSavedViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SavedView`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavedView` that was created by this mutation. */
  savedView?: Maybe<SavedView>;
  /** An edge for our `SavedView`. May be used by Relay 1. */
  savedViewEdge?: Maybe<SavedViewsEdge>;
};


/** The output of our create `SavedView` mutation. */
export type CreateSavedViewPayloadSavedViewEdgeArgs = {
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};

/** All input for the create `ShapeFolder` mutation. */
export type CreateShapeFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ShapeFolder` to be created by this mutation. */
  shapeFolder: ShapeFolderInput;
};

/** The output of our create `ShapeFolder` mutation. */
export type CreateShapeFolderPayload = {
  __typename?: 'CreateShapeFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ShapeFolder`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShapeFolder` that was created by this mutation. */
  shapeFolder?: Maybe<ShapeFolder>;
  /** An edge for our `ShapeFolder`. May be used by Relay 1. */
  shapeFolderEdge?: Maybe<ShapeFoldersEdge>;
};


/** The output of our create `ShapeFolder` mutation. */
export type CreateShapeFolderPayloadShapeFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};

/** All input for the create `Shape` mutation. */
export type CreateShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Shape` to be created by this mutation. */
  shape: ShapeInput;
};

/** The output of our create `Shape` mutation. */
export type CreateShapePayload = {
  __typename?: 'CreateShapePayload';
  /** Reads a single `AutoShape` that is related to this `Shape`. */
  autoShape?: Maybe<AutoShape>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Shape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shape` that was created by this mutation. */
  shape?: Maybe<Shape>;
  /** An edge for our `Shape`. May be used by Relay 1. */
  shapeEdge?: Maybe<ShapesEdge>;
  /** Reads a single `ShapeFolder` that is related to this `Shape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
};


/** The output of our create `Shape` mutation. */
export type CreateShapePayloadShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};

/** All input for the create `ShapePoint` mutation. */
export type CreateShapePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ShapePoint` to be created by this mutation. */
  shapePoint: ShapePointInput;
};

/** The output of our create `ShapePoint` mutation. */
export type CreateShapePointPayload = {
  __typename?: 'CreateShapePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `ShapePoint`. */
  shape?: Maybe<Shape>;
  /** The `ShapePoint` that was created by this mutation. */
  shapePoint?: Maybe<ShapePoint>;
  /** An edge for our `ShapePoint`. May be used by Relay 1. */
  shapePointEdge?: Maybe<ShapePointsEdge>;
};


/** The output of our create `ShapePoint` mutation. */
export type CreateShapePointPayloadShapePointEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapePointsOrderBy>>;
};

/** All input for the create `SharedLink` mutation. */
export type CreateSharedLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SharedLink` to be created by this mutation. */
  sharedLink: SharedLinkInput;
};

/** The output of our create `SharedLink` mutation. */
export type CreateSharedLinkPayload = {
  __typename?: 'CreateSharedLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `InitialState` that is related to this `SharedLink`. */
  initialState?: Maybe<InitialState>;
  /** Reads a single `Project` that is related to this `SharedLink`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SharedLink` that was created by this mutation. */
  sharedLink?: Maybe<SharedLink>;
  /** An edge for our `SharedLink`. May be used by Relay 1. */
  sharedLinkEdge?: Maybe<SharedLinksEdge>;
};


/** The output of our create `SharedLink` mutation. */
export type CreateSharedLinkPayloadSharedLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};

/** All input for the `createSharedLinkWithDuration` mutation. */
export type CreateSharedLinkWithDurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  theExpiresInSeconds: Scalars['Int'];
  theInitialStateId: Scalars['UUID'];
  theName: Scalars['String'];
  theOrderIds: Array<InputMaybe<Scalars['UUID']>>;
  theProjectId: Scalars['UUID'];
};

/** The output of our `createSharedLinkWithDuration` mutation. */
export type CreateSharedLinkWithDurationPayload = {
  __typename?: 'CreateSharedLinkWithDurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `InitialState` that is related to this `SharedLink`. */
  initialState?: Maybe<InitialState>;
  /** Reads a single `Project` that is related to this `SharedLink`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sharedLink?: Maybe<SharedLink>;
  /** An edge for our `SharedLink`. May be used by Relay 1. */
  sharedLinkEdge?: Maybe<SharedLinksEdge>;
};


/** The output of our `createSharedLinkWithDuration` mutation. */
export type CreateSharedLinkWithDurationPayloadSharedLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};

/** All input for the create `Sheet` mutation. */
export type CreateSheetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Sheet` to be created by this mutation. */
  sheet: SheetInput;
};

/** All input for the create `SheetPageCalibration` mutation. */
export type CreateSheetPageCalibrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetPageCalibration` to be created by this mutation. */
  sheetPageCalibration: SheetPageCalibrationInput;
};

/** The output of our create `SheetPageCalibration` mutation. */
export type CreateSheetPageCalibrationPayload = {
  __typename?: 'CreateSheetPageCalibrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Sheet` that is related to this `SheetPageCalibration`. */
  sheet?: Maybe<Sheet>;
  /** The `SheetPageCalibration` that was created by this mutation. */
  sheetPageCalibration?: Maybe<SheetPageCalibration>;
  /** An edge for our `SheetPageCalibration`. May be used by Relay 1. */
  sheetPageCalibrationEdge?: Maybe<SheetPageCalibrationsEdge>;
};


/** The output of our create `SheetPageCalibration` mutation. */
export type CreateSheetPageCalibrationPayloadSheetPageCalibrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};

/** The output of our create `Sheet` mutation. */
export type CreateSheetPayload = {
  __typename?: 'CreateSheetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Sheet`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Sheet` that was created by this mutation. */
  sheet?: Maybe<Sheet>;
  /** An edge for our `Sheet`. May be used by Relay 1. */
  sheetEdge?: Maybe<SheetsEdge>;
};


/** The output of our create `Sheet` mutation. */
export type CreateSheetPayloadSheetEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};

/** All input for the create `SheetShape` mutation. */
export type CreateSheetShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetShape` to be created by this mutation. */
  sheetShape: SheetShapeInput;
};

/** All input for the create `SheetShapeLegend` mutation. */
export type CreateSheetShapeLegendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetShapeLegend` to be created by this mutation. */
  sheetShapeLegend: SheetShapeLegendInput;
};

/** The output of our create `SheetShapeLegend` mutation. */
export type CreateSheetShapeLegendPayload = {
  __typename?: 'CreateSheetShapeLegendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `SheetShapeLegend`. */
  legendOrder?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLegend`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeLegend` that was created by this mutation. */
  sheetShapeLegend?: Maybe<SheetShapeLegend>;
  /** An edge for our `SheetShapeLegend`. May be used by Relay 1. */
  sheetShapeLegendEdge?: Maybe<SheetShapeLegendsEdge>;
};


/** The output of our create `SheetShapeLegend` mutation. */
export type CreateSheetShapeLegendPayloadSheetShapeLegendEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};

/** All input for the create `SheetShapeLine` mutation. */
export type CreateSheetShapeLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetShapeLine` to be created by this mutation. */
  sheetShapeLine: SheetShapeLineInput;
};

/** The output of our create `SheetShapeLine` mutation. */
export type CreateSheetShapeLinePayload = {
  __typename?: 'CreateSheetShapeLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLine`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeLine` that was created by this mutation. */
  sheetShapeLine?: Maybe<SheetShapeLine>;
  /** An edge for our `SheetShapeLine`. May be used by Relay 1. */
  sheetShapeLineEdge?: Maybe<SheetShapeLinesEdge>;
};


/** The output of our create `SheetShapeLine` mutation. */
export type CreateSheetShapeLinePayloadSheetShapeLineEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeLinesOrderBy>>;
};

/** The output of our create `SheetShape` mutation. */
export type CreateSheetShapePayload = {
  __typename?: 'CreateSheetShapePayload';
  /** Reads a single `AutoShape` that is related to this `SheetShape`. */
  autoShape?: Maybe<AutoShape>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SheetShape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ShapeFolder` that is related to this `SheetShape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
  /** Reads a single `Sheet` that is related to this `SheetShape`. */
  sheet?: Maybe<Sheet>;
  /** The `SheetShape` that was created by this mutation. */
  sheetShape?: Maybe<SheetShape>;
  /** An edge for our `SheetShape`. May be used by Relay 1. */
  sheetShapeEdge?: Maybe<SheetShapesEdge>;
};


/** The output of our create `SheetShape` mutation. */
export type CreateSheetShapePayloadSheetShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};

/** All input for the create `SheetShapePoint` mutation. */
export type CreateSheetShapePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetShapePoint` to be created by this mutation. */
  sheetShapePoint: SheetShapePointInput;
};

/** The output of our create `SheetShapePoint` mutation. */
export type CreateSheetShapePointPayload = {
  __typename?: 'CreateSheetShapePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapePoint`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapePoint` that was created by this mutation. */
  sheetShapePoint?: Maybe<SheetShapePoint>;
  /** An edge for our `SheetShapePoint`. May be used by Relay 1. */
  sheetShapePointEdge?: Maybe<SheetShapePointsEdge>;
};


/** The output of our create `SheetShapePoint` mutation. */
export type CreateSheetShapePointPayloadSheetShapePointEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapePointsOrderBy>>;
};

/** All input for the create `SheetShapePolygon` mutation. */
export type CreateSheetShapePolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetShapePolygon` to be created by this mutation. */
  sheetShapePolygon: SheetShapePolygonInput;
};

/** The output of our create `SheetShapePolygon` mutation. */
export type CreateSheetShapePolygonPayload = {
  __typename?: 'CreateSheetShapePolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapePolygon`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapePolygon` that was created by this mutation. */
  sheetShapePolygon?: Maybe<SheetShapePolygon>;
  /** An edge for our `SheetShapePolygon`. May be used by Relay 1. */
  sheetShapePolygonEdge?: Maybe<SheetShapePolygonsEdge>;
};


/** The output of our create `SheetShapePolygon` mutation. */
export type CreateSheetShapePolygonPayloadSheetShapePolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapePolygonsOrderBy>>;
};

/** All input for the create `SheetShapeSplitLine` mutation. */
export type CreateSheetShapeSplitLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SheetShapeSplitLine` to be created by this mutation. */
  sheetShapeSplitLine: SheetShapeSplitLineInput;
};

/** The output of our create `SheetShapeSplitLine` mutation. */
export type CreateSheetShapeSplitLinePayload = {
  __typename?: 'CreateSheetShapeSplitLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeSplitLine`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeSplitLine` that was created by this mutation. */
  sheetShapeSplitLine?: Maybe<SheetShapeSplitLine>;
  /** An edge for our `SheetShapeSplitLine`. May be used by Relay 1. */
  sheetShapeSplitLineEdge?: Maybe<SheetShapeSplitLinesEdge>;
};


/** The output of our create `SheetShapeSplitLine` mutation. */
export type CreateSheetShapeSplitLinePayloadSheetShapeSplitLineEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeSplitLinesOrderBy>>;
};

/** All input for the create `SparkelAiAnalysis` mutation. */
export type CreateSparkelAiAnalysisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SparkelAiAnalysis` to be created by this mutation. */
  sparkelAiAnalysis: SparkelAiAnalysisInput;
};

/** The output of our create `SparkelAiAnalysis` mutation. */
export type CreateSparkelAiAnalysisPayload = {
  __typename?: 'CreateSparkelAiAnalysisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SparkelAiAnalysis`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SparkelAiAnalysis` that was created by this mutation. */
  sparkelAiAnalysis?: Maybe<SparkelAiAnalysis>;
  /** An edge for our `SparkelAiAnalysis`. May be used by Relay 1. */
  sparkelAiAnalysisEdge?: Maybe<SparkelAiAnalysesEdge>;
};


/** The output of our create `SparkelAiAnalysis` mutation. */
export type CreateSparkelAiAnalysisPayloadSparkelAiAnalysisEdgeArgs = {
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};

/** All input for the create `SparkelProperty` mutation. */
export type CreateSparkelPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SparkelProperty` to be created by this mutation. */
  sparkelProperty: SparkelPropertyInput;
};

/** The output of our create `SparkelProperty` mutation. */
export type CreateSparkelPropertyPayload = {
  __typename?: 'CreateSparkelPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SparkelProperty`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SparkelProperty` that was created by this mutation. */
  sparkelProperty?: Maybe<SparkelProperty>;
  /** An edge for our `SparkelProperty`. May be used by Relay 1. */
  sparkelPropertyEdge?: Maybe<SparkelPropertiesEdge>;
};


/** The output of our create `SparkelProperty` mutation. */
export type CreateSparkelPropertyPayloadSparkelPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};

/** All input for the `createTableFromTemplate` mutation. */
export type CreateTableFromTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ordername: Scalars['String'];
  projectId: Scalars['UUID'];
  theProjectTemplateId: Scalars['UUID'];
};

/** The output of our `createTableFromTemplate` mutation. */
export type CreateTableFromTemplatePayload = {
  __typename?: 'CreateTableFromTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Project` that is related to this `Order`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createTableFromTemplate` mutation. */
export type CreateTableFromTemplatePayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `createTemplateFromOrderEntry` mutation. */
export type CreateTemplateFromOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateName: Scalars['String'];
  theOrderEntryId: Scalars['UUID'];
};

/** The output of our `createTemplateFromOrderEntry` mutation. */
export type CreateTemplateFromOrderEntryPayload = {
  __typename?: 'CreateTemplateFromOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `OrderEntryTemplate`. */
  contractor?: Maybe<Contractor>;
  orderEntryTemplate?: Maybe<OrderEntryTemplate>;
  /** An edge for our `OrderEntryTemplate`. May be used by Relay 1. */
  orderEntryTemplateEdge?: Maybe<OrderEntryTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createTemplateFromOrderEntry` mutation. */
export type CreateTemplateFromOrderEntryPayloadOrderEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};

/** All input for the `createTemplateFromProject` mutation. */
export type CreateTemplateFromProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateName: Scalars['String'];
  theProjectId: Scalars['UUID'];
};

/** The output of our `createTemplateFromProject` mutation. */
export type CreateTemplateFromProjectPayload = {
  __typename?: 'CreateTemplateFromProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTemplate`. */
  contractor?: Maybe<Contractor>;
  projectTemplate?: Maybe<ProjectTemplate>;
  /** An edge for our `ProjectTemplate`. May be used by Relay 1. */
  projectTemplateEdge?: Maybe<ProjectTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createTemplateFromProject` mutation. */
export type CreateTemplateFromProjectPayloadProjectTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};

export type CreateUserInput = {
  displayName: Scalars['String'];
  email: Scalars['String'];
};

export enum CurrencyEnum {
  Nok = 'NOK'
}

/** A filter to be used against CurrencyEnum fields. All fields are combined with a logical ‘and.’ */
export type CurrencyEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CurrencyEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CurrencyEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CurrencyEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CurrencyEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CurrencyEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CurrencyEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CurrencyEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CurrencyEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CurrencyEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CurrencyEnum>>;
};

export type CustomField = Node & {
  __typename?: 'CustomField';
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `OrderColumn` that is related to this `CustomField`. */
  orderColumn?: Maybe<OrderColumn>;
  orderColumnId: Scalars['UUID'];
  /** Reads a single `OrderEntry` that is related to this `CustomField`. */
  orderEntry?: Maybe<OrderEntry>;
  orderEntryId: Scalars['UUID'];
  value: QuantityType;
};

/**
 * A condition to be used against `CustomField` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CustomFieldCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `orderColumnId` field. */
  orderColumnId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `orderEntryId` field. */
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<QuantityTypeInput>;
};

/** The fields on `customField` to look up the row to connect. */
export type CustomFieldCustomFieldsOrderColumnIdOrderEntryIdKeyConnect = {
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
};

/** The fields on `customField` to look up the row to delete. */
export type CustomFieldCustomFieldsOrderColumnIdOrderEntryIdKeyDelete = {
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
};

/** The fields on `customField` to look up the row to connect. */
export type CustomFieldCustomFieldsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `customField` to look up the row to delete. */
export type CustomFieldCustomFieldsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `CustomField` object types. All fields are combined with a logical ‘and.’ */
export type CustomFieldFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomFieldFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomFieldFilter>>;
  /** Filter by the object’s `orderColumnId` field. */
  orderColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `orderEntryId` field. */
  orderEntryId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<QuantityTypeFilter>;
};

/** An input for mutations affecting `CustomField` */
export type CustomFieldInput = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumn?: InputMaybe<CustomFieldsOrderColumnIdFkeyInput>;
  orderColumnId?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<CustomFieldsOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  value: QuantityTypeInput;
};

/** The globally unique `ID` look up for the row to connect. */
export type CustomFieldNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `customField` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CustomFieldNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `customField` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderColumn` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderColumn` being updated. */
  patch: OrderColumnPatch;
};

/** The fields on `customField` to look up the row to update. */
export type CustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingCustomFieldsOrderColumnIdOrderEntryIdKeyUpdate = {
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customField` being updated. */
  patch: UpdateCustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyPatch;
};

/** The fields on `customField` to look up the row to update. */
export type CustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingCustomFieldsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customField` being updated. */
  patch: UpdateCustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderEntry` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderEntry` being updated. */
  patch: OrderEntryPatch;
};

/** The fields on `customField` to look up the row to update. */
export type CustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyUsingCustomFieldsOrderColumnIdOrderEntryIdKeyUpdate = {
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customField` being updated. */
  patch: UpdateCustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyPatch;
};

/** The fields on `customField` to look up the row to update. */
export type CustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyUsingCustomFieldsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customField` being updated. */
  patch: UpdateCustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyPatch;
};

/** Represents an update to a `CustomField`. Fields that are set will be updated. */
export type CustomFieldPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumn?: InputMaybe<CustomFieldsOrderColumnIdFkeyInput>;
  orderColumnId?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<CustomFieldsOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<QuantityTypeInput>;
};

export type CustomFieldTemplate = Node & {
  __typename?: 'CustomFieldTemplate';
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `OrderColumnTemplate` that is related to this `CustomFieldTemplate`. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  orderColumnTemplateId: Scalars['UUID'];
  /** Reads a single `ProjectTemplateOrderEntry` that is related to this `CustomFieldTemplate`. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  projectTemplateOrderEntryId: Scalars['UUID'];
  value: QuantityType;
};

/**
 * A condition to be used against `CustomFieldTemplate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CustomFieldTemplateCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `orderColumnTemplateId` field. */
  orderColumnTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectTemplateOrderEntryId` field. */
  projectTemplateOrderEntryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<QuantityTypeInput>;
};

/** The fields on `customFieldTemplate` to look up the row to connect. */
export type CustomFieldTemplateCustomFieldTemplatesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `customFieldTemplate` to look up the row to delete. */
export type CustomFieldTemplateCustomFieldTemplatesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `CustomFieldTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CustomFieldTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomFieldTemplateFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomFieldTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomFieldTemplateFilter>>;
  /** Filter by the object’s `orderColumnTemplateId` field. */
  orderColumnTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectTemplateOrderEntryId` field. */
  projectTemplateOrderEntryId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<QuantityTypeFilter>;
};

/** An input for mutations affecting `CustomFieldTemplate` */
export type CustomFieldTemplateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumnTemplate?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInput>;
  orderColumnTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntry?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput>;
  projectTemplateOrderEntryId?: InputMaybe<Scalars['UUID']>;
  value: QuantityTypeInput;
};

/** The globally unique `ID` look up for the row to connect. */
export type CustomFieldTemplateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `customFieldTemplate` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CustomFieldTemplateNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `customFieldTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderColumnTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderColumnTemplate` being updated. */
  patch: OrderColumnTemplatePatch;
};

/** The fields on `customFieldTemplate` to look up the row to update. */
export type CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyUsingCustomFieldTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customFieldTemplate` being updated. */
  patch: UpdateCustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntry` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplateOrderEntry` being updated. */
  patch: ProjectTemplateOrderEntryPatch;
};

/** The fields on `customFieldTemplate` to look up the row to update. */
export type CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyUsingCustomFieldTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customFieldTemplate` being updated. */
  patch: UpdateCustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyPatch;
};

/** Represents an update to a `CustomFieldTemplate`. Fields that are set will be updated. */
export type CustomFieldTemplatePatch = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumnTemplate?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInput>;
  orderColumnTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntry?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput>;
  projectTemplateOrderEntryId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<QuantityTypeInput>;
};

/** A connection to a list of `CustomFieldTemplate` values. */
export type CustomFieldTemplatesConnection = {
  __typename?: 'CustomFieldTemplatesConnection';
  /** A list of edges which contains the `CustomFieldTemplate` and cursor to aid in pagination. */
  edges: Array<CustomFieldTemplatesEdge>;
  /** A list of `CustomFieldTemplate` objects. */
  nodes: Array<CustomFieldTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomFieldTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CustomFieldTemplate` edge in the connection. */
export type CustomFieldTemplatesEdge = {
  __typename?: 'CustomFieldTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CustomFieldTemplate` at the end of the edge. */
  node: CustomFieldTemplate;
};

/** Methods to use when ordering `CustomFieldTemplate`. */
export enum CustomFieldTemplatesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderColumnTemplateIdAsc = 'ORDER_COLUMN_TEMPLATE_ID_ASC',
  OrderColumnTemplateIdDesc = 'ORDER_COLUMN_TEMPLATE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectTemplateOrderEntryIdAsc = 'PROJECT_TEMPLATE_ORDER_ENTRY_ID_ASC',
  ProjectTemplateOrderEntryIdDesc = 'PROJECT_TEMPLATE_ORDER_ENTRY_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The `customFieldTemplate` to be created by this mutation. */
export type CustomFieldTemplatesOrderColumnTemplateIdFkeyCustomFieldTemplatesCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumnTemplate?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInput>;
  orderColumnTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntry?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput>;
  projectTemplateOrderEntryId?: InputMaybe<Scalars['UUID']>;
  value: QuantityTypeInput;
};

/** Input for the nested mutation of `orderColumnTemplate` in the `CustomFieldTemplateInput` mutation. */
export type CustomFieldTemplatesOrderColumnTemplateIdFkeyInput = {
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<OrderColumnTemplateOrderColumnTemplatesPkeyConnect>;
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderColumnTemplateNodeIdConnect>;
  /** A `OrderColumnTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyOrderColumnTemplatesCreateInput>;
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderColumnTemplateOrderColumnTemplatesPkeyDelete>;
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderColumnTemplateNodeIdDelete>;
  /** The primary key(s) and patch data for `orderColumnTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<OrderColumnTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyUsingOrderColumnTemplatesPkeyUpdate>;
  /** The primary key(s) and patch data for `orderColumnTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `customFieldTemplate` in the `OrderColumnTemplateInput` mutation. */
export type CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput = {
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomFieldTemplateCustomFieldTemplatesPkeyConnect>>;
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CustomFieldTemplateNodeIdConnect>>;
  /** A `CustomFieldTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomFieldTemplatesOrderColumnTemplateIdFkeyCustomFieldTemplatesCreateInput>>;
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CustomFieldTemplateCustomFieldTemplatesPkeyDelete>>;
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CustomFieldTemplateNodeIdDelete>>;
  /** Flag indicating whether all other `customFieldTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `customFieldTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyUsingCustomFieldTemplatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `customFieldTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderColumnTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyNodeIdUpdate>>;
};

/** The `orderColumnTemplate` to be created by this mutation. */
export type CustomFieldTemplatesOrderColumnTemplateIdFkeyOrderColumnTemplatesCreateInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType: ColumnType;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  projectTemplateOrder?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
};

/** The `customFieldTemplate` to be created by this mutation. */
export type CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyCustomFieldTemplatesCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumnTemplate?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInput>;
  orderColumnTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntry?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput>;
  projectTemplateOrderEntryId?: InputMaybe<Scalars['UUID']>;
  value: QuantityTypeInput;
};

/** Input for the nested mutation of `projectTemplateOrderEntry` in the `CustomFieldTemplateInput` mutation. */
export type CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput = {
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateOrderEntryProjectTemplateOrderEntriesPkeyConnect>;
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectTemplateOrderEntryNodeIdConnect>;
  /** A `ProjectTemplateOrderEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyProjectTemplateOrderEntriesCreateInput>;
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectTemplateOrderEntryProjectTemplateOrderEntriesPkeyDelete>;
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectTemplateOrderEntryNodeIdDelete>;
  /** The primary key(s) and patch data for `projectTemplateOrderEntry` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOrderEntryOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyUsingProjectTemplateOrderEntriesPkeyUpdate>;
  /** The primary key(s) and patch data for `projectTemplateOrderEntry` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `customFieldTemplate` in the `ProjectTemplateOrderEntryInput` mutation. */
export type CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput = {
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomFieldTemplateCustomFieldTemplatesPkeyConnect>>;
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CustomFieldTemplateNodeIdConnect>>;
  /** A `CustomFieldTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyCustomFieldTemplatesCreateInput>>;
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CustomFieldTemplateCustomFieldTemplatesPkeyDelete>>;
  /** The primary key(s) for `customFieldTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CustomFieldTemplateNodeIdDelete>>;
  /** Flag indicating whether all other `customFieldTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `customFieldTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyUsingCustomFieldTemplatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `customFieldTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectTemplateOrderEntryOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyNodeIdUpdate>>;
};

/** The `projectTemplateOrderEntry` to be created by this mutation. */
export type CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyProjectTemplateOrderEntriesCreateInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrder?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `CustomField` values. */
export type CustomFieldsConnection = {
  __typename?: 'CustomFieldsConnection';
  /** A list of edges which contains the `CustomField` and cursor to aid in pagination. */
  edges: Array<CustomFieldsEdge>;
  /** A list of `CustomField` objects. */
  nodes: Array<CustomField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CustomField` edge in the connection. */
export type CustomFieldsEdge = {
  __typename?: 'CustomFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CustomField` at the end of the edge. */
  node: CustomField;
};

/** Methods to use when ordering `CustomField`. */
export enum CustomFieldsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderColumnIdAsc = 'ORDER_COLUMN_ID_ASC',
  OrderColumnIdDesc = 'ORDER_COLUMN_ID_DESC',
  OrderEntryIdAsc = 'ORDER_ENTRY_ID_ASC',
  OrderEntryIdDesc = 'ORDER_ENTRY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The `customField` to be created by this mutation. */
export type CustomFieldsOrderColumnIdFkeyCustomFieldsCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumn?: InputMaybe<CustomFieldsOrderColumnIdFkeyInput>;
  orderColumnId?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<CustomFieldsOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  value: QuantityTypeInput;
};

/** Input for the nested mutation of `orderColumn` in the `CustomFieldInput` mutation. */
export type CustomFieldsOrderColumnIdFkeyInput = {
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  connectById?: InputMaybe<OrderColumnOrderColumnsPkeyConnect>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  connectByNameAndColumnTypeAndOrderId?: InputMaybe<OrderColumnOrderColumnsNameOrderIdKeyConnect>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderColumnNodeIdConnect>;
  /** A `OrderColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<CustomFieldsOrderColumnIdFkeyOrderColumnsCreateInput>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderColumnOrderColumnsPkeyDelete>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  deleteByNameAndColumnTypeAndOrderId?: InputMaybe<OrderColumnOrderColumnsNameOrderIdKeyDelete>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderColumnNodeIdDelete>;
  /** The primary key(s) and patch data for `orderColumn` for the far side of the relationship. */
  updateById?: InputMaybe<OrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingOrderColumnsPkeyUpdate>;
  /** The primary key(s) and patch data for `orderColumn` for the far side of the relationship. */
  updateByNameAndColumnTypeAndOrderId?: InputMaybe<OrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingOrderColumnsNameOrderIdKeyUpdate>;
  /** The primary key(s) and patch data for `orderColumn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `customField` in the `OrderColumnInput` mutation. */
export type CustomFieldsOrderColumnIdFkeyInverseInput = {
  /** The primary key(s) for `customField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomFieldCustomFieldsPkeyConnect>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CustomFieldNodeIdConnect>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  connectByOrderColumnIdAndOrderEntryId?: InputMaybe<Array<CustomFieldCustomFieldsOrderColumnIdOrderEntryIdKeyConnect>>;
  /** A `CustomFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomFieldsOrderColumnIdFkeyCustomFieldsCreateInput>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CustomFieldCustomFieldsPkeyDelete>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CustomFieldNodeIdDelete>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  deleteByOrderColumnIdAndOrderEntryId?: InputMaybe<Array<CustomFieldCustomFieldsOrderColumnIdOrderEntryIdKeyDelete>>;
  /** Flag indicating whether all other `customField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `customField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingCustomFieldsPkeyUpdate>>;
  /** The primary key(s) and patch data for `customField` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `customField` for the far side of the relationship. */
  updateByOrderColumnIdAndOrderEntryId?: InputMaybe<Array<CustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingCustomFieldsOrderColumnIdOrderEntryIdKeyUpdate>>;
};

/** The `orderColumn` to be created by this mutation. */
export type CustomFieldsOrderColumnIdFkeyOrderColumnsCreateInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType: ColumnType;
  customFields?: InputMaybe<CustomFieldsOrderColumnIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderColumnsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  showTotal?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['UUID']>;
};

/** The `customField` to be created by this mutation. */
export type CustomFieldsOrderEntryIdFkeyCustomFieldsCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumn?: InputMaybe<CustomFieldsOrderColumnIdFkeyInput>;
  orderColumnId?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<CustomFieldsOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  value: QuantityTypeInput;
};

/** Input for the nested mutation of `orderEntry` in the `CustomFieldInput` mutation. */
export type CustomFieldsOrderEntryIdFkeyInput = {
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  connectById?: InputMaybe<OrderEntryOrderEntriesPkeyConnect>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderEntryNodeIdConnect>;
  /** A `OrderEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<CustomFieldsOrderEntryIdFkeyOrderEntriesCreateInput>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderEntryOrderEntriesPkeyDelete>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderEntryNodeIdDelete>;
  /** The primary key(s) and patch data for `orderEntry` for the far side of the relationship. */
  updateById?: InputMaybe<OrderEntryOnCustomFieldForCustomFieldsOrderEntryIdFkeyUsingOrderEntriesPkeyUpdate>;
  /** The primary key(s) and patch data for `orderEntry` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `customField` in the `OrderEntryInput` mutation. */
export type CustomFieldsOrderEntryIdFkeyInverseInput = {
  /** The primary key(s) for `customField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomFieldCustomFieldsPkeyConnect>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CustomFieldNodeIdConnect>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  connectByOrderColumnIdAndOrderEntryId?: InputMaybe<Array<CustomFieldCustomFieldsOrderColumnIdOrderEntryIdKeyConnect>>;
  /** A `CustomFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomFieldsOrderEntryIdFkeyCustomFieldsCreateInput>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CustomFieldCustomFieldsPkeyDelete>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CustomFieldNodeIdDelete>>;
  /** The primary key(s) for `customField` for the far side of the relationship. */
  deleteByOrderColumnIdAndOrderEntryId?: InputMaybe<Array<CustomFieldCustomFieldsOrderColumnIdOrderEntryIdKeyDelete>>;
  /** Flag indicating whether all other `customField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `customField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyUsingCustomFieldsPkeyUpdate>>;
  /** The primary key(s) and patch data for `customField` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderEntryOnCustomFieldForCustomFieldsOrderEntryIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `customField` for the far side of the relationship. */
  updateByOrderColumnIdAndOrderEntryId?: InputMaybe<Array<CustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyUsingCustomFieldsOrderColumnIdOrderEntryIdKeyUpdate>>;
};

/** The `orderEntry` to be created by this mutation. */
export type CustomFieldsOrderEntryIdFkeyOrderEntriesCreateInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

export type DatabaseLookupType = {
  __typename?: 'DatabaseLookupType';
  databaseId?: Maybe<Scalars['UUID']>;
  lookupProfileId?: Maybe<Scalars['UUID']>;
  prompt?: Maybe<Scalars['String']>;
  searchColumnId?: Maybe<Scalars['UUID']>;
  searchTerm?: Maybe<Scalars['String']>;
  valueColumnId?: Maybe<Scalars['UUID']>;
};

/** A filter to be used against `DatabaseLookupType` object types. All fields are combined with a logical ‘and.’ */
export type DatabaseLookupTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DatabaseLookupTypeFilter>>;
  /** Filter by the object’s `databaseId` field. */
  databaseId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lookupProfileId` field. */
  lookupProfileId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DatabaseLookupTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DatabaseLookupTypeFilter>>;
  /** Filter by the object’s `prompt` field. */
  prompt?: InputMaybe<StringFilter>;
  /** Filter by the object’s `searchColumnId` field. */
  searchColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `searchTerm` field. */
  searchTerm?: InputMaybe<StringFilter>;
  /** Filter by the object’s `valueColumnId` field. */
  valueColumnId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `DatabaseLookupType` */
export type DatabaseLookupTypeInput = {
  databaseId?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  prompt?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

/** All input for the `deleteAutoShapeByNodeId` mutation. */
export type DeleteAutoShapeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AutoShape` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteAutoShape` mutation. */
export type DeleteAutoShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AutoShape` mutation. */
export type DeleteAutoShapePayload = {
  __typename?: 'DeleteAutoShapePayload';
  /** The `AutoShape` that was deleted by this mutation. */
  autoShape?: Maybe<AutoShape>;
  /** An edge for our `AutoShape`. May be used by Relay 1. */
  autoShapeEdge?: Maybe<AutoShapesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAutoShapeNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `AutoShape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AutoShape` mutation. */
export type DeleteAutoShapePayloadAutoShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};

/** All input for the `deleteCommentByNodeId` mutation. */
export type DeleteCommentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Comment` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteComment` mutation. */
export type DeleteCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Comment` mutation. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` that was deleted by this mutation. */
  comment?: Maybe<Comment>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  commentByReplies?: Maybe<Comment>;
  /** An edge for our `Comment`. May be used by Relay 1. */
  commentEdge?: Maybe<CommentsEdge>;
  deletedCommentNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Order` that is related to this `Comment`. */
  order?: Maybe<Order>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  parent?: Maybe<Comment>;
  /** Reads a single `Project` that is related to this `Comment`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavedView` that is related to this `Comment`. */
  savedViews?: Maybe<SavedView>;
};


/** The output of our delete `Comment` mutation. */
export type DeleteCommentPayloadCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseCellByNodeId` mutation. */
export type DeleteCompanyDatabaseCellByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseCell` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseCell` mutation. */
export type DeleteCompanyDatabaseCellInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  columnId: Scalars['UUID'];
  rowId: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseCell` mutation. */
export type DeleteCompanyDatabaseCellPayload = {
  __typename?: 'DeleteCompanyDatabaseCellPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseCell`. */
  column?: Maybe<CompanyDatabaseColumn>;
  /** The `CompanyDatabaseCell` that was deleted by this mutation. */
  companyDatabaseCell?: Maybe<CompanyDatabaseCell>;
  /** An edge for our `CompanyDatabaseCell`. May be used by Relay 1. */
  companyDatabaseCellEdge?: Maybe<CompanyDatabaseCellsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseCell`. */
  database?: Maybe<CompanyDatabasis>;
  deletedCompanyDatabaseCellNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseCell`. */
  row?: Maybe<CompanyDatabaseRow>;
};


/** The output of our delete `CompanyDatabaseCell` mutation. */
export type DeleteCompanyDatabaseCellPayloadCompanyDatabaseCellEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseColumnByNodeId` mutation. */
export type DeleteCompanyDatabaseColumnByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseColumn` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseColumn` mutation. */
export type DeleteCompanyDatabaseColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseColumn` mutation. */
export type DeleteCompanyDatabaseColumnPayload = {
  __typename?: 'DeleteCompanyDatabaseColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseColumn` that was deleted by this mutation. */
  companyDatabaseColumn?: Maybe<CompanyDatabaseColumn>;
  /** An edge for our `CompanyDatabaseColumn`. May be used by Relay 1. */
  companyDatabaseColumnEdge?: Maybe<CompanyDatabaseColumnsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseColumn`. */
  database?: Maybe<CompanyDatabasis>;
  deletedCompanyDatabaseColumnNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyDatabaseColumn` mutation. */
export type DeleteCompanyDatabaseColumnPayloadCompanyDatabaseColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseImportJobByNodeId` mutation. */
export type DeleteCompanyDatabaseImportJobByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseImportJob` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseImportJob` mutation. */
export type DeleteCompanyDatabaseImportJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseImportJob` mutation. */
export type DeleteCompanyDatabaseImportJobPayload = {
  __typename?: 'DeleteCompanyDatabaseImportJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseImportJob` that was deleted by this mutation. */
  companyDatabaseImportJob?: Maybe<CompanyDatabaseImportJob>;
  /** An edge for our `CompanyDatabaseImportJob`. May be used by Relay 1. */
  companyDatabaseImportJobEdge?: Maybe<CompanyDatabaseImportJobsEdge>;
  /** Reads a single `Contractor` that is related to this `CompanyDatabaseImportJob`. */
  contractor?: Maybe<Contractor>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseImportJob`. */
  database?: Maybe<CompanyDatabasis>;
  deletedCompanyDatabaseImportJobNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyDatabaseImportJob` mutation. */
export type DeleteCompanyDatabaseImportJobPayloadCompanyDatabaseImportJobEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId` mutation. */
export type DeleteCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** All input for the `deleteCompanyDatabaseLookupCacheByNodeId` mutation. */
export type DeleteCompanyDatabaseLookupCacheByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseLookupCache` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseLookupCache` mutation. */
export type DeleteCompanyDatabaseLookupCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseLookupCache` mutation. */
export type DeleteCompanyDatabaseLookupCachePayload = {
  __typename?: 'DeleteCompanyDatabaseLookupCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupCache` that was deleted by this mutation. */
  companyDatabaseLookupCache?: Maybe<CompanyDatabaseLookupCache>;
  /** An edge for our `CompanyDatabaseLookupCache`. May be used by Relay 1. */
  companyDatabaseLookupCacheEdge?: Maybe<CompanyDatabaseLookupCachesEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupCache`. */
  database?: Maybe<CompanyDatabasis>;
  deletedCompanyDatabaseLookupCacheNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupCache`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseLookupCache`. */
  resolved?: Maybe<CompanyDatabaseRow>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  searchColumn?: Maybe<CompanyDatabaseColumn>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  valueColumn?: Maybe<CompanyDatabaseColumn>;
};


/** The output of our delete `CompanyDatabaseLookupCache` mutation. */
export type DeleteCompanyDatabaseLookupCachePayloadCompanyDatabaseLookupCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseLookupJobByNodeId` mutation. */
export type DeleteCompanyDatabaseLookupJobByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseLookupJob` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseLookupJob` mutation. */
export type DeleteCompanyDatabaseLookupJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseLookupJob` mutation. */
export type DeleteCompanyDatabaseLookupJobPayload = {
  __typename?: 'DeleteCompanyDatabaseLookupJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupJob` that was deleted by this mutation. */
  companyDatabaseLookupJob?: Maybe<CompanyDatabaseLookupJob>;
  /** An edge for our `CompanyDatabaseLookupJob`. May be used by Relay 1. */
  companyDatabaseLookupJobEdge?: Maybe<CompanyDatabaseLookupJobsEdge>;
  deletedCompanyDatabaseLookupJobNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupJob`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyDatabaseLookupJob` mutation. */
export type DeleteCompanyDatabaseLookupJobPayloadCompanyDatabaseLookupJobEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseLookupProfileByNodeId` mutation. */
export type DeleteCompanyDatabaseLookupProfileByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseLookupProfile` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseLookupProfile` mutation. */
export type DeleteCompanyDatabaseLookupProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseLookupProfile` mutation. */
export type DeleteCompanyDatabaseLookupProfilePayload = {
  __typename?: 'DeleteCompanyDatabaseLookupProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupProfile` that was deleted by this mutation. */
  companyDatabaseLookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** An edge for our `CompanyDatabaseLookupProfile`. May be used by Relay 1. */
  companyDatabaseLookupProfileEdge?: Maybe<CompanyDatabaseLookupProfilesEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupProfile`. */
  database?: Maybe<CompanyDatabasis>;
  deletedCompanyDatabaseLookupProfileNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyDatabaseLookupProfile` mutation. */
export type DeleteCompanyDatabaseLookupProfilePayloadCompanyDatabaseLookupProfileEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};

/** All input for the `deleteCompanyDatabaseRowByNodeId` mutation. */
export type DeleteCompanyDatabaseRowByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseRow` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabaseRow` mutation. */
export type DeleteCompanyDatabaseRowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabaseRow` mutation. */
export type DeleteCompanyDatabaseRowPayload = {
  __typename?: 'DeleteCompanyDatabaseRowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseRow` that was deleted by this mutation. */
  companyDatabaseRow?: Maybe<CompanyDatabaseRow>;
  /** An edge for our `CompanyDatabaseRow`. May be used by Relay 1. */
  companyDatabaseRowEdge?: Maybe<CompanyDatabaseRowsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseRow`. */
  database?: Maybe<CompanyDatabasis>;
  deletedCompanyDatabaseRowNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyDatabaseRow` mutation. */
export type DeleteCompanyDatabaseRowPayloadCompanyDatabaseRowEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};

/** All input for the `deleteCompanyDatabasisByNodeId` mutation. */
export type DeleteCompanyDatabasisByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabasis` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCompanyDatabasis` mutation. */
export type DeleteCompanyDatabasisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyDatabasis` mutation. */
export type DeleteCompanyDatabasisPayload = {
  __typename?: 'DeleteCompanyDatabasisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabasis` that was deleted by this mutation. */
  companyDatabasis?: Maybe<CompanyDatabasis>;
  /** An edge for our `CompanyDatabasis`. May be used by Relay 1. */
  companyDatabasisEdge?: Maybe<CompanyDatabasesEdge>;
  /** Reads a single `Contractor` that is related to this `CompanyDatabasis`. */
  contractor?: Maybe<Contractor>;
  deletedCompanyDatabasisNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyDatabasis` mutation. */
export type DeleteCompanyDatabasisPayloadCompanyDatabasisEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};

/** All input for the `deleteContractorByNodeId` mutation. */
export type DeleteContractorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Contractor` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteContractorByTenant` mutation. */
export type DeleteContractorByTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  tenant: Scalars['String'];
};

/** All input for the `deleteContractor` mutation. */
export type DeleteContractorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Contractor` mutation. */
export type DeleteContractorPayload = {
  __typename?: 'DeleteContractorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contractor` that was deleted by this mutation. */
  contractor?: Maybe<Contractor>;
  /** An edge for our `Contractor`. May be used by Relay 1. */
  contractorEdge?: Maybe<ContractorsEdge>;
  deletedContractorNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Contractor` mutation. */
export type DeleteContractorPayloadContractorEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractorsOrderBy>>;
};

/** All input for the `deleteCopilotExchangeByNodeId` mutation. */
export type DeleteCopilotExchangeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CopilotExchange` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCopilotExchange` mutation. */
export type DeleteCopilotExchangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CopilotExchange` mutation. */
export type DeleteCopilotExchangePayload = {
  __typename?: 'DeleteCopilotExchangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `CopilotExchange`. */
  contractor?: Maybe<Contractor>;
  /** The `CopilotExchange` that was deleted by this mutation. */
  copilotExchange?: Maybe<CopilotExchange>;
  /** An edge for our `CopilotExchange`. May be used by Relay 1. */
  copilotExchangeEdge?: Maybe<CopilotExchangesEdge>;
  deletedCopilotExchangeNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `CopilotExchange`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CopilotExchange` mutation. */
export type DeleteCopilotExchangePayloadCopilotExchangeEdgeArgs = {
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};

/** All input for the `deleteCopilotExchangesFeedbackByNodeId` mutation. */
export type DeleteCopilotExchangesFeedbackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CopilotExchangesFeedback` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCopilotExchangesFeedback` mutation. */
export type DeleteCopilotExchangesFeedbackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CopilotExchangesFeedback` mutation. */
export type DeleteCopilotExchangesFeedbackPayload = {
  __typename?: 'DeleteCopilotExchangesFeedbackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CopilotExchange` that is related to this `CopilotExchangesFeedback`. */
  copilotExchangeById?: Maybe<CopilotExchange>;
  /** The `CopilotExchangesFeedback` that was deleted by this mutation. */
  copilotExchangesFeedback?: Maybe<CopilotExchangesFeedback>;
  /** An edge for our `CopilotExchangesFeedback`. May be used by Relay 1. */
  copilotExchangesFeedbackEdge?: Maybe<CopilotExchangesFeedbacksEdge>;
  deletedCopilotExchangesFeedbackNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CopilotExchangesFeedback` mutation. */
export type DeleteCopilotExchangesFeedbackPayloadCopilotExchangesFeedbackEdgeArgs = {
  orderBy?: InputMaybe<Array<CopilotExchangesFeedbacksOrderBy>>;
};

/** All input for the `deleteCustomFieldByNodeId` mutation. */
export type DeleteCustomFieldByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CustomField` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCustomFieldByOrderColumnIdAndOrderEntryId` mutation. */
export type DeleteCustomFieldByOrderColumnIdAndOrderEntryIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
};

/** All input for the `deleteCustomField` mutation. */
export type DeleteCustomFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CustomField` mutation. */
export type DeleteCustomFieldPayload = {
  __typename?: 'DeleteCustomFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomField` that was deleted by this mutation. */
  customField?: Maybe<CustomField>;
  /** An edge for our `CustomField`. May be used by Relay 1. */
  customFieldEdge?: Maybe<CustomFieldsEdge>;
  deletedCustomFieldNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `OrderColumn` that is related to this `CustomField`. */
  orderColumn?: Maybe<OrderColumn>;
  /** Reads a single `OrderEntry` that is related to this `CustomField`. */
  orderEntry?: Maybe<OrderEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CustomField` mutation. */
export type DeleteCustomFieldPayloadCustomFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};

/** All input for the `deleteCustomFieldTemplateByNodeId` mutation. */
export type DeleteCustomFieldTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CustomFieldTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCustomFieldTemplate` mutation. */
export type DeleteCustomFieldTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CustomFieldTemplate` mutation. */
export type DeleteCustomFieldTemplatePayload = {
  __typename?: 'DeleteCustomFieldTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomFieldTemplate` that was deleted by this mutation. */
  customFieldTemplate?: Maybe<CustomFieldTemplate>;
  /** An edge for our `CustomFieldTemplate`. May be used by Relay 1. */
  customFieldTemplateEdge?: Maybe<CustomFieldTemplatesEdge>;
  deletedCustomFieldTemplateNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `OrderColumnTemplate` that is related to this `CustomFieldTemplate`. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** Reads a single `ProjectTemplateOrderEntry` that is related to this `CustomFieldTemplate`. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CustomFieldTemplate` mutation. */
export type DeleteCustomFieldTemplatePayloadCustomFieldTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};

/** All input for the `deleteExtrudedPolygonByNodeId` mutation. */
export type DeleteExtrudedPolygonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ExtrudedPolygon` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteExtrudedPolygonByShapeId` mutation. */
export type DeleteExtrudedPolygonByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapeId: Scalars['UUID'];
};

/** All input for the `deleteExtrudedPolygon` mutation. */
export type DeleteExtrudedPolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ExtrudedPolygon` mutation. */
export type DeleteExtrudedPolygonPayload = {
  __typename?: 'DeleteExtrudedPolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExtrudedPolygonNodeId?: Maybe<Scalars['ID']>;
  /** The `ExtrudedPolygon` that was deleted by this mutation. */
  extrudedPolygon?: Maybe<ExtrudedPolygon>;
  /** An edge for our `ExtrudedPolygon`. May be used by Relay 1. */
  extrudedPolygonEdge?: Maybe<ExtrudedPolygonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `ExtrudedPolygon`. */
  shape?: Maybe<Shape>;
};


/** The output of our delete `ExtrudedPolygon` mutation. */
export type DeleteExtrudedPolygonPayloadExtrudedPolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<ExtrudedPolygonsOrderBy>>;
};

/** All input for the `deleteFlowActionByFlowIdAndPosition` mutation. */
export type DeleteFlowActionByFlowIdAndPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  flowId: Scalars['UUID'];
  position: Scalars['Int'];
};

/** All input for the `deleteFlowActionByNodeId` mutation. */
export type DeleteFlowActionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowAction` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFlowAction` mutation. */
export type DeleteFlowActionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `FlowAction` mutation. */
export type DeleteFlowActionPayload = {
  __typename?: 'DeleteFlowActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFlowActionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Flow` that is related to this `FlowAction`. */
  flow?: Maybe<Flow>;
  /** The `FlowAction` that was deleted by this mutation. */
  flowAction?: Maybe<FlowAction>;
  /** An edge for our `FlowAction`. May be used by Relay 1. */
  flowActionEdge?: Maybe<FlowActionsEdge>;
  /** Reads a single `FlowAction` that is related to this `FlowAction`. */
  parentLoopAction?: Maybe<FlowAction>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FlowAction` mutation. */
export type DeleteFlowActionPayloadFlowActionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};

/** All input for the `deleteFlowByNodeId` mutation. */
export type DeleteFlowByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Flow` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFlowExecutionByNodeId` mutation. */
export type DeleteFlowExecutionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowExecution` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFlowExecution` mutation. */
export type DeleteFlowExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `FlowExecution` mutation. */
export type DeleteFlowExecutionPayload = {
  __typename?: 'DeleteFlowExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFlowExecutionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Flow` that is related to this `FlowExecution`. */
  flow?: Maybe<Flow>;
  /** The `FlowExecution` that was deleted by this mutation. */
  flowExecution?: Maybe<FlowExecution>;
  /** An edge for our `FlowExecution`. May be used by Relay 1. */
  flowExecutionEdge?: Maybe<FlowExecutionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FlowExecution` mutation. */
export type DeleteFlowExecutionPayloadFlowExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};

/** All input for the `deleteFlow` mutation. */
export type DeleteFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteFlowMailboxByContractorId` mutation. */
export type DeleteFlowMailboxByContractorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractorId: Scalars['UUID'];
};

/** All input for the `deleteFlowMailboxByEmailLocalPartAndEmailDomain` mutation. */
export type DeleteFlowMailboxByEmailLocalPartAndEmailDomainInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
};

/** All input for the `deleteFlowMailboxByNodeId` mutation. */
export type DeleteFlowMailboxByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowMailbox` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFlowMailbox` mutation. */
export type DeleteFlowMailboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteFlowMailboxMessageByNodeId` mutation. */
export type DeleteFlowMailboxMessageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowMailboxMessage` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFlowMailboxMessage` mutation. */
export type DeleteFlowMailboxMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `FlowMailboxMessage` mutation. */
export type DeleteFlowMailboxMessagePayload = {
  __typename?: 'DeleteFlowMailboxMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFlowMailboxMessageNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `FlowExecution` that is related to this `FlowMailboxMessage`. */
  flowExecution?: Maybe<FlowExecution>;
  /** The `FlowMailboxMessage` that was deleted by this mutation. */
  flowMailboxMessage?: Maybe<FlowMailboxMessage>;
  /** An edge for our `FlowMailboxMessage`. May be used by Relay 1. */
  flowMailboxMessageEdge?: Maybe<FlowMailboxMessagesEdge>;
  /** Reads a single `FlowMailbox` that is related to this `FlowMailboxMessage`. */
  mailbox?: Maybe<FlowMailbox>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FlowMailboxMessage` mutation. */
export type DeleteFlowMailboxMessagePayloadFlowMailboxMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};

/** The output of our delete `FlowMailbox` mutation. */
export type DeleteFlowMailboxPayload = {
  __typename?: 'DeleteFlowMailboxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `FlowMailbox`. */
  contractor?: Maybe<Contractor>;
  deletedFlowMailboxNodeId?: Maybe<Scalars['ID']>;
  /** The `FlowMailbox` that was deleted by this mutation. */
  flowMailbox?: Maybe<FlowMailbox>;
  /** An edge for our `FlowMailbox`. May be used by Relay 1. */
  flowMailboxEdge?: Maybe<FlowMailboxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FlowMailbox` mutation. */
export type DeleteFlowMailboxPayloadFlowMailboxEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowMailboxesOrderBy>>;
};

/** The output of our delete `Flow` mutation. */
export type DeleteFlowPayload = {
  __typename?: 'DeleteFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Flow`. */
  contractor?: Maybe<Contractor>;
  deletedFlowNodeId?: Maybe<Scalars['ID']>;
  /** The `Flow` that was deleted by this mutation. */
  flow?: Maybe<Flow>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Flow` mutation. */
export type DeleteFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the `deleteHistoryEventByNodeId` mutation. */
export type DeleteHistoryEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `HistoryEvent` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteHistoryEvent` mutation. */
export type DeleteHistoryEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `HistoryEvent` mutation. */
export type DeleteHistoryEventPayload = {
  __typename?: 'DeleteHistoryEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedHistoryEventNodeId?: Maybe<Scalars['ID']>;
  /** The `HistoryEvent` that was deleted by this mutation. */
  historyEvent?: Maybe<HistoryEvent>;
  /** An edge for our `HistoryEvent`. May be used by Relay 1. */
  historyEventEdge?: Maybe<HistoryEventsEdge>;
  /** Reads a single `Project` that is related to this `HistoryEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `HistoryEvent` mutation. */
export type DeleteHistoryEventPayloadHistoryEventEdgeArgs = {
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};

/** All input for the `deleteInitialStateByNodeId` mutation. */
export type DeleteInitialStateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InitialState` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteInitialState` mutation. */
export type DeleteInitialStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `InitialState` mutation. */
export type DeleteInitialStatePayload = {
  __typename?: 'DeleteInitialStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInitialStateNodeId?: Maybe<Scalars['ID']>;
  /** The `InitialState` that was deleted by this mutation. */
  initialState?: Maybe<InitialState>;
  /** An edge for our `InitialState`. May be used by Relay 1. */
  initialStateEdge?: Maybe<InitialStatesEdge>;
  /** Reads a single `Project` that is related to this `InitialState`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavedView` that is related to this `InitialState`. */
  view?: Maybe<SavedView>;
};


/** The output of our delete `InitialState` mutation. */
export type DeleteInitialStatePayloadInitialStateEdgeArgs = {
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};

/** All input for the `deleteIssueByNodeId` mutation. */
export type DeleteIssueByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Issue` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteIssueCommentByNodeId` mutation. */
export type DeleteIssueCommentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IssueComment` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteIssueComment` mutation. */
export type DeleteIssueCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `IssueComment` mutation. */
export type DeleteIssueCommentPayload = {
  __typename?: 'DeleteIssueCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedIssueCommentNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Issue` that is related to this `IssueComment`. */
  issue?: Maybe<Issue>;
  /** The `IssueComment` that was deleted by this mutation. */
  issueComment?: Maybe<IssueComment>;
  /** An edge for our `IssueComment`. May be used by Relay 1. */
  issueCommentEdge?: Maybe<IssueCommentsEdge>;
  /** Reads a single `Project` that is related to this `IssueComment`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IssueComment` mutation. */
export type DeleteIssueCommentPayloadIssueCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};

/** All input for the `deleteIssue` mutation. */
export type DeleteIssueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Issue` mutation. */
export type DeleteIssuePayload = {
  __typename?: 'DeleteIssuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedIssueNodeId?: Maybe<Scalars['ID']>;
  /** The `Issue` that was deleted by this mutation. */
  issue?: Maybe<Issue>;
  /** An edge for our `Issue`. May be used by Relay 1. */
  issueEdge?: Maybe<IssuesEdge>;
  /** Reads a single `Project` that is related to this `Issue`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Issue` mutation. */
export type DeleteIssuePayloadIssueEdgeArgs = {
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};

/** All input for the `deleteLineByNodeId` mutation. */
export type DeleteLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Line` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteLineByShapeId` mutation. */
export type DeleteLineByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapeId: Scalars['UUID'];
};

/** All input for the `deleteLine` mutation. */
export type DeleteLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Line` mutation. */
export type DeleteLinePayload = {
  __typename?: 'DeleteLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLineNodeId?: Maybe<Scalars['ID']>;
  /** The `Line` that was deleted by this mutation. */
  line?: Maybe<Line>;
  /** An edge for our `Line`. May be used by Relay 1. */
  lineEdge?: Maybe<LinesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `Line`. */
  shape?: Maybe<Shape>;
};


/** The output of our delete `Line` mutation. */
export type DeleteLinePayloadLineEdgeArgs = {
  orderBy?: InputMaybe<Array<LinesOrderBy>>;
};

/** All input for the `deleteModelByNodeId` mutation. */
export type DeleteModelByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Model` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteModelByProjectIdAndNameAndVersion` mutation. */
export type DeleteModelByProjectIdAndNameAndVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** All input for the `deleteModel` mutation. */
export type DeleteModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Model` mutation. */
export type DeleteModelPayload = {
  __typename?: 'DeleteModelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedModelNodeId?: Maybe<Scalars['ID']>;
  /** The `Model` that was deleted by this mutation. */
  model?: Maybe<Model>;
  /** An edge for our `Model`. May be used by Relay 1. */
  modelEdge?: Maybe<ModelsEdge>;
  /** Reads a single `Project` that is related to this `Model`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Model` mutation. */
export type DeleteModelPayloadModelEdgeArgs = {
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};

/** All input for the `deleteModelVersion` mutation. */
export type DeleteModelVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
  versionName: Scalars['String'];
};

/** The output of our `deleteModelVersion` mutation. */
export type DeleteModelVersionPayload = {
  __typename?: 'DeleteModelVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  model?: Maybe<Model>;
  /** An edge for our `Model`. May be used by Relay 1. */
  modelEdge?: Maybe<ModelsEdge>;
  /** Reads a single `Project` that is related to this `Model`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteModelVersion` mutation. */
export type DeleteModelVersionPayloadModelEdgeArgs = {
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};

/** All input for the `deleteOrderByNodeId` mutation. */
export type DeleteOrderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Order` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderColumnByNameAndColumnTypeAndOrderId` mutation. */
export type DeleteOrderColumnByNameAndColumnTypeAndOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
};

/** All input for the `deleteOrderColumnByNodeId` mutation. */
export type DeleteOrderColumnByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderColumn` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderColumn` mutation. */
export type DeleteOrderColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `OrderColumn` mutation. */
export type DeleteOrderColumnPayload = {
  __typename?: 'DeleteOrderColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOrderColumnNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Order` that is related to this `OrderColumn`. */
  order?: Maybe<Order>;
  /** The `OrderColumn` that was deleted by this mutation. */
  orderColumn?: Maybe<OrderColumn>;
  /** An edge for our `OrderColumn`. May be used by Relay 1. */
  orderColumnEdge?: Maybe<OrderColumnsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderColumn` mutation. */
export type DeleteOrderColumnPayloadOrderColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};

/** All input for the `deleteOrderColumnTemplateByNodeId` mutation. */
export type DeleteOrderColumnTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderColumnTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderColumnTemplate` mutation. */
export type DeleteOrderColumnTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `OrderColumnTemplate` mutation. */
export type DeleteOrderColumnTemplatePayload = {
  __typename?: 'DeleteOrderColumnTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOrderColumnTemplateNodeId?: Maybe<Scalars['ID']>;
  /** The `OrderColumnTemplate` that was deleted by this mutation. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** An edge for our `OrderColumnTemplate`. May be used by Relay 1. */
  orderColumnTemplateEdge?: Maybe<OrderColumnTemplatesEdge>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `OrderColumnTemplate`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderColumnTemplate` mutation. */
export type DeleteOrderColumnTemplatePayloadOrderColumnTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};

/** All input for the `deleteOrderEntryByNodeId` mutation. */
export type DeleteOrderEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntry` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderEntryCacheByNodeId` mutation. */
export type DeleteOrderEntryCacheByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntryCache` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderEntryCacheByOrderEntryId` mutation. */
export type DeleteOrderEntryCacheByOrderEntryIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderEntryId: Scalars['UUID'];
};

/** All input for the `deleteOrderEntryCache` mutation. */
export type DeleteOrderEntryCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `OrderEntryCache` mutation. */
export type DeleteOrderEntryCachePayload = {
  __typename?: 'DeleteOrderEntryCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOrderEntryCacheNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `OrderEntry` that is related to this `OrderEntryCache`. */
  orderEntry?: Maybe<OrderEntry>;
  /** The `OrderEntryCache` that was deleted by this mutation. */
  orderEntryCache?: Maybe<OrderEntryCache>;
  /** An edge for our `OrderEntryCache`. May be used by Relay 1. */
  orderEntryCacheEdge?: Maybe<OrderEntryCachesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderEntryCache` mutation. */
export type DeleteOrderEntryCachePayloadOrderEntryCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryCachesOrderBy>>;
};

/** All input for the `deleteOrderEntry` mutation. */
export type DeleteOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `OrderEntry` mutation. */
export type DeleteOrderEntryPayload = {
  __typename?: 'DeleteOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOrderEntryNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Order` that is related to this `OrderEntry`. */
  order?: Maybe<Order>;
  /** The `OrderEntry` that was deleted by this mutation. */
  orderEntry?: Maybe<OrderEntry>;
  /** An edge for our `OrderEntry`. May be used by Relay 1. */
  orderEntryEdge?: Maybe<OrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderEntry` mutation. */
export type DeleteOrderEntryPayloadOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};

/** All input for the `deleteOrderEntryTemplateByNodeId` mutation. */
export type DeleteOrderEntryTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntryTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderEntryTemplate` mutation. */
export type DeleteOrderEntryTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `OrderEntryTemplate` mutation. */
export type DeleteOrderEntryTemplatePayload = {
  __typename?: 'DeleteOrderEntryTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `OrderEntryTemplate`. */
  contractor?: Maybe<Contractor>;
  deletedOrderEntryTemplateNodeId?: Maybe<Scalars['ID']>;
  /** The `OrderEntryTemplate` that was deleted by this mutation. */
  orderEntryTemplate?: Maybe<OrderEntryTemplate>;
  /** An edge for our `OrderEntryTemplate`. May be used by Relay 1. */
  orderEntryTemplateEdge?: Maybe<OrderEntryTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderEntryTemplate` mutation. */
export type DeleteOrderEntryTemplatePayloadOrderEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};

/** All input for the `deleteOrderEntryViewByNodeId` mutation. */
export type DeleteOrderEntryViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntryView` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrderEntryViewByProjectIdAndName` mutation. */
export type DeleteOrderEntryViewByProjectIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** All input for the `deleteOrderEntryView` mutation. */
export type DeleteOrderEntryViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `OrderEntryView` mutation. */
export type DeleteOrderEntryViewPayload = {
  __typename?: 'DeleteOrderEntryViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOrderEntryViewNodeId?: Maybe<Scalars['ID']>;
  /** The `OrderEntryView` that was deleted by this mutation. */
  orderEntryView?: Maybe<OrderEntryView>;
  /** An edge for our `OrderEntryView`. May be used by Relay 1. */
  orderEntryViewEdge?: Maybe<OrderEntryViewsEdge>;
  /** Reads a single `Project` that is related to this `OrderEntryView`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderEntryView` mutation. */
export type DeleteOrderEntryViewPayloadOrderEntryViewEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};

/** All input for the `deleteOrder` mutation. */
export type DeleteOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Order` mutation. */
export type DeleteOrderPayload = {
  __typename?: 'DeleteOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedOrderNodeId?: Maybe<Scalars['ID']>;
  /** The `Order` that was deleted by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Project` that is related to this `Order`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Order` mutation. */
export type DeleteOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `deletePolygonByNodeId` mutation. */
export type DeletePolygonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Polygon` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePolygonByShapeId` mutation. */
export type DeletePolygonByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapeId: Scalars['UUID'];
};

/** All input for the `deletePolygon` mutation. */
export type DeletePolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Polygon` mutation. */
export type DeletePolygonPayload = {
  __typename?: 'DeletePolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPolygonNodeId?: Maybe<Scalars['ID']>;
  /** The `Polygon` that was deleted by this mutation. */
  polygon?: Maybe<Polygon>;
  /** An edge for our `Polygon`. May be used by Relay 1. */
  polygonEdge?: Maybe<PolygonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `Polygon`. */
  shape?: Maybe<Shape>;
};


/** The output of our delete `Polygon` mutation. */
export type DeletePolygonPayloadPolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<PolygonsOrderBy>>;
};

/** All input for the `deleteProjectByNodeId` mutation. */
export type DeleteProjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Project` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProject` mutation. */
export type DeleteProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Project`. */
  contractor?: Maybe<Contractor>;
  deletedProjectNodeId?: Maybe<Scalars['ID']>;
  /** The `Project` that was deleted by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Project` mutation. */
export type DeleteProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `deleteProjectTagByNodeId` mutation. */
export type DeleteProjectTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTag` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectTag` mutation. */
export type DeleteProjectTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectTag` mutation. */
export type DeleteProjectTagPayload = {
  __typename?: 'DeleteProjectTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTag`. */
  contractor?: Maybe<Contractor>;
  deletedProjectTagNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectTag` that was deleted by this mutation. */
  projectTag?: Maybe<ProjectTag>;
  /** An edge for our `ProjectTag`. May be used by Relay 1. */
  projectTagEdge?: Maybe<ProjectTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectTag` mutation. */
export type DeleteProjectTagPayloadProjectTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** All input for the `deleteProjectTemplateByNodeId` mutation. */
export type DeleteProjectTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectTemplate` mutation. */
export type DeleteProjectTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteProjectTemplateOrderByNodeId` mutation. */
export type DeleteProjectTemplateOrderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplateOrder` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectTemplateOrderEntryByNodeId` mutation. */
export type DeleteProjectTemplateOrderEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplateOrderEntry` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectTemplateOrderEntry` mutation. */
export type DeleteProjectTemplateOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectTemplateOrderEntry` mutation. */
export type DeleteProjectTemplateOrderEntryPayload = {
  __typename?: 'DeleteProjectTemplateOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectTemplateOrderEntryNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `ProjectTemplateOrderEntry`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** The `ProjectTemplateOrderEntry` that was deleted by this mutation. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** An edge for our `ProjectTemplateOrderEntry`. May be used by Relay 1. */
  projectTemplateOrderEntryEdge?: Maybe<ProjectTemplateOrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectTemplateOrderEntry` mutation. */
export type DeleteProjectTemplateOrderEntryPayloadProjectTemplateOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};

/** All input for the `deleteProjectTemplateOrderEntryViewByNodeId` mutation. */
export type DeleteProjectTemplateOrderEntryViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplateOrderEntryView` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProjectTemplateOrderEntryView` mutation. */
export type DeleteProjectTemplateOrderEntryViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectTemplateOrderEntryView` mutation. */
export type DeleteProjectTemplateOrderEntryViewPayload = {
  __typename?: 'DeleteProjectTemplateOrderEntryViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectTemplateOrderEntryViewNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrderEntryView`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** The `ProjectTemplateOrderEntryView` that was deleted by this mutation. */
  projectTemplateOrderEntryView?: Maybe<ProjectTemplateOrderEntryView>;
  /** An edge for our `ProjectTemplateOrderEntryView`. May be used by Relay 1. */
  projectTemplateOrderEntryViewEdge?: Maybe<ProjectTemplateOrderEntryViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectTemplateOrderEntryView` mutation. */
export type DeleteProjectTemplateOrderEntryViewPayloadProjectTemplateOrderEntryViewEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};

/** All input for the `deleteProjectTemplateOrder` mutation. */
export type DeleteProjectTemplateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectTemplateOrder` mutation. */
export type DeleteProjectTemplateOrderPayload = {
  __typename?: 'DeleteProjectTemplateOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectTemplateOrderNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrder`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** The `ProjectTemplateOrder` that was deleted by this mutation. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** An edge for our `ProjectTemplateOrder`. May be used by Relay 1. */
  projectTemplateOrderEdge?: Maybe<ProjectTemplateOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectTemplateOrder` mutation. */
export type DeleteProjectTemplateOrderPayloadProjectTemplateOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};

/** The output of our delete `ProjectTemplate` mutation. */
export type DeleteProjectTemplatePayload = {
  __typename?: 'DeleteProjectTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTemplate`. */
  contractor?: Maybe<Contractor>;
  deletedProjectTemplateNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectTemplate` that was deleted by this mutation. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** An edge for our `ProjectTemplate`. May be used by Relay 1. */
  projectTemplateEdge?: Maybe<ProjectTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectTemplate` mutation. */
export type DeleteProjectTemplatePayloadProjectTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};

/** All input for the `deleteProtanProjectStepByNodeId` mutation. */
export type DeleteProtanProjectStepByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProtanProjectStep` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProtanProjectStepByProjectIdAndStep` mutation. */
export type DeleteProtanProjectStepByProjectIdAndStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
  step: ProtanProjectStepEnum;
};

/** All input for the `deleteProtanProjectStep` mutation. */
export type DeleteProtanProjectStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProtanProjectStep` mutation. */
export type DeleteProtanProjectStepPayload = {
  __typename?: 'DeleteProtanProjectStepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProtanProjectStepNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `ProtanProjectStep`. */
  project?: Maybe<Project>;
  /** The `ProtanProjectStep` that was deleted by this mutation. */
  protanProjectStep?: Maybe<ProtanProjectStep>;
  /** An edge for our `ProtanProjectStep`. May be used by Relay 1. */
  protanProjectStepEdge?: Maybe<ProtanProjectStepsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProtanProjectStep` mutation. */
export type DeleteProtanProjectStepPayloadProtanProjectStepEdgeArgs = {
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};

/** All input for the `deleteSavedViewByNameAndProjectId` mutation. */
export type DeleteSavedViewByNameAndProjectIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** All input for the `deleteSavedViewByNodeId` mutation. */
export type DeleteSavedViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SavedView` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSavedView` mutation. */
export type DeleteSavedViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SavedView` mutation. */
export type DeleteSavedViewPayload = {
  __typename?: 'DeleteSavedViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSavedViewNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `SavedView`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavedView` that was deleted by this mutation. */
  savedView?: Maybe<SavedView>;
  /** An edge for our `SavedView`. May be used by Relay 1. */
  savedViewEdge?: Maybe<SavedViewsEdge>;
};


/** The output of our delete `SavedView` mutation. */
export type DeleteSavedViewPayloadSavedViewEdgeArgs = {
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};

/** All input for the `deleteShapeByNodeId` mutation. */
export type DeleteShapeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Shape` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteShapeByUrnAndDbId` mutation. */
export type DeleteShapeByUrnAndDbIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};

/** All input for the `deleteShapeFolderByNodeId` mutation. */
export type DeleteShapeFolderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ShapeFolder` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteShapeFolderByProjectIdAndName` mutation. */
export type DeleteShapeFolderByProjectIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** All input for the `deleteShapeFolder` mutation. */
export type DeleteShapeFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ShapeFolder` mutation. */
export type DeleteShapeFolderPayload = {
  __typename?: 'DeleteShapeFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedShapeFolderNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `ShapeFolder`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShapeFolder` that was deleted by this mutation. */
  shapeFolder?: Maybe<ShapeFolder>;
  /** An edge for our `ShapeFolder`. May be used by Relay 1. */
  shapeFolderEdge?: Maybe<ShapeFoldersEdge>;
};


/** The output of our delete `ShapeFolder` mutation. */
export type DeleteShapeFolderPayloadShapeFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};

/** All input for the `deleteShape` mutation. */
export type DeleteShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Shape` mutation. */
export type DeleteShapePayload = {
  __typename?: 'DeleteShapePayload';
  /** Reads a single `AutoShape` that is related to this `Shape`. */
  autoShape?: Maybe<AutoShape>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedShapeNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `Shape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shape` that was deleted by this mutation. */
  shape?: Maybe<Shape>;
  /** An edge for our `Shape`. May be used by Relay 1. */
  shapeEdge?: Maybe<ShapesEdge>;
  /** Reads a single `ShapeFolder` that is related to this `Shape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
};


/** The output of our delete `Shape` mutation. */
export type DeleteShapePayloadShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};

/** All input for the `deleteShapePointByNodeId` mutation. */
export type DeleteShapePointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ShapePoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteShapePointByShapeId` mutation. */
export type DeleteShapePointByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shapeId: Scalars['UUID'];
};

/** All input for the `deleteShapePoint` mutation. */
export type DeleteShapePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ShapePoint` mutation. */
export type DeleteShapePointPayload = {
  __typename?: 'DeleteShapePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedShapePointNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `ShapePoint`. */
  shape?: Maybe<Shape>;
  /** The `ShapePoint` that was deleted by this mutation. */
  shapePoint?: Maybe<ShapePoint>;
  /** An edge for our `ShapePoint`. May be used by Relay 1. */
  shapePointEdge?: Maybe<ShapePointsEdge>;
};


/** The output of our delete `ShapePoint` mutation. */
export type DeleteShapePointPayloadShapePointEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapePointsOrderBy>>;
};

/** All input for the `deleteSharedLinkByInitialStateId` mutation. */
export type DeleteSharedLinkByInitialStateIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  initialStateId: Scalars['UUID'];
};

/** All input for the `deleteSharedLinkByNodeId` mutation. */
export type DeleteSharedLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SharedLink` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSharedLink` mutation. */
export type DeleteSharedLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SharedLink` mutation. */
export type DeleteSharedLinkPayload = {
  __typename?: 'DeleteSharedLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSharedLinkNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `InitialState` that is related to this `SharedLink`. */
  initialState?: Maybe<InitialState>;
  /** Reads a single `Project` that is related to this `SharedLink`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SharedLink` that was deleted by this mutation. */
  sharedLink?: Maybe<SharedLink>;
  /** An edge for our `SharedLink`. May be used by Relay 1. */
  sharedLinkEdge?: Maybe<SharedLinksEdge>;
};


/** The output of our delete `SharedLink` mutation. */
export type DeleteSharedLinkPayloadSharedLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};

/** All input for the `deleteSheetByNodeId` mutation. */
export type DeleteSheetByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sheet` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetByProjectIdAndNameAndVersion` mutation. */
export type DeleteSheetByProjectIdAndNameAndVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** All input for the `deleteSheet` mutation. */
export type DeleteSheetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteSheetPageCalibrationByNodeId` mutation. */
export type DeleteSheetPageCalibrationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetPageCalibration` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetPageCalibration` mutation. */
export type DeleteSheetPageCalibrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pageNumber: Scalars['Int'];
  sheetId: Scalars['UUID'];
};

/** The output of our delete `SheetPageCalibration` mutation. */
export type DeleteSheetPageCalibrationPayload = {
  __typename?: 'DeleteSheetPageCalibrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetPageCalibrationNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Sheet` that is related to this `SheetPageCalibration`. */
  sheet?: Maybe<Sheet>;
  /** The `SheetPageCalibration` that was deleted by this mutation. */
  sheetPageCalibration?: Maybe<SheetPageCalibration>;
  /** An edge for our `SheetPageCalibration`. May be used by Relay 1. */
  sheetPageCalibrationEdge?: Maybe<SheetPageCalibrationsEdge>;
};


/** The output of our delete `SheetPageCalibration` mutation. */
export type DeleteSheetPageCalibrationPayloadSheetPageCalibrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};

/** The output of our delete `Sheet` mutation. */
export type DeleteSheetPayload = {
  __typename?: 'DeleteSheetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `Sheet`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Sheet` that was deleted by this mutation. */
  sheet?: Maybe<Sheet>;
  /** An edge for our `Sheet`. May be used by Relay 1. */
  sheetEdge?: Maybe<SheetsEdge>;
};


/** The output of our delete `Sheet` mutation. */
export type DeleteSheetPayloadSheetEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};

/** All input for the `deleteSheetShapeByNodeId` mutation. */
export type DeleteSheetShapeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShape` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetShapeByUrnAndDbId` mutation. */
export type DeleteSheetShapeByUrnAndDbIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};

/** All input for the `deleteSheetShape` mutation. */
export type DeleteSheetShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteSheetShapeLegendByNodeId` mutation. */
export type DeleteSheetShapeLegendByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapeLegend` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetShapeLegendBySheetShapeId` mutation. */
export type DeleteSheetShapeLegendBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `deleteSheetShapeLegend` mutation. */
export type DeleteSheetShapeLegendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SheetShapeLegend` mutation. */
export type DeleteSheetShapeLegendPayload = {
  __typename?: 'DeleteSheetShapeLegendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetShapeLegendNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Order` that is related to this `SheetShapeLegend`. */
  legendOrder?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLegend`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeLegend` that was deleted by this mutation. */
  sheetShapeLegend?: Maybe<SheetShapeLegend>;
  /** An edge for our `SheetShapeLegend`. May be used by Relay 1. */
  sheetShapeLegendEdge?: Maybe<SheetShapeLegendsEdge>;
};


/** The output of our delete `SheetShapeLegend` mutation. */
export type DeleteSheetShapeLegendPayloadSheetShapeLegendEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};

/** All input for the `deleteSheetShapeLineByNodeId` mutation. */
export type DeleteSheetShapeLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapeLine` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetShapeLineBySheetShapeId` mutation. */
export type DeleteSheetShapeLineBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `deleteSheetShapeLine` mutation. */
export type DeleteSheetShapeLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SheetShapeLine` mutation. */
export type DeleteSheetShapeLinePayload = {
  __typename?: 'DeleteSheetShapeLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetShapeLineNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLine`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeLine` that was deleted by this mutation. */
  sheetShapeLine?: Maybe<SheetShapeLine>;
  /** An edge for our `SheetShapeLine`. May be used by Relay 1. */
  sheetShapeLineEdge?: Maybe<SheetShapeLinesEdge>;
};


/** The output of our delete `SheetShapeLine` mutation. */
export type DeleteSheetShapeLinePayloadSheetShapeLineEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeLinesOrderBy>>;
};

/** The output of our delete `SheetShape` mutation. */
export type DeleteSheetShapePayload = {
  __typename?: 'DeleteSheetShapePayload';
  /** Reads a single `AutoShape` that is related to this `SheetShape`. */
  autoShape?: Maybe<AutoShape>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetShapeNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `SheetShape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ShapeFolder` that is related to this `SheetShape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
  /** Reads a single `Sheet` that is related to this `SheetShape`. */
  sheet?: Maybe<Sheet>;
  /** The `SheetShape` that was deleted by this mutation. */
  sheetShape?: Maybe<SheetShape>;
  /** An edge for our `SheetShape`. May be used by Relay 1. */
  sheetShapeEdge?: Maybe<SheetShapesEdge>;
};


/** The output of our delete `SheetShape` mutation. */
export type DeleteSheetShapePayloadSheetShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};

/** All input for the `deleteSheetShapePointByNodeId` mutation. */
export type DeleteSheetShapePointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapePoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetShapePointBySheetShapeId` mutation. */
export type DeleteSheetShapePointBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `deleteSheetShapePoint` mutation. */
export type DeleteSheetShapePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SheetShapePoint` mutation. */
export type DeleteSheetShapePointPayload = {
  __typename?: 'DeleteSheetShapePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetShapePointNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapePoint`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapePoint` that was deleted by this mutation. */
  sheetShapePoint?: Maybe<SheetShapePoint>;
  /** An edge for our `SheetShapePoint`. May be used by Relay 1. */
  sheetShapePointEdge?: Maybe<SheetShapePointsEdge>;
};


/** The output of our delete `SheetShapePoint` mutation. */
export type DeleteSheetShapePointPayloadSheetShapePointEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapePointsOrderBy>>;
};

/** All input for the `deleteSheetShapePolygonByNodeId` mutation. */
export type DeleteSheetShapePolygonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapePolygon` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetShapePolygonBySheetShapeId` mutation. */
export type DeleteSheetShapePolygonBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `deleteSheetShapePolygon` mutation. */
export type DeleteSheetShapePolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SheetShapePolygon` mutation. */
export type DeleteSheetShapePolygonPayload = {
  __typename?: 'DeleteSheetShapePolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetShapePolygonNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapePolygon`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapePolygon` that was deleted by this mutation. */
  sheetShapePolygon?: Maybe<SheetShapePolygon>;
  /** An edge for our `SheetShapePolygon`. May be used by Relay 1. */
  sheetShapePolygonEdge?: Maybe<SheetShapePolygonsEdge>;
};


/** The output of our delete `SheetShapePolygon` mutation. */
export type DeleteSheetShapePolygonPayloadSheetShapePolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapePolygonsOrderBy>>;
};

/** All input for the `deleteSheetShapeSplitLineByNodeId` mutation. */
export type DeleteSheetShapeSplitLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapeSplitLine` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSheetShapeSplitLineBySheetShapeId` mutation. */
export type DeleteSheetShapeSplitLineBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `deleteSheetShapeSplitLine` mutation. */
export type DeleteSheetShapeSplitLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SheetShapeSplitLine` mutation. */
export type DeleteSheetShapeSplitLinePayload = {
  __typename?: 'DeleteSheetShapeSplitLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSheetShapeSplitLineNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeSplitLine`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeSplitLine` that was deleted by this mutation. */
  sheetShapeSplitLine?: Maybe<SheetShapeSplitLine>;
  /** An edge for our `SheetShapeSplitLine`. May be used by Relay 1. */
  sheetShapeSplitLineEdge?: Maybe<SheetShapeSplitLinesEdge>;
};


/** The output of our delete `SheetShapeSplitLine` mutation. */
export type DeleteSheetShapeSplitLinePayloadSheetShapeSplitLineEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeSplitLinesOrderBy>>;
};

/** All input for the `deleteSheetVersion` mutation. */
export type DeleteSheetVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['UUID'];
  versionName: Scalars['String'];
};

/** The output of our `deleteSheetVersion` mutation. */
export type DeleteSheetVersionPayload = {
  __typename?: 'DeleteSheetVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Sheet`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sheet?: Maybe<Sheet>;
  /** An edge for our `Sheet`. May be used by Relay 1. */
  sheetEdge?: Maybe<SheetsEdge>;
};


/** The output of our `deleteSheetVersion` mutation. */
export type DeleteSheetVersionPayloadSheetEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};

/** All input for the `deleteSparkelAiAnalysisByNodeId` mutation. */
export type DeleteSparkelAiAnalysisByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SparkelAiAnalysis` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSparkelAiAnalysis` mutation. */
export type DeleteSparkelAiAnalysisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SparkelAiAnalysis` mutation. */
export type DeleteSparkelAiAnalysisPayload = {
  __typename?: 'DeleteSparkelAiAnalysisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSparkelAiAnalysisNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `SparkelAiAnalysis`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SparkelAiAnalysis` that was deleted by this mutation. */
  sparkelAiAnalysis?: Maybe<SparkelAiAnalysis>;
  /** An edge for our `SparkelAiAnalysis`. May be used by Relay 1. */
  sparkelAiAnalysisEdge?: Maybe<SparkelAiAnalysesEdge>;
};


/** The output of our delete `SparkelAiAnalysis` mutation. */
export type DeleteSparkelAiAnalysisPayloadSparkelAiAnalysisEdgeArgs = {
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};

/** All input for the `deleteSparkelPropertyByNodeId` mutation. */
export type DeleteSparkelPropertyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SparkelProperty` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySet` mutation. */
export type DeleteSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbId: Scalars['Int'];
  modelUrn: Scalars['String'];
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
};

/** All input for the `deleteSparkelProperty` mutation. */
export type DeleteSparkelPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SparkelProperty` mutation. */
export type DeleteSparkelPropertyPayload = {
  __typename?: 'DeleteSparkelPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSparkelPropertyNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `SparkelProperty`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SparkelProperty` that was deleted by this mutation. */
  sparkelProperty?: Maybe<SparkelProperty>;
  /** An edge for our `SparkelProperty`. May be used by Relay 1. */
  sparkelPropertyEdge?: Maybe<SparkelPropertiesEdge>;
};


/** The output of our delete `SparkelProperty` mutation. */
export type DeleteSparkelPropertyPayloadSparkelPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};

export type DropdownOption = {
  __typename?: 'DropdownOption';
  colorScheme?: Maybe<TagColorScheme>;
  value?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `DropdownOption` */
export type DropdownOptionInput = {
  colorScheme?: InputMaybe<TagColorScheme>;
  value?: InputMaybe<Scalars['String']>;
};

/** All input for the `duplicateOrder` mutation. */
export type DuplicateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  newOrderName: Scalars['String'];
  theOrderId: Scalars['UUID'];
};

/** The output of our `duplicateOrder` mutation. */
export type DuplicateOrderPayload = {
  __typename?: 'DuplicateOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Project` that is related to this `Order`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `duplicateOrder` mutation. */
export type DuplicateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

export type DuplicateProjectInput = {
  newProjectName: Scalars['String'];
  projectId: Scalars['UUID'];
};

export type DuplicateProjectPayload = {
  __typename?: 'DuplicateProjectPayload';
  project?: Maybe<Project>;
};

export enum ElementCategoryEnum {
  Area = 'AREA',
  Boolean = 'BOOLEAN',
  Dropdown = 'DROPDOWN',
  Length = 'LENGTH',
  Number = 'NUMBER',
  String = 'STRING',
  Volume = 'VOLUME'
}

export type ElementCategoryType = {
  __typename?: 'ElementCategoryType';
  dropdownValues?: Maybe<Array<DropdownOption>>;
  name: Scalars['String'];
  type: ElementCategoryEnum;
};

/** An input for mutations affecting `ElementCategoryType` */
export type ElementCategoryTypeInput = {
  dropdownValues?: InputMaybe<Array<InputMaybe<DropdownOptionInput>>>;
  name: Scalars['String'];
  type: ElementCategoryEnum;
};

export type ElementIdentifierDbidType = {
  __typename?: 'ElementIdentifierDbidType';
  dbIds: Array<Scalars['Int']>;
  modelUrn: Scalars['String'];
};

/** An input for mutations affecting `ElementIdentifierDbidType` */
export type ElementIdentifierDbidTypeInput = {
  dbIds: Array<InputMaybe<Scalars['Int']>>;
  modelUrn: Scalars['String'];
};

export enum EventResource {
  AutoShape = 'AUTO_SHAPE',
  Label = 'LABEL',
  Model = 'MODEL',
  Order = 'ORDER',
  OrderEntry = 'ORDER_ENTRY',
  Project = 'PROJECT',
  Shape = 'SHAPE',
  ShapeFolder = 'SHAPE_FOLDER',
  Sheet = 'SHEET',
  SheetShape = 'SHEET_SHAPE',
  SparkelProperty = 'SPARKEL_PROPERTY'
}

/** A filter to be used against EventResource fields. All fields are combined with a logical ‘and.’ */
export type EventResourceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EventResource>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EventResource>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EventResource>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EventResource>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EventResource>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EventResource>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EventResource>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EventResource>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EventResource>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EventResource>>;
};

export enum EventType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Duplicated = 'DUPLICATED',
  Modified = 'MODIFIED'
}

/** A filter to be used against EventType fields. All fields are combined with a logical ‘and.’ */
export type EventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EventType>>;
};

export type ExportShapesToIfcInput = {
  projectId: Scalars['UUID'];
  tenant: Scalars['String'];
};

export type ExportShapesToIfcPayload = {
  __typename?: 'ExportShapesToIfcPayload';
  jobId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ExportShapesToIfcStatusPayload = {
  __typename?: 'ExportShapesToIfcStatusPayload';
  downloadUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ExternalAccessToken = {
  __typename?: 'ExternalAccessToken';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
};

export type ExternalAwsAccessCredentials = {
  __typename?: 'ExternalAwsAccessCredentials';
  accessKeyId: Scalars['String'];
  expiration: Scalars['Datetime'];
  secretAccessKey: Scalars['String'];
  sessionToken: Scalars['String'];
};

export type ExternalWallFinishes3DInput = {
  autoShapeId: Scalars['UUID'];
  options: ExternalWallFinishes3DOptions;
  projectId: Scalars['UUID'];
  tenant: Scalars['String'];
};

export type ExternalWallFinishes3DOptions = {
  elements: Array<ElementWithProperties>;
  globalOffset: Point3;
  modelId: Scalars['UUID'];
};

export type ExternalWallFinishes3DResponse = {
  __typename?: 'ExternalWallFinishes3DResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ExtrudedPolygon = Node & {
  __typename?: 'ExtrudedPolygon';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  multipolygon: MultiPolygon3Type;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  plane: PlaneType;
  /** Reads a single `Shape` that is related to this `ExtrudedPolygon`. */
  shape?: Maybe<Shape>;
  shapeId: Scalars['UUID'];
  thickness: Scalars['Float'];
  unitScale: Scalars['Float'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ExtrudedPolygon` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExtrudedPolygonCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `multipolygon` field. */
  multipolygon?: InputMaybe<MultiPolygon3TypeInput>;
  /** Checks for equality with the object’s `plane` field. */
  plane?: InputMaybe<PlaneTypeInput>;
  /** Checks for equality with the object’s `shapeId` field. */
  shapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `thickness` field. */
  thickness?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `unitScale` field. */
  unitScale?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `extrudedPolygon` to look up the row to connect. */
export type ExtrudedPolygonExtrudedPolygonsPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `extrudedPolygon` to look up the row to delete. */
export type ExtrudedPolygonExtrudedPolygonsPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `extrudedPolygon` to look up the row to connect. */
export type ExtrudedPolygonExtrudedPolygonsShapeIdKeyConnect = {
  shapeId: Scalars['UUID'];
};

/** The fields on `extrudedPolygon` to look up the row to delete. */
export type ExtrudedPolygonExtrudedPolygonsShapeIdKeyDelete = {
  shapeId: Scalars['UUID'];
};

/** A filter to be used against `ExtrudedPolygon` object types. All fields are combined with a logical ‘and.’ */
export type ExtrudedPolygonFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExtrudedPolygonFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExtrudedPolygonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExtrudedPolygonFilter>>;
  /** Filter by the object’s `plane` field. */
  plane?: InputMaybe<PlaneTypeFilter>;
  /** Filter by the object’s `shapeId` field. */
  shapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `thickness` field. */
  thickness?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `unitScale` field. */
  unitScale?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ExtrudedPolygon` */
export type ExtrudedPolygonInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon: MultiPolygon3TypeInput;
  plane: PlaneTypeInput;
  shape?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  thickness: Scalars['Float'];
  unitScale: Scalars['Float'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ExtrudedPolygonNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `extrudedPolygon` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ExtrudedPolygonNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `extrudedPolygon` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `extrudedPolygon` to look up the row to update. */
export type ExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingExtrudedPolygonsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `extrudedPolygon` being updated. */
  patch: UpdateExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyPatch;
};

/** The fields on `extrudedPolygon` to look up the row to update. */
export type ExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingExtrudedPolygonsShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `extrudedPolygon` being updated. */
  patch: UpdateExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyPatch;
  shapeId: Scalars['UUID'];
};

/** Represents an update to a `ExtrudedPolygon`. Fields that are set will be updated. */
export type ExtrudedPolygonPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon?: InputMaybe<MultiPolygon3TypeInput>;
  plane?: InputMaybe<PlaneTypeInput>;
  shape?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  thickness?: InputMaybe<Scalars['Float']>;
  unitScale?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ExtrudedPolygon` values. */
export type ExtrudedPolygonsConnection = {
  __typename?: 'ExtrudedPolygonsConnection';
  /** A list of edges which contains the `ExtrudedPolygon` and cursor to aid in pagination. */
  edges: Array<ExtrudedPolygonsEdge>;
  /** A list of `ExtrudedPolygon` objects. */
  nodes: Array<ExtrudedPolygon>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExtrudedPolygon` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExtrudedPolygon` edge in the connection. */
export type ExtrudedPolygonsEdge = {
  __typename?: 'ExtrudedPolygonsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExtrudedPolygon` at the end of the edge. */
  node: ExtrudedPolygon;
};

/** Methods to use when ordering `ExtrudedPolygon`. */
export enum ExtrudedPolygonsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MultipolygonAsc = 'MULTIPOLYGON_ASC',
  MultipolygonDesc = 'MULTIPOLYGON_DESC',
  Natural = 'NATURAL',
  PlaneAsc = 'PLANE_ASC',
  PlaneDesc = 'PLANE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShapeIdAsc = 'SHAPE_ID_ASC',
  ShapeIdDesc = 'SHAPE_ID_DESC',
  ThicknessAsc = 'THICKNESS_ASC',
  ThicknessDesc = 'THICKNESS_DESC',
  UnitScaleAsc = 'UNIT_SCALE_ASC',
  UnitScaleDesc = 'UNIT_SCALE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The `extrudedPolygon` to be created by this mutation. */
export type ExtrudedPolygonsShapeIdFkeyExtrudedPolygonsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon: MultiPolygon3TypeInput;
  plane: PlaneTypeInput;
  shape?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  thickness: Scalars['Float'];
  unitScale: Scalars['Float'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `shape` in the `ExtrudedPolygonInput` mutation. */
export type ExtrudedPolygonsShapeIdFkeyInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<ShapeShapesPkeyConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapeNodeIdConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbConnect>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExtrudedPolygonsShapeIdFkeyShapesCreateInput>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapeShapesPkeyDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapeNodeIdDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<ShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<ShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `extrudedPolygon` in the `ShapeInput` mutation. */
export type ExtrudedPolygonsShapeIdFkeyInverseInput = {
  /** The primary key(s) for `extrudedPolygon` for the far side of the relationship. */
  connectById?: InputMaybe<ExtrudedPolygonExtrudedPolygonsPkeyConnect>;
  /** The primary key(s) for `extrudedPolygon` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ExtrudedPolygonNodeIdConnect>;
  /** The primary key(s) for `extrudedPolygon` for the far side of the relationship. */
  connectByShapeId?: InputMaybe<ExtrudedPolygonExtrudedPolygonsShapeIdKeyConnect>;
  /** A `ExtrudedPolygonInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExtrudedPolygonsShapeIdFkeyExtrudedPolygonsCreateInput>>;
  /** The primary key(s) for `extrudedPolygon` for the far side of the relationship. */
  deleteById?: InputMaybe<ExtrudedPolygonExtrudedPolygonsPkeyDelete>;
  /** The primary key(s) for `extrudedPolygon` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ExtrudedPolygonNodeIdDelete>;
  /** The primary key(s) for `extrudedPolygon` for the far side of the relationship. */
  deleteByShapeId?: InputMaybe<ExtrudedPolygonExtrudedPolygonsShapeIdKeyDelete>;
  /** Flag indicating whether all other `extrudedPolygon` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `extrudedPolygon` for the far side of the relationship. */
  updateById?: InputMaybe<ExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingExtrudedPolygonsPkeyUpdate>;
  /** The primary key(s) and patch data for `extrudedPolygon` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `extrudedPolygon` for the far side of the relationship. */
  updateByShapeId?: InputMaybe<ExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingExtrudedPolygonsShapeIdKeyUpdate>;
};

/** The `shape` to be created by this mutation. */
export type ExtrudedPolygonsShapeIdFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** All input for the `flattenSubrows` mutation. */
export type FlattenSubrowsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  subrows: Array<InputMaybe<ResolvedSubrowInput>>;
  theOrderEntryId: Scalars['UUID'];
};

/** The output of our `flattenSubrows` mutation. */
export type FlattenSubrowsPayload = {
  __typename?: 'FlattenSubrowsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  orderEntries?: Maybe<Array<OrderEntry>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/** Flow definitions: automation chains with triggers and actions */
export type Flow = Node & {
  __typename?: 'Flow';
  /** Reads a single `Contractor` that is related to this `Flow`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `FlowAction`. */
  flowActions: Array<FlowAction>;
  /** Reads and enables pagination through a set of `FlowAction`. */
  flowActionsConnection: FlowActionsConnection;
  /** Reads and enables pagination through a set of `FlowExecution`. */
  flowExecutions: Array<FlowExecution>;
  /** Reads and enables pagination through a set of `FlowExecution`. */
  flowExecutionsConnection: FlowExecutionsConnection;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  triggerConfig: Scalars['JSON'];
  triggerType: FlowTriggerType;
  updatedAt: Scalars['Datetime'];
};


/** Flow definitions: automation chains with triggers and actions */
export type FlowFlowActionsArgs = {
  condition?: InputMaybe<FlowActionCondition>;
  filter?: InputMaybe<FlowActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};


/** Flow definitions: automation chains with triggers and actions */
export type FlowFlowActionsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowActionCondition>;
  filter?: InputMaybe<FlowActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};


/** Flow definitions: automation chains with triggers and actions */
export type FlowFlowExecutionsArgs = {
  condition?: InputMaybe<FlowExecutionCondition>;
  filter?: InputMaybe<FlowExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};


/** Flow definitions: automation chains with triggers and actions */
export type FlowFlowExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowExecutionCondition>;
  filter?: InputMaybe<FlowExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};

/** Ordered actions within a flow */
export type FlowAction = Node & {
  __typename?: 'FlowAction';
  actionConfig: Scalars['JSON'];
  actionType: FlowActionType;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Flow` that is related to this `FlowAction`. */
  flow?: Maybe<Flow>;
  /** Reads and enables pagination through a set of `FlowAction`. */
  flowActionsByParentLoopActionId: Array<FlowAction>;
  /** Reads and enables pagination through a set of `FlowAction`. */
  flowActionsByParentLoopActionIdConnection: FlowActionsConnection;
  flowId: Scalars['UUID'];
  id: Scalars['UUID'];
  loopConfig?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  outputKey?: Maybe<Scalars['String']>;
  /** Reads a single `FlowAction` that is related to this `FlowAction`. */
  parentLoopAction?: Maybe<FlowAction>;
  parentLoopActionId?: Maybe<Scalars['UUID']>;
  position: Scalars['Int'];
};


/** Ordered actions within a flow */
export type FlowActionFlowActionsByParentLoopActionIdArgs = {
  condition?: InputMaybe<FlowActionCondition>;
  filter?: InputMaybe<FlowActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};


/** Ordered actions within a flow */
export type FlowActionFlowActionsByParentLoopActionIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowActionCondition>;
  filter?: InputMaybe<FlowActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};

/**
 * A condition to be used against `FlowAction` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FlowActionCondition = {
  /** Checks for equality with the object’s `actionConfig` field. */
  actionConfig?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `actionType` field. */
  actionType?: InputMaybe<FlowActionType>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `flowId` field. */
  flowId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `loopConfig` field. */
  loopConfig?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `outputKey` field. */
  outputKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentLoopActionId` field. */
  parentLoopActionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `FlowAction` object types. All fields are combined with a logical ‘and.’ */
export type FlowActionFilter = {
  /** Filter by the object’s `actionConfig` field. */
  actionConfig?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `actionType` field. */
  actionType?: InputMaybe<FlowActionTypeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowActionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `flowId` field. */
  flowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `loopConfig` field. */
  loopConfig?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowActionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowActionFilter>>;
  /** Filter by the object’s `outputKey` field. */
  outputKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `parentLoopActionId` field. */
  parentLoopActionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<IntFilter>;
};

/** The fields on `flowAction` to look up the row to connect. */
export type FlowActionFlowActionsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `flowAction` to look up the row to delete. */
export type FlowActionFlowActionsPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FlowAction` */
export type FlowActionInput = {
  actionConfig?: InputMaybe<Scalars['JSON']>;
  actionType: FlowActionType;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flow?: InputMaybe<FlowActionsFlowIdFkeyInput>;
  flowAction?: InputMaybe<FlowActionsParentLoopActionIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  loopConfig?: InputMaybe<Scalars['JSON']>;
  outputKey?: InputMaybe<Scalars['String']>;
  parentLoopActionId?: InputMaybe<Scalars['UUID']>;
  position: Scalars['Int'];
};

/** The globally unique `ID` look up for the row to connect. */
export type FlowActionNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `flowAction` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FlowActionNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `flowAction` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type FlowActionOnFlowActionForFlowActionsFlowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flow` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flow` being updated. */
  patch: FlowPatch;
};

/** The fields on `flowAction` to look up the row to update. */
export type FlowActionOnFlowActionForFlowActionsFlowIdFkeyUsingFlowActionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowAction` being updated. */
  patch: UpdateFlowActionOnFlowActionForFlowActionsFlowIdFkeyPatch;
};

/** The fields on `flowAction` to look up the row to update. */
export type FlowActionOnFlowActionForFlowActionsFlowIdFkeyUsingUniqueFlowActionPositionUpdate = {
  flowId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowAction` being updated. */
  patch: UpdateFlowActionOnFlowActionForFlowActionsFlowIdFkeyPatch;
  position: Scalars['Int'];
};

/** The globally unique `ID` look up for the row to update. */
export type FlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowAction` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowAction` being updated. */
  patch: FlowActionPatch;
};

/** The fields on `flowAction` to look up the row to update. */
export type FlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyUsingFlowActionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowAction` being updated. */
  patch: UpdateFlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyPatch;
};

/** The fields on `flowAction` to look up the row to update. */
export type FlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyUsingUniqueFlowActionPositionUpdate = {
  flowId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowAction` being updated. */
  patch: UpdateFlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyPatch;
  position: Scalars['Int'];
};

/** Represents an update to a `FlowAction`. Fields that are set will be updated. */
export type FlowActionPatch = {
  actionConfig?: InputMaybe<Scalars['JSON']>;
  actionType?: InputMaybe<FlowActionType>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flow?: InputMaybe<FlowActionsFlowIdFkeyInput>;
  flowAction?: InputMaybe<FlowActionsParentLoopActionIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  loopConfig?: InputMaybe<Scalars['JSON']>;
  outputKey?: InputMaybe<Scalars['String']>;
  parentLoopActionId?: InputMaybe<Scalars['UUID']>;
  position?: InputMaybe<Scalars['Int']>;
};

export enum FlowActionType {
  CreateOrder = 'CREATE_ORDER',
  CreateOrderEntry = 'CREATE_ORDER_ENTRY',
  CreateProject = 'CREATE_PROJECT',
  ParseEmail = 'PARSE_EMAIL',
  SendEmail = 'SEND_EMAIL'
}

/** A filter to be used against FlowActionType fields. All fields are combined with a logical ‘and.’ */
export type FlowActionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FlowActionType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FlowActionType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FlowActionType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FlowActionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FlowActionType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FlowActionType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FlowActionType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FlowActionType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FlowActionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FlowActionType>>;
};

/** The fields on `flowAction` to look up the row to connect. */
export type FlowActionUniqueFlowActionPositionConnect = {
  flowId: Scalars['UUID'];
  position: Scalars['Int'];
};

/** The fields on `flowAction` to look up the row to delete. */
export type FlowActionUniqueFlowActionPositionDelete = {
  flowId: Scalars['UUID'];
  position: Scalars['Int'];
};

/** A connection to a list of `FlowAction` values. */
export type FlowActionsConnection = {
  __typename?: 'FlowActionsConnection';
  /** A list of edges which contains the `FlowAction` and cursor to aid in pagination. */
  edges: Array<FlowActionsEdge>;
  /** A list of `FlowAction` objects. */
  nodes: Array<FlowAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlowAction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FlowAction` edge in the connection. */
export type FlowActionsEdge = {
  __typename?: 'FlowActionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FlowAction` at the end of the edge. */
  node: FlowAction;
};

/** The `flowAction` to be created by this mutation. */
export type FlowActionsFlowIdFkeyFlowActionsCreateInput = {
  actionConfig?: InputMaybe<Scalars['JSON']>;
  actionType: FlowActionType;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flow?: InputMaybe<FlowActionsFlowIdFkeyInput>;
  flowAction?: InputMaybe<FlowActionsParentLoopActionIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  loopConfig?: InputMaybe<Scalars['JSON']>;
  outputKey?: InputMaybe<Scalars['String']>;
  parentLoopActionId?: InputMaybe<Scalars['UUID']>;
  position: Scalars['Int'];
};

/** The `flow` to be created by this mutation. */
export type FlowActionsFlowIdFkeyFlowsCreateInput = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType: FlowTriggerType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `flow` in the `FlowActionInput` mutation. */
export type FlowActionsFlowIdFkeyInput = {
  /** The primary key(s) for `flow` for the far side of the relationship. */
  connectById?: InputMaybe<FlowFlowsPkeyConnect>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FlowNodeIdConnect>;
  /** A `FlowInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowActionsFlowIdFkeyFlowsCreateInput>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  deleteById?: InputMaybe<FlowFlowsPkeyDelete>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FlowNodeIdDelete>;
  /** The primary key(s) and patch data for `flow` for the far side of the relationship. */
  updateById?: InputMaybe<FlowOnFlowActionForFlowActionsFlowIdFkeyUsingFlowsPkeyUpdate>;
  /** The primary key(s) and patch data for `flow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowActionOnFlowActionForFlowActionsFlowIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `flowAction` in the `FlowInput` mutation. */
export type FlowActionsFlowIdFkeyInverseInput = {
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  connectByFlowIdAndPosition?: InputMaybe<Array<FlowActionUniqueFlowActionPositionConnect>>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FlowActionFlowActionsPkeyConnect>>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FlowActionNodeIdConnect>>;
  /** A `FlowActionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FlowActionsFlowIdFkeyFlowActionsCreateInput>>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  deleteByFlowIdAndPosition?: InputMaybe<Array<FlowActionUniqueFlowActionPositionDelete>>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FlowActionFlowActionsPkeyDelete>>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FlowActionNodeIdDelete>>;
  /** Flag indicating whether all other `flowAction` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `flowAction` for the far side of the relationship. */
  updateByFlowIdAndPosition?: InputMaybe<Array<FlowActionOnFlowActionForFlowActionsFlowIdFkeyUsingUniqueFlowActionPositionUpdate>>;
  /** The primary key(s) and patch data for `flowAction` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FlowActionOnFlowActionForFlowActionsFlowIdFkeyUsingFlowActionsPkeyUpdate>>;
  /** The primary key(s) and patch data for `flowAction` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<FlowOnFlowActionForFlowActionsFlowIdFkeyNodeIdUpdate>>;
};

/** Methods to use when ordering `FlowAction`. */
export enum FlowActionsOrderBy {
  ActionConfigAsc = 'ACTION_CONFIG_ASC',
  ActionConfigDesc = 'ACTION_CONFIG_DESC',
  ActionTypeAsc = 'ACTION_TYPE_ASC',
  ActionTypeDesc = 'ACTION_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FlowIdAsc = 'FLOW_ID_ASC',
  FlowIdDesc = 'FLOW_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LoopConfigAsc = 'LOOP_CONFIG_ASC',
  LoopConfigDesc = 'LOOP_CONFIG_DESC',
  Natural = 'NATURAL',
  OutputKeyAsc = 'OUTPUT_KEY_ASC',
  OutputKeyDesc = 'OUTPUT_KEY_DESC',
  ParentLoopActionIdAsc = 'PARENT_LOOP_ACTION_ID_ASC',
  ParentLoopActionIdDesc = 'PARENT_LOOP_ACTION_ID_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The `flowAction` to be created by this mutation. */
export type FlowActionsParentLoopActionIdFkeyFlowActionsCreateInput = {
  actionConfig?: InputMaybe<Scalars['JSON']>;
  actionType: FlowActionType;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flow?: InputMaybe<FlowActionsFlowIdFkeyInput>;
  flowAction?: InputMaybe<FlowActionsParentLoopActionIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  loopConfig?: InputMaybe<Scalars['JSON']>;
  outputKey?: InputMaybe<Scalars['String']>;
  parentLoopActionId?: InputMaybe<Scalars['UUID']>;
  position: Scalars['Int'];
};

/** Input for the nested mutation of `flowAction` in the `FlowActionInput` mutation. */
export type FlowActionsParentLoopActionIdFkeyInput = {
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  connectByFlowIdAndPosition?: InputMaybe<FlowActionUniqueFlowActionPositionConnect>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  connectById?: InputMaybe<FlowActionFlowActionsPkeyConnect>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FlowActionNodeIdConnect>;
  /** A `FlowActionInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowActionsParentLoopActionIdFkeyFlowActionsCreateInput>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  deleteByFlowIdAndPosition?: InputMaybe<FlowActionUniqueFlowActionPositionDelete>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  deleteById?: InputMaybe<FlowActionFlowActionsPkeyDelete>;
  /** The primary key(s) for `flowAction` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FlowActionNodeIdDelete>;
  /** The primary key(s) and patch data for `flowAction` for the far side of the relationship. */
  updateByFlowIdAndPosition?: InputMaybe<FlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyUsingUniqueFlowActionPositionUpdate>;
  /** The primary key(s) and patch data for `flowAction` for the far side of the relationship. */
  updateById?: InputMaybe<FlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyUsingFlowActionsPkeyUpdate>;
  /** The primary key(s) and patch data for `flowAction` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyNodeIdUpdate>;
};

/** A condition to be used against `Flow` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FlowCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `triggerConfig` field. */
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `triggerType` field. */
  triggerType?: InputMaybe<FlowTriggerType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Individual flow execution runs with status and rollback data */
export type FlowExecution = Node & {
  __typename?: 'FlowExecution';
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  createdResources: Scalars['JSON'];
  currentActionPosition?: Maybe<Scalars['Int']>;
  errorActionPosition?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** Reads a single `Flow` that is related to this `FlowExecution`. */
  flow?: Maybe<Flow>;
  flowId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `FlowMailboxMessage`. */
  flowMailboxMessages: Array<FlowMailboxMessage>;
  /** Reads and enables pagination through a set of `FlowMailboxMessage`. */
  flowMailboxMessagesConnection: FlowMailboxMessagesConnection;
  id: Scalars['UUID'];
  inputData: Scalars['JSON'];
  lambdaRequestId?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  outputData: Scalars['JSON'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: FlowExecutionStatus;
};


/** Individual flow execution runs with status and rollback data */
export type FlowExecutionFlowMailboxMessagesArgs = {
  condition?: InputMaybe<FlowMailboxMessageCondition>;
  filter?: InputMaybe<FlowMailboxMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};


/** Individual flow execution runs with status and rollback data */
export type FlowExecutionFlowMailboxMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowMailboxMessageCondition>;
  filter?: InputMaybe<FlowMailboxMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};

/**
 * A condition to be used against `FlowExecution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FlowExecutionCondition = {
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdResources` field. */
  createdResources?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `currentActionPosition` field. */
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `errorActionPosition` field. */
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `flowId` field. */
  flowId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inputData` field. */
  inputData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `lambdaRequestId` field. */
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `outputData` field. */
  outputData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<FlowExecutionStatus>;
};

/** A filter to be used against `FlowExecution` object types. All fields are combined with a logical ‘and.’ */
export type FlowExecutionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowExecutionFilter>>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdResources` field. */
  createdResources?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `currentActionPosition` field. */
  currentActionPosition?: InputMaybe<IntFilter>;
  /** Filter by the object’s `errorActionPosition` field. */
  errorActionPosition?: InputMaybe<IntFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flowId` field. */
  flowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inputData` field. */
  inputData?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `lambdaRequestId` field. */
  lambdaRequestId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowExecutionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowExecutionFilter>>;
  /** Filter by the object’s `outputData` field. */
  outputData?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<FlowExecutionStatusFilter>;
};

/** The fields on `flowExecution` to look up the row to connect. */
export type FlowExecutionFlowExecutionsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `flowExecution` to look up the row to delete. */
export type FlowExecutionFlowExecutionsPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FlowExecution` */
export type FlowExecutionInput = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdResources?: InputMaybe<Scalars['JSON']>;
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<FlowExecutionsFlowIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  outputData?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<FlowExecutionStatus>;
};

/** The globally unique `ID` look up for the row to connect. */
export type FlowExecutionNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `flowExecution` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FlowExecutionNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `flowExecution` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type FlowExecutionOnFlowExecutionForFlowExecutionsFlowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flow` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flow` being updated. */
  patch: FlowPatch;
};

/** The fields on `flowExecution` to look up the row to update. */
export type FlowExecutionOnFlowExecutionForFlowExecutionsFlowIdFkeyUsingFlowExecutionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowExecution` being updated. */
  patch: UpdateFlowExecutionOnFlowExecutionForFlowExecutionsFlowIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type FlowExecutionOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowMailboxMessage` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowMailboxMessage` being updated. */
  patch: FlowMailboxMessagePatch;
};

/** The fields on `flowExecution` to look up the row to update. */
export type FlowExecutionOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyUsingFlowExecutionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowExecution` being updated. */
  patch: UpdateFlowExecutionOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyPatch;
};

/** Represents an update to a `FlowExecution`. Fields that are set will be updated. */
export type FlowExecutionPatch = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdResources?: InputMaybe<Scalars['JSON']>;
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<FlowExecutionsFlowIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  outputData?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<FlowExecutionStatus>;
};

export enum FlowExecutionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RolledBack = 'ROLLED_BACK',
  Running = 'RUNNING'
}

/** A filter to be used against FlowExecutionStatus fields. All fields are combined with a logical ‘and.’ */
export type FlowExecutionStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FlowExecutionStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FlowExecutionStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FlowExecutionStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FlowExecutionStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FlowExecutionStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FlowExecutionStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FlowExecutionStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FlowExecutionStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FlowExecutionStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FlowExecutionStatus>>;
};

/** A connection to a list of `FlowExecution` values. */
export type FlowExecutionsConnection = {
  __typename?: 'FlowExecutionsConnection';
  /** A list of edges which contains the `FlowExecution` and cursor to aid in pagination. */
  edges: Array<FlowExecutionsEdge>;
  /** A list of `FlowExecution` objects. */
  nodes: Array<FlowExecution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlowExecution` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FlowExecution` edge in the connection. */
export type FlowExecutionsEdge = {
  __typename?: 'FlowExecutionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FlowExecution` at the end of the edge. */
  node: FlowExecution;
};

/** The `flowExecution` to be created by this mutation. */
export type FlowExecutionsFlowIdFkeyFlowExecutionsCreateInput = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdResources?: InputMaybe<Scalars['JSON']>;
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<FlowExecutionsFlowIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  outputData?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<FlowExecutionStatus>;
};

/** The `flow` to be created by this mutation. */
export type FlowExecutionsFlowIdFkeyFlowsCreateInput = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType: FlowTriggerType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `flow` in the `FlowExecutionInput` mutation. */
export type FlowExecutionsFlowIdFkeyInput = {
  /** The primary key(s) for `flow` for the far side of the relationship. */
  connectById?: InputMaybe<FlowFlowsPkeyConnect>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FlowNodeIdConnect>;
  /** A `FlowInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowExecutionsFlowIdFkeyFlowsCreateInput>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  deleteById?: InputMaybe<FlowFlowsPkeyDelete>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FlowNodeIdDelete>;
  /** The primary key(s) and patch data for `flow` for the far side of the relationship. */
  updateById?: InputMaybe<FlowOnFlowExecutionForFlowExecutionsFlowIdFkeyUsingFlowsPkeyUpdate>;
  /** The primary key(s) and patch data for `flow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowExecutionOnFlowExecutionForFlowExecutionsFlowIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `flowExecution` in the `FlowInput` mutation. */
export type FlowExecutionsFlowIdFkeyInverseInput = {
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FlowExecutionFlowExecutionsPkeyConnect>>;
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FlowExecutionNodeIdConnect>>;
  /** A `FlowExecutionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FlowExecutionsFlowIdFkeyFlowExecutionsCreateInput>>;
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FlowExecutionFlowExecutionsPkeyDelete>>;
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FlowExecutionNodeIdDelete>>;
  /** Flag indicating whether all other `flowExecution` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `flowExecution` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FlowExecutionOnFlowExecutionForFlowExecutionsFlowIdFkeyUsingFlowExecutionsPkeyUpdate>>;
  /** The primary key(s) and patch data for `flowExecution` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<FlowOnFlowExecutionForFlowExecutionsFlowIdFkeyNodeIdUpdate>>;
};

/** Methods to use when ordering `FlowExecution`. */
export enum FlowExecutionsOrderBy {
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedResourcesAsc = 'CREATED_RESOURCES_ASC',
  CreatedResourcesDesc = 'CREATED_RESOURCES_DESC',
  CurrentActionPositionAsc = 'CURRENT_ACTION_POSITION_ASC',
  CurrentActionPositionDesc = 'CURRENT_ACTION_POSITION_DESC',
  ErrorActionPositionAsc = 'ERROR_ACTION_POSITION_ASC',
  ErrorActionPositionDesc = 'ERROR_ACTION_POSITION_DESC',
  ErrorMessageAsc = 'ERROR_MESSAGE_ASC',
  ErrorMessageDesc = 'ERROR_MESSAGE_DESC',
  FlowIdAsc = 'FLOW_ID_ASC',
  FlowIdDesc = 'FLOW_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InputDataAsc = 'INPUT_DATA_ASC',
  InputDataDesc = 'INPUT_DATA_DESC',
  LambdaRequestIdAsc = 'LAMBDA_REQUEST_ID_ASC',
  LambdaRequestIdDesc = 'LAMBDA_REQUEST_ID_DESC',
  Natural = 'NATURAL',
  OutputDataAsc = 'OUTPUT_DATA_ASC',
  OutputDataDesc = 'OUTPUT_DATA_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** A filter to be used against `Flow` object types. All fields are combined with a logical ‘and.’ */
export type FlowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowFilter>>;
  /** Filter by the object’s `triggerConfig` field. */
  triggerConfig?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `triggerType` field. */
  triggerType?: InputMaybe<FlowTriggerTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `flow` to look up the row to connect. */
export type FlowFlowsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `flow` to look up the row to delete. */
export type FlowFlowsPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `Flow` */
export type FlowInput = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType: FlowTriggerType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Tenant-specific email mailboxes for Sparkel Flows. Each tenant can have one mailbox that can receive and send emails. */
export type FlowMailbox = Node & {
  __typename?: 'FlowMailbox';
  /** Reads a single `Contractor` that is related to this `FlowMailbox`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  /** Reads and enables pagination through a set of `FlowMailboxMessage`. */
  flowMailboxMessagesByMailboxId: Array<FlowMailboxMessage>;
  /** Reads and enables pagination through a set of `FlowMailboxMessage`. */
  flowMailboxMessagesByMailboxIdConnection: FlowMailboxMessagesConnection;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};


/** Tenant-specific email mailboxes for Sparkel Flows. Each tenant can have one mailbox that can receive and send emails. */
export type FlowMailboxFlowMailboxMessagesByMailboxIdArgs = {
  condition?: InputMaybe<FlowMailboxMessageCondition>;
  filter?: InputMaybe<FlowMailboxMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};


/** Tenant-specific email mailboxes for Sparkel Flows. Each tenant can have one mailbox that can receive and send emails. */
export type FlowMailboxFlowMailboxMessagesByMailboxIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowMailboxMessageCondition>;
  filter?: InputMaybe<FlowMailboxMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};

/**
 * A condition to be used against `FlowMailbox` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FlowMailboxCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `emailDomain` field. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `emailLocalPart` field. */
  emailLocalPart?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `FlowMailbox` object types. All fields are combined with a logical ‘and.’ */
export type FlowMailboxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowMailboxFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailDomain` field. */
  emailDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailLocalPart` field. */
  emailLocalPart?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowMailboxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowMailboxFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `flowMailbox` to look up the row to connect. */
export type FlowMailboxFlowMailboxesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `flowMailbox` to look up the row to delete. */
export type FlowMailboxFlowMailboxesPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FlowMailbox` */
export type FlowMailboxInput = {
  contractor?: InputMaybe<FlowMailboxesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Audit log of all emails sent and received through flow mailboxes. */
export type FlowMailboxMessage = Node & {
  __typename?: 'FlowMailboxMessage';
  ccAddresses?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Datetime'];
  direction: Scalars['String'];
  /** Reads a single `FlowExecution` that is related to this `FlowMailboxMessage`. */
  flowExecution?: Maybe<FlowExecution>;
  flowExecutionId?: Maybe<Scalars['UUID']>;
  fromAddress: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads a single `FlowMailbox` that is related to this `FlowMailboxMessage`. */
  mailbox?: Maybe<FlowMailbox>;
  mailboxId: Scalars['UUID'];
  messageId?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  receivedAt?: Maybe<Scalars['Datetime']>;
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Datetime']>;
  subject?: Maybe<Scalars['String']>;
  toAddresses: Array<Scalars['String']>;
};

/**
 * A condition to be used against `FlowMailboxMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FlowMailboxMessageCondition = {
  /** Checks for equality with the object’s `ccAddresses` field. */
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `direction` field. */
  direction?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `flowExecutionId` field. */
  flowExecutionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fromAddress` field. */
  fromAddress?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mailboxId` field. */
  mailboxId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `receivedAt` field. */
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `s3Bucket` field. */
  s3Bucket?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `s3Key` field. */
  s3Key?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sentAt` field. */
  sentAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `toAddresses` field. */
  toAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A filter to be used against `FlowMailboxMessage` object types. All fields are combined with a logical ‘and.’ */
export type FlowMailboxMessageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowMailboxMessageFilter>>;
  /** Filter by the object’s `ccAddresses` field. */
  ccAddresses?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `direction` field. */
  direction?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flowExecutionId` field. */
  flowExecutionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fromAddress` field. */
  fromAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mailboxId` field. */
  mailboxId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `messageId` field. */
  messageId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowMailboxMessageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowMailboxMessageFilter>>;
  /** Filter by the object’s `receivedAt` field. */
  receivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `s3Bucket` field. */
  s3Bucket?: InputMaybe<StringFilter>;
  /** Filter by the object’s `s3Key` field. */
  s3Key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sentAt` field. */
  sentAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toAddresses` field. */
  toAddresses?: InputMaybe<StringListFilter>;
};

/** The fields on `flowMailboxMessage` to look up the row to connect. */
export type FlowMailboxMessageFlowMailboxMessagesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `flowMailboxMessage` to look up the row to delete. */
export type FlowMailboxMessageFlowMailboxMessagesPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FlowMailboxMessage` */
export type FlowMailboxMessageInput = {
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  direction: Scalars['String'];
  flowExecution?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInput>;
  flowExecutionId?: InputMaybe<Scalars['UUID']>;
  flowMailbox?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInput>;
  fromAddress: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  mailboxId?: InputMaybe<Scalars['UUID']>;
  messageId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses: Array<InputMaybe<Scalars['String']>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type FlowMailboxMessageNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `flowMailboxMessage` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FlowMailboxMessageNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `flowMailboxMessage` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowExecution` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowExecution` being updated. */
  patch: FlowExecutionPatch;
};

/** The fields on `flowMailboxMessage` to look up the row to update. */
export type FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyUsingFlowMailboxMessagesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowMailboxMessage` being updated. */
  patch: UpdateFlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowMailbox` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: FlowMailboxPatch;
};

/** The fields on `flowMailboxMessage` to look up the row to update. */
export type FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingFlowMailboxMessagesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowMailboxMessage` being updated. */
  patch: UpdateFlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyPatch;
};

/** Represents an update to a `FlowMailboxMessage`. Fields that are set will be updated. */
export type FlowMailboxMessagePatch = {
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  direction?: InputMaybe<Scalars['String']>;
  flowExecution?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInput>;
  flowExecutionId?: InputMaybe<Scalars['UUID']>;
  flowMailbox?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInput>;
  fromAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mailboxId?: InputMaybe<Scalars['UUID']>;
  messageId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A connection to a list of `FlowMailboxMessage` values. */
export type FlowMailboxMessagesConnection = {
  __typename?: 'FlowMailboxMessagesConnection';
  /** A list of edges which contains the `FlowMailboxMessage` and cursor to aid in pagination. */
  edges: Array<FlowMailboxMessagesEdge>;
  /** A list of `FlowMailboxMessage` objects. */
  nodes: Array<FlowMailboxMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlowMailboxMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FlowMailboxMessage` edge in the connection. */
export type FlowMailboxMessagesEdge = {
  __typename?: 'FlowMailboxMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FlowMailboxMessage` at the end of the edge. */
  node: FlowMailboxMessage;
};

/** The `flowExecution` to be created by this mutation. */
export type FlowMailboxMessagesFlowExecutionIdFkeyFlowExecutionsCreateInput = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdResources?: InputMaybe<Scalars['JSON']>;
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<FlowExecutionsFlowIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  outputData?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<FlowExecutionStatus>;
};

/** The `flowMailboxMessage` to be created by this mutation. */
export type FlowMailboxMessagesFlowExecutionIdFkeyFlowMailboxMessagesCreateInput = {
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  direction: Scalars['String'];
  flowExecution?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInput>;
  flowExecutionId?: InputMaybe<Scalars['UUID']>;
  flowMailbox?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInput>;
  fromAddress: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  mailboxId?: InputMaybe<Scalars['UUID']>;
  messageId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses: Array<InputMaybe<Scalars['String']>>;
};

/** Input for the nested mutation of `flowExecution` in the `FlowMailboxMessageInput` mutation. */
export type FlowMailboxMessagesFlowExecutionIdFkeyInput = {
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  connectById?: InputMaybe<FlowExecutionFlowExecutionsPkeyConnect>;
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FlowExecutionNodeIdConnect>;
  /** A `FlowExecutionInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyFlowExecutionsCreateInput>;
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  deleteById?: InputMaybe<FlowExecutionFlowExecutionsPkeyDelete>;
  /** The primary key(s) for `flowExecution` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FlowExecutionNodeIdDelete>;
  /** The primary key(s) and patch data for `flowExecution` for the far side of the relationship. */
  updateById?: InputMaybe<FlowExecutionOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyUsingFlowExecutionsPkeyUpdate>;
  /** The primary key(s) and patch data for `flowExecution` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `flowMailboxMessage` in the `FlowExecutionInput` mutation. */
export type FlowMailboxMessagesFlowExecutionIdFkeyInverseInput = {
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FlowMailboxMessageFlowMailboxMessagesPkeyConnect>>;
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FlowMailboxMessageNodeIdConnect>>;
  /** A `FlowMailboxMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FlowMailboxMessagesFlowExecutionIdFkeyFlowMailboxMessagesCreateInput>>;
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FlowMailboxMessageFlowMailboxMessagesPkeyDelete>>;
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FlowMailboxMessageNodeIdDelete>>;
  /** Flag indicating whether all other `flowMailboxMessage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `flowMailboxMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyUsingFlowMailboxMessagesPkeyUpdate>>;
  /** The primary key(s) and patch data for `flowMailboxMessage` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<FlowExecutionOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyNodeIdUpdate>>;
};

/** The `flowMailboxMessage` to be created by this mutation. */
export type FlowMailboxMessagesMailboxIdFkeyFlowMailboxMessagesCreateInput = {
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  direction: Scalars['String'];
  flowExecution?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInput>;
  flowExecutionId?: InputMaybe<Scalars['UUID']>;
  flowMailbox?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInput>;
  fromAddress: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  mailboxId?: InputMaybe<Scalars['UUID']>;
  messageId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses: Array<InputMaybe<Scalars['String']>>;
};

/** The `flowMailbox` to be created by this mutation. */
export type FlowMailboxMessagesMailboxIdFkeyFlowMailboxesCreateInput = {
  contractor?: InputMaybe<FlowMailboxesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `flowMailbox` in the `FlowMailboxMessageInput` mutation. */
export type FlowMailboxMessagesMailboxIdFkeyInput = {
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectByContractorId?: InputMaybe<FlowMailboxUniqueContractorMailboxConnect>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectByEmailLocalPartAndEmailDomain?: InputMaybe<FlowMailboxUniqueEmailAddressConnect>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectById?: InputMaybe<FlowMailboxFlowMailboxesPkeyConnect>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FlowMailboxNodeIdConnect>;
  /** A `FlowMailboxInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyFlowMailboxesCreateInput>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteByContractorId?: InputMaybe<FlowMailboxUniqueContractorMailboxDelete>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteByEmailLocalPartAndEmailDomain?: InputMaybe<FlowMailboxUniqueEmailAddressDelete>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteById?: InputMaybe<FlowMailboxFlowMailboxesPkeyDelete>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FlowMailboxNodeIdDelete>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateByContractorId?: InputMaybe<FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingUniqueContractorMailboxUpdate>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateByEmailLocalPartAndEmailDomain?: InputMaybe<FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingUniqueEmailAddressUpdate>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateById?: InputMaybe<FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingFlowMailboxesPkeyUpdate>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `flowMailboxMessage` in the `FlowMailboxInput` mutation. */
export type FlowMailboxMessagesMailboxIdFkeyInverseInput = {
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FlowMailboxMessageFlowMailboxMessagesPkeyConnect>>;
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FlowMailboxMessageNodeIdConnect>>;
  /** A `FlowMailboxMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FlowMailboxMessagesMailboxIdFkeyFlowMailboxMessagesCreateInput>>;
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FlowMailboxMessageFlowMailboxMessagesPkeyDelete>>;
  /** The primary key(s) for `flowMailboxMessage` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FlowMailboxMessageNodeIdDelete>>;
  /** Flag indicating whether all other `flowMailboxMessage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `flowMailboxMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingFlowMailboxMessagesPkeyUpdate>>;
  /** The primary key(s) and patch data for `flowMailboxMessage` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyNodeIdUpdate>>;
};

/** Methods to use when ordering `FlowMailboxMessage`. */
export enum FlowMailboxMessagesOrderBy {
  CcAddressesAsc = 'CC_ADDRESSES_ASC',
  CcAddressesDesc = 'CC_ADDRESSES_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DirectionAsc = 'DIRECTION_ASC',
  DirectionDesc = 'DIRECTION_DESC',
  FlowExecutionIdAsc = 'FLOW_EXECUTION_ID_ASC',
  FlowExecutionIdDesc = 'FLOW_EXECUTION_ID_DESC',
  FromAddressAsc = 'FROM_ADDRESS_ASC',
  FromAddressDesc = 'FROM_ADDRESS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MailboxIdAsc = 'MAILBOX_ID_ASC',
  MailboxIdDesc = 'MAILBOX_ID_DESC',
  MessageIdAsc = 'MESSAGE_ID_ASC',
  MessageIdDesc = 'MESSAGE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReceivedAtAsc = 'RECEIVED_AT_ASC',
  ReceivedAtDesc = 'RECEIVED_AT_DESC',
  S3BucketAsc = 'S3_BUCKET_ASC',
  S3BucketDesc = 'S3_BUCKET_DESC',
  S3KeyAsc = 'S3_KEY_ASC',
  S3KeyDesc = 'S3_KEY_DESC',
  SentAtAsc = 'SENT_AT_ASC',
  SentAtDesc = 'SENT_AT_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  ToAddressesAsc = 'TO_ADDRESSES_ASC',
  ToAddressesDesc = 'TO_ADDRESSES_DESC'
}

/** The globally unique `ID` look up for the row to connect. */
export type FlowMailboxNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `flowMailbox` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FlowMailboxNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `flowMailbox` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `flowMailbox` to look up the row to update. */
export type FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingFlowMailboxesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: UpdateFlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch;
};

/** The fields on `flowMailbox` to look up the row to update. */
export type FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingUniqueContractorMailboxUpdate = {
  contractorId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: UpdateFlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch;
};

/** The fields on `flowMailbox` to look up the row to update. */
export type FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingUniqueEmailAddressUpdate = {
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: UpdateFlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowMailboxMessage` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowMailboxMessage` being updated. */
  patch: FlowMailboxMessagePatch;
};

/** The fields on `flowMailbox` to look up the row to update. */
export type FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingFlowMailboxesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: UpdateFlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyPatch;
};

/** The fields on `flowMailbox` to look up the row to update. */
export type FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingUniqueContractorMailboxUpdate = {
  contractorId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: UpdateFlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyPatch;
};

/** The fields on `flowMailbox` to look up the row to update. */
export type FlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyUsingUniqueEmailAddressUpdate = {
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  /** An object where the defined keys will be set on the `flowMailbox` being updated. */
  patch: UpdateFlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyPatch;
};

/** Represents an update to a `FlowMailbox`. Fields that are set will be updated. */
export type FlowMailboxPatch = {
  contractor?: InputMaybe<FlowMailboxesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart?: InputMaybe<Scalars['String']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `flowMailbox` to look up the row to connect. */
export type FlowMailboxUniqueContractorMailboxConnect = {
  contractorId: Scalars['UUID'];
};

/** The fields on `flowMailbox` to look up the row to delete. */
export type FlowMailboxUniqueContractorMailboxDelete = {
  contractorId: Scalars['UUID'];
};

/** The fields on `flowMailbox` to look up the row to connect. */
export type FlowMailboxUniqueEmailAddressConnect = {
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
};

/** The fields on `flowMailbox` to look up the row to delete. */
export type FlowMailboxUniqueEmailAddressDelete = {
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
};

/** A connection to a list of `FlowMailbox` values. */
export type FlowMailboxesConnection = {
  __typename?: 'FlowMailboxesConnection';
  /** A list of edges which contains the `FlowMailbox` and cursor to aid in pagination. */
  edges: Array<FlowMailboxesEdge>;
  /** A list of `FlowMailbox` objects. */
  nodes: Array<FlowMailbox>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlowMailbox` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type FlowMailboxesContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `flowMailbox` to be created by this mutation. */
export type FlowMailboxesContractorIdFkeyFlowMailboxesCreateInput = {
  contractor?: InputMaybe<FlowMailboxesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `FlowMailboxInput` mutation. */
export type FlowMailboxesContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowMailboxesContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `flowMailbox` in the `ContractorInput` mutation. */
export type FlowMailboxesContractorIdFkeyInverseInput = {
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectByContractorId?: InputMaybe<FlowMailboxUniqueContractorMailboxConnect>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectByEmailLocalPartAndEmailDomain?: InputMaybe<FlowMailboxUniqueEmailAddressConnect>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectById?: InputMaybe<FlowMailboxFlowMailboxesPkeyConnect>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FlowMailboxNodeIdConnect>;
  /** A `FlowMailboxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FlowMailboxesContractorIdFkeyFlowMailboxesCreateInput>>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteByContractorId?: InputMaybe<FlowMailboxUniqueContractorMailboxDelete>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteByEmailLocalPartAndEmailDomain?: InputMaybe<FlowMailboxUniqueEmailAddressDelete>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteById?: InputMaybe<FlowMailboxFlowMailboxesPkeyDelete>;
  /** The primary key(s) for `flowMailbox` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FlowMailboxNodeIdDelete>;
  /** Flag indicating whether all other `flowMailbox` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateByContractorId?: InputMaybe<FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingUniqueContractorMailboxUpdate>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateByEmailLocalPartAndEmailDomain?: InputMaybe<FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingUniqueEmailAddressUpdate>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateById?: InputMaybe<FlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyUsingFlowMailboxesPkeyUpdate>;
  /** The primary key(s) and patch data for `flowMailbox` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyNodeIdUpdate>;
};

/** A `FlowMailbox` edge in the connection. */
export type FlowMailboxesEdge = {
  __typename?: 'FlowMailboxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FlowMailbox` at the end of the edge. */
  node: FlowMailbox;
};

/** Methods to use when ordering `FlowMailbox`. */
export enum FlowMailboxesOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailDomainAsc = 'EMAIL_DOMAIN_ASC',
  EmailDomainDesc = 'EMAIL_DOMAIN_DESC',
  EmailLocalPartAsc = 'EMAIL_LOCAL_PART_ASC',
  EmailLocalPartDesc = 'EMAIL_LOCAL_PART_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The globally unique `ID` look up for the row to connect. */
export type FlowNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `flow` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FlowNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `flow` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type FlowOnFlowActionForFlowActionsFlowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowAction` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowAction` being updated. */
  patch: FlowActionPatch;
};

/** The fields on `flow` to look up the row to update. */
export type FlowOnFlowActionForFlowActionsFlowIdFkeyUsingFlowsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flow` being updated. */
  patch: UpdateFlowOnFlowActionForFlowActionsFlowIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type FlowOnFlowExecutionForFlowExecutionsFlowIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `flowExecution` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `flowExecution` being updated. */
  patch: FlowExecutionPatch;
};

/** The fields on `flow` to look up the row to update. */
export type FlowOnFlowExecutionForFlowExecutionsFlowIdFkeyUsingFlowsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flow` being updated. */
  patch: UpdateFlowOnFlowExecutionForFlowExecutionsFlowIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type FlowOnFlowForFlowsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `flow` to look up the row to update. */
export type FlowOnFlowForFlowsContractorIdFkeyUsingFlowsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `flow` being updated. */
  patch: UpdateFlowOnFlowForFlowsContractorIdFkeyPatch;
};

/** Represents an update to a `Flow`. Fields that are set will be updated. */
export type FlowPatch = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType?: InputMaybe<FlowTriggerType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum FlowTriggerType {
  EmailReceived = 'EMAIL_RECEIVED',
  Manual = 'MANUAL',
  Webhook = 'WEBHOOK'
}

/** A filter to be used against FlowTriggerType fields. All fields are combined with a logical ‘and.’ */
export type FlowTriggerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FlowTriggerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FlowTriggerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FlowTriggerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FlowTriggerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FlowTriggerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FlowTriggerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FlowTriggerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FlowTriggerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FlowTriggerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FlowTriggerType>>;
};

/** A connection to a list of `Flow` values. */
export type FlowsConnection = {
  __typename?: 'FlowsConnection';
  /** A list of edges which contains the `Flow` and cursor to aid in pagination. */
  edges: Array<FlowsEdge>;
  /** A list of `Flow` objects. */
  nodes: Array<Flow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Flow` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type FlowsContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `flow` to be created by this mutation. */
export type FlowsContractorIdFkeyFlowsCreateInput = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType: FlowTriggerType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `FlowInput` mutation. */
export type FlowsContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<FlowsContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnFlowForFlowsContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FlowOnFlowForFlowsContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnFlowForFlowsContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `flow` in the `ContractorInput` mutation. */
export type FlowsContractorIdFkeyInverseInput = {
  /** The primary key(s) for `flow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FlowFlowsPkeyConnect>>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FlowNodeIdConnect>>;
  /** A `FlowInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FlowsContractorIdFkeyFlowsCreateInput>>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FlowFlowsPkeyDelete>>;
  /** The primary key(s) for `flow` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FlowNodeIdDelete>>;
  /** Flag indicating whether all other `flow` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `flow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FlowOnFlowForFlowsContractorIdFkeyUsingFlowsPkeyUpdate>>;
  /** The primary key(s) and patch data for `flow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnFlowForFlowsContractorIdFkeyNodeIdUpdate>>;
};

/** A `Flow` edge in the connection. */
export type FlowsEdge = {
  __typename?: 'FlowsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Flow` at the end of the edge. */
  node: Flow;
};

/** Methods to use when ordering `Flow`. */
export enum FlowsOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TriggerConfigAsc = 'TRIGGER_CONFIG_ASC',
  TriggerConfigDesc = 'TRIGGER_CONFIG_DESC',
  TriggerTypeAsc = 'TRIGGER_TYPE_ASC',
  TriggerTypeDesc = 'TRIGGER_TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ForgeAccessToken = {
  __typename?: 'ForgeAccessToken';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
};

export type ForgeAttributePredicateType = {
  __typename?: 'ForgeAttributePredicateType';
  attribute: ForgeAttributeType;
  attributeValues?: Maybe<Array<Scalars['String']>>;
  predicate: PredicateType;
};

/** An input for mutations affecting `ForgeAttributePredicateType` */
export type ForgeAttributePredicateTypeInput = {
  attribute: ForgeAttributeTypeInput;
  attributeValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  predicate: PredicateType;
};

export type ForgeAttributeQueryInput = {
  predicates: Array<InputMaybe<ForgeAttributePredicateTypeInput>>;
};

export type ForgeAttributeQueryType = {
  __typename?: 'ForgeAttributeQueryType';
  predicates: Array<ForgeAttributePredicateType>;
};

/** An input for mutations affecting `ForgeAttributeQueryType` */
export type ForgeAttributeQueryTypeInput = {
  predicates: Array<InputMaybe<ForgeAttributePredicateTypeInput>>;
};

export type ForgeAttributeType = {
  __typename?: 'ForgeAttributeType';
  category: Scalars['String'];
  name: Scalars['String'];
};

/** A filter to be used against `ForgeAttributeType` object types. All fields are combined with a logical ‘and.’ */
export type ForgeAttributeTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ForgeAttributeTypeFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ForgeAttributeTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ForgeAttributeTypeFilter>>;
};

/** An input for mutations affecting `ForgeAttributeType` */
export type ForgeAttributeTypeInput = {
  category: Scalars['String'];
  name: Scalars['String'];
};

export type GetDescriptionReaderInput = {
  projectId: Scalars['UUID'];
  sheetIds?: InputMaybe<Array<Scalars['UUID']>>;
  tableId: Scalars['UUID'];
};

export type GetDescriptionReaderResponse = {
  __typename?: 'GetDescriptionReaderResponse';
  answer?: Maybe<Scalars['String']>;
};

/** A `GetHistoryEventGroupsRecord` edge in the connection. */
export type GetHistoryEventGroupEdge = {
  __typename?: 'GetHistoryEventGroupEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GetHistoryEventGroupsRecord` at the end of the edge. */
  node: GetHistoryEventGroupsRecord;
};

/** A connection to a list of `GetHistoryEventGroupsRecord` values. */
export type GetHistoryEventGroupsConnection = {
  __typename?: 'GetHistoryEventGroupsConnection';
  /** A list of edges which contains the `GetHistoryEventGroupsRecord` and cursor to aid in pagination. */
  edges: Array<GetHistoryEventGroupEdge>;
  /** A list of `GetHistoryEventGroupsRecord` objects. */
  nodes: Array<GetHistoryEventGroupsRecord>;
  /** The count of *all* `GetHistoryEventGroupsRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `getHistoryEventGroupsConnection` query. */
export type GetHistoryEventGroupsRecord = {
  __typename?: 'GetHistoryEventGroupsRecord';
  affectedResources?: Maybe<Scalars['Int']>;
  author?: Maybe<Scalars['String']>;
  eventCount?: Maybe<Scalars['Int']>;
  eventDay?: Maybe<Scalars['Date']>;
  eventType?: Maybe<EventType>;
  firstEvent?: Maybe<HistoryEvent>;
  groupDate?: Maybe<Scalars['Datetime']>;
  isCheckpoint?: Maybe<Scalars['Boolean']>;
  resourceType?: Maybe<EventResource>;
};

/** A filter to be used against `GetHistoryEventGroupsRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetHistoryEventGroupsRecordFilter = {
  /** Filter by the object’s `affectedResources` field. */
  affectedResources?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetHistoryEventGroupsRecordFilter>>;
  /** Filter by the object’s `author` field. */
  author?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventCount` field. */
  eventCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventDay` field. */
  eventDay?: InputMaybe<DateFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<EventTypeFilter>;
  /** Filter by the object’s `groupDate` field. */
  groupDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `isCheckpoint` field. */
  isCheckpoint?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetHistoryEventGroupsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetHistoryEventGroupsRecordFilter>>;
  /** Filter by the object’s `resourceType` field. */
  resourceType?: InputMaybe<EventResourceFilter>;
};

export type GetMagicSheetShapeInput = {
  mousePoints: Array<MousePoint>;
  pageNumber: Scalars['Int'];
  sheetId: Scalars['UUID'];
};

export type GetMagicSheetShapeResponse = {
  __typename?: 'GetMagicSheetShapeResponse';
  polygon?: Maybe<LinearRing2Type>;
};

export type HistoryEvent = Node & {
  __typename?: 'HistoryEvent';
  author?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  eventName: Scalars['String'];
  eventType: EventType;
  id: Scalars['UUID'];
  isCheckpoint: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `HistoryEvent`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  resolved: Scalars['Boolean'];
  resourceName: Scalars['String'];
  resourceType: EventResource;
  stateKey: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `HistoryEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type HistoryEventCondition = {
  /** Checks for equality with the object’s `author` field. */
  author?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `eventName` field. */
  eventName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<EventType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCheckpoint` field. */
  isCheckpoint?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `resolved` field. */
  resolved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `resourceName` field. */
  resourceName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `resourceType` field. */
  resourceType?: InputMaybe<EventResource>;
  /** Checks for equality with the object’s `stateKey` field. */
  stateKey?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `HistoryEvent` object types. All fields are combined with a logical ‘and.’ */
export type HistoryEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HistoryEventFilter>>;
  /** Filter by the object’s `author` field. */
  author?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventName` field. */
  eventName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<EventTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isCheckpoint` field. */
  isCheckpoint?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HistoryEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HistoryEventFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `resolved` field. */
  resolved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `resourceName` field. */
  resourceName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `resourceType` field. */
  resourceType?: InputMaybe<EventResourceFilter>;
  /** Filter by the object’s `stateKey` field. */
  stateKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `historyEvent` to look up the row to connect. */
export type HistoryEventHistoryEventsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `historyEvent` to look up the row to delete. */
export type HistoryEventHistoryEventsPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `HistoryEvent` */
export type HistoryEventInput = {
  author?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  eventName: Scalars['String'];
  eventType: EventType;
  id?: InputMaybe<Scalars['UUID']>;
  isCheckpoint?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  project?: InputMaybe<HistoryEventsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resourceName: Scalars['String'];
  resourceType: EventResource;
  stateKey: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type HistoryEventNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `historyEvent` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type HistoryEventNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `historyEvent` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type HistoryEventOnHistoryEventForHistoryEventsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `historyEvent` to look up the row to update. */
export type HistoryEventOnHistoryEventForHistoryEventsProjectIdFkeyUsingHistoryEventsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `historyEvent` being updated. */
  patch: UpdateHistoryEventOnHistoryEventForHistoryEventsProjectIdFkeyPatch;
};

/** Represents an update to a `HistoryEvent`. Fields that are set will be updated. */
export type HistoryEventPatch = {
  author?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  id?: InputMaybe<Scalars['UUID']>;
  isCheckpoint?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  project?: InputMaybe<HistoryEventsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resourceName?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<EventResource>;
  stateKey?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `HistoryEvent` values. */
export type HistoryEventsConnection = {
  __typename?: 'HistoryEventsConnection';
  /** A list of edges which contains the `HistoryEvent` and cursor to aid in pagination. */
  edges: Array<HistoryEventsEdge>;
  /** A list of `HistoryEvent` objects. */
  nodes: Array<HistoryEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HistoryEvent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `HistoryEvent` edge in the connection. */
export type HistoryEventsEdge = {
  __typename?: 'HistoryEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `HistoryEvent` at the end of the edge. */
  node: HistoryEvent;
};

/** Methods to use when ordering `HistoryEvent`. */
export enum HistoryEventsOrderBy {
  AuthorAsc = 'AUTHOR_ASC',
  AuthorDesc = 'AUTHOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EventNameAsc = 'EVENT_NAME_ASC',
  EventNameDesc = 'EVENT_NAME_DESC',
  EventTypeAsc = 'EVENT_TYPE_ASC',
  EventTypeDesc = 'EVENT_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCheckpointAsc = 'IS_CHECKPOINT_ASC',
  IsCheckpointDesc = 'IS_CHECKPOINT_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ResolvedAsc = 'RESOLVED_ASC',
  ResolvedDesc = 'RESOLVED_DESC',
  ResourceNameAsc = 'RESOURCE_NAME_ASC',
  ResourceNameDesc = 'RESOURCE_NAME_DESC',
  ResourceTypeAsc = 'RESOURCE_TYPE_ASC',
  ResourceTypeDesc = 'RESOURCE_TYPE_DESC',
  StateKeyAsc = 'STATE_KEY_ASC',
  StateKeyDesc = 'STATE_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The `historyEvent` to be created by this mutation. */
export type HistoryEventsProjectIdFkeyHistoryEventsCreateInput = {
  author?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  eventName: Scalars['String'];
  eventType: EventType;
  id?: InputMaybe<Scalars['UUID']>;
  isCheckpoint?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  project?: InputMaybe<HistoryEventsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resourceName: Scalars['String'];
  resourceType: EventResource;
  stateKey: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `project` in the `HistoryEventInput` mutation. */
export type HistoryEventsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<HistoryEventsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnHistoryEventForHistoryEventsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<HistoryEventOnHistoryEventForHistoryEventsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `historyEvent` in the `ProjectInput` mutation. */
export type HistoryEventsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `historyEvent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<HistoryEventHistoryEventsPkeyConnect>>;
  /** The primary key(s) for `historyEvent` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<HistoryEventNodeIdConnect>>;
  /** A `HistoryEventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<HistoryEventsProjectIdFkeyHistoryEventsCreateInput>>;
  /** The primary key(s) for `historyEvent` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<HistoryEventHistoryEventsPkeyDelete>>;
  /** The primary key(s) for `historyEvent` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<HistoryEventNodeIdDelete>>;
  /** Flag indicating whether all other `historyEvent` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `historyEvent` for the far side of the relationship. */
  updateById?: InputMaybe<Array<HistoryEventOnHistoryEventForHistoryEventsProjectIdFkeyUsingHistoryEventsPkeyUpdate>>;
  /** The primary key(s) and patch data for `historyEvent` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnHistoryEventForHistoryEventsProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type HistoryEventsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An input for mutations affecting `IdPair` */
export type IdPairInput = {
  newId?: InputMaybe<Scalars['String']>;
  oldId?: InputMaybe<Scalars['String']>;
};

export type ImportCompanyDatabaseDataInput = {
  columnIds?: InputMaybe<Array<Scalars['UUID']>>;
  columns: Array<CompanyDatabaseImportColumnInput>;
  databaseId: Scalars['UUID'];
  mode: CompanyDatabaseImportMode;
  rows: Array<CompanyDatabaseImportRowInput>;
};

export type ImportCompanyDatabaseDataPayload = {
  __typename?: 'ImportCompanyDatabaseDataPayload';
  columnIds?: Maybe<Array<Scalars['UUID']>>;
  columnsCreated?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  rowsImported?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type InitialState = Node & {
  __typename?: 'InitialState';
  expandedOrderEntries: Array<Scalars['String']>;
  externalAccessToken: Scalars['String'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `InitialState`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  selectedOrderEntries: Array<Scalars['String']>;
  /** Reads a single `SharedLink` that is related to this `InitialState`. */
  sharedLink?: Maybe<SharedLink>;
  /** Reads a single `SavedView` that is related to this `InitialState`. */
  view?: Maybe<SavedView>;
  viewId: Scalars['UUID'];
  viewSettings: ViewSettingsType;
};

/**
 * A condition to be used against `InitialState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InitialStateCondition = {
  /** Checks for equality with the object’s `expandedOrderEntries` field. */
  expandedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `externalAccessToken` field. */
  externalAccessToken?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `selectedOrderEntries` field. */
  selectedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `viewId` field. */
  viewId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `viewSettings` field. */
  viewSettings?: InputMaybe<ViewSettingsTypeInput>;
};

/** A filter to be used against `InitialState` object types. All fields are combined with a logical ‘and.’ */
export type InitialStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InitialStateFilter>>;
  /** Filter by the object’s `expandedOrderEntries` field. */
  expandedOrderEntries?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `externalAccessToken` field. */
  externalAccessToken?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InitialStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InitialStateFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `selectedOrderEntries` field. */
  selectedOrderEntries?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `viewId` field. */
  viewId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `viewSettings` field. */
  viewSettings?: InputMaybe<ViewSettingsTypeFilter>;
};

/** The fields on `initialState` to look up the row to connect. */
export type InitialStateInitialStatesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `initialState` to look up the row to delete. */
export type InitialStateInitialStatesPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `InitialState` */
export type InitialStateInput = {
  expandedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  externalAccessToken: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings: ViewSettingsTypeInput;
};

/** The globally unique `ID` look up for the row to connect. */
export type InitialStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `initialState` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type InitialStateNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `initialState` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type InitialStateOnInitialStateForInitialStatesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `initialState` to look up the row to update. */
export type InitialStateOnInitialStateForInitialStatesProjectIdFkeyUsingInitialStatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `initialState` being updated. */
  patch: UpdateInitialStateOnInitialStateForInitialStatesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type InitialStateOnInitialStateForInitialStatesViewIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `savedView` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: SavedViewPatch;
};

/** The fields on `initialState` to look up the row to update. */
export type InitialStateOnInitialStateForInitialStatesViewIdFkeyUsingInitialStatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `initialState` being updated. */
  patch: UpdateInitialStateOnInitialStateForInitialStatesViewIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type InitialStateOnSharedLinkForSharedLinksInitialStateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sharedLink` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sharedLink` being updated. */
  patch: SharedLinkPatch;
};

/** The fields on `initialState` to look up the row to update. */
export type InitialStateOnSharedLinkForSharedLinksInitialStateIdFkeyUsingInitialStatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `initialState` being updated. */
  patch: UpdateInitialStateOnSharedLinkForSharedLinksInitialStateIdFkeyPatch;
};

/** Represents an update to a `InitialState`. Fields that are set will be updated. */
export type InitialStatePatch = {
  expandedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAccessToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings?: InputMaybe<ViewSettingsTypeInput>;
};

/** A connection to a list of `InitialState` values. */
export type InitialStatesConnection = {
  __typename?: 'InitialStatesConnection';
  /** A list of edges which contains the `InitialState` and cursor to aid in pagination. */
  edges: Array<InitialStatesEdge>;
  /** A list of `InitialState` objects. */
  nodes: Array<InitialState>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InitialState` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InitialState` edge in the connection. */
export type InitialStatesEdge = {
  __typename?: 'InitialStatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InitialState` at the end of the edge. */
  node: InitialState;
};

/** Methods to use when ordering `InitialState`. */
export enum InitialStatesOrderBy {
  ExpandedOrderEntriesAsc = 'EXPANDED_ORDER_ENTRIES_ASC',
  ExpandedOrderEntriesDesc = 'EXPANDED_ORDER_ENTRIES_DESC',
  ExternalAccessTokenAsc = 'EXTERNAL_ACCESS_TOKEN_ASC',
  ExternalAccessTokenDesc = 'EXTERNAL_ACCESS_TOKEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  SelectedOrderEntriesAsc = 'SELECTED_ORDER_ENTRIES_ASC',
  SelectedOrderEntriesDesc = 'SELECTED_ORDER_ENTRIES_DESC',
  ViewIdAsc = 'VIEW_ID_ASC',
  ViewIdDesc = 'VIEW_ID_DESC',
  ViewSettingsAsc = 'VIEW_SETTINGS_ASC',
  ViewSettingsDesc = 'VIEW_SETTINGS_DESC'
}

/** The `initialState` to be created by this mutation. */
export type InitialStatesProjectIdFkeyInitialStatesCreateInput = {
  expandedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  externalAccessToken: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings: ViewSettingsTypeInput;
};

/** Input for the nested mutation of `project` in the `InitialStateInput` mutation. */
export type InitialStatesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<InitialStatesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnInitialStateForInitialStatesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InitialStateOnInitialStateForInitialStatesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `initialState` in the `ProjectInput` mutation. */
export type InitialStatesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  connectById?: InputMaybe<Array<InitialStateInitialStatesPkeyConnect>>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InitialStateNodeIdConnect>>;
  /** A `InitialStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<InitialStatesProjectIdFkeyInitialStatesCreateInput>>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<InitialStateInitialStatesPkeyDelete>>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<InitialStateNodeIdDelete>>;
  /** Flag indicating whether all other `initialState` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `initialState` for the far side of the relationship. */
  updateById?: InputMaybe<Array<InitialStateOnInitialStateForInitialStatesProjectIdFkeyUsingInitialStatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `initialState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnInitialStateForInitialStatesProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type InitialStatesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `initialState` to be created by this mutation. */
export type InitialStatesViewIdFkeyInitialStatesCreateInput = {
  expandedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  externalAccessToken: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings: ViewSettingsTypeInput;
};

/** Input for the nested mutation of `savedView` in the `InitialStateInput` mutation. */
export type InitialStatesViewIdFkeyInput = {
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectById?: InputMaybe<SavedViewSavedViewsPkeyConnect>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectByNameAndProjectId?: InputMaybe<SavedViewSavedViewsNameProjectIdUniqueConnect>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SavedViewNodeIdConnect>;
  /** A `SavedViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<InitialStatesViewIdFkeySavedViewsCreateInput>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteById?: InputMaybe<SavedViewSavedViewsPkeyDelete>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteByNameAndProjectId?: InputMaybe<SavedViewSavedViewsNameProjectIdUniqueDelete>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SavedViewNodeIdDelete>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateById?: InputMaybe<SavedViewOnInitialStateForInitialStatesViewIdFkeyUsingSavedViewsPkeyUpdate>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateByNameAndProjectId?: InputMaybe<SavedViewOnInitialStateForInitialStatesViewIdFkeyUsingSavedViewsNameProjectIdUniqueUpdate>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InitialStateOnInitialStateForInitialStatesViewIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `initialState` in the `SavedViewInput` mutation. */
export type InitialStatesViewIdFkeyInverseInput = {
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  connectById?: InputMaybe<Array<InitialStateInitialStatesPkeyConnect>>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InitialStateNodeIdConnect>>;
  /** A `InitialStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<InitialStatesViewIdFkeyInitialStatesCreateInput>>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<InitialStateInitialStatesPkeyDelete>>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<InitialStateNodeIdDelete>>;
  /** Flag indicating whether all other `initialState` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `initialState` for the far side of the relationship. */
  updateById?: InputMaybe<Array<InitialStateOnInitialStateForInitialStatesViewIdFkeyUsingInitialStatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `initialState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<SavedViewOnInitialStateForInitialStatesViewIdFkeyNodeIdUpdate>>;
};

/** The `savedView` to be created by this mutation. */
export type InitialStatesViewIdFkeySavedViewsCreateInput = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories: Array<InputMaybe<Scalars['String']>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses: Array<InputMaybe<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** All input for the `invalidateLookupCacheForDatabase` mutation. */
export type InvalidateLookupCacheForDatabaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  theDatabaseId: Scalars['UUID'];
};

/** The output of our `invalidateLookupCacheForDatabase` mutation. */
export type InvalidateLookupCacheForDatabasePayload = {
  __typename?: 'InvalidateLookupCacheForDatabasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Issue = Node & {
  __typename?: 'Issue';
  assignedTo?: Maybe<Scalars['String']>;
  commentCount: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `IssueComment`. */
  issueComments: Array<IssueComment>;
  /** Reads and enables pagination through a set of `IssueComment`. */
  issueCommentsConnection: IssueCommentsConnection;
  lastUpdated: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `Issue`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  status: IssueStatusEnum;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type IssueIssueCommentsArgs = {
  condition?: InputMaybe<IssueCommentCondition>;
  filter?: InputMaybe<IssueCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};


export type IssueIssueCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IssueCommentCondition>;
  filter?: InputMaybe<IssueCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};

export type IssueComment = Node & {
  __typename?: 'IssueComment';
  comment: Scalars['String'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads a single `Issue` that is related to this `IssueComment`. */
  issue?: Maybe<Issue>;
  issueId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `IssueComment`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `IssueComment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IssueCommentCondition = {
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `issueId` field. */
  issueId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `IssueComment` object types. All fields are combined with a logical ‘and.’ */
export type IssueCommentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IssueCommentFilter>>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `issueId` field. */
  issueId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IssueCommentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IssueCommentFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `IssueComment` */
export type IssueCommentInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  issue?: InputMaybe<IssueCommentsIssueIdFkeyInput>;
  issueId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<IssueCommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `issueComment` to look up the row to connect. */
export type IssueCommentIssueCommentsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `issueComment` to look up the row to delete. */
export type IssueCommentIssueCommentsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to connect. */
export type IssueCommentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `issueComment` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type IssueCommentNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `issueComment` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type IssueCommentOnIssueCommentForIssueCommentsIssueIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `issue` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `issue` being updated. */
  patch: IssuePatch;
};

/** The fields on `issueComment` to look up the row to update. */
export type IssueCommentOnIssueCommentForIssueCommentsIssueIdFkeyUsingIssueCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `issueComment` being updated. */
  patch: UpdateIssueCommentOnIssueCommentForIssueCommentsIssueIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type IssueCommentOnIssueCommentForIssueCommentsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `issueComment` to look up the row to update. */
export type IssueCommentOnIssueCommentForIssueCommentsProjectIdFkeyUsingIssueCommentsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `issueComment` being updated. */
  patch: UpdateIssueCommentOnIssueCommentForIssueCommentsProjectIdFkeyPatch;
};

/** Represents an update to a `IssueComment`. Fields that are set will be updated. */
export type IssueCommentPatch = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  issue?: InputMaybe<IssueCommentsIssueIdFkeyInput>;
  issueId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<IssueCommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `IssueComment` values. */
export type IssueCommentsConnection = {
  __typename?: 'IssueCommentsConnection';
  /** A list of edges which contains the `IssueComment` and cursor to aid in pagination. */
  edges: Array<IssueCommentsEdge>;
  /** A list of `IssueComment` objects. */
  nodes: Array<IssueComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IssueComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `IssueComment` edge in the connection. */
export type IssueCommentsEdge = {
  __typename?: 'IssueCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IssueComment` at the end of the edge. */
  node: IssueComment;
};

/** Input for the nested mutation of `issue` in the `IssueCommentInput` mutation. */
export type IssueCommentsIssueIdFkeyInput = {
  /** The primary key(s) for `issue` for the far side of the relationship. */
  connectById?: InputMaybe<IssueIssuesPkeyConnect>;
  /** The primary key(s) for `issue` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<IssueNodeIdConnect>;
  /** A `IssueInput` object that will be created and connected to this object. */
  create?: InputMaybe<IssueCommentsIssueIdFkeyIssuesCreateInput>;
  /** The primary key(s) for `issue` for the far side of the relationship. */
  deleteById?: InputMaybe<IssueIssuesPkeyDelete>;
  /** The primary key(s) for `issue` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<IssueNodeIdDelete>;
  /** The primary key(s) and patch data for `issue` for the far side of the relationship. */
  updateById?: InputMaybe<IssueOnIssueCommentForIssueCommentsIssueIdFkeyUsingIssuesPkeyUpdate>;
  /** The primary key(s) and patch data for `issue` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<IssueCommentOnIssueCommentForIssueCommentsIssueIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `issueComment` in the `IssueInput` mutation. */
export type IssueCommentsIssueIdFkeyInverseInput = {
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IssueCommentIssueCommentsPkeyConnect>>;
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<IssueCommentNodeIdConnect>>;
  /** A `IssueCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IssueCommentsIssueIdFkeyIssueCommentsCreateInput>>;
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<IssueCommentIssueCommentsPkeyDelete>>;
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<IssueCommentNodeIdDelete>>;
  /** Flag indicating whether all other `issueComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `issueComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IssueCommentOnIssueCommentForIssueCommentsIssueIdFkeyUsingIssueCommentsPkeyUpdate>>;
  /** The primary key(s) and patch data for `issueComment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<IssueOnIssueCommentForIssueCommentsIssueIdFkeyNodeIdUpdate>>;
};

/** The `issueComment` to be created by this mutation. */
export type IssueCommentsIssueIdFkeyIssueCommentsCreateInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  issue?: InputMaybe<IssueCommentsIssueIdFkeyInput>;
  issueId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<IssueCommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
};

/** The `issue` to be created by this mutation. */
export type IssueCommentsIssueIdFkeyIssuesCreateInput = {
  assignedTo?: InputMaybe<Scalars['String']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  issueComments?: InputMaybe<IssueCommentsIssueIdFkeyInverseInput>;
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  project?: InputMaybe<IssuesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<IssueStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Methods to use when ordering `IssueComment`. */
export enum IssueCommentsOrderBy {
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IssueIdAsc = 'ISSUE_ID_ASC',
  IssueIdDesc = 'ISSUE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC'
}

/** Input for the nested mutation of `project` in the `IssueCommentInput` mutation. */
export type IssueCommentsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<IssueCommentsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnIssueCommentForIssueCommentsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<IssueCommentOnIssueCommentForIssueCommentsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `issueComment` in the `ProjectInput` mutation. */
export type IssueCommentsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IssueCommentIssueCommentsPkeyConnect>>;
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<IssueCommentNodeIdConnect>>;
  /** A `IssueCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IssueCommentsProjectIdFkeyIssueCommentsCreateInput>>;
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<IssueCommentIssueCommentsPkeyDelete>>;
  /** The primary key(s) for `issueComment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<IssueCommentNodeIdDelete>>;
  /** Flag indicating whether all other `issueComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `issueComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IssueCommentOnIssueCommentForIssueCommentsProjectIdFkeyUsingIssueCommentsPkeyUpdate>>;
  /** The primary key(s) and patch data for `issueComment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnIssueCommentForIssueCommentsProjectIdFkeyNodeIdUpdate>>;
};

/** The `issueComment` to be created by this mutation. */
export type IssueCommentsProjectIdFkeyIssueCommentsCreateInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  issue?: InputMaybe<IssueCommentsIssueIdFkeyInput>;
  issueId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<IssueCommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
};

/** The `project` to be created by this mutation. */
export type IssueCommentsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A condition to be used against `Issue` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type IssueCondition = {
  /** Checks for equality with the object’s `assignedTo` field. */
  assignedTo?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `commentCount` field. */
  commentCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<IssueStatusEnum>;
  /** Checks for equality with the object’s `thumbnail` field. */
  thumbnail?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Issue` object types. All fields are combined with a logical ‘and.’ */
export type IssueFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IssueFilter>>;
  /** Filter by the object’s `assignedTo` field. */
  assignedTo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `commentCount` field. */
  commentCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IssueFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IssueFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IssueStatusEnumFilter>;
  /** Filter by the object’s `thumbnail` field. */
  thumbnail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Issue` */
export type IssueInput = {
  assignedTo?: InputMaybe<Scalars['String']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  issueComments?: InputMaybe<IssueCommentsIssueIdFkeyInverseInput>;
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  project?: InputMaybe<IssuesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<IssueStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** The fields on `issue` to look up the row to connect. */
export type IssueIssuesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `issue` to look up the row to delete. */
export type IssueIssuesPkeyDelete = {
  id: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to connect. */
export type IssueNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `issue` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type IssueNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `issue` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type IssueOnIssueCommentForIssueCommentsIssueIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `issueComment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `issueComment` being updated. */
  patch: IssueCommentPatch;
};

/** The fields on `issue` to look up the row to update. */
export type IssueOnIssueCommentForIssueCommentsIssueIdFkeyUsingIssuesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `issue` being updated. */
  patch: UpdateIssueOnIssueCommentForIssueCommentsIssueIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type IssueOnIssueForIssuesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `issue` to look up the row to update. */
export type IssueOnIssueForIssuesProjectIdFkeyUsingIssuesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `issue` being updated. */
  patch: UpdateIssueOnIssueForIssuesProjectIdFkeyPatch;
};

/** Represents an update to a `Issue`. Fields that are set will be updated. */
export type IssuePatch = {
  assignedTo?: InputMaybe<Scalars['String']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  issueComments?: InputMaybe<IssueCommentsIssueIdFkeyInverseInput>;
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  project?: InputMaybe<IssuesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<IssueStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum IssueStatusEnum {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

/** A filter to be used against IssueStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type IssueStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IssueStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IssueStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IssueStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IssueStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IssueStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IssueStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IssueStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IssueStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IssueStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IssueStatusEnum>>;
};

/** A connection to a list of `Issue` values. */
export type IssuesConnection = {
  __typename?: 'IssuesConnection';
  /** A list of edges which contains the `Issue` and cursor to aid in pagination. */
  edges: Array<IssuesEdge>;
  /** A list of `Issue` objects. */
  nodes: Array<Issue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Issue` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Issue` edge in the connection. */
export type IssuesEdge = {
  __typename?: 'IssuesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Issue` at the end of the edge. */
  node: Issue;
};

/** Methods to use when ordering `Issue`. */
export enum IssuesOrderBy {
  AssignedToAsc = 'ASSIGNED_TO_ASC',
  AssignedToDesc = 'ASSIGNED_TO_DESC',
  CommentCountAsc = 'COMMENT_COUNT_ASC',
  CommentCountDesc = 'COMMENT_COUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastUpdatedAsc = 'LAST_UPDATED_ASC',
  LastUpdatedDesc = 'LAST_UPDATED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  ThumbnailAsc = 'THUMBNAIL_ASC',
  ThumbnailDesc = 'THUMBNAIL_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** Input for the nested mutation of `project` in the `IssueInput` mutation. */
export type IssuesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<IssuesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnIssueForIssuesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<IssueOnIssueForIssuesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `issue` in the `ProjectInput` mutation. */
export type IssuesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `issue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IssueIssuesPkeyConnect>>;
  /** The primary key(s) for `issue` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<IssueNodeIdConnect>>;
  /** A `IssueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IssuesProjectIdFkeyIssuesCreateInput>>;
  /** The primary key(s) for `issue` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<IssueIssuesPkeyDelete>>;
  /** The primary key(s) for `issue` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<IssueNodeIdDelete>>;
  /** Flag indicating whether all other `issue` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `issue` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IssueOnIssueForIssuesProjectIdFkeyUsingIssuesPkeyUpdate>>;
  /** The primary key(s) and patch data for `issue` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnIssueForIssuesProjectIdFkeyNodeIdUpdate>>;
};

/** The `issue` to be created by this mutation. */
export type IssuesProjectIdFkeyIssuesCreateInput = {
  assignedTo?: InputMaybe<Scalars['String']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  issueComments?: InputMaybe<IssueCommentsIssueIdFkeyInverseInput>;
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  project?: InputMaybe<IssuesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<IssueStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** The `project` to be created by this mutation. */
export type IssuesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

export enum LabelEnum {
  String = 'STRING'
}

export type LabelType = {
  __typename?: 'LabelType';
  name: Scalars['String'];
  type: LabelEnum;
};

/** An input for mutations affecting `LabelType` */
export type LabelTypeInput = {
  name: Scalars['String'];
  type: LabelEnum;
};

export type LengthUnitSettingType = {
  __typename?: 'LengthUnitSettingType';
  rounding?: Maybe<RoundingEnum>;
  units?: Maybe<LengthUnitTypeEnum>;
};

/** A filter to be used against `LengthUnitSettingType` object types. All fields are combined with a logical ‘and.’ */
export type LengthUnitSettingTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LengthUnitSettingTypeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<LengthUnitSettingTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LengthUnitSettingTypeFilter>>;
  /** Filter by the object’s `rounding` field. */
  rounding?: InputMaybe<RoundingEnumFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<LengthUnitTypeEnumFilter>;
};

/** An input for mutations affecting `LengthUnitSettingType` */
export type LengthUnitSettingTypeInput = {
  rounding?: InputMaybe<RoundingEnum>;
  units?: InputMaybe<LengthUnitTypeEnum>;
};

export enum LengthUnitTypeEnum {
  Centimeters = 'CENTIMETERS',
  DecimalFeet = 'DECIMAL_FEET',
  DecimalInches = 'DECIMAL_INCHES',
  Decimeters = 'DECIMETERS',
  FeetAndFractionalInches = 'FEET_AND_FRACTIONAL_INCHES',
  FractionalInches = 'FRACTIONAL_INCHES',
  Meters = 'METERS',
  MetersAndMillimeters = 'METERS_AND_MILLIMETERS',
  Millimeters = 'MILLIMETERS'
}

/** A filter to be used against LengthUnitTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type LengthUnitTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LengthUnitTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LengthUnitTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LengthUnitTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LengthUnitTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LengthUnitTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LengthUnitTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LengthUnitTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LengthUnitTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LengthUnitTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LengthUnitTypeEnum>>;
};

export type Line = Node & {
  __typename?: 'Line';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  points: Array<Point3Type>;
  /** Reads a single `Shape` that is related to this `Line`. */
  shape?: Maybe<Shape>;
  shapeId: Scalars['UUID'];
  unitScale: Scalars['Float'];
  updatedAt: Scalars['Datetime'];
};

/** A condition to be used against `Line` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LineCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `points` field. */
  points?: InputMaybe<Array<InputMaybe<Point3TypeInput>>>;
  /** Checks for equality with the object’s `shapeId` field. */
  shapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `unitScale` field. */
  unitScale?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Line` object types. All fields are combined with a logical ‘and.’ */
export type LineFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LineFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LineFilter>>;
  /** Filter by the object’s `shapeId` field. */
  shapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `unitScale` field. */
  unitScale?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Line` */
export type LineInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points: Array<InputMaybe<Point3TypeInput>>;
  shape?: InputMaybe<LinesShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  unitScale: Scalars['Float'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `line` to look up the row to connect. */
export type LineLinesPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `line` to look up the row to delete. */
export type LineLinesPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `line` to look up the row to connect. */
export type LineLinesShapeIdKeyConnect = {
  shapeId: Scalars['UUID'];
};

/** The fields on `line` to look up the row to delete. */
export type LineLinesShapeIdKeyDelete = {
  shapeId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to connect. */
export type LineNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `line` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type LineNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `line` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type LineOnLineForLinesShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `line` to look up the row to update. */
export type LineOnLineForLinesShapeIdFkeyUsingLinesPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `line` being updated. */
  patch: UpdateLineOnLineForLinesShapeIdFkeyPatch;
};

/** The fields on `line` to look up the row to update. */
export type LineOnLineForLinesShapeIdFkeyUsingLinesShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `line` being updated. */
  patch: UpdateLineOnLineForLinesShapeIdFkeyPatch;
  shapeId: Scalars['UUID'];
};

/** Represents an update to a `Line`. Fields that are set will be updated. */
export type LinePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points?: InputMaybe<Array<InputMaybe<Point3TypeInput>>>;
  shape?: InputMaybe<LinesShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  unitScale?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type LinearRing2Type = {
  __typename?: 'LinearRing2Type';
  points: Array<Point2Type>;
};

/** An input for mutations affecting `LinearRing2Type` */
export type LinearRing2TypeInput = {
  points: Array<InputMaybe<Point2TypeInput>>;
};

export type LinearRing3Type = {
  __typename?: 'LinearRing3Type';
  points: Array<Point3Type>;
};

/** An input for mutations affecting `LinearRing3Type` */
export type LinearRing3TypeInput = {
  points: Array<InputMaybe<Point3TypeInput>>;
};

/** A connection to a list of `Line` values. */
export type LinesConnection = {
  __typename?: 'LinesConnection';
  /** A list of edges which contains the `Line` and cursor to aid in pagination. */
  edges: Array<LinesEdge>;
  /** A list of `Line` objects. */
  nodes: Array<Line>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Line` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Line` edge in the connection. */
export type LinesEdge = {
  __typename?: 'LinesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Line` at the end of the edge. */
  node: Line;
};

/** Methods to use when ordering `Line`. */
export enum LinesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointsAsc = 'POINTS_ASC',
  PointsDesc = 'POINTS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShapeIdAsc = 'SHAPE_ID_ASC',
  ShapeIdDesc = 'SHAPE_ID_DESC',
  UnitScaleAsc = 'UNIT_SCALE_ASC',
  UnitScaleDesc = 'UNIT_SCALE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `shape` in the `LineInput` mutation. */
export type LinesShapeIdFkeyInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<ShapeShapesPkeyConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapeNodeIdConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbConnect>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<LinesShapeIdFkeyShapesCreateInput>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapeShapesPkeyDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapeNodeIdDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<ShapeOnLineForLinesShapeIdFkeyUsingShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<LineOnLineForLinesShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<ShapeOnLineForLinesShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `line` in the `ShapeInput` mutation. */
export type LinesShapeIdFkeyInverseInput = {
  /** The primary key(s) for `line` for the far side of the relationship. */
  connectById?: InputMaybe<LineLinesPkeyConnect>;
  /** The primary key(s) for `line` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<LineNodeIdConnect>;
  /** The primary key(s) for `line` for the far side of the relationship. */
  connectByShapeId?: InputMaybe<LineLinesShapeIdKeyConnect>;
  /** A `LineInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LinesShapeIdFkeyLinesCreateInput>>;
  /** The primary key(s) for `line` for the far side of the relationship. */
  deleteById?: InputMaybe<LineLinesPkeyDelete>;
  /** The primary key(s) for `line` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<LineNodeIdDelete>;
  /** The primary key(s) for `line` for the far side of the relationship. */
  deleteByShapeId?: InputMaybe<LineLinesShapeIdKeyDelete>;
  /** Flag indicating whether all other `line` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `line` for the far side of the relationship. */
  updateById?: InputMaybe<LineOnLineForLinesShapeIdFkeyUsingLinesPkeyUpdate>;
  /** The primary key(s) and patch data for `line` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnLineForLinesShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `line` for the far side of the relationship. */
  updateByShapeId?: InputMaybe<LineOnLineForLinesShapeIdFkeyUsingLinesShapeIdKeyUpdate>;
};

/** The `line` to be created by this mutation. */
export type LinesShapeIdFkeyLinesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points: Array<InputMaybe<Point3TypeInput>>;
  shape?: InputMaybe<LinesShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  unitScale: Scalars['Float'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `shape` to be created by this mutation. */
export type LinesShapeIdFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

export enum LookupJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** A filter to be used against LookupJobStatus fields. All fields are combined with a logical ‘and.’ */
export type LookupJobStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LookupJobStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LookupJobStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LookupJobStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LookupJobStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LookupJobStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LookupJobStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LookupJobStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LookupJobStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LookupJobStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LookupJobStatus>>;
};

export enum MatchComparison {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  LlmEvaluate = 'LLM_EVALUATE',
  NumericEquals = 'NUMERIC_EQUALS',
  NumericRange = 'NUMERIC_RANGE',
  RegexMatch = 'REGEX_MATCH'
}

export type MatchCriterion = {
  __typename?: 'MatchCriterion';
  comparison?: Maybe<MatchComparison>;
  name?: Maybe<Scalars['String']>;
  negateSource?: Maybe<Scalars['Boolean']>;
  negateTarget?: Maybe<Scalars['Boolean']>;
  normalizations?: Maybe<Array<TextNormalization>>;
  required?: Maybe<Scalars['Boolean']>;
  scoreWeight?: Maybe<Scalars['Int']>;
  sourcePattern?: Maybe<Scalars['String']>;
  targetColumnId?: Maybe<Scalars['UUID']>;
  targetPattern?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `MatchCriterion` */
export type MatchCriterionInput = {
  comparison?: InputMaybe<MatchComparison>;
  name?: InputMaybe<Scalars['String']>;
  negateSource?: InputMaybe<Scalars['Boolean']>;
  negateTarget?: InputMaybe<Scalars['Boolean']>;
  normalizations?: InputMaybe<Array<InputMaybe<TextNormalization>>>;
  required?: InputMaybe<Scalars['Boolean']>;
  scoreWeight?: InputMaybe<Scalars['Int']>;
  sourcePattern?: InputMaybe<Scalars['String']>;
  targetColumnId?: InputMaybe<Scalars['UUID']>;
  targetPattern?: InputMaybe<Scalars['String']>;
};

export type Model = Node & {
  __typename?: 'Model';
  activeViewGuid?: Maybe<Scalars['String']>;
  availableViewGuids?: Maybe<Array<ModelView>>;
  createdAt: Scalars['Datetime'];
  filename: Scalars['String'];
  forgeUrn?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  ifcCategories?: Maybe<Array<Scalars['String']>>;
  ifcLayers?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  objTranslationStatus: ObjTranslationStatus;
  /** Reads a single `Project` that is related to this `Model`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  propertySets?: Maybe<Array<PropertySetType>>;
  revitCategories?: Maybe<Array<Scalars['String']>>;
  revitLevels?: Maybe<Array<Scalars['String']>>;
  status: ModelProcessingStatus;
  updatedAt: Scalars['Datetime'];
  version: Scalars['Int'];
};

/** A condition to be used against `Model` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ModelCondition = {
  /** Checks for equality with the object’s `activeViewGuid` field. */
  activeViewGuid?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `availableViewGuids` field. */
  availableViewGuids?: InputMaybe<Array<InputMaybe<ModelViewInput>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `forgeUrn` field. */
  forgeUrn?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ifcCategories` field. */
  ifcCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `ifcLayers` field. */
  ifcLayers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `objTranslationStatus` field. */
  objTranslationStatus?: InputMaybe<ObjTranslationStatus>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `propertySets` field. */
  propertySets?: InputMaybe<Array<InputMaybe<PropertySetTypeInput>>>;
  /** Checks for equality with the object’s `revitCategories` field. */
  revitCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `revitLevels` field. */
  revitLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ModelProcessingStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Model` object types. All fields are combined with a logical ‘and.’ */
export type ModelFilter = {
  /** Filter by the object’s `activeViewGuid` field. */
  activeViewGuid?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ModelFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>;
  /** Filter by the object’s `forgeUrn` field. */
  forgeUrn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ifcCategories` field. */
  ifcCategories?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `ifcLayers` field. */
  ifcLayers?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ModelFilter>;
  /** Filter by the object’s `objTranslationStatus` field. */
  objTranslationStatus?: InputMaybe<ObjTranslationStatusFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ModelFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `revitCategories` field. */
  revitCategories?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `revitLevels` field. */
  revitLevels?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ModelProcessingStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Model` */
export type ModelInput = {
  activeViewGuid?: InputMaybe<Scalars['String']>;
  availableViewGuids?: InputMaybe<Array<InputMaybe<ModelViewInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename: Scalars['String'];
  forgeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ifcCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ifcLayers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  objTranslationStatus?: InputMaybe<ObjTranslationStatus>;
  project?: InputMaybe<ModelsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  propertySets?: InputMaybe<Array<InputMaybe<PropertySetTypeInput>>>;
  revitCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revitLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status: ModelProcessingStatus;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version: Scalars['Int'];
};

/** The fields on `model` to look up the row to connect. */
export type ModelModelsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `model` to look up the row to delete. */
export type ModelModelsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to connect. */
export type ModelNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `model` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ModelNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `model` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ModelOnModelForModelsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `model` to look up the row to update. */
export type ModelOnModelForModelsProjectIdFkeyUsingModelsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `model` being updated. */
  patch: UpdateModelOnModelForModelsProjectIdFkeyPatch;
};

/** The fields on `model` to look up the row to update. */
export type ModelOnModelForModelsProjectIdFkeyUsingUniqueModelVersionForProjectUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `model` being updated. */
  patch: UpdateModelOnModelForModelsProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** Represents an update to a `Model`. Fields that are set will be updated. */
export type ModelPatch = {
  activeViewGuid?: InputMaybe<Scalars['String']>;
  availableViewGuids?: InputMaybe<Array<InputMaybe<ModelViewInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  forgeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ifcCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ifcLayers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  objTranslationStatus?: InputMaybe<ObjTranslationStatus>;
  project?: InputMaybe<ModelsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  propertySets?: InputMaybe<Array<InputMaybe<PropertySetTypeInput>>>;
  revitCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revitLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<ModelProcessingStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

export enum ModelProcessingStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

/** A filter to be used against ModelProcessingStatus fields. All fields are combined with a logical ‘and.’ */
export type ModelProcessingStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ModelProcessingStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ModelProcessingStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ModelProcessingStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ModelProcessingStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ModelProcessingStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ModelProcessingStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ModelProcessingStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ModelProcessingStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ModelProcessingStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ModelProcessingStatus>>;
};

export type ModelProcessingSubscriptionPayload = {
  __typename?: 'ModelProcessingSubscriptionPayload';
  model?: Maybe<Model>;
};

/** The fields on `model` to look up the row to connect. */
export type ModelUniqueModelVersionForProjectConnect = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** The fields on `model` to look up the row to delete. */
export type ModelUniqueModelVersionForProjectDelete = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

export type ModelView = {
  __typename?: 'ModelView';
  guid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ModelViewInput = {
  guid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Model` values. */
export type ModelsConnection = {
  __typename?: 'ModelsConnection';
  /** A list of edges which contains the `Model` and cursor to aid in pagination. */
  edges: Array<ModelsEdge>;
  /** A list of `Model` objects. */
  nodes: Array<Model>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Model` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Model` edge in the connection. */
export type ModelsEdge = {
  __typename?: 'ModelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Model` at the end of the edge. */
  node: Model;
};

/** Methods to use when ordering `Model`. */
export enum ModelsOrderBy {
  ActiveViewGuidAsc = 'ACTIVE_VIEW_GUID_ASC',
  ActiveViewGuidDesc = 'ACTIVE_VIEW_GUID_DESC',
  AvailableViewGuidsAsc = 'AVAILABLE_VIEW_GUIDS_ASC',
  AvailableViewGuidsDesc = 'AVAILABLE_VIEW_GUIDS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FilenameAsc = 'FILENAME_ASC',
  FilenameDesc = 'FILENAME_DESC',
  ForgeUrnAsc = 'FORGE_URN_ASC',
  ForgeUrnDesc = 'FORGE_URN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IfcCategoriesAsc = 'IFC_CATEGORIES_ASC',
  IfcCategoriesDesc = 'IFC_CATEGORIES_DESC',
  IfcLayersAsc = 'IFC_LAYERS_ASC',
  IfcLayersDesc = 'IFC_LAYERS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ObjTranslationStatusAsc = 'OBJ_TRANSLATION_STATUS_ASC',
  ObjTranslationStatusDesc = 'OBJ_TRANSLATION_STATUS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  PropertySetsAsc = 'PROPERTY_SETS_ASC',
  PropertySetsDesc = 'PROPERTY_SETS_DESC',
  RevitCategoriesAsc = 'REVIT_CATEGORIES_ASC',
  RevitCategoriesDesc = 'REVIT_CATEGORIES_DESC',
  RevitLevelsAsc = 'REVIT_LEVELS_ASC',
  RevitLevelsDesc = 'REVIT_LEVELS_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

/** Input for the nested mutation of `project` in the `ModelInput` mutation. */
export type ModelsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<ModelsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnModelForModelsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ModelOnModelForModelsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `model` in the `ProjectInput` mutation. */
export type ModelsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `model` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ModelModelsPkeyConnect>>;
  /** The primary key(s) for `model` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ModelNodeIdConnect>>;
  /** The primary key(s) for `model` for the far side of the relationship. */
  connectByProjectIdAndNameAndVersion?: InputMaybe<Array<ModelUniqueModelVersionForProjectConnect>>;
  /** A `ModelInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ModelsProjectIdFkeyModelsCreateInput>>;
  /** The primary key(s) for `model` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ModelModelsPkeyDelete>>;
  /** The primary key(s) for `model` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ModelNodeIdDelete>>;
  /** The primary key(s) for `model` for the far side of the relationship. */
  deleteByProjectIdAndNameAndVersion?: InputMaybe<Array<ModelUniqueModelVersionForProjectDelete>>;
  /** Flag indicating whether all other `model` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `model` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ModelOnModelForModelsProjectIdFkeyUsingModelsPkeyUpdate>>;
  /** The primary key(s) and patch data for `model` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnModelForModelsProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `model` for the far side of the relationship. */
  updateByProjectIdAndNameAndVersion?: InputMaybe<Array<ModelOnModelForModelsProjectIdFkeyUsingUniqueModelVersionForProjectUpdate>>;
};

/** The `model` to be created by this mutation. */
export type ModelsProjectIdFkeyModelsCreateInput = {
  activeViewGuid?: InputMaybe<Scalars['String']>;
  availableViewGuids?: InputMaybe<Array<InputMaybe<ModelViewInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename: Scalars['String'];
  forgeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ifcCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ifcLayers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  objTranslationStatus?: InputMaybe<ObjTranslationStatus>;
  project?: InputMaybe<ModelsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  propertySets?: InputMaybe<Array<InputMaybe<PropertySetTypeInput>>>;
  revitCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revitLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status: ModelProcessingStatus;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version: Scalars['Int'];
};

/** The `project` to be created by this mutation. */
export type ModelsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type MousePoint = {
  foreground: Scalars['Boolean'];
  point: Point2TypeInput;
};

/** All input for the `moveOrCopyOrderEntries` mutation. */
export type MoveOrCopyOrderEntriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  copyEntries: Scalars['Boolean'];
  orderEntryIds: Array<InputMaybe<Scalars['UUID']>>;
  targetOrderId: Scalars['UUID'];
};

/** The output of our `moveOrCopyOrderEntries` mutation. */
export type MoveOrCopyOrderEntriesPayload = {
  __typename?: 'MoveOrCopyOrderEntriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  orderEntries?: Maybe<Array<OrderEntry>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type MultiPolygon2Type = {
  __typename?: 'MultiPolygon2Type';
  polygons: Array<Polygon2Type>;
};

/** An input for mutations affecting `MultiPolygon2Type` */
export type MultiPolygon2TypeInput = {
  polygons: Array<InputMaybe<Polygon2TypeInput>>;
};

export type MultiPolygon3Type = {
  __typename?: 'MultiPolygon3Type';
  polygons: Array<Polygon3Type>;
};

/** An input for mutations affecting `MultiPolygon3Type` */
export type MultiPolygon3TypeInput = {
  polygons: Array<InputMaybe<Polygon3TypeInput>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  applyPromptLinking: ApplyPromptLinkingPayload;
  askCopilot?: Maybe<CopilotAnswer>;
  bulkCreateShapes?: Maybe<BulkCreateShapesPayload>;
  bulkCreateSheetShapes?: Maybe<BulkCreateSheetShapesPayload>;
  bulkDeleteShapes?: Maybe<BulkDeleteShapesPayload>;
  bulkDeleteSheetShapes?: Maybe<BulkDeleteSheetShapesPayload>;
  bulkDeleteSparkelProperties?: Maybe<BulkDeleteSparkelPropertiesPayload>;
  bulkUpdateShapes?: Maybe<BulkUpdateShapesPayload>;
  bulkUpdateSheetShapes?: Maybe<BulkUpdateSheetShapesPayload>;
  bulkUpsertOrderEntryCache?: Maybe<BulkUpsertOrderEntryCachePayload>;
  bulkUpsertSparkelProperties?: Maybe<BulkUpsertSparkelPropertiesPayload>;
  createApiClient?: Maybe<CreateApiClientPayload>;
  /** Creates a single `AutoShape`. */
  createAutoShape?: Maybe<CreateAutoShapePayload>;
  createCheckoutUrl: Scalars['String'];
  /** Creates a single `Comment`. */
  createComment?: Maybe<CreateCommentPayload>;
  /** Creates a single `CompanyDatabaseCell`. */
  createCompanyDatabaseCell?: Maybe<CreateCompanyDatabaseCellPayload>;
  /** Creates a single `CompanyDatabaseColumn`. */
  createCompanyDatabaseColumn?: Maybe<CreateCompanyDatabaseColumnPayload>;
  /** Creates a single `CompanyDatabaseImportJob`. */
  createCompanyDatabaseImportJob?: Maybe<CreateCompanyDatabaseImportJobPayload>;
  /** Creates a single `CompanyDatabaseLookupCache`. */
  createCompanyDatabaseLookupCache?: Maybe<CreateCompanyDatabaseLookupCachePayload>;
  /** Creates a single `CompanyDatabaseLookupJob`. */
  createCompanyDatabaseLookupJob?: Maybe<CreateCompanyDatabaseLookupJobPayload>;
  /** Creates a single `CompanyDatabaseLookupProfile`. */
  createCompanyDatabaseLookupProfile?: Maybe<CreateCompanyDatabaseLookupProfilePayload>;
  /** Creates a single `CompanyDatabaseRow`. */
  createCompanyDatabaseRow?: Maybe<CreateCompanyDatabaseRowPayload>;
  /** Creates a single `CompanyDatabasis`. */
  createCompanyDatabasis?: Maybe<CreateCompanyDatabasisPayload>;
  /** Creates a single `Contractor`. */
  createContractor?: Maybe<CreateContractorPayload>;
  /** Creates a single `CopilotExchange`. */
  createCopilotExchange?: Maybe<CreateCopilotExchangePayload>;
  /** Creates a single `CopilotExchangesFeedback`. */
  createCopilotExchangesFeedback?: Maybe<CreateCopilotExchangesFeedbackPayload>;
  /** Creates a single `CustomField`. */
  createCustomField?: Maybe<CreateCustomFieldPayload>;
  /** Creates a single `CustomFieldTemplate`. */
  createCustomFieldTemplate?: Maybe<CreateCustomFieldTemplatePayload>;
  /** Creates a single `ExtrudedPolygon`. */
  createExtrudedPolygon?: Maybe<CreateExtrudedPolygonPayload>;
  /** Creates a single `Flow`. */
  createFlow?: Maybe<CreateFlowPayload>;
  /** Creates a single `FlowAction`. */
  createFlowAction?: Maybe<CreateFlowActionPayload>;
  /** Creates a single `FlowExecution`. */
  createFlowExecution?: Maybe<CreateFlowExecutionPayload>;
  /** Creates a single `FlowMailbox`. */
  createFlowMailbox?: Maybe<CreateFlowMailboxPayload>;
  /** Creates a single `FlowMailboxMessage`. */
  createFlowMailboxMessage?: Maybe<CreateFlowMailboxMessagePayload>;
  /** Creates a single `HistoryEvent`. */
  createHistoryEvent?: Maybe<CreateHistoryEventPayload>;
  /** Creates a single `InitialState`. */
  createInitialState?: Maybe<CreateInitialStatePayload>;
  /** Creates a single `Issue`. */
  createIssue?: Maybe<CreateIssuePayload>;
  /** Creates a single `IssueComment`. */
  createIssueComment?: Maybe<CreateIssueCommentPayload>;
  /** Creates a single `Line`. */
  createLine?: Maybe<CreateLinePayload>;
  /** Creates a single `Model`. */
  createModel?: Maybe<CreateModelPayload>;
  /** Creates a single `Order`. */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Creates a single `OrderColumn`. */
  createOrderColumn?: Maybe<CreateOrderColumnPayload>;
  /** Creates a single `OrderColumnTemplate`. */
  createOrderColumnTemplate?: Maybe<CreateOrderColumnTemplatePayload>;
  /** Creates a single `OrderEntry`. */
  createOrderEntry?: Maybe<CreateOrderEntryPayload>;
  /** Creates a single `OrderEntryCache`. */
  createOrderEntryCache?: Maybe<CreateOrderEntryCachePayload>;
  createOrderEntryFromTemplate?: Maybe<CreateOrderEntryFromTemplatePayload>;
  /** Creates a single `OrderEntryTemplate`. */
  createOrderEntryTemplate?: Maybe<CreateOrderEntryTemplatePayload>;
  /** Creates a single `OrderEntryView`. */
  createOrderEntryView?: Maybe<CreateOrderEntryViewPayload>;
  /**
   * Create a project with an order containing entries from a table.
   * Each entry will have a database lookup performed using the specified profile.
   * Returns the resolved data including matched products from the lookup.
   */
  createOrderFromTable: CreateOrderFromTableResult;
  /** Creates a single `Polygon`. */
  createPolygon?: Maybe<CreatePolygonPayload>;
  /** Creates a single `Project`. */
  createProject?: Maybe<CreateProjectPayload>;
  createProjectFromDocuments: CreateProjectFromDocumentsPayload;
  createProjectFromTemplate?: Maybe<CreateProjectFromTemplatePayload>;
  /** Creates a single `ProjectTag`. */
  createProjectTag?: Maybe<CreateProjectTagPayload>;
  /** Creates a single `ProjectTemplate`. */
  createProjectTemplate?: Maybe<CreateProjectTemplatePayload>;
  /** Creates a single `ProjectTemplateOrder`. */
  createProjectTemplateOrder?: Maybe<CreateProjectTemplateOrderPayload>;
  /** Creates a single `ProjectTemplateOrderEntry`. */
  createProjectTemplateOrderEntry?: Maybe<CreateProjectTemplateOrderEntryPayload>;
  /** Creates a single `ProjectTemplateOrderEntryView`. */
  createProjectTemplateOrderEntryView?: Maybe<CreateProjectTemplateOrderEntryViewPayload>;
  /** Creates a single `ProtanProjectStep`. */
  createProtanProjectStep?: Maybe<CreateProtanProjectStepPayload>;
  /** Creates a single `PublicInitialState`. */
  createPublicInitialState?: Maybe<CreatePublicInitialStatePayload>;
  /** Creates a single `SavedView`. */
  createSavedView?: Maybe<CreateSavedViewPayload>;
  /** Creates a single `Shape`. */
  createShape?: Maybe<CreateShapePayload>;
  /** Creates a single `ShapeFolder`. */
  createShapeFolder?: Maybe<CreateShapeFolderPayload>;
  /** Creates a single `ShapePoint`. */
  createShapePoint?: Maybe<CreateShapePointPayload>;
  /** Creates a single `SharedLink`. */
  createSharedLink?: Maybe<CreateSharedLinkPayload>;
  createSharedLinkWithDuration?: Maybe<CreateSharedLinkWithDurationPayload>;
  /** Creates a single `Sheet`. */
  createSheet?: Maybe<CreateSheetPayload>;
  /** Creates a single `SheetPageCalibration`. */
  createSheetPageCalibration?: Maybe<CreateSheetPageCalibrationPayload>;
  /** Creates a single `SheetShape`. */
  createSheetShape?: Maybe<CreateSheetShapePayload>;
  /** Creates a single `SheetShapeLegend`. */
  createSheetShapeLegend?: Maybe<CreateSheetShapeLegendPayload>;
  /** Creates a single `SheetShapeLine`. */
  createSheetShapeLine?: Maybe<CreateSheetShapeLinePayload>;
  /** Creates a single `SheetShapePoint`. */
  createSheetShapePoint?: Maybe<CreateSheetShapePointPayload>;
  /** Creates a single `SheetShapePolygon`. */
  createSheetShapePolygon?: Maybe<CreateSheetShapePolygonPayload>;
  /** Creates a single `SheetShapeSplitLine`. */
  createSheetShapeSplitLine?: Maybe<CreateSheetShapeSplitLinePayload>;
  /** Creates a single `SparkelAiAnalysis`. */
  createSparkelAiAnalysis?: Maybe<CreateSparkelAiAnalysisPayload>;
  /** Creates a single `SparkelProperty`. */
  createSparkelProperty?: Maybe<CreateSparkelPropertyPayload>;
  createTableFromTemplate?: Maybe<CreateTableFromTemplatePayload>;
  createTemplateFromOrderEntry?: Maybe<CreateTemplateFromOrderEntryPayload>;
  createTemplateFromProject?: Maybe<CreateTemplateFromProjectPayload>;
  createUser: User;
  /** Deletes a single `AutoShape` using a unique key. */
  deleteAutoShape?: Maybe<DeleteAutoShapePayload>;
  /** Deletes a single `AutoShape` using its globally unique id. */
  deleteAutoShapeByNodeId?: Maybe<DeleteAutoShapePayload>;
  deleteAutoShapeShapes: Scalars['Boolean'];
  /** Deletes a single `Comment` using a unique key. */
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** Deletes a single `Comment` using its globally unique id. */
  deleteCommentByNodeId?: Maybe<DeleteCommentPayload>;
  /** Deletes a single `CompanyDatabaseCell` using a unique key. */
  deleteCompanyDatabaseCell?: Maybe<DeleteCompanyDatabaseCellPayload>;
  /** Deletes a single `CompanyDatabaseCell` using its globally unique id. */
  deleteCompanyDatabaseCellByNodeId?: Maybe<DeleteCompanyDatabaseCellPayload>;
  /** Deletes a single `CompanyDatabaseColumn` using a unique key. */
  deleteCompanyDatabaseColumn?: Maybe<DeleteCompanyDatabaseColumnPayload>;
  /** Deletes a single `CompanyDatabaseColumn` using its globally unique id. */
  deleteCompanyDatabaseColumnByNodeId?: Maybe<DeleteCompanyDatabaseColumnPayload>;
  /** Deletes a single `CompanyDatabaseImportJob` using a unique key. */
  deleteCompanyDatabaseImportJob?: Maybe<DeleteCompanyDatabaseImportJobPayload>;
  /** Deletes a single `CompanyDatabaseImportJob` using its globally unique id. */
  deleteCompanyDatabaseImportJobByNodeId?: Maybe<DeleteCompanyDatabaseImportJobPayload>;
  /** Deletes a single `CompanyDatabaseLookupCache` using a unique key. */
  deleteCompanyDatabaseLookupCache?: Maybe<DeleteCompanyDatabaseLookupCachePayload>;
  /** Deletes a single `CompanyDatabaseLookupCache` using a unique key. */
  deleteCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: Maybe<DeleteCompanyDatabaseLookupCachePayload>;
  /** Deletes a single `CompanyDatabaseLookupCache` using its globally unique id. */
  deleteCompanyDatabaseLookupCacheByNodeId?: Maybe<DeleteCompanyDatabaseLookupCachePayload>;
  /** Deletes a single `CompanyDatabaseLookupJob` using a unique key. */
  deleteCompanyDatabaseLookupJob?: Maybe<DeleteCompanyDatabaseLookupJobPayload>;
  /** Deletes a single `CompanyDatabaseLookupJob` using its globally unique id. */
  deleteCompanyDatabaseLookupJobByNodeId?: Maybe<DeleteCompanyDatabaseLookupJobPayload>;
  /** Deletes a single `CompanyDatabaseLookupProfile` using a unique key. */
  deleteCompanyDatabaseLookupProfile?: Maybe<DeleteCompanyDatabaseLookupProfilePayload>;
  /** Deletes a single `CompanyDatabaseLookupProfile` using its globally unique id. */
  deleteCompanyDatabaseLookupProfileByNodeId?: Maybe<DeleteCompanyDatabaseLookupProfilePayload>;
  /** Deletes a single `CompanyDatabaseRow` using a unique key. */
  deleteCompanyDatabaseRow?: Maybe<DeleteCompanyDatabaseRowPayload>;
  /** Deletes a single `CompanyDatabaseRow` using its globally unique id. */
  deleteCompanyDatabaseRowByNodeId?: Maybe<DeleteCompanyDatabaseRowPayload>;
  /** Deletes a single `CompanyDatabasis` using a unique key. */
  deleteCompanyDatabasis?: Maybe<DeleteCompanyDatabasisPayload>;
  /** Deletes a single `CompanyDatabasis` using its globally unique id. */
  deleteCompanyDatabasisByNodeId?: Maybe<DeleteCompanyDatabasisPayload>;
  /** Deletes a single `Contractor` using a unique key. */
  deleteContractor?: Maybe<DeleteContractorPayload>;
  /** Deletes a single `Contractor` using its globally unique id. */
  deleteContractorByNodeId?: Maybe<DeleteContractorPayload>;
  /** Deletes a single `Contractor` using a unique key. */
  deleteContractorByTenant?: Maybe<DeleteContractorPayload>;
  /** Deletes a single `CopilotExchange` using a unique key. */
  deleteCopilotExchange?: Maybe<DeleteCopilotExchangePayload>;
  /** Deletes a single `CopilotExchange` using its globally unique id. */
  deleteCopilotExchangeByNodeId?: Maybe<DeleteCopilotExchangePayload>;
  /** Deletes a single `CopilotExchangesFeedback` using a unique key. */
  deleteCopilotExchangesFeedback?: Maybe<DeleteCopilotExchangesFeedbackPayload>;
  /** Deletes a single `CopilotExchangesFeedback` using its globally unique id. */
  deleteCopilotExchangesFeedbackByNodeId?: Maybe<DeleteCopilotExchangesFeedbackPayload>;
  /** Deletes a single `CustomField` using a unique key. */
  deleteCustomField?: Maybe<DeleteCustomFieldPayload>;
  /** Deletes a single `CustomField` using its globally unique id. */
  deleteCustomFieldByNodeId?: Maybe<DeleteCustomFieldPayload>;
  /** Deletes a single `CustomField` using a unique key. */
  deleteCustomFieldByOrderColumnIdAndOrderEntryId?: Maybe<DeleteCustomFieldPayload>;
  /** Deletes a single `CustomFieldTemplate` using a unique key. */
  deleteCustomFieldTemplate?: Maybe<DeleteCustomFieldTemplatePayload>;
  /** Deletes a single `CustomFieldTemplate` using its globally unique id. */
  deleteCustomFieldTemplateByNodeId?: Maybe<DeleteCustomFieldTemplatePayload>;
  /** Deletes a single `ExtrudedPolygon` using a unique key. */
  deleteExtrudedPolygon?: Maybe<DeleteExtrudedPolygonPayload>;
  /** Deletes a single `ExtrudedPolygon` using its globally unique id. */
  deleteExtrudedPolygonByNodeId?: Maybe<DeleteExtrudedPolygonPayload>;
  /** Deletes a single `ExtrudedPolygon` using a unique key. */
  deleteExtrudedPolygonByShapeId?: Maybe<DeleteExtrudedPolygonPayload>;
  /** Deletes a single `Flow` using a unique key. */
  deleteFlow?: Maybe<DeleteFlowPayload>;
  /** Deletes a single `FlowAction` using a unique key. */
  deleteFlowAction?: Maybe<DeleteFlowActionPayload>;
  /** Deletes a single `FlowAction` using a unique key. */
  deleteFlowActionByFlowIdAndPosition?: Maybe<DeleteFlowActionPayload>;
  /** Deletes a single `FlowAction` using its globally unique id. */
  deleteFlowActionByNodeId?: Maybe<DeleteFlowActionPayload>;
  /** Deletes a single `Flow` using its globally unique id. */
  deleteFlowByNodeId?: Maybe<DeleteFlowPayload>;
  /** Deletes a single `FlowExecution` using a unique key. */
  deleteFlowExecution?: Maybe<DeleteFlowExecutionPayload>;
  /** Deletes a single `FlowExecution` using its globally unique id. */
  deleteFlowExecutionByNodeId?: Maybe<DeleteFlowExecutionPayload>;
  /** Deletes a single `FlowMailbox` using a unique key. */
  deleteFlowMailbox?: Maybe<DeleteFlowMailboxPayload>;
  /** Deletes a single `FlowMailbox` using a unique key. */
  deleteFlowMailboxByContractorId?: Maybe<DeleteFlowMailboxPayload>;
  /** Deletes a single `FlowMailbox` using a unique key. */
  deleteFlowMailboxByEmailLocalPartAndEmailDomain?: Maybe<DeleteFlowMailboxPayload>;
  /** Deletes a single `FlowMailbox` using its globally unique id. */
  deleteFlowMailboxByNodeId?: Maybe<DeleteFlowMailboxPayload>;
  /** Deletes a single `FlowMailboxMessage` using a unique key. */
  deleteFlowMailboxMessage?: Maybe<DeleteFlowMailboxMessagePayload>;
  /** Deletes a single `FlowMailboxMessage` using its globally unique id. */
  deleteFlowMailboxMessageByNodeId?: Maybe<DeleteFlowMailboxMessagePayload>;
  /** Deletes a single `HistoryEvent` using a unique key. */
  deleteHistoryEvent?: Maybe<DeleteHistoryEventPayload>;
  /** Deletes a single `HistoryEvent` using its globally unique id. */
  deleteHistoryEventByNodeId?: Maybe<DeleteHistoryEventPayload>;
  /** Deletes a single `InitialState` using a unique key. */
  deleteInitialState?: Maybe<DeleteInitialStatePayload>;
  /** Deletes a single `InitialState` using its globally unique id. */
  deleteInitialStateByNodeId?: Maybe<DeleteInitialStatePayload>;
  /** Deletes a single `Issue` using a unique key. */
  deleteIssue?: Maybe<DeleteIssuePayload>;
  /** Deletes a single `Issue` using its globally unique id. */
  deleteIssueByNodeId?: Maybe<DeleteIssuePayload>;
  /** Deletes a single `IssueComment` using a unique key. */
  deleteIssueComment?: Maybe<DeleteIssueCommentPayload>;
  /** Deletes a single `IssueComment` using its globally unique id. */
  deleteIssueCommentByNodeId?: Maybe<DeleteIssueCommentPayload>;
  /** Deletes a single `Line` using a unique key. */
  deleteLine?: Maybe<DeleteLinePayload>;
  /** Deletes a single `Line` using its globally unique id. */
  deleteLineByNodeId?: Maybe<DeleteLinePayload>;
  /** Deletes a single `Line` using a unique key. */
  deleteLineByShapeId?: Maybe<DeleteLinePayload>;
  /** Deletes a single `Model` using a unique key. */
  deleteModel?: Maybe<DeleteModelPayload>;
  /** Deletes a single `Model` using its globally unique id. */
  deleteModelByNodeId?: Maybe<DeleteModelPayload>;
  /** Deletes a single `Model` using a unique key. */
  deleteModelByProjectIdAndNameAndVersion?: Maybe<DeleteModelPayload>;
  deleteModelVersion?: Maybe<DeleteModelVersionPayload>;
  /** Deletes a single `Order` using a unique key. */
  deleteOrder?: Maybe<DeleteOrderPayload>;
  /** Deletes a single `Order` using its globally unique id. */
  deleteOrderByNodeId?: Maybe<DeleteOrderPayload>;
  /** Deletes a single `OrderColumn` using a unique key. */
  deleteOrderColumn?: Maybe<DeleteOrderColumnPayload>;
  /** Deletes a single `OrderColumn` using a unique key. */
  deleteOrderColumnByNameAndColumnTypeAndOrderId?: Maybe<DeleteOrderColumnPayload>;
  /** Deletes a single `OrderColumn` using its globally unique id. */
  deleteOrderColumnByNodeId?: Maybe<DeleteOrderColumnPayload>;
  /** Deletes a single `OrderColumnTemplate` using a unique key. */
  deleteOrderColumnTemplate?: Maybe<DeleteOrderColumnTemplatePayload>;
  /** Deletes a single `OrderColumnTemplate` using its globally unique id. */
  deleteOrderColumnTemplateByNodeId?: Maybe<DeleteOrderColumnTemplatePayload>;
  /** Deletes a single `OrderEntry` using a unique key. */
  deleteOrderEntry?: Maybe<DeleteOrderEntryPayload>;
  /** Deletes a single `OrderEntry` using its globally unique id. */
  deleteOrderEntryByNodeId?: Maybe<DeleteOrderEntryPayload>;
  /** Deletes a single `OrderEntryCache` using a unique key. */
  deleteOrderEntryCache?: Maybe<DeleteOrderEntryCachePayload>;
  /** Deletes a single `OrderEntryCache` using its globally unique id. */
  deleteOrderEntryCacheByNodeId?: Maybe<DeleteOrderEntryCachePayload>;
  /** Deletes a single `OrderEntryCache` using a unique key. */
  deleteOrderEntryCacheByOrderEntryId?: Maybe<DeleteOrderEntryCachePayload>;
  /** Deletes a single `OrderEntryTemplate` using a unique key. */
  deleteOrderEntryTemplate?: Maybe<DeleteOrderEntryTemplatePayload>;
  /** Deletes a single `OrderEntryTemplate` using its globally unique id. */
  deleteOrderEntryTemplateByNodeId?: Maybe<DeleteOrderEntryTemplatePayload>;
  /** Deletes a single `OrderEntryView` using a unique key. */
  deleteOrderEntryView?: Maybe<DeleteOrderEntryViewPayload>;
  /** Deletes a single `OrderEntryView` using its globally unique id. */
  deleteOrderEntryViewByNodeId?: Maybe<DeleteOrderEntryViewPayload>;
  /** Deletes a single `OrderEntryView` using a unique key. */
  deleteOrderEntryViewByProjectIdAndName?: Maybe<DeleteOrderEntryViewPayload>;
  /** Deletes a single `Polygon` using a unique key. */
  deletePolygon?: Maybe<DeletePolygonPayload>;
  /** Deletes a single `Polygon` using its globally unique id. */
  deletePolygonByNodeId?: Maybe<DeletePolygonPayload>;
  /** Deletes a single `Polygon` using a unique key. */
  deletePolygonByShapeId?: Maybe<DeletePolygonPayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProject?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `Project` using its globally unique id. */
  deleteProjectByNodeId?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `ProjectTag` using a unique key. */
  deleteProjectTag?: Maybe<DeleteProjectTagPayload>;
  /** Deletes a single `ProjectTag` using its globally unique id. */
  deleteProjectTagByNodeId?: Maybe<DeleteProjectTagPayload>;
  /** Deletes a single `ProjectTemplate` using a unique key. */
  deleteProjectTemplate?: Maybe<DeleteProjectTemplatePayload>;
  /** Deletes a single `ProjectTemplate` using its globally unique id. */
  deleteProjectTemplateByNodeId?: Maybe<DeleteProjectTemplatePayload>;
  /** Deletes a single `ProjectTemplateOrder` using a unique key. */
  deleteProjectTemplateOrder?: Maybe<DeleteProjectTemplateOrderPayload>;
  /** Deletes a single `ProjectTemplateOrder` using its globally unique id. */
  deleteProjectTemplateOrderByNodeId?: Maybe<DeleteProjectTemplateOrderPayload>;
  /** Deletes a single `ProjectTemplateOrderEntry` using a unique key. */
  deleteProjectTemplateOrderEntry?: Maybe<DeleteProjectTemplateOrderEntryPayload>;
  /** Deletes a single `ProjectTemplateOrderEntry` using its globally unique id. */
  deleteProjectTemplateOrderEntryByNodeId?: Maybe<DeleteProjectTemplateOrderEntryPayload>;
  /** Deletes a single `ProjectTemplateOrderEntryView` using a unique key. */
  deleteProjectTemplateOrderEntryView?: Maybe<DeleteProjectTemplateOrderEntryViewPayload>;
  /** Deletes a single `ProjectTemplateOrderEntryView` using its globally unique id. */
  deleteProjectTemplateOrderEntryViewByNodeId?: Maybe<DeleteProjectTemplateOrderEntryViewPayload>;
  /** Deletes a single `ProtanProjectStep` using a unique key. */
  deleteProtanProjectStep?: Maybe<DeleteProtanProjectStepPayload>;
  /** Deletes a single `ProtanProjectStep` using its globally unique id. */
  deleteProtanProjectStepByNodeId?: Maybe<DeleteProtanProjectStepPayload>;
  /** Deletes a single `ProtanProjectStep` using a unique key. */
  deleteProtanProjectStepByProjectIdAndStep?: Maybe<DeleteProtanProjectStepPayload>;
  /** Deletes a single `SavedView` using a unique key. */
  deleteSavedView?: Maybe<DeleteSavedViewPayload>;
  /** Deletes a single `SavedView` using a unique key. */
  deleteSavedViewByNameAndProjectId?: Maybe<DeleteSavedViewPayload>;
  /** Deletes a single `SavedView` using its globally unique id. */
  deleteSavedViewByNodeId?: Maybe<DeleteSavedViewPayload>;
  /** Deletes a single `Shape` using a unique key. */
  deleteShape?: Maybe<DeleteShapePayload>;
  /** Deletes a single `Shape` using its globally unique id. */
  deleteShapeByNodeId?: Maybe<DeleteShapePayload>;
  /** Deletes a single `Shape` using a unique key. */
  deleteShapeByUrnAndDbId?: Maybe<DeleteShapePayload>;
  /** Deletes a single `ShapeFolder` using a unique key. */
  deleteShapeFolder?: Maybe<DeleteShapeFolderPayload>;
  /** Deletes a single `ShapeFolder` using its globally unique id. */
  deleteShapeFolderByNodeId?: Maybe<DeleteShapeFolderPayload>;
  /** Deletes a single `ShapeFolder` using a unique key. */
  deleteShapeFolderByProjectIdAndName?: Maybe<DeleteShapeFolderPayload>;
  /** Deletes a single `ShapePoint` using a unique key. */
  deleteShapePoint?: Maybe<DeleteShapePointPayload>;
  /** Deletes a single `ShapePoint` using its globally unique id. */
  deleteShapePointByNodeId?: Maybe<DeleteShapePointPayload>;
  /** Deletes a single `ShapePoint` using a unique key. */
  deleteShapePointByShapeId?: Maybe<DeleteShapePointPayload>;
  /** Deletes a single `SharedLink` using a unique key. */
  deleteSharedLink?: Maybe<DeleteSharedLinkPayload>;
  /** Deletes a single `SharedLink` using a unique key. */
  deleteSharedLinkByInitialStateId?: Maybe<DeleteSharedLinkPayload>;
  /** Deletes a single `SharedLink` using its globally unique id. */
  deleteSharedLinkByNodeId?: Maybe<DeleteSharedLinkPayload>;
  /** Deletes a single `Sheet` using a unique key. */
  deleteSheet?: Maybe<DeleteSheetPayload>;
  /** Deletes a single `Sheet` using its globally unique id. */
  deleteSheetByNodeId?: Maybe<DeleteSheetPayload>;
  /** Deletes a single `Sheet` using a unique key. */
  deleteSheetByProjectIdAndNameAndVersion?: Maybe<DeleteSheetPayload>;
  /** Deletes a single `SheetPageCalibration` using a unique key. */
  deleteSheetPageCalibration?: Maybe<DeleteSheetPageCalibrationPayload>;
  /** Deletes a single `SheetPageCalibration` using its globally unique id. */
  deleteSheetPageCalibrationByNodeId?: Maybe<DeleteSheetPageCalibrationPayload>;
  /** Deletes a single `SheetShape` using a unique key. */
  deleteSheetShape?: Maybe<DeleteSheetShapePayload>;
  /** Deletes a single `SheetShape` using its globally unique id. */
  deleteSheetShapeByNodeId?: Maybe<DeleteSheetShapePayload>;
  /** Deletes a single `SheetShape` using a unique key. */
  deleteSheetShapeByUrnAndDbId?: Maybe<DeleteSheetShapePayload>;
  /** Deletes a single `SheetShapeLegend` using a unique key. */
  deleteSheetShapeLegend?: Maybe<DeleteSheetShapeLegendPayload>;
  /** Deletes a single `SheetShapeLegend` using its globally unique id. */
  deleteSheetShapeLegendByNodeId?: Maybe<DeleteSheetShapeLegendPayload>;
  /** Deletes a single `SheetShapeLegend` using a unique key. */
  deleteSheetShapeLegendBySheetShapeId?: Maybe<DeleteSheetShapeLegendPayload>;
  /** Deletes a single `SheetShapeLine` using a unique key. */
  deleteSheetShapeLine?: Maybe<DeleteSheetShapeLinePayload>;
  /** Deletes a single `SheetShapeLine` using its globally unique id. */
  deleteSheetShapeLineByNodeId?: Maybe<DeleteSheetShapeLinePayload>;
  /** Deletes a single `SheetShapeLine` using a unique key. */
  deleteSheetShapeLineBySheetShapeId?: Maybe<DeleteSheetShapeLinePayload>;
  /** Deletes a single `SheetShapePoint` using a unique key. */
  deleteSheetShapePoint?: Maybe<DeleteSheetShapePointPayload>;
  /** Deletes a single `SheetShapePoint` using its globally unique id. */
  deleteSheetShapePointByNodeId?: Maybe<DeleteSheetShapePointPayload>;
  /** Deletes a single `SheetShapePoint` using a unique key. */
  deleteSheetShapePointBySheetShapeId?: Maybe<DeleteSheetShapePointPayload>;
  /** Deletes a single `SheetShapePolygon` using a unique key. */
  deleteSheetShapePolygon?: Maybe<DeleteSheetShapePolygonPayload>;
  /** Deletes a single `SheetShapePolygon` using its globally unique id. */
  deleteSheetShapePolygonByNodeId?: Maybe<DeleteSheetShapePolygonPayload>;
  /** Deletes a single `SheetShapePolygon` using a unique key. */
  deleteSheetShapePolygonBySheetShapeId?: Maybe<DeleteSheetShapePolygonPayload>;
  /** Deletes a single `SheetShapeSplitLine` using a unique key. */
  deleteSheetShapeSplitLine?: Maybe<DeleteSheetShapeSplitLinePayload>;
  /** Deletes a single `SheetShapeSplitLine` using its globally unique id. */
  deleteSheetShapeSplitLineByNodeId?: Maybe<DeleteSheetShapeSplitLinePayload>;
  /** Deletes a single `SheetShapeSplitLine` using a unique key. */
  deleteSheetShapeSplitLineBySheetShapeId?: Maybe<DeleteSheetShapeSplitLinePayload>;
  deleteSheetVersion?: Maybe<DeleteSheetVersionPayload>;
  /** Deletes a single `SparkelAiAnalysis` using a unique key. */
  deleteSparkelAiAnalysis?: Maybe<DeleteSparkelAiAnalysisPayload>;
  /** Deletes a single `SparkelAiAnalysis` using its globally unique id. */
  deleteSparkelAiAnalysisByNodeId?: Maybe<DeleteSparkelAiAnalysisPayload>;
  /** Deletes a single `SparkelProperty` using a unique key. */
  deleteSparkelProperty?: Maybe<DeleteSparkelPropertyPayload>;
  /** Deletes a single `SparkelProperty` using its globally unique id. */
  deleteSparkelPropertyByNodeId?: Maybe<DeleteSparkelPropertyPayload>;
  /** Deletes a single `SparkelProperty` using a unique key. */
  deleteSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySet?: Maybe<DeleteSparkelPropertyPayload>;
  deleteUser: User;
  descriptionReader?: Maybe<GetDescriptionReaderResponse>;
  duplicateOrder?: Maybe<DuplicateOrderPayload>;
  duplicateProject?: Maybe<DuplicateProjectPayload>;
  exportShapesToIfc: ExportShapesToIfcPayload;
  flattenSubrows?: Maybe<FlattenSubrowsPayload>;
  getMagicSheetShape?: Maybe<GetMagicSheetShapeResponse>;
  importCompanyDatabaseData: ImportCompanyDatabaseDataPayload;
  invalidateLookupCacheForDatabase?: Maybe<InvalidateLookupCacheForDatabasePayload>;
  moveOrCopyOrderEntries?: Maybe<MoveOrCopyOrderEntriesPayload>;
  runClassification?: Maybe<RunClassificationResponse>;
  runExternalWallFinishes3D?: Maybe<ExternalWallFinishes3DResponse>;
  runRoomDetection2D: RoomDetection2DPayload;
  runSymbolDetection2D: SymbolDetection2DPayload;
  updateAccessibleProjectsForUser: User;
  /** Updates a single `AutoShape` using a unique key and a patch. */
  updateAutoShape?: Maybe<UpdateAutoShapePayload>;
  /** Updates a single `AutoShape` using its globally unique id and a patch. */
  updateAutoShapeByNodeId?: Maybe<UpdateAutoShapePayload>;
  /** Updates a single `Comment` using a unique key and a patch. */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** Updates a single `Comment` using its globally unique id and a patch. */
  updateCommentByNodeId?: Maybe<UpdateCommentPayload>;
  /** Updates a single `CompanyDatabaseCell` using a unique key and a patch. */
  updateCompanyDatabaseCell?: Maybe<UpdateCompanyDatabaseCellPayload>;
  /** Updates a single `CompanyDatabaseCell` using its globally unique id and a patch. */
  updateCompanyDatabaseCellByNodeId?: Maybe<UpdateCompanyDatabaseCellPayload>;
  /** Updates a single `CompanyDatabaseColumn` using a unique key and a patch. */
  updateCompanyDatabaseColumn?: Maybe<UpdateCompanyDatabaseColumnPayload>;
  /** Updates a single `CompanyDatabaseColumn` using its globally unique id and a patch. */
  updateCompanyDatabaseColumnByNodeId?: Maybe<UpdateCompanyDatabaseColumnPayload>;
  /** Updates a single `CompanyDatabaseImportJob` using a unique key and a patch. */
  updateCompanyDatabaseImportJob?: Maybe<UpdateCompanyDatabaseImportJobPayload>;
  /** Updates a single `CompanyDatabaseImportJob` using its globally unique id and a patch. */
  updateCompanyDatabaseImportJobByNodeId?: Maybe<UpdateCompanyDatabaseImportJobPayload>;
  /** Updates a single `CompanyDatabaseLookupCache` using a unique key and a patch. */
  updateCompanyDatabaseLookupCache?: Maybe<UpdateCompanyDatabaseLookupCachePayload>;
  /** Updates a single `CompanyDatabaseLookupCache` using a unique key and a patch. */
  updateCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: Maybe<UpdateCompanyDatabaseLookupCachePayload>;
  /** Updates a single `CompanyDatabaseLookupCache` using its globally unique id and a patch. */
  updateCompanyDatabaseLookupCacheByNodeId?: Maybe<UpdateCompanyDatabaseLookupCachePayload>;
  /** Updates a single `CompanyDatabaseLookupJob` using a unique key and a patch. */
  updateCompanyDatabaseLookupJob?: Maybe<UpdateCompanyDatabaseLookupJobPayload>;
  /** Updates a single `CompanyDatabaseLookupJob` using its globally unique id and a patch. */
  updateCompanyDatabaseLookupJobByNodeId?: Maybe<UpdateCompanyDatabaseLookupJobPayload>;
  /** Updates a single `CompanyDatabaseLookupProfile` using a unique key and a patch. */
  updateCompanyDatabaseLookupProfile?: Maybe<UpdateCompanyDatabaseLookupProfilePayload>;
  /** Updates a single `CompanyDatabaseLookupProfile` using its globally unique id and a patch. */
  updateCompanyDatabaseLookupProfileByNodeId?: Maybe<UpdateCompanyDatabaseLookupProfilePayload>;
  /** Updates a single `CompanyDatabaseRow` using a unique key and a patch. */
  updateCompanyDatabaseRow?: Maybe<UpdateCompanyDatabaseRowPayload>;
  /** Updates a single `CompanyDatabaseRow` using its globally unique id and a patch. */
  updateCompanyDatabaseRowByNodeId?: Maybe<UpdateCompanyDatabaseRowPayload>;
  /** Updates a single `CompanyDatabasis` using a unique key and a patch. */
  updateCompanyDatabasis?: Maybe<UpdateCompanyDatabasisPayload>;
  /** Updates a single `CompanyDatabasis` using its globally unique id and a patch. */
  updateCompanyDatabasisByNodeId?: Maybe<UpdateCompanyDatabasisPayload>;
  /** Updates a single `Contractor` using a unique key and a patch. */
  updateContractor?: Maybe<UpdateContractorPayload>;
  /** Updates a single `Contractor` using its globally unique id and a patch. */
  updateContractorByNodeId?: Maybe<UpdateContractorPayload>;
  /** Updates a single `Contractor` using a unique key and a patch. */
  updateContractorByTenant?: Maybe<UpdateContractorPayload>;
  /** Updates a single `CopilotExchange` using a unique key and a patch. */
  updateCopilotExchange?: Maybe<UpdateCopilotExchangePayload>;
  /** Updates a single `CopilotExchange` using its globally unique id and a patch. */
  updateCopilotExchangeByNodeId?: Maybe<UpdateCopilotExchangePayload>;
  /** Updates a single `CopilotExchangesFeedback` using a unique key and a patch. */
  updateCopilotExchangesFeedback?: Maybe<UpdateCopilotExchangesFeedbackPayload>;
  /** Updates a single `CopilotExchangesFeedback` using its globally unique id and a patch. */
  updateCopilotExchangesFeedbackByNodeId?: Maybe<UpdateCopilotExchangesFeedbackPayload>;
  /** Updates a single `CustomField` using a unique key and a patch. */
  updateCustomField?: Maybe<UpdateCustomFieldPayload>;
  /** Updates a single `CustomField` using its globally unique id and a patch. */
  updateCustomFieldByNodeId?: Maybe<UpdateCustomFieldPayload>;
  /** Updates a single `CustomField` using a unique key and a patch. */
  updateCustomFieldByOrderColumnIdAndOrderEntryId?: Maybe<UpdateCustomFieldPayload>;
  /** Updates a single `CustomFieldTemplate` using a unique key and a patch. */
  updateCustomFieldTemplate?: Maybe<UpdateCustomFieldTemplatePayload>;
  /** Updates a single `CustomFieldTemplate` using its globally unique id and a patch. */
  updateCustomFieldTemplateByNodeId?: Maybe<UpdateCustomFieldTemplatePayload>;
  /** Updates a single `ExtrudedPolygon` using a unique key and a patch. */
  updateExtrudedPolygon?: Maybe<UpdateExtrudedPolygonPayload>;
  /** Updates a single `ExtrudedPolygon` using its globally unique id and a patch. */
  updateExtrudedPolygonByNodeId?: Maybe<UpdateExtrudedPolygonPayload>;
  /** Updates a single `ExtrudedPolygon` using a unique key and a patch. */
  updateExtrudedPolygonByShapeId?: Maybe<UpdateExtrudedPolygonPayload>;
  /** Updates a single `Flow` using a unique key and a patch. */
  updateFlow?: Maybe<UpdateFlowPayload>;
  /** Updates a single `FlowAction` using a unique key and a patch. */
  updateFlowAction?: Maybe<UpdateFlowActionPayload>;
  /** Updates a single `FlowAction` using a unique key and a patch. */
  updateFlowActionByFlowIdAndPosition?: Maybe<UpdateFlowActionPayload>;
  /** Updates a single `FlowAction` using its globally unique id and a patch. */
  updateFlowActionByNodeId?: Maybe<UpdateFlowActionPayload>;
  /** Updates a single `Flow` using its globally unique id and a patch. */
  updateFlowByNodeId?: Maybe<UpdateFlowPayload>;
  /** Updates a single `FlowExecution` using a unique key and a patch. */
  updateFlowExecution?: Maybe<UpdateFlowExecutionPayload>;
  /** Updates a single `FlowExecution` using its globally unique id and a patch. */
  updateFlowExecutionByNodeId?: Maybe<UpdateFlowExecutionPayload>;
  /** Updates a single `FlowMailbox` using a unique key and a patch. */
  updateFlowMailbox?: Maybe<UpdateFlowMailboxPayload>;
  /** Updates a single `FlowMailbox` using a unique key and a patch. */
  updateFlowMailboxByContractorId?: Maybe<UpdateFlowMailboxPayload>;
  /** Updates a single `FlowMailbox` using a unique key and a patch. */
  updateFlowMailboxByEmailLocalPartAndEmailDomain?: Maybe<UpdateFlowMailboxPayload>;
  /** Updates a single `FlowMailbox` using its globally unique id and a patch. */
  updateFlowMailboxByNodeId?: Maybe<UpdateFlowMailboxPayload>;
  /** Updates a single `FlowMailboxMessage` using a unique key and a patch. */
  updateFlowMailboxMessage?: Maybe<UpdateFlowMailboxMessagePayload>;
  /** Updates a single `FlowMailboxMessage` using its globally unique id and a patch. */
  updateFlowMailboxMessageByNodeId?: Maybe<UpdateFlowMailboxMessagePayload>;
  /** Updates a single `HistoryEvent` using a unique key and a patch. */
  updateHistoryEvent?: Maybe<UpdateHistoryEventPayload>;
  /** Updates a single `HistoryEvent` using its globally unique id and a patch. */
  updateHistoryEventByNodeId?: Maybe<UpdateHistoryEventPayload>;
  /** Updates a single `InitialState` using a unique key and a patch. */
  updateInitialState?: Maybe<UpdateInitialStatePayload>;
  /** Updates a single `InitialState` using its globally unique id and a patch. */
  updateInitialStateByNodeId?: Maybe<UpdateInitialStatePayload>;
  /** Updates a single `Issue` using a unique key and a patch. */
  updateIssue?: Maybe<UpdateIssuePayload>;
  /** Updates a single `Issue` using its globally unique id and a patch. */
  updateIssueByNodeId?: Maybe<UpdateIssuePayload>;
  /** Updates a single `IssueComment` using a unique key and a patch. */
  updateIssueComment?: Maybe<UpdateIssueCommentPayload>;
  /** Updates a single `IssueComment` using its globally unique id and a patch. */
  updateIssueCommentByNodeId?: Maybe<UpdateIssueCommentPayload>;
  /** Updates a single `Line` using a unique key and a patch. */
  updateLine?: Maybe<UpdateLinePayload>;
  /** Updates a single `Line` using its globally unique id and a patch. */
  updateLineByNodeId?: Maybe<UpdateLinePayload>;
  /** Updates a single `Line` using a unique key and a patch. */
  updateLineByShapeId?: Maybe<UpdateLinePayload>;
  /** Updates a single `Model` using a unique key and a patch. */
  updateModel?: Maybe<UpdateModelPayload>;
  /** Updates a single `Model` using its globally unique id and a patch. */
  updateModelByNodeId?: Maybe<UpdateModelPayload>;
  /** Updates a single `Model` using a unique key and a patch. */
  updateModelByProjectIdAndNameAndVersion?: Maybe<UpdateModelPayload>;
  /** Updates a single `Order` using a unique key and a patch. */
  updateOrder?: Maybe<UpdateOrderPayload>;
  /** Updates a single `Order` using its globally unique id and a patch. */
  updateOrderByNodeId?: Maybe<UpdateOrderPayload>;
  /** Updates a single `OrderColumn` using a unique key and a patch. */
  updateOrderColumn?: Maybe<UpdateOrderColumnPayload>;
  /** Updates a single `OrderColumn` using a unique key and a patch. */
  updateOrderColumnByNameAndColumnTypeAndOrderId?: Maybe<UpdateOrderColumnPayload>;
  /** Updates a single `OrderColumn` using its globally unique id and a patch. */
  updateOrderColumnByNodeId?: Maybe<UpdateOrderColumnPayload>;
  /** Updates a single `OrderColumnTemplate` using a unique key and a patch. */
  updateOrderColumnTemplate?: Maybe<UpdateOrderColumnTemplatePayload>;
  /** Updates a single `OrderColumnTemplate` using its globally unique id and a patch. */
  updateOrderColumnTemplateByNodeId?: Maybe<UpdateOrderColumnTemplatePayload>;
  /** Updates a single `OrderEntry` using a unique key and a patch. */
  updateOrderEntry?: Maybe<UpdateOrderEntryPayload>;
  /** Updates a single `OrderEntry` using its globally unique id and a patch. */
  updateOrderEntryByNodeId?: Maybe<UpdateOrderEntryPayload>;
  /** Updates a single `OrderEntryCache` using a unique key and a patch. */
  updateOrderEntryCache?: Maybe<UpdateOrderEntryCachePayload>;
  /** Updates a single `OrderEntryCache` using its globally unique id and a patch. */
  updateOrderEntryCacheByNodeId?: Maybe<UpdateOrderEntryCachePayload>;
  /** Updates a single `OrderEntryCache` using a unique key and a patch. */
  updateOrderEntryCacheByOrderEntryId?: Maybe<UpdateOrderEntryCachePayload>;
  /** Updates a single `OrderEntryTemplate` using a unique key and a patch. */
  updateOrderEntryTemplate?: Maybe<UpdateOrderEntryTemplatePayload>;
  /** Updates a single `OrderEntryTemplate` using its globally unique id and a patch. */
  updateOrderEntryTemplateByNodeId?: Maybe<UpdateOrderEntryTemplatePayload>;
  /** Updates a single `OrderEntryView` using a unique key and a patch. */
  updateOrderEntryView?: Maybe<UpdateOrderEntryViewPayload>;
  /** Updates a single `OrderEntryView` using its globally unique id and a patch. */
  updateOrderEntryViewByNodeId?: Maybe<UpdateOrderEntryViewPayload>;
  /** Updates a single `OrderEntryView` using a unique key and a patch. */
  updateOrderEntryViewByProjectIdAndName?: Maybe<UpdateOrderEntryViewPayload>;
  /** Updates a single `Polygon` using a unique key and a patch. */
  updatePolygon?: Maybe<UpdatePolygonPayload>;
  /** Updates a single `Polygon` using its globally unique id and a patch. */
  updatePolygonByNodeId?: Maybe<UpdatePolygonPayload>;
  /** Updates a single `Polygon` using a unique key and a patch. */
  updatePolygonByShapeId?: Maybe<UpdatePolygonPayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Updates a single `Project` using its globally unique id and a patch. */
  updateProjectByNodeId?: Maybe<UpdateProjectPayload>;
  /** Updates a single `ProjectTag` using a unique key and a patch. */
  updateProjectTag?: Maybe<UpdateProjectTagPayload>;
  /** Updates a single `ProjectTag` using its globally unique id and a patch. */
  updateProjectTagByNodeId?: Maybe<UpdateProjectTagPayload>;
  /** Updates a single `ProjectTemplate` using a unique key and a patch. */
  updateProjectTemplate?: Maybe<UpdateProjectTemplatePayload>;
  /** Updates a single `ProjectTemplate` using its globally unique id and a patch. */
  updateProjectTemplateByNodeId?: Maybe<UpdateProjectTemplatePayload>;
  /** Updates a single `ProjectTemplateOrder` using a unique key and a patch. */
  updateProjectTemplateOrder?: Maybe<UpdateProjectTemplateOrderPayload>;
  /** Updates a single `ProjectTemplateOrder` using its globally unique id and a patch. */
  updateProjectTemplateOrderByNodeId?: Maybe<UpdateProjectTemplateOrderPayload>;
  /** Updates a single `ProjectTemplateOrderEntry` using a unique key and a patch. */
  updateProjectTemplateOrderEntry?: Maybe<UpdateProjectTemplateOrderEntryPayload>;
  /** Updates a single `ProjectTemplateOrderEntry` using its globally unique id and a patch. */
  updateProjectTemplateOrderEntryByNodeId?: Maybe<UpdateProjectTemplateOrderEntryPayload>;
  /** Updates a single `ProjectTemplateOrderEntryView` using a unique key and a patch. */
  updateProjectTemplateOrderEntryView?: Maybe<UpdateProjectTemplateOrderEntryViewPayload>;
  /** Updates a single `ProjectTemplateOrderEntryView` using its globally unique id and a patch. */
  updateProjectTemplateOrderEntryViewByNodeId?: Maybe<UpdateProjectTemplateOrderEntryViewPayload>;
  /** Updates a single `ProtanProjectStep` using a unique key and a patch. */
  updateProtanProjectStep?: Maybe<UpdateProtanProjectStepPayload>;
  /** Updates a single `ProtanProjectStep` using its globally unique id and a patch. */
  updateProtanProjectStepByNodeId?: Maybe<UpdateProtanProjectStepPayload>;
  /** Updates a single `ProtanProjectStep` using a unique key and a patch. */
  updateProtanProjectStepByProjectIdAndStep?: Maybe<UpdateProtanProjectStepPayload>;
  /** Updates a single `SavedView` using a unique key and a patch. */
  updateSavedView?: Maybe<UpdateSavedViewPayload>;
  /** Updates a single `SavedView` using a unique key and a patch. */
  updateSavedViewByNameAndProjectId?: Maybe<UpdateSavedViewPayload>;
  /** Updates a single `SavedView` using its globally unique id and a patch. */
  updateSavedViewByNodeId?: Maybe<UpdateSavedViewPayload>;
  /** Updates a single `Shape` using a unique key and a patch. */
  updateShape?: Maybe<UpdateShapePayload>;
  /** Updates a single `Shape` using its globally unique id and a patch. */
  updateShapeByNodeId?: Maybe<UpdateShapePayload>;
  /** Updates a single `Shape` using a unique key and a patch. */
  updateShapeByUrnAndDbId?: Maybe<UpdateShapePayload>;
  /** Updates a single `ShapeFolder` using a unique key and a patch. */
  updateShapeFolder?: Maybe<UpdateShapeFolderPayload>;
  /** Updates a single `ShapeFolder` using its globally unique id and a patch. */
  updateShapeFolderByNodeId?: Maybe<UpdateShapeFolderPayload>;
  /** Updates a single `ShapeFolder` using a unique key and a patch. */
  updateShapeFolderByProjectIdAndName?: Maybe<UpdateShapeFolderPayload>;
  /** Updates a single `ShapePoint` using a unique key and a patch. */
  updateShapePoint?: Maybe<UpdateShapePointPayload>;
  /** Updates a single `ShapePoint` using its globally unique id and a patch. */
  updateShapePointByNodeId?: Maybe<UpdateShapePointPayload>;
  /** Updates a single `ShapePoint` using a unique key and a patch. */
  updateShapePointByShapeId?: Maybe<UpdateShapePointPayload>;
  /** Updates a single `SharedLink` using a unique key and a patch. */
  updateSharedLink?: Maybe<UpdateSharedLinkPayload>;
  /** Updates a single `SharedLink` using a unique key and a patch. */
  updateSharedLinkByInitialStateId?: Maybe<UpdateSharedLinkPayload>;
  /** Updates a single `SharedLink` using its globally unique id and a patch. */
  updateSharedLinkByNodeId?: Maybe<UpdateSharedLinkPayload>;
  /** Updates a single `Sheet` using a unique key and a patch. */
  updateSheet?: Maybe<UpdateSheetPayload>;
  /** Updates a single `Sheet` using its globally unique id and a patch. */
  updateSheetByNodeId?: Maybe<UpdateSheetPayload>;
  /** Updates a single `Sheet` using a unique key and a patch. */
  updateSheetByProjectIdAndNameAndVersion?: Maybe<UpdateSheetPayload>;
  /** Updates a single `SheetPageCalibration` using a unique key and a patch. */
  updateSheetPageCalibration?: Maybe<UpdateSheetPageCalibrationPayload>;
  /** Updates a single `SheetPageCalibration` using its globally unique id and a patch. */
  updateSheetPageCalibrationByNodeId?: Maybe<UpdateSheetPageCalibrationPayload>;
  /** Updates a single `SheetShape` using a unique key and a patch. */
  updateSheetShape?: Maybe<UpdateSheetShapePayload>;
  /** Updates a single `SheetShape` using its globally unique id and a patch. */
  updateSheetShapeByNodeId?: Maybe<UpdateSheetShapePayload>;
  /** Updates a single `SheetShape` using a unique key and a patch. */
  updateSheetShapeByUrnAndDbId?: Maybe<UpdateSheetShapePayload>;
  /** Updates a single `SheetShapeLegend` using a unique key and a patch. */
  updateSheetShapeLegend?: Maybe<UpdateSheetShapeLegendPayload>;
  /** Updates a single `SheetShapeLegend` using its globally unique id and a patch. */
  updateSheetShapeLegendByNodeId?: Maybe<UpdateSheetShapeLegendPayload>;
  /** Updates a single `SheetShapeLegend` using a unique key and a patch. */
  updateSheetShapeLegendBySheetShapeId?: Maybe<UpdateSheetShapeLegendPayload>;
  /** Updates a single `SheetShapeLine` using a unique key and a patch. */
  updateSheetShapeLine?: Maybe<UpdateSheetShapeLinePayload>;
  /** Updates a single `SheetShapeLine` using its globally unique id and a patch. */
  updateSheetShapeLineByNodeId?: Maybe<UpdateSheetShapeLinePayload>;
  /** Updates a single `SheetShapeLine` using a unique key and a patch. */
  updateSheetShapeLineBySheetShapeId?: Maybe<UpdateSheetShapeLinePayload>;
  /** Updates a single `SheetShapePoint` using a unique key and a patch. */
  updateSheetShapePoint?: Maybe<UpdateSheetShapePointPayload>;
  /** Updates a single `SheetShapePoint` using its globally unique id and a patch. */
  updateSheetShapePointByNodeId?: Maybe<UpdateSheetShapePointPayload>;
  /** Updates a single `SheetShapePoint` using a unique key and a patch. */
  updateSheetShapePointBySheetShapeId?: Maybe<UpdateSheetShapePointPayload>;
  /** Updates a single `SheetShapePolygon` using a unique key and a patch. */
  updateSheetShapePolygon?: Maybe<UpdateSheetShapePolygonPayload>;
  /** Updates a single `SheetShapePolygon` using its globally unique id and a patch. */
  updateSheetShapePolygonByNodeId?: Maybe<UpdateSheetShapePolygonPayload>;
  /** Updates a single `SheetShapePolygon` using a unique key and a patch. */
  updateSheetShapePolygonBySheetShapeId?: Maybe<UpdateSheetShapePolygonPayload>;
  /** Updates a single `SheetShapeSplitLine` using a unique key and a patch. */
  updateSheetShapeSplitLine?: Maybe<UpdateSheetShapeSplitLinePayload>;
  /** Updates a single `SheetShapeSplitLine` using its globally unique id and a patch. */
  updateSheetShapeSplitLineByNodeId?: Maybe<UpdateSheetShapeSplitLinePayload>;
  /** Updates a single `SheetShapeSplitLine` using a unique key and a patch. */
  updateSheetShapeSplitLineBySheetShapeId?: Maybe<UpdateSheetShapeSplitLinePayload>;
  /** Updates a single `SparkelAiAnalysis` using a unique key and a patch. */
  updateSparkelAiAnalysis?: Maybe<UpdateSparkelAiAnalysisPayload>;
  /** Updates a single `SparkelAiAnalysis` using its globally unique id and a patch. */
  updateSparkelAiAnalysisByNodeId?: Maybe<UpdateSparkelAiAnalysisPayload>;
  /** Updates a single `SparkelProperty` using a unique key and a patch. */
  updateSparkelProperty?: Maybe<UpdateSparkelPropertyPayload>;
  /** Updates a single `SparkelProperty` using its globally unique id and a patch. */
  updateSparkelPropertyByNodeId?: Maybe<UpdateSparkelPropertyPayload>;
  /** Updates a single `SparkelProperty` using a unique key and a patch. */
  updateSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySet?: Maybe<UpdateSparkelPropertyPayload>;
  upsertProtanProjectStep?: Maybe<UpsertProtanProjectStepPayload>;
  verifyApiClientSecret?: Maybe<VerifyApiClientSecretPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApplyPromptLinkingArgs = {
  input: ApplyPromptLinkingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAskCopilotArgs = {
  projectId: Scalars['UUID'];
  query: Scalars['String'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkCreateShapesArgs = {
  input: BulkCreateShapesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkCreateSheetShapesArgs = {
  input: BulkCreateSheetShapesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkDeleteShapesArgs = {
  input: BulkDeleteShapesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkDeleteSheetShapesArgs = {
  input: BulkDeleteSheetShapesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkDeleteSparkelPropertiesArgs = {
  input: BulkDeleteSparkelPropertiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkUpdateShapesArgs = {
  input: BulkUpdateShapesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkUpdateSheetShapesArgs = {
  input: BulkUpdateSheetShapesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkUpsertOrderEntryCacheArgs = {
  input: BulkUpsertOrderEntryCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkUpsertSparkelPropertiesArgs = {
  input: BulkUpsertSparkelPropertiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiClientArgs = {
  input: CreateApiClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAutoShapeArgs = {
  input: CreateAutoShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseCellArgs = {
  input: CreateCompanyDatabaseCellInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseColumnArgs = {
  input: CreateCompanyDatabaseColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseImportJobArgs = {
  input: CreateCompanyDatabaseImportJobInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseLookupCacheArgs = {
  input: CreateCompanyDatabaseLookupCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseLookupJobArgs = {
  input: CreateCompanyDatabaseLookupJobInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseLookupProfileArgs = {
  input: CreateCompanyDatabaseLookupProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabaseRowArgs = {
  input: CreateCompanyDatabaseRowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyDatabasisArgs = {
  input: CreateCompanyDatabasisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractorArgs = {
  input: CreateContractorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCopilotExchangeArgs = {
  input: CreateCopilotExchangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCopilotExchangesFeedbackArgs = {
  input: CreateCopilotExchangesFeedbackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomFieldArgs = {
  input: CreateCustomFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomFieldTemplateArgs = {
  input: CreateCustomFieldTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExtrudedPolygonArgs = {
  input: CreateExtrudedPolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowArgs = {
  input: CreateFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowActionArgs = {
  input: CreateFlowActionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowExecutionArgs = {
  input: CreateFlowExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowMailboxArgs = {
  input: CreateFlowMailboxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowMailboxMessageArgs = {
  input: CreateFlowMailboxMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateHistoryEventArgs = {
  input: CreateHistoryEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInitialStateArgs = {
  input: CreateInitialStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIssueArgs = {
  input: CreateIssueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIssueCommentArgs = {
  input: CreateIssueCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLineArgs = {
  input: CreateLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateModelArgs = {
  input: CreateModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderColumnArgs = {
  input: CreateOrderColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderColumnTemplateArgs = {
  input: CreateOrderColumnTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderEntryArgs = {
  input: CreateOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderEntryCacheArgs = {
  input: CreateOrderEntryCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderEntryFromTemplateArgs = {
  input: CreateOrderEntryFromTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderEntryTemplateArgs = {
  input: CreateOrderEntryTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderEntryViewArgs = {
  input: CreateOrderEntryViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderFromTableArgs = {
  contractorId: Scalars['UUID'];
  databaseId: Scalars['UUID'];
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  orderName?: InputMaybe<Scalars['String']>;
  projectName?: InputMaybe<Scalars['String']>;
  rows: Array<TableRowInput>;
  searchColumnId: Scalars['UUID'];
  valueColumnId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePolygonArgs = {
  input: CreatePolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectFromDocumentsArgs = {
  input: CreateProjectFromDocumentsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectFromTemplateArgs = {
  input: CreateProjectFromTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTagArgs = {
  input: CreateProjectTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTemplateArgs = {
  input: CreateProjectTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTemplateOrderArgs = {
  input: CreateProjectTemplateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTemplateOrderEntryArgs = {
  input: CreateProjectTemplateOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTemplateOrderEntryViewArgs = {
  input: CreateProjectTemplateOrderEntryViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProtanProjectStepArgs = {
  input: CreateProtanProjectStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePublicInitialStateArgs = {
  input: CreatePublicInitialStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShapeArgs = {
  input: CreateShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShapeFolderArgs = {
  input: CreateShapeFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShapePointArgs = {
  input: CreateShapePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSharedLinkArgs = {
  input: CreateSharedLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSharedLinkWithDurationArgs = {
  input: CreateSharedLinkWithDurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetArgs = {
  input: CreateSheetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetPageCalibrationArgs = {
  input: CreateSheetPageCalibrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetShapeArgs = {
  input: CreateSheetShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetShapeLegendArgs = {
  input: CreateSheetShapeLegendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetShapeLineArgs = {
  input: CreateSheetShapeLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetShapePointArgs = {
  input: CreateSheetShapePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetShapePolygonArgs = {
  input: CreateSheetShapePolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSheetShapeSplitLineArgs = {
  input: CreateSheetShapeSplitLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSparkelAiAnalysisArgs = {
  input: CreateSparkelAiAnalysisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSparkelPropertyArgs = {
  input: CreateSparkelPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTableFromTemplateArgs = {
  input: CreateTableFromTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTemplateFromOrderEntryArgs = {
  input: CreateTemplateFromOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTemplateFromProjectArgs = {
  input: CreateTemplateFromProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAutoShapeArgs = {
  input: DeleteAutoShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAutoShapeByNodeIdArgs = {
  input: DeleteAutoShapeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAutoShapeShapesArgs = {
  autoShapeId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommentByNodeIdArgs = {
  input: DeleteCommentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseCellArgs = {
  input: DeleteCompanyDatabaseCellInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseCellByNodeIdArgs = {
  input: DeleteCompanyDatabaseCellByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseColumnArgs = {
  input: DeleteCompanyDatabaseColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseColumnByNodeIdArgs = {
  input: DeleteCompanyDatabaseColumnByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseImportJobArgs = {
  input: DeleteCompanyDatabaseImportJobInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseImportJobByNodeIdArgs = {
  input: DeleteCompanyDatabaseImportJobByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupCacheArgs = {
  input: DeleteCompanyDatabaseLookupCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdArgs = {
  input: DeleteCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupCacheByNodeIdArgs = {
  input: DeleteCompanyDatabaseLookupCacheByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupJobArgs = {
  input: DeleteCompanyDatabaseLookupJobInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupJobByNodeIdArgs = {
  input: DeleteCompanyDatabaseLookupJobByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupProfileArgs = {
  input: DeleteCompanyDatabaseLookupProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseLookupProfileByNodeIdArgs = {
  input: DeleteCompanyDatabaseLookupProfileByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseRowArgs = {
  input: DeleteCompanyDatabaseRowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabaseRowByNodeIdArgs = {
  input: DeleteCompanyDatabaseRowByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabasisArgs = {
  input: DeleteCompanyDatabasisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyDatabasisByNodeIdArgs = {
  input: DeleteCompanyDatabasisByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractorArgs = {
  input: DeleteContractorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractorByNodeIdArgs = {
  input: DeleteContractorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractorByTenantArgs = {
  input: DeleteContractorByTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCopilotExchangeArgs = {
  input: DeleteCopilotExchangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCopilotExchangeByNodeIdArgs = {
  input: DeleteCopilotExchangeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCopilotExchangesFeedbackArgs = {
  input: DeleteCopilotExchangesFeedbackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCopilotExchangesFeedbackByNodeIdArgs = {
  input: DeleteCopilotExchangesFeedbackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomFieldArgs = {
  input: DeleteCustomFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomFieldByNodeIdArgs = {
  input: DeleteCustomFieldByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomFieldByOrderColumnIdAndOrderEntryIdArgs = {
  input: DeleteCustomFieldByOrderColumnIdAndOrderEntryIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomFieldTemplateArgs = {
  input: DeleteCustomFieldTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomFieldTemplateByNodeIdArgs = {
  input: DeleteCustomFieldTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExtrudedPolygonArgs = {
  input: DeleteExtrudedPolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExtrudedPolygonByNodeIdArgs = {
  input: DeleteExtrudedPolygonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExtrudedPolygonByShapeIdArgs = {
  input: DeleteExtrudedPolygonByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowArgs = {
  input: DeleteFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowActionArgs = {
  input: DeleteFlowActionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowActionByFlowIdAndPositionArgs = {
  input: DeleteFlowActionByFlowIdAndPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowActionByNodeIdArgs = {
  input: DeleteFlowActionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowByNodeIdArgs = {
  input: DeleteFlowByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowExecutionArgs = {
  input: DeleteFlowExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowExecutionByNodeIdArgs = {
  input: DeleteFlowExecutionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowMailboxArgs = {
  input: DeleteFlowMailboxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowMailboxByContractorIdArgs = {
  input: DeleteFlowMailboxByContractorIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowMailboxByEmailLocalPartAndEmailDomainArgs = {
  input: DeleteFlowMailboxByEmailLocalPartAndEmailDomainInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowMailboxByNodeIdArgs = {
  input: DeleteFlowMailboxByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowMailboxMessageArgs = {
  input: DeleteFlowMailboxMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowMailboxMessageByNodeIdArgs = {
  input: DeleteFlowMailboxMessageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHistoryEventArgs = {
  input: DeleteHistoryEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHistoryEventByNodeIdArgs = {
  input: DeleteHistoryEventByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInitialStateArgs = {
  input: DeleteInitialStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInitialStateByNodeIdArgs = {
  input: DeleteInitialStateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIssueArgs = {
  input: DeleteIssueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIssueByNodeIdArgs = {
  input: DeleteIssueByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIssueCommentArgs = {
  input: DeleteIssueCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIssueCommentByNodeIdArgs = {
  input: DeleteIssueCommentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineArgs = {
  input: DeleteLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineByNodeIdArgs = {
  input: DeleteLineByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLineByShapeIdArgs = {
  input: DeleteLineByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteModelArgs = {
  input: DeleteModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteModelByNodeIdArgs = {
  input: DeleteModelByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteModelByProjectIdAndNameAndVersionArgs = {
  input: DeleteModelByProjectIdAndNameAndVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteModelVersionArgs = {
  input: DeleteModelVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderByNodeIdArgs = {
  input: DeleteOrderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderColumnArgs = {
  input: DeleteOrderColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderColumnByNameAndColumnTypeAndOrderIdArgs = {
  input: DeleteOrderColumnByNameAndColumnTypeAndOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderColumnByNodeIdArgs = {
  input: DeleteOrderColumnByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderColumnTemplateArgs = {
  input: DeleteOrderColumnTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderColumnTemplateByNodeIdArgs = {
  input: DeleteOrderColumnTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryArgs = {
  input: DeleteOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryByNodeIdArgs = {
  input: DeleteOrderEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryCacheArgs = {
  input: DeleteOrderEntryCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryCacheByNodeIdArgs = {
  input: DeleteOrderEntryCacheByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryCacheByOrderEntryIdArgs = {
  input: DeleteOrderEntryCacheByOrderEntryIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryTemplateArgs = {
  input: DeleteOrderEntryTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryTemplateByNodeIdArgs = {
  input: DeleteOrderEntryTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryViewArgs = {
  input: DeleteOrderEntryViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryViewByNodeIdArgs = {
  input: DeleteOrderEntryViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderEntryViewByProjectIdAndNameArgs = {
  input: DeleteOrderEntryViewByProjectIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePolygonArgs = {
  input: DeletePolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePolygonByNodeIdArgs = {
  input: DeletePolygonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePolygonByShapeIdArgs = {
  input: DeletePolygonByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectByNodeIdArgs = {
  input: DeleteProjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTagArgs = {
  input: DeleteProjectTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTagByNodeIdArgs = {
  input: DeleteProjectTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateArgs = {
  input: DeleteProjectTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateByNodeIdArgs = {
  input: DeleteProjectTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateOrderArgs = {
  input: DeleteProjectTemplateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateOrderByNodeIdArgs = {
  input: DeleteProjectTemplateOrderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateOrderEntryArgs = {
  input: DeleteProjectTemplateOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateOrderEntryByNodeIdArgs = {
  input: DeleteProjectTemplateOrderEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateOrderEntryViewArgs = {
  input: DeleteProjectTemplateOrderEntryViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTemplateOrderEntryViewByNodeIdArgs = {
  input: DeleteProjectTemplateOrderEntryViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProtanProjectStepArgs = {
  input: DeleteProtanProjectStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProtanProjectStepByNodeIdArgs = {
  input: DeleteProtanProjectStepByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProtanProjectStepByProjectIdAndStepArgs = {
  input: DeleteProtanProjectStepByProjectIdAndStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavedViewArgs = {
  input: DeleteSavedViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavedViewByNameAndProjectIdArgs = {
  input: DeleteSavedViewByNameAndProjectIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavedViewByNodeIdArgs = {
  input: DeleteSavedViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapeArgs = {
  input: DeleteShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapeByNodeIdArgs = {
  input: DeleteShapeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapeByUrnAndDbIdArgs = {
  input: DeleteShapeByUrnAndDbIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapeFolderArgs = {
  input: DeleteShapeFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapeFolderByNodeIdArgs = {
  input: DeleteShapeFolderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapeFolderByProjectIdAndNameArgs = {
  input: DeleteShapeFolderByProjectIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapePointArgs = {
  input: DeleteShapePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapePointByNodeIdArgs = {
  input: DeleteShapePointByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShapePointByShapeIdArgs = {
  input: DeleteShapePointByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSharedLinkArgs = {
  input: DeleteSharedLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSharedLinkByInitialStateIdArgs = {
  input: DeleteSharedLinkByInitialStateIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSharedLinkByNodeIdArgs = {
  input: DeleteSharedLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetArgs = {
  input: DeleteSheetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetByNodeIdArgs = {
  input: DeleteSheetByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetByProjectIdAndNameAndVersionArgs = {
  input: DeleteSheetByProjectIdAndNameAndVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetPageCalibrationArgs = {
  input: DeleteSheetPageCalibrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetPageCalibrationByNodeIdArgs = {
  input: DeleteSheetPageCalibrationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeArgs = {
  input: DeleteSheetShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeByNodeIdArgs = {
  input: DeleteSheetShapeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeByUrnAndDbIdArgs = {
  input: DeleteSheetShapeByUrnAndDbIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeLegendArgs = {
  input: DeleteSheetShapeLegendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeLegendByNodeIdArgs = {
  input: DeleteSheetShapeLegendByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeLegendBySheetShapeIdArgs = {
  input: DeleteSheetShapeLegendBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeLineArgs = {
  input: DeleteSheetShapeLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeLineByNodeIdArgs = {
  input: DeleteSheetShapeLineByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeLineBySheetShapeIdArgs = {
  input: DeleteSheetShapeLineBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapePointArgs = {
  input: DeleteSheetShapePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapePointByNodeIdArgs = {
  input: DeleteSheetShapePointByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapePointBySheetShapeIdArgs = {
  input: DeleteSheetShapePointBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapePolygonArgs = {
  input: DeleteSheetShapePolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapePolygonByNodeIdArgs = {
  input: DeleteSheetShapePolygonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapePolygonBySheetShapeIdArgs = {
  input: DeleteSheetShapePolygonBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeSplitLineArgs = {
  input: DeleteSheetShapeSplitLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeSplitLineByNodeIdArgs = {
  input: DeleteSheetShapeSplitLineByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetShapeSplitLineBySheetShapeIdArgs = {
  input: DeleteSheetShapeSplitLineBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSheetVersionArgs = {
  input: DeleteSheetVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSparkelAiAnalysisArgs = {
  input: DeleteSparkelAiAnalysisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSparkelAiAnalysisByNodeIdArgs = {
  input: DeleteSparkelAiAnalysisByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSparkelPropertyArgs = {
  input: DeleteSparkelPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSparkelPropertyByNodeIdArgs = {
  input: DeleteSparkelPropertyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetArgs = {
  input: DeleteSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  id: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDescriptionReaderArgs = {
  input: GetDescriptionReaderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDuplicateOrderArgs = {
  input: DuplicateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDuplicateProjectArgs = {
  input: DuplicateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExportShapesToIfcArgs = {
  input: ExportShapesToIfcInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFlattenSubrowsArgs = {
  input: FlattenSubrowsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetMagicSheetShapeArgs = {
  input: GetMagicSheetShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportCompanyDatabaseDataArgs = {
  input: ImportCompanyDatabaseDataInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInvalidateLookupCacheForDatabaseArgs = {
  input: InvalidateLookupCacheForDatabaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMoveOrCopyOrderEntriesArgs = {
  input: MoveOrCopyOrderEntriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRunClassificationArgs = {
  input: RunClassificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRunExternalWallFinishes3DArgs = {
  input: ExternalWallFinishes3DInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRunRoomDetection2DArgs = {
  input: RoomDetection2DInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRunSymbolDetection2DArgs = {
  input: SymbolDetection2DInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccessibleProjectsForUserArgs = {
  id: Scalars['UUID'];
  projectIds?: InputMaybe<Array<Scalars['UUID']>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAutoShapeArgs = {
  input: UpdateAutoShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAutoShapeByNodeIdArgs = {
  input: UpdateAutoShapeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommentByNodeIdArgs = {
  input: UpdateCommentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseCellArgs = {
  input: UpdateCompanyDatabaseCellInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseCellByNodeIdArgs = {
  input: UpdateCompanyDatabaseCellByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseColumnArgs = {
  input: UpdateCompanyDatabaseColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseColumnByNodeIdArgs = {
  input: UpdateCompanyDatabaseColumnByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseImportJobArgs = {
  input: UpdateCompanyDatabaseImportJobInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseImportJobByNodeIdArgs = {
  input: UpdateCompanyDatabaseImportJobByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupCacheArgs = {
  input: UpdateCompanyDatabaseLookupCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdArgs = {
  input: UpdateCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupCacheByNodeIdArgs = {
  input: UpdateCompanyDatabaseLookupCacheByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupJobArgs = {
  input: UpdateCompanyDatabaseLookupJobInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupJobByNodeIdArgs = {
  input: UpdateCompanyDatabaseLookupJobByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupProfileArgs = {
  input: UpdateCompanyDatabaseLookupProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseLookupProfileByNodeIdArgs = {
  input: UpdateCompanyDatabaseLookupProfileByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseRowArgs = {
  input: UpdateCompanyDatabaseRowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabaseRowByNodeIdArgs = {
  input: UpdateCompanyDatabaseRowByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabasisArgs = {
  input: UpdateCompanyDatabasisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyDatabasisByNodeIdArgs = {
  input: UpdateCompanyDatabasisByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractorByNodeIdArgs = {
  input: UpdateContractorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractorByTenantArgs = {
  input: UpdateContractorByTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCopilotExchangeArgs = {
  input: UpdateCopilotExchangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCopilotExchangeByNodeIdArgs = {
  input: UpdateCopilotExchangeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCopilotExchangesFeedbackArgs = {
  input: UpdateCopilotExchangesFeedbackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCopilotExchangesFeedbackByNodeIdArgs = {
  input: UpdateCopilotExchangesFeedbackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomFieldArgs = {
  input: UpdateCustomFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomFieldByNodeIdArgs = {
  input: UpdateCustomFieldByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomFieldByOrderColumnIdAndOrderEntryIdArgs = {
  input: UpdateCustomFieldByOrderColumnIdAndOrderEntryIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomFieldTemplateArgs = {
  input: UpdateCustomFieldTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomFieldTemplateByNodeIdArgs = {
  input: UpdateCustomFieldTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExtrudedPolygonArgs = {
  input: UpdateExtrudedPolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExtrudedPolygonByNodeIdArgs = {
  input: UpdateExtrudedPolygonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExtrudedPolygonByShapeIdArgs = {
  input: UpdateExtrudedPolygonByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowArgs = {
  input: UpdateFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowActionArgs = {
  input: UpdateFlowActionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowActionByFlowIdAndPositionArgs = {
  input: UpdateFlowActionByFlowIdAndPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowActionByNodeIdArgs = {
  input: UpdateFlowActionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowByNodeIdArgs = {
  input: UpdateFlowByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowExecutionArgs = {
  input: UpdateFlowExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowExecutionByNodeIdArgs = {
  input: UpdateFlowExecutionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowMailboxArgs = {
  input: UpdateFlowMailboxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowMailboxByContractorIdArgs = {
  input: UpdateFlowMailboxByContractorIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowMailboxByEmailLocalPartAndEmailDomainArgs = {
  input: UpdateFlowMailboxByEmailLocalPartAndEmailDomainInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowMailboxByNodeIdArgs = {
  input: UpdateFlowMailboxByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowMailboxMessageArgs = {
  input: UpdateFlowMailboxMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowMailboxMessageByNodeIdArgs = {
  input: UpdateFlowMailboxMessageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHistoryEventArgs = {
  input: UpdateHistoryEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHistoryEventByNodeIdArgs = {
  input: UpdateHistoryEventByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInitialStateArgs = {
  input: UpdateInitialStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInitialStateByNodeIdArgs = {
  input: UpdateInitialStateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIssueArgs = {
  input: UpdateIssueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIssueByNodeIdArgs = {
  input: UpdateIssueByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIssueCommentArgs = {
  input: UpdateIssueCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIssueCommentByNodeIdArgs = {
  input: UpdateIssueCommentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineArgs = {
  input: UpdateLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineByNodeIdArgs = {
  input: UpdateLineByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLineByShapeIdArgs = {
  input: UpdateLineByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateModelArgs = {
  input: UpdateModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateModelByNodeIdArgs = {
  input: UpdateModelByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateModelByProjectIdAndNameAndVersionArgs = {
  input: UpdateModelByProjectIdAndNameAndVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderByNodeIdArgs = {
  input: UpdateOrderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderColumnArgs = {
  input: UpdateOrderColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderColumnByNameAndColumnTypeAndOrderIdArgs = {
  input: UpdateOrderColumnByNameAndColumnTypeAndOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderColumnByNodeIdArgs = {
  input: UpdateOrderColumnByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderColumnTemplateArgs = {
  input: UpdateOrderColumnTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderColumnTemplateByNodeIdArgs = {
  input: UpdateOrderColumnTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryArgs = {
  input: UpdateOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryByNodeIdArgs = {
  input: UpdateOrderEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryCacheArgs = {
  input: UpdateOrderEntryCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryCacheByNodeIdArgs = {
  input: UpdateOrderEntryCacheByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryCacheByOrderEntryIdArgs = {
  input: UpdateOrderEntryCacheByOrderEntryIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryTemplateArgs = {
  input: UpdateOrderEntryTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryTemplateByNodeIdArgs = {
  input: UpdateOrderEntryTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryViewArgs = {
  input: UpdateOrderEntryViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryViewByNodeIdArgs = {
  input: UpdateOrderEntryViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderEntryViewByProjectIdAndNameArgs = {
  input: UpdateOrderEntryViewByProjectIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePolygonArgs = {
  input: UpdatePolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePolygonByNodeIdArgs = {
  input: UpdatePolygonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePolygonByShapeIdArgs = {
  input: UpdatePolygonByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectByNodeIdArgs = {
  input: UpdateProjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTagArgs = {
  input: UpdateProjectTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTagByNodeIdArgs = {
  input: UpdateProjectTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateArgs = {
  input: UpdateProjectTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateByNodeIdArgs = {
  input: UpdateProjectTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateOrderArgs = {
  input: UpdateProjectTemplateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateOrderByNodeIdArgs = {
  input: UpdateProjectTemplateOrderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateOrderEntryArgs = {
  input: UpdateProjectTemplateOrderEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateOrderEntryByNodeIdArgs = {
  input: UpdateProjectTemplateOrderEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateOrderEntryViewArgs = {
  input: UpdateProjectTemplateOrderEntryViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateOrderEntryViewByNodeIdArgs = {
  input: UpdateProjectTemplateOrderEntryViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProtanProjectStepArgs = {
  input: UpdateProtanProjectStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProtanProjectStepByNodeIdArgs = {
  input: UpdateProtanProjectStepByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProtanProjectStepByProjectIdAndStepArgs = {
  input: UpdateProtanProjectStepByProjectIdAndStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavedViewArgs = {
  input: UpdateSavedViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavedViewByNameAndProjectIdArgs = {
  input: UpdateSavedViewByNameAndProjectIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavedViewByNodeIdArgs = {
  input: UpdateSavedViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapeArgs = {
  input: UpdateShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapeByNodeIdArgs = {
  input: UpdateShapeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapeByUrnAndDbIdArgs = {
  input: UpdateShapeByUrnAndDbIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapeFolderArgs = {
  input: UpdateShapeFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapeFolderByNodeIdArgs = {
  input: UpdateShapeFolderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapeFolderByProjectIdAndNameArgs = {
  input: UpdateShapeFolderByProjectIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapePointArgs = {
  input: UpdateShapePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapePointByNodeIdArgs = {
  input: UpdateShapePointByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShapePointByShapeIdArgs = {
  input: UpdateShapePointByShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSharedLinkArgs = {
  input: UpdateSharedLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSharedLinkByInitialStateIdArgs = {
  input: UpdateSharedLinkByInitialStateIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSharedLinkByNodeIdArgs = {
  input: UpdateSharedLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetArgs = {
  input: UpdateSheetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetByNodeIdArgs = {
  input: UpdateSheetByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetByProjectIdAndNameAndVersionArgs = {
  input: UpdateSheetByProjectIdAndNameAndVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetPageCalibrationArgs = {
  input: UpdateSheetPageCalibrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetPageCalibrationByNodeIdArgs = {
  input: UpdateSheetPageCalibrationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeArgs = {
  input: UpdateSheetShapeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeByNodeIdArgs = {
  input: UpdateSheetShapeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeByUrnAndDbIdArgs = {
  input: UpdateSheetShapeByUrnAndDbIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeLegendArgs = {
  input: UpdateSheetShapeLegendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeLegendByNodeIdArgs = {
  input: UpdateSheetShapeLegendByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeLegendBySheetShapeIdArgs = {
  input: UpdateSheetShapeLegendBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeLineArgs = {
  input: UpdateSheetShapeLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeLineByNodeIdArgs = {
  input: UpdateSheetShapeLineByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeLineBySheetShapeIdArgs = {
  input: UpdateSheetShapeLineBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapePointArgs = {
  input: UpdateSheetShapePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapePointByNodeIdArgs = {
  input: UpdateSheetShapePointByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapePointBySheetShapeIdArgs = {
  input: UpdateSheetShapePointBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapePolygonArgs = {
  input: UpdateSheetShapePolygonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapePolygonByNodeIdArgs = {
  input: UpdateSheetShapePolygonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapePolygonBySheetShapeIdArgs = {
  input: UpdateSheetShapePolygonBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeSplitLineArgs = {
  input: UpdateSheetShapeSplitLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeSplitLineByNodeIdArgs = {
  input: UpdateSheetShapeSplitLineByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSheetShapeSplitLineBySheetShapeIdArgs = {
  input: UpdateSheetShapeSplitLineBySheetShapeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSparkelAiAnalysisArgs = {
  input: UpdateSparkelAiAnalysisInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSparkelAiAnalysisByNodeIdArgs = {
  input: UpdateSparkelAiAnalysisByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSparkelPropertyArgs = {
  input: UpdateSparkelPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSparkelPropertyByNodeIdArgs = {
  input: UpdateSparkelPropertyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetArgs = {
  input: UpdateSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProtanProjectStepArgs = {
  input: UpsertProtanProjectStepInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyApiClientSecretArgs = {
  input: VerifyApiClientSecretInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export enum ObjTranslationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** A filter to be used against ObjTranslationStatus fields. All fields are combined with a logical ‘and.’ */
export type ObjTranslationStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ObjTranslationStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ObjTranslationStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ObjTranslationStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ObjTranslationStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ObjTranslationStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ObjTranslationStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ObjTranslationStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ObjTranslationStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ObjTranslationStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ObjTranslationStatus>>;
};

export type Order = Node & {
  __typename?: 'Order';
  aggregatedOrderAggregation?: Maybe<Array<AggregatedOrderAggregationType>>;
  aggregatedOrderFilters?: Maybe<Array<AggregatedOrderFilterType>>;
  aggregatedOrderGrouping?: Maybe<Array<AggregatedOrderGroupingType>>;
  aggregatedOrderView?: Maybe<AggregatedOrderViewType>;
  areItemsFlattened?: Maybe<Scalars['Boolean']>;
  columnNameMapping?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Comment`. */
  comments: Array<Comment>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsConnection: CommentsConnection;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isAggregatedOrder: Scalars['Boolean'];
  labels?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OrderColumn`. */
  orderColumns: Array<OrderColumn>;
  /** Reads and enables pagination through a set of `OrderColumn`. */
  orderColumnsConnection: OrderColumnsConnection;
  /** Reads and enables pagination through a set of `OrderEntry`. */
  orderEntries: Array<OrderEntry>;
  /** Reads and enables pagination through a set of `OrderEntry`. */
  orderEntriesConnection: OrderEntriesConnection;
  /** Reads a single `Project` that is related to this `Order`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `SheetShapeLegend`. */
  sheetShapeLegendsByLegendOrderId: Array<SheetShapeLegend>;
  /** Reads and enables pagination through a set of `SheetShapeLegend`. */
  sheetShapeLegendsByLegendOrderIdConnection: SheetShapeLegendsConnection;
  status: OrderStatus;
  templateId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
};


export type OrderCommentsArgs = {
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type OrderCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type OrderOrderColumnsArgs = {
  condition?: InputMaybe<OrderColumnCondition>;
  filter?: InputMaybe<OrderColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};


export type OrderOrderColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderColumnCondition>;
  filter?: InputMaybe<OrderColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};


export type OrderOrderEntriesArgs = {
  condition?: InputMaybe<OrderEntryCondition>;
  filter?: InputMaybe<OrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};


export type OrderOrderEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryCondition>;
  filter?: InputMaybe<OrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};


export type OrderSheetShapeLegendsByLegendOrderIdArgs = {
  condition?: InputMaybe<SheetShapeLegendCondition>;
  filter?: InputMaybe<SheetShapeLegendFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};


export type OrderSheetShapeLegendsByLegendOrderIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeLegendCondition>;
  filter?: InputMaybe<SheetShapeLegendFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};

export type OrderColumn = Node & {
  __typename?: 'OrderColumn';
  columnOrder?: Maybe<Scalars['Int']>;
  columnType: ColumnType;
  /** Reads and enables pagination through a set of `CustomField`. */
  customFields: Array<CustomField>;
  /** Reads and enables pagination through a set of `CustomField`. */
  customFieldsConnection: CustomFieldsConnection;
  id: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Order` that is related to this `OrderColumn`. */
  order?: Maybe<Order>;
  orderId: Scalars['UUID'];
  showTotal: Scalars['Boolean'];
  templateId?: Maybe<Scalars['UUID']>;
};


export type OrderColumnCustomFieldsArgs = {
  condition?: InputMaybe<CustomFieldCondition>;
  filter?: InputMaybe<CustomFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};


export type OrderColumnCustomFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomFieldCondition>;
  filter?: InputMaybe<CustomFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};

/**
 * A condition to be used against `OrderColumn` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OrderColumnCondition = {
  /** Checks for equality with the object’s `columnOrder` field. */
  columnOrder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `columnType` field. */
  columnType?: InputMaybe<ColumnType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isVisible` field. */
  isVisible?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `showTotal` field. */
  showTotal?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `templateId` field. */
  templateId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `OrderColumn` object types. All fields are combined with a logical ‘and.’ */
export type OrderColumnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderColumnFilter>>;
  /** Filter by the object’s `columnOrder` field. */
  columnOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `columnType` field. */
  columnType?: InputMaybe<ColumnTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isVisible` field. */
  isVisible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderColumnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderColumnFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `showTotal` field. */
  showTotal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `templateId` field. */
  templateId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `OrderColumn` */
export type OrderColumnInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType: ColumnType;
  customFields?: InputMaybe<CustomFieldsOrderColumnIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderColumnsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  showTotal?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['UUID']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderColumnNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `orderColumn` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderColumnNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `orderColumn` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `customField` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `customField` being updated. */
  patch: CustomFieldPatch;
};

/** The fields on `orderColumn` to look up the row to update. */
export type OrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingOrderColumnsNameOrderIdKeyUpdate = {
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderColumn` being updated. */
  patch: UpdateOrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyPatch;
};

/** The fields on `orderColumn` to look up the row to update. */
export type OrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyUsingOrderColumnsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderColumn` being updated. */
  patch: UpdateOrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `order` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: OrderPatch;
};

/** The fields on `orderColumn` to look up the row to update. */
export type OrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyUsingOrderColumnsNameOrderIdKeyUpdate = {
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderColumn` being updated. */
  patch: UpdateOrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyPatch;
};

/** The fields on `orderColumn` to look up the row to update. */
export type OrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyUsingOrderColumnsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderColumn` being updated. */
  patch: UpdateOrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyPatch;
};

/** The fields on `orderColumn` to look up the row to connect. */
export type OrderColumnOrderColumnsNameOrderIdKeyConnect = {
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
};

/** The fields on `orderColumn` to look up the row to delete. */
export type OrderColumnOrderColumnsNameOrderIdKeyDelete = {
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
};

/** The fields on `orderColumn` to look up the row to connect. */
export type OrderColumnOrderColumnsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `orderColumn` to look up the row to delete. */
export type OrderColumnOrderColumnsPkeyDelete = {
  id: Scalars['UUID'];
};

/** Represents an update to a `OrderColumn`. Fields that are set will be updated. */
export type OrderColumnPatch = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType?: InputMaybe<ColumnType>;
  customFields?: InputMaybe<CustomFieldsOrderColumnIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderColumnsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  showTotal?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['UUID']>;
};

export type OrderColumnTemplate = Node & {
  __typename?: 'OrderColumnTemplate';
  columnOrder?: Maybe<Scalars['Int']>;
  columnType: ColumnType;
  /** Reads and enables pagination through a set of `CustomFieldTemplate`. */
  customFieldTemplates: Array<CustomFieldTemplate>;
  /** Reads and enables pagination through a set of `CustomFieldTemplate`. */
  customFieldTemplatesConnection: CustomFieldTemplatesConnection;
  id: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `ProjectTemplateOrder` that is related to this `OrderColumnTemplate`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  projectTemplateOrderId: Scalars['UUID'];
};


export type OrderColumnTemplateCustomFieldTemplatesArgs = {
  condition?: InputMaybe<CustomFieldTemplateCondition>;
  filter?: InputMaybe<CustomFieldTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};


export type OrderColumnTemplateCustomFieldTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomFieldTemplateCondition>;
  filter?: InputMaybe<CustomFieldTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};

/**
 * A condition to be used against `OrderColumnTemplate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OrderColumnTemplateCondition = {
  /** Checks for equality with the object’s `columnOrder` field. */
  columnOrder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `columnType` field. */
  columnType?: InputMaybe<ColumnType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isVisible` field. */
  isVisible?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectTemplateOrderId` field. */
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `OrderColumnTemplate` object types. All fields are combined with a logical ‘and.’ */
export type OrderColumnTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderColumnTemplateFilter>>;
  /** Filter by the object’s `columnOrder` field. */
  columnOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `columnType` field. */
  columnType?: InputMaybe<ColumnTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isVisible` field. */
  isVisible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderColumnTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderColumnTemplateFilter>>;
  /** Filter by the object’s `projectTemplateOrderId` field. */
  projectTemplateOrderId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `OrderColumnTemplate` */
export type OrderColumnTemplateInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType: ColumnType;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  projectTemplateOrder?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderColumnTemplateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `orderColumnTemplate` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderColumnTemplateNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `orderColumnTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderColumnTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `customFieldTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `customFieldTemplate` being updated. */
  patch: CustomFieldTemplatePatch;
};

/** The fields on `orderColumnTemplate` to look up the row to update. */
export type OrderColumnTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyUsingOrderColumnTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderColumnTemplate` being updated. */
  patch: UpdateOrderColumnTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderColumnTemplateOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrder` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
  patch: ProjectTemplateOrderPatch;
};

/** The fields on `orderColumnTemplate` to look up the row to update. */
export type OrderColumnTemplateOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyUsingOrderColumnTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderColumnTemplate` being updated. */
  patch: UpdateOrderColumnTemplateOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyPatch;
};

/** The fields on `orderColumnTemplate` to look up the row to connect. */
export type OrderColumnTemplateOrderColumnTemplatesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `orderColumnTemplate` to look up the row to delete. */
export type OrderColumnTemplateOrderColumnTemplatesPkeyDelete = {
  id: Scalars['UUID'];
};

/** Represents an update to a `OrderColumnTemplate`. Fields that are set will be updated. */
export type OrderColumnTemplatePatch = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType?: InputMaybe<ColumnType>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectTemplateOrder?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `OrderColumnTemplate` values. */
export type OrderColumnTemplatesConnection = {
  __typename?: 'OrderColumnTemplatesConnection';
  /** A list of edges which contains the `OrderColumnTemplate` and cursor to aid in pagination. */
  edges: Array<OrderColumnTemplatesEdge>;
  /** A list of `OrderColumnTemplate` objects. */
  nodes: Array<OrderColumnTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderColumnTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrderColumnTemplate` edge in the connection. */
export type OrderColumnTemplatesEdge = {
  __typename?: 'OrderColumnTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrderColumnTemplate` at the end of the edge. */
  node: OrderColumnTemplate;
};

/** Methods to use when ordering `OrderColumnTemplate`. */
export enum OrderColumnTemplatesOrderBy {
  ColumnOrderAsc = 'COLUMN_ORDER_ASC',
  ColumnOrderDesc = 'COLUMN_ORDER_DESC',
  ColumnTypeAsc = 'COLUMN_TYPE_ASC',
  ColumnTypeDesc = 'COLUMN_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsVisibleAsc = 'IS_VISIBLE_ASC',
  IsVisibleDesc = 'IS_VISIBLE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectTemplateOrderIdAsc = 'PROJECT_TEMPLATE_ORDER_ID_ASC',
  ProjectTemplateOrderIdDesc = 'PROJECT_TEMPLATE_ORDER_ID_DESC'
}

/** Input for the nested mutation of `projectTemplateOrder` in the `OrderColumnTemplateInput` mutation. */
export type OrderColumnTemplatesProjectTemplateOrderIdFkeyInput = {
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateOrderProjectTemplateOrdersPkeyConnect>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectTemplateOrderNodeIdConnect>;
  /** A `ProjectTemplateOrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyProjectTemplateOrdersCreateInput>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectTemplateOrderProjectTemplateOrdersPkeyDelete>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectTemplateOrderNodeIdDelete>;
  /** The primary key(s) and patch data for `projectTemplateOrder` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOrderOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyUsingProjectTemplateOrdersPkeyUpdate>;
  /** The primary key(s) and patch data for `projectTemplateOrder` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderColumnTemplateOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `orderColumnTemplate` in the `ProjectTemplateOrderInput` mutation. */
export type OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput = {
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OrderColumnTemplateOrderColumnTemplatesPkeyConnect>>;
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrderColumnTemplateNodeIdConnect>>;
  /** A `OrderColumnTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrderColumnTemplatesProjectTemplateOrderIdFkeyOrderColumnTemplatesCreateInput>>;
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OrderColumnTemplateOrderColumnTemplatesPkeyDelete>>;
  /** The primary key(s) for `orderColumnTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OrderColumnTemplateNodeIdDelete>>;
  /** Flag indicating whether all other `orderColumnTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `orderColumnTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OrderColumnTemplateOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyUsingOrderColumnTemplatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `orderColumnTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectTemplateOrderOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyNodeIdUpdate>>;
};

/** The `orderColumnTemplate` to be created by this mutation. */
export type OrderColumnTemplatesProjectTemplateOrderIdFkeyOrderColumnTemplatesCreateInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType: ColumnType;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  projectTemplateOrder?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
};

/** The `projectTemplateOrder` to be created by this mutation. */
export type OrderColumnTemplatesProjectTemplateOrderIdFkeyProjectTemplateOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A connection to a list of `OrderColumn` values. */
export type OrderColumnsConnection = {
  __typename?: 'OrderColumnsConnection';
  /** A list of edges which contains the `OrderColumn` and cursor to aid in pagination. */
  edges: Array<OrderColumnsEdge>;
  /** A list of `OrderColumn` objects. */
  nodes: Array<OrderColumn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderColumn` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrderColumn` edge in the connection. */
export type OrderColumnsEdge = {
  __typename?: 'OrderColumnsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrderColumn` at the end of the edge. */
  node: OrderColumn;
};

/** Methods to use when ordering `OrderColumn`. */
export enum OrderColumnsOrderBy {
  ColumnOrderAsc = 'COLUMN_ORDER_ASC',
  ColumnOrderDesc = 'COLUMN_ORDER_DESC',
  ColumnTypeAsc = 'COLUMN_TYPE_ASC',
  ColumnTypeDesc = 'COLUMN_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsVisibleAsc = 'IS_VISIBLE_ASC',
  IsVisibleDesc = 'IS_VISIBLE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShowTotalAsc = 'SHOW_TOTAL_ASC',
  ShowTotalDesc = 'SHOW_TOTAL_DESC',
  TemplateIdAsc = 'TEMPLATE_ID_ASC',
  TemplateIdDesc = 'TEMPLATE_ID_DESC'
}

/** Input for the nested mutation of `order` in the `OrderColumnInput` mutation. */
export type OrderColumnsOrderIdFkeyInput = {
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectById?: InputMaybe<OrderOrdersPkeyConnect>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderNodeIdConnect>;
  /** A `OrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrderColumnsOrderIdFkeyOrdersCreateInput>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderOrdersPkeyDelete>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderNodeIdDelete>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateById?: InputMaybe<OrderOnOrderColumnForOrderColumnsOrderIdFkeyUsingOrdersPkeyUpdate>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `orderColumn` in the `OrderInput` mutation. */
export type OrderColumnsOrderIdFkeyInverseInput = {
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OrderColumnOrderColumnsPkeyConnect>>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  connectByNameAndColumnTypeAndOrderId?: InputMaybe<Array<OrderColumnOrderColumnsNameOrderIdKeyConnect>>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrderColumnNodeIdConnect>>;
  /** A `OrderColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrderColumnsOrderIdFkeyOrderColumnsCreateInput>>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OrderColumnOrderColumnsPkeyDelete>>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  deleteByNameAndColumnTypeAndOrderId?: InputMaybe<Array<OrderColumnOrderColumnsNameOrderIdKeyDelete>>;
  /** The primary key(s) for `orderColumn` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OrderColumnNodeIdDelete>>;
  /** Flag indicating whether all other `orderColumn` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `orderColumn` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyUsingOrderColumnsPkeyUpdate>>;
  /** The primary key(s) and patch data for `orderColumn` for the far side of the relationship. */
  updateByNameAndColumnTypeAndOrderId?: InputMaybe<Array<OrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyUsingOrderColumnsNameOrderIdKeyUpdate>>;
  /** The primary key(s) and patch data for `orderColumn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderOnOrderColumnForOrderColumnsOrderIdFkeyNodeIdUpdate>>;
};

/** The `orderColumn` to be created by this mutation. */
export type OrderColumnsOrderIdFkeyOrderColumnsCreateInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType: ColumnType;
  customFields?: InputMaybe<CustomFieldsOrderColumnIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderColumnsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  showTotal?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['UUID']>;
};

/** The `order` to be created by this mutation. */
export type OrderColumnsOrderIdFkeyOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A condition to be used against `Order` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OrderCondition = {
  /** Checks for equality with the object’s `aggregatedOrderAggregation` field. */
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  /** Checks for equality with the object’s `aggregatedOrderFilters` field. */
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  /** Checks for equality with the object’s `aggregatedOrderGrouping` field. */
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  /** Checks for equality with the object’s `aggregatedOrderView` field. */
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  /** Checks for equality with the object’s `areItemsFlattened` field. */
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `columnNameMapping` field. */
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isAggregatedOrder` field. */
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `labels` field. */
  labels?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<OrderStatus>;
  /** Checks for equality with the object’s `templateId` field. */
  templateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `OrderEntry` values. */
export type OrderEntriesConnection = {
  __typename?: 'OrderEntriesConnection';
  /** A list of edges which contains the `OrderEntry` and cursor to aid in pagination. */
  edges: Array<OrderEntriesEdge>;
  /** A list of `OrderEntry` objects. */
  nodes: Array<OrderEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrderEntry` edge in the connection. */
export type OrderEntriesEdge = {
  __typename?: 'OrderEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrderEntry` at the end of the edge. */
  node: OrderEntry;
};

/** Methods to use when ordering `OrderEntry`. */
export enum OrderEntriesOrderBy {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  ElementIdentifiersDbidAsc = 'ELEMENT_IDENTIFIERS_DBID_ASC',
  ElementIdentifiersDbidDesc = 'ELEMENT_IDENTIFIERS_DBID_DESC',
  ElementIdentifiersQueryAsc = 'ELEMENT_IDENTIFIERS_QUERY_ASC',
  ElementIdentifiersQueryDesc = 'ELEMENT_IDENTIFIERS_QUERY_DESC',
  GroupByAttributesAsc = 'GROUP_BY_ATTRIBUTES_ASC',
  GroupByAttributesDesc = 'GROUP_BY_ATTRIBUTES_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PromptForLinkingAsc = 'PROMPT_FOR_LINKING_ASC',
  PromptForLinkingDesc = 'PROMPT_FOR_LINKING_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  TemplateIdAsc = 'TEMPLATE_ID_ASC',
  TemplateIdDesc = 'TEMPLATE_ID_DESC',
  UnitAsc = 'UNIT_ASC',
  UnitDesc = 'UNIT_DESC',
  UnitPriceAsc = 'UNIT_PRICE_ASC',
  UnitPriceDesc = 'UNIT_PRICE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsePromptForLinkingAsc = 'USE_PROMPT_FOR_LINKING_ASC',
  UsePromptForLinkingDesc = 'USE_PROMPT_FOR_LINKING_DESC'
}

/** Input for the nested mutation of `order` in the `OrderEntryInput` mutation. */
export type OrderEntriesOrderIdFkeyInput = {
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectById?: InputMaybe<OrderOrdersPkeyConnect>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderNodeIdConnect>;
  /** A `OrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrderEntriesOrderIdFkeyOrdersCreateInput>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderOrdersPkeyDelete>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderNodeIdDelete>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateById?: InputMaybe<OrderOnOrderEntryForOrderEntriesOrderIdFkeyUsingOrdersPkeyUpdate>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderEntryOnOrderEntryForOrderEntriesOrderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `orderEntry` in the `OrderInput` mutation. */
export type OrderEntriesOrderIdFkeyInverseInput = {
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OrderEntryOrderEntriesPkeyConnect>>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrderEntryNodeIdConnect>>;
  /** A `OrderEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrderEntriesOrderIdFkeyOrderEntriesCreateInput>>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OrderEntryOrderEntriesPkeyDelete>>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OrderEntryNodeIdDelete>>;
  /** Flag indicating whether all other `orderEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `orderEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OrderEntryOnOrderEntryForOrderEntriesOrderIdFkeyUsingOrderEntriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `orderEntry` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderOnOrderEntryForOrderEntriesOrderIdFkeyNodeIdUpdate>>;
};

/** The `orderEntry` to be created by this mutation. */
export type OrderEntriesOrderIdFkeyOrderEntriesCreateInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** The `order` to be created by this mutation. */
export type OrderEntriesOrderIdFkeyOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type OrderEntry = Node & {
  __typename?: 'OrderEntry';
  color: Scalars['String'];
  createdAt: Scalars['Datetime'];
  currency: CurrencyEnum;
  /** Reads and enables pagination through a set of `CustomField`. */
  customFields: Array<CustomField>;
  /** Reads and enables pagination through a set of `CustomField`. */
  customFieldsConnection: CustomFieldsConnection;
  elementIdentifiersDbid?: Maybe<Array<ElementIdentifierDbidType>>;
  elementIdentifiersQuery?: Maybe<ForgeAttributeQueryType>;
  groupByAttributes?: Maybe<Array<ForgeAttributeType>>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Order` that is related to this `OrderEntry`. */
  order?: Maybe<Order>;
  /** Reads a single `OrderEntryCache` that is related to this `OrderEntry`. */
  orderEntryCache?: Maybe<OrderEntryCache>;
  orderId: Scalars['UUID'];
  promptForLinking?: Maybe<Scalars['String']>;
  quantity?: Maybe<QuantityType>;
  templateId?: Maybe<Scalars['UUID']>;
  unit?: Maybe<Unit>;
  unitPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
  usePromptForLinking: Scalars['Boolean'];
};


export type OrderEntryCustomFieldsArgs = {
  condition?: InputMaybe<CustomFieldCondition>;
  filter?: InputMaybe<CustomFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};


export type OrderEntryCustomFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomFieldCondition>;
  filter?: InputMaybe<CustomFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};

export type OrderEntryCache = Node & {
  __typename?: 'OrderEntryCache';
  createdAt: Scalars['Datetime'];
  hash: Scalars['String'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `OrderEntry` that is related to this `OrderEntryCache`. */
  orderEntry?: Maybe<OrderEntry>;
  orderEntryId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  value: Scalars['JSON'];
};

/**
 * A condition to be used against `OrderEntryCache` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrderEntryCacheCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hash` field. */
  hash?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `orderEntryId` field. */
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `OrderEntryCache` object types. All fields are combined with a logical ‘and.’ */
export type OrderEntryCacheFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderEntryCacheFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hash` field. */
  hash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderEntryCacheFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderEntryCacheFilter>>;
  /** Filter by the object’s `orderEntryId` field. */
  orderEntryId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `OrderEntryCache` */
export type OrderEntryCacheInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hash: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['JSON'];
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderEntryCacheNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `orderEntryCache` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderEntryCacheNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `orderEntryCache` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderEntry` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderEntry` being updated. */
  patch: OrderEntryPatch;
};

/** The fields on `orderEntryCache` to look up the row to update. */
export type OrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyUsingOrderEntryCacheOrderEntryIdKeyUpdate = {
  orderEntryId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntryCache` being updated. */
  patch: UpdateOrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyPatch;
};

/** The fields on `orderEntryCache` to look up the row to update. */
export type OrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyUsingOrderEntryCachePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntryCache` being updated. */
  patch: UpdateOrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyPatch;
};

/** The fields on `orderEntryCache` to look up the row to connect. */
export type OrderEntryCacheOrderEntryCacheOrderEntryIdKeyConnect = {
  orderEntryId: Scalars['UUID'];
};

/** The fields on `orderEntryCache` to look up the row to delete. */
export type OrderEntryCacheOrderEntryCacheOrderEntryIdKeyDelete = {
  orderEntryId: Scalars['UUID'];
};

/** The fields on `orderEntryCache` to look up the row to connect. */
export type OrderEntryCacheOrderEntryCachePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `orderEntryCache` to look up the row to delete. */
export type OrderEntryCacheOrderEntryCachePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `orderEntry` in the `OrderEntryCacheInput` mutation. */
export type OrderEntryCacheOrderEntryIdFkeyInput = {
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  connectById?: InputMaybe<OrderEntryOrderEntriesPkeyConnect>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderEntryNodeIdConnect>;
  /** A `OrderEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyOrderEntriesCreateInput>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderEntryOrderEntriesPkeyDelete>;
  /** The primary key(s) for `orderEntry` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderEntryNodeIdDelete>;
  /** The primary key(s) and patch data for `orderEntry` for the far side of the relationship. */
  updateById?: InputMaybe<OrderEntryOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyUsingOrderEntriesPkeyUpdate>;
  /** The primary key(s) and patch data for `orderEntry` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `orderEntryCache` in the `OrderEntryInput` mutation. */
export type OrderEntryCacheOrderEntryIdFkeyInverseInput = {
  /** The primary key(s) for `orderEntryCache` for the far side of the relationship. */
  connectById?: InputMaybe<OrderEntryCacheOrderEntryCachePkeyConnect>;
  /** The primary key(s) for `orderEntryCache` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderEntryCacheNodeIdConnect>;
  /** The primary key(s) for `orderEntryCache` for the far side of the relationship. */
  connectByOrderEntryId?: InputMaybe<OrderEntryCacheOrderEntryCacheOrderEntryIdKeyConnect>;
  /** A `OrderEntryCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrderEntryCacheOrderEntryIdFkeyOrderEntryCacheCreateInput>>;
  /** The primary key(s) for `orderEntryCache` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderEntryCacheOrderEntryCachePkeyDelete>;
  /** The primary key(s) for `orderEntryCache` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderEntryCacheNodeIdDelete>;
  /** The primary key(s) for `orderEntryCache` for the far side of the relationship. */
  deleteByOrderEntryId?: InputMaybe<OrderEntryCacheOrderEntryCacheOrderEntryIdKeyDelete>;
  /** Flag indicating whether all other `orderEntryCache` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `orderEntryCache` for the far side of the relationship. */
  updateById?: InputMaybe<OrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyUsingOrderEntryCachePkeyUpdate>;
  /** The primary key(s) and patch data for `orderEntryCache` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderEntryOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `orderEntryCache` for the far side of the relationship. */
  updateByOrderEntryId?: InputMaybe<OrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyUsingOrderEntryCacheOrderEntryIdKeyUpdate>;
};

/** The `orderEntry` to be created by this mutation. */
export type OrderEntryCacheOrderEntryIdFkeyOrderEntriesCreateInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** The `orderEntryCache` to be created by this mutation. */
export type OrderEntryCacheOrderEntryIdFkeyOrderEntryCacheCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hash: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['JSON'];
};

/** Represents an update to a `OrderEntryCache`. Fields that are set will be updated. */
export type OrderEntryCachePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `OrderEntryCache` values. */
export type OrderEntryCachesConnection = {
  __typename?: 'OrderEntryCachesConnection';
  /** A list of edges which contains the `OrderEntryCache` and cursor to aid in pagination. */
  edges: Array<OrderEntryCachesEdge>;
  /** A list of `OrderEntryCache` objects. */
  nodes: Array<OrderEntryCache>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderEntryCache` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrderEntryCache` edge in the connection. */
export type OrderEntryCachesEdge = {
  __typename?: 'OrderEntryCachesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrderEntryCache` at the end of the edge. */
  node: OrderEntryCache;
};

/** Methods to use when ordering `OrderEntryCache`. */
export enum OrderEntryCachesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HashAsc = 'HASH_ASC',
  HashDesc = 'HASH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderEntryIdAsc = 'ORDER_ENTRY_ID_ASC',
  OrderEntryIdDesc = 'ORDER_ENTRY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/**
 * A condition to be used against `OrderEntry` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OrderEntryCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<CurrencyEnum>;
  /** Checks for equality with the object’s `elementIdentifiersDbid` field. */
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  /** Checks for equality with the object’s `elementIdentifiersQuery` field. */
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  /** Checks for equality with the object’s `groupByAttributes` field. */
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `promptForLinking` field. */
  promptForLinking?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<QuantityTypeInput>;
  /** Checks for equality with the object’s `templateId` field. */
  templateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Unit>;
  /** Checks for equality with the object’s `unitPrice` field. */
  unitPrice?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `usePromptForLinking` field. */
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `OrderEntry` object types. All fields are combined with a logical ‘and.’ */
export type OrderEntryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderEntryFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyEnumFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderEntryFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `promptForLinking` field. */
  promptForLinking?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<QuantityTypeFilter>;
  /** Filter by the object’s `templateId` field. */
  templateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<UnitFilter>;
  /** Filter by the object’s `unitPrice` field. */
  unitPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usePromptForLinking` field. */
  usePromptForLinking?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `OrderEntry` */
export type OrderEntryInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderEntryNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `orderEntry` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderEntryNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `orderEntry` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderEntryOnCustomFieldForCustomFieldsOrderEntryIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `customField` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `customField` being updated. */
  patch: CustomFieldPatch;
};

/** The fields on `orderEntry` to look up the row to update. */
export type OrderEntryOnCustomFieldForCustomFieldsOrderEntryIdFkeyUsingOrderEntriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntry` being updated. */
  patch: UpdateOrderEntryOnCustomFieldForCustomFieldsOrderEntryIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderEntryOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderEntryCache` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderEntryCache` being updated. */
  patch: OrderEntryCachePatch;
};

/** The fields on `orderEntry` to look up the row to update. */
export type OrderEntryOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyUsingOrderEntriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntry` being updated. */
  patch: UpdateOrderEntryOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderEntryOnOrderEntryForOrderEntriesOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `order` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: OrderPatch;
};

/** The fields on `orderEntry` to look up the row to update. */
export type OrderEntryOnOrderEntryForOrderEntriesOrderIdFkeyUsingOrderEntriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntry` being updated. */
  patch: UpdateOrderEntryOnOrderEntryForOrderEntriesOrderIdFkeyPatch;
};

/** The fields on `orderEntry` to look up the row to connect. */
export type OrderEntryOrderEntriesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `orderEntry` to look up the row to delete. */
export type OrderEntryOrderEntriesPkeyDelete = {
  id: Scalars['UUID'];
};

/** Represents an update to a `OrderEntry`. Fields that are set will be updated. */
export type OrderEntryPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

export type OrderEntryTemplate = Node & {
  __typename?: 'OrderEntryTemplate';
  /** Reads a single `Contractor` that is related to this `OrderEntryTemplate`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  currency: CurrencyEnum;
  customFields?: Maybe<Array<TemplateCustomFieldType>>;
  elementIdentifiersDbid?: Maybe<Array<ElementIdentifierDbidType>>;
  elementIdentifiersQuery?: Maybe<ForgeAttributeQueryType>;
  groupByAttributes?: Maybe<Array<ForgeAttributeType>>;
  id: Scalars['UUID'];
  isPublic: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  originalOrderEntryId?: Maybe<Scalars['UUID']>;
  quantity?: Maybe<QuantityType>;
  templateName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `OrderEntryTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrderEntryTemplateCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<CurrencyEnum>;
  /** Checks for equality with the object’s `customFields` field. */
  customFields?: InputMaybe<Array<InputMaybe<TemplateCustomFieldTypeInput>>>;
  /** Checks for equality with the object’s `elementIdentifiersDbid` field. */
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  /** Checks for equality with the object’s `elementIdentifiersQuery` field. */
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  /** Checks for equality with the object’s `groupByAttributes` field. */
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isPublic` field. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `originalOrderEntryId` field. */
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<QuantityTypeInput>;
  /** Checks for equality with the object’s `templateName` field. */
  templateName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Unit>;
  /** Checks for equality with the object’s `unitPrice` field. */
  unitPrice?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `OrderEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type OrderEntryTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderEntryTemplateFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyEnumFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isPublic` field. */
  isPublic?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderEntryTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderEntryTemplateFilter>>;
  /** Filter by the object’s `originalOrderEntryId` field. */
  originalOrderEntryId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<QuantityTypeFilter>;
  /** Filter by the object’s `templateName` field. */
  templateName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<UnitFilter>;
  /** Filter by the object’s `unitPrice` field. */
  unitPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `OrderEntryTemplate` */
export type OrderEntryTemplateInput = {
  contractor?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<Array<InputMaybe<TemplateCustomFieldTypeInput>>>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateName: Scalars['String'];
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderEntryTemplateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `orderEntryTemplate` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderEntryTemplateNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `orderEntryTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderEntryTemplateOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `orderEntryTemplate` to look up the row to update. */
export type OrderEntryTemplateOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyUsingOrderEntryTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntryTemplate` being updated. */
  patch: UpdateOrderEntryTemplateOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyPatch;
};

/** The fields on `orderEntryTemplate` to look up the row to connect. */
export type OrderEntryTemplateOrderEntryTemplatesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `orderEntryTemplate` to look up the row to delete. */
export type OrderEntryTemplateOrderEntryTemplatesPkeyDelete = {
  id: Scalars['UUID'];
};

/** Represents an update to a `OrderEntryTemplate`. Fields that are set will be updated. */
export type OrderEntryTemplatePatch = {
  contractor?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<Array<InputMaybe<TemplateCustomFieldTypeInput>>>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateName?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `OrderEntryTemplate` values. */
export type OrderEntryTemplatesConnection = {
  __typename?: 'OrderEntryTemplatesConnection';
  /** A list of edges which contains the `OrderEntryTemplate` and cursor to aid in pagination. */
  edges: Array<OrderEntryTemplatesEdge>;
  /** A list of `OrderEntryTemplate` objects. */
  nodes: Array<OrderEntryTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderEntryTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type OrderEntryTemplatesContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `OrderEntryTemplateInput` mutation. */
export type OrderEntryTemplatesContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrderEntryTemplatesContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderEntryTemplateOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `orderEntryTemplate` in the `ContractorInput` mutation. */
export type OrderEntryTemplatesContractorIdFkeyInverseInput = {
  /** The primary key(s) for `orderEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OrderEntryTemplateOrderEntryTemplatesPkeyConnect>>;
  /** The primary key(s) for `orderEntryTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrderEntryTemplateNodeIdConnect>>;
  /** A `OrderEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrderEntryTemplatesContractorIdFkeyOrderEntryTemplatesCreateInput>>;
  /** The primary key(s) for `orderEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OrderEntryTemplateOrderEntryTemplatesPkeyDelete>>;
  /** The primary key(s) for `orderEntryTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OrderEntryTemplateNodeIdDelete>>;
  /** Flag indicating whether all other `orderEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `orderEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OrderEntryTemplateOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyUsingOrderEntryTemplatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `orderEntryTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyNodeIdUpdate>>;
};

/** The `orderEntryTemplate` to be created by this mutation. */
export type OrderEntryTemplatesContractorIdFkeyOrderEntryTemplatesCreateInput = {
  contractor?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<Array<InputMaybe<TemplateCustomFieldTypeInput>>>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateName: Scalars['String'];
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A `OrderEntryTemplate` edge in the connection. */
export type OrderEntryTemplatesEdge = {
  __typename?: 'OrderEntryTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrderEntryTemplate` at the end of the edge. */
  node: OrderEntryTemplate;
};

/** Methods to use when ordering `OrderEntryTemplate`. */
export enum OrderEntryTemplatesOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  CustomFieldsAsc = 'CUSTOM_FIELDS_ASC',
  CustomFieldsDesc = 'CUSTOM_FIELDS_DESC',
  ElementIdentifiersDbidAsc = 'ELEMENT_IDENTIFIERS_DBID_ASC',
  ElementIdentifiersDbidDesc = 'ELEMENT_IDENTIFIERS_DBID_DESC',
  ElementIdentifiersQueryAsc = 'ELEMENT_IDENTIFIERS_QUERY_ASC',
  ElementIdentifiersQueryDesc = 'ELEMENT_IDENTIFIERS_QUERY_DESC',
  GroupByAttributesAsc = 'GROUP_BY_ATTRIBUTES_ASC',
  GroupByAttributesDesc = 'GROUP_BY_ATTRIBUTES_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPublicAsc = 'IS_PUBLIC_ASC',
  IsPublicDesc = 'IS_PUBLIC_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalOrderEntryIdAsc = 'ORIGINAL_ORDER_ENTRY_ID_ASC',
  OriginalOrderEntryIdDesc = 'ORIGINAL_ORDER_ENTRY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  TemplateNameAsc = 'TEMPLATE_NAME_ASC',
  TemplateNameDesc = 'TEMPLATE_NAME_DESC',
  UnitAsc = 'UNIT_ASC',
  UnitDesc = 'UNIT_DESC',
  UnitPriceAsc = 'UNIT_PRICE_ASC',
  UnitPriceDesc = 'UNIT_PRICE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type OrderEntryView = Node & {
  __typename?: 'OrderEntryView';
  columnFilters?: Maybe<Array<ColumnFilterType>>;
  createdAt: Scalars['Datetime'];
  globalFilter: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `OrderEntryView`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  visibleColumns: Array<Scalars['String']>;
};

/**
 * A condition to be used against `OrderEntryView` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrderEntryViewCondition = {
  /** Checks for equality with the object’s `columnFilters` field. */
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `globalFilter` field. */
  globalFilter?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `visibleColumns` field. */
  visibleColumns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A filter to be used against `OrderEntryView` object types. All fields are combined with a logical ‘and.’ */
export type OrderEntryViewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderEntryViewFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `globalFilter` field. */
  globalFilter?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderEntryViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderEntryViewFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `visibleColumns` field. */
  visibleColumns?: InputMaybe<StringListFilter>;
};

/** An input for mutations affecting `OrderEntryView` */
export type OrderEntryViewInput = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  globalFilter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<OrderEntryViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  visibleColumns: Array<InputMaybe<Scalars['String']>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderEntryViewNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `orderEntryView` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderEntryViewNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `orderEntryView` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `orderEntryView` to look up the row to update. */
export type OrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyUsingOrderEntryViewsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `orderEntryView` being updated. */
  patch: UpdateOrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyPatch;
};

/** The fields on `orderEntryView` to look up the row to update. */
export type OrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyUsingOrderEntryViewsProjectIdNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `orderEntryView` being updated. */
  patch: UpdateOrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `orderEntryView` to look up the row to connect. */
export type OrderEntryViewOrderEntryViewsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `orderEntryView` to look up the row to delete. */
export type OrderEntryViewOrderEntryViewsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `orderEntryView` to look up the row to connect. */
export type OrderEntryViewOrderEntryViewsProjectIdNameKeyConnect = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** The fields on `orderEntryView` to look up the row to delete. */
export type OrderEntryViewOrderEntryViewsProjectIdNameKeyDelete = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** Represents an update to a `OrderEntryView`. Fields that are set will be updated. */
export type OrderEntryViewPatch = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  globalFilter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<OrderEntryViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  visibleColumns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A connection to a list of `OrderEntryView` values. */
export type OrderEntryViewsConnection = {
  __typename?: 'OrderEntryViewsConnection';
  /** A list of edges which contains the `OrderEntryView` and cursor to aid in pagination. */
  edges: Array<OrderEntryViewsEdge>;
  /** A list of `OrderEntryView` objects. */
  nodes: Array<OrderEntryView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderEntryView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrderEntryView` edge in the connection. */
export type OrderEntryViewsEdge = {
  __typename?: 'OrderEntryViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrderEntryView` at the end of the edge. */
  node: OrderEntryView;
};

/** Methods to use when ordering `OrderEntryView`. */
export enum OrderEntryViewsOrderBy {
  ColumnFiltersAsc = 'COLUMN_FILTERS_ASC',
  ColumnFiltersDesc = 'COLUMN_FILTERS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GlobalFilterAsc = 'GLOBAL_FILTER_ASC',
  GlobalFilterDesc = 'GLOBAL_FILTER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VisibleColumnsAsc = 'VISIBLE_COLUMNS_ASC',
  VisibleColumnsDesc = 'VISIBLE_COLUMNS_DESC'
}

/** Input for the nested mutation of `project` in the `OrderEntryViewInput` mutation. */
export type OrderEntryViewsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrderEntryViewsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnOrderEntryViewForOrderEntryViewsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `orderEntryView` in the `ProjectInput` mutation. */
export type OrderEntryViewsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `orderEntryView` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OrderEntryViewOrderEntryViewsPkeyConnect>>;
  /** The primary key(s) for `orderEntryView` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrderEntryViewNodeIdConnect>>;
  /** The primary key(s) for `orderEntryView` for the far side of the relationship. */
  connectByProjectIdAndName?: InputMaybe<Array<OrderEntryViewOrderEntryViewsProjectIdNameKeyConnect>>;
  /** A `OrderEntryViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrderEntryViewsProjectIdFkeyOrderEntryViewsCreateInput>>;
  /** The primary key(s) for `orderEntryView` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OrderEntryViewOrderEntryViewsPkeyDelete>>;
  /** The primary key(s) for `orderEntryView` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OrderEntryViewNodeIdDelete>>;
  /** The primary key(s) for `orderEntryView` for the far side of the relationship. */
  deleteByProjectIdAndName?: InputMaybe<Array<OrderEntryViewOrderEntryViewsProjectIdNameKeyDelete>>;
  /** Flag indicating whether all other `orderEntryView` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `orderEntryView` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyUsingOrderEntryViewsPkeyUpdate>>;
  /** The primary key(s) and patch data for `orderEntryView` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnOrderEntryViewForOrderEntryViewsProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `orderEntryView` for the far side of the relationship. */
  updateByProjectIdAndName?: InputMaybe<Array<OrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyUsingOrderEntryViewsProjectIdNameKeyUpdate>>;
};

/** The `orderEntryView` to be created by this mutation. */
export type OrderEntryViewsProjectIdFkeyOrderEntryViewsCreateInput = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  globalFilter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<OrderEntryViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  visibleColumns: Array<InputMaybe<Scalars['String']>>;
};

/** The `project` to be created by this mutation. */
export type OrderEntryViewsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Order` object types. All fields are combined with a logical ‘and.’ */
export type OrderFilter = {
  /** Filter by the object’s `aggregatedOrderView` field. */
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewTypeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderFilter>>;
  /** Filter by the object’s `areItemsFlattened` field. */
  areItemsFlattened?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `columnNameMapping` field. */
  columnNameMapping?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isAggregatedOrder` field. */
  isAggregatedOrder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `labels` field. */
  labels?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<OrderStatusFilter>;
  /** Filter by the object’s `templateId` field. */
  templateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Order` */
export type OrderInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrderNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `order` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OrderNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `order` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrderOnCommentForCommentsOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `comment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: CommentPatch;
};

/** The fields on `order` to look up the row to update. */
export type OrderOnCommentForCommentsOrderIdFkeyUsingOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: UpdateOrderOnCommentForCommentsOrderIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderOnOrderColumnForOrderColumnsOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderColumn` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderColumn` being updated. */
  patch: OrderColumnPatch;
};

/** The fields on `order` to look up the row to update. */
export type OrderOnOrderColumnForOrderColumnsOrderIdFkeyUsingOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: UpdateOrderOnOrderColumnForOrderColumnsOrderIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderOnOrderEntryForOrderEntriesOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderEntry` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderEntry` being updated. */
  patch: OrderEntryPatch;
};

/** The fields on `order` to look up the row to update. */
export type OrderOnOrderEntryForOrderEntriesOrderIdFkeyUsingOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: UpdateOrderOnOrderEntryForOrderEntriesOrderIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderOnOrderForOrdersProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `order` to look up the row to update. */
export type OrderOnOrderForOrdersProjectIdFkeyUsingOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: UpdateOrderOnOrderForOrdersProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrderOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShapeLegend` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
  patch: SheetShapeLegendPatch;
};

/** The fields on `order` to look up the row to update. */
export type OrderOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyUsingOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: UpdateOrderOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyPatch;
};

/** The fields on `order` to look up the row to connect. */
export type OrderOrdersPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `order` to look up the row to delete. */
export type OrderOrdersPkeyDelete = {
  id: Scalars['UUID'];
};

/** Represents an update to a `Order`. Fields that are set will be updated. */
export type OrderPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum OrderStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Publishing = 'PUBLISHING'
}

/** A filter to be used against OrderStatus fields. All fields are combined with a logical ‘and.’ */
export type OrderStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrderStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrderStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrderStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrderStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrderStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrderStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrderStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrderStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrderStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrderStatus>>;
};

/** A connection to a list of `Order` values. */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges which contains the `Order` and cursor to aid in pagination. */
  edges: Array<OrdersEdge>;
  /** A list of `Order` objects. */
  nodes: Array<Order>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Order` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Order` edge in the connection. */
export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Order` at the end of the edge. */
  node: Order;
};

/** Methods to use when ordering `Order`. */
export enum OrdersOrderBy {
  AggregatedOrderAggregationAsc = 'AGGREGATED_ORDER_AGGREGATION_ASC',
  AggregatedOrderAggregationDesc = 'AGGREGATED_ORDER_AGGREGATION_DESC',
  AggregatedOrderFiltersAsc = 'AGGREGATED_ORDER_FILTERS_ASC',
  AggregatedOrderFiltersDesc = 'AGGREGATED_ORDER_FILTERS_DESC',
  AggregatedOrderGroupingAsc = 'AGGREGATED_ORDER_GROUPING_ASC',
  AggregatedOrderGroupingDesc = 'AGGREGATED_ORDER_GROUPING_DESC',
  AggregatedOrderViewAsc = 'AGGREGATED_ORDER_VIEW_ASC',
  AggregatedOrderViewDesc = 'AGGREGATED_ORDER_VIEW_DESC',
  AreItemsFlattenedAsc = 'ARE_ITEMS_FLATTENED_ASC',
  AreItemsFlattenedDesc = 'ARE_ITEMS_FLATTENED_DESC',
  ColumnNameMappingAsc = 'COLUMN_NAME_MAPPING_ASC',
  ColumnNameMappingDesc = 'COLUMN_NAME_MAPPING_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAggregatedOrderAsc = 'IS_AGGREGATED_ORDER_ASC',
  IsAggregatedOrderDesc = 'IS_AGGREGATED_ORDER_DESC',
  LabelsAsc = 'LABELS_ASC',
  LabelsDesc = 'LABELS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TemplateIdAsc = 'TEMPLATE_ID_ASC',
  TemplateIdDesc = 'TEMPLATE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `project` in the `OrderInput` mutation. */
export type OrdersProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrdersProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnOrderForOrdersProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrderOnOrderForOrdersProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `order` in the `ProjectInput` mutation. */
export type OrdersProjectIdFkeyInverseInput = {
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OrderOrdersPkeyConnect>>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrderNodeIdConnect>>;
  /** A `OrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OrdersProjectIdFkeyOrdersCreateInput>>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OrderOrdersPkeyDelete>>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OrderNodeIdDelete>>;
  /** Flag indicating whether all other `order` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OrderOnOrderForOrdersProjectIdFkeyUsingOrdersPkeyUpdate>>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnOrderForOrdersProjectIdFkeyNodeIdUpdate>>;
};

/** The `order` to be created by this mutation. */
export type OrdersProjectIdFkeyOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `project` to be created by this mutation. */
export type OrdersProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type PlaneType = {
  __typename?: 'PlaneType';
  a: Scalars['Float'];
  b: Scalars['Float'];
  c: Scalars['Float'];
  d: Scalars['Float'];
};

/** A filter to be used against `PlaneType` object types. All fields are combined with a logical ‘and.’ */
export type PlaneTypeFilter = {
  /** Filter by the object’s `a` field. */
  a?: InputMaybe<FloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlaneTypeFilter>>;
  /** Filter by the object’s `b` field. */
  b?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `c` field. */
  c?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `d` field. */
  d?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlaneTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlaneTypeFilter>>;
};

/** An input for mutations affecting `PlaneType` */
export type PlaneTypeInput = {
  a: Scalars['Float'];
  b: Scalars['Float'];
  c: Scalars['Float'];
  d: Scalars['Float'];
};

export type Point2Type = {
  __typename?: 'Point2Type';
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** A filter to be used against `Point2Type` object types. All fields are combined with a logical ‘and.’ */
export type Point2TypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Point2TypeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<Point2TypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Point2TypeFilter>>;
  /** Filter by the object’s `x` field. */
  x?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `y` field. */
  y?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `Point2Type` */
export type Point2TypeInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Point3 = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type Point3Type = {
  __typename?: 'Point3Type';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

/** A filter to be used against `Point3Type` object types. All fields are combined with a logical ‘and.’ */
export type Point3TypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<Point3TypeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<Point3TypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<Point3TypeFilter>>;
  /** Filter by the object’s `x` field. */
  x?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `y` field. */
  y?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `z` field. */
  z?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `Point3Type` */
export type Point3TypeInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type Polygon = Node & {
  __typename?: 'Polygon';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  multipolygon: MultiPolygon3Type;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  plane: PlaneType;
  /** Reads a single `Shape` that is related to this `Polygon`. */
  shape?: Maybe<Shape>;
  shapeId: Scalars['UUID'];
  unitScale: Scalars['Float'];
  updatedAt: Scalars['Datetime'];
};

export type Polygon2Type = {
  __typename?: 'Polygon2Type';
  exterior: LinearRing2Type;
  interiors: Array<LinearRing2Type>;
};

/** An input for mutations affecting `Polygon2Type` */
export type Polygon2TypeInput = {
  exterior: LinearRing2TypeInput;
  interiors: Array<InputMaybe<LinearRing2TypeInput>>;
};

export type Polygon3Type = {
  __typename?: 'Polygon3Type';
  exterior: LinearRing3Type;
  interiors: Array<LinearRing3Type>;
};

/** An input for mutations affecting `Polygon3Type` */
export type Polygon3TypeInput = {
  exterior: LinearRing3TypeInput;
  interiors: Array<InputMaybe<LinearRing3TypeInput>>;
};

/** A condition to be used against `Polygon` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PolygonCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `multipolygon` field. */
  multipolygon?: InputMaybe<MultiPolygon3TypeInput>;
  /** Checks for equality with the object’s `plane` field. */
  plane?: InputMaybe<PlaneTypeInput>;
  /** Checks for equality with the object’s `shapeId` field. */
  shapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `unitScale` field. */
  unitScale?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Polygon` object types. All fields are combined with a logical ‘and.’ */
export type PolygonFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PolygonFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PolygonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PolygonFilter>>;
  /** Filter by the object’s `plane` field. */
  plane?: InputMaybe<PlaneTypeFilter>;
  /** Filter by the object’s `shapeId` field. */
  shapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `unitScale` field. */
  unitScale?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Polygon` */
export type PolygonInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon: MultiPolygon3TypeInput;
  plane: PlaneTypeInput;
  shape?: InputMaybe<PolygonsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  unitScale: Scalars['Float'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type PolygonNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `polygon` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type PolygonNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `polygon` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type PolygonOnPolygonForPolygonsShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `polygon` to look up the row to update. */
export type PolygonOnPolygonForPolygonsShapeIdFkeyUsingPolygonsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `polygon` being updated. */
  patch: UpdatePolygonOnPolygonForPolygonsShapeIdFkeyPatch;
};

/** The fields on `polygon` to look up the row to update. */
export type PolygonOnPolygonForPolygonsShapeIdFkeyUsingPolygonsShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `polygon` being updated. */
  patch: UpdatePolygonOnPolygonForPolygonsShapeIdFkeyPatch;
  shapeId: Scalars['UUID'];
};

/** Represents an update to a `Polygon`. Fields that are set will be updated. */
export type PolygonPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon?: InputMaybe<MultiPolygon3TypeInput>;
  plane?: InputMaybe<PlaneTypeInput>;
  shape?: InputMaybe<PolygonsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  unitScale?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `polygon` to look up the row to connect. */
export type PolygonPolygonsPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `polygon` to look up the row to delete. */
export type PolygonPolygonsPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `polygon` to look up the row to connect. */
export type PolygonPolygonsShapeIdKeyConnect = {
  shapeId: Scalars['UUID'];
};

/** The fields on `polygon` to look up the row to delete. */
export type PolygonPolygonsShapeIdKeyDelete = {
  shapeId: Scalars['UUID'];
};

/** A connection to a list of `Polygon` values. */
export type PolygonsConnection = {
  __typename?: 'PolygonsConnection';
  /** A list of edges which contains the `Polygon` and cursor to aid in pagination. */
  edges: Array<PolygonsEdge>;
  /** A list of `Polygon` objects. */
  nodes: Array<Polygon>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Polygon` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Polygon` edge in the connection. */
export type PolygonsEdge = {
  __typename?: 'PolygonsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Polygon` at the end of the edge. */
  node: Polygon;
};

/** Methods to use when ordering `Polygon`. */
export enum PolygonsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MultipolygonAsc = 'MULTIPOLYGON_ASC',
  MultipolygonDesc = 'MULTIPOLYGON_DESC',
  Natural = 'NATURAL',
  PlaneAsc = 'PLANE_ASC',
  PlaneDesc = 'PLANE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShapeIdAsc = 'SHAPE_ID_ASC',
  ShapeIdDesc = 'SHAPE_ID_DESC',
  UnitScaleAsc = 'UNIT_SCALE_ASC',
  UnitScaleDesc = 'UNIT_SCALE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `shape` in the `PolygonInput` mutation. */
export type PolygonsShapeIdFkeyInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<ShapeShapesPkeyConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapeNodeIdConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbConnect>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PolygonsShapeIdFkeyShapesCreateInput>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapeShapesPkeyDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapeNodeIdDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<ShapeOnPolygonForPolygonsShapeIdFkeyUsingShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PolygonOnPolygonForPolygonsShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<ShapeOnPolygonForPolygonsShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `polygon` in the `ShapeInput` mutation. */
export type PolygonsShapeIdFkeyInverseInput = {
  /** The primary key(s) for `polygon` for the far side of the relationship. */
  connectById?: InputMaybe<PolygonPolygonsPkeyConnect>;
  /** The primary key(s) for `polygon` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PolygonNodeIdConnect>;
  /** The primary key(s) for `polygon` for the far side of the relationship. */
  connectByShapeId?: InputMaybe<PolygonPolygonsShapeIdKeyConnect>;
  /** A `PolygonInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PolygonsShapeIdFkeyPolygonsCreateInput>>;
  /** The primary key(s) for `polygon` for the far side of the relationship. */
  deleteById?: InputMaybe<PolygonPolygonsPkeyDelete>;
  /** The primary key(s) for `polygon` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<PolygonNodeIdDelete>;
  /** The primary key(s) for `polygon` for the far side of the relationship. */
  deleteByShapeId?: InputMaybe<PolygonPolygonsShapeIdKeyDelete>;
  /** Flag indicating whether all other `polygon` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `polygon` for the far side of the relationship. */
  updateById?: InputMaybe<PolygonOnPolygonForPolygonsShapeIdFkeyUsingPolygonsPkeyUpdate>;
  /** The primary key(s) and patch data for `polygon` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnPolygonForPolygonsShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `polygon` for the far side of the relationship. */
  updateByShapeId?: InputMaybe<PolygonOnPolygonForPolygonsShapeIdFkeyUsingPolygonsShapeIdKeyUpdate>;
};

/** The `polygon` to be created by this mutation. */
export type PolygonsShapeIdFkeyPolygonsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon: MultiPolygon3TypeInput;
  plane: PlaneTypeInput;
  shape?: InputMaybe<PolygonsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  unitScale: Scalars['Float'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `shape` to be created by this mutation. */
export type PolygonsShapeIdFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

export enum PredicateType {
  AnyOf = 'ANY_OF',
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  Exists = 'EXISTS',
  FromRegex = 'FROM_REGEX',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
  NotExists = 'NOT_EXISTS'
}

export type Project = Node & {
  __typename?: 'Project';
  /** Reads and enables pagination through a set of `Model`. */
  activeModels?: Maybe<Array<Model>>;
  /** Reads and enables pagination through a set of `Model`. */
  activeModelsConnection: ModelsConnection;
  /** Reads and enables pagination through a set of `Sheet`. */
  activeSheets?: Maybe<Array<Sheet>>;
  /** Reads and enables pagination through a set of `Sheet`. */
  activeSheetsConnection: SheetsConnection;
  /** Reads and enables pagination through a set of `AutoShape`. */
  autoShapes: Array<AutoShape>;
  /** Reads and enables pagination through a set of `AutoShape`. */
  autoShapesConnection: AutoShapesConnection;
  /** Reads and enables pagination through a set of `Comment`. */
  comments: Array<Comment>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsConnection: CommentsConnection;
  /** Reads a single `Contractor` that is related to this `Project`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CopilotExchange`. */
  copilotExchanges: Array<CopilotExchange>;
  /** Reads and enables pagination through a set of `CopilotExchange`. */
  copilotExchangesConnection: CopilotExchangesConnection;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `HistoryEvent`. */
  historyEvents: Array<HistoryEvent>;
  /** Reads and enables pagination through a set of `HistoryEvent`. */
  historyEventsConnection: HistoryEventsConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InitialState`. */
  initialStates: Array<InitialState>;
  /** Reads and enables pagination through a set of `InitialState`. */
  initialStatesConnection: InitialStatesConnection;
  /** Reads and enables pagination through a set of `IssueComment`. */
  issueComments: Array<IssueComment>;
  /** Reads and enables pagination through a set of `IssueComment`. */
  issueCommentsConnection: IssueCommentsConnection;
  /** Reads and enables pagination through a set of `Issue`. */
  issues: Array<Issue>;
  /** Reads and enables pagination through a set of `Issue`. */
  issuesConnection: IssuesConnection;
  /** Reads and enables pagination through a set of `Model`. */
  models: Array<Model>;
  /** Reads and enables pagination through a set of `Model`. */
  modelsConnection: ModelsConnection;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OrderEntryView`. */
  orderEntryViews: Array<OrderEntryView>;
  /** Reads and enables pagination through a set of `OrderEntryView`. */
  orderEntryViewsConnection: OrderEntryViewsConnection;
  /** Reads and enables pagination through a set of `Order`. */
  orders: Array<Order>;
  /** Reads and enables pagination through a set of `Order`. */
  ordersConnection: OrdersConnection;
  /** Reads and enables pagination through a set of `ProtanProjectStep`. */
  protanProjectSteps: Array<ProtanProjectStep>;
  /** Reads and enables pagination through a set of `ProtanProjectStep`. */
  protanProjectStepsConnection: ProtanProjectStepsConnection;
  /** Reads and enables pagination through a set of `SavedView`. */
  savedViews: Array<SavedView>;
  /** Reads and enables pagination through a set of `SavedView`. */
  savedViewsConnection: SavedViewsConnection;
  settings?: Maybe<ProjectSettingsType>;
  /** Reads and enables pagination through a set of `ShapeFolder`. */
  shapeFolders: Array<ShapeFolder>;
  /** Reads and enables pagination through a set of `ShapeFolder`. */
  shapeFoldersConnection: ShapeFoldersConnection;
  /** Reads and enables pagination through a set of `Shape`. */
  shapes: Array<Shape>;
  /** Reads and enables pagination through a set of `Shape`. */
  shapesConnection: ShapesConnection;
  /** Reads and enables pagination through a set of `SharedLink`. */
  sharedLinks: Array<SharedLink>;
  /** Reads and enables pagination through a set of `SharedLink`. */
  sharedLinksConnection: SharedLinksConnection;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapes: Array<SheetShape>;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapesConnection: SheetShapesConnection;
  /** Reads and enables pagination through a set of `Sheet`. */
  sheets: Array<Sheet>;
  /** Reads and enables pagination through a set of `Sheet`. */
  sheetsConnection: SheetsConnection;
  /** Reads and enables pagination through a set of `SparkelAiAnalysis`. */
  sparkelAiAnalyses: Array<SparkelAiAnalysis>;
  /** Reads and enables pagination through a set of `SparkelAiAnalysis`. */
  sparkelAiAnalysesConnection: SparkelAiAnalysesConnection;
  /** Reads and enables pagination through a set of `SparkelProperty`. */
  sparkelProperties: Array<SparkelProperty>;
  /** Reads and enables pagination through a set of `SparkelProperty`. */
  sparkelPropertiesConnection: SparkelPropertiesConnection;
  tags: Array<Scalars['UUID']>;
  templateId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
};


export type ProjectActiveModelsArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectActiveModelsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectActiveSheetsArgs = {
  filter?: InputMaybe<SheetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectActiveSheetsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SheetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectAutoShapesArgs = {
  condition?: InputMaybe<AutoShapeCondition>;
  filter?: InputMaybe<AutoShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};


export type ProjectAutoShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AutoShapeCondition>;
  filter?: InputMaybe<AutoShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};


export type ProjectCommentsArgs = {
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type ProjectCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type ProjectCopilotExchangesArgs = {
  condition?: InputMaybe<CopilotExchangeCondition>;
  filter?: InputMaybe<CopilotExchangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};


export type ProjectCopilotExchangesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CopilotExchangeCondition>;
  filter?: InputMaybe<CopilotExchangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};


export type ProjectHistoryEventsArgs = {
  condition?: InputMaybe<HistoryEventCondition>;
  filter?: InputMaybe<HistoryEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};


export type ProjectHistoryEventsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HistoryEventCondition>;
  filter?: InputMaybe<HistoryEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};


export type ProjectInitialStatesArgs = {
  condition?: InputMaybe<InitialStateCondition>;
  filter?: InputMaybe<InitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};


export type ProjectInitialStatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InitialStateCondition>;
  filter?: InputMaybe<InitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};


export type ProjectIssueCommentsArgs = {
  condition?: InputMaybe<IssueCommentCondition>;
  filter?: InputMaybe<IssueCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};


export type ProjectIssueCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IssueCommentCondition>;
  filter?: InputMaybe<IssueCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};


export type ProjectIssuesArgs = {
  condition?: InputMaybe<IssueCondition>;
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};


export type ProjectIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IssueCondition>;
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};


export type ProjectModelsArgs = {
  condition?: InputMaybe<ModelCondition>;
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};


export type ProjectModelsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ModelCondition>;
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};


export type ProjectOrderEntryViewsArgs = {
  condition?: InputMaybe<OrderEntryViewCondition>;
  filter?: InputMaybe<OrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};


export type ProjectOrderEntryViewsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryViewCondition>;
  filter?: InputMaybe<OrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};


export type ProjectOrdersArgs = {
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type ProjectOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type ProjectProtanProjectStepsArgs = {
  condition?: InputMaybe<ProtanProjectStepCondition>;
  filter?: InputMaybe<ProtanProjectStepFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};


export type ProjectProtanProjectStepsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProtanProjectStepCondition>;
  filter?: InputMaybe<ProtanProjectStepFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};


export type ProjectSavedViewsArgs = {
  condition?: InputMaybe<SavedViewCondition>;
  filter?: InputMaybe<SavedViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};


export type ProjectSavedViewsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavedViewCondition>;
  filter?: InputMaybe<SavedViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};


export type ProjectShapeFoldersArgs = {
  condition?: InputMaybe<ShapeFolderCondition>;
  filter?: InputMaybe<ShapeFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};


export type ProjectShapeFoldersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapeFolderCondition>;
  filter?: InputMaybe<ShapeFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};


export type ProjectShapesArgs = {
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


export type ProjectShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


export type ProjectSharedLinksArgs = {
  condition?: InputMaybe<SharedLinkCondition>;
  filter?: InputMaybe<SharedLinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};


export type ProjectSharedLinksConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SharedLinkCondition>;
  filter?: InputMaybe<SharedLinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};


export type ProjectSheetShapesArgs = {
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


export type ProjectSheetShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


export type ProjectSheetsArgs = {
  condition?: InputMaybe<SheetCondition>;
  filter?: InputMaybe<SheetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};


export type ProjectSheetsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetCondition>;
  filter?: InputMaybe<SheetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};


export type ProjectSparkelAiAnalysesArgs = {
  condition?: InputMaybe<SparkelAiAnalysisCondition>;
  filter?: InputMaybe<SparkelAiAnalysisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};


export type ProjectSparkelAiAnalysesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SparkelAiAnalysisCondition>;
  filter?: InputMaybe<SparkelAiAnalysisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};


export type ProjectSparkelPropertiesArgs = {
  condition?: InputMaybe<SparkelPropertyCondition>;
  filter?: InputMaybe<SparkelPropertyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};


export type ProjectSparkelPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SparkelPropertyCondition>;
  filter?: InputMaybe<SparkelPropertyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `settings` field. */
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `templateId` field. */
  templateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `settings` field. */
  settings?: InputMaybe<ProjectSettingsTypeFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `templateId` field. */
  templateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Project` */
export type ProjectInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProjectNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProjectNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `project` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnAutoShapeForAutoShapesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `autoShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `autoShape` being updated. */
  patch: AutoShapePatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnAutoShapeForAutoShapesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnAutoShapeForAutoShapesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnCommentForCommentsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `comment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: CommentPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnCommentForCommentsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnCommentForCommentsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnCopilotExchangeForCopilotExchangesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `copilotExchange` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `copilotExchange` being updated. */
  patch: CopilotExchangePatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnCopilotExchangeForCopilotExchangesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnCopilotExchangeForCopilotExchangesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnHistoryEventForHistoryEventsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `historyEvent` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `historyEvent` being updated. */
  patch: HistoryEventPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnHistoryEventForHistoryEventsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnHistoryEventForHistoryEventsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnInitialStateForInitialStatesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `initialState` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `initialState` being updated. */
  patch: InitialStatePatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnInitialStateForInitialStatesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnInitialStateForInitialStatesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnIssueCommentForIssueCommentsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `issueComment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `issueComment` being updated. */
  patch: IssueCommentPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnIssueCommentForIssueCommentsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnIssueCommentForIssueCommentsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnIssueForIssuesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `issue` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `issue` being updated. */
  patch: IssuePatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnIssueForIssuesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnIssueForIssuesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnModelForModelsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `model` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `model` being updated. */
  patch: ModelPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnModelForModelsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnModelForModelsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnOrderEntryViewForOrderEntryViewsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderEntryView` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderEntryView` being updated. */
  patch: OrderEntryViewPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnOrderEntryViewForOrderEntryViewsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnOrderEntryViewForOrderEntryViewsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnOrderForOrdersProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `order` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: OrderPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnOrderForOrdersProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnOrderForOrdersProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnProjectForProjectsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectsContractorIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectsContractorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnProtanProjectStepForProtanProjectStepsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `protanProjectStep` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `protanProjectStep` being updated. */
  patch: ProtanProjectStepPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProtanProjectStepForProtanProjectStepsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProtanProjectStepForProtanProjectStepsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnSavedViewForSavedViewsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `savedView` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: SavedViewPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnSavedViewForSavedViewsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnSavedViewForSavedViewsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnShapeFolderForShapeFoldersProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shapeFolder` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: ShapeFolderPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnShapeFolderForShapeFoldersProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnShapeFolderForShapeFoldersProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnShapeForShapesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnShapeForShapesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnShapeForShapesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnSharedLinkForSharedLinksProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sharedLink` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sharedLink` being updated. */
  patch: SharedLinkPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnSharedLinkForSharedLinksProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnSharedLinkForSharedLinksProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnSheetForSheetsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheet` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: SheetPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnSheetForSheetsProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnSheetForSheetsProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnSheetShapeForSheetShapesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnSheetShapeForSheetShapesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnSheetShapeForSheetShapesProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sparkelAiAnalysis` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sparkelAiAnalysis` being updated. */
  patch: SparkelAiAnalysisPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectOnSparkelPropertyForSparkelPropertiesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sparkelProperty` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sparkelProperty` being updated. */
  patch: SparkelPropertyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnSparkelPropertyForSparkelPropertiesProjectIdFkeyUsingProjectsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnSparkelPropertyForSparkelPropertiesProjectIdFkeyPatch;
};

/** Represents an update to a `Project`. Fields that are set will be updated. */
export type ProjectPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `project` to look up the row to delete. */
export type ProjectProjectsPkeyDelete = {
  id: Scalars['UUID'];
};

export type ProjectSettingsType = {
  __typename?: 'ProjectSettingsType';
  allowedElementsCategories?: Maybe<Array<ElementCategoryType>>;
  allowedOrderLabels?: Maybe<Array<LabelType>>;
  manuallyApplyFilters?: Maybe<Scalars['Boolean']>;
  polygonCalculationLimit?: Maybe<Scalars['Int']>;
  translationType?: Maybe<TranslationType>;
  unitSettings?: Maybe<UnitSettingsType>;
  viewerGlobalOffset?: Maybe<Point3Type>;
};

/** A filter to be used against `ProjectSettingsType` object types. All fields are combined with a logical ‘and.’ */
export type ProjectSettingsTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectSettingsTypeFilter>>;
  /** Filter by the object’s `manuallyApplyFilters` field. */
  manuallyApplyFilters?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectSettingsTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectSettingsTypeFilter>>;
  /** Filter by the object’s `polygonCalculationLimit` field. */
  polygonCalculationLimit?: InputMaybe<IntFilter>;
  /** Filter by the object’s `translationType` field. */
  translationType?: InputMaybe<TranslationTypeFilter>;
  /** Filter by the object’s `unitSettings` field. */
  unitSettings?: InputMaybe<UnitSettingsTypeFilter>;
  /** Filter by the object’s `viewerGlobalOffset` field. */
  viewerGlobalOffset?: InputMaybe<Point3TypeFilter>;
};

/** An input for mutations affecting `ProjectSettingsType` */
export type ProjectSettingsTypeInput = {
  allowedElementsCategories?: InputMaybe<Array<InputMaybe<ElementCategoryTypeInput>>>;
  allowedOrderLabels?: InputMaybe<Array<InputMaybe<LabelTypeInput>>>;
  manuallyApplyFilters?: InputMaybe<Scalars['Boolean']>;
  polygonCalculationLimit?: InputMaybe<Scalars['Int']>;
  translationType?: InputMaybe<TranslationType>;
  unitSettings?: InputMaybe<UnitSettingsTypeInput>;
  viewerGlobalOffset?: InputMaybe<Point3TypeInput>;
};

export type ProjectTag = Node & {
  __typename?: 'ProjectTag';
  color: TagColorScheme;
  /** Reads a single `Contractor` that is related to this `ProjectTag`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `ProjectTag` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProjectTagCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<TagColorScheme>;
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTagFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<TagColorSchemeFilter>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTagFilter>>;
};

/** An input for mutations affecting `ProjectTag` */
export type ProjectTagInput = {
  color: TagColorScheme;
  contractor?: InputMaybe<ProjectTagsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type ProjectTagNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `projectTag` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProjectTagNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `projectTag` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTagOnProjectTagForProjectTagsContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `projectTag` to look up the row to update. */
export type ProjectTagOnProjectTagForProjectTagsContractorIdFkeyUsingProjectTagsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTag` being updated. */
  patch: UpdateProjectTagOnProjectTagForProjectTagsContractorIdFkeyPatch;
};

/** Represents an update to a `ProjectTag`. Fields that are set will be updated. */
export type ProjectTagPatch = {
  color?: InputMaybe<TagColorScheme>;
  contractor?: InputMaybe<ProjectTagsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The fields on `projectTag` to look up the row to connect. */
export type ProjectTagProjectTagsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectTag` to look up the row to delete. */
export type ProjectTagProjectTagsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ProjectTag` values. */
export type ProjectTagsConnection = {
  __typename?: 'ProjectTagsConnection';
  /** A list of edges which contains the `ProjectTag` and cursor to aid in pagination. */
  edges: Array<ProjectTagsEdge>;
  /** A list of `ProjectTag` objects. */
  nodes: Array<ProjectTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTag` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type ProjectTagsContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `ProjectTagInput` mutation. */
export type ProjectTagsContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTagsContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnProjectTagForProjectTagsContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProjectTagOnProjectTagForProjectTagsContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnProjectTagForProjectTagsContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `projectTag` in the `ContractorInput` mutation. */
export type ProjectTagsContractorIdFkeyInverseInput = {
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTagProjectTagsPkeyConnect>>;
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProjectTagNodeIdConnect>>;
  /** A `ProjectTagInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTagsContractorIdFkeyProjectTagsCreateInput>>;
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTagProjectTagsPkeyDelete>>;
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProjectTagNodeIdDelete>>;
  /** Flag indicating whether all other `projectTag` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectTag` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTagOnProjectTagForProjectTagsContractorIdFkeyUsingProjectTagsPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectTag` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnProjectTagForProjectTagsContractorIdFkeyNodeIdUpdate>>;
};

/** The `projectTag` to be created by this mutation. */
export type ProjectTagsContractorIdFkeyProjectTagsCreateInput = {
  color: TagColorScheme;
  contractor?: InputMaybe<ProjectTagsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** A `ProjectTag` edge in the connection. */
export type ProjectTagsEdge = {
  __typename?: 'ProjectTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectTag` at the end of the edge. */
  node: ProjectTag;
};

/** Methods to use when ordering `ProjectTag`. */
export enum ProjectTagsOrderBy {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ProjectTemplate = Node & {
  __typename?: 'ProjectTemplate';
  /** Reads a single `Contractor` that is related to this `ProjectTemplate`. */
  contractor?: Maybe<Contractor>;
  contractorId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  isPublic: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  originalProjectId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrderEntryView`. */
  projectTemplateOrderEntryViews: Array<ProjectTemplateOrderEntryView>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrderEntryView`. */
  projectTemplateOrderEntryViewsConnection: ProjectTemplateOrderEntryViewsConnection;
  /** Reads and enables pagination through a set of `ProjectTemplateOrder`. */
  projectTemplateOrders: Array<ProjectTemplateOrder>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrder`. */
  projectTemplateOrdersConnection: ProjectTemplateOrdersConnection;
  settings?: Maybe<ProjectTemplateSettings>;
  shapeFolderNames?: Maybe<Array<Scalars['String']>>;
  templateName: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type ProjectTemplateProjectTemplateOrderEntryViewsArgs = {
  condition?: InputMaybe<ProjectTemplateOrderEntryViewCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};


export type ProjectTemplateProjectTemplateOrderEntryViewsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateOrderEntryViewCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};


export type ProjectTemplateProjectTemplateOrdersArgs = {
  condition?: InputMaybe<ProjectTemplateOrderCondition>;
  filter?: InputMaybe<ProjectTemplateOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};


export type ProjectTemplateProjectTemplateOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateOrderCondition>;
  filter?: InputMaybe<ProjectTemplateOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};

/**
 * A condition to be used against `ProjectTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectTemplateCondition = {
  /** Checks for equality with the object’s `contractorId` field. */
  contractorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isPublic` field. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `originalProjectId` field. */
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `settings` field. */
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  /** Checks for equality with the object’s `shapeFolderNames` field. */
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `templateName` field. */
  templateName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProjectTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTemplateFilter>>;
  /** Filter by the object’s `contractorId` field. */
  contractorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isPublic` field. */
  isPublic?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTemplateFilter>>;
  /** Filter by the object’s `originalProjectId` field. */
  originalProjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `shapeFolderNames` field. */
  shapeFolderNames?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `templateName` field. */
  templateName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectTemplate` */
export type ProjectTemplateInput = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProjectTemplateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `projectTemplate` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProjectTemplateNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `projectTemplate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOnProjectTemplateForProjectTemplatesContractorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contractor` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `contractor` being updated. */
  patch: ContractorPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnProjectTemplateForProjectTemplatesContractorIdFkeyUsingProjectTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnProjectTemplateForProjectTemplatesContractorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntryView` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplateOrderEntryView` being updated. */
  patch: ProjectTemplateOrderEntryViewPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyUsingProjectTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrder` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
  patch: ProjectTemplateOrderPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyUsingProjectTemplatesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyPatch;
};

export type ProjectTemplateOrder = Node & {
  __typename?: 'ProjectTemplateOrder';
  aggregatedOrderAggregation?: Maybe<Array<AggregatedOrderAggregationType>>;
  aggregatedOrderFilters?: Maybe<Array<AggregatedOrderFilterType>>;
  aggregatedOrderGrouping?: Maybe<Array<AggregatedOrderGroupingType>>;
  aggregatedOrderView?: Maybe<AggregatedOrderViewType>;
  areItemsFlattened?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isAggregatedOrder: Scalars['Boolean'];
  labels?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OrderColumnTemplate`. */
  orderColumnTemplates: Array<OrderColumnTemplate>;
  /** Reads and enables pagination through a set of `OrderColumnTemplate`. */
  orderColumnTemplatesConnection: OrderColumnTemplatesConnection;
  originalOrderId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrder`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  projectTemplateId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProjectTemplateOrderEntry`. */
  projectTemplateOrderEntries: Array<ProjectTemplateOrderEntry>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrderEntry`. */
  projectTemplateOrderEntriesConnection: ProjectTemplateOrderEntriesConnection;
  shapeFolderNames?: Maybe<Array<Scalars['String']>>;
};


export type ProjectTemplateOrderOrderColumnTemplatesArgs = {
  condition?: InputMaybe<OrderColumnTemplateCondition>;
  filter?: InputMaybe<OrderColumnTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};


export type ProjectTemplateOrderOrderColumnTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderColumnTemplateCondition>;
  filter?: InputMaybe<OrderColumnTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};


export type ProjectTemplateOrderProjectTemplateOrderEntriesArgs = {
  condition?: InputMaybe<ProjectTemplateOrderEntryCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};


export type ProjectTemplateOrderProjectTemplateOrderEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateOrderEntryCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};

/**
 * A condition to be used against `ProjectTemplateOrder` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProjectTemplateOrderCondition = {
  /** Checks for equality with the object’s `aggregatedOrderAggregation` field. */
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  /** Checks for equality with the object’s `aggregatedOrderFilters` field. */
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  /** Checks for equality with the object’s `aggregatedOrderGrouping` field. */
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  /** Checks for equality with the object’s `aggregatedOrderView` field. */
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  /** Checks for equality with the object’s `areItemsFlattened` field. */
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isAggregatedOrder` field. */
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `labels` field. */
  labels?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `originalOrderId` field. */
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectTemplateId` field. */
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `shapeFolderNames` field. */
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A connection to a list of `ProjectTemplateOrderEntry` values. */
export type ProjectTemplateOrderEntriesConnection = {
  __typename?: 'ProjectTemplateOrderEntriesConnection';
  /** A list of edges which contains the `ProjectTemplateOrderEntry` and cursor to aid in pagination. */
  edges: Array<ProjectTemplateOrderEntriesEdge>;
  /** A list of `ProjectTemplateOrderEntry` objects. */
  nodes: Array<ProjectTemplateOrderEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTemplateOrderEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectTemplateOrderEntry` edge in the connection. */
export type ProjectTemplateOrderEntriesEdge = {
  __typename?: 'ProjectTemplateOrderEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectTemplateOrderEntry` at the end of the edge. */
  node: ProjectTemplateOrderEntry;
};

/** Methods to use when ordering `ProjectTemplateOrderEntry`. */
export enum ProjectTemplateOrderEntriesOrderBy {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  ElementIdentifiersQueryAsc = 'ELEMENT_IDENTIFIERS_QUERY_ASC',
  ElementIdentifiersQueryDesc = 'ELEMENT_IDENTIFIERS_QUERY_DESC',
  GroupByAttributesAsc = 'GROUP_BY_ATTRIBUTES_ASC',
  GroupByAttributesDesc = 'GROUP_BY_ATTRIBUTES_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalOrderEntryIdAsc = 'ORIGINAL_ORDER_ENTRY_ID_ASC',
  OriginalOrderEntryIdDesc = 'ORIGINAL_ORDER_ENTRY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectTemplateOrderIdAsc = 'PROJECT_TEMPLATE_ORDER_ID_ASC',
  ProjectTemplateOrderIdDesc = 'PROJECT_TEMPLATE_ORDER_ID_DESC',
  PromptForLinkingAsc = 'PROMPT_FOR_LINKING_ASC',
  PromptForLinkingDesc = 'PROMPT_FOR_LINKING_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  UnitAsc = 'UNIT_ASC',
  UnitDesc = 'UNIT_DESC',
  UnitPriceAsc = 'UNIT_PRICE_ASC',
  UnitPriceDesc = 'UNIT_PRICE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsePromptForLinkingAsc = 'USE_PROMPT_FOR_LINKING_ASC',
  UsePromptForLinkingDesc = 'USE_PROMPT_FOR_LINKING_DESC'
}

/** Input for the nested mutation of `projectTemplateOrder` in the `ProjectTemplateOrderEntryInput` mutation. */
export type ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput = {
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateOrderProjectTemplateOrdersPkeyConnect>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectTemplateOrderNodeIdConnect>;
  /** A `ProjectTemplateOrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyProjectTemplateOrdersCreateInput>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectTemplateOrderProjectTemplateOrdersPkeyDelete>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectTemplateOrderNodeIdDelete>;
  /** The primary key(s) and patch data for `projectTemplateOrder` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOrderOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyUsingProjectTemplateOrdersPkeyUpdate>;
  /** The primary key(s) and patch data for `projectTemplateOrder` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProjectTemplateOrderEntryOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `projectTemplateOrderEntry` in the `ProjectTemplateOrderInput` mutation. */
export type ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput = {
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateOrderEntryProjectTemplateOrderEntriesPkeyConnect>>;
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProjectTemplateOrderEntryNodeIdConnect>>;
  /** A `ProjectTemplateOrderEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyProjectTemplateOrderEntriesCreateInput>>;
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTemplateOrderEntryProjectTemplateOrderEntriesPkeyDelete>>;
  /** The primary key(s) for `projectTemplateOrderEntry` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProjectTemplateOrderEntryNodeIdDelete>>;
  /** Flag indicating whether all other `projectTemplateOrderEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectTemplateOrderEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOrderEntryOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyUsingProjectTemplateOrderEntriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectTemplateOrderEntry` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectTemplateOrderOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyNodeIdUpdate>>;
};

/** The `projectTemplateOrderEntry` to be created by this mutation. */
export type ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyProjectTemplateOrderEntriesCreateInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrder?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** The `projectTemplateOrder` to be created by this mutation. */
export type ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyProjectTemplateOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProjectTemplateOrderEntry = Node & {
  __typename?: 'ProjectTemplateOrderEntry';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  currency: CurrencyEnum;
  /** Reads and enables pagination through a set of `CustomFieldTemplate`. */
  customFieldTemplates: Array<CustomFieldTemplate>;
  /** Reads and enables pagination through a set of `CustomFieldTemplate`. */
  customFieldTemplatesConnection: CustomFieldTemplatesConnection;
  elementIdentifiersQuery?: Maybe<ForgeAttributeQueryType>;
  groupByAttributes?: Maybe<Array<ForgeAttributeType>>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  originalOrderEntryId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `ProjectTemplateOrderEntry`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  projectTemplateOrderId: Scalars['UUID'];
  promptForLinking?: Maybe<Scalars['String']>;
  quantity?: Maybe<QuantityType>;
  unit?: Maybe<Unit>;
  unitPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
  usePromptForLinking: Scalars['Boolean'];
};


export type ProjectTemplateOrderEntryCustomFieldTemplatesArgs = {
  condition?: InputMaybe<CustomFieldTemplateCondition>;
  filter?: InputMaybe<CustomFieldTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};


export type ProjectTemplateOrderEntryCustomFieldTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomFieldTemplateCondition>;
  filter?: InputMaybe<CustomFieldTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};

/**
 * A condition to be used against `ProjectTemplateOrderEntry` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectTemplateOrderEntryCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<CurrencyEnum>;
  /** Checks for equality with the object’s `elementIdentifiersQuery` field. */
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  /** Checks for equality with the object’s `groupByAttributes` field. */
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `originalOrderEntryId` field. */
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectTemplateOrderId` field. */
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `promptForLinking` field. */
  promptForLinking?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<QuantityTypeInput>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Unit>;
  /** Checks for equality with the object’s `unitPrice` field. */
  unitPrice?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `usePromptForLinking` field. */
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `ProjectTemplateOrderEntry` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateOrderEntryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTemplateOrderEntryFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyEnumFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTemplateOrderEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTemplateOrderEntryFilter>>;
  /** Filter by the object’s `originalOrderEntryId` field. */
  originalOrderEntryId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectTemplateOrderId` field. */
  projectTemplateOrderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `promptForLinking` field. */
  promptForLinking?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<QuantityTypeFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<UnitFilter>;
  /** Filter by the object’s `unitPrice` field. */
  unitPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usePromptForLinking` field. */
  usePromptForLinking?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `ProjectTemplateOrderEntry` */
export type ProjectTemplateOrderEntryInput = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrder?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProjectTemplateOrderEntryNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntry` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProjectTemplateOrderEntryNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntry` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOrderEntryOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `customFieldTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `customFieldTemplate` being updated. */
  patch: CustomFieldTemplatePatch;
};

/** The fields on `projectTemplateOrderEntry` to look up the row to update. */
export type ProjectTemplateOrderEntryOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyUsingProjectTemplateOrderEntriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplateOrderEntry` being updated. */
  patch: UpdateProjectTemplateOrderEntryOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOrderEntryOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrder` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
  patch: ProjectTemplateOrderPatch;
};

/** The fields on `projectTemplateOrderEntry` to look up the row to update. */
export type ProjectTemplateOrderEntryOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyUsingProjectTemplateOrderEntriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplateOrderEntry` being updated. */
  patch: UpdateProjectTemplateOrderEntryOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyPatch;
};

/** Represents an update to a `ProjectTemplateOrderEntry`. Fields that are set will be updated. */
export type ProjectTemplateOrderEntryPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrder?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `projectTemplateOrderEntry` to look up the row to connect. */
export type ProjectTemplateOrderEntryProjectTemplateOrderEntriesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectTemplateOrderEntry` to look up the row to delete. */
export type ProjectTemplateOrderEntryProjectTemplateOrderEntriesPkeyDelete = {
  id: Scalars['UUID'];
};

export type ProjectTemplateOrderEntryView = Node & {
  __typename?: 'ProjectTemplateOrderEntryView';
  columnFilters?: Maybe<Array<ColumnFilterType>>;
  globalFilter: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  originalOrderEntryViewId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrderEntryView`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  projectTemplateId: Scalars['UUID'];
  visibleColumns: Array<Scalars['String']>;
};

/**
 * A condition to be used against `ProjectTemplateOrderEntryView` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectTemplateOrderEntryViewCondition = {
  /** Checks for equality with the object’s `columnFilters` field. */
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  /** Checks for equality with the object’s `globalFilter` field. */
  globalFilter?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `originalOrderEntryViewId` field. */
  originalOrderEntryViewId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectTemplateId` field. */
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `visibleColumns` field. */
  visibleColumns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A filter to be used against `ProjectTemplateOrderEntryView` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateOrderEntryViewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTemplateOrderEntryViewFilter>>;
  /** Filter by the object’s `globalFilter` field. */
  globalFilter?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTemplateOrderEntryViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTemplateOrderEntryViewFilter>>;
  /** Filter by the object’s `originalOrderEntryViewId` field. */
  originalOrderEntryViewId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectTemplateId` field. */
  projectTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `visibleColumns` field. */
  visibleColumns?: InputMaybe<StringListFilter>;
};

/** An input for mutations affecting `ProjectTemplateOrderEntryView` */
export type ProjectTemplateOrderEntryViewInput = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  globalFilter: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  originalOrderEntryViewId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  visibleColumns: Array<InputMaybe<Scalars['String']>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProjectTemplateOrderEntryViewNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntryView` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProjectTemplateOrderEntryViewNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntryView` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOrderEntryViewOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: ProjectTemplatePatch;
};

/** The fields on `projectTemplateOrderEntryView` to look up the row to update. */
export type ProjectTemplateOrderEntryViewOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyUsingProjectTemplateOrderEntryViewsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplateOrderEntryView` being updated. */
  patch: UpdateProjectTemplateOrderEntryViewOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyPatch;
};

/** Represents an update to a `ProjectTemplateOrderEntryView`. Fields that are set will be updated. */
export type ProjectTemplateOrderEntryViewPatch = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  globalFilter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryViewId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  visibleColumns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The fields on `projectTemplateOrderEntryView` to look up the row to connect. */
export type ProjectTemplateOrderEntryViewProjectTemplateOrderEntryViewsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectTemplateOrderEntryView` to look up the row to delete. */
export type ProjectTemplateOrderEntryViewProjectTemplateOrderEntryViewsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ProjectTemplateOrderEntryView` values. */
export type ProjectTemplateOrderEntryViewsConnection = {
  __typename?: 'ProjectTemplateOrderEntryViewsConnection';
  /** A list of edges which contains the `ProjectTemplateOrderEntryView` and cursor to aid in pagination. */
  edges: Array<ProjectTemplateOrderEntryViewsEdge>;
  /** A list of `ProjectTemplateOrderEntryView` objects. */
  nodes: Array<ProjectTemplateOrderEntryView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTemplateOrderEntryView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectTemplateOrderEntryView` edge in the connection. */
export type ProjectTemplateOrderEntryViewsEdge = {
  __typename?: 'ProjectTemplateOrderEntryViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectTemplateOrderEntryView` at the end of the edge. */
  node: ProjectTemplateOrderEntryView;
};

/** Methods to use when ordering `ProjectTemplateOrderEntryView`. */
export enum ProjectTemplateOrderEntryViewsOrderBy {
  ColumnFiltersAsc = 'COLUMN_FILTERS_ASC',
  ColumnFiltersDesc = 'COLUMN_FILTERS_DESC',
  GlobalFilterAsc = 'GLOBAL_FILTER_ASC',
  GlobalFilterDesc = 'GLOBAL_FILTER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalOrderEntryViewIdAsc = 'ORIGINAL_ORDER_ENTRY_VIEW_ID_ASC',
  OriginalOrderEntryViewIdDesc = 'ORIGINAL_ORDER_ENTRY_VIEW_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectTemplateIdAsc = 'PROJECT_TEMPLATE_ID_ASC',
  ProjectTemplateIdDesc = 'PROJECT_TEMPLATE_ID_DESC',
  VisibleColumnsAsc = 'VISIBLE_COLUMNS_ASC',
  VisibleColumnsDesc = 'VISIBLE_COLUMNS_DESC'
}

/** Input for the nested mutation of `projectTemplate` in the `ProjectTemplateOrderEntryViewInput` mutation. */
export type ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateProjectTemplatesPkeyConnect>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectTemplateNodeIdConnect>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyProjectTemplatesCreateInput>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectTemplateProjectTemplatesPkeyDelete>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectTemplateNodeIdDelete>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyUsingProjectTemplatesPkeyUpdate>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProjectTemplateOrderEntryViewOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `projectTemplateOrderEntryView` in the `ProjectTemplateInput` mutation. */
export type ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput = {
  /** The primary key(s) for `projectTemplateOrderEntryView` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateOrderEntryViewProjectTemplateOrderEntryViewsPkeyConnect>>;
  /** The primary key(s) for `projectTemplateOrderEntryView` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProjectTemplateOrderEntryViewNodeIdConnect>>;
  /** A `ProjectTemplateOrderEntryViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyProjectTemplateOrderEntryViewsCreateInput>>;
  /** The primary key(s) for `projectTemplateOrderEntryView` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTemplateOrderEntryViewProjectTemplateOrderEntryViewsPkeyDelete>>;
  /** The primary key(s) for `projectTemplateOrderEntryView` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProjectTemplateOrderEntryViewNodeIdDelete>>;
  /** Flag indicating whether all other `projectTemplateOrderEntryView` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectTemplateOrderEntryView` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOrderEntryViewOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyUsingProjectTemplateOrderEntryViewsPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectTemplateOrderEntryView` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectTemplateOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyNodeIdUpdate>>;
};

/** The `projectTemplateOrderEntryView` to be created by this mutation. */
export type ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyProjectTemplateOrderEntryViewsCreateInput = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  globalFilter: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  originalOrderEntryViewId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  visibleColumns: Array<InputMaybe<Scalars['String']>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyProjectTemplatesCreateInput = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProjectTemplateOrder` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateOrderFilter = {
  /** Filter by the object’s `aggregatedOrderView` field. */
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewTypeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTemplateOrderFilter>>;
  /** Filter by the object’s `areItemsFlattened` field. */
  areItemsFlattened?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isAggregatedOrder` field. */
  isAggregatedOrder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `labels` field. */
  labels?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTemplateOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTemplateOrderFilter>>;
  /** Filter by the object’s `originalOrderId` field. */
  originalOrderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectTemplateId` field. */
  projectTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `shapeFolderNames` field. */
  shapeFolderNames?: InputMaybe<StringListFilter>;
};

/** An input for mutations affecting `ProjectTemplateOrder` */
export type ProjectTemplateOrderInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProjectTemplateOrderNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrder` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProjectTemplateOrderNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrder` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOrderOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `orderColumnTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `orderColumnTemplate` being updated. */
  patch: OrderColumnTemplatePatch;
};

/** The fields on `projectTemplateOrder` to look up the row to update. */
export type ProjectTemplateOrderOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyUsingProjectTemplateOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
  patch: UpdateProjectTemplateOrderOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOrderOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplateOrderEntry` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplateOrderEntry` being updated. */
  patch: ProjectTemplateOrderEntryPatch;
};

/** The fields on `projectTemplateOrder` to look up the row to update. */
export type ProjectTemplateOrderOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyUsingProjectTemplateOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
  patch: UpdateProjectTemplateOrderOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProjectTemplateOrderOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `projectTemplate` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: ProjectTemplatePatch;
};

/** The fields on `projectTemplateOrder` to look up the row to update. */
export type ProjectTemplateOrderOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyUsingProjectTemplateOrdersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
  patch: UpdateProjectTemplateOrderOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyPatch;
};

/** Represents an update to a `ProjectTemplateOrder`. Fields that are set will be updated. */
export type ProjectTemplateOrderPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The fields on `projectTemplateOrder` to look up the row to connect. */
export type ProjectTemplateOrderProjectTemplateOrdersPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectTemplateOrder` to look up the row to delete. */
export type ProjectTemplateOrderProjectTemplateOrdersPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ProjectTemplateOrder` values. */
export type ProjectTemplateOrdersConnection = {
  __typename?: 'ProjectTemplateOrdersConnection';
  /** A list of edges which contains the `ProjectTemplateOrder` and cursor to aid in pagination. */
  edges: Array<ProjectTemplateOrdersEdge>;
  /** A list of `ProjectTemplateOrder` objects. */
  nodes: Array<ProjectTemplateOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTemplateOrder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectTemplateOrder` edge in the connection. */
export type ProjectTemplateOrdersEdge = {
  __typename?: 'ProjectTemplateOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectTemplateOrder` at the end of the edge. */
  node: ProjectTemplateOrder;
};

/** Methods to use when ordering `ProjectTemplateOrder`. */
export enum ProjectTemplateOrdersOrderBy {
  AggregatedOrderAggregationAsc = 'AGGREGATED_ORDER_AGGREGATION_ASC',
  AggregatedOrderAggregationDesc = 'AGGREGATED_ORDER_AGGREGATION_DESC',
  AggregatedOrderFiltersAsc = 'AGGREGATED_ORDER_FILTERS_ASC',
  AggregatedOrderFiltersDesc = 'AGGREGATED_ORDER_FILTERS_DESC',
  AggregatedOrderGroupingAsc = 'AGGREGATED_ORDER_GROUPING_ASC',
  AggregatedOrderGroupingDesc = 'AGGREGATED_ORDER_GROUPING_DESC',
  AggregatedOrderViewAsc = 'AGGREGATED_ORDER_VIEW_ASC',
  AggregatedOrderViewDesc = 'AGGREGATED_ORDER_VIEW_DESC',
  AreItemsFlattenedAsc = 'ARE_ITEMS_FLATTENED_ASC',
  AreItemsFlattenedDesc = 'ARE_ITEMS_FLATTENED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAggregatedOrderAsc = 'IS_AGGREGATED_ORDER_ASC',
  IsAggregatedOrderDesc = 'IS_AGGREGATED_ORDER_DESC',
  LabelsAsc = 'LABELS_ASC',
  LabelsDesc = 'LABELS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalOrderIdAsc = 'ORIGINAL_ORDER_ID_ASC',
  OriginalOrderIdDesc = 'ORIGINAL_ORDER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectTemplateIdAsc = 'PROJECT_TEMPLATE_ID_ASC',
  ProjectTemplateIdDesc = 'PROJECT_TEMPLATE_ID_DESC',
  ShapeFolderNamesAsc = 'SHAPE_FOLDER_NAMES_ASC',
  ShapeFolderNamesDesc = 'SHAPE_FOLDER_NAMES_DESC'
}

/** Input for the nested mutation of `projectTemplate` in the `ProjectTemplateOrderInput` mutation. */
export type ProjectTemplateOrdersProjectTemplateIdFkeyInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateProjectTemplatesPkeyConnect>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectTemplateNodeIdConnect>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyProjectTemplatesCreateInput>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectTemplateProjectTemplatesPkeyDelete>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectTemplateNodeIdDelete>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyUsingProjectTemplatesPkeyUpdate>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProjectTemplateOrderOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `projectTemplateOrder` in the `ProjectTemplateInput` mutation. */
export type ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput = {
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateOrderProjectTemplateOrdersPkeyConnect>>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProjectTemplateOrderNodeIdConnect>>;
  /** A `ProjectTemplateOrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplateOrdersProjectTemplateIdFkeyProjectTemplateOrdersCreateInput>>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTemplateOrderProjectTemplateOrdersPkeyDelete>>;
  /** The primary key(s) for `projectTemplateOrder` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProjectTemplateOrderNodeIdDelete>>;
  /** Flag indicating whether all other `projectTemplateOrder` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectTemplateOrder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOrderOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyUsingProjectTemplateOrdersPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectTemplateOrder` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectTemplateOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyNodeIdUpdate>>;
};

/** The `projectTemplateOrder` to be created by this mutation. */
export type ProjectTemplateOrdersProjectTemplateIdFkeyProjectTemplateOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ProjectTemplateOrdersProjectTemplateIdFkeyProjectTemplatesCreateInput = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `ProjectTemplate`. Fields that are set will be updated. */
export type ProjectTemplatePatch = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `projectTemplate` to look up the row to connect. */
export type ProjectTemplateProjectTemplatesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectTemplate` to look up the row to delete. */
export type ProjectTemplateProjectTemplatesPkeyDelete = {
  id: Scalars['UUID'];
};

export type ProjectTemplateSettings = {
  __typename?: 'ProjectTemplateSettings';
  allowedElementsCategories?: Maybe<Array<ElementCategoryType>>;
  allowedOrderLabels?: Maybe<Array<LabelType>>;
  manuallyApplyFilters?: Maybe<Scalars['Boolean']>;
  polygonCalculationLimit?: Maybe<Scalars['Int']>;
  translationType?: Maybe<TranslationType>;
  unitSettings?: Maybe<UnitSettingsType>;
};

export type ProjectTemplateSettingsInput = {
  allowedElementsCategories?: InputMaybe<Array<InputMaybe<ElementCategoryTypeInput>>>;
  allowedOrderLabels?: InputMaybe<Array<InputMaybe<LabelTypeInput>>>;
  manuallyApplyFilters?: InputMaybe<Scalars['Boolean']>;
  polygonCalculationLimit?: InputMaybe<Scalars['Int']>;
  translationType?: InputMaybe<TranslationType>;
  unitSettings?: InputMaybe<UnitSettingsTypeInput>;
};

/** A connection to a list of `ProjectTemplate` values. */
export type ProjectTemplatesConnection = {
  __typename?: 'ProjectTemplatesConnection';
  /** A list of edges which contains the `ProjectTemplate` and cursor to aid in pagination. */
  edges: Array<ProjectTemplatesEdge>;
  /** A list of `ProjectTemplate` objects. */
  nodes: Array<ProjectTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type ProjectTemplatesContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `ProjectTemplateInput` mutation. */
export type ProjectTemplatesContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTemplatesContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProjectTemplateOnProjectTemplateForProjectTemplatesContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `projectTemplate` in the `ContractorInput` mutation. */
export type ProjectTemplatesContractorIdFkeyInverseInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateProjectTemplatesPkeyConnect>>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProjectTemplateNodeIdConnect>>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplatesContractorIdFkeyProjectTemplatesCreateInput>>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTemplateProjectTemplatesPkeyDelete>>;
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProjectTemplateNodeIdDelete>>;
  /** Flag indicating whether all other `projectTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOnProjectTemplateForProjectTemplatesContractorIdFkeyUsingProjectTemplatesPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyNodeIdUpdate>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ProjectTemplatesContractorIdFkeyProjectTemplatesCreateInput = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A `ProjectTemplate` edge in the connection. */
export type ProjectTemplatesEdge = {
  __typename?: 'ProjectTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectTemplate` at the end of the edge. */
  node: ProjectTemplate;
};

/** Methods to use when ordering `ProjectTemplate`. */
export enum ProjectTemplatesOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPublicAsc = 'IS_PUBLIC_ASC',
  IsPublicDesc = 'IS_PUBLIC_DESC',
  Natural = 'NATURAL',
  OriginalProjectIdAsc = 'ORIGINAL_PROJECT_ID_ASC',
  OriginalProjectIdDesc = 'ORIGINAL_PROJECT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SettingsAsc = 'SETTINGS_ASC',
  SettingsDesc = 'SETTINGS_DESC',
  ShapeFolderNamesAsc = 'SHAPE_FOLDER_NAMES_ASC',
  ShapeFolderNamesDesc = 'SHAPE_FOLDER_NAMES_DESC',
  TemplateNameAsc = 'TEMPLATE_NAME_ASC',
  TemplateNameDesc = 'TEMPLATE_NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename?: 'ProjectsConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Project>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractor` to be created by this mutation. */
export type ProjectsContractorIdFkeyContractorsCreateInput = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractor` in the `ProjectInput` mutation. */
export type ProjectsContractorIdFkeyInput = {
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectById?: InputMaybe<ContractorContractorsPkeyConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContractorNodeIdConnect>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  connectByTenant?: InputMaybe<ContractorContractorsTenantKeyConnect>;
  /** A `ContractorInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectsContractorIdFkeyContractorsCreateInput>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractorContractorsPkeyDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContractorNodeIdDelete>;
  /** The primary key(s) for `contractor` for the far side of the relationship. */
  deleteByTenant?: InputMaybe<ContractorContractorsTenantKeyDelete>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateById?: InputMaybe<ContractorOnProjectForProjectsContractorIdFkeyUsingContractorsPkeyUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProjectOnProjectForProjectsContractorIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `contractor` for the far side of the relationship. */
  updateByTenant?: InputMaybe<ContractorOnProjectForProjectsContractorIdFkeyUsingContractorsTenantKeyUpdate>;
};

/** Input for the nested mutation of `project` in the `ContractorInput` mutation. */
export type ProjectsContractorIdFkeyInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectsPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProjectNodeIdConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectsContractorIdFkeyProjectsCreateInput>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectProjectsPkeyDelete>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProjectNodeIdDelete>>;
  /** Flag indicating whether all other `project` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectsContractorIdFkeyUsingProjectsPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContractorOnProjectForProjectsContractorIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ProjectsContractorIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename?: 'ProjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Project` at the end of the edge. */
  node: Project;
};

/** Methods to use when ordering `Project`. */
export enum ProjectsOrderBy {
  ContractorIdAsc = 'CONTRACTOR_ID_ASC',
  ContractorIdDesc = 'CONTRACTOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SettingsAsc = 'SETTINGS_ASC',
  SettingsDesc = 'SETTINGS_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TemplateIdAsc = 'TEMPLATE_ID_ASC',
  TemplateIdDesc = 'TEMPLATE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type PropertySetType = {
  __typename?: 'PropertySetType';
  category: Scalars['String'];
  properties: Array<Scalars['String']>;
};

/** An input for mutations affecting `PropertySetType` */
export type PropertySetTypeInput = {
  category: Scalars['String'];
  properties: Array<InputMaybe<Scalars['String']>>;
};

export type ProtanProjectStep = Node & {
  __typename?: 'ProtanProjectStep';
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `ProtanProjectStep`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  status: ProtanProjectStepStatusEnum;
  step: ProtanProjectStepEnum;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ProtanProjectStep` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProtanProjectStepCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Checks for equality with the object’s `step` field. */
  step?: InputMaybe<ProtanProjectStepEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum ProtanProjectStepEnum {
  AiAnalysis = 'AI_ANALYSIS',
  DrainLinePlacement = 'DRAIN_LINE_PLACEMENT',
  DrainPlacement = 'DRAIN_PLACEMENT',
  DrawingCalibration = 'DRAWING_CALIBRATION',
  ParameterDefinition = 'PARAMETER_DEFINITION',
  RoofOutline = 'ROOF_OUTLINE',
  WedgePlacement = 'WEDGE_PLACEMENT'
}

/** A filter to be used against ProtanProjectStepEnum fields. All fields are combined with a logical ‘and.’ */
export type ProtanProjectStepEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProtanProjectStepEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProtanProjectStepEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProtanProjectStepEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProtanProjectStepEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProtanProjectStepEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProtanProjectStepEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProtanProjectStepEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProtanProjectStepEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProtanProjectStepEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProtanProjectStepEnum>>;
};

/** A filter to be used against `ProtanProjectStep` object types. All fields are combined with a logical ‘and.’ */
export type ProtanProjectStepFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProtanProjectStepFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProtanProjectStepFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProtanProjectStepFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ProtanProjectStepStatusEnumFilter>;
  /** Filter by the object’s `step` field. */
  step?: InputMaybe<ProtanProjectStepEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProtanProjectStep` */
export type ProtanProjectStepInput = {
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ProtanProjectStepsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ProtanProjectStepStatusEnum>;
  step: ProtanProjectStepEnum;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProtanProjectStepNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `protanProjectStep` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProtanProjectStepNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `protanProjectStep` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `protanProjectStep` to look up the row to update. */
export type ProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyUsingProtanProjectStepsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `protanProjectStep` being updated. */
  patch: UpdateProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyPatch;
};

/** The fields on `protanProjectStep` to look up the row to update. */
export type ProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyUsingProtanProjectStepsProjectIdStepKeyUpdate = {
  /** An object where the defined keys will be set on the `protanProjectStep` being updated. */
  patch: UpdateProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
  step: ProtanProjectStepEnum;
};

/** Represents an update to a `ProtanProjectStep`. Fields that are set will be updated. */
export type ProtanProjectStepPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ProtanProjectStepsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ProtanProjectStepStatusEnum>;
  step?: InputMaybe<ProtanProjectStepEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `protanProjectStep` to look up the row to connect. */
export type ProtanProjectStepProtanProjectStepsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `protanProjectStep` to look up the row to delete. */
export type ProtanProjectStepProtanProjectStepsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `protanProjectStep` to look up the row to connect. */
export type ProtanProjectStepProtanProjectStepsProjectIdStepKeyConnect = {
  projectId: Scalars['UUID'];
  step: ProtanProjectStepEnum;
};

/** The fields on `protanProjectStep` to look up the row to delete. */
export type ProtanProjectStepProtanProjectStepsProjectIdStepKeyDelete = {
  projectId: Scalars['UUID'];
  step: ProtanProjectStepEnum;
};

export enum ProtanProjectStepStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** A filter to be used against ProtanProjectStepStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type ProtanProjectStepStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProtanProjectStepStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProtanProjectStepStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProtanProjectStepStatusEnum>>;
};

/** A connection to a list of `ProtanProjectStep` values. */
export type ProtanProjectStepsConnection = {
  __typename?: 'ProtanProjectStepsConnection';
  /** A list of edges which contains the `ProtanProjectStep` and cursor to aid in pagination. */
  edges: Array<ProtanProjectStepsEdge>;
  /** A list of `ProtanProjectStep` objects. */
  nodes: Array<ProtanProjectStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProtanProjectStep` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProtanProjectStep` edge in the connection. */
export type ProtanProjectStepsEdge = {
  __typename?: 'ProtanProjectStepsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProtanProjectStep` at the end of the edge. */
  node: ProtanProjectStep;
};

/** Methods to use when ordering `ProtanProjectStep`. */
export enum ProtanProjectStepsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StepAsc = 'STEP_ASC',
  StepDesc = 'STEP_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `project` in the `ProtanProjectStepInput` mutation. */
export type ProtanProjectStepsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProtanProjectStepsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProtanProjectStepForProtanProjectStepsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `protanProjectStep` in the `ProjectInput` mutation. */
export type ProtanProjectStepsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `protanProjectStep` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProtanProjectStepProtanProjectStepsPkeyConnect>>;
  /** The primary key(s) for `protanProjectStep` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProtanProjectStepNodeIdConnect>>;
  /** The primary key(s) for `protanProjectStep` for the far side of the relationship. */
  connectByProjectIdAndStep?: InputMaybe<Array<ProtanProjectStepProtanProjectStepsProjectIdStepKeyConnect>>;
  /** A `ProtanProjectStepInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProtanProjectStepsProjectIdFkeyProtanProjectStepsCreateInput>>;
  /** The primary key(s) for `protanProjectStep` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProtanProjectStepProtanProjectStepsPkeyDelete>>;
  /** The primary key(s) for `protanProjectStep` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProtanProjectStepNodeIdDelete>>;
  /** The primary key(s) for `protanProjectStep` for the far side of the relationship. */
  deleteByProjectIdAndStep?: InputMaybe<Array<ProtanProjectStepProtanProjectStepsProjectIdStepKeyDelete>>;
  /** Flag indicating whether all other `protanProjectStep` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `protanProjectStep` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyUsingProtanProjectStepsPkeyUpdate>>;
  /** The primary key(s) and patch data for `protanProjectStep` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnProtanProjectStepForProtanProjectStepsProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `protanProjectStep` for the far side of the relationship. */
  updateByProjectIdAndStep?: InputMaybe<Array<ProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyUsingProtanProjectStepsProjectIdStepKeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ProtanProjectStepsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `protanProjectStep` to be created by this mutation. */
export type ProtanProjectStepsProjectIdFkeyProtanProjectStepsCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ProtanProjectStepsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ProtanProjectStepStatusEnum>;
  step: ProtanProjectStepEnum;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PublicInitialState = {
  __typename?: 'PublicInitialState';
  externalAccessToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `PublicInitialState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PublicInitialStateCondition = {
  /** Checks for equality with the object’s `externalAccessToken` field. */
  externalAccessToken?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `PublicInitialState` object types. All fields are combined with a logical ‘and.’ */
export type PublicInitialStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PublicInitialStateFilter>>;
  /** Filter by the object’s `externalAccessToken` field. */
  externalAccessToken?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PublicInitialStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PublicInitialStateFilter>>;
};

/** An input for mutations affecting `PublicInitialState` */
export type PublicInitialStateInput = {
  externalAccessToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `PublicInitialState` values. */
export type PublicInitialStatesConnection = {
  __typename?: 'PublicInitialStatesConnection';
  /** A list of edges which contains the `PublicInitialState` and cursor to aid in pagination. */
  edges: Array<PublicInitialStatesEdge>;
  /** A list of `PublicInitialState` objects. */
  nodes: Array<PublicInitialState>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PublicInitialState` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PublicInitialState` edge in the connection. */
export type PublicInitialStatesEdge = {
  __typename?: 'PublicInitialStatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PublicInitialState` at the end of the edge. */
  node: PublicInitialState;
};

/** Methods to use when ordering `PublicInitialState`. */
export enum PublicInitialStatesOrderBy {
  ExternalAccessTokenAsc = 'EXTERNAL_ACCESS_TOKEN_ASC',
  ExternalAccessTokenDesc = 'EXTERNAL_ACCESS_TOKEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL'
}

export type Quantity = {
  __typename?: 'Quantity';
  calculation?: Maybe<CalculationType>;
  databaseLookup?: Maybe<DatabaseLookupType>;
  derivedFormula?: Maybe<Scalars['String']>;
  stringValue?: Maybe<Scalars['String']>;
  type: QuantityEnum;
  unitFormatOverride?: Maybe<UnitSettingsType>;
  value?: Maybe<Scalars['Float']>;
};

export enum QuantityEnum {
  DatabaseLookup = 'DATABASE_LOOKUP',
  Derived = 'DERIVED',
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

/** A filter to be used against QuantityEnum fields. All fields are combined with a logical ‘and.’ */
export type QuantityEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<QuantityEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<QuantityEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<QuantityEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<QuantityEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<QuantityEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<QuantityEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<QuantityEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<QuantityEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<QuantityEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<QuantityEnum>>;
};

export type QuantityExtraction = {
  __typename?: 'QuantityExtraction';
  operation: Scalars['String'];
  propertyName: Scalars['String'];
  propertySet: Scalars['String'];
};

export type QuantityInput = {
  calculation?: InputMaybe<CalculationTypeInput>;
  databaseLookup?: InputMaybe<DatabaseLookupTypeInput>;
  derivedFormula?: InputMaybe<Scalars['String']>;
  stringValue?: InputMaybe<Scalars['String']>;
  type: QuantityEnum;
  unitFormatOverride?: InputMaybe<UnitSettingsTypeInput>;
  value?: InputMaybe<Scalars['Float']>;
};

export enum QuantityOperation {
  Count = 'COUNT',
  Extract = 'EXTRACT',
  Sum = 'SUM'
}

/** A filter to be used against QuantityOperation fields. All fields are combined with a logical ‘and.’ */
export type QuantityOperationFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<QuantityOperation>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<QuantityOperation>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<QuantityOperation>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<QuantityOperation>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<QuantityOperation>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<QuantityOperation>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<QuantityOperation>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<QuantityOperation>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<QuantityOperation>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<QuantityOperation>>;
};

export type QuantityType = {
  __typename?: 'QuantityType';
  calculation?: Maybe<CalculationType>;
  databaseLookup?: Maybe<DatabaseLookupType>;
  derivedFormula?: Maybe<Scalars['String']>;
  stringValue?: Maybe<Scalars['String']>;
  type: QuantityEnum;
  unitFormatOverride?: Maybe<UnitSettingsType>;
  value?: Maybe<Scalars['Float']>;
};

/** A filter to be used against `QuantityType` object types. All fields are combined with a logical ‘and.’ */
export type QuantityTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<QuantityTypeFilter>>;
  /** Filter by the object’s `calculation` field. */
  calculation?: InputMaybe<CalculationTypeFilter>;
  /** Filter by the object’s `databaseLookup` field. */
  databaseLookup?: InputMaybe<DatabaseLookupTypeFilter>;
  /** Filter by the object’s `derivedFormula` field. */
  derivedFormula?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<QuantityTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<QuantityTypeFilter>>;
  /** Filter by the object’s `stringValue` field. */
  stringValue?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<QuantityEnumFilter>;
  /** Filter by the object’s `unitFormatOverride` field. */
  unitFormatOverride?: InputMaybe<UnitSettingsTypeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `QuantityType` */
export type QuantityTypeInput = {
  calculation?: InputMaybe<CalculationTypeInput>;
  databaseLookup?: InputMaybe<DatabaseLookupTypeInput>;
  derivedFormula?: InputMaybe<Scalars['String']>;
  stringValue?: InputMaybe<Scalars['String']>;
  type: QuantityEnum;
  unitFormatOverride?: InputMaybe<UnitSettingsTypeInput>;
  value?: InputMaybe<Scalars['Float']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  _findPreviousSheetId?: Maybe<Scalars['UUID']>;
  autoShape?: Maybe<AutoShape>;
  /** Reads a single `AutoShape` using its globally unique `ID`. */
  autoShapeByNodeId?: Maybe<AutoShape>;
  /** Reads a set of `AutoShape`. */
  autoShapes?: Maybe<Array<AutoShape>>;
  /** Reads and enables pagination through a set of `AutoShape`. */
  autoShapesConnection?: Maybe<AutoShapesConnection>;
  comment?: Maybe<Comment>;
  /** Reads a single `Comment` using its globally unique `ID`. */
  commentByNodeId?: Maybe<Comment>;
  /** Reads a set of `Comment`. */
  comments?: Maybe<Array<Comment>>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsConnection?: Maybe<CommentsConnection>;
  companyDatabaseCell?: Maybe<CompanyDatabaseCell>;
  /** Reads a single `CompanyDatabaseCell` using its globally unique `ID`. */
  companyDatabaseCellByNodeId?: Maybe<CompanyDatabaseCell>;
  /** Reads a set of `CompanyDatabaseCell`. */
  companyDatabaseCells?: Maybe<Array<CompanyDatabaseCell>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseCell`. */
  companyDatabaseCellsConnection?: Maybe<CompanyDatabaseCellsConnection>;
  companyDatabaseColumn?: Maybe<CompanyDatabaseColumn>;
  /** Reads a single `CompanyDatabaseColumn` using its globally unique `ID`. */
  companyDatabaseColumnByNodeId?: Maybe<CompanyDatabaseColumn>;
  /** Reads a set of `CompanyDatabaseColumn`. */
  companyDatabaseColumns?: Maybe<Array<CompanyDatabaseColumn>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseColumn`. */
  companyDatabaseColumnsConnection?: Maybe<CompanyDatabaseColumnsConnection>;
  companyDatabaseImportJob?: Maybe<CompanyDatabaseImportJob>;
  /** Reads a single `CompanyDatabaseImportJob` using its globally unique `ID`. */
  companyDatabaseImportJobByNodeId?: Maybe<CompanyDatabaseImportJob>;
  /** Reads a set of `CompanyDatabaseImportJob`. */
  companyDatabaseImportJobs?: Maybe<Array<CompanyDatabaseImportJob>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseImportJob`. */
  companyDatabaseImportJobsConnection?: Maybe<CompanyDatabaseImportJobsConnection>;
  companyDatabaseLookupCache?: Maybe<CompanyDatabaseLookupCache>;
  companyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId?: Maybe<CompanyDatabaseLookupCache>;
  /** Reads a single `CompanyDatabaseLookupCache` using its globally unique `ID`. */
  companyDatabaseLookupCacheByNodeId?: Maybe<CompanyDatabaseLookupCache>;
  /** Reads a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCaches?: Maybe<Array<CompanyDatabaseLookupCache>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupCache`. */
  companyDatabaseLookupCachesConnection?: Maybe<CompanyDatabaseLookupCachesConnection>;
  companyDatabaseLookupJob?: Maybe<CompanyDatabaseLookupJob>;
  /** Reads a single `CompanyDatabaseLookupJob` using its globally unique `ID`. */
  companyDatabaseLookupJobByNodeId?: Maybe<CompanyDatabaseLookupJob>;
  /** Reads a set of `CompanyDatabaseLookupJob`. */
  companyDatabaseLookupJobs?: Maybe<Array<CompanyDatabaseLookupJob>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupJob`. */
  companyDatabaseLookupJobsConnection?: Maybe<CompanyDatabaseLookupJobsConnection>;
  companyDatabaseLookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Reads a single `CompanyDatabaseLookupProfile` using its globally unique `ID`. */
  companyDatabaseLookupProfileByNodeId?: Maybe<CompanyDatabaseLookupProfile>;
  /** Reads a set of `CompanyDatabaseLookupProfile`. */
  companyDatabaseLookupProfiles?: Maybe<Array<CompanyDatabaseLookupProfile>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseLookupProfile`. */
  companyDatabaseLookupProfilesConnection?: Maybe<CompanyDatabaseLookupProfilesConnection>;
  companyDatabaseRow?: Maybe<CompanyDatabaseRow>;
  /** Reads a single `CompanyDatabaseRow` using its globally unique `ID`. */
  companyDatabaseRowByNodeId?: Maybe<CompanyDatabaseRow>;
  /** Reads a set of `CompanyDatabaseRow`. */
  companyDatabaseRows?: Maybe<Array<CompanyDatabaseRow>>;
  /** Reads and enables pagination through a set of `CompanyDatabaseRow`. */
  companyDatabaseRowsConnection?: Maybe<CompanyDatabaseRowsConnection>;
  /** Reads a set of `CompanyDatabasis`. */
  companyDatabases?: Maybe<Array<CompanyDatabasis>>;
  /** Reads and enables pagination through a set of `CompanyDatabasis`. */
  companyDatabasesConnection?: Maybe<CompanyDatabasesConnection>;
  companyDatabasis?: Maybe<CompanyDatabasis>;
  /** Reads a single `CompanyDatabasis` using its globally unique `ID`. */
  companyDatabasisByNodeId?: Maybe<CompanyDatabasis>;
  contractor?: Maybe<Contractor>;
  /** Reads a single `Contractor` using its globally unique `ID`. */
  contractorByNodeId?: Maybe<Contractor>;
  contractorByTenant?: Maybe<Contractor>;
  /** Reads a set of `Contractor`. */
  contractors?: Maybe<Array<Contractor>>;
  /** Reads and enables pagination through a set of `Contractor`. */
  contractorsConnection?: Maybe<ContractorsConnection>;
  copilotExchange?: Maybe<CopilotExchange>;
  /** Reads a single `CopilotExchange` using its globally unique `ID`. */
  copilotExchangeByNodeId?: Maybe<CopilotExchange>;
  /** Reads a set of `CopilotExchange`. */
  copilotExchanges?: Maybe<Array<CopilotExchange>>;
  /** Reads and enables pagination through a set of `CopilotExchange`. */
  copilotExchangesConnection?: Maybe<CopilotExchangesConnection>;
  copilotExchangesFeedback?: Maybe<CopilotExchangesFeedback>;
  /** Reads a single `CopilotExchangesFeedback` using its globally unique `ID`. */
  copilotExchangesFeedbackByNodeId?: Maybe<CopilotExchangesFeedback>;
  /** Reads a set of `CopilotExchangesFeedback`. */
  copilotExchangesFeedbacks?: Maybe<Array<CopilotExchangesFeedback>>;
  /** Reads and enables pagination through a set of `CopilotExchangesFeedback`. */
  copilotExchangesFeedbacksConnection?: Maybe<CopilotExchangesFeedbacksConnection>;
  createProjectFromDocumentsStatus: CreateProjectFromDocumentsStatusPayload;
  customField?: Maybe<CustomField>;
  /** Reads a single `CustomField` using its globally unique `ID`. */
  customFieldByNodeId?: Maybe<CustomField>;
  customFieldByOrderColumnIdAndOrderEntryId?: Maybe<CustomField>;
  customFieldTemplate?: Maybe<CustomFieldTemplate>;
  /** Reads a single `CustomFieldTemplate` using its globally unique `ID`. */
  customFieldTemplateByNodeId?: Maybe<CustomFieldTemplate>;
  /** Reads a set of `CustomFieldTemplate`. */
  customFieldTemplates?: Maybe<Array<CustomFieldTemplate>>;
  /** Reads and enables pagination through a set of `CustomFieldTemplate`. */
  customFieldTemplatesConnection?: Maybe<CustomFieldTemplatesConnection>;
  /** Reads a set of `CustomField`. */
  customFields?: Maybe<Array<CustomField>>;
  /** Reads and enables pagination through a set of `CustomField`. */
  customFieldsConnection?: Maybe<CustomFieldsConnection>;
  exportShapesToIfcStatus: ExportShapesToIfcStatusPayload;
  externalAccessToken?: Maybe<ExternalAccessToken>;
  externalAwsCredentials: ExternalAwsAccessCredentials;
  extrudedPolygon?: Maybe<ExtrudedPolygon>;
  /** Reads a single `ExtrudedPolygon` using its globally unique `ID`. */
  extrudedPolygonByNodeId?: Maybe<ExtrudedPolygon>;
  extrudedPolygonByShapeId?: Maybe<ExtrudedPolygon>;
  /** Reads a set of `ExtrudedPolygon`. */
  extrudedPolygons?: Maybe<Array<ExtrudedPolygon>>;
  /** Reads and enables pagination through a set of `ExtrudedPolygon`. */
  extrudedPolygonsConnection?: Maybe<ExtrudedPolygonsConnection>;
  flow?: Maybe<Flow>;
  flowAction?: Maybe<FlowAction>;
  flowActionByFlowIdAndPosition?: Maybe<FlowAction>;
  /** Reads a single `FlowAction` using its globally unique `ID`. */
  flowActionByNodeId?: Maybe<FlowAction>;
  /** Reads a set of `FlowAction`. */
  flowActions?: Maybe<Array<FlowAction>>;
  /** Reads and enables pagination through a set of `FlowAction`. */
  flowActionsConnection?: Maybe<FlowActionsConnection>;
  /** Reads a single `Flow` using its globally unique `ID`. */
  flowByNodeId?: Maybe<Flow>;
  flowExecution?: Maybe<FlowExecution>;
  /** Reads a single `FlowExecution` using its globally unique `ID`. */
  flowExecutionByNodeId?: Maybe<FlowExecution>;
  /** Reads a set of `FlowExecution`. */
  flowExecutions?: Maybe<Array<FlowExecution>>;
  /** Reads and enables pagination through a set of `FlowExecution`. */
  flowExecutionsConnection?: Maybe<FlowExecutionsConnection>;
  flowMailbox?: Maybe<FlowMailbox>;
  flowMailboxByContractorId?: Maybe<FlowMailbox>;
  flowMailboxByEmailLocalPartAndEmailDomain?: Maybe<FlowMailbox>;
  /** Reads a single `FlowMailbox` using its globally unique `ID`. */
  flowMailboxByNodeId?: Maybe<FlowMailbox>;
  flowMailboxMessage?: Maybe<FlowMailboxMessage>;
  /** Reads a single `FlowMailboxMessage` using its globally unique `ID`. */
  flowMailboxMessageByNodeId?: Maybe<FlowMailboxMessage>;
  /** Reads a set of `FlowMailboxMessage`. */
  flowMailboxMessages?: Maybe<Array<FlowMailboxMessage>>;
  /** Reads and enables pagination through a set of `FlowMailboxMessage`. */
  flowMailboxMessagesConnection?: Maybe<FlowMailboxMessagesConnection>;
  /** Reads a set of `FlowMailbox`. */
  flowMailboxes?: Maybe<Array<FlowMailbox>>;
  /** Reads and enables pagination through a set of `FlowMailbox`. */
  flowMailboxesConnection?: Maybe<FlowMailboxesConnection>;
  /** Reads a set of `Flow`. */
  flows?: Maybe<Array<Flow>>;
  /** Reads and enables pagination through a set of `Flow`. */
  flowsConnection?: Maybe<FlowsConnection>;
  forgeAccessToken?: Maybe<ForgeAccessToken>;
  /**
   * Fetch algorithm geometry for specific elements.
   * Returns geometry data only for the requested dbIds.
   */
  getAlgorithmGeometry: Array<AlgorithmGeometryResult>;
  /**
   * Get a cell value from a company database row by row ID and column ID.
   * Use this after lookupCompanyDatabaseValue to get additional columns from the same row
   * without re-running the lookup.
   */
  getCompanyDatabaseCellValue?: Maybe<Scalars['String']>;
  getContractorByMailboxEmail?: Maybe<Scalars['UUID']>;
  getFlowWithActions?: Maybe<Scalars['JSON']>;
  getHistoryEventGroups?: Maybe<Array<GetHistoryEventGroupsRecord>>;
  getHistoryEventGroupsConnection?: Maybe<GetHistoryEventGroupsConnection>;
  getMailboxByEmail?: Maybe<Scalars['UUID']>;
  getMailboxEmailAddress?: Maybe<Scalars['String']>;
  getNextModelVersion?: Maybe<Scalars['Int']>;
  historyEvent?: Maybe<HistoryEvent>;
  /** Reads a single `HistoryEvent` using its globally unique `ID`. */
  historyEventByNodeId?: Maybe<HistoryEvent>;
  /** Reads a set of `HistoryEvent`. */
  historyEvents?: Maybe<Array<HistoryEvent>>;
  /** Reads and enables pagination through a set of `HistoryEvent`. */
  historyEventsConnection?: Maybe<HistoryEventsConnection>;
  initialState?: Maybe<InitialState>;
  /** Reads a single `InitialState` using its globally unique `ID`. */
  initialStateByNodeId?: Maybe<InitialState>;
  /** Reads a set of `InitialState`. */
  initialStates?: Maybe<Array<InitialState>>;
  /** Reads and enables pagination through a set of `InitialState`. */
  initialStatesConnection?: Maybe<InitialStatesConnection>;
  issue?: Maybe<Issue>;
  /** Reads a single `Issue` using its globally unique `ID`. */
  issueByNodeId?: Maybe<Issue>;
  issueComment?: Maybe<IssueComment>;
  /** Reads a single `IssueComment` using its globally unique `ID`. */
  issueCommentByNodeId?: Maybe<IssueComment>;
  /** Reads a set of `IssueComment`. */
  issueComments?: Maybe<Array<IssueComment>>;
  /** Reads and enables pagination through a set of `IssueComment`. */
  issueCommentsConnection?: Maybe<IssueCommentsConnection>;
  /** Reads a set of `Issue`. */
  issues?: Maybe<Array<Issue>>;
  /** Reads and enables pagination through a set of `Issue`. */
  issuesConnection?: Maybe<IssuesConnection>;
  line?: Maybe<Line>;
  /** Reads a single `Line` using its globally unique `ID`. */
  lineByNodeId?: Maybe<Line>;
  lineByShapeId?: Maybe<Line>;
  /** Reads a set of `Line`. */
  lines?: Maybe<Array<Line>>;
  /** Reads and enables pagination through a set of `Line`. */
  linesConnection?: Maybe<LinesConnection>;
  listUsers: Array<User>;
  /**
   * Look up a value in a company database.
   * If lookupProfileId is provided, uses the profile's match criteria and system prompt.
   * Otherwise, performs a simple EQUALS match on the search column.
   * Returns rowId which can be used with getCompanyDatabaseCellValue for additional columns.
   */
  lookupCompanyDatabaseValue: CompanyDatabaseLookupResult;
  model?: Maybe<Model>;
  /** Reads a single `Model` using its globally unique `ID`. */
  modelByNodeId?: Maybe<Model>;
  modelByProjectIdAndNameAndVersion?: Maybe<Model>;
  /** Reads a set of `Model`. */
  models?: Maybe<Array<Model>>;
  /** Reads and enables pagination through a set of `Model`. */
  modelsConnection?: Maybe<ModelsConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  order?: Maybe<Order>;
  /** Reads a single `Order` using its globally unique `ID`. */
  orderByNodeId?: Maybe<Order>;
  orderColumn?: Maybe<OrderColumn>;
  orderColumnByNameAndColumnTypeAndOrderId?: Maybe<OrderColumn>;
  /** Reads a single `OrderColumn` using its globally unique `ID`. */
  orderColumnByNodeId?: Maybe<OrderColumn>;
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** Reads a single `OrderColumnTemplate` using its globally unique `ID`. */
  orderColumnTemplateByNodeId?: Maybe<OrderColumnTemplate>;
  /** Reads a set of `OrderColumnTemplate`. */
  orderColumnTemplates?: Maybe<Array<OrderColumnTemplate>>;
  /** Reads and enables pagination through a set of `OrderColumnTemplate`. */
  orderColumnTemplatesConnection?: Maybe<OrderColumnTemplatesConnection>;
  /** Reads a set of `OrderColumn`. */
  orderColumns?: Maybe<Array<OrderColumn>>;
  /** Reads and enables pagination through a set of `OrderColumn`. */
  orderColumnsConnection?: Maybe<OrderColumnsConnection>;
  /** Reads a set of `OrderEntry`. */
  orderEntries?: Maybe<Array<OrderEntry>>;
  /** Reads and enables pagination through a set of `OrderEntry`. */
  orderEntriesConnection?: Maybe<OrderEntriesConnection>;
  orderEntry?: Maybe<OrderEntry>;
  /** Reads a single `OrderEntry` using its globally unique `ID`. */
  orderEntryByNodeId?: Maybe<OrderEntry>;
  orderEntryCache?: Maybe<OrderEntryCache>;
  /** Reads a single `OrderEntryCache` using its globally unique `ID`. */
  orderEntryCacheByNodeId?: Maybe<OrderEntryCache>;
  orderEntryCacheByOrderEntryId?: Maybe<OrderEntryCache>;
  /** Reads a set of `OrderEntryCache`. */
  orderEntryCaches?: Maybe<Array<OrderEntryCache>>;
  /** Reads and enables pagination through a set of `OrderEntryCache`. */
  orderEntryCachesConnection?: Maybe<OrderEntryCachesConnection>;
  orderEntryTemplate?: Maybe<OrderEntryTemplate>;
  /** Reads a single `OrderEntryTemplate` using its globally unique `ID`. */
  orderEntryTemplateByNodeId?: Maybe<OrderEntryTemplate>;
  /** Reads a set of `OrderEntryTemplate`. */
  orderEntryTemplates?: Maybe<Array<OrderEntryTemplate>>;
  /** Reads and enables pagination through a set of `OrderEntryTemplate`. */
  orderEntryTemplatesConnection?: Maybe<OrderEntryTemplatesConnection>;
  orderEntryView?: Maybe<OrderEntryView>;
  /** Reads a single `OrderEntryView` using its globally unique `ID`. */
  orderEntryViewByNodeId?: Maybe<OrderEntryView>;
  orderEntryViewByProjectIdAndName?: Maybe<OrderEntryView>;
  /** Reads a set of `OrderEntryView`. */
  orderEntryViews?: Maybe<Array<OrderEntryView>>;
  /** Reads and enables pagination through a set of `OrderEntryView`. */
  orderEntryViewsConnection?: Maybe<OrderEntryViewsConnection>;
  /** Reads a set of `Order`. */
  orders?: Maybe<Array<Order>>;
  /** Reads and enables pagination through a set of `Order`. */
  ordersConnection?: Maybe<OrdersConnection>;
  polygon?: Maybe<Polygon>;
  /** Reads a single `Polygon` using its globally unique `ID`. */
  polygonByNodeId?: Maybe<Polygon>;
  polygonByShapeId?: Maybe<Polygon>;
  /** Reads a set of `Polygon`. */
  polygons?: Maybe<Array<Polygon>>;
  /** Reads and enables pagination through a set of `Polygon`. */
  polygonsConnection?: Maybe<PolygonsConnection>;
  project?: Maybe<Project>;
  /** Reads a single `Project` using its globally unique `ID`. */
  projectByNodeId?: Maybe<Project>;
  projectTag?: Maybe<ProjectTag>;
  /** Reads a single `ProjectTag` using its globally unique `ID`. */
  projectTagByNodeId?: Maybe<ProjectTag>;
  /** Reads a set of `ProjectTag`. */
  projectTags?: Maybe<Array<ProjectTag>>;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTagsConnection?: Maybe<ProjectTagsConnection>;
  projectTemplate?: Maybe<ProjectTemplate>;
  /** Reads a single `ProjectTemplate` using its globally unique `ID`. */
  projectTemplateByNodeId?: Maybe<ProjectTemplate>;
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** Reads a single `ProjectTemplateOrder` using its globally unique `ID`. */
  projectTemplateOrderByNodeId?: Maybe<ProjectTemplateOrder>;
  /** Reads a set of `ProjectTemplateOrderEntry`. */
  projectTemplateOrderEntries?: Maybe<Array<ProjectTemplateOrderEntry>>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrderEntry`. */
  projectTemplateOrderEntriesConnection?: Maybe<ProjectTemplateOrderEntriesConnection>;
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** Reads a single `ProjectTemplateOrderEntry` using its globally unique `ID`. */
  projectTemplateOrderEntryByNodeId?: Maybe<ProjectTemplateOrderEntry>;
  projectTemplateOrderEntryView?: Maybe<ProjectTemplateOrderEntryView>;
  /** Reads a single `ProjectTemplateOrderEntryView` using its globally unique `ID`. */
  projectTemplateOrderEntryViewByNodeId?: Maybe<ProjectTemplateOrderEntryView>;
  /** Reads a set of `ProjectTemplateOrderEntryView`. */
  projectTemplateOrderEntryViews?: Maybe<Array<ProjectTemplateOrderEntryView>>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrderEntryView`. */
  projectTemplateOrderEntryViewsConnection?: Maybe<ProjectTemplateOrderEntryViewsConnection>;
  /** Reads a set of `ProjectTemplateOrder`. */
  projectTemplateOrders?: Maybe<Array<ProjectTemplateOrder>>;
  /** Reads and enables pagination through a set of `ProjectTemplateOrder`. */
  projectTemplateOrdersConnection?: Maybe<ProjectTemplateOrdersConnection>;
  /** Reads a set of `ProjectTemplate`. */
  projectTemplates?: Maybe<Array<ProjectTemplate>>;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplatesConnection?: Maybe<ProjectTemplatesConnection>;
  /** Reads a set of `Project`. */
  projects?: Maybe<Array<Project>>;
  /** Reads and enables pagination through a set of `Project`. */
  projectsConnection?: Maybe<ProjectsConnection>;
  protanProjectStep?: Maybe<ProtanProjectStep>;
  /** Reads a single `ProtanProjectStep` using its globally unique `ID`. */
  protanProjectStepByNodeId?: Maybe<ProtanProjectStep>;
  protanProjectStepByProjectIdAndStep?: Maybe<ProtanProjectStep>;
  /** Reads a set of `ProtanProjectStep`. */
  protanProjectSteps?: Maybe<Array<ProtanProjectStep>>;
  /** Reads and enables pagination through a set of `ProtanProjectStep`. */
  protanProjectStepsConnection?: Maybe<ProtanProjectStepsConnection>;
  /** Reads a set of `PublicInitialState`. */
  publicInitialStates?: Maybe<Array<PublicInitialState>>;
  /** Reads and enables pagination through a set of `PublicInitialState`. */
  publicInitialStatesConnection?: Maybe<PublicInitialStatesConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  replaceFormulaIds?: Maybe<QuantityType>;
  replaceFormulaIdsWithNames?: Maybe<Quantity>;
  replaceFormulaNamesWithIds?: Maybe<Quantity>;
  savedView?: Maybe<SavedView>;
  savedViewByNameAndProjectId?: Maybe<SavedView>;
  /** Reads a single `SavedView` using its globally unique `ID`. */
  savedViewByNodeId?: Maybe<SavedView>;
  /** Reads a set of `SavedView`. */
  savedViews?: Maybe<Array<SavedView>>;
  /** Reads and enables pagination through a set of `SavedView`. */
  savedViewsConnection?: Maybe<SavedViewsConnection>;
  shape?: Maybe<Shape>;
  /** Reads a single `Shape` using its globally unique `ID`. */
  shapeByNodeId?: Maybe<Shape>;
  shapeByUrnAndDbId?: Maybe<Shape>;
  shapeFolder?: Maybe<ShapeFolder>;
  /** Reads a single `ShapeFolder` using its globally unique `ID`. */
  shapeFolderByNodeId?: Maybe<ShapeFolder>;
  shapeFolderByProjectIdAndName?: Maybe<ShapeFolder>;
  /** Reads a set of `ShapeFolder`. */
  shapeFolders?: Maybe<Array<ShapeFolder>>;
  /** Reads and enables pagination through a set of `ShapeFolder`. */
  shapeFoldersConnection?: Maybe<ShapeFoldersConnection>;
  shapePoint?: Maybe<ShapePoint>;
  /** Reads a single `ShapePoint` using its globally unique `ID`. */
  shapePointByNodeId?: Maybe<ShapePoint>;
  shapePointByShapeId?: Maybe<ShapePoint>;
  /** Reads a set of `ShapePoint`. */
  shapePoints?: Maybe<Array<ShapePoint>>;
  /** Reads and enables pagination through a set of `ShapePoint`. */
  shapePointsConnection?: Maybe<ShapePointsConnection>;
  /** Reads a set of `Shape`. */
  shapes?: Maybe<Array<Shape>>;
  /** Reads and enables pagination through a set of `Shape`. */
  shapesConnection?: Maybe<ShapesConnection>;
  sharedLink?: Maybe<SharedLink>;
  sharedLinkByInitialStateId?: Maybe<SharedLink>;
  /** Reads a single `SharedLink` using its globally unique `ID`. */
  sharedLinkByNodeId?: Maybe<SharedLink>;
  /** Reads a set of `SharedLink`. */
  sharedLinks?: Maybe<Array<SharedLink>>;
  /** Reads and enables pagination through a set of `SharedLink`. */
  sharedLinksConnection?: Maybe<SharedLinksConnection>;
  sheet?: Maybe<Sheet>;
  /** Reads a single `Sheet` using its globally unique `ID`. */
  sheetByNodeId?: Maybe<Sheet>;
  sheetByProjectIdAndNameAndVersion?: Maybe<Sheet>;
  sheetPageCalibration?: Maybe<SheetPageCalibration>;
  /** Reads a single `SheetPageCalibration` using its globally unique `ID`. */
  sheetPageCalibrationByNodeId?: Maybe<SheetPageCalibration>;
  /** Reads a set of `SheetPageCalibration`. */
  sheetPageCalibrations?: Maybe<Array<SheetPageCalibration>>;
  /** Reads and enables pagination through a set of `SheetPageCalibration`. */
  sheetPageCalibrationsConnection?: Maybe<SheetPageCalibrationsConnection>;
  sheetShape?: Maybe<SheetShape>;
  /** Reads a single `SheetShape` using its globally unique `ID`. */
  sheetShapeByNodeId?: Maybe<SheetShape>;
  sheetShapeByUrnAndDbId?: Maybe<SheetShape>;
  sheetShapeLegend?: Maybe<SheetShapeLegend>;
  /** Reads a single `SheetShapeLegend` using its globally unique `ID`. */
  sheetShapeLegendByNodeId?: Maybe<SheetShapeLegend>;
  sheetShapeLegendBySheetShapeId?: Maybe<SheetShapeLegend>;
  /** Reads a set of `SheetShapeLegend`. */
  sheetShapeLegends?: Maybe<Array<SheetShapeLegend>>;
  /** Reads and enables pagination through a set of `SheetShapeLegend`. */
  sheetShapeLegendsConnection?: Maybe<SheetShapeLegendsConnection>;
  sheetShapeLine?: Maybe<SheetShapeLine>;
  /** Reads a single `SheetShapeLine` using its globally unique `ID`. */
  sheetShapeLineByNodeId?: Maybe<SheetShapeLine>;
  sheetShapeLineBySheetShapeId?: Maybe<SheetShapeLine>;
  /** Reads a set of `SheetShapeLine`. */
  sheetShapeLines?: Maybe<Array<SheetShapeLine>>;
  /** Reads and enables pagination through a set of `SheetShapeLine`. */
  sheetShapeLinesConnection?: Maybe<SheetShapeLinesConnection>;
  sheetShapePoint?: Maybe<SheetShapePoint>;
  /** Reads a single `SheetShapePoint` using its globally unique `ID`. */
  sheetShapePointByNodeId?: Maybe<SheetShapePoint>;
  sheetShapePointBySheetShapeId?: Maybe<SheetShapePoint>;
  /** Reads a set of `SheetShapePoint`. */
  sheetShapePoints?: Maybe<Array<SheetShapePoint>>;
  /** Reads and enables pagination through a set of `SheetShapePoint`. */
  sheetShapePointsConnection?: Maybe<SheetShapePointsConnection>;
  sheetShapePolygon?: Maybe<SheetShapePolygon>;
  /** Reads a single `SheetShapePolygon` using its globally unique `ID`. */
  sheetShapePolygonByNodeId?: Maybe<SheetShapePolygon>;
  sheetShapePolygonBySheetShapeId?: Maybe<SheetShapePolygon>;
  /** Reads a set of `SheetShapePolygon`. */
  sheetShapePolygons?: Maybe<Array<SheetShapePolygon>>;
  /** Reads and enables pagination through a set of `SheetShapePolygon`. */
  sheetShapePolygonsConnection?: Maybe<SheetShapePolygonsConnection>;
  sheetShapeSplitLine?: Maybe<SheetShapeSplitLine>;
  /** Reads a single `SheetShapeSplitLine` using its globally unique `ID`. */
  sheetShapeSplitLineByNodeId?: Maybe<SheetShapeSplitLine>;
  sheetShapeSplitLineBySheetShapeId?: Maybe<SheetShapeSplitLine>;
  /** Reads a set of `SheetShapeSplitLine`. */
  sheetShapeSplitLines?: Maybe<Array<SheetShapeSplitLine>>;
  /** Reads and enables pagination through a set of `SheetShapeSplitLine`. */
  sheetShapeSplitLinesConnection?: Maybe<SheetShapeSplitLinesConnection>;
  /** Reads a set of `SheetShape`. */
  sheetShapes?: Maybe<Array<SheetShape>>;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapesConnection?: Maybe<SheetShapesConnection>;
  /** Reads a set of `Sheet`. */
  sheets?: Maybe<Array<Sheet>>;
  /** Reads and enables pagination through a set of `Sheet`. */
  sheetsConnection?: Maybe<SheetsConnection>;
  /** Reads a set of `SparkelAiAnalysis`. */
  sparkelAiAnalyses?: Maybe<Array<SparkelAiAnalysis>>;
  /** Reads and enables pagination through a set of `SparkelAiAnalysis`. */
  sparkelAiAnalysesConnection?: Maybe<SparkelAiAnalysesConnection>;
  sparkelAiAnalysis?: Maybe<SparkelAiAnalysis>;
  /** Reads a single `SparkelAiAnalysis` using its globally unique `ID`. */
  sparkelAiAnalysisByNodeId?: Maybe<SparkelAiAnalysis>;
  /** Reads a set of `SparkelProperty`. */
  sparkelProperties?: Maybe<Array<SparkelProperty>>;
  /** Reads and enables pagination through a set of `SparkelProperty`. */
  sparkelPropertiesConnection?: Maybe<SparkelPropertiesConnection>;
  sparkelProperty?: Maybe<SparkelProperty>;
  /** Reads a single `SparkelProperty` using its globally unique `ID`. */
  sparkelPropertyByNodeId?: Maybe<SparkelProperty>;
  sparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySet?: Maybe<SparkelProperty>;
  validateFlowActionLoopDepth?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type Query_FindPreviousSheetIdArgs = {
  pName: Scalars['String'];
  pNewSheetId: Scalars['UUID'];
  pProjectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAutoShapeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAutoShapeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAutoShapesArgs = {
  condition?: InputMaybe<AutoShapeCondition>;
  filter?: InputMaybe<AutoShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAutoShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AutoShapeCondition>;
  filter?: InputMaybe<AutoShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentsArgs = {
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseCellArgs = {
  columnId: Scalars['UUID'];
  rowId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseCellByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseCellsArgs = {
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseCellsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseCellCondition>;
  filter?: InputMaybe<CompanyDatabaseCellFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseColumnArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseColumnByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseColumnsArgs = {
  condition?: InputMaybe<CompanyDatabaseColumnCondition>;
  filter?: InputMaybe<CompanyDatabaseColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseColumnCondition>;
  filter?: InputMaybe<CompanyDatabaseColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseImportJobArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseImportJobByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseImportJobsArgs = {
  condition?: InputMaybe<CompanyDatabaseImportJobCondition>;
  filter?: InputMaybe<CompanyDatabaseImportJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseImportJobsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseImportJobCondition>;
  filter?: InputMaybe<CompanyDatabaseImportJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupCacheArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdArgs = {
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupCacheByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupCachesArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupCachesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupCacheCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupJobArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupJobByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupJobsArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupJobCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupJobsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupJobCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupProfileArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupProfileByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupProfilesArgs = {
  condition?: InputMaybe<CompanyDatabaseLookupProfileCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseLookupProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseLookupProfileCondition>;
  filter?: InputMaybe<CompanyDatabaseLookupProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseRowArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseRowByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseRowsArgs = {
  condition?: InputMaybe<CompanyDatabaseRowCondition>;
  filter?: InputMaybe<CompanyDatabaseRowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabaseRowsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabaseRowCondition>;
  filter?: InputMaybe<CompanyDatabaseRowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabasesArgs = {
  condition?: InputMaybe<CompanyDatabasisCondition>;
  filter?: InputMaybe<CompanyDatabasisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabasesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyDatabasisCondition>;
  filter?: InputMaybe<CompanyDatabasisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabasisArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyDatabasisByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractorArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractorByTenantArgs = {
  tenant: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractorsArgs = {
  condition?: InputMaybe<ContractorCondition>;
  filter?: InputMaybe<ContractorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractorsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractorCondition>;
  filter?: InputMaybe<ContractorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangesArgs = {
  condition?: InputMaybe<CopilotExchangeCondition>;
  filter?: InputMaybe<CopilotExchangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CopilotExchangeCondition>;
  filter?: InputMaybe<CopilotExchangeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangesFeedbackArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangesFeedbackByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangesFeedbacksArgs = {
  condition?: InputMaybe<CopilotExchangesFeedbackCondition>;
  filter?: InputMaybe<CopilotExchangesFeedbackFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesFeedbacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCopilotExchangesFeedbacksConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CopilotExchangesFeedbackCondition>;
  filter?: InputMaybe<CopilotExchangesFeedbackFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CopilotExchangesFeedbacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCreateProjectFromDocumentsStatusArgs = {
  jobId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldByOrderColumnIdAndOrderEntryIdArgs = {
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldTemplateArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldTemplateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldTemplatesArgs = {
  condition?: InputMaybe<CustomFieldTemplateCondition>;
  filter?: InputMaybe<CustomFieldTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomFieldTemplateCondition>;
  filter?: InputMaybe<CustomFieldTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldsArgs = {
  condition?: InputMaybe<CustomFieldCondition>;
  filter?: InputMaybe<CustomFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomFieldCondition>;
  filter?: InputMaybe<CustomFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportShapesToIfcStatusArgs = {
  jobId: Scalars['String'];
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalAccessTokenArgs = {
  expiresIn: Scalars['Int'];
  orderIds: Array<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalAwsCredentialsArgs = {
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrudedPolygonArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrudedPolygonByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrudedPolygonByShapeIdArgs = {
  shapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrudedPolygonsArgs = {
  condition?: InputMaybe<ExtrudedPolygonCondition>;
  filter?: InputMaybe<ExtrudedPolygonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExtrudedPolygonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrudedPolygonsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExtrudedPolygonCondition>;
  filter?: InputMaybe<ExtrudedPolygonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExtrudedPolygonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowActionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowActionByFlowIdAndPositionArgs = {
  flowId: Scalars['UUID'];
  position: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowActionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowActionsArgs = {
  condition?: InputMaybe<FlowActionCondition>;
  filter?: InputMaybe<FlowActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowActionsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowActionCondition>;
  filter?: InputMaybe<FlowActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowExecutionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowExecutionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowExecutionsArgs = {
  condition?: InputMaybe<FlowExecutionCondition>;
  filter?: InputMaybe<FlowExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowExecutionCondition>;
  filter?: InputMaybe<FlowExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxByContractorIdArgs = {
  contractorId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxByEmailLocalPartAndEmailDomainArgs = {
  emailDomain: Scalars['String'];
  emailLocalPart: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxMessageArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxMessageByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxMessagesArgs = {
  condition?: InputMaybe<FlowMailboxMessageCondition>;
  filter?: InputMaybe<FlowMailboxMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowMailboxMessageCondition>;
  filter?: InputMaybe<FlowMailboxMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxesArgs = {
  condition?: InputMaybe<FlowMailboxCondition>;
  filter?: InputMaybe<FlowMailboxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowMailboxesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowMailboxCondition>;
  filter?: InputMaybe<FlowMailboxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowMailboxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowsArgs = {
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryForgeAccessTokenArgs = {
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAlgorithmGeometryArgs = {
  algorithmType: Scalars['String'];
  dbIds: Array<Scalars['Int']>;
  modelId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompanyDatabaseCellValueArgs = {
  columnId: Scalars['UUID'];
  rowId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetContractorByMailboxEmailArgs = {
  pEmail: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetFlowWithActionsArgs = {
  pFlowId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetHistoryEventGroupsArgs = {
  afterCursor?: InputMaybe<Scalars['Datetime']>;
  beforeCursor?: InputMaybe<Scalars['Datetime']>;
  filter?: InputMaybe<GetHistoryEventGroupsRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetHistoryEventGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  afterCursor?: InputMaybe<Scalars['Datetime']>;
  before?: InputMaybe<Scalars['Cursor']>;
  beforeCursor?: InputMaybe<Scalars['Datetime']>;
  filter?: InputMaybe<GetHistoryEventGroupsRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetMailboxByEmailArgs = {
  pEmail: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetMailboxEmailAddressArgs = {
  pMailboxId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetNextModelVersionArgs = {
  inputName: Scalars['String'];
  inputProjectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHistoryEventArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHistoryEventByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHistoryEventsArgs = {
  condition?: InputMaybe<HistoryEventCondition>;
  filter?: InputMaybe<HistoryEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHistoryEventsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HistoryEventCondition>;
  filter?: InputMaybe<HistoryEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInitialStateArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInitialStateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInitialStatesArgs = {
  condition?: InputMaybe<InitialStateCondition>;
  filter?: InputMaybe<InitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInitialStatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InitialStateCondition>;
  filter?: InputMaybe<InitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIssueArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIssueByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIssueCommentArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIssueCommentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIssueCommentsArgs = {
  condition?: InputMaybe<IssueCommentCondition>;
  filter?: InputMaybe<IssueCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIssueCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IssueCommentCondition>;
  filter?: InputMaybe<IssueCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIssuesArgs = {
  condition?: InputMaybe<IssueCondition>;
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IssueCondition>;
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLineArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLineByShapeIdArgs = {
  shapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinesArgs = {
  condition?: InputMaybe<LineCondition>;
  filter?: InputMaybe<LineFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLinesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LineCondition>;
  filter?: InputMaybe<LineFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLookupCompanyDatabaseValueArgs = {
  databaseId: Scalars['UUID'];
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModelArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModelByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModelByProjectIdAndNameAndVersionArgs = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModelsArgs = {
  condition?: InputMaybe<ModelCondition>;
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryModelsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ModelCondition>;
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnByNameAndColumnTypeAndOrderIdArgs = {
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnTemplateArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnTemplateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnTemplatesArgs = {
  condition?: InputMaybe<OrderColumnTemplateCondition>;
  filter?: InputMaybe<OrderColumnTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderColumnTemplateCondition>;
  filter?: InputMaybe<OrderColumnTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnsArgs = {
  condition?: InputMaybe<OrderColumnCondition>;
  filter?: InputMaybe<OrderColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderColumnCondition>;
  filter?: InputMaybe<OrderColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntriesArgs = {
  condition?: InputMaybe<OrderEntryCondition>;
  filter?: InputMaybe<OrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryCondition>;
  filter?: InputMaybe<OrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryCacheArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryCacheByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryCacheByOrderEntryIdArgs = {
  orderEntryId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryCachesArgs = {
  condition?: InputMaybe<OrderEntryCacheCondition>;
  filter?: InputMaybe<OrderEntryCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryCachesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryCachesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryCacheCondition>;
  filter?: InputMaybe<OrderEntryCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryCachesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryTemplateArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryTemplateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryTemplatesArgs = {
  condition?: InputMaybe<OrderEntryTemplateCondition>;
  filter?: InputMaybe<OrderEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryTemplateCondition>;
  filter?: InputMaybe<OrderEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryViewArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryViewByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryViewByProjectIdAndNameArgs = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryViewsArgs = {
  condition?: InputMaybe<OrderEntryViewCondition>;
  filter?: InputMaybe<OrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderEntryViewsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderEntryViewCondition>;
  filter?: InputMaybe<OrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrdersArgs = {
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPolygonArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPolygonByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPolygonByShapeIdArgs = {
  shapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPolygonsArgs = {
  condition?: InputMaybe<PolygonCondition>;
  filter?: InputMaybe<PolygonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PolygonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPolygonsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PolygonCondition>;
  filter?: InputMaybe<PolygonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PolygonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTagArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTagByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTagsArgs = {
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTagsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntriesArgs = {
  condition?: InputMaybe<ProjectTemplateOrderEntryCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateOrderEntryCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntryArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntryViewArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntryViewByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntryViewsArgs = {
  condition?: InputMaybe<ProjectTemplateOrderEntryViewCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrderEntryViewsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateOrderEntryViewCondition>;
  filter?: InputMaybe<ProjectTemplateOrderEntryViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrdersArgs = {
  condition?: InputMaybe<ProjectTemplateOrderCondition>;
  filter?: InputMaybe<ProjectTemplateOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateOrderCondition>;
  filter?: InputMaybe<ProjectTemplateOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplatesArgs = {
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProtanProjectStepArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProtanProjectStepByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProtanProjectStepByProjectIdAndStepArgs = {
  projectId: Scalars['UUID'];
  step: ProtanProjectStepEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryProtanProjectStepsArgs = {
  condition?: InputMaybe<ProtanProjectStepCondition>;
  filter?: InputMaybe<ProtanProjectStepFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProtanProjectStepsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProtanProjectStepCondition>;
  filter?: InputMaybe<ProtanProjectStepFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPublicInitialStatesArgs = {
  condition?: InputMaybe<PublicInitialStateCondition>;
  filter?: InputMaybe<PublicInitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PublicInitialStatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPublicInitialStatesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PublicInitialStateCondition>;
  filter?: InputMaybe<PublicInitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PublicInitialStatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReplaceFormulaIdsArgs = {
  idMap: Array<InputMaybe<IdPairInput>>;
  originalQuantity: QuantityInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryReplaceFormulaIdsWithNamesArgs = {
  quantity: QuantityInput;
  theOrderId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReplaceFormulaNamesWithIdsArgs = {
  customFields: Array<InputMaybe<TemplateCustomFieldTypeInput>>;
  templateQuantity: QuantityInput;
  theOrderId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedViewArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedViewByNameAndProjectIdArgs = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedViewByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedViewsArgs = {
  condition?: InputMaybe<SavedViewCondition>;
  filter?: InputMaybe<SavedViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedViewsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavedViewCondition>;
  filter?: InputMaybe<SavedViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeByUrnAndDbIdArgs = {
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeFolderArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeFolderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeFolderByProjectIdAndNameArgs = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeFoldersArgs = {
  condition?: InputMaybe<ShapeFolderCondition>;
  filter?: InputMaybe<ShapeFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShapeFoldersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapeFolderCondition>;
  filter?: InputMaybe<ShapeFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShapePointArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapePointByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapePointByShapeIdArgs = {
  shapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShapePointsArgs = {
  condition?: InputMaybe<ShapePointCondition>;
  filter?: InputMaybe<ShapePointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapePointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShapePointsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapePointCondition>;
  filter?: InputMaybe<ShapePointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapePointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShapesArgs = {
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySharedLinkArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySharedLinkByInitialStateIdArgs = {
  initialStateId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySharedLinkByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySharedLinksArgs = {
  condition?: InputMaybe<SharedLinkCondition>;
  filter?: InputMaybe<SharedLinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySharedLinksConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SharedLinkCondition>;
  filter?: InputMaybe<SharedLinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetByProjectIdAndNameAndVersionArgs = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetPageCalibrationArgs = {
  pageNumber: Scalars['Int'];
  sheetId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetPageCalibrationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetPageCalibrationsArgs = {
  condition?: InputMaybe<SheetPageCalibrationCondition>;
  filter?: InputMaybe<SheetPageCalibrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetPageCalibrationsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetPageCalibrationCondition>;
  filter?: InputMaybe<SheetPageCalibrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeByUrnAndDbIdArgs = {
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLegendArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLegendByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLegendBySheetShapeIdArgs = {
  sheetShapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLegendsArgs = {
  condition?: InputMaybe<SheetShapeLegendCondition>;
  filter?: InputMaybe<SheetShapeLegendFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLegendsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeLegendCondition>;
  filter?: InputMaybe<SheetShapeLegendFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLineArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLineBySheetShapeIdArgs = {
  sheetShapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLinesArgs = {
  condition?: InputMaybe<SheetShapeLineCondition>;
  filter?: InputMaybe<SheetShapeLineFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeLinesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeLineCondition>;
  filter?: InputMaybe<SheetShapeLineFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePointArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePointByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePointBySheetShapeIdArgs = {
  sheetShapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePointsArgs = {
  condition?: InputMaybe<SheetShapePointCondition>;
  filter?: InputMaybe<SheetShapePointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapePointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePointsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapePointCondition>;
  filter?: InputMaybe<SheetShapePointFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapePointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePolygonArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePolygonByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePolygonBySheetShapeIdArgs = {
  sheetShapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePolygonsArgs = {
  condition?: InputMaybe<SheetShapePolygonCondition>;
  filter?: InputMaybe<SheetShapePolygonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapePolygonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapePolygonsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapePolygonCondition>;
  filter?: InputMaybe<SheetShapePolygonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapePolygonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeSplitLineArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeSplitLineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeSplitLineBySheetShapeIdArgs = {
  sheetShapeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeSplitLinesArgs = {
  condition?: InputMaybe<SheetShapeSplitLineCondition>;
  filter?: InputMaybe<SheetShapeSplitLineFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeSplitLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapeSplitLinesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeSplitLineCondition>;
  filter?: InputMaybe<SheetShapeSplitLineFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapeSplitLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapesArgs = {
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetsArgs = {
  condition?: InputMaybe<SheetCondition>;
  filter?: InputMaybe<SheetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySheetsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetCondition>;
  filter?: InputMaybe<SheetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelAiAnalysesArgs = {
  condition?: InputMaybe<SparkelAiAnalysisCondition>;
  filter?: InputMaybe<SparkelAiAnalysisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelAiAnalysesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SparkelAiAnalysisCondition>;
  filter?: InputMaybe<SparkelAiAnalysisFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelAiAnalysisArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelAiAnalysisByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelPropertiesArgs = {
  condition?: InputMaybe<SparkelPropertyCondition>;
  filter?: InputMaybe<SparkelPropertyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SparkelPropertyCondition>;
  filter?: InputMaybe<SparkelPropertyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelPropertyArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelPropertyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetArgs = {
  dbId: Scalars['Int'];
  modelUrn: Scalars['String'];
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidateFlowActionLoopDepthArgs = {
  pParentLoopActionId: Scalars['UUID'];
};

export type Rectangle2 = {
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type ResolvedSubrowInput = {
  color?: InputMaybe<Scalars['String']>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type ResolvedTableRow = {
  __typename?: 'ResolvedTableRow';
  matchedProduct?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderEntryId: Scalars['UUID'];
  quantity: Scalars['Float'];
  unit: Scalars['String'];
};

export type RoomDetection2DInput = {
  autoShapeId: Scalars['UUID'];
  options: RoomDetection2DOptions;
  projectId: Scalars['UUID'];
  tenant: Scalars['String'];
};

export type RoomDetection2DOptions = {
  /**
   * Maximum gap size for smart gap closing.
   * - If page is CALIBRATED: interpreted as millimeters (default: 800mm)
   * - If page is NOT calibrated: interpreted as pixels (default: 90px)
   */
  maxGap?: InputMaybe<Scalars['Float']>;
  /**
   * Minimum room area to include.
   * - If page is CALIBRATED: interpreted as square meters (default: 1 m²)
   * - If page is NOT calibrated: interpreted as square pixels (default: 500px²)
   */
  minRoomArea?: InputMaybe<Scalars['Float']>;
  /** The page number (1-based) to detect rooms on */
  pageNumber: Scalars['Int'];
  /** The sheet ID containing the PDF to process */
  sheetId: Scalars['UUID'];
  /**
   * Polygon simplification tolerance (absolute).
   * - If page is CALIBRATED: interpreted as millimeters (default: 50mm)
   * - If page is NOT calibrated: interpreted as pixels (default: 3px)
   */
  simplifyTolerance?: InputMaybe<Scalars['Float']>;
  /**
   * Wall thickness between rooms.
   * - If page is CALIBRATED: interpreted as millimeters (default: 200mm)
   * - If page is NOT calibrated: interpreted as pixels (default: 2px)
   */
  wallThickness?: InputMaybe<Scalars['Float']>;
};

export type RoomDetection2DPayload = {
  __typename?: 'RoomDetection2DPayload';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum RoundingEnum {
  Nearest_10 = 'NEAREST_10',
  Nearest_100 = 'NEAREST_100',
  Nearest_1000 = 'NEAREST_1000',
  '0Decimals' = '_0_DECIMALS',
  '1Decimals' = '_1_DECIMALS',
  '2Decimals' = '_2_DECIMALS',
  '3Decimals' = '_3_DECIMALS'
}

/** A filter to be used against RoundingEnum fields. All fields are combined with a logical ‘and.’ */
export type RoundingEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RoundingEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RoundingEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RoundingEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RoundingEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RoundingEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RoundingEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RoundingEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RoundingEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RoundingEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RoundingEnum>>;
};

export type RunClassificationInput = {
  modelId: Scalars['UUID'];
};

export type RunClassificationResponse = {
  __typename?: 'RunClassificationResponse';
  success: Scalars['Boolean'];
};

export type SavedView = Node & {
  __typename?: 'SavedView';
  cameraPosition?: Maybe<CameraPositionType>;
  categories: Array<Scalars['String']>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsBySavedViewsId: Array<Comment>;
  /** Reads and enables pagination through a set of `Comment`. */
  commentsBySavedViewsIdConnection: CommentsConnection;
  createdAt: Scalars['Datetime'];
  hiddenElements?: Maybe<Array<ElementIdentifierDbidType>>;
  hiddenModels?: Maybe<Array<Scalars['String']>>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InitialState`. */
  initialStatesByViewId: Array<InitialState>;
  /** Reads and enables pagination through a set of `InitialState`. */
  initialStatesByViewIdConnection: InitialStatesConnection;
  isCommentView?: Maybe<Scalars['Boolean']>;
  isDefault: Scalars['Boolean'];
  isolatedElements?: Maybe<Array<ElementIdentifierDbidType>>;
  layers: Array<Scalars['String']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `SavedView`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  section?: Maybe<ViewSection>;
  statuses: Array<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


export type SavedViewCommentsBySavedViewsIdArgs = {
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type SavedViewCommentsBySavedViewsIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentCondition>;
  filter?: InputMaybe<CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};


export type SavedViewInitialStatesByViewIdArgs = {
  condition?: InputMaybe<InitialStateCondition>;
  filter?: InputMaybe<InitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};


export type SavedViewInitialStatesByViewIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InitialStateCondition>;
  filter?: InputMaybe<InitialStateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};

/**
 * A condition to be used against `SavedView` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SavedViewCondition = {
  /** Checks for equality with the object’s `cameraPosition` field. */
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  /** Checks for equality with the object’s `categories` field. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hiddenElements` field. */
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  /** Checks for equality with the object’s `hiddenModels` field. */
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isCommentView` field. */
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isDefault` field. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isolatedElements` field. */
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  /** Checks for equality with the object’s `layers` field. */
  layers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `section` field. */
  section?: InputMaybe<ViewSection>;
  /** Checks for equality with the object’s `statuses` field. */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SavedView` object types. All fields are combined with a logical ‘and.’ */
export type SavedViewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SavedViewFilter>>;
  /** Filter by the object’s `cameraPosition` field. */
  cameraPosition?: InputMaybe<CameraPositionTypeFilter>;
  /** Filter by the object’s `categories` field. */
  categories?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hiddenModels` field. */
  hiddenModels?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isCommentView` field. */
  isCommentView?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `layers` field. */
  layers?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SavedViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SavedViewFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `section` field. */
  section?: InputMaybe<ViewSectionFilter>;
  /** Filter by the object’s `statuses` field. */
  statuses?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SavedView` */
export type SavedViewInput = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories: Array<InputMaybe<Scalars['String']>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses: Array<InputMaybe<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SavedViewNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `savedView` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SavedViewNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `savedView` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SavedViewOnCommentForCommentsSavedViewsIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `comment` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `comment` being updated. */
  patch: CommentPatch;
};

/** The fields on `savedView` to look up the row to update. */
export type SavedViewOnCommentForCommentsSavedViewsIdFkeyUsingSavedViewsNameProjectIdUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: UpdateSavedViewOnCommentForCommentsSavedViewsIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `savedView` to look up the row to update. */
export type SavedViewOnCommentForCommentsSavedViewsIdFkeyUsingSavedViewsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: UpdateSavedViewOnCommentForCommentsSavedViewsIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type SavedViewOnInitialStateForInitialStatesViewIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `initialState` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `initialState` being updated. */
  patch: InitialStatePatch;
};

/** The fields on `savedView` to look up the row to update. */
export type SavedViewOnInitialStateForInitialStatesViewIdFkeyUsingSavedViewsNameProjectIdUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: UpdateSavedViewOnInitialStateForInitialStatesViewIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `savedView` to look up the row to update. */
export type SavedViewOnInitialStateForInitialStatesViewIdFkeyUsingSavedViewsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: UpdateSavedViewOnInitialStateForInitialStatesViewIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type SavedViewOnSavedViewForSavedViewsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `savedView` to look up the row to update. */
export type SavedViewOnSavedViewForSavedViewsProjectIdFkeyUsingSavedViewsNameProjectIdUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: UpdateSavedViewOnSavedViewForSavedViewsProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `savedView` to look up the row to update. */
export type SavedViewOnSavedViewForSavedViewsProjectIdFkeyUsingSavedViewsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `savedView` being updated. */
  patch: UpdateSavedViewOnSavedViewForSavedViewsProjectIdFkeyPatch;
};

/** Represents an update to a `SavedView`. Fields that are set will be updated. */
export type SavedViewPatch = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `savedView` to look up the row to connect. */
export type SavedViewSavedViewsNameProjectIdUniqueConnect = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** The fields on `savedView` to look up the row to delete. */
export type SavedViewSavedViewsNameProjectIdUniqueDelete = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** The fields on `savedView` to look up the row to connect. */
export type SavedViewSavedViewsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `savedView` to look up the row to delete. */
export type SavedViewSavedViewsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SavedView` values. */
export type SavedViewsConnection = {
  __typename?: 'SavedViewsConnection';
  /** A list of edges which contains the `SavedView` and cursor to aid in pagination. */
  edges: Array<SavedViewsEdge>;
  /** A list of `SavedView` objects. */
  nodes: Array<SavedView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SavedView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SavedView` edge in the connection. */
export type SavedViewsEdge = {
  __typename?: 'SavedViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SavedView` at the end of the edge. */
  node: SavedView;
};

/** Methods to use when ordering `SavedView`. */
export enum SavedViewsOrderBy {
  CameraPositionAsc = 'CAMERA_POSITION_ASC',
  CameraPositionDesc = 'CAMERA_POSITION_DESC',
  CategoriesAsc = 'CATEGORIES_ASC',
  CategoriesDesc = 'CATEGORIES_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HiddenElementsAsc = 'HIDDEN_ELEMENTS_ASC',
  HiddenElementsDesc = 'HIDDEN_ELEMENTS_DESC',
  HiddenModelsAsc = 'HIDDEN_MODELS_ASC',
  HiddenModelsDesc = 'HIDDEN_MODELS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsolatedElementsAsc = 'ISOLATED_ELEMENTS_ASC',
  IsolatedElementsDesc = 'ISOLATED_ELEMENTS_DESC',
  IsCommentViewAsc = 'IS_COMMENT_VIEW_ASC',
  IsCommentViewDesc = 'IS_COMMENT_VIEW_DESC',
  IsDefaultAsc = 'IS_DEFAULT_ASC',
  IsDefaultDesc = 'IS_DEFAULT_DESC',
  LayersAsc = 'LAYERS_ASC',
  LayersDesc = 'LAYERS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  SectionAsc = 'SECTION_ASC',
  SectionDesc = 'SECTION_DESC',
  StatusesAsc = 'STATUSES_ASC',
  StatusesDesc = 'STATUSES_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `project` in the `SavedViewInput` mutation. */
export type SavedViewsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<SavedViewsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnSavedViewForSavedViewsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SavedViewOnSavedViewForSavedViewsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `savedView` in the `ProjectInput` mutation. */
export type SavedViewsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SavedViewSavedViewsPkeyConnect>>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectByNameAndProjectId?: InputMaybe<Array<SavedViewSavedViewsNameProjectIdUniqueConnect>>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SavedViewNodeIdConnect>>;
  /** A `SavedViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SavedViewsProjectIdFkeySavedViewsCreateInput>>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SavedViewSavedViewsPkeyDelete>>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteByNameAndProjectId?: InputMaybe<Array<SavedViewSavedViewsNameProjectIdUniqueDelete>>;
  /** The primary key(s) for `savedView` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SavedViewNodeIdDelete>>;
  /** Flag indicating whether all other `savedView` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SavedViewOnSavedViewForSavedViewsProjectIdFkeyUsingSavedViewsPkeyUpdate>>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateByNameAndProjectId?: InputMaybe<Array<SavedViewOnSavedViewForSavedViewsProjectIdFkeyUsingSavedViewsNameProjectIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `savedView` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnSavedViewForSavedViewsProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type SavedViewsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `savedView` to be created by this mutation. */
export type SavedViewsProjectIdFkeySavedViewsCreateInput = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories: Array<InputMaybe<Scalars['String']>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses: Array<InputMaybe<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type Shape = Node & {
  __typename?: 'Shape';
  /** Reads a single `AutoShape` that is related to this `Shape`. */
  autoShape?: Maybe<AutoShape>;
  autoShapeId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  dbId: Scalars['Int'];
  /** Reads a single `ExtrudedPolygon` that is related to this `Shape`. */
  extrudedPolygon?: Maybe<ExtrudedPolygon>;
  folder?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads a single `Line` that is related to this `Shape`. */
  line?: Maybe<Line>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Polygon` that is related to this `Shape`. */
  polygon?: Maybe<Polygon>;
  /** Reads a single `Project` that is related to this `Shape`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  /** Reads a single `ShapeFolder` that is related to this `Shape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
  /** Reads a single `ShapePoint` that is related to this `Shape`. */
  shapePoint?: Maybe<ShapePoint>;
  updatedAt: Scalars['Datetime'];
  urn: Scalars['String'];
};

/** A condition to be used against `Shape` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ShapeCondition = {
  /** Checks for equality with the object’s `autoShapeId` field. */
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dbId` field. */
  dbId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `folder` field. */
  folder?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `urn` field. */
  urn?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Shape` object types. All fields are combined with a logical ‘and.’ */
export type ShapeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShapeFilter>>;
  /** Filter by the object’s `autoShapeId` field. */
  autoShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dbId` field. */
  dbId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `folder` field. */
  folder?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShapeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShapeFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `urn` field. */
  urn?: InputMaybe<StringFilter>;
};

export type ShapeFolder = Node & {
  __typename?: 'ShapeFolder';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `ShapeFolder`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Shape`. */
  shapesByFolder: Array<Shape>;
  /** Reads and enables pagination through a set of `Shape`. */
  shapesByFolderConnection: ShapesConnection;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapesByFolder: Array<SheetShape>;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapesByFolderConnection: SheetShapesConnection;
  updatedAt: Scalars['Datetime'];
};


export type ShapeFolderShapesByFolderArgs = {
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


export type ShapeFolderShapesByFolderConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShapeCondition>;
  filter?: InputMaybe<ShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};


export type ShapeFolderSheetShapesByFolderArgs = {
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


export type ShapeFolderSheetShapesByFolderConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};

/**
 * A condition to be used against `ShapeFolder` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ShapeFolderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ShapeFolder` object types. All fields are combined with a logical ‘and.’ */
export type ShapeFolderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShapeFolderFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShapeFolderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShapeFolderFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ShapeFolder` */
export type ShapeFolderInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ShapeFolderNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `shapeFolder` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ShapeFolderNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `shapeFolder` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `shapeFolder` to look up the row to update. */
export type ShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyUsingShapeFoldersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: UpdateShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyPatch;
};

/** The fields on `shapeFolder` to look up the row to update. */
export type ShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyUsingShapeFoldersUniqueProjectIdNameUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: UpdateShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeFolderOnShapeForShapesFolderFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `shapeFolder` to look up the row to update. */
export type ShapeFolderOnShapeForShapesFolderFkeyUsingShapeFoldersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: UpdateShapeFolderOnShapeForShapesFolderFkeyPatch;
};

/** The fields on `shapeFolder` to look up the row to update. */
export type ShapeFolderOnShapeForShapesFolderFkeyUsingShapeFoldersUniqueProjectIdNameUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: UpdateShapeFolderOnShapeForShapesFolderFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeFolderOnSheetShapeForSheetShapesFolderFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `shapeFolder` to look up the row to update. */
export type ShapeFolderOnSheetShapeForSheetShapesFolderFkeyUsingShapeFoldersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: UpdateShapeFolderOnSheetShapeForSheetShapesFolderFkeyPatch;
};

/** The fields on `shapeFolder` to look up the row to update. */
export type ShapeFolderOnSheetShapeForSheetShapesFolderFkeyUsingShapeFoldersUniqueProjectIdNameUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: UpdateShapeFolderOnSheetShapeForSheetShapesFolderFkeyPatch;
  projectId: Scalars['UUID'];
};

/** Represents an update to a `ShapeFolder`. Fields that are set will be updated. */
export type ShapeFolderPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `shapeFolder` to look up the row to connect. */
export type ShapeFolderShapeFoldersPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `shapeFolder` to look up the row to delete. */
export type ShapeFolderShapeFoldersPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `shapeFolder` to look up the row to connect. */
export type ShapeFolderShapeFoldersUniqueProjectIdNameConnect = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** The fields on `shapeFolder` to look up the row to delete. */
export type ShapeFolderShapeFoldersUniqueProjectIdNameDelete = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
};

/** A connection to a list of `ShapeFolder` values. */
export type ShapeFoldersConnection = {
  __typename?: 'ShapeFoldersConnection';
  /** A list of edges which contains the `ShapeFolder` and cursor to aid in pagination. */
  edges: Array<ShapeFoldersEdge>;
  /** A list of `ShapeFolder` objects. */
  nodes: Array<ShapeFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShapeFolder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ShapeFolder` edge in the connection. */
export type ShapeFoldersEdge = {
  __typename?: 'ShapeFoldersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ShapeFolder` at the end of the edge. */
  node: ShapeFolder;
};

/** Methods to use when ordering `ShapeFolder`. */
export enum ShapeFoldersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `project` in the `ShapeFolderInput` mutation. */
export type ShapeFoldersProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<ShapeFoldersProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnShapeFolderForShapeFoldersProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `shapeFolder` in the `ProjectInput` mutation. */
export type ShapeFoldersProjectIdFkeyInverseInput = {
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ShapeFolderShapeFoldersPkeyConnect>>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ShapeFolderNodeIdConnect>>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectByProjectIdAndName?: InputMaybe<Array<ShapeFolderShapeFoldersUniqueProjectIdNameConnect>>;
  /** A `ShapeFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ShapeFoldersProjectIdFkeyShapeFoldersCreateInput>>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ShapeFolderShapeFoldersPkeyDelete>>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ShapeFolderNodeIdDelete>>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteByProjectIdAndName?: InputMaybe<Array<ShapeFolderShapeFoldersUniqueProjectIdNameDelete>>;
  /** Flag indicating whether all other `shapeFolder` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyUsingShapeFoldersPkeyUpdate>>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnShapeFolderForShapeFoldersProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateByProjectIdAndName?: InputMaybe<Array<ShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyUsingShapeFoldersUniqueProjectIdNameUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ShapeFoldersProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `shapeFolder` to be created by this mutation. */
export type ShapeFoldersProjectIdFkeyShapeFoldersCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An input for mutations affecting `Shape` */
export type ShapeInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type ShapeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ShapeNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `shape` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `extrudedPolygon` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `extrudedPolygon` being updated. */
  patch: ExtrudedPolygonPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnLineForLinesShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `line` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `line` being updated. */
  patch: LinePatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnLineForLinesShapeIdFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnLineForLinesShapeIdFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnLineForLinesShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnLineForLinesShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnPolygonForPolygonsShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `polygon` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `polygon` being updated. */
  patch: PolygonPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnPolygonForPolygonsShapeIdFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnPolygonForPolygonsShapeIdFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnPolygonForPolygonsShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnPolygonForPolygonsShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnShapeForShapesAutoShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `autoShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `autoShape` being updated. */
  patch: AutoShapePatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapeForShapesAutoShapeIdFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapeForShapesAutoShapeIdFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapeForShapesAutoShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapeForShapesAutoShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnShapeForShapesFolderFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shapeFolder` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: ShapeFolderPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapeForShapesFolderFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapeForShapesFolderFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapeForShapesFolderFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapeForShapesFolderFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnShapeForShapesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapeForShapesProjectIdFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapeForShapesProjectIdFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapeForShapesProjectIdFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapeForShapesProjectIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapeOnShapePointForShapePointsShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shapePoint` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shapePoint` being updated. */
  patch: ShapePointPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapePointForShapePointsShapeIdFkeyUsingShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapePointForShapePointsShapeIdFkeyPatch;
};

/** The fields on `shape` to look up the row to update. */
export type ShapeOnShapePointForShapePointsShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: UpdateShapeOnShapePointForShapePointsShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** Represents an update to a `Shape`. Fields that are set will be updated. */
export type ShapePatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

export type ShapePoint = Node & {
  __typename?: 'ShapePoint';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  point: Point3Type;
  /** Reads a single `Shape` that is related to this `ShapePoint`. */
  shape?: Maybe<Shape>;
  shapeId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ShapePoint` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ShapePointCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `point` field. */
  point?: InputMaybe<Point3TypeInput>;
  /** Checks for equality with the object’s `shapeId` field. */
  shapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ShapePoint` object types. All fields are combined with a logical ‘and.’ */
export type ShapePointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShapePointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShapePointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShapePointFilter>>;
  /** Filter by the object’s `point` field. */
  point?: InputMaybe<Point3TypeFilter>;
  /** Filter by the object’s `shapeId` field. */
  shapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ShapePoint` */
export type ShapePointInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point: Point3TypeInput;
  shape?: InputMaybe<ShapePointsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ShapePointNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `shapePoint` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ShapePointNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `shapePoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ShapePointOnShapePointForShapePointsShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shape` being updated. */
  patch: ShapePatch;
};

/** The fields on `shapePoint` to look up the row to update. */
export type ShapePointOnShapePointForShapePointsShapeIdFkeyUsingShapePointsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `shapePoint` being updated. */
  patch: UpdateShapePointOnShapePointForShapePointsShapeIdFkeyPatch;
};

/** The fields on `shapePoint` to look up the row to update. */
export type ShapePointOnShapePointForShapePointsShapeIdFkeyUsingShapePointsShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `shapePoint` being updated. */
  patch: UpdateShapePointOnShapePointForShapePointsShapeIdFkeyPatch;
  shapeId: Scalars['UUID'];
};

/** Represents an update to a `ShapePoint`. Fields that are set will be updated. */
export type ShapePointPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point?: InputMaybe<Point3TypeInput>;
  shape?: InputMaybe<ShapePointsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `shapePoint` to look up the row to connect. */
export type ShapePointShapePointsPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `shapePoint` to look up the row to delete. */
export type ShapePointShapePointsPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `shapePoint` to look up the row to connect. */
export type ShapePointShapePointsShapeIdKeyConnect = {
  shapeId: Scalars['UUID'];
};

/** The fields on `shapePoint` to look up the row to delete. */
export type ShapePointShapePointsShapeIdKeyDelete = {
  shapeId: Scalars['UUID'];
};

/** A connection to a list of `ShapePoint` values. */
export type ShapePointsConnection = {
  __typename?: 'ShapePointsConnection';
  /** A list of edges which contains the `ShapePoint` and cursor to aid in pagination. */
  edges: Array<ShapePointsEdge>;
  /** A list of `ShapePoint` objects. */
  nodes: Array<ShapePoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShapePoint` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ShapePoint` edge in the connection. */
export type ShapePointsEdge = {
  __typename?: 'ShapePointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ShapePoint` at the end of the edge. */
  node: ShapePoint;
};

/** Methods to use when ordering `ShapePoint`. */
export enum ShapePointsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointAsc = 'POINT_ASC',
  PointDesc = 'POINT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShapeIdAsc = 'SHAPE_ID_ASC',
  ShapeIdDesc = 'SHAPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `shape` in the `ShapePointInput` mutation. */
export type ShapePointsShapeIdFkeyInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<ShapeShapesPkeyConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapeNodeIdConnect>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbConnect>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ShapePointsShapeIdFkeyShapesCreateInput>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapeShapesPkeyDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapeNodeIdDelete>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<ShapeShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<ShapeOnShapePointForShapePointsShapeIdFkeyUsingShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapePointOnShapePointForShapePointsShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<ShapeOnShapePointForShapePointsShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `shapePoint` in the `ShapeInput` mutation. */
export type ShapePointsShapeIdFkeyInverseInput = {
  /** The primary key(s) for `shapePoint` for the far side of the relationship. */
  connectById?: InputMaybe<ShapePointShapePointsPkeyConnect>;
  /** The primary key(s) for `shapePoint` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapePointNodeIdConnect>;
  /** The primary key(s) for `shapePoint` for the far side of the relationship. */
  connectByShapeId?: InputMaybe<ShapePointShapePointsShapeIdKeyConnect>;
  /** A `ShapePointInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ShapePointsShapeIdFkeyShapePointsCreateInput>>;
  /** The primary key(s) for `shapePoint` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapePointShapePointsPkeyDelete>;
  /** The primary key(s) for `shapePoint` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapePointNodeIdDelete>;
  /** The primary key(s) for `shapePoint` for the far side of the relationship. */
  deleteByShapeId?: InputMaybe<ShapePointShapePointsShapeIdKeyDelete>;
  /** Flag indicating whether all other `shapePoint` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `shapePoint` for the far side of the relationship. */
  updateById?: InputMaybe<ShapePointOnShapePointForShapePointsShapeIdFkeyUsingShapePointsPkeyUpdate>;
  /** The primary key(s) and patch data for `shapePoint` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnShapePointForShapePointsShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shapePoint` for the far side of the relationship. */
  updateByShapeId?: InputMaybe<ShapePointOnShapePointForShapePointsShapeIdFkeyUsingShapePointsShapeIdKeyUpdate>;
};

/** The `shapePoint` to be created by this mutation. */
export type ShapePointsShapeIdFkeyShapePointsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point: Point3TypeInput;
  shape?: InputMaybe<ShapePointsShapeIdFkeyInput>;
  shapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `shape` to be created by this mutation. */
export type ShapePointsShapeIdFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** The fields on `shape` to look up the row to connect. */
export type ShapeShapesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `shape` to look up the row to delete. */
export type ShapeShapesPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `shape` to look up the row to connect. */
export type ShapeShapesUniqueProjectIdDbConnect = {
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};

/** The fields on `shape` to look up the row to delete. */
export type ShapeShapesUniqueProjectIdDbDelete = {
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};

/** The `autoShape` to be created by this mutation. */
export type ShapesAutoShapeIdFkeyAutoShapesCreateInput = {
  algorithmInput: Scalars['JSON'];
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `autoShape` in the `ShapeInput` mutation. */
export type ShapesAutoShapeIdFkeyInput = {
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  connectById?: InputMaybe<AutoShapeAutoShapesPkeyConnect>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AutoShapeNodeIdConnect>;
  /** A `AutoShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ShapesAutoShapeIdFkeyAutoShapesCreateInput>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  deleteById?: InputMaybe<AutoShapeAutoShapesPkeyDelete>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<AutoShapeNodeIdDelete>;
  /** The primary key(s) and patch data for `autoShape` for the far side of the relationship. */
  updateById?: InputMaybe<AutoShapeOnShapeForShapesAutoShapeIdFkeyUsingAutoShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `autoShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnShapeForShapesAutoShapeIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `shape` in the `AutoShapeInput` mutation. */
export type ShapesAutoShapeIdFkeyInverseInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ShapeShapesPkeyConnect>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ShapeNodeIdConnect>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<ShapeShapesUniqueProjectIdDbConnect>>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ShapesAutoShapeIdFkeyShapesCreateInput>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ShapeShapesPkeyDelete>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ShapeNodeIdDelete>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<ShapeShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `shape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ShapeOnShapeForShapesAutoShapeIdFkeyUsingShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<AutoShapeOnShapeForShapesAutoShapeIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<ShapeOnShapeForShapesAutoShapeIdFkeyUsingShapesUniqueProjectIdDbUpdate>>;
};

/** The `shape` to be created by this mutation. */
export type ShapesAutoShapeIdFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** A connection to a list of `Shape` values. */
export type ShapesConnection = {
  __typename?: 'ShapesConnection';
  /** A list of edges which contains the `Shape` and cursor to aid in pagination. */
  edges: Array<ShapesEdge>;
  /** A list of `Shape` objects. */
  nodes: Array<Shape>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Shape` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Shape` edge in the connection. */
export type ShapesEdge = {
  __typename?: 'ShapesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Shape` at the end of the edge. */
  node: Shape;
};

/** Input for the nested mutation of `shapeFolder` in the `ShapeInput` mutation. */
export type ShapesFolderFkeyInput = {
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectById?: InputMaybe<ShapeFolderShapeFoldersPkeyConnect>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapeFolderNodeIdConnect>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectByProjectIdAndName?: InputMaybe<ShapeFolderShapeFoldersUniqueProjectIdNameConnect>;
  /** A `ShapeFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<ShapesFolderFkeyShapeFoldersCreateInput>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapeFolderShapeFoldersPkeyDelete>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapeFolderNodeIdDelete>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteByProjectIdAndName?: InputMaybe<ShapeFolderShapeFoldersUniqueProjectIdNameDelete>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateById?: InputMaybe<ShapeFolderOnShapeForShapesFolderFkeyUsingShapeFoldersPkeyUpdate>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnShapeForShapesFolderFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateByProjectIdAndName?: InputMaybe<ShapeFolderOnShapeForShapesFolderFkeyUsingShapeFoldersUniqueProjectIdNameUpdate>;
};

/** Input for the nested mutation of `shape` in the `ShapeFolderInput` mutation. */
export type ShapesFolderFkeyInverseInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ShapeShapesPkeyConnect>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ShapeNodeIdConnect>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<ShapeShapesUniqueProjectIdDbConnect>>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ShapesFolderFkeyShapesCreateInput>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ShapeShapesPkeyDelete>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ShapeNodeIdDelete>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<ShapeShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `shape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ShapeOnShapeForShapesFolderFkeyUsingShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ShapeFolderOnShapeForShapesFolderFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<ShapeOnShapeForShapesFolderFkeyUsingShapesUniqueProjectIdDbUpdate>>;
};

/** The `shapeFolder` to be created by this mutation. */
export type ShapesFolderFkeyShapeFoldersCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `shape` to be created by this mutation. */
export type ShapesFolderFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** Methods to use when ordering `Shape`. */
export enum ShapesOrderBy {
  AutoShapeIdAsc = 'AUTO_SHAPE_ID_ASC',
  AutoShapeIdDesc = 'AUTO_SHAPE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DbIdAsc = 'DB_ID_ASC',
  DbIdDesc = 'DB_ID_DESC',
  FolderAsc = 'FOLDER_ASC',
  FolderDesc = 'FOLDER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UrnAsc = 'URN_ASC',
  UrnDesc = 'URN_DESC'
}

/** Input for the nested mutation of `project` in the `ShapeInput` mutation. */
export type ShapesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<ShapesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnShapeForShapesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ShapeOnShapeForShapesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `shape` in the `ProjectInput` mutation. */
export type ShapesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ShapeShapesPkeyConnect>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ShapeNodeIdConnect>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<ShapeShapesUniqueProjectIdDbConnect>>;
  /** A `ShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ShapesProjectIdFkeyShapesCreateInput>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ShapeShapesPkeyDelete>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ShapeNodeIdDelete>>;
  /** The primary key(s) for `shape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<ShapeShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `shape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ShapeOnShapeForShapesProjectIdFkeyUsingShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnShapeForShapesProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `shape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<ShapeOnShapeForShapesProjectIdFkeyUsingShapesUniqueProjectIdDbUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ShapesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `shape` to be created by this mutation. */
export type ShapesProjectIdFkeyShapesCreateInput = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name: Scalars['String'];
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

export type SharedLink = Node & {
  __typename?: 'SharedLink';
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['String']>;
  expiresAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `InitialState` that is related to this `SharedLink`. */
  initialState?: Maybe<InitialState>;
  initialStateId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  orderIds?: Maybe<Array<Scalars['UUID']>>;
  /** Reads a single `Project` that is related to this `SharedLink`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SharedLink` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SharedLinkCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `initialStateId` field. */
  initialStateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `orderIds` field. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SharedLink` object types. All fields are combined with a logical ‘and.’ */
export type SharedLinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SharedLinkFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `initialStateId` field. */
  initialStateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SharedLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SharedLinkFilter>>;
  /** Filter by the object’s `orderIds` field. */
  orderIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SharedLink` */
export type SharedLinkInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  initialState?: InputMaybe<SharedLinksInitialStateIdFkeyInput>;
  initialStateId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  project?: InputMaybe<SharedLinksProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SharedLinkNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sharedLink` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SharedLinkNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sharedLink` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `initialState` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `initialState` being updated. */
  patch: InitialStatePatch;
};

/** The fields on `sharedLink` to look up the row to update. */
export type SharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyUsingSharedLinksInitialStateIdKeyUpdate = {
  initialStateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sharedLink` being updated. */
  patch: UpdateSharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyPatch;
};

/** The fields on `sharedLink` to look up the row to update. */
export type SharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyUsingSharedLinksPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sharedLink` being updated. */
  patch: UpdateSharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type SharedLinkOnSharedLinkForSharedLinksProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `sharedLink` to look up the row to update. */
export type SharedLinkOnSharedLinkForSharedLinksProjectIdFkeyUsingSharedLinksInitialStateIdKeyUpdate = {
  initialStateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sharedLink` being updated. */
  patch: UpdateSharedLinkOnSharedLinkForSharedLinksProjectIdFkeyPatch;
};

/** The fields on `sharedLink` to look up the row to update. */
export type SharedLinkOnSharedLinkForSharedLinksProjectIdFkeyUsingSharedLinksPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sharedLink` being updated. */
  patch: UpdateSharedLinkOnSharedLinkForSharedLinksProjectIdFkeyPatch;
};

/** Represents an update to a `SharedLink`. Fields that are set will be updated. */
export type SharedLinkPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  initialState?: InputMaybe<SharedLinksInitialStateIdFkeyInput>;
  initialStateId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  project?: InputMaybe<SharedLinksProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sharedLink` to look up the row to connect. */
export type SharedLinkSharedLinksInitialStateIdKeyConnect = {
  initialStateId: Scalars['UUID'];
};

/** The fields on `sharedLink` to look up the row to delete. */
export type SharedLinkSharedLinksInitialStateIdKeyDelete = {
  initialStateId: Scalars['UUID'];
};

/** The fields on `sharedLink` to look up the row to connect. */
export type SharedLinkSharedLinksPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `sharedLink` to look up the row to delete. */
export type SharedLinkSharedLinksPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SharedLink` values. */
export type SharedLinksConnection = {
  __typename?: 'SharedLinksConnection';
  /** A list of edges which contains the `SharedLink` and cursor to aid in pagination. */
  edges: Array<SharedLinksEdge>;
  /** A list of `SharedLink` objects. */
  nodes: Array<SharedLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SharedLink` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SharedLink` edge in the connection. */
export type SharedLinksEdge = {
  __typename?: 'SharedLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SharedLink` at the end of the edge. */
  node: SharedLink;
};

/** The `initialState` to be created by this mutation. */
export type SharedLinksInitialStateIdFkeyInitialStatesCreateInput = {
  expandedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  externalAccessToken: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries: Array<InputMaybe<Scalars['String']>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings: ViewSettingsTypeInput;
};

/** Input for the nested mutation of `initialState` in the `SharedLinkInput` mutation. */
export type SharedLinksInitialStateIdFkeyInput = {
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  connectById?: InputMaybe<InitialStateInitialStatesPkeyConnect>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InitialStateNodeIdConnect>;
  /** A `InitialStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<SharedLinksInitialStateIdFkeyInitialStatesCreateInput>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  deleteById?: InputMaybe<InitialStateInitialStatesPkeyDelete>;
  /** The primary key(s) for `initialState` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<InitialStateNodeIdDelete>;
  /** The primary key(s) and patch data for `initialState` for the far side of the relationship. */
  updateById?: InputMaybe<InitialStateOnSharedLinkForSharedLinksInitialStateIdFkeyUsingInitialStatesPkeyUpdate>;
  /** The primary key(s) and patch data for `initialState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sharedLink` in the `InitialStateInput` mutation. */
export type SharedLinksInitialStateIdFkeyInverseInput = {
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  connectById?: InputMaybe<SharedLinkSharedLinksPkeyConnect>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  connectByInitialStateId?: InputMaybe<SharedLinkSharedLinksInitialStateIdKeyConnect>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SharedLinkNodeIdConnect>;
  /** A `SharedLinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SharedLinksInitialStateIdFkeySharedLinksCreateInput>>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  deleteById?: InputMaybe<SharedLinkSharedLinksPkeyDelete>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  deleteByInitialStateId?: InputMaybe<SharedLinkSharedLinksInitialStateIdKeyDelete>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SharedLinkNodeIdDelete>;
  /** Flag indicating whether all other `sharedLink` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sharedLink` for the far side of the relationship. */
  updateById?: InputMaybe<SharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyUsingSharedLinksPkeyUpdate>;
  /** The primary key(s) and patch data for `sharedLink` for the far side of the relationship. */
  updateByInitialStateId?: InputMaybe<SharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyUsingSharedLinksInitialStateIdKeyUpdate>;
  /** The primary key(s) and patch data for `sharedLink` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InitialStateOnSharedLinkForSharedLinksInitialStateIdFkeyNodeIdUpdate>;
};

/** The `sharedLink` to be created by this mutation. */
export type SharedLinksInitialStateIdFkeySharedLinksCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  initialState?: InputMaybe<SharedLinksInitialStateIdFkeyInput>;
  initialStateId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  project?: InputMaybe<SharedLinksProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Methods to use when ordering `SharedLink`. */
export enum SharedLinksOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InitialStateIdAsc = 'INITIAL_STATE_ID_ASC',
  InitialStateIdDesc = 'INITIAL_STATE_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderIdsAsc = 'ORDER_IDS_ASC',
  OrderIdsDesc = 'ORDER_IDS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `project` in the `SharedLinkInput` mutation. */
export type SharedLinksProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<SharedLinksProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnSharedLinkForSharedLinksProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SharedLinkOnSharedLinkForSharedLinksProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sharedLink` in the `ProjectInput` mutation. */
export type SharedLinksProjectIdFkeyInverseInput = {
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SharedLinkSharedLinksPkeyConnect>>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  connectByInitialStateId?: InputMaybe<Array<SharedLinkSharedLinksInitialStateIdKeyConnect>>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SharedLinkNodeIdConnect>>;
  /** A `SharedLinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SharedLinksProjectIdFkeySharedLinksCreateInput>>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SharedLinkSharedLinksPkeyDelete>>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  deleteByInitialStateId?: InputMaybe<Array<SharedLinkSharedLinksInitialStateIdKeyDelete>>;
  /** The primary key(s) for `sharedLink` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SharedLinkNodeIdDelete>>;
  /** Flag indicating whether all other `sharedLink` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sharedLink` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SharedLinkOnSharedLinkForSharedLinksProjectIdFkeyUsingSharedLinksPkeyUpdate>>;
  /** The primary key(s) and patch data for `sharedLink` for the far side of the relationship. */
  updateByInitialStateId?: InputMaybe<Array<SharedLinkOnSharedLinkForSharedLinksProjectIdFkeyUsingSharedLinksInitialStateIdKeyUpdate>>;
  /** The primary key(s) and patch data for `sharedLink` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnSharedLinkForSharedLinksProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type SharedLinksProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sharedLink` to be created by this mutation. */
export type SharedLinksProjectIdFkeySharedLinksCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  initialState?: InputMaybe<SharedLinksInitialStateIdFkeyInput>;
  initialStateId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  project?: InputMaybe<SharedLinksProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type Sheet = Node & {
  __typename?: 'Sheet';
  createdAt: Scalars['Datetime'];
  filename: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `Sheet`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `SheetPageCalibration`. */
  sheetPageCalibrations: Array<SheetPageCalibration>;
  /** Reads and enables pagination through a set of `SheetPageCalibration`. */
  sheetPageCalibrationsConnection: SheetPageCalibrationsConnection;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapes: Array<SheetShape>;
  /** Reads and enables pagination through a set of `SheetShape`. */
  sheetShapesConnection: SheetShapesConnection;
  updatedAt: Scalars['Datetime'];
  version: Scalars['Int'];
};


export type SheetSheetPageCalibrationsArgs = {
  condition?: InputMaybe<SheetPageCalibrationCondition>;
  filter?: InputMaybe<SheetPageCalibrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};


export type SheetSheetPageCalibrationsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetPageCalibrationCondition>;
  filter?: InputMaybe<SheetPageCalibrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};


export type SheetSheetShapesArgs = {
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};


export type SheetSheetShapesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SheetShapeCondition>;
  filter?: InputMaybe<SheetShapeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};

/** A condition to be used against `Sheet` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SheetCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Sheet` object types. All fields are combined with a logical ‘and.’ */
export type SheetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Sheet` */
export type SheetInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheet` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheet` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetOnSheetForSheetsProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `sheet` to look up the row to update. */
export type SheetOnSheetForSheetsProjectIdFkeyUsingSheetsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: UpdateSheetOnSheetForSheetsProjectIdFkeyPatch;
};

/** The fields on `sheet` to look up the row to update. */
export type SheetOnSheetForSheetsProjectIdFkeyUsingSheetsProjectIdNameVersionKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: UpdateSheetOnSheetForSheetsProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetPageCalibration` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetPageCalibration` being updated. */
  patch: SheetPageCalibrationPatch;
};

/** The fields on `sheet` to look up the row to update. */
export type SheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyUsingSheetsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: UpdateSheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyPatch;
};

/** The fields on `sheet` to look up the row to update. */
export type SheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyUsingSheetsProjectIdNameVersionKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: UpdateSheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyPatch;
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetOnSheetShapeForSheetShapesSheetIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `sheet` to look up the row to update. */
export type SheetOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: UpdateSheetOnSheetShapeForSheetShapesSheetIdFkeyPatch;
};

/** The fields on `sheet` to look up the row to update. */
export type SheetOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetsProjectIdNameVersionKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: UpdateSheetOnSheetShapeForSheetShapesSheetIdFkeyPatch;
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

export type SheetPageCalibration = Node & {
  __typename?: 'SheetPageCalibration';
  calibration: SheetScaleType;
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  pageNumber: Scalars['Int'];
  /** Reads a single `Sheet` that is related to this `SheetPageCalibration`. */
  sheet?: Maybe<Sheet>;
  sheetId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SheetPageCalibration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SheetPageCalibrationCondition = {
  /** Checks for equality with the object’s `calibration` field. */
  calibration?: InputMaybe<SheetScaleTypeInput>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sheetId` field. */
  sheetId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SheetPageCalibration` object types. All fields are combined with a logical ‘and.’ */
export type SheetPageCalibrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetPageCalibrationFilter>>;
  /** Filter by the object’s `calibration` field. */
  calibration?: InputMaybe<SheetScaleTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetPageCalibrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetPageCalibrationFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sheetId` field. */
  sheetId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SheetPageCalibration` */
export type SheetPageCalibrationInput = {
  calibration: SheetScaleTypeInput;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  pageNumber: Scalars['Int'];
  sheet?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetPageCalibrationNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetPageCalibration` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetPageCalibrationNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetPageCalibration` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetPageCalibrationOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheet` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: SheetPatch;
};

/** The fields on `sheetPageCalibration` to look up the row to update. */
export type SheetPageCalibrationOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyUsingSheetPageCalibrationsPkeyUpdate = {
  pageNumber: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetPageCalibration` being updated. */
  patch: UpdateSheetPageCalibrationOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyPatch;
  sheetId: Scalars['UUID'];
};

/** Represents an update to a `SheetPageCalibration`. Fields that are set will be updated. */
export type SheetPageCalibrationPatch = {
  calibration?: InputMaybe<SheetScaleTypeInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sheet?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sheetPageCalibration` to look up the row to connect. */
export type SheetPageCalibrationSheetPageCalibrationsPkeyConnect = {
  pageNumber: Scalars['Int'];
  sheetId: Scalars['UUID'];
};

/** The fields on `sheetPageCalibration` to look up the row to delete. */
export type SheetPageCalibrationSheetPageCalibrationsPkeyDelete = {
  pageNumber: Scalars['Int'];
  sheetId: Scalars['UUID'];
};

/** A connection to a list of `SheetPageCalibration` values. */
export type SheetPageCalibrationsConnection = {
  __typename?: 'SheetPageCalibrationsConnection';
  /** A list of edges which contains the `SheetPageCalibration` and cursor to aid in pagination. */
  edges: Array<SheetPageCalibrationsEdge>;
  /** A list of `SheetPageCalibration` objects. */
  nodes: Array<SheetPageCalibration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetPageCalibration` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetPageCalibration` edge in the connection. */
export type SheetPageCalibrationsEdge = {
  __typename?: 'SheetPageCalibrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetPageCalibration` at the end of the edge. */
  node: SheetPageCalibration;
};

/** Methods to use when ordering `SheetPageCalibration`. */
export enum SheetPageCalibrationsOrderBy {
  CalibrationAsc = 'CALIBRATION_ASC',
  CalibrationDesc = 'CALIBRATION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PageNumberAsc = 'PAGE_NUMBER_ASC',
  PageNumberDesc = 'PAGE_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SheetIdAsc = 'SHEET_ID_ASC',
  SheetIdDesc = 'SHEET_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `sheet` in the `SheetPageCalibrationInput` mutation. */
export type SheetPageCalibrationsSheetIdFkeyInput = {
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectById?: InputMaybe<SheetSheetsPkeyConnect>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetNodeIdConnect>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectByProjectIdAndNameAndVersion?: InputMaybe<SheetSheetsProjectIdNameVersionKeyConnect>;
  /** A `SheetInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetPageCalibrationsSheetIdFkeySheetsCreateInput>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetSheetsPkeyDelete>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetNodeIdDelete>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteByProjectIdAndNameAndVersion?: InputMaybe<SheetSheetsProjectIdNameVersionKeyDelete>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateById?: InputMaybe<SheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyUsingSheetsPkeyUpdate>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetPageCalibrationOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateByProjectIdAndNameAndVersion?: InputMaybe<SheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyUsingSheetsProjectIdNameVersionKeyUpdate>;
};

/** Input for the nested mutation of `sheetPageCalibration` in the `SheetInput` mutation. */
export type SheetPageCalibrationsSheetIdFkeyInverseInput = {
  /** The primary key(s) for `sheetPageCalibration` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetPageCalibrationNodeIdConnect>>;
  /** The primary key(s) for `sheetPageCalibration` for the far side of the relationship. */
  connectBySheetIdAndPageNumber?: InputMaybe<Array<SheetPageCalibrationSheetPageCalibrationsPkeyConnect>>;
  /** A `SheetPageCalibrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetPageCalibrationsSheetIdFkeySheetPageCalibrationsCreateInput>>;
  /** The primary key(s) for `sheetPageCalibration` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetPageCalibrationNodeIdDelete>>;
  /** The primary key(s) for `sheetPageCalibration` for the far side of the relationship. */
  deleteBySheetIdAndPageNumber?: InputMaybe<Array<SheetPageCalibrationSheetPageCalibrationsPkeyDelete>>;
  /** Flag indicating whether all other `sheetPageCalibration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetPageCalibration` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<SheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheetPageCalibration` for the far side of the relationship. */
  updateBySheetIdAndPageNumber?: InputMaybe<Array<SheetPageCalibrationOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyUsingSheetPageCalibrationsPkeyUpdate>>;
};

/** The `sheetPageCalibration` to be created by this mutation. */
export type SheetPageCalibrationsSheetIdFkeySheetPageCalibrationsCreateInput = {
  calibration: SheetScaleTypeInput;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  pageNumber: Scalars['Int'];
  sheet?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheet` to be created by this mutation. */
export type SheetPageCalibrationsSheetIdFkeySheetsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Sheet`. Fields that are set will be updated. */
export type SheetPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type SheetScaleType = {
  __typename?: 'SheetScaleType';
  destinationUnit: CalibrationUnit;
  destinationWidth: Scalars['Float'];
  pointA: Point2Type;
  pointB: Point2Type;
};

/** A filter to be used against `SheetScaleType` object types. All fields are combined with a logical ‘and.’ */
export type SheetScaleTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetScaleTypeFilter>>;
  /** Filter by the object’s `destinationUnit` field. */
  destinationUnit?: InputMaybe<CalibrationUnitFilter>;
  /** Filter by the object’s `destinationWidth` field. */
  destinationWidth?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetScaleTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetScaleTypeFilter>>;
  /** Filter by the object’s `pointA` field. */
  pointA?: InputMaybe<Point2TypeFilter>;
  /** Filter by the object’s `pointB` field. */
  pointB?: InputMaybe<Point2TypeFilter>;
};

/** An input for mutations affecting `SheetScaleType` */
export type SheetScaleTypeInput = {
  destinationUnit: CalibrationUnit;
  destinationWidth: Scalars['Float'];
  pointA: Point2TypeInput;
  pointB: Point2TypeInput;
};

export type SheetShape = Node & {
  __typename?: 'SheetShape';
  /** Reads a single `AutoShape` that is related to this `SheetShape`. */
  autoShape?: Maybe<AutoShape>;
  autoShapeId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  dbId: Scalars['Int'];
  folder?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `SheetShape`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  /** Reads a single `ShapeFolder` that is related to this `SheetShape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
  /** Reads a single `Sheet` that is related to this `SheetShape`. */
  sheet?: Maybe<Sheet>;
  sheetId: Scalars['UUID'];
  sheetPageNumber: Scalars['Int'];
  /** Reads a single `SheetShapeLegend` that is related to this `SheetShape`. */
  sheetShapeLegend?: Maybe<SheetShapeLegend>;
  /** Reads a single `SheetShapeLine` that is related to this `SheetShape`. */
  sheetShapeLine?: Maybe<SheetShapeLine>;
  /** Reads a single `SheetShapePoint` that is related to this `SheetShape`. */
  sheetShapePoint?: Maybe<SheetShapePoint>;
  /** Reads a single `SheetShapePolygon` that is related to this `SheetShape`. */
  sheetShapePolygon?: Maybe<SheetShapePolygon>;
  /** Reads a single `SheetShapeSplitLine` that is related to this `SheetShape`. */
  sheetShapeSplitLine?: Maybe<SheetShapeSplitLine>;
  updatedAt: Scalars['Datetime'];
  urn: Scalars['String'];
};

/**
 * A condition to be used against `SheetShape` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SheetShapeCondition = {
  /** Checks for equality with the object’s `autoShapeId` field. */
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dbId` field. */
  dbId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `folder` field. */
  folder?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sheetId` field. */
  sheetId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sheetPageNumber` field. */
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `urn` field. */
  urn?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SheetShape` object types. All fields are combined with a logical ‘and.’ */
export type SheetShapeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetShapeFilter>>;
  /** Filter by the object’s `autoShapeId` field. */
  autoShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dbId` field. */
  dbId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `folder` field. */
  folder?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetShapeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetShapeFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sheetId` field. */
  sheetId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sheetPageNumber` field. */
  sheetPageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `urn` field. */
  urn?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SheetShape` */
export type SheetShapeInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

export type SheetShapeLegend = Node & {
  __typename?: 'SheetShapeLegend';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** Reads a single `Order` that is related to this `SheetShapeLegend`. */
  legendOrder?: Maybe<Order>;
  legendOrderId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  position: Point2Type;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLegend`. */
  sheetShape?: Maybe<SheetShape>;
  sheetShapeId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SheetShapeLegend` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SheetShapeLegendCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `legendOrderId` field. */
  legendOrderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Point2TypeInput>;
  /** Checks for equality with the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SheetShapeLegend` object types. All fields are combined with a logical ‘and.’ */
export type SheetShapeLegendFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetShapeLegendFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `legendOrderId` field. */
  legendOrderId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetShapeLegendFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetShapeLegendFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<Point2TypeFilter>;
  /** Filter by the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SheetShapeLegend` */
export type SheetShapeLegendInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  legendOrderId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInput>;
  position: Point2TypeInput;
  sheetShape?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetShapeLegendNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetShapeLegend` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetShapeLegendNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetShapeLegend` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `order` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `order` being updated. */
  patch: OrderPatch;
};

/** The fields on `sheetShapeLegend` to look up the row to update. */
export type SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyUsingSheetShapeLegendsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
  patch: UpdateSheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyPatch;
};

/** The fields on `sheetShapeLegend` to look up the row to update. */
export type SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyUsingSheetShapeLegendsSheetShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
  patch: UpdateSheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyPatch;
  sheetShapeId: Scalars['UUID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `sheetShapeLegend` to look up the row to update. */
export type SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapeLegendsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
  patch: UpdateSheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShapeLegend` to look up the row to update. */
export type SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapeLegendsSheetShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
  patch: UpdateSheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyPatch;
  sheetShapeId: Scalars['UUID'];
};

/** Represents an update to a `SheetShapeLegend`. Fields that are set will be updated. */
export type SheetShapeLegendPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  legendOrderId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInput>;
  position?: InputMaybe<Point2TypeInput>;
  sheetShape?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sheetShapeLegend` to look up the row to connect. */
export type SheetShapeLegendSheetShapeLegendsPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapeLegend` to look up the row to delete. */
export type SheetShapeLegendSheetShapeLegendsPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapeLegend` to look up the row to connect. */
export type SheetShapeLegendSheetShapeLegendsSheetShapeIdKeyConnect = {
  sheetShapeId: Scalars['UUID'];
};

/** The fields on `sheetShapeLegend` to look up the row to delete. */
export type SheetShapeLegendSheetShapeLegendsSheetShapeIdKeyDelete = {
  sheetShapeId: Scalars['UUID'];
};

/** A connection to a list of `SheetShapeLegend` values. */
export type SheetShapeLegendsConnection = {
  __typename?: 'SheetShapeLegendsConnection';
  /** A list of edges which contains the `SheetShapeLegend` and cursor to aid in pagination. */
  edges: Array<SheetShapeLegendsEdge>;
  /** A list of `SheetShapeLegend` objects. */
  nodes: Array<SheetShapeLegend>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetShapeLegend` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetShapeLegend` edge in the connection. */
export type SheetShapeLegendsEdge = {
  __typename?: 'SheetShapeLegendsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetShapeLegend` at the end of the edge. */
  node: SheetShapeLegend;
};

/** Input for the nested mutation of `order` in the `SheetShapeLegendInput` mutation. */
export type SheetShapeLegendsLegendOrderIdFkeyInput = {
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectById?: InputMaybe<OrderOrdersPkeyConnect>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrderNodeIdConnect>;
  /** A `OrderInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyOrdersCreateInput>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteById?: InputMaybe<OrderOrdersPkeyDelete>;
  /** The primary key(s) for `order` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OrderNodeIdDelete>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateById?: InputMaybe<OrderOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyUsingOrdersPkeyUpdate>;
  /** The primary key(s) and patch data for `order` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sheetShapeLegend` in the `OrderInput` mutation. */
export type SheetShapeLegendsLegendOrderIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SheetShapeLegendSheetShapeLegendsPkeyConnect>>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetShapeLegendNodeIdConnect>>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  connectBySheetShapeId?: InputMaybe<Array<SheetShapeLegendSheetShapeLegendsSheetShapeIdKeyConnect>>;
  /** A `SheetShapeLegendInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapeLegendsLegendOrderIdFkeySheetShapeLegendsCreateInput>>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SheetShapeLegendSheetShapeLegendsPkeyDelete>>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetShapeLegendNodeIdDelete>>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  deleteBySheetShapeId?: InputMaybe<Array<SheetShapeLegendSheetShapeLegendsSheetShapeIdKeyDelete>>;
  /** Flag indicating whether all other `sheetShapeLegend` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShapeLegend` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyUsingSheetShapeLegendsPkeyUpdate>>;
  /** The primary key(s) and patch data for `sheetShapeLegend` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrderOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheetShapeLegend` for the far side of the relationship. */
  updateBySheetShapeId?: InputMaybe<Array<SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyUsingSheetShapeLegendsSheetShapeIdKeyUpdate>>;
};

/** The `order` to be created by this mutation. */
export type SheetShapeLegendsLegendOrderIdFkeyOrdersCreateInput = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShapeLegend` to be created by this mutation. */
export type SheetShapeLegendsLegendOrderIdFkeySheetShapeLegendsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  legendOrderId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInput>;
  position: Point2TypeInput;
  sheetShape?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Methods to use when ordering `SheetShapeLegend`. */
export enum SheetShapeLegendsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LegendOrderIdAsc = 'LEGEND_ORDER_ID_ASC',
  LegendOrderIdDesc = 'LEGEND_ORDER_ID_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SheetShapeIdAsc = 'SHEET_SHAPE_ID_ASC',
  SheetShapeIdDesc = 'SHEET_SHAPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `sheetShape` in the `SheetShapeLegendInput` mutation. */
export type SheetShapeLegendsSheetShapeIdFkeyInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeSheetShapesPkeyConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeNodeIdConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbConnect>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeySheetShapesCreateInput>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeSheetShapesPkeyDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeNodeIdDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<SheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `sheetShapeLegend` in the `SheetShapeInput` mutation. */
export type SheetShapeLegendsSheetShapeIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeLegendSheetShapeLegendsPkeyConnect>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeLegendNodeIdConnect>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  connectBySheetShapeId?: InputMaybe<SheetShapeLegendSheetShapeLegendsSheetShapeIdKeyConnect>;
  /** A `SheetShapeLegendInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapeLegendsSheetShapeIdFkeySheetShapeLegendsCreateInput>>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeLegendSheetShapeLegendsPkeyDelete>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeLegendNodeIdDelete>;
  /** The primary key(s) for `sheetShapeLegend` for the far side of the relationship. */
  deleteBySheetShapeId?: InputMaybe<SheetShapeLegendSheetShapeLegendsSheetShapeIdKeyDelete>;
  /** Flag indicating whether all other `sheetShapeLegend` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShapeLegend` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapeLegendsPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShapeLegend` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShapeLegend` for the far side of the relationship. */
  updateBySheetShapeId?: InputMaybe<SheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapeLegendsSheetShapeIdKeyUpdate>;
};

/** The `sheetShapeLegend` to be created by this mutation. */
export type SheetShapeLegendsSheetShapeIdFkeySheetShapeLegendsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  legendOrderId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInput>;
  position: Point2TypeInput;
  sheetShape?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapeLegendsSheetShapeIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

export type SheetShapeLine = Node & {
  __typename?: 'SheetShapeLine';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  points: Array<Point2Type>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLine`. */
  sheetShape?: Maybe<SheetShape>;
  sheetShapeId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SheetShapeLine` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SheetShapeLineCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `points` field. */
  points?: InputMaybe<Array<InputMaybe<Point2TypeInput>>>;
  /** Checks for equality with the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SheetShapeLine` object types. All fields are combined with a logical ‘and.’ */
export type SheetShapeLineFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetShapeLineFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetShapeLineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetShapeLineFilter>>;
  /** Filter by the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SheetShapeLine` */
export type SheetShapeLineInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points: Array<InputMaybe<Point2TypeInput>>;
  sheetShape?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetShapeLineNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetShapeLine` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetShapeLineNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetShapeLine` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `sheetShapeLine` to look up the row to update. */
export type SheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapeLinesPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShapeLine` being updated. */
  patch: UpdateSheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShapeLine` to look up the row to update. */
export type SheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapeLinesSheetShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `sheetShapeLine` being updated. */
  patch: UpdateSheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyPatch;
  sheetShapeId: Scalars['UUID'];
};

/** Represents an update to a `SheetShapeLine`. Fields that are set will be updated. */
export type SheetShapeLinePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points?: InputMaybe<Array<InputMaybe<Point2TypeInput>>>;
  sheetShape?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sheetShapeLine` to look up the row to connect. */
export type SheetShapeLineSheetShapeLinesPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapeLine` to look up the row to delete. */
export type SheetShapeLineSheetShapeLinesPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapeLine` to look up the row to connect. */
export type SheetShapeLineSheetShapeLinesSheetShapeIdKeyConnect = {
  sheetShapeId: Scalars['UUID'];
};

/** The fields on `sheetShapeLine` to look up the row to delete. */
export type SheetShapeLineSheetShapeLinesSheetShapeIdKeyDelete = {
  sheetShapeId: Scalars['UUID'];
};

/** A connection to a list of `SheetShapeLine` values. */
export type SheetShapeLinesConnection = {
  __typename?: 'SheetShapeLinesConnection';
  /** A list of edges which contains the `SheetShapeLine` and cursor to aid in pagination. */
  edges: Array<SheetShapeLinesEdge>;
  /** A list of `SheetShapeLine` objects. */
  nodes: Array<SheetShapeLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetShapeLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetShapeLine` edge in the connection. */
export type SheetShapeLinesEdge = {
  __typename?: 'SheetShapeLinesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetShapeLine` at the end of the edge. */
  node: SheetShapeLine;
};

/** Methods to use when ordering `SheetShapeLine`. */
export enum SheetShapeLinesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointsAsc = 'POINTS_ASC',
  PointsDesc = 'POINTS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SheetShapeIdAsc = 'SHEET_SHAPE_ID_ASC',
  SheetShapeIdDesc = 'SHEET_SHAPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `sheetShape` in the `SheetShapeLineInput` mutation. */
export type SheetShapeLinesSheetShapeIdFkeyInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeSheetShapesPkeyConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeNodeIdConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbConnect>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapeLinesSheetShapeIdFkeySheetShapesCreateInput>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeSheetShapesPkeyDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeNodeIdDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<SheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `sheetShapeLine` in the `SheetShapeInput` mutation. */
export type SheetShapeLinesSheetShapeIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShapeLine` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeLineSheetShapeLinesPkeyConnect>;
  /** The primary key(s) for `sheetShapeLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeLineNodeIdConnect>;
  /** The primary key(s) for `sheetShapeLine` for the far side of the relationship. */
  connectBySheetShapeId?: InputMaybe<SheetShapeLineSheetShapeLinesSheetShapeIdKeyConnect>;
  /** A `SheetShapeLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapeLinesSheetShapeIdFkeySheetShapeLinesCreateInput>>;
  /** The primary key(s) for `sheetShapeLine` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeLineSheetShapeLinesPkeyDelete>;
  /** The primary key(s) for `sheetShapeLine` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeLineNodeIdDelete>;
  /** The primary key(s) for `sheetShapeLine` for the far side of the relationship. */
  deleteBySheetShapeId?: InputMaybe<SheetShapeLineSheetShapeLinesSheetShapeIdKeyDelete>;
  /** Flag indicating whether all other `sheetShapeLine` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShapeLine` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapeLinesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShapeLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShapeLine` for the far side of the relationship. */
  updateBySheetShapeId?: InputMaybe<SheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapeLinesSheetShapeIdKeyUpdate>;
};

/** The `sheetShapeLine` to be created by this mutation. */
export type SheetShapeLinesSheetShapeIdFkeySheetShapeLinesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points: Array<InputMaybe<Point2TypeInput>>;
  sheetShape?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapeLinesSheetShapeIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetShapeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetShapeNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `autoShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `autoShape` being updated. */
  patch: AutoShapePatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesFolderFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `shapeFolder` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `shapeFolder` being updated. */
  patch: ShapeFolderPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesFolderFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesFolderFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesFolderFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesFolderFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesProjectIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesProjectIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesProjectIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesProjectIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesSheetIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheet` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheet` being updated. */
  patch: SheetPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesSheetIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeForSheetShapesSheetIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShapeLegend` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
  patch: SheetShapeLegendPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShapeLine` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShapeLine` being updated. */
  patch: SheetShapeLinePatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShapePoint` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShapePoint` being updated. */
  patch: SheetShapePointPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShapePolygon` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShapePolygon` being updated. */
  patch: SheetShapePolygonPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShapeSplitLine` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShapeSplitLine` being updated. */
  patch: SheetShapeSplitLinePatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShape` to look up the row to update. */
export type SheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate = {
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: UpdateSheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyPatch;
  urn: Scalars['String'];
};

/** Represents an update to a `SheetShape`. Fields that are set will be updated. */
export type SheetShapePatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

export type SheetShapePoint = Node & {
  __typename?: 'SheetShapePoint';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  point: Point2Type;
  /** Reads a single `SheetShape` that is related to this `SheetShapePoint`. */
  sheetShape?: Maybe<SheetShape>;
  sheetShapeId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SheetShapePoint` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SheetShapePointCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `point` field. */
  point?: InputMaybe<Point2TypeInput>;
  /** Checks for equality with the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SheetShapePoint` object types. All fields are combined with a logical ‘and.’ */
export type SheetShapePointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetShapePointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetShapePointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetShapePointFilter>>;
  /** Filter by the object’s `point` field. */
  point?: InputMaybe<Point2TypeFilter>;
  /** Filter by the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SheetShapePoint` */
export type SheetShapePointInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point: Point2TypeInput;
  sheetShape?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetShapePointNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetShapePoint` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetShapePointNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetShapePoint` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `sheetShapePoint` to look up the row to update. */
export type SheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapePointsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShapePoint` being updated. */
  patch: UpdateSheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShapePoint` to look up the row to update. */
export type SheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapePointsSheetShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `sheetShapePoint` being updated. */
  patch: UpdateSheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyPatch;
  sheetShapeId: Scalars['UUID'];
};

/** Represents an update to a `SheetShapePoint`. Fields that are set will be updated. */
export type SheetShapePointPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point?: InputMaybe<Point2TypeInput>;
  sheetShape?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sheetShapePoint` to look up the row to connect. */
export type SheetShapePointSheetShapePointsPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapePoint` to look up the row to delete. */
export type SheetShapePointSheetShapePointsPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapePoint` to look up the row to connect. */
export type SheetShapePointSheetShapePointsSheetShapeIdKeyConnect = {
  sheetShapeId: Scalars['UUID'];
};

/** The fields on `sheetShapePoint` to look up the row to delete. */
export type SheetShapePointSheetShapePointsSheetShapeIdKeyDelete = {
  sheetShapeId: Scalars['UUID'];
};

/** A connection to a list of `SheetShapePoint` values. */
export type SheetShapePointsConnection = {
  __typename?: 'SheetShapePointsConnection';
  /** A list of edges which contains the `SheetShapePoint` and cursor to aid in pagination. */
  edges: Array<SheetShapePointsEdge>;
  /** A list of `SheetShapePoint` objects. */
  nodes: Array<SheetShapePoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetShapePoint` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetShapePoint` edge in the connection. */
export type SheetShapePointsEdge = {
  __typename?: 'SheetShapePointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetShapePoint` at the end of the edge. */
  node: SheetShapePoint;
};

/** Methods to use when ordering `SheetShapePoint`. */
export enum SheetShapePointsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointAsc = 'POINT_ASC',
  PointDesc = 'POINT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SheetShapeIdAsc = 'SHEET_SHAPE_ID_ASC',
  SheetShapeIdDesc = 'SHEET_SHAPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `sheetShape` in the `SheetShapePointInput` mutation. */
export type SheetShapePointsSheetShapeIdFkeyInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeSheetShapesPkeyConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeNodeIdConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbConnect>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapePointsSheetShapeIdFkeySheetShapesCreateInput>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeSheetShapesPkeyDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeNodeIdDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<SheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `sheetShapePoint` in the `SheetShapeInput` mutation. */
export type SheetShapePointsSheetShapeIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShapePoint` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapePointSheetShapePointsPkeyConnect>;
  /** The primary key(s) for `sheetShapePoint` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapePointNodeIdConnect>;
  /** The primary key(s) for `sheetShapePoint` for the far side of the relationship. */
  connectBySheetShapeId?: InputMaybe<SheetShapePointSheetShapePointsSheetShapeIdKeyConnect>;
  /** A `SheetShapePointInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapePointsSheetShapeIdFkeySheetShapePointsCreateInput>>;
  /** The primary key(s) for `sheetShapePoint` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapePointSheetShapePointsPkeyDelete>;
  /** The primary key(s) for `sheetShapePoint` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapePointNodeIdDelete>;
  /** The primary key(s) for `sheetShapePoint` for the far side of the relationship. */
  deleteBySheetShapeId?: InputMaybe<SheetShapePointSheetShapePointsSheetShapeIdKeyDelete>;
  /** Flag indicating whether all other `sheetShapePoint` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShapePoint` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapePointsPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShapePoint` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShapePoint` for the far side of the relationship. */
  updateBySheetShapeId?: InputMaybe<SheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyUsingSheetShapePointsSheetShapeIdKeyUpdate>;
};

/** The `sheetShapePoint` to be created by this mutation. */
export type SheetShapePointsSheetShapeIdFkeySheetShapePointsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point: Point2TypeInput;
  sheetShape?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapePointsSheetShapeIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

export type SheetShapePolygon = Node & {
  __typename?: 'SheetShapePolygon';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  multipolygon: MultiPolygon2Type;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `SheetShape` that is related to this `SheetShapePolygon`. */
  sheetShape?: Maybe<SheetShape>;
  sheetShapeId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SheetShapePolygon` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SheetShapePolygonCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `multipolygon` field. */
  multipolygon?: InputMaybe<MultiPolygon2TypeInput>;
  /** Checks for equality with the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SheetShapePolygon` object types. All fields are combined with a logical ‘and.’ */
export type SheetShapePolygonFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetShapePolygonFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetShapePolygonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetShapePolygonFilter>>;
  /** Filter by the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SheetShapePolygon` */
export type SheetShapePolygonInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon: MultiPolygon2TypeInput;
  sheetShape?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetShapePolygonNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetShapePolygon` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetShapePolygonNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetShapePolygon` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `sheetShapePolygon` to look up the row to update. */
export type SheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapePolygonsPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShapePolygon` being updated. */
  patch: UpdateSheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShapePolygon` to look up the row to update. */
export type SheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapePolygonsSheetShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `sheetShapePolygon` being updated. */
  patch: UpdateSheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyPatch;
  sheetShapeId: Scalars['UUID'];
};

/** Represents an update to a `SheetShapePolygon`. Fields that are set will be updated. */
export type SheetShapePolygonPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon?: InputMaybe<MultiPolygon2TypeInput>;
  sheetShape?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sheetShapePolygon` to look up the row to connect. */
export type SheetShapePolygonSheetShapePolygonsPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapePolygon` to look up the row to delete. */
export type SheetShapePolygonSheetShapePolygonsPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapePolygon` to look up the row to connect. */
export type SheetShapePolygonSheetShapePolygonsSheetShapeIdKeyConnect = {
  sheetShapeId: Scalars['UUID'];
};

/** The fields on `sheetShapePolygon` to look up the row to delete. */
export type SheetShapePolygonSheetShapePolygonsSheetShapeIdKeyDelete = {
  sheetShapeId: Scalars['UUID'];
};

/** A connection to a list of `SheetShapePolygon` values. */
export type SheetShapePolygonsConnection = {
  __typename?: 'SheetShapePolygonsConnection';
  /** A list of edges which contains the `SheetShapePolygon` and cursor to aid in pagination. */
  edges: Array<SheetShapePolygonsEdge>;
  /** A list of `SheetShapePolygon` objects. */
  nodes: Array<SheetShapePolygon>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetShapePolygon` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetShapePolygon` edge in the connection. */
export type SheetShapePolygonsEdge = {
  __typename?: 'SheetShapePolygonsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetShapePolygon` at the end of the edge. */
  node: SheetShapePolygon;
};

/** Methods to use when ordering `SheetShapePolygon`. */
export enum SheetShapePolygonsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MultipolygonAsc = 'MULTIPOLYGON_ASC',
  MultipolygonDesc = 'MULTIPOLYGON_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SheetShapeIdAsc = 'SHEET_SHAPE_ID_ASC',
  SheetShapeIdDesc = 'SHEET_SHAPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `sheetShape` in the `SheetShapePolygonInput` mutation. */
export type SheetShapePolygonsSheetShapeIdFkeyInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeSheetShapesPkeyConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeNodeIdConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbConnect>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeySheetShapesCreateInput>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeSheetShapesPkeyDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeNodeIdDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<SheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `sheetShapePolygon` in the `SheetShapeInput` mutation. */
export type SheetShapePolygonsSheetShapeIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShapePolygon` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapePolygonSheetShapePolygonsPkeyConnect>;
  /** The primary key(s) for `sheetShapePolygon` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapePolygonNodeIdConnect>;
  /** The primary key(s) for `sheetShapePolygon` for the far side of the relationship. */
  connectBySheetShapeId?: InputMaybe<SheetShapePolygonSheetShapePolygonsSheetShapeIdKeyConnect>;
  /** A `SheetShapePolygonInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapePolygonsSheetShapeIdFkeySheetShapePolygonsCreateInput>>;
  /** The primary key(s) for `sheetShapePolygon` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapePolygonSheetShapePolygonsPkeyDelete>;
  /** The primary key(s) for `sheetShapePolygon` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapePolygonNodeIdDelete>;
  /** The primary key(s) for `sheetShapePolygon` for the far side of the relationship. */
  deleteBySheetShapeId?: InputMaybe<SheetShapePolygonSheetShapePolygonsSheetShapeIdKeyDelete>;
  /** Flag indicating whether all other `sheetShapePolygon` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShapePolygon` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapePolygonsPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShapePolygon` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShapePolygon` for the far side of the relationship. */
  updateBySheetShapeId?: InputMaybe<SheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyUsingSheetShapePolygonsSheetShapeIdKeyUpdate>;
};

/** The `sheetShapePolygon` to be created by this mutation. */
export type SheetShapePolygonsSheetShapeIdFkeySheetShapePolygonsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon: MultiPolygon2TypeInput;
  sheetShape?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapePolygonsSheetShapeIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** The fields on `sheetShape` to look up the row to connect. */
export type SheetShapeSheetShapesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `sheetShape` to look up the row to delete. */
export type SheetShapeSheetShapesPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `sheetShape` to look up the row to connect. */
export type SheetShapeSheetShapesUniqueProjectIdDbConnect = {
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};

/** The fields on `sheetShape` to look up the row to delete. */
export type SheetShapeSheetShapesUniqueProjectIdDbDelete = {
  dbId: Scalars['Int'];
  urn: Scalars['String'];
};

export type SheetShapeSplitLine = Node & {
  __typename?: 'SheetShapeSplitLine';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  points: Array<Point2Type>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeSplitLine`. */
  sheetShape?: Maybe<SheetShape>;
  sheetShapeId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SheetShapeSplitLine` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SheetShapeSplitLineCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `points` field. */
  points?: InputMaybe<Array<InputMaybe<Point2TypeInput>>>;
  /** Checks for equality with the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SheetShapeSplitLine` object types. All fields are combined with a logical ‘and.’ */
export type SheetShapeSplitLineFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SheetShapeSplitLineFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SheetShapeSplitLineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SheetShapeSplitLineFilter>>;
  /** Filter by the object’s `sheetShapeId` field. */
  sheetShapeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SheetShapeSplitLine` */
export type SheetShapeSplitLineInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points: Array<InputMaybe<Point2TypeInput>>;
  sheetShape?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type SheetShapeSplitLineNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sheetShapeSplitLine` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SheetShapeSplitLineNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sheetShapeSplitLine` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `sheetShape` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `sheetShape` being updated. */
  patch: SheetShapePatch;
};

/** The fields on `sheetShapeSplitLine` to look up the row to update. */
export type SheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapeSplitLinesPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `sheetShapeSplitLine` being updated. */
  patch: UpdateSheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyPatch;
};

/** The fields on `sheetShapeSplitLine` to look up the row to update. */
export type SheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapeSplitLinesSheetShapeIdKeyUpdate = {
  /** An object where the defined keys will be set on the `sheetShapeSplitLine` being updated. */
  patch: UpdateSheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyPatch;
  sheetShapeId: Scalars['UUID'];
};

/** Represents an update to a `SheetShapeSplitLine`. Fields that are set will be updated. */
export type SheetShapeSplitLinePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points?: InputMaybe<Array<InputMaybe<Point2TypeInput>>>;
  sheetShape?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `sheetShapeSplitLine` to look up the row to connect. */
export type SheetShapeSplitLineSheetShapeSplitLinesPkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapeSplitLine` to look up the row to delete. */
export type SheetShapeSplitLineSheetShapeSplitLinesPkeyDelete = {
  id: Scalars['Int'];
};

/** The fields on `sheetShapeSplitLine` to look up the row to connect. */
export type SheetShapeSplitLineSheetShapeSplitLinesSheetShapeIdKeyConnect = {
  sheetShapeId: Scalars['UUID'];
};

/** The fields on `sheetShapeSplitLine` to look up the row to delete. */
export type SheetShapeSplitLineSheetShapeSplitLinesSheetShapeIdKeyDelete = {
  sheetShapeId: Scalars['UUID'];
};

/** A connection to a list of `SheetShapeSplitLine` values. */
export type SheetShapeSplitLinesConnection = {
  __typename?: 'SheetShapeSplitLinesConnection';
  /** A list of edges which contains the `SheetShapeSplitLine` and cursor to aid in pagination. */
  edges: Array<SheetShapeSplitLinesEdge>;
  /** A list of `SheetShapeSplitLine` objects. */
  nodes: Array<SheetShapeSplitLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetShapeSplitLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetShapeSplitLine` edge in the connection. */
export type SheetShapeSplitLinesEdge = {
  __typename?: 'SheetShapeSplitLinesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetShapeSplitLine` at the end of the edge. */
  node: SheetShapeSplitLine;
};

/** Methods to use when ordering `SheetShapeSplitLine`. */
export enum SheetShapeSplitLinesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PointsAsc = 'POINTS_ASC',
  PointsDesc = 'POINTS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SheetShapeIdAsc = 'SHEET_SHAPE_ID_ASC',
  SheetShapeIdDesc = 'SHEET_SHAPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Input for the nested mutation of `sheetShape` in the `SheetShapeSplitLineInput` mutation. */
export type SheetShapeSplitLinesSheetShapeIdFkeyInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeSheetShapesPkeyConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeNodeIdConnect>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbConnect>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeySheetShapesCreateInput>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeSheetShapesPkeyDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeNodeIdDelete>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<SheetShapeSheetShapesUniqueProjectIdDbDelete>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<SheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>;
};

/** Input for the nested mutation of `sheetShapeSplitLine` in the `SheetShapeInput` mutation. */
export type SheetShapeSplitLinesSheetShapeIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShapeSplitLine` for the far side of the relationship. */
  connectById?: InputMaybe<SheetShapeSplitLineSheetShapeSplitLinesPkeyConnect>;
  /** The primary key(s) for `sheetShapeSplitLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetShapeSplitLineNodeIdConnect>;
  /** The primary key(s) for `sheetShapeSplitLine` for the far side of the relationship. */
  connectBySheetShapeId?: InputMaybe<SheetShapeSplitLineSheetShapeSplitLinesSheetShapeIdKeyConnect>;
  /** A `SheetShapeSplitLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapeSplitLinesSheetShapeIdFkeySheetShapeSplitLinesCreateInput>>;
  /** The primary key(s) for `sheetShapeSplitLine` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetShapeSplitLineSheetShapeSplitLinesPkeyDelete>;
  /** The primary key(s) for `sheetShapeSplitLine` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetShapeSplitLineNodeIdDelete>;
  /** The primary key(s) for `sheetShapeSplitLine` for the far side of the relationship. */
  deleteBySheetShapeId?: InputMaybe<SheetShapeSplitLineSheetShapeSplitLinesSheetShapeIdKeyDelete>;
  /** Flag indicating whether all other `sheetShapeSplitLine` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShapeSplitLine` for the far side of the relationship. */
  updateById?: InputMaybe<SheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapeSplitLinesPkeyUpdate>;
  /** The primary key(s) and patch data for `sheetShapeSplitLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheetShapeSplitLine` for the far side of the relationship. */
  updateBySheetShapeId?: InputMaybe<SheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyUsingSheetShapeSplitLinesSheetShapeIdKeyUpdate>;
};

/** The `sheetShapeSplitLine` to be created by this mutation. */
export type SheetShapeSplitLinesSheetShapeIdFkeySheetShapeSplitLinesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points: Array<InputMaybe<Point2TypeInput>>;
  sheetShape?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapeSplitLinesSheetShapeIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** The `autoShape` to be created by this mutation. */
export type SheetShapesAutoShapeIdFkeyAutoShapesCreateInput = {
  algorithmInput: Scalars['JSON'];
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `autoShape` in the `SheetShapeInput` mutation. */
export type SheetShapesAutoShapeIdFkeyInput = {
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  connectById?: InputMaybe<AutoShapeAutoShapesPkeyConnect>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AutoShapeNodeIdConnect>;
  /** A `AutoShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapesAutoShapeIdFkeyAutoShapesCreateInput>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  deleteById?: InputMaybe<AutoShapeAutoShapesPkeyDelete>;
  /** The primary key(s) for `autoShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<AutoShapeNodeIdDelete>;
  /** The primary key(s) and patch data for `autoShape` for the far side of the relationship. */
  updateById?: InputMaybe<AutoShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyUsingAutoShapesPkeyUpdate>;
  /** The primary key(s) and patch data for `autoShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sheetShape` in the `AutoShapeInput` mutation. */
export type SheetShapesAutoShapeIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SheetShapeSheetShapesPkeyConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetShapeNodeIdConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbConnect>>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapesAutoShapeIdFkeySheetShapesCreateInput>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SheetShapeSheetShapesPkeyDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetShapeNodeIdDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `sheetShape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyUsingSheetShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<AutoShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapesAutoShapeIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** A connection to a list of `SheetShape` values. */
export type SheetShapesConnection = {
  __typename?: 'SheetShapesConnection';
  /** A list of edges which contains the `SheetShape` and cursor to aid in pagination. */
  edges: Array<SheetShapesEdge>;
  /** A list of `SheetShape` objects. */
  nodes: Array<SheetShape>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SheetShape` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SheetShape` edge in the connection. */
export type SheetShapesEdge = {
  __typename?: 'SheetShapesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SheetShape` at the end of the edge. */
  node: SheetShape;
};

/** Input for the nested mutation of `shapeFolder` in the `SheetShapeInput` mutation. */
export type SheetShapesFolderFkeyInput = {
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectById?: InputMaybe<ShapeFolderShapeFoldersPkeyConnect>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ShapeFolderNodeIdConnect>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  connectByProjectIdAndName?: InputMaybe<ShapeFolderShapeFoldersUniqueProjectIdNameConnect>;
  /** A `ShapeFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapesFolderFkeyShapeFoldersCreateInput>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<ShapeFolderShapeFoldersPkeyDelete>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ShapeFolderNodeIdDelete>;
  /** The primary key(s) for `shapeFolder` for the far side of the relationship. */
  deleteByProjectIdAndName?: InputMaybe<ShapeFolderShapeFoldersUniqueProjectIdNameDelete>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateById?: InputMaybe<ShapeFolderOnSheetShapeForSheetShapesFolderFkeyUsingShapeFoldersPkeyUpdate>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeForSheetShapesFolderFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `shapeFolder` for the far side of the relationship. */
  updateByProjectIdAndName?: InputMaybe<ShapeFolderOnSheetShapeForSheetShapesFolderFkeyUsingShapeFoldersUniqueProjectIdNameUpdate>;
};

/** Input for the nested mutation of `sheetShape` in the `ShapeFolderInput` mutation. */
export type SheetShapesFolderFkeyInverseInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SheetShapeSheetShapesPkeyConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetShapeNodeIdConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbConnect>>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapesFolderFkeySheetShapesCreateInput>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SheetShapeSheetShapesPkeyDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetShapeNodeIdDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `sheetShape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesFolderFkeyUsingSheetShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ShapeFolderOnSheetShapeForSheetShapesFolderFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesFolderFkeyUsingSheetShapesUniqueProjectIdDbUpdate>>;
};

/** The `shapeFolder` to be created by this mutation. */
export type SheetShapesFolderFkeyShapeFoldersCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapesFolderFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** Methods to use when ordering `SheetShape`. */
export enum SheetShapesOrderBy {
  AutoShapeIdAsc = 'AUTO_SHAPE_ID_ASC',
  AutoShapeIdDesc = 'AUTO_SHAPE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DbIdAsc = 'DB_ID_ASC',
  DbIdDesc = 'DB_ID_DESC',
  FolderAsc = 'FOLDER_ASC',
  FolderDesc = 'FOLDER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  SheetIdAsc = 'SHEET_ID_ASC',
  SheetIdDesc = 'SHEET_ID_DESC',
  SheetPageNumberAsc = 'SHEET_PAGE_NUMBER_ASC',
  SheetPageNumberDesc = 'SHEET_PAGE_NUMBER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UrnAsc = 'URN_ASC',
  UrnDesc = 'URN_DESC'
}

/** Input for the nested mutation of `project` in the `SheetShapeInput` mutation. */
export type SheetShapesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnSheetShapeForSheetShapesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeForSheetShapesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sheetShape` in the `ProjectInput` mutation. */
export type SheetShapesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SheetShapeSheetShapesPkeyConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetShapeNodeIdConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbConnect>>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapesProjectIdFkeySheetShapesCreateInput>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SheetShapeSheetShapesPkeyDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetShapeNodeIdDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `sheetShape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesProjectIdFkeyUsingSheetShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnSheetShapeForSheetShapesProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesProjectIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>>;
};

/** The `project` to be created by this mutation. */
export type SheetShapesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapesProjectIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** Input for the nested mutation of `sheet` in the `SheetShapeInput` mutation. */
export type SheetShapesSheetIdFkeyInput = {
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectById?: InputMaybe<SheetSheetsPkeyConnect>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<SheetNodeIdConnect>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectByProjectIdAndNameAndVersion?: InputMaybe<SheetSheetsProjectIdNameVersionKeyConnect>;
  /** A `SheetInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetShapesSheetIdFkeySheetsCreateInput>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteById?: InputMaybe<SheetSheetsPkeyDelete>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<SheetNodeIdDelete>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteByProjectIdAndNameAndVersion?: InputMaybe<SheetSheetsProjectIdNameVersionKeyDelete>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateById?: InputMaybe<SheetOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetsPkeyUpdate>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetShapeOnSheetShapeForSheetShapesSheetIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateByProjectIdAndNameAndVersion?: InputMaybe<SheetOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetsProjectIdNameVersionKeyUpdate>;
};

/** Input for the nested mutation of `sheetShape` in the `SheetInput` mutation. */
export type SheetShapesSheetIdFkeyInverseInput = {
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SheetShapeSheetShapesPkeyConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetShapeNodeIdConnect>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  connectByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbConnect>>;
  /** A `SheetShapeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetShapesSheetIdFkeySheetShapesCreateInput>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SheetShapeSheetShapesPkeyDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetShapeNodeIdDelete>>;
  /** The primary key(s) for `sheetShape` for the far side of the relationship. */
  deleteByUrnAndDbId?: InputMaybe<Array<SheetShapeSheetShapesUniqueProjectIdDbDelete>>;
  /** Flag indicating whether all other `sheetShape` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetShapesPkeyUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<SheetOnSheetShapeForSheetShapesSheetIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheetShape` for the far side of the relationship. */
  updateByUrnAndDbId?: InputMaybe<Array<SheetShapeOnSheetShapeForSheetShapesSheetIdFkeyUsingSheetShapesUniqueProjectIdDbUpdate>>;
};

/** The `sheetShape` to be created by this mutation. */
export type SheetShapesSheetIdFkeySheetShapesCreateInput = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber: Scalars['Int'];
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn: Scalars['String'];
};

/** The `sheet` to be created by this mutation. */
export type SheetShapesSheetIdFkeySheetsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** The fields on `sheet` to look up the row to connect. */
export type SheetSheetsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `sheet` to look up the row to delete. */
export type SheetSheetsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `sheet` to look up the row to connect. */
export type SheetSheetsProjectIdNameVersionKeyConnect = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** The fields on `sheet` to look up the row to delete. */
export type SheetSheetsProjectIdNameVersionKeyDelete = {
  name: Scalars['String'];
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** A connection to a list of `Sheet` values. */
export type SheetsConnection = {
  __typename?: 'SheetsConnection';
  /** A list of edges which contains the `Sheet` and cursor to aid in pagination. */
  edges: Array<SheetsEdge>;
  /** A list of `Sheet` objects. */
  nodes: Array<Sheet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Sheet` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Sheet` edge in the connection. */
export type SheetsEdge = {
  __typename?: 'SheetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Sheet` at the end of the edge. */
  node: Sheet;
};

/** Methods to use when ordering `Sheet`. */
export enum SheetsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FilenameAsc = 'FILENAME_ASC',
  FilenameDesc = 'FILENAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

/** Input for the nested mutation of `project` in the `SheetInput` mutation. */
export type SheetsProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<SheetsProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnSheetForSheetsProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SheetOnSheetForSheetsProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sheet` in the `ProjectInput` mutation. */
export type SheetsProjectIdFkeyInverseInput = {
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SheetSheetsPkeyConnect>>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SheetNodeIdConnect>>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  connectByProjectIdAndNameAndVersion?: InputMaybe<Array<SheetSheetsProjectIdNameVersionKeyConnect>>;
  /** A `SheetInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SheetsProjectIdFkeySheetsCreateInput>>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SheetSheetsPkeyDelete>>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SheetNodeIdDelete>>;
  /** The primary key(s) for `sheet` for the far side of the relationship. */
  deleteByProjectIdAndNameAndVersion?: InputMaybe<Array<SheetSheetsProjectIdNameVersionKeyDelete>>;
  /** Flag indicating whether all other `sheet` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SheetOnSheetForSheetsProjectIdFkeyUsingSheetsPkeyUpdate>>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnSheetForSheetsProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sheet` for the far side of the relationship. */
  updateByProjectIdAndNameAndVersion?: InputMaybe<Array<SheetOnSheetForSheetsProjectIdFkeyUsingSheetsProjectIdNameVersionKeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type SheetsProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sheet` to be created by this mutation. */
export type SheetsProjectIdFkeySheetsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `SparkelAiAnalysis` values. */
export type SparkelAiAnalysesConnection = {
  __typename?: 'SparkelAiAnalysesConnection';
  /** A list of edges which contains the `SparkelAiAnalysis` and cursor to aid in pagination. */
  edges: Array<SparkelAiAnalysesEdge>;
  /** A list of `SparkelAiAnalysis` objects. */
  nodes: Array<SparkelAiAnalysis>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SparkelAiAnalysis` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SparkelAiAnalysis` edge in the connection. */
export type SparkelAiAnalysesEdge = {
  __typename?: 'SparkelAiAnalysesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SparkelAiAnalysis` at the end of the edge. */
  node: SparkelAiAnalysis;
};

/** Methods to use when ordering `SparkelAiAnalysis`. */
export enum SparkelAiAnalysesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type SparkelAiAnalysis = Node & {
  __typename?: 'SparkelAiAnalysis';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `SparkelAiAnalysis`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['UUID']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SparkelAiAnalysis` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SparkelAiAnalysisCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SparkelAiAnalysis` object types. All fields are combined with a logical ‘and.’ */
export type SparkelAiAnalysisFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SparkelAiAnalysisFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SparkelAiAnalysisFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SparkelAiAnalysisFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SparkelAiAnalysis` */
export type SparkelAiAnalysisInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  label: Scalars['String'];
  project?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  value: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type SparkelAiAnalysisNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sparkelAiAnalysis` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SparkelAiAnalysisNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sparkelAiAnalysis` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SparkelAiAnalysisOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `sparkelAiAnalysis` to look up the row to update. */
export type SparkelAiAnalysisOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyUsingSparkelAiAnalysisPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sparkelAiAnalysis` being updated. */
  patch: UpdateSparkelAiAnalysisOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyPatch;
};

/** Represents an update to a `SparkelAiAnalysis`. Fields that are set will be updated. */
export type SparkelAiAnalysisPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  label?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `project` in the `SparkelAiAnalysisInput` mutation. */
export type SparkelAiAnalysisProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<SparkelAiAnalysisProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SparkelAiAnalysisOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sparkelAiAnalysis` in the `ProjectInput` mutation. */
export type SparkelAiAnalysisProjectIdFkeyInverseInput = {
  /** The primary key(s) for `sparkelAiAnalysis` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SparkelAiAnalysisSparkelAiAnalysisPkeyConnect>>;
  /** The primary key(s) for `sparkelAiAnalysis` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SparkelAiAnalysisNodeIdConnect>>;
  /** A `SparkelAiAnalysisInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SparkelAiAnalysisProjectIdFkeySparkelAiAnalysisCreateInput>>;
  /** The primary key(s) for `sparkelAiAnalysis` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SparkelAiAnalysisSparkelAiAnalysisPkeyDelete>>;
  /** The primary key(s) for `sparkelAiAnalysis` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SparkelAiAnalysisNodeIdDelete>>;
  /** Flag indicating whether all other `sparkelAiAnalysis` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sparkelAiAnalysis` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SparkelAiAnalysisOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyUsingSparkelAiAnalysisPkeyUpdate>>;
  /** The primary key(s) and patch data for `sparkelAiAnalysis` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyNodeIdUpdate>>;
};

/** The `project` to be created by this mutation. */
export type SparkelAiAnalysisProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sparkelAiAnalysis` to be created by this mutation. */
export type SparkelAiAnalysisProjectIdFkeySparkelAiAnalysisCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  label: Scalars['String'];
  project?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  value: Scalars['String'];
};

/** The fields on `sparkelAiAnalysis` to look up the row to connect. */
export type SparkelAiAnalysisSparkelAiAnalysisPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `sparkelAiAnalysis` to look up the row to delete. */
export type SparkelAiAnalysisSparkelAiAnalysisPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SparkelProperty` values. */
export type SparkelPropertiesConnection = {
  __typename?: 'SparkelPropertiesConnection';
  /** A list of edges which contains the `SparkelProperty` and cursor to aid in pagination. */
  edges: Array<SparkelPropertiesEdge>;
  /** A list of `SparkelProperty` objects. */
  nodes: Array<SparkelProperty>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SparkelProperty` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SparkelProperty` edge in the connection. */
export type SparkelPropertiesEdge = {
  __typename?: 'SparkelPropertiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SparkelProperty` at the end of the edge. */
  node: SparkelProperty;
};

/** Methods to use when ordering `SparkelProperty`. */
export enum SparkelPropertiesOrderBy {
  DbIdAsc = 'DB_ID_ASC',
  DbIdDesc = 'DB_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModelUrnAsc = 'MODEL_URN_ASC',
  ModelUrnDesc = 'MODEL_URN_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  PropertySetAsc = 'PROPERTY_SET_ASC',
  PropertySetDesc = 'PROPERTY_SET_DESC',
  PropertyValueAsc = 'PROPERTY_VALUE_ASC',
  PropertyValueDesc = 'PROPERTY_VALUE_DESC'
}

/** Input for the nested mutation of `project` in the `SparkelPropertyInput` mutation. */
export type SparkelPropertiesProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectsPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProjectNodeIdConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<SparkelPropertiesProjectIdFkeyProjectsCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectsPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProjectNodeIdDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnSparkelPropertyForSparkelPropertiesProjectIdFkeyUsingProjectsPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `sparkelProperty` in the `ProjectInput` mutation. */
export type SparkelPropertiesProjectIdFkeyInverseInput = {
  /** The primary key(s) for `sparkelProperty` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SparkelPropertySparkelPropertiesPkeyConnect>>;
  /** The primary key(s) for `sparkelProperty` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SparkelPropertyNodeIdConnect>>;
  /** The primary key(s) for `sparkelProperty` for the far side of the relationship. */
  connectByProjectIdAndModelUrnAndDbIdAndPropertySet?: InputMaybe<Array<SparkelPropertyUniqueProjectIdModelUrnDbIdPropertySetConnect>>;
  /** A `SparkelPropertyInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SparkelPropertiesProjectIdFkeySparkelPropertiesCreateInput>>;
  /** The primary key(s) for `sparkelProperty` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SparkelPropertySparkelPropertiesPkeyDelete>>;
  /** The primary key(s) for `sparkelProperty` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<SparkelPropertyNodeIdDelete>>;
  /** The primary key(s) for `sparkelProperty` for the far side of the relationship. */
  deleteByProjectIdAndModelUrnAndDbIdAndPropertySet?: InputMaybe<Array<SparkelPropertyUniqueProjectIdModelUrnDbIdPropertySetDelete>>;
  /** Flag indicating whether all other `sparkelProperty` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `sparkelProperty` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyUsingSparkelPropertiesPkeyUpdate>>;
  /** The primary key(s) and patch data for `sparkelProperty` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProjectOnSparkelPropertyForSparkelPropertiesProjectIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `sparkelProperty` for the far side of the relationship. */
  updateByProjectIdAndModelUrnAndDbIdAndPropertySet?: InputMaybe<Array<SparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyUsingUniqueProjectIdModelUrnDbIdPropertySetUpdate>>;
};

/** The `project` to be created by this mutation. */
export type SparkelPropertiesProjectIdFkeyProjectsCreateInput = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name: Scalars['String'];
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `sparkelProperty` to be created by this mutation. */
export type SparkelPropertiesProjectIdFkeySparkelPropertiesCreateInput = {
  dbId: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  modelUrn: Scalars['String'];
  project?: InputMaybe<SparkelPropertiesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  propertySet: Scalars['String'];
  propertyValue: Scalars['String'];
};

export type SparkelProperty = Node & {
  __typename?: 'SparkelProperty';
  dbId: Scalars['Int'];
  id: Scalars['UUID'];
  modelUrn: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Project` that is related to this `SparkelProperty`. */
  project?: Maybe<Project>;
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
  propertyValue: Scalars['String'];
};

/**
 * A condition to be used against `SparkelProperty` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SparkelPropertyCondition = {
  /** Checks for equality with the object’s `dbId` field. */
  dbId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `modelUrn` field. */
  modelUrn?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `propertySet` field. */
  propertySet?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `propertyValue` field. */
  propertyValue?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SparkelProperty` object types. All fields are combined with a logical ‘and.’ */
export type SparkelPropertyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SparkelPropertyFilter>>;
  /** Filter by the object’s `dbId` field. */
  dbId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `modelUrn` field. */
  modelUrn?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SparkelPropertyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SparkelPropertyFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `propertySet` field. */
  propertySet?: InputMaybe<StringFilter>;
  /** Filter by the object’s `propertyValue` field. */
  propertyValue?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SparkelProperty` */
export type SparkelPropertyInput = {
  dbId: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  modelUrn: Scalars['String'];
  project?: InputMaybe<SparkelPropertiesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  propertySet: Scalars['String'];
  propertyValue: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type SparkelPropertyNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `sparkelProperty` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type SparkelPropertyNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `sparkelProperty` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type SparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `project` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: ProjectPatch;
};

/** The fields on `sparkelProperty` to look up the row to update. */
export type SparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyUsingSparkelPropertiesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `sparkelProperty` being updated. */
  patch: UpdateSparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyPatch;
};

/** The fields on `sparkelProperty` to look up the row to update. */
export type SparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyUsingUniqueProjectIdModelUrnDbIdPropertySetUpdate = {
  dbId: Scalars['Int'];
  modelUrn: Scalars['String'];
  /** An object where the defined keys will be set on the `sparkelProperty` being updated. */
  patch: UpdateSparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
};

/** Represents an update to a `SparkelProperty`. Fields that are set will be updated. */
export type SparkelPropertyPatch = {
  dbId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  modelUrn?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SparkelPropertiesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  propertySet?: InputMaybe<Scalars['String']>;
  propertyValue?: InputMaybe<Scalars['String']>;
};

/** The fields on `sparkelProperty` to look up the row to connect. */
export type SparkelPropertySparkelPropertiesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `sparkelProperty` to look up the row to delete. */
export type SparkelPropertySparkelPropertiesPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `sparkelProperty` to look up the row to connect. */
export type SparkelPropertyUniqueProjectIdModelUrnDbIdPropertySetConnect = {
  dbId: Scalars['Int'];
  modelUrn: Scalars['String'];
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
};

/** The fields on `sparkelProperty` to look up the row to delete. */
export type SparkelPropertyUniqueProjectIdModelUrnDbIdPropertySetDelete = {
  dbId: Scalars['Int'];
  modelUrn: Scalars['String'];
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  autoShapeStatusUpdated?: Maybe<AutoShapeProcessingSubscriptionPayload>;
  modelStatusUpdated?: Maybe<ModelProcessingSubscriptionPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAutoShapeStatusUpdatedArgs = {
  projectId?: InputMaybe<Scalars['UUID']>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionModelStatusUpdatedArgs = {
  projectId?: InputMaybe<Scalars['UUID']>;
};

export type SymbolDetection2DInput = {
  autoShapeId: Scalars['UUID'];
  options: SymbolDetection2DOptions;
  projectId: Scalars['UUID'];
  tenant: Scalars['String'];
};

export type SymbolDetection2DOptions = {
  pageNumber: Scalars['Int'];
  sensitivity: Scalars['Float'];
  sheetId: Scalars['UUID'];
  templates: Array<SymbolTemplate2D>;
};

export type SymbolDetection2DPayload = {
  __typename?: 'SymbolDetection2DPayload';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SymbolTemplate2D = {
  pageNumber: Scalars['Int'];
  rect: Rectangle2;
  sheetId: Scalars['UUID'];
};

export type TableRowInput = {
  name: Scalars['String'];
  quantity: Scalars['Float'];
  unit: Scalars['String'];
};

export enum TagColorScheme {
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Teal = 'TEAL',
  Yellow = 'YELLOW'
}

/** A filter to be used against TagColorScheme fields. All fields are combined with a logical ‘and.’ */
export type TagColorSchemeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TagColorScheme>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TagColorScheme>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TagColorScheme>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TagColorScheme>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TagColorScheme>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TagColorScheme>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TagColorScheme>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TagColorScheme>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TagColorScheme>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TagColorScheme>>;
};

export type TemplateCustomFieldType = {
  __typename?: 'TemplateCustomFieldType';
  columnOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  value: QuantityType;
};

/** An input for mutations affecting `TemplateCustomFieldType` */
export type TemplateCustomFieldTypeInput = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  value: QuantityTypeInput;
};

export enum TextNormalization {
  AlphanumericOnly = 'ALPHANUMERIC_ONLY',
  Lowercase = 'LOWERCASE',
  StripLeadingZeros = 'STRIP_LEADING_ZEROS',
  StripWhitespace = 'STRIP_WHITESPACE',
  Trim = 'TRIM',
  Uppercase = 'UPPERCASE'
}

export enum TranslationType {
  Modern = 'MODERN',
  V3 = 'V3',
  V4 = 'V4'
}

/** A filter to be used against TranslationType fields. All fields are combined with a logical ‘and.’ */
export type TranslationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TranslationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TranslationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TranslationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TranslationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TranslationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TranslationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TranslationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TranslationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TranslationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TranslationType>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** A filter to be used against UUID List fields. All fields are combined with a logical ‘and.’ */
export type UuidListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['UUID']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['UUID']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export enum Unit {
  Cm = 'CM',
  Cm2 = 'CM2',
  Cm3 = 'CM3',
  Dm = 'DM',
  Dm2 = 'DM2',
  Dm3 = 'DM3',
  Ft = 'FT',
  Ft2 = 'FT2',
  Ft3 = 'FT3',
  In = 'IN',
  In2 = 'IN2',
  In3 = 'IN3',
  Kg = 'KG',
  M = 'M',
  M2 = 'M2',
  M3 = 'M3',
  Mm = 'MM',
  Mm2 = 'MM2',
  Mm3 = 'MM3',
  Pcs = 'PCS'
}

/** A filter to be used against Unit fields. All fields are combined with a logical ‘and.’ */
export type UnitFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Unit>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Unit>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Unit>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Unit>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Unit>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Unit>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Unit>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Unit>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Unit>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Unit>>;
};

export type UnitSettingsType = {
  __typename?: 'UnitSettingsType';
  area?: Maybe<AreaUnitSettingType>;
  length?: Maybe<LengthUnitSettingType>;
  volume?: Maybe<VolumeUnitSettingType>;
};

/** A filter to be used against `UnitSettingsType` object types. All fields are combined with a logical ‘and.’ */
export type UnitSettingsTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitSettingsTypeFilter>>;
  /** Filter by the object’s `area` field. */
  area?: InputMaybe<AreaUnitSettingTypeFilter>;
  /** Filter by the object’s `length` field. */
  length?: InputMaybe<LengthUnitSettingTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitSettingsTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitSettingsTypeFilter>>;
  /** Filter by the object’s `volume` field. */
  volume?: InputMaybe<VolumeUnitSettingTypeFilter>;
};

/** An input for mutations affecting `UnitSettingsType` */
export type UnitSettingsTypeInput = {
  area?: InputMaybe<AreaUnitSettingTypeInput>;
  length?: InputMaybe<LengthUnitSettingTypeInput>;
  volume?: InputMaybe<VolumeUnitSettingTypeInput>;
};

/** All input for the `updateAutoShapeByNodeId` mutation. */
export type UpdateAutoShapeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AutoShape` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AutoShape` being updated. */
  patch: AutoShapePatch;
};

/** All input for the `updateAutoShape` mutation. */
export type UpdateAutoShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AutoShape` being updated. */
  patch: AutoShapePatch;
};

/** The output of our update `AutoShape` mutation. */
export type UpdateAutoShapePayload = {
  __typename?: 'UpdateAutoShapePayload';
  /** The `AutoShape` that was updated by this mutation. */
  autoShape?: Maybe<AutoShape>;
  /** An edge for our `AutoShape`. May be used by Relay 1. */
  autoShapeEdge?: Maybe<AutoShapesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `AutoShape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AutoShape` mutation. */
export type UpdateAutoShapePayloadAutoShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<AutoShapesOrderBy>>;
};

/** All input for the `updateCommentByNodeId` mutation. */
export type UpdateCommentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Comment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Comment` being updated. */
  patch: CommentPatch;
};

/** All input for the `updateComment` mutation. */
export type UpdateCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Comment` being updated. */
  patch: CommentPatch;
};

/** The output of our update `Comment` mutation. */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Comment` that was updated by this mutation. */
  comment?: Maybe<Comment>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  commentByReplies?: Maybe<Comment>;
  /** An edge for our `Comment`. May be used by Relay 1. */
  commentEdge?: Maybe<CommentsEdge>;
  /** Reads a single `Order` that is related to this `Comment`. */
  order?: Maybe<Order>;
  /** Reads a single `Comment` that is related to this `Comment`. */
  parent?: Maybe<Comment>;
  /** Reads a single `Project` that is related to this `Comment`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavedView` that is related to this `Comment`. */
  savedViews?: Maybe<SavedView>;
};


/** The output of our update `Comment` mutation. */
export type UpdateCommentPayloadCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentsOrderBy>>;
};

/** All input for the `updateCompanyDatabaseCellByNodeId` mutation. */
export type UpdateCompanyDatabaseCellByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseCell` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseCell` being updated. */
  patch: CompanyDatabaseCellPatch;
};

/** All input for the `updateCompanyDatabaseCell` mutation. */
export type UpdateCompanyDatabaseCellInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  columnId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseCell` being updated. */
  patch: CompanyDatabaseCellPatch;
  rowId: Scalars['UUID'];
};

/** The output of our update `CompanyDatabaseCell` mutation. */
export type UpdateCompanyDatabaseCellPayload = {
  __typename?: 'UpdateCompanyDatabaseCellPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseCell`. */
  column?: Maybe<CompanyDatabaseColumn>;
  /** The `CompanyDatabaseCell` that was updated by this mutation. */
  companyDatabaseCell?: Maybe<CompanyDatabaseCell>;
  /** An edge for our `CompanyDatabaseCell`. May be used by Relay 1. */
  companyDatabaseCellEdge?: Maybe<CompanyDatabaseCellsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseCell`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseCell`. */
  row?: Maybe<CompanyDatabaseRow>;
};


/** The output of our update `CompanyDatabaseCell` mutation. */
export type UpdateCompanyDatabaseCellPayloadCompanyDatabaseCellEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseCellsOrderBy>>;
};

/** All input for the `updateCompanyDatabaseColumnByNodeId` mutation. */
export type UpdateCompanyDatabaseColumnByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseColumn` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseColumn` being updated. */
  patch: CompanyDatabaseColumnPatch;
};

/** All input for the `updateCompanyDatabaseColumn` mutation. */
export type UpdateCompanyDatabaseColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseColumn` being updated. */
  patch: CompanyDatabaseColumnPatch;
};

/** The output of our update `CompanyDatabaseColumn` mutation. */
export type UpdateCompanyDatabaseColumnPayload = {
  __typename?: 'UpdateCompanyDatabaseColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseColumn` that was updated by this mutation. */
  companyDatabaseColumn?: Maybe<CompanyDatabaseColumn>;
  /** An edge for our `CompanyDatabaseColumn`. May be used by Relay 1. */
  companyDatabaseColumnEdge?: Maybe<CompanyDatabaseColumnsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseColumn`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyDatabaseColumn` mutation. */
export type UpdateCompanyDatabaseColumnPayloadCompanyDatabaseColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseColumnsOrderBy>>;
};

/** All input for the `updateCompanyDatabaseImportJobByNodeId` mutation. */
export type UpdateCompanyDatabaseImportJobByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseImportJob` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseImportJob` being updated. */
  patch: CompanyDatabaseImportJobPatch;
};

/** All input for the `updateCompanyDatabaseImportJob` mutation. */
export type UpdateCompanyDatabaseImportJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseImportJob` being updated. */
  patch: CompanyDatabaseImportJobPatch;
};

/** The output of our update `CompanyDatabaseImportJob` mutation. */
export type UpdateCompanyDatabaseImportJobPayload = {
  __typename?: 'UpdateCompanyDatabaseImportJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseImportJob` that was updated by this mutation. */
  companyDatabaseImportJob?: Maybe<CompanyDatabaseImportJob>;
  /** An edge for our `CompanyDatabaseImportJob`. May be used by Relay 1. */
  companyDatabaseImportJobEdge?: Maybe<CompanyDatabaseImportJobsEdge>;
  /** Reads a single `Contractor` that is related to this `CompanyDatabaseImportJob`. */
  contractor?: Maybe<Contractor>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseImportJob`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyDatabaseImportJob` mutation. */
export type UpdateCompanyDatabaseImportJobPayloadCompanyDatabaseImportJobEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseImportJobsOrderBy>>;
};

/** All input for the `updateCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnId` mutation. */
export type UpdateCompanyDatabaseLookupCacheByDatabaseIdAndLookupProfileIdAndSearchColumnIdAndSearchTermAndValueColumnIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  databaseId: Scalars['UUID'];
  lookupProfileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
};

/** All input for the `updateCompanyDatabaseLookupCacheByNodeId` mutation. */
export type UpdateCompanyDatabaseLookupCacheByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseLookupCache` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** All input for the `updateCompanyDatabaseLookupCache` mutation. */
export type UpdateCompanyDatabaseLookupCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupCache` being updated. */
  patch: CompanyDatabaseLookupCachePatch;
};

/** The output of our update `CompanyDatabaseLookupCache` mutation. */
export type UpdateCompanyDatabaseLookupCachePayload = {
  __typename?: 'UpdateCompanyDatabaseLookupCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupCache` that was updated by this mutation. */
  companyDatabaseLookupCache?: Maybe<CompanyDatabaseLookupCache>;
  /** An edge for our `CompanyDatabaseLookupCache`. May be used by Relay 1. */
  companyDatabaseLookupCacheEdge?: Maybe<CompanyDatabaseLookupCachesEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupCache`. */
  database?: Maybe<CompanyDatabasis>;
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupCache`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `CompanyDatabaseRow` that is related to this `CompanyDatabaseLookupCache`. */
  resolved?: Maybe<CompanyDatabaseRow>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  searchColumn?: Maybe<CompanyDatabaseColumn>;
  /** Reads a single `CompanyDatabaseColumn` that is related to this `CompanyDatabaseLookupCache`. */
  valueColumn?: Maybe<CompanyDatabaseColumn>;
};


/** The output of our update `CompanyDatabaseLookupCache` mutation. */
export type UpdateCompanyDatabaseLookupCachePayloadCompanyDatabaseLookupCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupCachesOrderBy>>;
};

/** All input for the `updateCompanyDatabaseLookupJobByNodeId` mutation. */
export type UpdateCompanyDatabaseLookupJobByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseLookupJob` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupJob` being updated. */
  patch: CompanyDatabaseLookupJobPatch;
};

/** All input for the `updateCompanyDatabaseLookupJob` mutation. */
export type UpdateCompanyDatabaseLookupJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupJob` being updated. */
  patch: CompanyDatabaseLookupJobPatch;
};

/** The output of our update `CompanyDatabaseLookupJob` mutation. */
export type UpdateCompanyDatabaseLookupJobPayload = {
  __typename?: 'UpdateCompanyDatabaseLookupJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupJob` that was updated by this mutation. */
  companyDatabaseLookupJob?: Maybe<CompanyDatabaseLookupJob>;
  /** An edge for our `CompanyDatabaseLookupJob`. May be used by Relay 1. */
  companyDatabaseLookupJobEdge?: Maybe<CompanyDatabaseLookupJobsEdge>;
  /** Reads a single `CompanyDatabaseLookupProfile` that is related to this `CompanyDatabaseLookupJob`. */
  lookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyDatabaseLookupJob` mutation. */
export type UpdateCompanyDatabaseLookupJobPayloadCompanyDatabaseLookupJobEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupJobsOrderBy>>;
};

/** All input for the `updateCompanyDatabaseLookupProfileByNodeId` mutation. */
export type UpdateCompanyDatabaseLookupProfileByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseLookupProfile` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupProfile` being updated. */
  patch: CompanyDatabaseLookupProfilePatch;
};

/** All input for the `updateCompanyDatabaseLookupProfile` mutation. */
export type UpdateCompanyDatabaseLookupProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseLookupProfile` being updated. */
  patch: CompanyDatabaseLookupProfilePatch;
};

/** The output of our update `CompanyDatabaseLookupProfile` mutation. */
export type UpdateCompanyDatabaseLookupProfilePayload = {
  __typename?: 'UpdateCompanyDatabaseLookupProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseLookupProfile` that was updated by this mutation. */
  companyDatabaseLookupProfile?: Maybe<CompanyDatabaseLookupProfile>;
  /** An edge for our `CompanyDatabaseLookupProfile`. May be used by Relay 1. */
  companyDatabaseLookupProfileEdge?: Maybe<CompanyDatabaseLookupProfilesEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseLookupProfile`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyDatabaseLookupProfile` mutation. */
export type UpdateCompanyDatabaseLookupProfilePayloadCompanyDatabaseLookupProfileEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseLookupProfilesOrderBy>>;
};

/** All input for the `updateCompanyDatabaseRowByNodeId` mutation. */
export type UpdateCompanyDatabaseRowByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabaseRow` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseRow` being updated. */
  patch: CompanyDatabaseRowPatch;
};

/** All input for the `updateCompanyDatabaseRow` mutation. */
export type UpdateCompanyDatabaseRowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabaseRow` being updated. */
  patch: CompanyDatabaseRowPatch;
};

/** The output of our update `CompanyDatabaseRow` mutation. */
export type UpdateCompanyDatabaseRowPayload = {
  __typename?: 'UpdateCompanyDatabaseRowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabaseRow` that was updated by this mutation. */
  companyDatabaseRow?: Maybe<CompanyDatabaseRow>;
  /** An edge for our `CompanyDatabaseRow`. May be used by Relay 1. */
  companyDatabaseRowEdge?: Maybe<CompanyDatabaseRowsEdge>;
  /** Reads a single `CompanyDatabasis` that is related to this `CompanyDatabaseRow`. */
  database?: Maybe<CompanyDatabasis>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyDatabaseRow` mutation. */
export type UpdateCompanyDatabaseRowPayloadCompanyDatabaseRowEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabaseRowsOrderBy>>;
};

/** All input for the `updateCompanyDatabasisByNodeId` mutation. */
export type UpdateCompanyDatabasisByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CompanyDatabasis` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CompanyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** All input for the `updateCompanyDatabasis` mutation. */
export type UpdateCompanyDatabasisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyDatabasis` being updated. */
  patch: CompanyDatabasisPatch;
};

/** The output of our update `CompanyDatabasis` mutation. */
export type UpdateCompanyDatabasisPayload = {
  __typename?: 'UpdateCompanyDatabasisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyDatabasis` that was updated by this mutation. */
  companyDatabasis?: Maybe<CompanyDatabasis>;
  /** An edge for our `CompanyDatabasis`. May be used by Relay 1. */
  companyDatabasisEdge?: Maybe<CompanyDatabasesEdge>;
  /** Reads a single `Contractor` that is related to this `CompanyDatabasis`. */
  contractor?: Maybe<Contractor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyDatabasis` mutation. */
export type UpdateCompanyDatabasisPayloadCompanyDatabasisEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyDatabasesOrderBy>>;
};

/** All input for the `updateContractorByNodeId` mutation. */
export type UpdateContractorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Contractor` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Contractor` being updated. */
  patch: ContractorPatch;
};

/** All input for the `updateContractorByTenant` mutation. */
export type UpdateContractorByTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Contractor` being updated. */
  patch: ContractorPatch;
  tenant: Scalars['String'];
};

/** All input for the `updateContractor` mutation. */
export type UpdateContractorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Contractor` being updated. */
  patch: ContractorPatch;
};

/** The output of our update `Contractor` mutation. */
export type UpdateContractorPayload = {
  __typename?: 'UpdateContractorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contractor` that was updated by this mutation. */
  contractor?: Maybe<Contractor>;
  /** An edge for our `Contractor`. May be used by Relay 1. */
  contractorEdge?: Maybe<ContractorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Contractor` mutation. */
export type UpdateContractorPayloadContractorEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractorsOrderBy>>;
};

/** All input for the `updateCopilotExchangeByNodeId` mutation. */
export type UpdateCopilotExchangeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CopilotExchange` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CopilotExchange` being updated. */
  patch: CopilotExchangePatch;
};

/** All input for the `updateCopilotExchange` mutation. */
export type UpdateCopilotExchangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CopilotExchange` being updated. */
  patch: CopilotExchangePatch;
};

/** The output of our update `CopilotExchange` mutation. */
export type UpdateCopilotExchangePayload = {
  __typename?: 'UpdateCopilotExchangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `CopilotExchange`. */
  contractor?: Maybe<Contractor>;
  /** The `CopilotExchange` that was updated by this mutation. */
  copilotExchange?: Maybe<CopilotExchange>;
  /** An edge for our `CopilotExchange`. May be used by Relay 1. */
  copilotExchangeEdge?: Maybe<CopilotExchangesEdge>;
  /** Reads a single `Project` that is related to this `CopilotExchange`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CopilotExchange` mutation. */
export type UpdateCopilotExchangePayloadCopilotExchangeEdgeArgs = {
  orderBy?: InputMaybe<Array<CopilotExchangesOrderBy>>;
};

/** All input for the `updateCopilotExchangesFeedbackByNodeId` mutation. */
export type UpdateCopilotExchangesFeedbackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CopilotExchangesFeedback` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CopilotExchangesFeedback` being updated. */
  patch: CopilotExchangesFeedbackPatch;
};

/** All input for the `updateCopilotExchangesFeedback` mutation. */
export type UpdateCopilotExchangesFeedbackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CopilotExchangesFeedback` being updated. */
  patch: CopilotExchangesFeedbackPatch;
};

/** The output of our update `CopilotExchangesFeedback` mutation. */
export type UpdateCopilotExchangesFeedbackPayload = {
  __typename?: 'UpdateCopilotExchangesFeedbackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CopilotExchange` that is related to this `CopilotExchangesFeedback`. */
  copilotExchangeById?: Maybe<CopilotExchange>;
  /** The `CopilotExchangesFeedback` that was updated by this mutation. */
  copilotExchangesFeedback?: Maybe<CopilotExchangesFeedback>;
  /** An edge for our `CopilotExchangesFeedback`. May be used by Relay 1. */
  copilotExchangesFeedbackEdge?: Maybe<CopilotExchangesFeedbacksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CopilotExchangesFeedback` mutation. */
export type UpdateCopilotExchangesFeedbackPayloadCopilotExchangesFeedbackEdgeArgs = {
  orderBy?: InputMaybe<Array<CopilotExchangesFeedbacksOrderBy>>;
};

/** All input for the `updateCustomFieldByNodeId` mutation. */
export type UpdateCustomFieldByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CustomField` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CustomField` being updated. */
  patch: CustomFieldPatch;
};

/** All input for the `updateCustomFieldByOrderColumnIdAndOrderEntryId` mutation. */
export type UpdateCustomFieldByOrderColumnIdAndOrderEntryIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderColumnId: Scalars['UUID'];
  orderEntryId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CustomField` being updated. */
  patch: CustomFieldPatch;
};

/** All input for the `updateCustomField` mutation. */
export type UpdateCustomFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CustomField` being updated. */
  patch: CustomFieldPatch;
};

/** The output of our update `CustomField` mutation. */
export type UpdateCustomFieldPayload = {
  __typename?: 'UpdateCustomFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomField` that was updated by this mutation. */
  customField?: Maybe<CustomField>;
  /** An edge for our `CustomField`. May be used by Relay 1. */
  customFieldEdge?: Maybe<CustomFieldsEdge>;
  /** Reads a single `OrderColumn` that is related to this `CustomField`. */
  orderColumn?: Maybe<OrderColumn>;
  /** Reads a single `OrderEntry` that is related to this `CustomField`. */
  orderEntry?: Maybe<OrderEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomField` mutation. */
export type UpdateCustomFieldPayloadCustomFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomFieldsOrderBy>>;
};

/** All input for the `updateCustomFieldTemplateByNodeId` mutation. */
export type UpdateCustomFieldTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CustomFieldTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CustomFieldTemplate` being updated. */
  patch: CustomFieldTemplatePatch;
};

/** All input for the `updateCustomFieldTemplate` mutation. */
export type UpdateCustomFieldTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CustomFieldTemplate` being updated. */
  patch: CustomFieldTemplatePatch;
};

/** The output of our update `CustomFieldTemplate` mutation. */
export type UpdateCustomFieldTemplatePayload = {
  __typename?: 'UpdateCustomFieldTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomFieldTemplate` that was updated by this mutation. */
  customFieldTemplate?: Maybe<CustomFieldTemplate>;
  /** An edge for our `CustomFieldTemplate`. May be used by Relay 1. */
  customFieldTemplateEdge?: Maybe<CustomFieldTemplatesEdge>;
  /** Reads a single `OrderColumnTemplate` that is related to this `CustomFieldTemplate`. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** Reads a single `ProjectTemplateOrderEntry` that is related to this `CustomFieldTemplate`. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomFieldTemplate` mutation. */
export type UpdateCustomFieldTemplatePayloadCustomFieldTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomFieldTemplatesOrderBy>>;
};

/** All input for the `updateExtrudedPolygonByNodeId` mutation. */
export type UpdateExtrudedPolygonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ExtrudedPolygon` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ExtrudedPolygon` being updated. */
  patch: ExtrudedPolygonPatch;
};

/** All input for the `updateExtrudedPolygonByShapeId` mutation. */
export type UpdateExtrudedPolygonByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ExtrudedPolygon` being updated. */
  patch: ExtrudedPolygonPatch;
  shapeId: Scalars['UUID'];
};

/** All input for the `updateExtrudedPolygon` mutation. */
export type UpdateExtrudedPolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ExtrudedPolygon` being updated. */
  patch: ExtrudedPolygonPatch;
};

/** The output of our update `ExtrudedPolygon` mutation. */
export type UpdateExtrudedPolygonPayload = {
  __typename?: 'UpdateExtrudedPolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExtrudedPolygon` that was updated by this mutation. */
  extrudedPolygon?: Maybe<ExtrudedPolygon>;
  /** An edge for our `ExtrudedPolygon`. May be used by Relay 1. */
  extrudedPolygonEdge?: Maybe<ExtrudedPolygonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `ExtrudedPolygon`. */
  shape?: Maybe<Shape>;
};


/** The output of our update `ExtrudedPolygon` mutation. */
export type UpdateExtrudedPolygonPayloadExtrudedPolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<ExtrudedPolygonsOrderBy>>;
};

/** All input for the `updateFlowActionByFlowIdAndPosition` mutation. */
export type UpdateFlowActionByFlowIdAndPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  flowId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FlowAction` being updated. */
  patch: FlowActionPatch;
  position: Scalars['Int'];
};

/** All input for the `updateFlowActionByNodeId` mutation. */
export type UpdateFlowActionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowAction` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FlowAction` being updated. */
  patch: FlowActionPatch;
};

/** All input for the `updateFlowAction` mutation. */
export type UpdateFlowActionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FlowAction` being updated. */
  patch: FlowActionPatch;
};

/** The output of our update `FlowAction` mutation. */
export type UpdateFlowActionPayload = {
  __typename?: 'UpdateFlowActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Flow` that is related to this `FlowAction`. */
  flow?: Maybe<Flow>;
  /** The `FlowAction` that was updated by this mutation. */
  flowAction?: Maybe<FlowAction>;
  /** An edge for our `FlowAction`. May be used by Relay 1. */
  flowActionEdge?: Maybe<FlowActionsEdge>;
  /** Reads a single `FlowAction` that is related to this `FlowAction`. */
  parentLoopAction?: Maybe<FlowAction>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FlowAction` mutation. */
export type UpdateFlowActionPayloadFlowActionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowActionsOrderBy>>;
};

/** All input for the `updateFlowByNodeId` mutation. */
export type UpdateFlowByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Flow` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Flow` being updated. */
  patch: FlowPatch;
};

/** All input for the `updateFlowExecutionByNodeId` mutation. */
export type UpdateFlowExecutionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowExecution` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FlowExecution` being updated. */
  patch: FlowExecutionPatch;
};

/** All input for the `updateFlowExecution` mutation. */
export type UpdateFlowExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FlowExecution` being updated. */
  patch: FlowExecutionPatch;
};

/** The output of our update `FlowExecution` mutation. */
export type UpdateFlowExecutionPayload = {
  __typename?: 'UpdateFlowExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Flow` that is related to this `FlowExecution`. */
  flow?: Maybe<Flow>;
  /** The `FlowExecution` that was updated by this mutation. */
  flowExecution?: Maybe<FlowExecution>;
  /** An edge for our `FlowExecution`. May be used by Relay 1. */
  flowExecutionEdge?: Maybe<FlowExecutionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FlowExecution` mutation. */
export type UpdateFlowExecutionPayloadFlowExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowExecutionsOrderBy>>;
};

/** All input for the `updateFlow` mutation. */
export type UpdateFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Flow` being updated. */
  patch: FlowPatch;
};

/** All input for the `updateFlowMailboxByContractorId` mutation. */
export type UpdateFlowMailboxByContractorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractorId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FlowMailbox` being updated. */
  patch: FlowMailboxPatch;
};

/** All input for the `updateFlowMailboxByEmailLocalPartAndEmailDomain` mutation. */
export type UpdateFlowMailboxByEmailLocalPartAndEmailDomainInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain: Scalars['String'];
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart: Scalars['String'];
  /** An object where the defined keys will be set on the `FlowMailbox` being updated. */
  patch: FlowMailboxPatch;
};

/** All input for the `updateFlowMailboxByNodeId` mutation. */
export type UpdateFlowMailboxByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowMailbox` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FlowMailbox` being updated. */
  patch: FlowMailboxPatch;
};

/** All input for the `updateFlowMailbox` mutation. */
export type UpdateFlowMailboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FlowMailbox` being updated. */
  patch: FlowMailboxPatch;
};

/** All input for the `updateFlowMailboxMessageByNodeId` mutation. */
export type UpdateFlowMailboxMessageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FlowMailboxMessage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FlowMailboxMessage` being updated. */
  patch: FlowMailboxMessagePatch;
};

/** All input for the `updateFlowMailboxMessage` mutation. */
export type UpdateFlowMailboxMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FlowMailboxMessage` being updated. */
  patch: FlowMailboxMessagePatch;
};

/** The output of our update `FlowMailboxMessage` mutation. */
export type UpdateFlowMailboxMessagePayload = {
  __typename?: 'UpdateFlowMailboxMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `FlowExecution` that is related to this `FlowMailboxMessage`. */
  flowExecution?: Maybe<FlowExecution>;
  /** The `FlowMailboxMessage` that was updated by this mutation. */
  flowMailboxMessage?: Maybe<FlowMailboxMessage>;
  /** An edge for our `FlowMailboxMessage`. May be used by Relay 1. */
  flowMailboxMessageEdge?: Maybe<FlowMailboxMessagesEdge>;
  /** Reads a single `FlowMailbox` that is related to this `FlowMailboxMessage`. */
  mailbox?: Maybe<FlowMailbox>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FlowMailboxMessage` mutation. */
export type UpdateFlowMailboxMessagePayloadFlowMailboxMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowMailboxMessagesOrderBy>>;
};

/** The output of our update `FlowMailbox` mutation. */
export type UpdateFlowMailboxPayload = {
  __typename?: 'UpdateFlowMailboxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `FlowMailbox`. */
  contractor?: Maybe<Contractor>;
  /** The `FlowMailbox` that was updated by this mutation. */
  flowMailbox?: Maybe<FlowMailbox>;
  /** An edge for our `FlowMailbox`. May be used by Relay 1. */
  flowMailboxEdge?: Maybe<FlowMailboxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FlowMailbox` mutation. */
export type UpdateFlowMailboxPayloadFlowMailboxEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowMailboxesOrderBy>>;
};

/** The output of our update `Flow` mutation. */
export type UpdateFlowPayload = {
  __typename?: 'UpdateFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Flow`. */
  contractor?: Maybe<Contractor>;
  /** The `Flow` that was updated by this mutation. */
  flow?: Maybe<Flow>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Flow` mutation. */
export type UpdateFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the `updateHistoryEventByNodeId` mutation. */
export type UpdateHistoryEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `HistoryEvent` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `HistoryEvent` being updated. */
  patch: HistoryEventPatch;
};

/** All input for the `updateHistoryEvent` mutation. */
export type UpdateHistoryEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `HistoryEvent` being updated. */
  patch: HistoryEventPatch;
};

/** The output of our update `HistoryEvent` mutation. */
export type UpdateHistoryEventPayload = {
  __typename?: 'UpdateHistoryEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `HistoryEvent` that was updated by this mutation. */
  historyEvent?: Maybe<HistoryEvent>;
  /** An edge for our `HistoryEvent`. May be used by Relay 1. */
  historyEventEdge?: Maybe<HistoryEventsEdge>;
  /** Reads a single `Project` that is related to this `HistoryEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `HistoryEvent` mutation. */
export type UpdateHistoryEventPayloadHistoryEventEdgeArgs = {
  orderBy?: InputMaybe<Array<HistoryEventsOrderBy>>;
};

/** All input for the `updateInitialStateByNodeId` mutation. */
export type UpdateInitialStateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InitialState` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InitialState` being updated. */
  patch: InitialStatePatch;
};

/** All input for the `updateInitialState` mutation. */
export type UpdateInitialStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `InitialState` being updated. */
  patch: InitialStatePatch;
};

/** The output of our update `InitialState` mutation. */
export type UpdateInitialStatePayload = {
  __typename?: 'UpdateInitialStatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InitialState` that was updated by this mutation. */
  initialState?: Maybe<InitialState>;
  /** An edge for our `InitialState`. May be used by Relay 1. */
  initialStateEdge?: Maybe<InitialStatesEdge>;
  /** Reads a single `Project` that is related to this `InitialState`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavedView` that is related to this `InitialState`. */
  view?: Maybe<SavedView>;
};


/** The output of our update `InitialState` mutation. */
export type UpdateInitialStatePayloadInitialStateEdgeArgs = {
  orderBy?: InputMaybe<Array<InitialStatesOrderBy>>;
};

/** All input for the `updateIssueByNodeId` mutation. */
export type UpdateIssueByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Issue` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Issue` being updated. */
  patch: IssuePatch;
};

/** All input for the `updateIssueCommentByNodeId` mutation. */
export type UpdateIssueCommentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `IssueComment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `IssueComment` being updated. */
  patch: IssueCommentPatch;
};

/** All input for the `updateIssueComment` mutation. */
export type UpdateIssueCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `IssueComment` being updated. */
  patch: IssueCommentPatch;
};

/** The output of our update `IssueComment` mutation. */
export type UpdateIssueCommentPayload = {
  __typename?: 'UpdateIssueCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Issue` that is related to this `IssueComment`. */
  issue?: Maybe<Issue>;
  /** The `IssueComment` that was updated by this mutation. */
  issueComment?: Maybe<IssueComment>;
  /** An edge for our `IssueComment`. May be used by Relay 1. */
  issueCommentEdge?: Maybe<IssueCommentsEdge>;
  /** Reads a single `Project` that is related to this `IssueComment`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IssueComment` mutation. */
export type UpdateIssueCommentPayloadIssueCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<IssueCommentsOrderBy>>;
};

/** All input for the `updateIssue` mutation. */
export type UpdateIssueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Issue` being updated. */
  patch: IssuePatch;
};

/** The output of our update `Issue` mutation. */
export type UpdateIssuePayload = {
  __typename?: 'UpdateIssuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Issue` that was updated by this mutation. */
  issue?: Maybe<Issue>;
  /** An edge for our `Issue`. May be used by Relay 1. */
  issueEdge?: Maybe<IssuesEdge>;
  /** Reads a single `Project` that is related to this `Issue`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Issue` mutation. */
export type UpdateIssuePayloadIssueEdgeArgs = {
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
};

/** All input for the `updateLineByNodeId` mutation. */
export type UpdateLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Line` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Line` being updated. */
  patch: LinePatch;
};

/** All input for the `updateLineByShapeId` mutation. */
export type UpdateLineByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Line` being updated. */
  patch: LinePatch;
  shapeId: Scalars['UUID'];
};

/** All input for the `updateLine` mutation. */
export type UpdateLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Line` being updated. */
  patch: LinePatch;
};

/** The output of our update `Line` mutation. */
export type UpdateLinePayload = {
  __typename?: 'UpdateLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Line` that was updated by this mutation. */
  line?: Maybe<Line>;
  /** An edge for our `Line`. May be used by Relay 1. */
  lineEdge?: Maybe<LinesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `Line`. */
  shape?: Maybe<Shape>;
};


/** The output of our update `Line` mutation. */
export type UpdateLinePayloadLineEdgeArgs = {
  orderBy?: InputMaybe<Array<LinesOrderBy>>;
};

/** All input for the `updateModelByNodeId` mutation. */
export type UpdateModelByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Model` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Model` being updated. */
  patch: ModelPatch;
};

/** All input for the `updateModelByProjectIdAndNameAndVersion` mutation. */
export type UpdateModelByProjectIdAndNameAndVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `Model` being updated. */
  patch: ModelPatch;
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** All input for the `updateModel` mutation. */
export type UpdateModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Model` being updated. */
  patch: ModelPatch;
};

/** The output of our update `Model` mutation. */
export type UpdateModelPayload = {
  __typename?: 'UpdateModelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Model` that was updated by this mutation. */
  model?: Maybe<Model>;
  /** An edge for our `Model`. May be used by Relay 1. */
  modelEdge?: Maybe<ModelsEdge>;
  /** Reads a single `Project` that is related to this `Model`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Model` mutation. */
export type UpdateModelPayloadModelEdgeArgs = {
  orderBy?: InputMaybe<Array<ModelsOrderBy>>;
};

/** All input for the `updateOrderByNodeId` mutation. */
export type UpdateOrderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Order` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Order` being updated. */
  patch: OrderPatch;
};

/** All input for the `updateOrderColumnByNameAndColumnTypeAndOrderId` mutation. */
export type UpdateOrderColumnByNameAndColumnTypeAndOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  columnType: ColumnType;
  name: Scalars['String'];
  orderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderColumn` being updated. */
  patch: OrderColumnPatch;
};

/** All input for the `updateOrderColumnByNodeId` mutation. */
export type UpdateOrderColumnByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderColumn` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrderColumn` being updated. */
  patch: OrderColumnPatch;
};

/** All input for the `updateOrderColumn` mutation. */
export type UpdateOrderColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderColumn` being updated. */
  patch: OrderColumnPatch;
};

/** The output of our update `OrderColumn` mutation. */
export type UpdateOrderColumnPayload = {
  __typename?: 'UpdateOrderColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `OrderColumn`. */
  order?: Maybe<Order>;
  /** The `OrderColumn` that was updated by this mutation. */
  orderColumn?: Maybe<OrderColumn>;
  /** An edge for our `OrderColumn`. May be used by Relay 1. */
  orderColumnEdge?: Maybe<OrderColumnsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderColumn` mutation. */
export type UpdateOrderColumnPayloadOrderColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderColumnsOrderBy>>;
};

/** All input for the `updateOrderColumnTemplateByNodeId` mutation. */
export type UpdateOrderColumnTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderColumnTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrderColumnTemplate` being updated. */
  patch: OrderColumnTemplatePatch;
};

/** All input for the `updateOrderColumnTemplate` mutation. */
export type UpdateOrderColumnTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderColumnTemplate` being updated. */
  patch: OrderColumnTemplatePatch;
};

/** The output of our update `OrderColumnTemplate` mutation. */
export type UpdateOrderColumnTemplatePayload = {
  __typename?: 'UpdateOrderColumnTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OrderColumnTemplate` that was updated by this mutation. */
  orderColumnTemplate?: Maybe<OrderColumnTemplate>;
  /** An edge for our `OrderColumnTemplate`. May be used by Relay 1. */
  orderColumnTemplateEdge?: Maybe<OrderColumnTemplatesEdge>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `OrderColumnTemplate`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderColumnTemplate` mutation. */
export type UpdateOrderColumnTemplatePayloadOrderColumnTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderColumnTemplatesOrderBy>>;
};

/** All input for the `updateOrderEntryByNodeId` mutation. */
export type UpdateOrderEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntry` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrderEntry` being updated. */
  patch: OrderEntryPatch;
};

/** All input for the `updateOrderEntryCacheByNodeId` mutation. */
export type UpdateOrderEntryCacheByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntryCache` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrderEntryCache` being updated. */
  patch: OrderEntryCachePatch;
};

/** All input for the `updateOrderEntryCacheByOrderEntryId` mutation. */
export type UpdateOrderEntryCacheByOrderEntryIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderEntryId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderEntryCache` being updated. */
  patch: OrderEntryCachePatch;
};

/** All input for the `updateOrderEntryCache` mutation. */
export type UpdateOrderEntryCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderEntryCache` being updated. */
  patch: OrderEntryCachePatch;
};

/** The output of our update `OrderEntryCache` mutation. */
export type UpdateOrderEntryCachePayload = {
  __typename?: 'UpdateOrderEntryCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `OrderEntry` that is related to this `OrderEntryCache`. */
  orderEntry?: Maybe<OrderEntry>;
  /** The `OrderEntryCache` that was updated by this mutation. */
  orderEntryCache?: Maybe<OrderEntryCache>;
  /** An edge for our `OrderEntryCache`. May be used by Relay 1. */
  orderEntryCacheEdge?: Maybe<OrderEntryCachesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderEntryCache` mutation. */
export type UpdateOrderEntryCachePayloadOrderEntryCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryCachesOrderBy>>;
};

/** All input for the `updateOrderEntry` mutation. */
export type UpdateOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderEntry` being updated. */
  patch: OrderEntryPatch;
};

/** The output of our update `OrderEntry` mutation. */
export type UpdateOrderEntryPayload = {
  __typename?: 'UpdateOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `OrderEntry`. */
  order?: Maybe<Order>;
  /** The `OrderEntry` that was updated by this mutation. */
  orderEntry?: Maybe<OrderEntry>;
  /** An edge for our `OrderEntry`. May be used by Relay 1. */
  orderEntryEdge?: Maybe<OrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderEntry` mutation. */
export type UpdateOrderEntryPayloadOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntriesOrderBy>>;
};

/** All input for the `updateOrderEntryTemplateByNodeId` mutation. */
export type UpdateOrderEntryTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntryTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrderEntryTemplate` being updated. */
  patch: OrderEntryTemplatePatch;
};

/** All input for the `updateOrderEntryTemplate` mutation. */
export type UpdateOrderEntryTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderEntryTemplate` being updated. */
  patch: OrderEntryTemplatePatch;
};

/** The output of our update `OrderEntryTemplate` mutation. */
export type UpdateOrderEntryTemplatePayload = {
  __typename?: 'UpdateOrderEntryTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `OrderEntryTemplate`. */
  contractor?: Maybe<Contractor>;
  /** The `OrderEntryTemplate` that was updated by this mutation. */
  orderEntryTemplate?: Maybe<OrderEntryTemplate>;
  /** An edge for our `OrderEntryTemplate`. May be used by Relay 1. */
  orderEntryTemplateEdge?: Maybe<OrderEntryTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderEntryTemplate` mutation. */
export type UpdateOrderEntryTemplatePayloadOrderEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryTemplatesOrderBy>>;
};

/** All input for the `updateOrderEntryViewByNodeId` mutation. */
export type UpdateOrderEntryViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrderEntryView` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrderEntryView` being updated. */
  patch: OrderEntryViewPatch;
};

/** All input for the `updateOrderEntryViewByProjectIdAndName` mutation. */
export type UpdateOrderEntryViewByProjectIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `OrderEntryView` being updated. */
  patch: OrderEntryViewPatch;
  projectId: Scalars['UUID'];
};

/** All input for the `updateOrderEntryView` mutation. */
export type UpdateOrderEntryViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrderEntryView` being updated. */
  patch: OrderEntryViewPatch;
};

/** The output of our update `OrderEntryView` mutation. */
export type UpdateOrderEntryViewPayload = {
  __typename?: 'UpdateOrderEntryViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `OrderEntryView` that was updated by this mutation. */
  orderEntryView?: Maybe<OrderEntryView>;
  /** An edge for our `OrderEntryView`. May be used by Relay 1. */
  orderEntryViewEdge?: Maybe<OrderEntryViewsEdge>;
  /** Reads a single `Project` that is related to this `OrderEntryView`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderEntryView` mutation. */
export type UpdateOrderEntryViewPayloadOrderEntryViewEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderEntryViewsOrderBy>>;
};

/** All input for the `updateOrder` mutation. */
export type UpdateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Order` being updated. */
  patch: OrderPatch;
};

/** The output of our update `Order` mutation. */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Order` that was updated by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Project` that is related to this `Order`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Order` mutation. */
export type UpdateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `updatePolygonByNodeId` mutation. */
export type UpdatePolygonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Polygon` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Polygon` being updated. */
  patch: PolygonPatch;
};

/** All input for the `updatePolygonByShapeId` mutation. */
export type UpdatePolygonByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Polygon` being updated. */
  patch: PolygonPatch;
  shapeId: Scalars['UUID'];
};

/** All input for the `updatePolygon` mutation. */
export type UpdatePolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Polygon` being updated. */
  patch: PolygonPatch;
};

/** The output of our update `Polygon` mutation. */
export type UpdatePolygonPayload = {
  __typename?: 'UpdatePolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Polygon` that was updated by this mutation. */
  polygon?: Maybe<Polygon>;
  /** An edge for our `Polygon`. May be used by Relay 1. */
  polygonEdge?: Maybe<PolygonsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `Polygon`. */
  shape?: Maybe<Shape>;
};


/** The output of our update `Polygon` mutation. */
export type UpdatePolygonPayloadPolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<PolygonsOrderBy>>;
};

/** All input for the `updateProjectByNodeId` mutation. */
export type UpdateProjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Project` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** All input for the `updateProject` mutation. */
export type UpdateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `Project`. */
  contractor?: Maybe<Contractor>;
  /** The `Project` that was updated by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Project` mutation. */
export type UpdateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `updateProjectTagByNodeId` mutation. */
export type UpdateProjectTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTag` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectTag` being updated. */
  patch: ProjectTagPatch;
};

/** All input for the `updateProjectTag` mutation. */
export type UpdateProjectTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectTag` being updated. */
  patch: ProjectTagPatch;
};

/** The output of our update `ProjectTag` mutation. */
export type UpdateProjectTagPayload = {
  __typename?: 'UpdateProjectTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTag`. */
  contractor?: Maybe<Contractor>;
  /** The `ProjectTag` that was updated by this mutation. */
  projectTag?: Maybe<ProjectTag>;
  /** An edge for our `ProjectTag`. May be used by Relay 1. */
  projectTagEdge?: Maybe<ProjectTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectTag` mutation. */
export type UpdateProjectTagPayloadProjectTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** All input for the `updateProjectTemplateByNodeId` mutation. */
export type UpdateProjectTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectTemplate` being updated. */
  patch: ProjectTemplatePatch;
};

/** All input for the `updateProjectTemplate` mutation. */
export type UpdateProjectTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectTemplate` being updated. */
  patch: ProjectTemplatePatch;
};

/** All input for the `updateProjectTemplateOrderByNodeId` mutation. */
export type UpdateProjectTemplateOrderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplateOrder` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectTemplateOrder` being updated. */
  patch: ProjectTemplateOrderPatch;
};

/** All input for the `updateProjectTemplateOrderEntryByNodeId` mutation. */
export type UpdateProjectTemplateOrderEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplateOrderEntry` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectTemplateOrderEntry` being updated. */
  patch: ProjectTemplateOrderEntryPatch;
};

/** All input for the `updateProjectTemplateOrderEntry` mutation. */
export type UpdateProjectTemplateOrderEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectTemplateOrderEntry` being updated. */
  patch: ProjectTemplateOrderEntryPatch;
};

/** The output of our update `ProjectTemplateOrderEntry` mutation. */
export type UpdateProjectTemplateOrderEntryPayload = {
  __typename?: 'UpdateProjectTemplateOrderEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProjectTemplateOrder` that is related to this `ProjectTemplateOrderEntry`. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** The `ProjectTemplateOrderEntry` that was updated by this mutation. */
  projectTemplateOrderEntry?: Maybe<ProjectTemplateOrderEntry>;
  /** An edge for our `ProjectTemplateOrderEntry`. May be used by Relay 1. */
  projectTemplateOrderEntryEdge?: Maybe<ProjectTemplateOrderEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectTemplateOrderEntry` mutation. */
export type UpdateProjectTemplateOrderEntryPayloadProjectTemplateOrderEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntriesOrderBy>>;
};

/** All input for the `updateProjectTemplateOrderEntryViewByNodeId` mutation. */
export type UpdateProjectTemplateOrderEntryViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProjectTemplateOrderEntryView` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProjectTemplateOrderEntryView` being updated. */
  patch: ProjectTemplateOrderEntryViewPatch;
};

/** All input for the `updateProjectTemplateOrderEntryView` mutation. */
export type UpdateProjectTemplateOrderEntryViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectTemplateOrderEntryView` being updated. */
  patch: ProjectTemplateOrderEntryViewPatch;
};

/** The output of our update `ProjectTemplateOrderEntryView` mutation. */
export type UpdateProjectTemplateOrderEntryViewPayload = {
  __typename?: 'UpdateProjectTemplateOrderEntryViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrderEntryView`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** The `ProjectTemplateOrderEntryView` that was updated by this mutation. */
  projectTemplateOrderEntryView?: Maybe<ProjectTemplateOrderEntryView>;
  /** An edge for our `ProjectTemplateOrderEntryView`. May be used by Relay 1. */
  projectTemplateOrderEntryViewEdge?: Maybe<ProjectTemplateOrderEntryViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectTemplateOrderEntryView` mutation. */
export type UpdateProjectTemplateOrderEntryViewPayloadProjectTemplateOrderEntryViewEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrderEntryViewsOrderBy>>;
};

/** All input for the `updateProjectTemplateOrder` mutation. */
export type UpdateProjectTemplateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectTemplateOrder` being updated. */
  patch: ProjectTemplateOrderPatch;
};

/** The output of our update `ProjectTemplateOrder` mutation. */
export type UpdateProjectTemplateOrderPayload = {
  __typename?: 'UpdateProjectTemplateOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ProjectTemplate` that is related to this `ProjectTemplateOrder`. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** The `ProjectTemplateOrder` that was updated by this mutation. */
  projectTemplateOrder?: Maybe<ProjectTemplateOrder>;
  /** An edge for our `ProjectTemplateOrder`. May be used by Relay 1. */
  projectTemplateOrderEdge?: Maybe<ProjectTemplateOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectTemplateOrder` mutation. */
export type UpdateProjectTemplateOrderPayloadProjectTemplateOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplateOrdersOrderBy>>;
};

/** The output of our update `ProjectTemplate` mutation. */
export type UpdateProjectTemplatePayload = {
  __typename?: 'UpdateProjectTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Contractor` that is related to this `ProjectTemplate`. */
  contractor?: Maybe<Contractor>;
  /** The `ProjectTemplate` that was updated by this mutation. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** An edge for our `ProjectTemplate`. May be used by Relay 1. */
  projectTemplateEdge?: Maybe<ProjectTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectTemplate` mutation. */
export type UpdateProjectTemplatePayloadProjectTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};

/** All input for the `updateProtanProjectStepByNodeId` mutation. */
export type UpdateProtanProjectStepByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProtanProjectStep` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProtanProjectStep` being updated. */
  patch: ProtanProjectStepPatch;
};

/** All input for the `updateProtanProjectStepByProjectIdAndStep` mutation. */
export type UpdateProtanProjectStepByProjectIdAndStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProtanProjectStep` being updated. */
  patch: ProtanProjectStepPatch;
  projectId: Scalars['UUID'];
  step: ProtanProjectStepEnum;
};

/** All input for the `updateProtanProjectStep` mutation. */
export type UpdateProtanProjectStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProtanProjectStep` being updated. */
  patch: ProtanProjectStepPatch;
};

/** The output of our update `ProtanProjectStep` mutation. */
export type UpdateProtanProjectStepPayload = {
  __typename?: 'UpdateProtanProjectStepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProtanProjectStep`. */
  project?: Maybe<Project>;
  /** The `ProtanProjectStep` that was updated by this mutation. */
  protanProjectStep?: Maybe<ProtanProjectStep>;
  /** An edge for our `ProtanProjectStep`. May be used by Relay 1. */
  protanProjectStepEdge?: Maybe<ProtanProjectStepsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProtanProjectStep` mutation. */
export type UpdateProtanProjectStepPayloadProtanProjectStepEdgeArgs = {
  orderBy?: InputMaybe<Array<ProtanProjectStepsOrderBy>>;
};

/** All input for the `updateSavedViewByNameAndProjectId` mutation. */
export type UpdateSavedViewByNameAndProjectIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `SavedView` being updated. */
  patch: SavedViewPatch;
  projectId: Scalars['UUID'];
};

/** All input for the `updateSavedViewByNodeId` mutation. */
export type UpdateSavedViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SavedView` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SavedView` being updated. */
  patch: SavedViewPatch;
};

/** All input for the `updateSavedView` mutation. */
export type UpdateSavedViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SavedView` being updated. */
  patch: SavedViewPatch;
};

/** The output of our update `SavedView` mutation. */
export type UpdateSavedViewPayload = {
  __typename?: 'UpdateSavedViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SavedView`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavedView` that was updated by this mutation. */
  savedView?: Maybe<SavedView>;
  /** An edge for our `SavedView`. May be used by Relay 1. */
  savedViewEdge?: Maybe<SavedViewsEdge>;
};


/** The output of our update `SavedView` mutation. */
export type UpdateSavedViewPayloadSavedViewEdgeArgs = {
  orderBy?: InputMaybe<Array<SavedViewsOrderBy>>;
};

/** All input for the `updateShapeByNodeId` mutation. */
export type UpdateShapeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Shape` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Shape` being updated. */
  patch: ShapePatch;
};

/** All input for the `updateShapeByUrnAndDbId` mutation. */
export type UpdateShapeByUrnAndDbIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `Shape` being updated. */
  patch: ShapePatch;
  urn: Scalars['String'];
};

/** All input for the `updateShapeFolderByNodeId` mutation. */
export type UpdateShapeFolderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ShapeFolder` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ShapeFolder` being updated. */
  patch: ShapeFolderPatch;
};

/** All input for the `updateShapeFolderByProjectIdAndName` mutation. */
export type UpdateShapeFolderByProjectIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ShapeFolder` being updated. */
  patch: ShapeFolderPatch;
  projectId: Scalars['UUID'];
};

/** All input for the `updateShapeFolder` mutation. */
export type UpdateShapeFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ShapeFolder` being updated. */
  patch: ShapeFolderPatch;
};

/** The output of our update `ShapeFolder` mutation. */
export type UpdateShapeFolderPayload = {
  __typename?: 'UpdateShapeFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ShapeFolder`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShapeFolder` that was updated by this mutation. */
  shapeFolder?: Maybe<ShapeFolder>;
  /** An edge for our `ShapeFolder`. May be used by Relay 1. */
  shapeFolderEdge?: Maybe<ShapeFoldersEdge>;
};


/** The output of our update `ShapeFolder` mutation. */
export type UpdateShapeFolderPayloadShapeFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapeFoldersOrderBy>>;
};

/** All input for the `updateShape` mutation. */
export type UpdateShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Shape` being updated. */
  patch: ShapePatch;
};

/** The output of our update `Shape` mutation. */
export type UpdateShapePayload = {
  __typename?: 'UpdateShapePayload';
  /** Reads a single `AutoShape` that is related to this `Shape`. */
  autoShape?: Maybe<AutoShape>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Shape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shape` that was updated by this mutation. */
  shape?: Maybe<Shape>;
  /** An edge for our `Shape`. May be used by Relay 1. */
  shapeEdge?: Maybe<ShapesEdge>;
  /** Reads a single `ShapeFolder` that is related to this `Shape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
};


/** The output of our update `Shape` mutation. */
export type UpdateShapePayloadShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapesOrderBy>>;
};

/** All input for the `updateShapePointByNodeId` mutation. */
export type UpdateShapePointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ShapePoint` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ShapePoint` being updated. */
  patch: ShapePointPatch;
};

/** All input for the `updateShapePointByShapeId` mutation. */
export type UpdateShapePointByShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ShapePoint` being updated. */
  patch: ShapePointPatch;
  shapeId: Scalars['UUID'];
};

/** All input for the `updateShapePoint` mutation. */
export type UpdateShapePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ShapePoint` being updated. */
  patch: ShapePointPatch;
};

/** The output of our update `ShapePoint` mutation. */
export type UpdateShapePointPayload = {
  __typename?: 'UpdateShapePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shape` that is related to this `ShapePoint`. */
  shape?: Maybe<Shape>;
  /** The `ShapePoint` that was updated by this mutation. */
  shapePoint?: Maybe<ShapePoint>;
  /** An edge for our `ShapePoint`. May be used by Relay 1. */
  shapePointEdge?: Maybe<ShapePointsEdge>;
};


/** The output of our update `ShapePoint` mutation. */
export type UpdateShapePointPayloadShapePointEdgeArgs = {
  orderBy?: InputMaybe<Array<ShapePointsOrderBy>>;
};

/** All input for the `updateSharedLinkByInitialStateId` mutation. */
export type UpdateSharedLinkByInitialStateIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  initialStateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SharedLink` being updated. */
  patch: SharedLinkPatch;
};

/** All input for the `updateSharedLinkByNodeId` mutation. */
export type UpdateSharedLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SharedLink` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SharedLink` being updated. */
  patch: SharedLinkPatch;
};

/** All input for the `updateSharedLink` mutation. */
export type UpdateSharedLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SharedLink` being updated. */
  patch: SharedLinkPatch;
};

/** The output of our update `SharedLink` mutation. */
export type UpdateSharedLinkPayload = {
  __typename?: 'UpdateSharedLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `InitialState` that is related to this `SharedLink`. */
  initialState?: Maybe<InitialState>;
  /** Reads a single `Project` that is related to this `SharedLink`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SharedLink` that was updated by this mutation. */
  sharedLink?: Maybe<SharedLink>;
  /** An edge for our `SharedLink`. May be used by Relay 1. */
  sharedLinkEdge?: Maybe<SharedLinksEdge>;
};


/** The output of our update `SharedLink` mutation. */
export type UpdateSharedLinkPayloadSharedLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<SharedLinksOrderBy>>;
};

/** All input for the `updateSheetByNodeId` mutation. */
export type UpdateSheetByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Sheet` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Sheet` being updated. */
  patch: SheetPatch;
};

/** All input for the `updateSheetByProjectIdAndNameAndVersion` mutation. */
export type UpdateSheetByProjectIdAndNameAndVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `Sheet` being updated. */
  patch: SheetPatch;
  projectId: Scalars['UUID'];
  version: Scalars['Int'];
};

/** All input for the `updateSheet` mutation. */
export type UpdateSheetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Sheet` being updated. */
  patch: SheetPatch;
};

/** All input for the `updateSheetPageCalibrationByNodeId` mutation. */
export type UpdateSheetPageCalibrationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetPageCalibration` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetPageCalibration` being updated. */
  patch: SheetPageCalibrationPatch;
};

/** All input for the `updateSheetPageCalibration` mutation. */
export type UpdateSheetPageCalibrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pageNumber: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetPageCalibration` being updated. */
  patch: SheetPageCalibrationPatch;
  sheetId: Scalars['UUID'];
};

/** The output of our update `SheetPageCalibration` mutation. */
export type UpdateSheetPageCalibrationPayload = {
  __typename?: 'UpdateSheetPageCalibrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Sheet` that is related to this `SheetPageCalibration`. */
  sheet?: Maybe<Sheet>;
  /** The `SheetPageCalibration` that was updated by this mutation. */
  sheetPageCalibration?: Maybe<SheetPageCalibration>;
  /** An edge for our `SheetPageCalibration`. May be used by Relay 1. */
  sheetPageCalibrationEdge?: Maybe<SheetPageCalibrationsEdge>;
};


/** The output of our update `SheetPageCalibration` mutation. */
export type UpdateSheetPageCalibrationPayloadSheetPageCalibrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetPageCalibrationsOrderBy>>;
};

/** The output of our update `Sheet` mutation. */
export type UpdateSheetPayload = {
  __typename?: 'UpdateSheetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `Sheet`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Sheet` that was updated by this mutation. */
  sheet?: Maybe<Sheet>;
  /** An edge for our `Sheet`. May be used by Relay 1. */
  sheetEdge?: Maybe<SheetsEdge>;
};


/** The output of our update `Sheet` mutation. */
export type UpdateSheetPayloadSheetEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetsOrderBy>>;
};

/** All input for the `updateSheetShapeByNodeId` mutation. */
export type UpdateSheetShapeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShape` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetShape` being updated. */
  patch: SheetShapePatch;
};

/** All input for the `updateSheetShapeByUrnAndDbId` mutation. */
export type UpdateSheetShapeByUrnAndDbIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbId: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetShape` being updated. */
  patch: SheetShapePatch;
  urn: Scalars['String'];
};

/** All input for the `updateSheetShape` mutation. */
export type UpdateSheetShapeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SheetShape` being updated. */
  patch: SheetShapePatch;
};

/** All input for the `updateSheetShapeLegendByNodeId` mutation. */
export type UpdateSheetShapeLegendByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapeLegend` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetShapeLegend` being updated. */
  patch: SheetShapeLegendPatch;
};

/** All input for the `updateSheetShapeLegendBySheetShapeId` mutation. */
export type UpdateSheetShapeLegendBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SheetShapeLegend` being updated. */
  patch: SheetShapeLegendPatch;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `updateSheetShapeLegend` mutation. */
export type UpdateSheetShapeLegendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetShapeLegend` being updated. */
  patch: SheetShapeLegendPatch;
};

/** The output of our update `SheetShapeLegend` mutation. */
export type UpdateSheetShapeLegendPayload = {
  __typename?: 'UpdateSheetShapeLegendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Order` that is related to this `SheetShapeLegend`. */
  legendOrder?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLegend`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeLegend` that was updated by this mutation. */
  sheetShapeLegend?: Maybe<SheetShapeLegend>;
  /** An edge for our `SheetShapeLegend`. May be used by Relay 1. */
  sheetShapeLegendEdge?: Maybe<SheetShapeLegendsEdge>;
};


/** The output of our update `SheetShapeLegend` mutation. */
export type UpdateSheetShapeLegendPayloadSheetShapeLegendEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeLegendsOrderBy>>;
};

/** All input for the `updateSheetShapeLineByNodeId` mutation. */
export type UpdateSheetShapeLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapeLine` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetShapeLine` being updated. */
  patch: SheetShapeLinePatch;
};

/** All input for the `updateSheetShapeLineBySheetShapeId` mutation. */
export type UpdateSheetShapeLineBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SheetShapeLine` being updated. */
  patch: SheetShapeLinePatch;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `updateSheetShapeLine` mutation. */
export type UpdateSheetShapeLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetShapeLine` being updated. */
  patch: SheetShapeLinePatch;
};

/** The output of our update `SheetShapeLine` mutation. */
export type UpdateSheetShapeLinePayload = {
  __typename?: 'UpdateSheetShapeLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeLine`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeLine` that was updated by this mutation. */
  sheetShapeLine?: Maybe<SheetShapeLine>;
  /** An edge for our `SheetShapeLine`. May be used by Relay 1. */
  sheetShapeLineEdge?: Maybe<SheetShapeLinesEdge>;
};


/** The output of our update `SheetShapeLine` mutation. */
export type UpdateSheetShapeLinePayloadSheetShapeLineEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeLinesOrderBy>>;
};

/** The output of our update `SheetShape` mutation. */
export type UpdateSheetShapePayload = {
  __typename?: 'UpdateSheetShapePayload';
  /** Reads a single `AutoShape` that is related to this `SheetShape`. */
  autoShape?: Maybe<AutoShape>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SheetShape`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ShapeFolder` that is related to this `SheetShape`. */
  shapeFolderByFolder?: Maybe<ShapeFolder>;
  /** Reads a single `Sheet` that is related to this `SheetShape`. */
  sheet?: Maybe<Sheet>;
  /** The `SheetShape` that was updated by this mutation. */
  sheetShape?: Maybe<SheetShape>;
  /** An edge for our `SheetShape`. May be used by Relay 1. */
  sheetShapeEdge?: Maybe<SheetShapesEdge>;
};


/** The output of our update `SheetShape` mutation. */
export type UpdateSheetShapePayloadSheetShapeEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapesOrderBy>>;
};

/** All input for the `updateSheetShapePointByNodeId` mutation. */
export type UpdateSheetShapePointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapePoint` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetShapePoint` being updated. */
  patch: SheetShapePointPatch;
};

/** All input for the `updateSheetShapePointBySheetShapeId` mutation. */
export type UpdateSheetShapePointBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SheetShapePoint` being updated. */
  patch: SheetShapePointPatch;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `updateSheetShapePoint` mutation. */
export type UpdateSheetShapePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetShapePoint` being updated. */
  patch: SheetShapePointPatch;
};

/** The output of our update `SheetShapePoint` mutation. */
export type UpdateSheetShapePointPayload = {
  __typename?: 'UpdateSheetShapePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapePoint`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapePoint` that was updated by this mutation. */
  sheetShapePoint?: Maybe<SheetShapePoint>;
  /** An edge for our `SheetShapePoint`. May be used by Relay 1. */
  sheetShapePointEdge?: Maybe<SheetShapePointsEdge>;
};


/** The output of our update `SheetShapePoint` mutation. */
export type UpdateSheetShapePointPayloadSheetShapePointEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapePointsOrderBy>>;
};

/** All input for the `updateSheetShapePolygonByNodeId` mutation. */
export type UpdateSheetShapePolygonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapePolygon` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetShapePolygon` being updated. */
  patch: SheetShapePolygonPatch;
};

/** All input for the `updateSheetShapePolygonBySheetShapeId` mutation. */
export type UpdateSheetShapePolygonBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SheetShapePolygon` being updated. */
  patch: SheetShapePolygonPatch;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `updateSheetShapePolygon` mutation. */
export type UpdateSheetShapePolygonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetShapePolygon` being updated. */
  patch: SheetShapePolygonPatch;
};

/** The output of our update `SheetShapePolygon` mutation. */
export type UpdateSheetShapePolygonPayload = {
  __typename?: 'UpdateSheetShapePolygonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapePolygon`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapePolygon` that was updated by this mutation. */
  sheetShapePolygon?: Maybe<SheetShapePolygon>;
  /** An edge for our `SheetShapePolygon`. May be used by Relay 1. */
  sheetShapePolygonEdge?: Maybe<SheetShapePolygonsEdge>;
};


/** The output of our update `SheetShapePolygon` mutation. */
export type UpdateSheetShapePolygonPayloadSheetShapePolygonEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapePolygonsOrderBy>>;
};

/** All input for the `updateSheetShapeSplitLineByNodeId` mutation. */
export type UpdateSheetShapeSplitLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SheetShapeSplitLine` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SheetShapeSplitLine` being updated. */
  patch: SheetShapeSplitLinePatch;
};

/** All input for the `updateSheetShapeSplitLineBySheetShapeId` mutation. */
export type UpdateSheetShapeSplitLineBySheetShapeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SheetShapeSplitLine` being updated. */
  patch: SheetShapeSplitLinePatch;
  sheetShapeId: Scalars['UUID'];
};

/** All input for the `updateSheetShapeSplitLine` mutation. */
export type UpdateSheetShapeSplitLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SheetShapeSplitLine` being updated. */
  patch: SheetShapeSplitLinePatch;
};

/** The output of our update `SheetShapeSplitLine` mutation. */
export type UpdateSheetShapeSplitLinePayload = {
  __typename?: 'UpdateSheetShapeSplitLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SheetShape` that is related to this `SheetShapeSplitLine`. */
  sheetShape?: Maybe<SheetShape>;
  /** The `SheetShapeSplitLine` that was updated by this mutation. */
  sheetShapeSplitLine?: Maybe<SheetShapeSplitLine>;
  /** An edge for our `SheetShapeSplitLine`. May be used by Relay 1. */
  sheetShapeSplitLineEdge?: Maybe<SheetShapeSplitLinesEdge>;
};


/** The output of our update `SheetShapeSplitLine` mutation. */
export type UpdateSheetShapeSplitLinePayloadSheetShapeSplitLineEdgeArgs = {
  orderBy?: InputMaybe<Array<SheetShapeSplitLinesOrderBy>>;
};

/** All input for the `updateSparkelAiAnalysisByNodeId` mutation. */
export type UpdateSparkelAiAnalysisByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SparkelAiAnalysis` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SparkelAiAnalysis` being updated. */
  patch: SparkelAiAnalysisPatch;
};

/** All input for the `updateSparkelAiAnalysis` mutation. */
export type UpdateSparkelAiAnalysisInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SparkelAiAnalysis` being updated. */
  patch: SparkelAiAnalysisPatch;
};

/** The output of our update `SparkelAiAnalysis` mutation. */
export type UpdateSparkelAiAnalysisPayload = {
  __typename?: 'UpdateSparkelAiAnalysisPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SparkelAiAnalysis`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SparkelAiAnalysis` that was updated by this mutation. */
  sparkelAiAnalysis?: Maybe<SparkelAiAnalysis>;
  /** An edge for our `SparkelAiAnalysis`. May be used by Relay 1. */
  sparkelAiAnalysisEdge?: Maybe<SparkelAiAnalysesEdge>;
};


/** The output of our update `SparkelAiAnalysis` mutation. */
export type UpdateSparkelAiAnalysisPayloadSparkelAiAnalysisEdgeArgs = {
  orderBy?: InputMaybe<Array<SparkelAiAnalysesOrderBy>>;
};

/** All input for the `updateSparkelPropertyByNodeId` mutation. */
export type UpdateSparkelPropertyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SparkelProperty` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SparkelProperty` being updated. */
  patch: SparkelPropertyPatch;
};

/** All input for the `updateSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySet` mutation. */
export type UpdateSparkelPropertyByProjectIdAndModelUrnAndDbIdAndPropertySetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dbId: Scalars['Int'];
  modelUrn: Scalars['String'];
  /** An object where the defined keys will be set on the `SparkelProperty` being updated. */
  patch: SparkelPropertyPatch;
  projectId: Scalars['UUID'];
  propertySet: Scalars['String'];
};

/** All input for the `updateSparkelProperty` mutation. */
export type UpdateSparkelPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SparkelProperty` being updated. */
  patch: SparkelPropertyPatch;
};

/** The output of our update `SparkelProperty` mutation. */
export type UpdateSparkelPropertyPayload = {
  __typename?: 'UpdateSparkelPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `SparkelProperty`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SparkelProperty` that was updated by this mutation. */
  sparkelProperty?: Maybe<SparkelProperty>;
  /** An edge for our `SparkelProperty`. May be used by Relay 1. */
  sparkelPropertyEdge?: Maybe<SparkelPropertiesEdge>;
};


/** The output of our update `SparkelProperty` mutation. */
export type UpdateSparkelPropertyPayloadSparkelPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<SparkelPropertiesOrderBy>>;
};

/** All input for the `upsertProtanProjectStep` mutation. */
export type UpsertProtanProjectStepInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  theProjectId: Scalars['UUID'];
  theStatus: ProtanProjectStepStatusEnum;
  theStep: ProtanProjectStepEnum;
};

/** The output of our `upsertProtanProjectStep` mutation. */
export type UpsertProtanProjectStepPayload = {
  __typename?: 'UpsertProtanProjectStepPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  protanProjectSteps?: Maybe<Array<ProtanProjectStep>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type User = {
  __typename?: 'User';
  accessProjectIds?: Maybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['UUID'];
  password?: Maybe<Scalars['String']>;
};

/** All input for the `verifyApiClientSecret` mutation. */
export type VerifyApiClientSecretInput = {
  _clientId: Scalars['UUID'];
  _providedSecret: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `verifyApiClientSecret` mutation. */
export type VerifyApiClientSecretPayload = {
  __typename?: 'VerifyApiClientSecretPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum ViewSection {
  Box = 'BOX',
  X = 'X',
  Y = 'Y',
  Z = 'Z'
}

/** A filter to be used against ViewSection fields. All fields are combined with a logical ‘and.’ */
export type ViewSectionFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ViewSection>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ViewSection>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ViewSection>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ViewSection>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ViewSection>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ViewSection>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ViewSection>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ViewSection>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ViewSection>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ViewSection>>;
};

export type ViewSettingsType = {
  __typename?: 'ViewSettingsType';
  focusMode?: Maybe<Scalars['Boolean']>;
  ghosting?: Maybe<Scalars['Boolean']>;
  orthographicMode?: Maybe<Scalars['Boolean']>;
  showLabels?: Maybe<Scalars['Boolean']>;
};

/** A filter to be used against `ViewSettingsType` object types. All fields are combined with a logical ‘and.’ */
export type ViewSettingsTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ViewSettingsTypeFilter>>;
  /** Filter by the object’s `focusMode` field. */
  focusMode?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `ghosting` field. */
  ghosting?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ViewSettingsTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ViewSettingsTypeFilter>>;
  /** Filter by the object’s `orthographicMode` field. */
  orthographicMode?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `showLabels` field. */
  showLabels?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `ViewSettingsType` */
export type ViewSettingsTypeInput = {
  focusMode?: InputMaybe<Scalars['Boolean']>;
  ghosting?: InputMaybe<Scalars['Boolean']>;
  orthographicMode?: InputMaybe<Scalars['Boolean']>;
  showLabels?: InputMaybe<Scalars['Boolean']>;
};

export type VolumeUnitSettingType = {
  __typename?: 'VolumeUnitSettingType';
  rounding?: Maybe<RoundingEnum>;
  units?: Maybe<VolumeUnitTypeEnum>;
};

/** A filter to be used against `VolumeUnitSettingType` object types. All fields are combined with a logical ‘and.’ */
export type VolumeUnitSettingTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VolumeUnitSettingTypeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VolumeUnitSettingTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VolumeUnitSettingTypeFilter>>;
  /** Filter by the object’s `rounding` field. */
  rounding?: InputMaybe<RoundingEnumFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<VolumeUnitTypeEnumFilter>;
};

/** An input for mutations affecting `VolumeUnitSettingType` */
export type VolumeUnitSettingTypeInput = {
  rounding?: InputMaybe<RoundingEnum>;
  units?: InputMaybe<VolumeUnitTypeEnum>;
};

export enum VolumeUnitTypeEnum {
  CentimetersCubed = 'CENTIMETERS_CUBED',
  DecimalFeetCubed = 'DECIMAL_FEET_CUBED',
  DecimalInchesCubed = 'DECIMAL_INCHES_CUBED',
  DecimetersCubed = 'DECIMETERS_CUBED',
  FeetAndFractionalInchesCubed = 'FEET_AND_FRACTIONAL_INCHES_CUBED',
  FractionalInchesCubed = 'FRACTIONAL_INCHES_CUBED',
  MetersCubed = 'METERS_CUBED',
  MillimetersCubed = 'MILLIMETERS_CUBED'
}

/** A filter to be used against VolumeUnitTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type VolumeUnitTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VolumeUnitTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VolumeUnitTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VolumeUnitTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VolumeUnitTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VolumeUnitTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VolumeUnitTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VolumeUnitTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VolumeUnitTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VolumeUnitTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VolumeUnitTypeEnum>>;
};

export type ElementWithProperties = {
  category: Scalars['String'];
  dbId: Scalars['Int'];
  material?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** An object where the defined keys will be set on the `autoShape` being updated. */
export type UpdateAutoShapeOnAutoShapeForAutoShapesProjectIdFkeyPatch = {
  algorithmInput?: InputMaybe<Scalars['JSON']>;
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `autoShape` being updated. */
export type UpdateAutoShapeOnShapeForShapesAutoShapeIdFkeyPatch = {
  algorithmInput?: InputMaybe<Scalars['JSON']>;
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `autoShape` being updated. */
export type UpdateAutoShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyPatch = {
  algorithmInput?: InputMaybe<Scalars['JSON']>;
  algorithmType?: InputMaybe<AutoShapeAlgorithmType>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<AutoShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
  shapes?: InputMaybe<ShapesAutoShapeIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesAutoShapeIdFkeyInverseInput>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<AutoShapeStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `comment` being updated. */
export type UpdateCommentOnCommentForCommentsOrderIdFkeyPatch = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `comment` being updated. */
export type UpdateCommentOnCommentForCommentsParentIdFkeyPatch = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `comment` being updated. */
export type UpdateCommentOnCommentForCommentsProjectIdFkeyPatch = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `comment` being updated. */
export type UpdateCommentOnCommentForCommentsRepliesFkeyPatch = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  savedViewsId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `comment` being updated. */
export type UpdateCommentOnCommentForCommentsSavedViewsIdFkeyPatch = {
  anchorPoint2D?: InputMaybe<Point2TypeInput>;
  anchorPoint3D?: InputMaybe<Point3TypeInput>;
  commentToParentId?: InputMaybe<CommentsParentIdFkeyInput>;
  commentToReplies?: InputMaybe<CommentsRepliesFkeyInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAtTz?: InputMaybe<Scalars['Datetime']>;
  elementIdentifiers?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<CommentsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<CommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  readBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  replies?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<CommentsSavedViewsIdFkeyInput>;
  username?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
export type UpdateCompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyPatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
export type UpdateCompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyPatch = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  rowId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companyDatabaseCell` being updated. */
export type UpdateCompanyDatabaseCellOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyPatch = {
  columnId?: InputMaybe<Scalars['UUID']>;
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInput>;
  /** Denormalized from rows table for efficient filtering and RLS checks */
  databaseId?: InputMaybe<Scalars['UUID']>;
  /** Value stored as text, parsed according to the column type */
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
export type UpdateCompanyDatabaseColumnOnCompanyDatabaseCellForCompanyDatabaseCellsColumnIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Display order of columns in the UI (0-indexed) */
  orderIndex?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CompanyDatabaseColumnType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
export type UpdateCompanyDatabaseColumnOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Display order of columns in the UI (0-indexed) */
  orderIndex?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CompanyDatabaseColumnType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabaseColumn` being updated. */
export type UpdateCompanyDatabaseColumnOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToSearchColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheSearchColumnIdFkeyInverseInput>;
  companyDatabaseLookupCachesToValueColumnIdUsingId?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Display order of columns in the UI (0-indexed) */
  orderIndex?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CompanyDatabaseColumnType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabaseImportJob` being updated. */
export type UpdateCompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyPatch = {
  companyDatabasis?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInput>;
  contractor?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  errorCount?: InputMaybe<Scalars['Int']>;
  errorSummary?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  /** S3 key for the uploaded import file */
  fileStorageKey?: InputMaybe<Scalars['String']>;
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Import mode: replace (truncate then import) or append */
  mode?: InputMaybe<CompanyDatabaseImportMode>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `companyDatabaseImportJob` being updated. */
export type UpdateCompanyDatabaseImportJobOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyPatch = {
  companyDatabasis?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInput>;
  contractor?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorCount?: InputMaybe<Scalars['Int']>;
  errorSummary?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  /** S3 key for the uploaded import file */
  fileStorageKey?: InputMaybe<Scalars['String']>;
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  insertedRows?: InputMaybe<Scalars['Int']>;
  /** Import mode: replace (truncate then import) or append */
  mode?: InputMaybe<CompanyDatabaseImportMode>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<CompanyDatabaseImportJobStatus>;
  totalRows?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
export type UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyPatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
export type UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyPatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
export type UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyPatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
export type UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheSearchColumnIdFkeyPatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  valueColumnId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupCache` being updated. */
export type UpdateCompanyDatabaseLookupCacheOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheValueColumnIdFkeyPatch = {
  companyDatabaseColumn?: InputMaybe<CompanyDatabaseLookupCacheValueColumnIdFkeyInput>;
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInput>;
  companyDatabaseRow?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInput>;
  confidence?: InputMaybe<Scalars['BigFloat']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
  reasoning?: InputMaybe<Scalars['String']>;
  resolvedRowId?: InputMaybe<Scalars['UUID']>;
  resolvedValue?: InputMaybe<Scalars['String']>;
  searchColumnId?: InputMaybe<Scalars['UUID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupJob` being updated. */
export type UpdateCompanyDatabaseLookupJobOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyPatch = {
  companyDatabaseLookupProfile?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInput>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** The order entries to resolve lookups for */
  orderEntryIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  processedItems?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<LookupJobStatus>;
  /** AWS Step Function execution ARN for debugging */
  stepFunctionExecutionArn?: InputMaybe<Scalars['String']>;
  totalItems?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
export type UpdateCompanyDatabaseLookupProfileOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheLookupProfileIdFkeyPatch = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name?: InputMaybe<Scalars['String']>;
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
export type UpdateCompanyDatabaseLookupProfileOnCompanyDatabaseLookupJobForCompanyDatabaseLookupJobsLookupProfileIdFkeyPatch = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name?: InputMaybe<Scalars['String']>;
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabaseLookupProfile` being updated. */
export type UpdateCompanyDatabaseLookupProfileOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyPatch = {
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheLookupProfileIdFkeyInverseInput>;
  companyDatabaseLookupJobs?: InputMaybe<CompanyDatabaseLookupJobsLookupProfileIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Configurable extraction, comparison, and scoring rules. Use required=true for hard filters, required=false with score_weight for soft scoring (positive=boost, negative=penalize) */
  matchCriteria?: InputMaybe<Array<InputMaybe<MatchCriterionInput>>>;
  name?: InputMaybe<Scalars['String']>;
  /** LLM system prompt with global rules like "prefer same supplier" */
  systemPrompt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
export type UpdateCompanyDatabaseRowOnCompanyDatabaseCellForCompanyDatabaseCellsRowIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex?: InputMaybe<Scalars['BigInt']>;
};

/** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
export type UpdateCompanyDatabaseRowOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheResolvedRowIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  databaseId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex?: InputMaybe<Scalars['BigInt']>;
};

/** An object where the defined keys will be set on the `companyDatabaseRow` being updated. */
export type UpdateCompanyDatabaseRowOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsRowIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheResolvedRowIdFkeyInverseInput>;
  companyDatabasis?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  /** Monotonic index for keyset pagination */
  rowIndex?: InputMaybe<Scalars['BigInt']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabaseCellForCompanyDatabaseCellsDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabaseColumnForCompanyDatabaseColumnsDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabaseLookupCacheForCompanyDatabaseLookupCacheDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabaseLookupProfileForCompanyDatabaseLookupProfilesDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabaseRowForCompanyDatabaseRowsDatabaseIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `companyDatabasis` being updated. */
export type UpdateCompanyDatabasisOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyPatch = {
  companyDatabaseCells?: InputMaybe<CompanyDatabaseCellsDatabaseIdFkeyInverseInput>;
  companyDatabaseColumns?: InputMaybe<CompanyDatabaseColumnsDatabaseIdFkeyInverseInput>;
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupCaches?: InputMaybe<CompanyDatabaseLookupCacheDatabaseIdFkeyInverseInput>;
  companyDatabaseLookupProfiles?: InputMaybe<CompanyDatabaseLookupProfilesDatabaseIdFkeyInverseInput>;
  companyDatabaseRows?: InputMaybe<CompanyDatabaseRowsDatabaseIdFkeyInverseInput>;
  contractor?: InputMaybe<CompanyDatabasesContractorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastImportAt?: InputMaybe<Scalars['Datetime']>;
  /** Status of the most recent import */
  lastImportStatus?: InputMaybe<CompanyDatabaseImportStatus>;
  name?: InputMaybe<Scalars['String']>;
  /** Cached count of rows for display purposes */
  rowCount?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnCompanyDatabaseImportJobForCompanyDatabaseImportJobsContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnCompanyDatabasisForCompanyDatabasesContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnCopilotExchangeForCopilotExchangesContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnFlowForFlowsContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnProjectForProjectsContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnProjectTagForProjectTagsContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractor` being updated. */
export type UpdateContractorOnProjectTemplateForProjectTemplatesContractorIdFkeyPatch = {
  companyDatabaseImportJobs?: InputMaybe<CompanyDatabaseImportJobsContractorIdFkeyInverseInput>;
  companyDatabases?: InputMaybe<CompanyDatabasesContractorIdFkeyInverseInput>;
  contractorTier?: InputMaybe<ContractorTierEnum>;
  copilotExchanges?: InputMaybe<CopilotExchangesContractorIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flowMailbox?: InputMaybe<FlowMailboxesContractorIdFkeyInverseInput>;
  flows?: InputMaybe<FlowsContractorIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryTemplates?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInverseInput>;
  projectTags?: InputMaybe<ProjectTagsContractorIdFkeyInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplatesContractorIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectsContractorIdFkeyInverseInput>;
  tenant?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `copilotExchange` being updated. */
export type UpdateCopilotExchangeOnCopilotExchangeForCopilotExchangesContractorIdFkeyPatch = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model?: InputMaybe<Scalars['String']>;
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `copilotExchange` being updated. */
export type UpdateCopilotExchangeOnCopilotExchangeForCopilotExchangesProjectIdFkeyPatch = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  id?: InputMaybe<Scalars['UUID']>;
  model?: InputMaybe<Scalars['String']>;
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `copilotExchange` being updated. */
export type UpdateCopilotExchangeOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyPatch = {
  contractor?: InputMaybe<CopilotExchangesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchangesFeedback?: InputMaybe<CopilotExchangesFeedbackIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<CopilotError>;
  model?: InputMaybe<Scalars['String']>;
  modelResponse?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<CopilotExchangesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `copilotExchangesFeedback` being updated. */
export type UpdateCopilotExchangesFeedbackOnCopilotExchangesFeedbackForCopilotExchangesFeedbackIdFkeyPatch = {
  approval?: InputMaybe<Scalars['Boolean']>;
  copilotExchange?: InputMaybe<CopilotExchangesFeedbackIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  feedback?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `customField` being updated. */
export type UpdateCustomFieldOnCustomFieldForCustomFieldsOrderColumnIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumn?: InputMaybe<CustomFieldsOrderColumnIdFkeyInput>;
  orderEntry?: InputMaybe<CustomFieldsOrderEntryIdFkeyInput>;
  orderEntryId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<QuantityTypeInput>;
};

/** An object where the defined keys will be set on the `customField` being updated. */
export type UpdateCustomFieldOnCustomFieldForCustomFieldsOrderEntryIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumn?: InputMaybe<CustomFieldsOrderColumnIdFkeyInput>;
  orderColumnId?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<CustomFieldsOrderEntryIdFkeyInput>;
  value?: InputMaybe<QuantityTypeInput>;
};

/** An object where the defined keys will be set on the `customFieldTemplate` being updated. */
export type UpdateCustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumnTemplate?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInput>;
  projectTemplateOrderEntry?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput>;
  projectTemplateOrderEntryId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<QuantityTypeInput>;
};

/** An object where the defined keys will be set on the `customFieldTemplate` being updated. */
export type UpdateCustomFieldTemplateOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  orderColumnTemplate?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInput>;
  orderColumnTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntry?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInput>;
  value?: InputMaybe<QuantityTypeInput>;
};

/** An object where the defined keys will be set on the `extrudedPolygon` being updated. */
export type UpdateExtrudedPolygonOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon?: InputMaybe<MultiPolygon3TypeInput>;
  plane?: InputMaybe<PlaneTypeInput>;
  shape?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInput>;
  thickness?: InputMaybe<Scalars['Float']>;
  unitScale?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `flowAction` being updated. */
export type UpdateFlowActionOnFlowActionForFlowActionsFlowIdFkeyPatch = {
  actionConfig?: InputMaybe<Scalars['JSON']>;
  actionType?: InputMaybe<FlowActionType>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flow?: InputMaybe<FlowActionsFlowIdFkeyInput>;
  flowAction?: InputMaybe<FlowActionsParentLoopActionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  loopConfig?: InputMaybe<Scalars['JSON']>;
  outputKey?: InputMaybe<Scalars['String']>;
  parentLoopActionId?: InputMaybe<Scalars['UUID']>;
  position?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `flowAction` being updated. */
export type UpdateFlowActionOnFlowActionForFlowActionsParentLoopActionIdFkeyPatch = {
  actionConfig?: InputMaybe<Scalars['JSON']>;
  actionType?: InputMaybe<FlowActionType>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flow?: InputMaybe<FlowActionsFlowIdFkeyInput>;
  flowAction?: InputMaybe<FlowActionsParentLoopActionIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  loopConfig?: InputMaybe<Scalars['JSON']>;
  outputKey?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `flowExecution` being updated. */
export type UpdateFlowExecutionOnFlowExecutionForFlowExecutionsFlowIdFkeyPatch = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdResources?: InputMaybe<Scalars['JSON']>;
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<FlowExecutionsFlowIdFkeyInput>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  outputData?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<FlowExecutionStatus>;
};

/** An object where the defined keys will be set on the `flowExecution` being updated. */
export type UpdateFlowExecutionOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyPatch = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdResources?: InputMaybe<Scalars['JSON']>;
  currentActionPosition?: InputMaybe<Scalars['Int']>;
  errorActionPosition?: InputMaybe<Scalars['Int']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<FlowExecutionsFlowIdFkeyInput>;
  flowId?: InputMaybe<Scalars['UUID']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  lambdaRequestId?: InputMaybe<Scalars['String']>;
  outputData?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<FlowExecutionStatus>;
};

/** An object where the defined keys will be set on the `flowMailboxMessage` being updated. */
export type UpdateFlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesFlowExecutionIdFkeyPatch = {
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  direction?: InputMaybe<Scalars['String']>;
  flowExecution?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInput>;
  flowMailbox?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInput>;
  fromAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mailboxId?: InputMaybe<Scalars['UUID']>;
  messageId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `flowMailboxMessage` being updated. */
export type UpdateFlowMailboxMessageOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyPatch = {
  ccAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  direction?: InputMaybe<Scalars['String']>;
  flowExecution?: InputMaybe<FlowMailboxMessagesFlowExecutionIdFkeyInput>;
  flowExecutionId?: InputMaybe<Scalars['UUID']>;
  flowMailbox?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInput>;
  fromAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  messageId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `flowMailbox` being updated. */
export type UpdateFlowMailboxOnFlowMailboxForFlowMailboxesContractorIdFkeyPatch = {
  contractor?: InputMaybe<FlowMailboxesContractorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart?: InputMaybe<Scalars['String']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `flowMailbox` being updated. */
export type UpdateFlowMailboxOnFlowMailboxMessageForFlowMailboxMessagesMailboxIdFkeyPatch = {
  contractor?: InputMaybe<FlowMailboxesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** The domain part of the email address. Default is flow.sparkel.ai. */
  emailDomain?: InputMaybe<Scalars['String']>;
  /** The local part of the email address (before @). Combined with email_domain forms the full address. */
  emailLocalPart?: InputMaybe<Scalars['String']>;
  flowMailboxMessages?: InputMaybe<FlowMailboxMessagesMailboxIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `flow` being updated. */
export type UpdateFlowOnFlowActionForFlowActionsFlowIdFkeyPatch = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType?: InputMaybe<FlowTriggerType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `flow` being updated. */
export type UpdateFlowOnFlowExecutionForFlowExecutionsFlowIdFkeyPatch = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType?: InputMaybe<FlowTriggerType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `flow` being updated. */
export type UpdateFlowOnFlowForFlowsContractorIdFkeyPatch = {
  contractor?: InputMaybe<FlowsContractorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  flowActions?: InputMaybe<FlowActionsFlowIdFkeyInverseInput>;
  flowExecutions?: InputMaybe<FlowExecutionsFlowIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<Scalars['JSON']>;
  triggerType?: InputMaybe<FlowTriggerType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `historyEvent` being updated. */
export type UpdateHistoryEventOnHistoryEventForHistoryEventsProjectIdFkeyPatch = {
  author?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  id?: InputMaybe<Scalars['UUID']>;
  isCheckpoint?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  project?: InputMaybe<HistoryEventsProjectIdFkeyInput>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resourceName?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<EventResource>;
  stateKey?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `initialState` being updated. */
export type UpdateInitialStateOnInitialStateForInitialStatesProjectIdFkeyPatch = {
  expandedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAccessToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings?: InputMaybe<ViewSettingsTypeInput>;
};

/** An object where the defined keys will be set on the `initialState` being updated. */
export type UpdateInitialStateOnInitialStateForInitialStatesViewIdFkeyPatch = {
  expandedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAccessToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewSettings?: InputMaybe<ViewSettingsTypeInput>;
};

/** An object where the defined keys will be set on the `initialState` being updated. */
export type UpdateInitialStateOnSharedLinkForSharedLinksInitialStateIdFkeyPatch = {
  expandedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAccessToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<InitialStatesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  savedView?: InputMaybe<InitialStatesViewIdFkeyInput>;
  selectedOrderEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sharedLink?: InputMaybe<SharedLinksInitialStateIdFkeyInverseInput>;
  viewId?: InputMaybe<Scalars['UUID']>;
  viewSettings?: InputMaybe<ViewSettingsTypeInput>;
};

/** An object where the defined keys will be set on the `issueComment` being updated. */
export type UpdateIssueCommentOnIssueCommentForIssueCommentsIssueIdFkeyPatch = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  issue?: InputMaybe<IssueCommentsIssueIdFkeyInput>;
  project?: InputMaybe<IssueCommentsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `issueComment` being updated. */
export type UpdateIssueCommentOnIssueCommentForIssueCommentsProjectIdFkeyPatch = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  issue?: InputMaybe<IssueCommentsIssueIdFkeyInput>;
  issueId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<IssueCommentsProjectIdFkeyInput>;
};

/** An object where the defined keys will be set on the `issue` being updated. */
export type UpdateIssueOnIssueCommentForIssueCommentsIssueIdFkeyPatch = {
  assignedTo?: InputMaybe<Scalars['String']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  issueComments?: InputMaybe<IssueCommentsIssueIdFkeyInverseInput>;
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  project?: InputMaybe<IssuesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<IssueStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `issue` being updated. */
export type UpdateIssueOnIssueForIssuesProjectIdFkeyPatch = {
  assignedTo?: InputMaybe<Scalars['String']>;
  commentCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  issueComments?: InputMaybe<IssueCommentsIssueIdFkeyInverseInput>;
  lastUpdated?: InputMaybe<Scalars['Datetime']>;
  project?: InputMaybe<IssuesProjectIdFkeyInput>;
  status?: InputMaybe<IssueStatusEnum>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `line` being updated. */
export type UpdateLineOnLineForLinesShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points?: InputMaybe<Array<InputMaybe<Point3TypeInput>>>;
  shape?: InputMaybe<LinesShapeIdFkeyInput>;
  unitScale?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `model` being updated. */
export type UpdateModelOnModelForModelsProjectIdFkeyPatch = {
  activeViewGuid?: InputMaybe<Scalars['String']>;
  availableViewGuids?: InputMaybe<Array<InputMaybe<ModelViewInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  forgeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ifcCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ifcLayers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  objTranslationStatus?: InputMaybe<ObjTranslationStatus>;
  project?: InputMaybe<ModelsProjectIdFkeyInput>;
  propertySets?: InputMaybe<Array<InputMaybe<PropertySetTypeInput>>>;
  revitCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revitLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<ModelProcessingStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `orderColumn` being updated. */
export type UpdateOrderColumnOnCustomFieldForCustomFieldsOrderColumnIdFkeyPatch = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType?: InputMaybe<ColumnType>;
  customFields?: InputMaybe<CustomFieldsOrderColumnIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderColumnsOrderIdFkeyInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  showTotal?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `orderColumn` being updated. */
export type UpdateOrderColumnOnOrderColumnForOrderColumnsOrderIdFkeyPatch = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType?: InputMaybe<ColumnType>;
  customFields?: InputMaybe<CustomFieldsOrderColumnIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderColumnsOrderIdFkeyInput>;
  showTotal?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `orderColumnTemplate` being updated. */
export type UpdateOrderColumnTemplateOnCustomFieldTemplateForCustomFieldTemplatesOrderColumnTemplateIdFkeyPatch = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType?: InputMaybe<ColumnType>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectTemplateOrder?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `orderColumnTemplate` being updated. */
export type UpdateOrderColumnTemplateOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyPatch = {
  columnOrder?: InputMaybe<Scalars['Int']>;
  columnType?: InputMaybe<ColumnType>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesOrderColumnTemplateIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectTemplateOrder?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInput>;
};

/** An object where the defined keys will be set on the `orderEntryCache` being updated. */
export type UpdateOrderEntryCacheOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  orderEntry?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `orderEntry` being updated. */
export type UpdateOrderEntryOnCustomFieldForCustomFieldsOrderEntryIdFkeyPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `orderEntry` being updated. */
export type UpdateOrderEntryOnOrderEntryCacheForOrderEntryCacheOrderEntryIdFkeyPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  orderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `orderEntry` being updated. */
export type UpdateOrderEntryOnOrderEntryForOrderEntriesOrderIdFkeyPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<CustomFieldsOrderEntryIdFkeyInverseInput>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderEntriesOrderIdFkeyInput>;
  orderEntryCache?: InputMaybe<OrderEntryCacheOrderEntryIdFkeyInverseInput>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateId?: InputMaybe<Scalars['UUID']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `orderEntryTemplate` being updated. */
export type UpdateOrderEntryTemplateOnOrderEntryTemplateForOrderEntryTemplatesContractorIdFkeyPatch = {
  contractor?: InputMaybe<OrderEntryTemplatesContractorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFields?: InputMaybe<Array<InputMaybe<TemplateCustomFieldTypeInput>>>;
  elementIdentifiersDbid?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  templateName?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `orderEntryView` being updated. */
export type UpdateOrderEntryViewOnOrderEntryViewForOrderEntryViewsProjectIdFkeyPatch = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  globalFilter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<OrderEntryViewsProjectIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  visibleColumns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `order` being updated. */
export type UpdateOrderOnCommentForCommentsOrderIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `order` being updated. */
export type UpdateOrderOnOrderColumnForOrderColumnsOrderIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `order` being updated. */
export type UpdateOrderOnOrderEntryForOrderEntriesOrderIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `order` being updated. */
export type UpdateOrderOnOrderForOrdersProjectIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `order` being updated. */
export type UpdateOrderOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  columnNameMapping?: InputMaybe<Scalars['JSON']>;
  comments?: InputMaybe<CommentsOrderIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumns?: InputMaybe<OrderColumnsOrderIdFkeyInverseInput>;
  orderEntries?: InputMaybe<OrderEntriesOrderIdFkeyInverseInput>;
  project?: InputMaybe<OrdersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetShapeLegends?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInverseInput>;
  status?: InputMaybe<OrderStatus>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `polygon` being updated. */
export type UpdatePolygonOnPolygonForPolygonsShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon?: InputMaybe<MultiPolygon3TypeInput>;
  plane?: InputMaybe<PlaneTypeInput>;
  shape?: InputMaybe<PolygonsShapeIdFkeyInput>;
  unitScale?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnAutoShapeForAutoShapesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnCommentForCommentsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnCopilotExchangeForCopilotExchangesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnHistoryEventForHistoryEventsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnInitialStateForInitialStatesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnIssueCommentForIssueCommentsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnIssueForIssuesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnModelForModelsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnOrderEntryViewForOrderEntryViewsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnOrderForOrdersProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectsContractorIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProtanProjectStepForProtanProjectStepsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnSavedViewForSavedViewsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnShapeFolderForShapeFoldersProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnShapeForShapesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnSharedLinkForSharedLinksProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnSheetForSheetsProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnSheetShapeForSheetShapesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnSparkelPropertyForSparkelPropertiesProjectIdFkeyPatch = {
  autoShapes?: InputMaybe<AutoShapesProjectIdFkeyInverseInput>;
  comments?: InputMaybe<CommentsProjectIdFkeyInverseInput>;
  contractor?: InputMaybe<ProjectsContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  copilotExchanges?: InputMaybe<CopilotExchangesProjectIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyEvents?: InputMaybe<HistoryEventsProjectIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesProjectIdFkeyInverseInput>;
  issueComments?: InputMaybe<IssueCommentsProjectIdFkeyInverseInput>;
  issues?: InputMaybe<IssuesProjectIdFkeyInverseInput>;
  models?: InputMaybe<ModelsProjectIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  orderEntryViews?: InputMaybe<OrderEntryViewsProjectIdFkeyInverseInput>;
  orders?: InputMaybe<OrdersProjectIdFkeyInverseInput>;
  protanProjectSteps?: InputMaybe<ProtanProjectStepsProjectIdFkeyInverseInput>;
  savedViews?: InputMaybe<SavedViewsProjectIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectSettingsTypeInput>;
  shapeFolders?: InputMaybe<ShapeFoldersProjectIdFkeyInverseInput>;
  shapes?: InputMaybe<ShapesProjectIdFkeyInverseInput>;
  sharedLinks?: InputMaybe<SharedLinksProjectIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesProjectIdFkeyInverseInput>;
  sheets?: InputMaybe<SheetsProjectIdFkeyInverseInput>;
  sparkelAiAnalyses?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInverseInput>;
  sparkelProperties?: InputMaybe<SparkelPropertiesProjectIdFkeyInverseInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  templateId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectTag` being updated. */
export type UpdateProjectTagOnProjectTagForProjectTagsContractorIdFkeyPatch = {
  color?: InputMaybe<TagColorScheme>;
  contractor?: InputMaybe<ProjectTagsContractorIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnProjectTemplateForProjectTemplatesContractorIdFkeyPatch = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyPatch = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyPatch = {
  contractor?: InputMaybe<ProjectTemplatesContractorIdFkeyInput>;
  contractorId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  originalProjectId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntryViews?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInverseInput>;
  projectTemplateOrders?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInverseInput>;
  settings?: InputMaybe<ProjectTemplateSettingsInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectTemplateOrderEntry` being updated. */
export type UpdateProjectTemplateOrderEntryOnCustomFieldTemplateForCustomFieldTemplatesProjectTemplateOrderEntryIdFkeyPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrder?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput>;
  projectTemplateOrderId?: InputMaybe<Scalars['UUID']>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `projectTemplateOrderEntry` being updated. */
export type UpdateProjectTemplateOrderEntryOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyPatch = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currency?: InputMaybe<CurrencyEnum>;
  customFieldTemplates?: InputMaybe<CustomFieldTemplatesProjectTemplateOrderEntryIdFkeyInverseInput>;
  elementIdentifiersQuery?: InputMaybe<ForgeAttributeQueryTypeInput>;
  groupByAttributes?: InputMaybe<Array<InputMaybe<ForgeAttributeTypeInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrder?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInput>;
  promptForLinking?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<QuantityTypeInput>;
  unit?: InputMaybe<Unit>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usePromptForLinking?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `projectTemplateOrderEntryView` being updated. */
export type UpdateProjectTemplateOrderEntryViewOnProjectTemplateOrderEntryViewForProjectTemplateOrderEntryViewsProjectTemplateIdFkeyPatch = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilterTypeInput>>>;
  globalFilter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  originalOrderEntryViewId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrderEntryViewsProjectTemplateIdFkeyInput>;
  visibleColumns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
export type UpdateProjectTemplateOrderOnOrderColumnTemplateForOrderColumnTemplatesProjectTemplateOrderIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
export type UpdateProjectTemplateOrderOnProjectTemplateOrderEntryForProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateId?: InputMaybe<Scalars['UUID']>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `projectTemplateOrder` being updated. */
export type UpdateProjectTemplateOrderOnProjectTemplateOrderForProjectTemplateOrdersProjectTemplateIdFkeyPatch = {
  aggregatedOrderAggregation?: InputMaybe<Array<InputMaybe<AggregatedOrderAggregationTypeInput>>>;
  aggregatedOrderFilters?: InputMaybe<Array<InputMaybe<AggregatedOrderFilterTypeInput>>>;
  aggregatedOrderGrouping?: InputMaybe<Array<InputMaybe<AggregatedOrderGroupingTypeInput>>>;
  aggregatedOrderView?: InputMaybe<AggregatedOrderViewType>;
  areItemsFlattened?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAggregatedOrder?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderColumnTemplates?: InputMaybe<OrderColumnTemplatesProjectTemplateOrderIdFkeyInverseInput>;
  originalOrderId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ProjectTemplateOrdersProjectTemplateIdFkeyInput>;
  projectTemplateOrderEntries?: InputMaybe<ProjectTemplateOrderEntriesProjectTemplateOrderIdFkeyInverseInput>;
  shapeFolderNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An object where the defined keys will be set on the `protanProjectStep` being updated. */
export type UpdateProtanProjectStepOnProtanProjectStepForProtanProjectStepsProjectIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ProtanProjectStepsProjectIdFkeyInput>;
  status?: InputMaybe<ProtanProjectStepStatusEnum>;
  step?: InputMaybe<ProtanProjectStepEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `savedView` being updated. */
export type UpdateSavedViewOnCommentForCommentsSavedViewsIdFkeyPatch = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `savedView` being updated. */
export type UpdateSavedViewOnInitialStateForInitialStatesViewIdFkeyPatch = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  section?: InputMaybe<ViewSection>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `savedView` being updated. */
export type UpdateSavedViewOnSavedViewForSavedViewsProjectIdFkeyPatch = {
  cameraPosition?: InputMaybe<CameraPositionTypeInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comments?: InputMaybe<CommentsSavedViewsIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hiddenElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  hiddenModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  initialStates?: InputMaybe<InitialStatesViewIdFkeyInverseInput>;
  isCommentView?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isolatedElements?: InputMaybe<Array<InputMaybe<ElementIdentifierDbidTypeInput>>>;
  layers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SavedViewsProjectIdFkeyInput>;
  section?: InputMaybe<ViewSection>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `shapeFolder` being updated. */
export type UpdateShapeFolderOnShapeFolderForShapeFoldersProjectIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `shapeFolder` being updated. */
export type UpdateShapeFolderOnShapeForShapesFolderFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `shapeFolder` being updated. */
export type UpdateShapeFolderOnSheetShapeForSheetShapesFolderFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ShapeFoldersProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapes?: InputMaybe<ShapesFolderFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesFolderFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnExtrudedPolygonForExtrudedPolygonsShapeIdFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnLineForLinesShapeIdFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnPolygonForPolygonsShapeIdFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnShapeForShapesAutoShapeIdFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnShapeForShapesFolderFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnShapeForShapesProjectIdFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shape` being updated. */
export type UpdateShapeOnShapePointForShapePointsShapeIdFkeyPatch = {
  autoShape?: InputMaybe<ShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  extrudedPolygon?: InputMaybe<ExtrudedPolygonsShapeIdFkeyInverseInput>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  line?: InputMaybe<LinesShapeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<PolygonsShapeIdFkeyInverseInput>;
  project?: InputMaybe<ShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<ShapesFolderFkeyInput>;
  shapePoint?: InputMaybe<ShapePointsShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `shapePoint` being updated. */
export type UpdateShapePointOnShapePointForShapePointsShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point?: InputMaybe<Point3TypeInput>;
  shape?: InputMaybe<ShapePointsShapeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sharedLink` being updated. */
export type UpdateSharedLinkOnSharedLinkForSharedLinksInitialStateIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  initialState?: InputMaybe<SharedLinksInitialStateIdFkeyInput>;
  name?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  project?: InputMaybe<SharedLinksProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sharedLink` being updated. */
export type UpdateSharedLinkOnSharedLinkForSharedLinksProjectIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  initialState?: InputMaybe<SharedLinksInitialStateIdFkeyInput>;
  initialStateId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  project?: InputMaybe<SharedLinksProjectIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheet` being updated. */
export type UpdateSheetOnSheetForSheetsProjectIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `sheet` being updated. */
export type UpdateSheetOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `sheet` being updated. */
export type UpdateSheetOnSheetShapeForSheetShapesSheetIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetsProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  sheetPageCalibrations?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInverseInput>;
  sheetShapes?: InputMaybe<SheetShapesSheetIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `sheetPageCalibration` being updated. */
export type UpdateSheetPageCalibrationOnSheetPageCalibrationForSheetPageCalibrationsSheetIdFkeyPatch = {
  calibration?: InputMaybe<SheetScaleTypeInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sheet?: InputMaybe<SheetPageCalibrationsSheetIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
export type UpdateSheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsLegendOrderIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  order?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInput>;
  position?: InputMaybe<Point2TypeInput>;
  sheetShape?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInput>;
  sheetShapeId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheetShapeLegend` being updated. */
export type UpdateSheetShapeLegendOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  legendOrderId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<SheetShapeLegendsLegendOrderIdFkeyInput>;
  position?: InputMaybe<Point2TypeInput>;
  sheetShape?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheetShapeLine` being updated. */
export type UpdateSheetShapeLineOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points?: InputMaybe<Array<InputMaybe<Point2TypeInput>>>;
  sheetShape?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeForSheetShapesAutoShapeIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeForSheetShapesFolderFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeForSheetShapesProjectIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeForSheetShapesSheetIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeLegendForSheetShapeLegendsSheetShapeIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeLineForSheetShapeLinesSheetShapeIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShape` being updated. */
export type UpdateSheetShapeOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyPatch = {
  autoShape?: InputMaybe<SheetShapesAutoShapeIdFkeyInput>;
  autoShapeId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dbId?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SheetShapesProjectIdFkeyInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  shapeFolder?: InputMaybe<SheetShapesFolderFkeyInput>;
  sheet?: InputMaybe<SheetShapesSheetIdFkeyInput>;
  sheetId?: InputMaybe<Scalars['UUID']>;
  sheetPageNumber?: InputMaybe<Scalars['Int']>;
  sheetShapeLegend?: InputMaybe<SheetShapeLegendsSheetShapeIdFkeyInverseInput>;
  sheetShapeLine?: InputMaybe<SheetShapeLinesSheetShapeIdFkeyInverseInput>;
  sheetShapePoint?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInverseInput>;
  sheetShapePolygon?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInverseInput>;
  sheetShapeSplitLine?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sheetShapePoint` being updated. */
export type UpdateSheetShapePointOnSheetShapePointForSheetShapePointsSheetShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  point?: InputMaybe<Point2TypeInput>;
  sheetShape?: InputMaybe<SheetShapePointsSheetShapeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheetShapePolygon` being updated. */
export type UpdateSheetShapePolygonOnSheetShapePolygonForSheetShapePolygonsSheetShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  multipolygon?: InputMaybe<MultiPolygon2TypeInput>;
  sheetShape?: InputMaybe<SheetShapePolygonsSheetShapeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sheetShapeSplitLine` being updated. */
export type UpdateSheetShapeSplitLineOnSheetShapeSplitLineForSheetShapeSplitLinesSheetShapeIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  points?: InputMaybe<Array<InputMaybe<Point2TypeInput>>>;
  sheetShape?: InputMaybe<SheetShapeSplitLinesSheetShapeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `sparkelAiAnalysis` being updated. */
export type UpdateSparkelAiAnalysisOnSparkelAiAnalysisForSparkelAiAnalysisProjectIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  label?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SparkelAiAnalysisProjectIdFkeyInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `sparkelProperty` being updated. */
export type UpdateSparkelPropertyOnSparkelPropertyForSparkelPropertiesProjectIdFkeyPatch = {
  dbId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  modelUrn?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<SparkelPropertiesProjectIdFkeyInput>;
  propertySet?: InputMaybe<Scalars['String']>;
  propertyValue?: InputMaybe<Scalars['String']>;
};

export type GetAlgorithmGeometryQueryVariables = Exact<{
  modelId: Scalars['UUID'];
  algorithmType: Scalars['String'];
  dbIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetAlgorithmGeometryQuery = { __typename?: 'Query', getAlgorithmGeometry: Array<{ __typename?: 'AlgorithmGeometryResult', dbId: number, type: number, triangles?: any | null, multiPolygon?: any | null, multiPolyline?: any | null, point?: any | null, plane?: { __typename?: 'AlgorithmGeometryPlane', a: number, b: number, c: number, d: number } | null }> };

export type AutoShapeDeepFragment = { __typename: 'AutoShape', id: string, name: string, algorithmType?: AutoShapeAlgorithmType | null, algorithmInput: any, status: AutoShapeStatus, startedAt?: string | null, completedAt?: string | null, result?: any | null, errorMessage?: string | null, projectId: string, createdAt: string, updatedAt: string, shapes: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }>, sheetShapes: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> };

export type CreateAutoShapeMutationVariables = Exact<{
  input: CreateAutoShapeInput;
}>;


export type CreateAutoShapeMutation = { __typename?: 'Mutation', createAutoShape?: { __typename?: 'CreateAutoShapePayload', autoShape?: { __typename: 'AutoShape', id: string, name: string, algorithmType?: AutoShapeAlgorithmType | null, algorithmInput: any, status: AutoShapeStatus, startedAt?: string | null, completedAt?: string | null, result?: any | null, errorMessage?: string | null, projectId: string, createdAt: string, updatedAt: string, shapes: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }>, sheetShapes: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> } | null } | null };

export type UpdateAutoShapeMutationVariables = Exact<{
  input: UpdateAutoShapeInput;
}>;


export type UpdateAutoShapeMutation = { __typename?: 'Mutation', updateAutoShape?: { __typename?: 'UpdateAutoShapePayload', autoShape?: { __typename: 'AutoShape', id: string, name: string, algorithmType?: AutoShapeAlgorithmType | null, algorithmInput: any, status: AutoShapeStatus, startedAt?: string | null, completedAt?: string | null, result?: any | null, errorMessage?: string | null, projectId: string, createdAt: string, updatedAt: string, shapes: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }>, sheetShapes: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> } | null } | null };

export type DeleteAutoShapeMutationVariables = Exact<{
  input: DeleteAutoShapeInput;
}>;


export type DeleteAutoShapeMutation = { __typename?: 'Mutation', deleteAutoShape?: { __typename?: 'DeleteAutoShapePayload', autoShape?: { __typename?: 'AutoShape', id: string, projectId: string } | null } | null };

export type GetAutoShapesForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetAutoShapesForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, autoShapes: Array<{ __typename: 'AutoShape', id: string, name: string, algorithmType?: AutoShapeAlgorithmType | null, algorithmInput: any, status: AutoShapeStatus, startedAt?: string | null, completedAt?: string | null, result?: any | null, errorMessage?: string | null, projectId: string, createdAt: string, updatedAt: string, shapes: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }>, sheetShapes: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> }> } | null };

export type OnAutoShapeStatusUpdatedSubscriptionVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type OnAutoShapeStatusUpdatedSubscription = { __typename?: 'Subscription', autoShapeStatusUpdated?: { __typename?: 'AutoShapeProcessingSubscriptionPayload', autoShape?: { __typename: 'AutoShape', id: string, name: string, algorithmType?: AutoShapeAlgorithmType | null, algorithmInput: any, status: AutoShapeStatus, startedAt?: string | null, completedAt?: string | null, result?: any | null, errorMessage?: string | null, projectId: string, createdAt: string, updatedAt: string, shapes: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }>, sheetShapes: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> } | null } | null };

export type RunExternalWallFinishes3DMutationVariables = Exact<{
  input: ExternalWallFinishes3DInput;
}>;


export type RunExternalWallFinishes3DMutation = { __typename?: 'Mutation', runExternalWallFinishes3D?: { __typename?: 'ExternalWallFinishes3DResponse', success: boolean, error?: string | null } | null };

export type RunRoomDetection2DMutationVariables = Exact<{
  input: RoomDetection2DInput;
}>;


export type RunRoomDetection2DMutation = { __typename?: 'Mutation', runRoomDetection2D: { __typename?: 'RoomDetection2DPayload', success: boolean, error?: string | null } };

export type RunSymbolDetection2DMutationVariables = Exact<{
  input: SymbolDetection2DInput;
}>;


export type RunSymbolDetection2DMutation = { __typename?: 'Mutation', runSymbolDetection2D: { __typename?: 'SymbolDetection2DPayload', success: boolean, error?: string | null } };

export type DeleteAutoShapeShapesMutationVariables = Exact<{
  autoShapeId: Scalars['UUID'];
}>;


export type DeleteAutoShapeShapesMutation = { __typename?: 'Mutation', deleteAutoShapeShapes: boolean };

export type GetProjectNameQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetProjectNameQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string } | null };

export type GetOrderNameQueryVariables = Exact<{
  orderId: Scalars['UUID'];
}>;


export type GetOrderNameQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, name: string, projectId: string } | null };

export type CommentDeepFragment = { __typename?: 'Comment', id: string, content: string, replies?: string | null, createdAtTz: string, parentId?: string | null, orderId?: string | null, projectId: string, username: string, readBy?: Array<string> | null, elementIdentifiers?: Array<{ __typename?: 'ElementIdentifierDbidType', dbIds: Array<number>, modelUrn: string }> | null, savedViews?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null, anchorPoint3D?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null };

export type CreateCommentMutationMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutationMutation = { __typename?: 'Mutation', createComment?: { __typename?: 'CreateCommentPayload', comment?: { __typename?: 'Comment', id: string, content: string, replies?: string | null, createdAtTz: string, parentId?: string | null, orderId?: string | null, projectId: string, username: string, readBy?: Array<string> | null, elementIdentifiers?: Array<{ __typename?: 'ElementIdentifierDbidType', dbIds: Array<number>, modelUrn: string }> | null, savedViews?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null, anchorPoint3D?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null } | null } | null };

export type UpdateCommentMutationMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutationMutation = { __typename?: 'Mutation', updateComment?: { __typename?: 'UpdateCommentPayload', comment?: { __typename?: 'Comment', id: string, content: string, replies?: string | null, createdAtTz: string, parentId?: string | null, orderId?: string | null, projectId: string, username: string, readBy?: Array<string> | null, elementIdentifiers?: Array<{ __typename?: 'ElementIdentifierDbidType', dbIds: Array<number>, modelUrn: string }> | null, savedViews?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null, anchorPoint3D?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null } | null } | null };

export type ListAllCommentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllCommentsQuery = { __typename?: 'Query', comments?: Array<{ __typename?: 'Comment', id: string, content: string, replies?: string | null, createdAtTz: string, parentId?: string | null, orderId?: string | null, projectId: string, username: string, readBy?: Array<string> | null, elementIdentifiers?: Array<{ __typename?: 'ElementIdentifierDbidType', dbIds: Array<number>, modelUrn: string }> | null, savedViews?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null, anchorPoint3D?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null }> | null };

export type GetCommentDeepQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCommentDeepQuery = { __typename?: 'Query', comment?: { __typename?: 'Comment', id: string, content: string, replies?: string | null, createdAtTz: string, parentId?: string | null, orderId?: string | null, projectId: string, username: string, readBy?: Array<string> | null, elementIdentifiers?: Array<{ __typename?: 'ElementIdentifierDbidType', dbIds: Array<number>, modelUrn: string }> | null, savedViews?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null, anchorPoint3D?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment?: { __typename?: 'DeleteCommentPayload', comment?: { __typename?: 'Comment', id: string } | null } | null };

export type CompanyDatabaseColumnFieldsFragment = { __typename?: 'CompanyDatabaseColumn', id: string, databaseId: string, name: string, type: CompanyDatabaseColumnType, orderIndex: number, createdAt: string, updatedAt: string };

export type CompanyDatabaseFieldsFragment = { __typename?: 'CompanyDatabasis', id: string, contractorId: string, name: string, rowCount: any, lastImportAt?: string | null, lastImportStatus?: CompanyDatabaseImportStatus | null, createdAt: string, updatedAt: string };

export type CompanyDatabaseWithColumnsFragment = { __typename?: 'CompanyDatabasis', id: string, contractorId: string, name: string, rowCount: any, lastImportAt?: string | null, lastImportStatus?: CompanyDatabaseImportStatus | null, createdAt: string, updatedAt: string, companyDatabaseColumnsByDatabaseId: Array<{ __typename?: 'CompanyDatabaseColumn', id: string, databaseId: string, name: string, type: CompanyDatabaseColumnType, orderIndex: number, createdAt: string, updatedAt: string }> };

export type CompanyDatabaseImportJobFieldsFragment = { __typename?: 'CompanyDatabaseImportJob', id: string, databaseId: string, contractorId: string, status: CompanyDatabaseImportJobStatus, createdAt: string, startedAt?: string | null, finishedAt?: string | null, fileName: string, mode: CompanyDatabaseImportMode, totalRows?: number | null, insertedRows: number, errorCount: number, errorSummary?: string | null };

export type CompanyDatabaseRowFieldsFragment = { __typename?: 'CompanyDatabaseRow', id: string, databaseId: string, rowIndex: any, createdAt: string };

export type CompanyDatabaseCellFieldsFragment = { __typename?: 'CompanyDatabaseCell', rowId: string, columnId: string, value?: string | null };

export type ListCompanyDatabasesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCompanyDatabasesQuery = { __typename?: 'Query', companyDatabases?: Array<{ __typename?: 'CompanyDatabasis', id: string, contractorId: string, name: string, rowCount: any, lastImportAt?: string | null, lastImportStatus?: CompanyDatabaseImportStatus | null, createdAt: string, updatedAt: string }> | null };

export type GetCompanyDatabaseQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCompanyDatabaseQuery = { __typename?: 'Query', companyDatabasis?: { __typename?: 'CompanyDatabasis', id: string, contractorId: string, name: string, rowCount: any, lastImportAt?: string | null, lastImportStatus?: CompanyDatabaseImportStatus | null, createdAt: string, updatedAt: string, companyDatabaseColumnsByDatabaseId: Array<{ __typename?: 'CompanyDatabaseColumn', id: string, databaseId: string, name: string, type: CompanyDatabaseColumnType, orderIndex: number, createdAt: string, updatedAt: string }> } | null };

export type CreateCompanyDatabaseMutationVariables = Exact<{
  input: CreateCompanyDatabasisInput;
}>;


export type CreateCompanyDatabaseMutation = { __typename?: 'Mutation', createCompanyDatabasis?: { __typename?: 'CreateCompanyDatabasisPayload', companyDatabasis?: { __typename?: 'CompanyDatabasis', id: string, contractorId: string, name: string, rowCount: any, lastImportAt?: string | null, lastImportStatus?: CompanyDatabaseImportStatus | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateCompanyDatabaseMutationVariables = Exact<{
  input: UpdateCompanyDatabasisInput;
}>;


export type UpdateCompanyDatabaseMutation = { __typename?: 'Mutation', updateCompanyDatabasis?: { __typename?: 'UpdateCompanyDatabasisPayload', companyDatabasis?: { __typename?: 'CompanyDatabasis', id: string, contractorId: string, name: string, rowCount: any, lastImportAt?: string | null, lastImportStatus?: CompanyDatabaseImportStatus | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteCompanyDatabaseMutationVariables = Exact<{
  input: DeleteCompanyDatabasisInput;
}>;


export type DeleteCompanyDatabaseMutation = { __typename?: 'Mutation', deleteCompanyDatabasis?: { __typename?: 'DeleteCompanyDatabasisPayload', companyDatabasis?: { __typename?: 'CompanyDatabasis', id: string } | null } | null };

export type CreateCompanyDatabaseColumnMutationVariables = Exact<{
  input: CreateCompanyDatabaseColumnInput;
}>;


export type CreateCompanyDatabaseColumnMutation = { __typename?: 'Mutation', createCompanyDatabaseColumn?: { __typename?: 'CreateCompanyDatabaseColumnPayload', companyDatabaseColumn?: { __typename?: 'CompanyDatabaseColumn', id: string, databaseId: string, name: string, type: CompanyDatabaseColumnType, orderIndex: number, createdAt: string, updatedAt: string } | null } | null };

export type UpdateCompanyDatabaseColumnMutationVariables = Exact<{
  input: UpdateCompanyDatabaseColumnInput;
}>;


export type UpdateCompanyDatabaseColumnMutation = { __typename?: 'Mutation', updateCompanyDatabaseColumn?: { __typename?: 'UpdateCompanyDatabaseColumnPayload', companyDatabaseColumn?: { __typename?: 'CompanyDatabaseColumn', id: string, databaseId: string, name: string, type: CompanyDatabaseColumnType, orderIndex: number, createdAt: string, updatedAt: string } | null } | null };

export type DeleteCompanyDatabaseColumnMutationVariables = Exact<{
  input: DeleteCompanyDatabaseColumnInput;
}>;


export type DeleteCompanyDatabaseColumnMutation = { __typename?: 'Mutation', deleteCompanyDatabaseColumn?: { __typename?: 'DeleteCompanyDatabaseColumnPayload', companyDatabaseColumn?: { __typename?: 'CompanyDatabaseColumn', id: string } | null } | null };

export type CompanyDatabaseLookupProfileFieldsFragment = { __typename?: 'CompanyDatabaseLookupProfile', id: string, databaseId: string, name: string, description?: string | null, systemPrompt: string, matchCriteria: Array<{ __typename?: 'MatchCriterion', name?: string | null, sourcePattern?: string | null, targetColumnId?: string | null, targetPattern?: string | null, comparison?: MatchComparison | null, normalizations?: Array<TextNormalization> | null, required?: boolean | null, negateSource?: boolean | null, negateTarget?: boolean | null, scoreWeight?: number | null }> };

export type GetCompanyDatabaseLookupProfilesQueryVariables = Exact<{
  databaseId: Scalars['UUID'];
}>;


export type GetCompanyDatabaseLookupProfilesQuery = { __typename?: 'Query', companyDatabaseLookupProfiles?: Array<{ __typename?: 'CompanyDatabaseLookupProfile', id: string, databaseId: string, name: string, description?: string | null, systemPrompt: string, matchCriteria: Array<{ __typename?: 'MatchCriterion', name?: string | null, sourcePattern?: string | null, targetColumnId?: string | null, targetPattern?: string | null, comparison?: MatchComparison | null, normalizations?: Array<TextNormalization> | null, required?: boolean | null, negateSource?: boolean | null, negateTarget?: boolean | null, scoreWeight?: number | null }> }> | null };

export type LookupCompanyDatabaseValueQueryVariables = Exact<{
  databaseId: Scalars['UUID'];
  searchColumnId: Scalars['UUID'];
  searchTerm: Scalars['String'];
  valueColumnId: Scalars['UUID'];
  lookupProfileId?: InputMaybe<Scalars['UUID']>;
}>;


export type LookupCompanyDatabaseValueQuery = { __typename?: 'Query', lookupCompanyDatabaseValue: { __typename?: 'CompanyDatabaseLookupResult', found: boolean, value?: string | null, rowId?: string | null } };

export type GetCompanyDatabaseCellValueQueryVariables = Exact<{
  rowId: Scalars['UUID'];
  columnId: Scalars['UUID'];
}>;


export type GetCompanyDatabaseCellValueQuery = { __typename?: 'Query', getCompanyDatabaseCellValue?: string | null };

export type GetCompanyDatabaseColumnQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCompanyDatabaseColumnQuery = { __typename?: 'Query', companyDatabaseColumn?: { __typename?: 'CompanyDatabaseColumn', id: string, name: string } | null };

export type GetCompanyDatabaseRowsQueryVariables = Exact<{
  databaseId: Scalars['UUID'];
  first: Scalars['Int'];
  afterRowIndex?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetCompanyDatabaseRowsQuery = { __typename?: 'Query', companyDatabaseRowsConnection?: { __typename?: 'CompanyDatabaseRowsConnection', totalCount: number, nodes: Array<{ __typename?: 'CompanyDatabaseRow', id: string, databaseId: string, rowIndex: any, createdAt: string, companyDatabaseCellsByRowIdConnection: { __typename?: 'CompanyDatabaseCellsConnection', nodes: Array<{ __typename?: 'CompanyDatabaseCell', rowId: string, columnId: string, value?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetCompanyDatabaseCellsForRowsQueryVariables = Exact<{
  rowIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetCompanyDatabaseCellsForRowsQuery = { __typename?: 'Query', companyDatabaseCells?: Array<{ __typename?: 'CompanyDatabaseCell', rowId: string, columnId: string, value?: string | null }> | null };

export type GetCompanyDatabaseImportJobsQueryVariables = Exact<{
  databaseId: Scalars['UUID'];
}>;


export type GetCompanyDatabaseImportJobsQuery = { __typename?: 'Query', companyDatabaseImportJobs?: Array<{ __typename?: 'CompanyDatabaseImportJob', id: string, databaseId: string, contractorId: string, status: CompanyDatabaseImportJobStatus, createdAt: string, startedAt?: string | null, finishedAt?: string | null, fileName: string, mode: CompanyDatabaseImportMode, totalRows?: number | null, insertedRows: number, errorCount: number, errorSummary?: string | null }> | null };

export type GetCompanyDatabaseImportJobQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCompanyDatabaseImportJobQuery = { __typename?: 'Query', companyDatabaseImportJob?: { __typename?: 'CompanyDatabaseImportJob', id: string, databaseId: string, contractorId: string, status: CompanyDatabaseImportJobStatus, createdAt: string, startedAt?: string | null, finishedAt?: string | null, fileName: string, mode: CompanyDatabaseImportMode, totalRows?: number | null, insertedRows: number, errorCount: number, errorSummary?: string | null } | null };

export type CreateCompanyDatabaseImportJobMutationVariables = Exact<{
  input: CreateCompanyDatabaseImportJobInput;
}>;


export type CreateCompanyDatabaseImportJobMutation = { __typename?: 'Mutation', createCompanyDatabaseImportJob?: { __typename?: 'CreateCompanyDatabaseImportJobPayload', companyDatabaseImportJob?: { __typename?: 'CompanyDatabaseImportJob', id: string, databaseId: string, contractorId: string, status: CompanyDatabaseImportJobStatus, createdAt: string, startedAt?: string | null, finishedAt?: string | null, fileName: string, mode: CompanyDatabaseImportMode, totalRows?: number | null, insertedRows: number, errorCount: number, errorSummary?: string | null } | null } | null };

export type UpdateCompanyDatabaseImportJobMutationVariables = Exact<{
  input: UpdateCompanyDatabaseImportJobInput;
}>;


export type UpdateCompanyDatabaseImportJobMutation = { __typename?: 'Mutation', updateCompanyDatabaseImportJob?: { __typename?: 'UpdateCompanyDatabaseImportJobPayload', companyDatabaseImportJob?: { __typename?: 'CompanyDatabaseImportJob', id: string, databaseId: string, contractorId: string, status: CompanyDatabaseImportJobStatus, createdAt: string, startedAt?: string | null, finishedAt?: string | null, fileName: string, mode: CompanyDatabaseImportMode, totalRows?: number | null, insertedRows: number, errorCount: number, errorSummary?: string | null } | null } | null };

export type ImportCompanyDatabaseDataMutationVariables = Exact<{
  input: ImportCompanyDatabaseDataInput;
}>;


export type ImportCompanyDatabaseDataMutation = { __typename?: 'Mutation', importCompanyDatabaseData: { __typename?: 'ImportCompanyDatabaseDataPayload', success: boolean, message?: string | null, rowsImported?: number | null, columnsCreated?: number | null, columnIds?: Array<string> | null } };

export type ListContractorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListContractorsQuery = { __typename?: 'Query', contractors?: Array<{ __typename?: 'Contractor', id: string, name: string, contractorTier: ContractorTierEnum }> | null };

export type CheckoutUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CheckoutUrlMutation = { __typename?: 'Mutation', createCheckoutUrl: string };

export type CopilotExchangeDeepFragment = { __typename?: 'CopilotExchange', id: string, userId?: string | null, createdAt: string };

export type GetAllCopilotExchangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCopilotExchangesQuery = { __typename?: 'Query', copilotExchangesConnection?: { __typename?: 'CopilotExchangesConnection', nodes: Array<{ __typename?: 'CopilotExchange', id: string, userId?: string | null, createdAt: string }> } | null };

type CopilotResultFragment_CopilotBadQueryResponse_Fragment = { __typename: 'CopilotBadQueryResponse', reason: string };

type CopilotResultFragment_CopilotResultData_Fragment = { __typename: 'CopilotResultData', attributeQuery: { __typename: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> }, quantity_extraction?: Array<{ __typename?: 'QuantityExtraction', propertySet: string, propertyName: string, operation: string }> | null, breakdown?: Array<{ __typename?: 'Breakdown', propertySet: string, propertyName: string }> | null };

export type CopilotResultFragmentFragment = CopilotResultFragment_CopilotBadQueryResponse_Fragment | CopilotResultFragment_CopilotResultData_Fragment;

export type AskCopilotMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  query: Scalars['String'];
}>;


export type AskCopilotMutation = { __typename?: 'Mutation', askCopilot?: { __typename?: 'CopilotAnswer', exchangeId: string, result: { __typename: 'CopilotBadQueryResponse', reason: string } | { __typename: 'CopilotResultData', attributeQuery: { __typename: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> }, quantity_extraction?: Array<{ __typename?: 'QuantityExtraction', propertySet: string, propertyName: string, operation: string }> | null, breakdown?: Array<{ __typename?: 'Breakdown', propertySet: string, propertyName: string }> | null } } | null };

export type CreateCopilotFeedbackMutationVariables = Exact<{
  input: CreateCopilotExchangesFeedbackInput;
}>;


export type CreateCopilotFeedbackMutation = { __typename?: 'Mutation', createCopilotExchangesFeedback?: { __typename?: 'CreateCopilotExchangesFeedbackPayload', clientMutationId?: string | null } | null };

export type UpdateCopilotFeedbackMutationVariables = Exact<{
  input: UpdateCopilotExchangesFeedbackInput;
}>;


export type UpdateCopilotFeedbackMutation = { __typename?: 'Mutation', updateCopilotExchangesFeedback?: { __typename?: 'UpdateCopilotExchangesFeedbackPayload', clientMutationId?: string | null } | null };

export type RunClassificationMutationVariables = Exact<{
  modelId: Scalars['UUID'];
}>;


export type RunClassificationMutation = { __typename?: 'Mutation', runClassification?: { __typename?: 'RunClassificationResponse', success: boolean } | null };

export type DescriptionReaderMutationVariables = Exact<{
  input: GetDescriptionReaderInput;
}>;


export type DescriptionReaderMutation = { __typename?: 'Mutation', descriptionReader?: { __typename?: 'GetDescriptionReaderResponse', answer?: string | null } | null };

export type GetExternalAwsCredentialsQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetExternalAwsCredentialsQuery = { __typename?: 'Query', externalAwsCredentials: { __typename?: 'ExternalAwsAccessCredentials', accessKeyId: string, secretAccessKey: string, sessionToken: string, expiration: string } };

export type FlowFieldsFragment = { __typename?: 'Flow', id: string, name: string, isActive: boolean, triggerType: FlowTriggerType, triggerConfig: any, createdAt: string, updatedAt: string };

export type FlowActionFieldsFragment = { __typename?: 'FlowAction', id: string, flowId: string, actionType: FlowActionType, actionConfig: any, outputKey?: string | null, position: number, parentLoopActionId?: string | null, loopConfig?: any | null };

export type FlowExecutionFieldsFragment = { __typename?: 'FlowExecution', id: string, flowId: string, status: FlowExecutionStatus, currentActionPosition?: number | null, inputData: any, outputData: any, createdResources: any, errorMessage?: string | null, errorActionPosition?: number | null, lambdaRequestId?: string | null, startedAt?: string | null, completedAt?: string | null, createdAt: string };

export type ListFlowsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFlowsQuery = { __typename?: 'Query', flows?: Array<{ __typename?: 'Flow', id: string, name: string, isActive: boolean, triggerType: FlowTriggerType, triggerConfig: any, createdAt: string, updatedAt: string }> | null };

export type GetFlowWithActionsQueryVariables = Exact<{
  flowId: Scalars['UUID'];
}>;


export type GetFlowWithActionsQuery = { __typename?: 'Query', flow?: { __typename?: 'Flow', id: string, name: string, isActive: boolean, triggerType: FlowTriggerType, triggerConfig: any, createdAt: string, updatedAt: string, contractor?: { __typename?: 'Contractor', flowMailbox?: { __typename?: 'FlowMailbox', emailLocalPart: string, emailDomain: string } | null } | null, flowActions: Array<{ __typename?: 'FlowAction', id: string, flowId: string, actionType: FlowActionType, actionConfig: any, outputKey?: string | null, position: number, parentLoopActionId?: string | null, loopConfig?: any | null }> } | null };

export type ListFlowExecutionsQueryVariables = Exact<{
  flowId: Scalars['UUID'];
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ListFlowExecutionsQuery = { __typename?: 'Query', flow?: { __typename?: 'Flow', id: string, name: string, triggerType: FlowTriggerType, flowExecutionsConnection: { __typename?: 'FlowExecutionsConnection', totalCount: number, nodes: Array<{ __typename?: 'FlowExecution', id: string, flowId: string, status: FlowExecutionStatus, currentActionPosition?: number | null, inputData: any, outputData: any, createdResources: any, errorMessage?: string | null, errorActionPosition?: number | null, lambdaRequestId?: string | null, startedAt?: string | null, completedAt?: string | null, createdAt: string }> } } | null };

export type GetFlowExecutionQueryVariables = Exact<{
  executionId: Scalars['UUID'];
}>;


export type GetFlowExecutionQuery = { __typename?: 'Query', flowExecution?: { __typename?: 'FlowExecution', id: string, flowId: string, status: FlowExecutionStatus, currentActionPosition?: number | null, inputData: any, outputData: any, createdResources: any, errorMessage?: string | null, errorActionPosition?: number | null, lambdaRequestId?: string | null, startedAt?: string | null, completedAt?: string | null, createdAt: string, flow?: { __typename?: 'Flow', id: string, name: string, isActive: boolean, triggerType: FlowTriggerType, triggerConfig: any, createdAt: string, updatedAt: string, flowActions: Array<{ __typename?: 'FlowAction', id: string, flowId: string, actionType: FlowActionType, actionConfig: any, outputKey?: string | null, position: number, parentLoopActionId?: string | null, loopConfig?: any | null }> } | null } | null };

export type GetForgeAccessTokenQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetForgeAccessTokenQuery = { __typename?: 'Query', forgeAccessToken?: { __typename?: 'ForgeAccessToken', accessToken: string, expiresIn: number } | null };

export type HistoryEventDeepFragment = { __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean };

export type HistoryEventGroupDeepFragment = { __typename?: 'GetHistoryEventGroupsRecord', groupDate?: string | null, author?: string | null, eventDay?: any | null, resourceType?: EventResource | null, eventType?: EventType | null, isCheckpoint?: boolean | null, affectedResources?: number | null, eventCount?: number | null, firstEvent?: { __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean } | null };

export type GetEventsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  first?: Scalars['Int'];
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetEventsForProjectQuery = { __typename?: 'Query', historyEventsConnection?: { __typename?: 'HistoryEventsConnection', nodes: Array<{ __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateHistoryEventMutationVariables = Exact<{
  input: CreateHistoryEventInput;
}>;


export type CreateHistoryEventMutation = { __typename?: 'Mutation', createHistoryEvent?: { __typename?: 'CreateHistoryEventPayload', historyEvent?: { __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean } | null } | null };

export type UpdateHistoryEventMutationVariables = Exact<{
  input: UpdateHistoryEventInput;
}>;


export type UpdateHistoryEventMutation = { __typename?: 'Mutation', updateHistoryEvent?: { __typename?: 'UpdateHistoryEventPayload', historyEvent?: { __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean } | null } | null };

export type GetEventGroupsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  pageSize?: Scalars['Int'];
  afterCursor?: InputMaybe<Scalars['Datetime']>;
}>;


export type GetEventGroupsForProjectQuery = { __typename?: 'Query', getHistoryEventGroups?: Array<{ __typename?: 'GetHistoryEventGroupsRecord', groupDate?: string | null, author?: string | null, eventDay?: any | null, resourceType?: EventResource | null, eventType?: EventType | null, isCheckpoint?: boolean | null, affectedResources?: number | null, eventCount?: number | null, firstEvent?: { __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean } | null }> | null };

export type GetCheckpointEventsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetCheckpointEventsForProjectQuery = { __typename?: 'Query', historyEvents?: Array<{ __typename?: 'HistoryEvent', id: string, projectId: string, author?: string | null, createdAt: string, updatedAt: string, eventName: string, eventType: EventType, resourceName: string, resourceType: EventResource, resolved: boolean, stateKey: string, metadata?: any | null, isCheckpoint: boolean }> | null };

export type InitialStateDeepFragment = { __typename?: 'InitialState', id: string, projectId: string, selectedOrderEntries: Array<string>, expandedOrderEntries: Array<string>, viewId: string, externalAccessToken: string, viewSettings: { __typename?: 'ViewSettingsType', ghosting?: boolean | null, focusMode?: boolean | null, showLabels?: boolean | null, orthographicMode?: boolean | null } };

export type PublicInitialStateDeepFragment = { __typename?: 'PublicInitialState', id?: string | null, externalAccessToken?: string | null };

export type GetInitialStateQueryVariables = Exact<{
  initialStateId: Scalars['UUID'];
}>;


export type GetInitialStateQuery = { __typename?: 'Query', initialState?: { __typename?: 'InitialState', id: string, projectId: string, selectedOrderEntries: Array<string>, expandedOrderEntries: Array<string>, viewId: string, externalAccessToken: string, viewSettings: { __typename?: 'ViewSettingsType', ghosting?: boolean | null, focusMode?: boolean | null, showLabels?: boolean | null, orthographicMode?: boolean | null } } | null };

export type GetPublicInitialStateQueryVariables = Exact<{
  initialStateId: Scalars['UUID'];
}>;


export type GetPublicInitialStateQuery = { __typename?: 'Query', publicInitialStates?: Array<{ __typename?: 'PublicInitialState', id?: string | null, externalAccessToken?: string | null }> | null };

export type GetViewFromInitialStateQueryVariables = Exact<{
  viewId: Scalars['UUID'];
}>;


export type GetViewFromInitialStateQuery = { __typename?: 'Query', initialStates?: Array<{ __typename?: 'InitialState', view?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null }> | null };

export type CreateInitialStateMutationVariables = Exact<{
  input: CreateInitialStateInput;
}>;


export type CreateInitialStateMutation = { __typename?: 'Mutation', createInitialState?: { __typename?: 'CreateInitialStatePayload', initialState?: { __typename?: 'InitialState', projectId: string, id: string, selectedOrderEntries: Array<string>, expandedOrderEntries: Array<string>, viewId: string, externalAccessToken: string, viewSettings: { __typename?: 'ViewSettingsType', ghosting?: boolean | null, focusMode?: boolean | null, showLabels?: boolean | null, orthographicMode?: boolean | null } } | null } | null };

export type IssueCommentDeepFragment = { __typename?: 'IssueComment', id: string, comment: string, createdBy?: string | null, createdAt: string, issueId: string, projectId?: string | null };

export type GetIssueCommentsForIssueQueryVariables = Exact<{
  issueId: Scalars['UUID'];
}>;


export type GetIssueCommentsForIssueQuery = { __typename?: 'Query', issue?: { __typename?: 'Issue', id: string, issueComments: Array<{ __typename?: 'IssueComment', id: string, comment: string, createdBy?: string | null, createdAt: string, issueId: string, projectId?: string | null }> } | null };

export type CreateIssueCommentMutationVariables = Exact<{
  input: CreateIssueCommentInput;
}>;


export type CreateIssueCommentMutation = { __typename?: 'Mutation', createIssueComment?: { __typename?: 'CreateIssueCommentPayload', issueComment?: { __typename?: 'IssueComment', id: string, comment: string, createdBy?: string | null, createdAt: string, issueId: string, projectId?: string | null } | null } | null };

export type UpdateIssueCommentMutationVariables = Exact<{
  input: UpdateIssueCommentInput;
}>;


export type UpdateIssueCommentMutation = { __typename?: 'Mutation', updateIssueComment?: { __typename?: 'UpdateIssueCommentPayload', issueComment?: { __typename?: 'IssueComment', id: string, comment: string, createdBy?: string | null, createdAt: string, issueId: string, projectId?: string | null } | null } | null };

export type DeleteIssueCommentMutationVariables = Exact<{
  input: DeleteIssueCommentInput;
}>;


export type DeleteIssueCommentMutation = { __typename?: 'Mutation', deleteIssueComment?: { __typename?: 'DeleteIssueCommentPayload', issueComment?: { __typename?: 'IssueComment', id: string, comment: string, createdBy?: string | null, createdAt: string, issueId: string, projectId?: string | null } | null } | null };

export type IssueDeepFragment = { __typename?: 'Issue', id: string, title: string, assignedTo?: string | null, status: IssueStatusEnum, commentCount: number, thumbnail?: string | null, createdBy?: string | null, createdAt: string, lastUpdated: string, dueDate?: string | null, projectId: string };

export type GetIssuesForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetIssuesForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, issues: Array<{ __typename?: 'Issue', id: string, title: string, assignedTo?: string | null, status: IssueStatusEnum, commentCount: number, thumbnail?: string | null, createdBy?: string | null, createdAt: string, lastUpdated: string, dueDate?: string | null, projectId: string }> } | null };

export type CreateIssueMutationVariables = Exact<{
  input: CreateIssueInput;
}>;


export type CreateIssueMutation = { __typename?: 'Mutation', createIssue?: { __typename?: 'CreateIssuePayload', issue?: { __typename?: 'Issue', id: string, title: string, assignedTo?: string | null, status: IssueStatusEnum, commentCount: number, thumbnail?: string | null, createdBy?: string | null, createdAt: string, lastUpdated: string, dueDate?: string | null, projectId: string } | null } | null };

export type UpdateIssueMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type UpdateIssueMutation = { __typename?: 'Mutation', updateIssue?: { __typename?: 'UpdateIssuePayload', issue?: { __typename?: 'Issue', id: string, title: string, assignedTo?: string | null, status: IssueStatusEnum, commentCount: number, thumbnail?: string | null, createdBy?: string | null, createdAt: string, lastUpdated: string, dueDate?: string | null, projectId: string } | null } | null };

export type DeleteIssueMutationVariables = Exact<{
  input: DeleteIssueInput;
}>;


export type DeleteIssueMutation = { __typename?: 'Mutation', deleteIssue?: { __typename?: 'DeleteIssuePayload', issue?: { __typename?: 'Issue', id: string, title: string, assignedTo?: string | null, status: IssueStatusEnum, commentCount: number, thumbnail?: string | null, createdBy?: string | null, createdAt: string, lastUpdated: string, dueDate?: string | null, projectId: string } | null } | null };

export type GetActiveModelsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetActiveModelsForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, activeModels?: Array<{ __typename?: 'Model', id: string, filename: string, version: number, createdAt: string, updatedAt: string, status: ModelProcessingStatus, name: string, forgeUrn?: string | null, activeViewGuid?: string | null, ifcCategories?: Array<string> | null, ifcLayers?: Array<string> | null, revitCategories?: Array<string> | null, revitLevels?: Array<string> | null, availableViewGuids?: Array<{ __typename?: 'ModelView', guid?: string | null, name?: string | null }> | null, propertySets?: Array<{ __typename?: 'PropertySetType', category: string, properties: Array<string> }> | null }> | null } | null };

export type ModelsDeepFragment = { __typename?: 'Model', id: string, filename: string, version: number, createdAt: string, updatedAt: string, status: ModelProcessingStatus, name: string, forgeUrn?: string | null, activeViewGuid?: string | null, ifcCategories?: Array<string> | null, ifcLayers?: Array<string> | null, revitCategories?: Array<string> | null, revitLevels?: Array<string> | null, availableViewGuids?: Array<{ __typename?: 'ModelView', guid?: string | null, name?: string | null }> | null, propertySets?: Array<{ __typename?: 'PropertySetType', category: string, properties: Array<string> }> | null };

export type GetModelsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetModelsForProjectQuery = { __typename?: 'Query', models?: Array<{ __typename?: 'Model', id: string, filename: string, version: number, createdAt: string, updatedAt: string, status: ModelProcessingStatus, name: string, forgeUrn?: string | null, activeViewGuid?: string | null, availableViewGuids?: Array<{ __typename?: 'ModelView', guid?: string | null, name?: string | null }> | null }> | null };

export type GetNextModelVersionQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  versionName: Scalars['String'];
}>;


export type GetNextModelVersionQuery = { __typename?: 'Query', getNextModelVersion?: number | null };

export type ModelProcessingSubscriptionVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type ModelProcessingSubscription = { __typename?: 'Subscription', modelStatusUpdated?: { __typename?: 'ModelProcessingSubscriptionPayload', model?: { __typename?: 'Model', id: string, filename: string, version: number, createdAt: string, updatedAt: string, status: ModelProcessingStatus, name: string, forgeUrn?: string | null, activeViewGuid?: string | null, ifcCategories?: Array<string> | null, ifcLayers?: Array<string> | null, revitCategories?: Array<string> | null, revitLevels?: Array<string> | null, availableViewGuids?: Array<{ __typename?: 'ModelView', guid?: string | null, name?: string | null }> | null, propertySets?: Array<{ __typename?: 'PropertySetType', category: string, properties: Array<string> }> | null } | null } | null };

export type UpdateModelMutationVariables = Exact<{
  input: UpdateModelInput;
}>;


export type UpdateModelMutation = { __typename?: 'Mutation', updateModel?: { __typename?: 'UpdateModelPayload', model?: { __typename?: 'Model', id: string, activeViewGuid?: string | null } | null } | null };

export type DeleteModelMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteModelMutation = { __typename?: 'Mutation', deleteModel?: { __typename?: 'DeleteModelPayload', model?: { __typename?: 'Model', id: string } | null } | null };

export type DeleteModelVersionMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  versionName: Scalars['String'];
}>;


export type DeleteModelVersionMutation = { __typename?: 'Mutation', deleteModelVersion?: { __typename?: 'DeleteModelVersionPayload', model?: { __typename?: 'Model', id: string } | null } | null };

export type CreateOrderColumnMutationVariables = Exact<{
  input: CreateOrderColumnInput;
}>;


export type CreateOrderColumnMutation = { __typename?: 'Mutation', createOrderColumn?: { __typename?: 'CreateOrderColumnPayload', orderColumn?: { __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean } | null } | null };

export type UpdateOrderColumnMutationVariables = Exact<{
  input: UpdateOrderColumnInput;
}>;


export type UpdateOrderColumnMutation = { __typename?: 'Mutation', updateOrderColumn?: { __typename?: 'UpdateOrderColumnPayload', orderColumn?: { __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean } | null } | null };

export type DeleteOrderColumnMutationVariables = Exact<{
  input: DeleteOrderColumnInput;
}>;


export type DeleteOrderColumnMutation = { __typename?: 'Mutation', deleteOrderColumn?: { __typename?: 'DeleteOrderColumnPayload', orderColumn?: { __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean } | null } | null };

export type OrderColumnDeepFragment = { __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean };

export type GetOrderColumnDeepQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetOrderColumnDeepQuery = { __typename?: 'Query', orderColumn?: { __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean } | null };

export type CreateOrderEntryMutationVariables = Exact<{
  input: CreateOrderEntryInput;
}>;


export type CreateOrderEntryMutation = { __typename?: 'Mutation', createOrderEntry?: { __typename?: 'CreateOrderEntryPayload', orderEntry?: { __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null } | null } | null };

export type UpdateOrderEntryMutationVariables = Exact<{
  input: UpdateOrderEntryInput;
}>;


export type UpdateOrderEntryMutation = { __typename?: 'Mutation', updateOrderEntry?: { __typename?: 'UpdateOrderEntryPayload', orderEntry?: { __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null } | null } | null };

export type MoveOrCopyOrderEntriesMutationVariables = Exact<{
  input: MoveOrCopyOrderEntriesInput;
}>;


export type MoveOrCopyOrderEntriesMutation = { __typename?: 'Mutation', moveOrCopyOrderEntries?: { __typename?: 'MoveOrCopyOrderEntriesPayload', orderEntries?: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> | null } | null };

export type FlattenSubrowsMutationVariables = Exact<{
  input: FlattenSubrowsInput;
}>;


export type FlattenSubrowsMutation = { __typename?: 'Mutation', flattenSubrows?: { __typename?: 'FlattenSubrowsPayload', orderEntries?: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> | null } | null };

export type QuantityDeepFragment = { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null };

export type OrderEntryDeepFragment = { __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null };

export type ApplyPromptLinkingMutationVariables = Exact<{
  input: ApplyPromptLinkingInput;
}>;


export type ApplyPromptLinkingMutation = { __typename?: 'Mutation', applyPromptLinking: { __typename?: 'ApplyPromptLinkingPayload', success: boolean, message?: string | null } };

export type ColumnFilterDeepFragment = { __typename?: 'ColumnFilterType', columnName: string, filterValues: Array<string> };

export type OrderEntryViewDeepFragment = { __typename?: 'OrderEntryView', id: string, name: string, visibleColumns: Array<string>, globalFilter: string, projectId: string, columnFilters?: Array<{ __typename?: 'ColumnFilterType', columnName: string, filterValues: Array<string> }> | null };

export type CreateOrderEntryViewMutationVariables = Exact<{
  input: CreateOrderEntryViewInput;
}>;


export type CreateOrderEntryViewMutation = { __typename?: 'Mutation', createOrderEntryView?: { __typename?: 'CreateOrderEntryViewPayload', orderEntryView?: { __typename?: 'OrderEntryView', id: string, name: string, visibleColumns: Array<string>, globalFilter: string, projectId: string, columnFilters?: Array<{ __typename?: 'ColumnFilterType', columnName: string, filterValues: Array<string> }> | null } | null } | null };

export type DeleteOrderEntryViewMutationVariables = Exact<{
  input: DeleteOrderEntryViewInput;
}>;


export type DeleteOrderEntryViewMutation = { __typename?: 'Mutation', deleteOrderEntryView?: { __typename?: 'DeleteOrderEntryViewPayload', orderEntryView?: { __typename?: 'OrderEntryView', id: string, projectId: string } | null } | null };

export type UpdateOrderEntryViewMutationVariables = Exact<{
  input: UpdateOrderEntryViewInput;
}>;


export type UpdateOrderEntryViewMutation = { __typename?: 'Mutation', updateOrderEntryView?: { __typename?: 'UpdateOrderEntryViewPayload', orderEntryView?: { __typename?: 'OrderEntryView', id: string, name: string, visibleColumns: Array<string>, globalFilter: string, projectId: string, columnFilters?: Array<{ __typename?: 'ColumnFilterType', columnName: string, filterValues: Array<string> }> | null } | null } | null };

export type GetOrderEntryViewsForProjectDeepQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetOrderEntryViewsForProjectDeepQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, orderEntryViews: Array<{ __typename?: 'OrderEntryView', id: string, name: string, visibleColumns: Array<string>, globalFilter: string, projectId: string, columnFilters?: Array<{ __typename?: 'ColumnFilterType', columnName: string, filterValues: Array<string> }> | null }> } | null };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'CreateOrderPayload', order?: { __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> } | null } | null };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'UpdateOrderPayload', order?: { __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> } | null } | null };

export type DeleteOrderMutationVariables = Exact<{
  input: DeleteOrderInput;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: { __typename?: 'DeleteOrderPayload', order?: { __typename?: 'Order', id: string, projectId: string } | null } | null };

export type DuplicateOrderMutationVariables = Exact<{
  input: DuplicateOrderInput;
}>;


export type DuplicateOrderMutation = { __typename?: 'Mutation', duplicateOrder?: { __typename?: 'DuplicateOrderPayload', order?: { __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> } | null } | null };

export type OrderDeepFragment = { __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> };

export type GetOrderDeepQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetOrderDeepQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> } | null };

export type GetOrdersForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetOrdersForProjectQuery = { __typename?: 'Query', orders?: Array<{ __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> }> | null };

export type GetOrderLabelsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetOrderLabelsQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, labels?: string | null } | null };

export type GetExternalAccessTokenQueryVariables = Exact<{
  orderIds: Array<Scalars['UUID']> | Scalars['UUID'];
  expiresIn: Scalars['Int'];
}>;


export type GetExternalAccessTokenQuery = { __typename?: 'Query', externalAccessToken?: { __typename?: 'ExternalAccessToken', accessToken: string, expiresIn: number } | null };

export type BulkUpsertOrderEntryCacheMutationVariables = Exact<{
  input: BulkUpsertOrderEntryCacheInput;
}>;


export type BulkUpsertOrderEntryCacheMutation = { __typename?: 'Mutation', bulkUpsertOrderEntryCache?: { __typename?: 'BulkUpsertOrderEntryCachePayload', results?: Array<{ __typename?: 'BulkUpsertOrderEntryCacheRecord', id?: string | null, hash?: string | null, orderEntryId?: string | null }> | null } | null };

export type SavedViewDetailsFragment = { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null };

export type GetSavedViewsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  isCommentView: Scalars['Boolean'];
}>;


export type GetSavedViewsForProjectQuery = { __typename?: 'Query', savedViews?: Array<{ __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null }> | null };

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateSavedViewInput;
}>;


export type CreateSavedViewMutation = { __typename?: 'Mutation', createSavedView?: { __typename?: 'CreateSavedViewPayload', savedView?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null } | null };

export type UpdateSavedViewMutationVariables = Exact<{
  input: UpdateSavedViewInput;
}>;


export type UpdateSavedViewMutation = { __typename?: 'Mutation', updateSavedView?: { __typename?: 'UpdateSavedViewPayload', savedView?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null } | null };

export type DeleteSavedViewMutationVariables = Exact<{
  input: DeleteSavedViewInput;
}>;


export type DeleteSavedViewMutation = { __typename?: 'Mutation', deleteSavedView?: { __typename?: 'DeleteSavedViewPayload', savedView?: { __typename?: 'SavedView', id: string, name: string, projectId: string, isDefault: boolean, isCommentView?: boolean | null, section?: ViewSection | null, layers: Array<string>, categories: Array<string>, statuses: Array<string>, hiddenModels?: Array<string> | null, createdAt: string, updatedAt: string, cameraPosition?: { __typename?: 'CameraPositionType', positionX: number, positionY: number, positionZ: number, targetX: number, targetY: number, targetZ: number, upX: number, upY: number, upZ: number, aspect: number, fov: number, orthoScale: number, isPerspective: boolean, applyGlobalOffset: boolean } | null, hiddenElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, isolatedElements?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null } | null } | null };

export type ProjectTagDeepFragment = { __typename?: 'ProjectTag', id: string, name: string, color: TagColorScheme };

export type GetProjectTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectTagsQuery = { __typename?: 'Query', projectTagsConnection?: { __typename?: 'ProjectTagsConnection', nodes: Array<{ __typename?: 'ProjectTag', id: string, name: string, color: TagColorScheme }> } | null };

export type CreateProjectTagMutationVariables = Exact<{
  input: CreateProjectTagInput;
}>;


export type CreateProjectTagMutation = { __typename?: 'Mutation', createProjectTag?: { __typename?: 'CreateProjectTagPayload', projectTag?: { __typename?: 'ProjectTag', id: string, name: string, color: TagColorScheme } | null } | null };

export type UpdateProjectTagMutationVariables = Exact<{
  input: UpdateProjectTagInput;
}>;


export type UpdateProjectTagMutation = { __typename?: 'Mutation', updateProjectTag?: { __typename?: 'UpdateProjectTagPayload', projectTag?: { __typename?: 'ProjectTag', id: string, name: string, color: TagColorScheme } | null } | null };

export type DeleteProjectTagMutationVariables = Exact<{
  input: DeleteProjectTagInput;
}>;


export type DeleteProjectTagMutation = { __typename?: 'Mutation', deleteProjectTag?: { __typename?: 'DeleteProjectTagPayload', projectTag?: { __typename?: 'ProjectTag', id: string, name: string, color: TagColorScheme } | null } | null };

export type GetProjectTemplatesPageQueryVariables = Exact<{
  first?: Scalars['Int'];
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetProjectTemplatesPageQuery = { __typename?: 'Query', projectTemplatesConnection?: { __typename?: 'ProjectTemplatesConnection', nodes: Array<{ __typename?: 'ProjectTemplate', id: string, templateName: string, isPublic: boolean, createdAt: string, updatedAt: string, projectTemplateOrders: Array<{ __typename?: 'ProjectTemplateOrder', id: string, name: string, labels?: string | null, projectTemplateOrderEntries: Array<{ __typename?: 'ProjectTemplateOrderEntry', id: string, name: string }> }> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type ProjectTemplateDeepFragment = { __typename?: 'ProjectTemplate', id: string, templateName: string, isPublic: boolean, createdAt: string, updatedAt: string, projectTemplateOrders: Array<{ __typename?: 'ProjectTemplateOrder', id: string, name: string, labels?: string | null, projectTemplateOrderEntries: Array<{ __typename?: 'ProjectTemplateOrderEntry', id: string, name: string }> }> };

export type CreateProjectFromTemplateMutationVariables = Exact<{
  projectName: Scalars['String'];
  theProjectTemplateId: Scalars['UUID'];
}>;


export type CreateProjectFromTemplateMutation = { __typename?: 'Mutation', createProjectFromTemplate?: { __typename?: 'CreateProjectFromTemplatePayload', project?: { __typename?: 'Project', id: string, name: string, createdAt: string, updatedAt: string, createdBy?: string | null, tags: Array<string>, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', name: string, type: LabelEnum }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null, orders: Array<{ __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> }> } | null } | null };

export type CreateTableFromTemplateMutationVariables = Exact<{
  templateId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  newName: Scalars['String'];
}>;


export type CreateTableFromTemplateMutation = { __typename?: 'Mutation', createTableFromTemplate?: { __typename?: 'CreateTableFromTemplatePayload', order?: { __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> } | null } | null };

export type RenameProjectTemplateMutationVariables = Exact<{
  id: Scalars['UUID'];
  newName: Scalars['String'];
}>;


export type RenameProjectTemplateMutation = { __typename?: 'Mutation', updateProjectTemplate?: { __typename?: 'UpdateProjectTemplatePayload', projectTemplate?: { __typename?: 'ProjectTemplate', id: string, templateName: string, isPublic: boolean, createdAt: string, updatedAt: string, projectTemplateOrders: Array<{ __typename?: 'ProjectTemplateOrder', id: string, name: string, labels?: string | null, projectTemplateOrderEntries: Array<{ __typename?: 'ProjectTemplateOrderEntry', id: string, name: string }> }> } | null } | null };

export type CreateTemplateFromProjectMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  templateName: Scalars['String'];
}>;


export type CreateTemplateFromProjectMutation = { __typename?: 'Mutation', createTemplateFromProject?: { __typename?: 'CreateTemplateFromProjectPayload', projectTemplate?: { __typename?: 'ProjectTemplate', id: string, templateName: string, isPublic: boolean, createdAt: string, updatedAt: string, projectTemplateOrders: Array<{ __typename?: 'ProjectTemplateOrder', id: string, name: string, labels?: string | null, projectTemplateOrderEntries: Array<{ __typename?: 'ProjectTemplateOrderEntry', id: string, name: string }> }> } | null } | null };

export type DeleteProjectTemplateMutationVariables = Exact<{
  input: DeleteProjectTemplateInput;
}>;


export type DeleteProjectTemplateMutation = { __typename?: 'Mutation', deleteProjectTemplate?: { __typename?: 'DeleteProjectTemplatePayload', projectTemplate?: { __typename?: 'ProjectTemplate', id: string } | null } | null };

export type GetOrdersForProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersForProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: string, name: string, orders: Array<{ __typename?: 'Order', id: string, name: string, projectId: string }> }> | null };

export type GetTagsByProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetTagsByProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, tags: Array<string> } | null };

export type GetProjectPageQueryVariables = Exact<{
  first?: Scalars['Int'];
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ProjectFilter>;
}>;


export type GetProjectPageQuery = { __typename?: 'Query', projectsConnection?: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, createdAt: string, updatedAt: string, createdBy?: string | null, tags: Array<string> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetSparkelAiAnalysisByProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetSparkelAiAnalysisByProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, sparkelAiAnalyses: Array<{ __typename?: 'SparkelAiAnalysis', createdAt: string, id: string, value: string, label: string }> } | null };

export type GetProjectSettingsQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetProjectSettingsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, tags: Array<string>, createdAt: string, updatedAt: string, createdBy?: string | null, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', type: LabelEnum, name: string }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null } | null };

export type ProjectDeepFragment = { __typename?: 'Project', id: string, name: string, createdAt: string, updatedAt: string, createdBy?: string | null, tags: Array<string>, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', name: string, type: LabelEnum }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null, orders: Array<{ __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> }> };

export type GetProjectDeepQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectDeepQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, createdAt: string, updatedAt: string, createdBy?: string | null, tags: Array<string>, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', name: string, type: LabelEnum }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null, orders: Array<{ __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> }> } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'CreateProjectPayload', project?: { __typename?: 'Project', id: string, name: string, createdAt: string, updatedAt: string, createdBy?: string | null, tags: Array<string>, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', name: string, type: LabelEnum }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null, orders: Array<{ __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> }> } | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', name: string, id: string, tags: Array<string>, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', name: string, type: LabelEnum }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null } | null } | null };

export type DuplicateProjectMutationVariables = Exact<{
  input: DuplicateProjectInput;
}>;


export type DuplicateProjectMutation = { __typename?: 'Mutation', duplicateProject?: { __typename?: 'DuplicateProjectPayload', project?: { __typename?: 'Project', id: string, name: string, createdAt: string, updatedAt: string, createdBy?: string | null, tags: Array<string>, settings?: { __typename?: 'ProjectSettingsType', translationType?: TranslationType | null, polygonCalculationLimit?: number | null, manuallyApplyFilters?: boolean | null, viewerGlobalOffset?: { __typename?: 'Point3Type', x: number, y: number, z: number } | null, allowedOrderLabels?: Array<{ __typename?: 'LabelType', name: string, type: LabelEnum }> | null, allowedElementsCategories?: Array<{ __typename?: 'ElementCategoryType', name: string, type: ElementCategoryEnum, dropdownValues?: Array<{ __typename?: 'DropdownOption', value?: string | null, colorScheme?: TagColorScheme | null }> | null }> | null, unitSettings?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null } | null, orders: Array<{ __typename?: 'Order', id: string, name: string, createdBy?: string | null, status: OrderStatus, labels?: string | null, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderView?: AggregatedOrderViewType | null, columnNameMapping?: any | null, projectId: string, createdAt: string, updatedAt: string, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderAggregation?: Array<{ __typename?: 'AggregatedOrderAggregationType', columnName?: string | null, columnType?: ColumnType | null, aggregationValue?: string | null }> | null, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }>, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null }> }> } | null } | null };

export type DeleteProjectMutationVariables = Exact<{
  input: DeleteProjectInput;
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject?: { __typename?: 'DeleteProjectPayload', project?: { __typename?: 'Project', id: string } | null } | null };

export type CreateProjectFromDocumentsMutationVariables = Exact<{
  input: CreateProjectFromDocumentsInput;
}>;


export type CreateProjectFromDocumentsMutation = { __typename?: 'Mutation', createProjectFromDocuments: { __typename?: 'CreateProjectFromDocumentsPayload', success: boolean, message?: string | null, jobId?: string | null } };

export type CreateProjectFromDocumentsStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type CreateProjectFromDocumentsStatusQuery = { __typename?: 'Query', createProjectFromDocumentsStatus: { __typename?: 'CreateProjectFromDocumentsStatusPayload', status: string, projectId?: string | null } };

export type ProtanProjectStepDeepFragment = { __typename?: 'ProtanProjectStep', id: string, projectId: string, step: ProtanProjectStepEnum, status: ProtanProjectStepStatusEnum };

export type GetProtanProjectStepsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetProtanProjectStepsForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, protanProjectSteps: Array<{ __typename?: 'ProtanProjectStep', id: string, projectId: string, step: ProtanProjectStepEnum, status: ProtanProjectStepStatusEnum }> } | null };

export type UpsertProtanProjectStepMutationVariables = Exact<{
  input: UpsertProtanProjectStepInput;
}>;


export type UpsertProtanProjectStepMutation = { __typename?: 'Mutation', upsertProtanProjectStep?: { __typename?: 'UpsertProtanProjectStepPayload', protanProjectSteps?: Array<{ __typename?: 'ProtanProjectStep', id: string, projectId: string, step: ProtanProjectStepEnum, status: ProtanProjectStepStatusEnum }> | null } | null };

export type GetOrderEntryTemplatesPageQueryVariables = Exact<{
  first?: Scalars['Int'];
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetOrderEntryTemplatesPageQuery = { __typename?: 'Query', orderEntryTemplatesConnection?: { __typename?: 'OrderEntryTemplatesConnection', nodes: Array<{ __typename?: 'OrderEntryTemplate', id: string, templateName: string, name: string, unit?: Unit | null, unitPrice?: number | null, isPublic: boolean, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, customFields?: Array<{ __typename?: 'TemplateCustomFieldType', name: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }> | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type OrderEntryTemplateDeepFragment = { __typename?: 'OrderEntryTemplate', id: string, templateName: string, name: string, unit?: Unit | null, unitPrice?: number | null, isPublic: boolean, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, customFields?: Array<{ __typename?: 'TemplateCustomFieldType', name: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }> | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null };

export type CreateTemplateFromOrderEntryMutationVariables = Exact<{
  orderEntryId: Scalars['UUID'];
  templateName: Scalars['String'];
}>;


export type CreateTemplateFromOrderEntryMutation = { __typename?: 'Mutation', createTemplateFromOrderEntry?: { __typename?: 'CreateTemplateFromOrderEntryPayload', orderEntryTemplate?: { __typename?: 'OrderEntryTemplate', id: string, templateName: string, name: string, unit?: Unit | null, unitPrice?: number | null, isPublic: boolean, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, customFields?: Array<{ __typename?: 'TemplateCustomFieldType', name: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }> | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null } | null } | null };

export type CreateOrderEntryFromTemplateMutationVariables = Exact<{
  input: CreateOrderEntryFromTemplateInput;
}>;


export type CreateOrderEntryFromTemplateMutation = { __typename?: 'Mutation', createOrderEntryFromTemplate?: { __typename?: 'CreateOrderEntryFromTemplatePayload', orderEntry?: { __typename?: 'OrderEntry', id: string, orderId: string, name: string, unit?: Unit | null, color: string, usePromptForLinking: boolean, promptForLinking?: string | null, unitPrice?: number | null, currency: CurrencyEnum, createdAt: string, updatedAt: string, order?: { __typename?: 'Order', id: string, orderColumns: Array<{ __typename?: 'OrderColumn', id: string, name: string, isVisible: boolean, columnType: ColumnType, orderId: string, columnOrder?: number | null, showTotal: boolean }> } | null, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, customFields: Array<{ __typename?: 'CustomField', id: string, orderColumnId: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }>, orderEntryCache?: { __typename?: 'OrderEntryCache', id: string, hash: string, value: any } | null } | null } | null };

export type RenameOrderEntryTemplateMutationVariables = Exact<{
  id: Scalars['UUID'];
  newName: Scalars['String'];
}>;


export type RenameOrderEntryTemplateMutation = { __typename?: 'Mutation', updateOrderEntryTemplate?: { __typename?: 'UpdateOrderEntryTemplatePayload', orderEntryTemplate?: { __typename?: 'OrderEntryTemplate', id: string, templateName: string, name: string, unit?: Unit | null, unitPrice?: number | null, isPublic: boolean, createdAt: string, updatedAt: string, quantity?: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } | null, elementIdentifiersQuery?: { __typename?: 'ForgeAttributeQueryType', predicates: Array<{ __typename?: 'ForgeAttributePredicateType', predicate: PredicateType, attributeValues?: Array<string> | null, attribute: { __typename?: 'ForgeAttributeType', category: string, name: string } }> } | null, elementIdentifiersDbid?: Array<{ __typename?: 'ElementIdentifierDbidType', modelUrn: string, dbIds: Array<number> }> | null, customFields?: Array<{ __typename?: 'TemplateCustomFieldType', name: string, value: { __typename?: 'QuantityType', type: QuantityEnum, value?: number | null, stringValue?: string | null, derivedFormula?: string | null, calculation?: { __typename?: 'CalculationType', operation: QuantityOperation, attribute?: { __typename?: 'ForgeAttributeType', category: string, name: string } | null } | null, unitFormatOverride?: { __typename?: 'UnitSettingsType', length?: { __typename?: 'LengthUnitSettingType', units?: LengthUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, area?: { __typename?: 'AreaUnitSettingType', units?: AreaUnitTypeEnum | null, rounding?: RoundingEnum | null } | null, volume?: { __typename?: 'VolumeUnitSettingType', units?: VolumeUnitTypeEnum | null, rounding?: RoundingEnum | null } | null } | null, databaseLookup?: { __typename?: 'DatabaseLookupType', databaseId?: string | null, valueColumnId?: string | null, searchColumnId?: string | null, searchTerm?: string | null, lookupProfileId?: string | null } | null } }> | null, groupByAttributes?: Array<{ __typename?: 'ForgeAttributeType', category: string, name: string }> | null } | null } | null };

export type DeleteOrderEntryTemplateMutationVariables = Exact<{
  input: DeleteOrderEntryTemplateInput;
}>;


export type DeleteOrderEntryTemplateMutation = { __typename?: 'Mutation', deleteOrderEntryTemplate?: { __typename?: 'DeleteOrderEntryTemplatePayload', orderEntryTemplate?: { __typename?: 'OrderEntryTemplate', id: string } | null } | null };

export type ShapeFolderDeepFragment = { __typename?: 'ShapeFolder', id: string, name: string, createdAt: string, updatedAt: string, projectId: string };

export type CreateShapeFolderMutationVariables = Exact<{
  input: CreateShapeFolderInput;
}>;


export type CreateShapeFolderMutation = { __typename?: 'Mutation', createShapeFolder?: { __typename?: 'CreateShapeFolderPayload', shapeFolder?: { __typename?: 'ShapeFolder', id: string, name: string, createdAt: string, updatedAt: string, projectId: string } | null } | null };

export type UpdateShapeFolderMutationVariables = Exact<{
  input: UpdateShapeFolderInput;
}>;


export type UpdateShapeFolderMutation = { __typename?: 'Mutation', updateShapeFolder?: { __typename?: 'UpdateShapeFolderPayload', shapeFolder?: { __typename?: 'ShapeFolder', id: string, name: string, createdAt: string, updatedAt: string, projectId: string } | null } | null };

export type DeleteShapeFolderMutationVariables = Exact<{
  input: DeleteShapeFolderInput;
}>;


export type DeleteShapeFolderMutation = { __typename?: 'Mutation', deleteShapeFolder?: { __typename?: 'DeleteShapeFolderPayload', shapeFolder?: { __typename?: 'ShapeFolder', id: string, projectId: string } | null } | null };

export type GetShapeFoldersForProjectDeepQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetShapeFoldersForProjectDeepQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, shapeFolders: Array<{ __typename?: 'ShapeFolder', id: string, name: string, createdAt: string, updatedAt: string, projectId: string }> } | null };

export type UpdateFolderForShapesMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateFolderForShapesMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, shapes: Array<{ __typename?: 'Shape', id: string, folder?: string | null }>, sheetShapes: Array<{ __typename?: 'SheetShape', id: string, folder?: string | null }> } | null } | null };

export type MultiPolygon3Fragment = { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> };

export type ShapeDeepFragment = { __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null };

export type CreateShapeMutationVariables = Exact<{
  input: CreateShapeInput;
}>;


export type CreateShapeMutation = { __typename?: 'Mutation', createShape?: { __typename?: 'CreateShapePayload', shape?: { __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null } | null } | null };

export type UpdateShapeMutationVariables = Exact<{
  input: UpdateShapeInput;
}>;


export type UpdateShapeMutation = { __typename?: 'Mutation', updateShape?: { __typename?: 'UpdateShapePayload', shape?: { __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null } | null } | null };

export type DeleteShapeMutationVariables = Exact<{
  input: DeleteShapeInput;
}>;


export type DeleteShapeMutation = { __typename?: 'Mutation', deleteShape?: { __typename?: 'DeleteShapePayload', shape?: { __typename?: 'Shape', id: string, projectId: string } | null } | null };

export type BulkDeleteShapesMutationVariables = Exact<{
  input: BulkDeleteShapesInput;
}>;


export type BulkDeleteShapesMutation = { __typename?: 'Mutation', bulkDeleteShapes?: { __typename?: 'BulkDeleteShapesPayload', shapes?: Array<{ __typename?: 'Shape', id: string, projectId: string }> | null } | null };

export type BulkCreateShapesMutationVariables = Exact<{
  input: BulkCreateShapesInput;
}>;


export type BulkCreateShapesMutation = { __typename?: 'Mutation', bulkCreateShapes?: { __typename?: 'BulkCreateShapesPayload', shapes?: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }> | null } | null };

export type BulkUpdateShapesMutationVariables = Exact<{
  input: BulkUpdateShapesInput;
}>;


export type BulkUpdateShapesMutation = { __typename?: 'Mutation', bulkUpdateShapes?: { __typename?: 'BulkUpdateShapesPayload', shapes?: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }> | null } | null };

export type GetShapesForProjectDeepQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetShapesForProjectDeepQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, shapes: Array<{ __typename: 'Shape', id: string, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, line?: { __typename?: 'Line', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> } | null, polygon?: { __typename?: 'Polygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, extrudedPolygon?: { __typename?: 'ExtrudedPolygon', id: number, shapeId: string, unitScale: number, createdAt: string, updatedAt: string, thickness: number, multipolygon: { __typename?: 'MultiPolygon3Type', polygons: Array<{ __typename?: 'Polygon3Type', exterior: { __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }, interiors: Array<{ __typename?: 'LinearRing3Type', points: Array<{ __typename?: 'Point3Type', x: number, y: number, z: number }> }> }> }, plane: { __typename?: 'PlaneType', a: number, b: number, c: number, d: number } } | null, shapePoint?: { __typename?: 'ShapePoint', id: number, shapeId: string, createdAt: string, updatedAt: string, point: { __typename?: 'Point3Type', x: number, y: number, z: number } } | null }> } | null };

export type ExportShapesToIfcMutationVariables = Exact<{
  input: ExportShapesToIfcInput;
}>;


export type ExportShapesToIfcMutation = { __typename?: 'Mutation', exportShapesToIfc: { __typename?: 'ExportShapesToIfcPayload', success: boolean, message?: string | null, jobId?: string | null } };

export type ExportShapesToIfcStatusQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  jobId: Scalars['String'];
}>;


export type ExportShapesToIfcStatusQuery = { __typename?: 'Query', exportShapesToIfcStatus: { __typename?: 'ExportShapesToIfcStatusPayload', status: string, downloadUrl?: string | null } };

export type SharedLinkDeepFragment = { __typename?: 'SharedLink', id: string, initialStateId: string, name?: string | null, orderIds?: Array<string> | null, createdAt: string, expiresAt: string, createdBy?: string | null };

export type GetSharedLinksQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetSharedLinksQuery = { __typename?: 'Query', sharedLinks?: Array<{ __typename?: 'SharedLink', id: string, initialStateId: string, name?: string | null, createdAt: string, expiresAt: string, createdBy?: string | null, orderIds?: Array<string> | null }> | null };

export type GetSharedLinksForOrderQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  orderId: Scalars['UUID'];
}>;


export type GetSharedLinksForOrderQuery = { __typename?: 'Query', sharedLinks?: Array<{ __typename?: 'SharedLink', id: string, name?: string | null, expiresAt: string }> | null };

export type DeleteSharedLinkMutationVariables = Exact<{
  input: DeleteSharedLinkInput;
}>;


export type DeleteSharedLinkMutation = { __typename?: 'Mutation', deleteSharedLink?: { __typename?: 'DeleteSharedLinkPayload', sharedLink?: { __typename?: 'SharedLink', id: string, projectId: string } | null } | null };

export type CreateSharedLinkWithDurationMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  initialStateId: Scalars['UUID'];
  name: Scalars['String'];
  expiresInSeconds: Scalars['Int'];
  orderIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type CreateSharedLinkWithDurationMutation = { __typename?: 'Mutation', createSharedLinkWithDuration?: { __typename?: 'CreateSharedLinkWithDurationPayload', sharedLink?: { __typename?: 'SharedLink', id: string, initialStateId: string, name?: string | null, expiresAt: string, createdAt: string, createdBy?: string | null, orderIds?: Array<string> | null } | null } | null };

export type MultiPolygon2Fragment = { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> };

export type SheetShapeDeepFragment = { __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null };

export type CreateSheetShapeMutationVariables = Exact<{
  input: CreateSheetShapeInput;
}>;


export type CreateSheetShapeMutation = { __typename?: 'Mutation', createSheetShape?: { __typename?: 'CreateSheetShapePayload', sheetShape?: { __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null } | null } | null };

export type UpdateSheetShapeMutationVariables = Exact<{
  input: UpdateSheetShapeInput;
}>;


export type UpdateSheetShapeMutation = { __typename?: 'Mutation', updateSheetShape?: { __typename?: 'UpdateSheetShapePayload', sheetShape?: { __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null } | null } | null };

export type DeleteSheetShapeMutationVariables = Exact<{
  input: DeleteSheetShapeInput;
}>;


export type DeleteSheetShapeMutation = { __typename?: 'Mutation', deleteSheetShape?: { __typename?: 'DeleteSheetShapePayload', sheetShape?: { __typename?: 'SheetShape', id: string, projectId: string, sheetId: string, sheetPageNumber: number } | null } | null };

export type BulkDeleteSheetShapesMutationVariables = Exact<{
  input: BulkDeleteSheetShapesInput;
}>;


export type BulkDeleteSheetShapesMutation = { __typename?: 'Mutation', bulkDeleteSheetShapes?: { __typename?: 'BulkDeleteSheetShapesPayload', sheetShapes?: Array<{ __typename?: 'SheetShape', id: string, projectId: string, sheetId: string, sheetPageNumber: number }> | null } | null };

export type BulkCreateSheetShapesMutationVariables = Exact<{
  input: BulkCreateSheetShapesInput;
}>;


export type BulkCreateSheetShapesMutation = { __typename?: 'Mutation', bulkCreateSheetShapes?: { __typename?: 'BulkCreateSheetShapesPayload', sheetShapes?: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> | null } | null };

export type BulkUpdateSheetShapesMutationVariables = Exact<{
  input: BulkUpdateSheetShapesInput;
}>;


export type BulkUpdateSheetShapesMutation = { __typename?: 'Mutation', bulkUpdateSheetShapes?: { __typename?: 'BulkUpdateSheetShapesPayload', sheetShapes?: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> | null } | null };

export type GetSheetShapesForProjectDeepQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetSheetShapesForProjectDeepQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, sheetShapes: Array<{ __typename: 'SheetShape', id: string, sheetId: string, sheetPageNumber: number, name: string, urn: string, dbId: number, projectId: string, createdAt: string, updatedAt: string, folder?: string | null, autoShapeId?: string | null, sheetShapeLine?: { __typename?: 'SheetShapeLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapePolygon?: { __typename?: 'SheetShapePolygon', id: number, createdAt: string, updatedAt: string, multipolygon: { __typename?: 'MultiPolygon2Type', polygons: Array<{ __typename?: 'Polygon2Type', exterior: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }, interiors: Array<{ __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> }> }> } } | null, sheetShapePoint?: { __typename?: 'SheetShapePoint', id: number, createdAt: string, updatedAt: string, point: { __typename?: 'Point2Type', x: number, y: number } } | null, sheetShapeSplitLine?: { __typename?: 'SheetShapeSplitLine', id: number, createdAt: string, updatedAt: string, points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null, sheetShapeLegend?: { __typename?: 'SheetShapeLegend', id: number, createdAt: string, updatedAt: string, legendOrderId: string, position: { __typename?: 'Point2Type', x: number, y: number }, legendOrder?: { __typename?: 'Order', id: string, name: string, isAggregatedOrder: boolean, areItemsFlattened?: boolean | null, aggregatedOrderGrouping?: Array<{ __typename?: 'AggregatedOrderGroupingType', columnName?: string | null, columnType?: ColumnType | null }> | null, aggregatedOrderFilters?: Array<{ __typename?: 'AggregatedOrderFilterType', columnName?: string | null, columnType?: ColumnType | null, predicate?: PredicateType | null, predicateValues?: Array<string> | null }> | null, orderEntries: Array<{ __typename?: 'OrderEntry', id: string, name: string, color: string }> } | null } | null }> } | null };

export type GetMagicSheetShapeMutationVariables = Exact<{
  input: GetMagicSheetShapeInput;
}>;


export type GetMagicSheetShapeMutation = { __typename?: 'Mutation', getMagicSheetShape?: { __typename?: 'GetMagicSheetShapeResponse', polygon?: { __typename?: 'LinearRing2Type', points: Array<{ __typename?: 'Point2Type', x: number, y: number }> } | null } | null };

export type SheetPageCalibrationFragment = { __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } };

export type SheetsDeepFragment = { __typename?: 'Sheet', id: string, name: string, projectId: string, version: number, filename: string, createdAt: string, updatedAt: string, sheetPageCalibrations: Array<{ __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } }> };

export type GetSheetsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetSheetsForProjectQuery = { __typename?: 'Query', sheets?: Array<{ __typename?: 'Sheet', id: string, name: string, projectId: string, version: number, filename: string, createdAt: string, updatedAt: string, sheetPageCalibrations: Array<{ __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } }> }> | null };

export type GetActiveSheetsForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetActiveSheetsForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, activeSheets?: Array<{ __typename?: 'Sheet', id: string, name: string, projectId: string, version: number, filename: string, createdAt: string, updatedAt: string, sheetPageCalibrations: Array<{ __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } }> }> | null } | null };

export type GetActiveSheetsForOrderQueryVariables = Exact<{
  orderId: Scalars['UUID'];
}>;


export type GetActiveSheetsForOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, project?: { __typename?: 'Project', id: string, activeSheets?: Array<{ __typename?: 'Sheet', id: string, name: string, projectId: string, version: number, filename: string, createdAt: string, updatedAt: string, sheetPageCalibrations: Array<{ __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } }> }> | null } | null } | null };

export type CreateSheetMutationVariables = Exact<{
  input: CreateSheetInput;
}>;


export type CreateSheetMutation = { __typename?: 'Mutation', createSheet?: { __typename?: 'CreateSheetPayload', sheet?: { __typename?: 'Sheet', id: string, name: string, projectId: string, version: number, filename: string, createdAt: string, updatedAt: string, sheetPageCalibrations: Array<{ __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } }> } | null } | null };

export type CreateCalibrationMutationVariables = Exact<{
  input: CreateSheetPageCalibrationInput;
}>;


export type CreateCalibrationMutation = { __typename?: 'Mutation', createSheetPageCalibration?: { __typename?: 'CreateSheetPageCalibrationPayload', sheetPageCalibration?: { __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } } | null } | null };

export type UpdateCalibrationMutationVariables = Exact<{
  input: UpdateSheetPageCalibrationInput;
}>;


export type UpdateCalibrationMutation = { __typename?: 'Mutation', updateSheetPageCalibration?: { __typename?: 'UpdateSheetPageCalibrationPayload', sheetPageCalibration?: { __typename?: 'SheetPageCalibration', sheetId: string, pageNumber: number, createdAt: string, updatedAt: string, calibration: { __typename?: 'SheetScaleType', destinationWidth: number, destinationUnit: CalibrationUnit, pointA: { __typename?: 'Point2Type', x: number, y: number }, pointB: { __typename?: 'Point2Type', x: number, y: number } } } | null } | null };

export type DeleteSheetVersionMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  versionName: Scalars['String'];
}>;


export type DeleteSheetVersionMutation = { __typename?: 'Mutation', deleteSheetVersion?: { __typename?: 'DeleteSheetVersionPayload', sheet?: { __typename?: 'Sheet', id: string } | null } | null };

export type GetSparkelPropertiesForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID'];
}>;


export type GetSparkelPropertiesForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, sparkelProperties: Array<{ __typename?: 'SparkelProperty', id: string, projectId: string, propertySet: string, propertyValue: string, modelUrn: string, dbId: number }> } | null };

export type GetSparkelPropertiesForOrderQueryVariables = Exact<{
  orderId: Scalars['UUID'];
}>;


export type GetSparkelPropertiesForOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, project?: { __typename?: 'Project', sparkelProperties: Array<{ __typename?: 'SparkelProperty', id: string, projectId: string, propertySet: string, propertyValue: string, modelUrn: string, dbId: number }> } | null } | null };

export type SparkelPropertyInfoFragment = { __typename?: 'SparkelProperty', id: string, projectId: string, propertySet: string, propertyValue: string, modelUrn: string, dbId: number };

export type BulkUpsertSparkelPropertiesMutationVariables = Exact<{
  input: BulkUpsertSparkelPropertiesInput;
}>;


export type BulkUpsertSparkelPropertiesMutation = { __typename?: 'Mutation', bulkUpsertSparkelProperties?: { __typename?: 'BulkUpsertSparkelPropertiesPayload', sparkelProperties?: Array<{ __typename?: 'SparkelProperty', id: string, projectId: string, propertySet: string, propertyValue: string, modelUrn: string, dbId: number }> | null } | null };

export type BulkDeleteSparkelPropertiesMutationVariables = Exact<{
  input: BulkDeleteSparkelPropertiesInput;
}>;


export type BulkDeleteSparkelPropertiesMutation = { __typename?: 'Mutation', bulkDeleteSparkelProperties?: { __typename?: 'BulkDeleteSparkelPropertiesPayload', sparkelProperties?: Array<{ __typename?: 'SparkelProperty', id: string, projectId: string, propertySet: string, propertyValue: string, modelUrn: string, dbId: number }> | null } | null };

export type ListUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: Array<{ __typename?: 'User', id: string, displayName: string, email: string, accessProjectIds?: Array<string> | null }> };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, displayName: string, email: string, password?: string | null } };

export type UpdateAccessibleProjectsForUserMutationVariables = Exact<{
  id: Scalars['UUID'];
  projectIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UpdateAccessibleProjectsForUserMutation = { __typename?: 'Mutation', updateAccessibleProjectsForUser: { __typename?: 'User', id: string, displayName: string, email: string } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string } };

export const MultiPolygon3FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiPolygon3"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiPolygon3Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polygons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exterior"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"interiors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MultiPolygon3Fragment, unknown>;
export const ShapeDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShapeDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Shape"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urn"}},{"kind":"Field","name":{"kind":"Name","value":"dbId"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"folder"}},{"kind":"Field","name":{"kind":"Name","value":"autoShapeId"}},{"kind":"Field","name":{"kind":"Name","value":"line"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitScale"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitScale"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"multipolygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiPolygon3"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"b"}},{"kind":"Field","name":{"kind":"Name","value":"c"}},{"kind":"Field","name":{"kind":"Name","value":"d"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extrudedPolygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitScale"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"multipolygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiPolygon3"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"b"}},{"kind":"Field","name":{"kind":"Name","value":"c"}},{"kind":"Field","name":{"kind":"Name","value":"d"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thickness"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shapePoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapeId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}}]}}]}},...MultiPolygon3FragmentDoc.definitions]} as unknown as DocumentNode<ShapeDeepFragment, unknown>;
export const MultiPolygon2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiPolygon2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiPolygon2Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polygons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exterior"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"interiors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MultiPolygon2Fragment, unknown>;
export const SheetShapeDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SheetShapeDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SheetShape"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sheetId"}},{"kind":"Field","name":{"kind":"Name","value":"sheetPageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urn"}},{"kind":"Field","name":{"kind":"Name","value":"dbId"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"folder"}},{"kind":"Field","name":{"kind":"Name","value":"autoShapeId"}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapeLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapePolygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"multipolygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiPolygon2"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapePoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapeSplitLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapeLegend"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legendOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"legendOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAggregatedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"areItemsFlattened"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedOrderGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedOrderFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}},{"kind":"Field","name":{"kind":"Name","value":"predicate"}},{"kind":"Field","name":{"kind":"Name","value":"predicateValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}},...MultiPolygon2FragmentDoc.definitions]} as unknown as DocumentNode<SheetShapeDeepFragment, unknown>;
export const AutoShapeDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoShapeDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AutoShape"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"algorithmType"}},{"kind":"Field","name":{"kind":"Name","value":"algorithmInput"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"shapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetShapeDeep"}}]}}]}},...ShapeDeepFragmentDoc.definitions,...SheetShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<AutoShapeDeepFragment, unknown>;
export const SavedViewDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SavedViewDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SavedView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isCommentView"}},{"kind":"Field","name":{"kind":"Name","value":"cameraPosition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positionX"}},{"kind":"Field","name":{"kind":"Name","value":"positionY"}},{"kind":"Field","name":{"kind":"Name","value":"positionZ"}},{"kind":"Field","name":{"kind":"Name","value":"targetX"}},{"kind":"Field","name":{"kind":"Name","value":"targetY"}},{"kind":"Field","name":{"kind":"Name","value":"targetZ"}},{"kind":"Field","name":{"kind":"Name","value":"upX"}},{"kind":"Field","name":{"kind":"Name","value":"upY"}},{"kind":"Field","name":{"kind":"Name","value":"upZ"}},{"kind":"Field","name":{"kind":"Name","value":"aspect"}},{"kind":"Field","name":{"kind":"Name","value":"fov"}},{"kind":"Field","name":{"kind":"Name","value":"orthoScale"}},{"kind":"Field","name":{"kind":"Name","value":"isPerspective"}},{"kind":"Field","name":{"kind":"Name","value":"applyGlobalOffset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"layers"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"statuses"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenElements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelUrn"}},{"kind":"Field","name":{"kind":"Name","value":"dbIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isolatedElements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelUrn"}},{"kind":"Field","name":{"kind":"Name","value":"dbIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenModels"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<SavedViewDetailsFragment, unknown>;
export const CommentDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"replies"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtTz"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"readBy"}},{"kind":"Field","name":{"kind":"Name","value":"elementIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dbIds"}},{"kind":"Field","name":{"kind":"Name","value":"modelUrn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"savedViews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SavedViewDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anchorPoint3D"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}}]}},...SavedViewDetailsFragmentDoc.definitions]} as unknown as DocumentNode<CommentDeepFragment, unknown>;
export const CompanyDatabaseFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabasis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractorId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rowCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastImportAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastImportStatus"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CompanyDatabaseFieldsFragment, unknown>;
export const CompanyDatabaseColumnFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseColumnFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabaseColumn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"orderIndex"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CompanyDatabaseColumnFieldsFragment, unknown>;
export const CompanyDatabaseWithColumnsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseWithColumns"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabasis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseFields"}},{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseColumnsByDatabaseId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseColumnFields"}}]}}]}},...CompanyDatabaseFieldsFragmentDoc.definitions,...CompanyDatabaseColumnFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CompanyDatabaseWithColumnsFragment, unknown>;
export const CompanyDatabaseImportJobFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseImportJobFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabaseImportJob"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"contractorId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"totalRows"}},{"kind":"Field","name":{"kind":"Name","value":"insertedRows"}},{"kind":"Field","name":{"kind":"Name","value":"errorCount"}},{"kind":"Field","name":{"kind":"Name","value":"errorSummary"}}]}}]} as unknown as DocumentNode<CompanyDatabaseImportJobFieldsFragment, unknown>;
export const CompanyDatabaseRowFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseRowFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabaseRow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<CompanyDatabaseRowFieldsFragment, unknown>;
export const CompanyDatabaseCellFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseCellFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabaseCell"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"columnId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CompanyDatabaseCellFieldsFragment, unknown>;
export const CompanyDatabaseLookupProfileFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyDatabaseLookupProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDatabaseLookupProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"systemPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"matchCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePattern"}},{"kind":"Field","name":{"kind":"Name","value":"targetColumnId"}},{"kind":"Field","name":{"kind":"Name","value":"targetPattern"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"normalizations"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"negateSource"}},{"kind":"Field","name":{"kind":"Name","value":"negateTarget"}},{"kind":"Field","name":{"kind":"Name","value":"scoreWeight"}}]}}]}}]} as unknown as DocumentNode<CompanyDatabaseLookupProfileFieldsFragment, unknown>;
export const CopilotExchangeDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopilotExchangeDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopilotExchange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<CopilotExchangeDeepFragment, unknown>;
export const CopilotResultFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopilotResultFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopilotResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopilotBadQueryResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopilotResultData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"attributeQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"predicates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predicate"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity_extraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertySet"}},{"kind":"Field","name":{"kind":"Name","value":"propertyName"}},{"kind":"Field","name":{"kind":"Name","value":"operation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertySet"}},{"kind":"Field","name":{"kind":"Name","value":"propertyName"}}]}}]}}]}}]} as unknown as DocumentNode<CopilotResultFragmentFragment, unknown>;
export const FlowFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FlowFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"triggerType"}},{"kind":"Field","name":{"kind":"Name","value":"triggerConfig"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<FlowFieldsFragment, unknown>;
export const FlowActionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FlowActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FlowAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flowId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionConfig"}},{"kind":"Field","name":{"kind":"Name","value":"outputKey"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"parentLoopActionId"}},{"kind":"Field","name":{"kind":"Name","value":"loopConfig"}}]}}]} as unknown as DocumentNode<FlowActionFieldsFragment, unknown>;
export const FlowExecutionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FlowExecutionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FlowExecution"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flowId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentActionPosition"}},{"kind":"Field","name":{"kind":"Name","value":"inputData"}},{"kind":"Field","name":{"kind":"Name","value":"outputData"}},{"kind":"Field","name":{"kind":"Name","value":"createdResources"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorActionPosition"}},{"kind":"Field","name":{"kind":"Name","value":"lambdaRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<FlowExecutionFieldsFragment, unknown>;
export const HistoryEventDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HistoryEventDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"resourceName"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"resolved"}},{"kind":"Field","name":{"kind":"Name","value":"stateKey"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"isCheckpoint"}}]}}]} as unknown as DocumentNode<HistoryEventDeepFragment, unknown>;
export const HistoryEventGroupDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HistoryEventGroupDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetHistoryEventGroupsRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupDate"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"eventDay"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"isCheckpoint"}},{"kind":"Field","name":{"kind":"Name","value":"groupDate"}},{"kind":"Field","name":{"kind":"Name","value":"affectedResources"}},{"kind":"Field","name":{"kind":"Name","value":"eventCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoryEventDeep"}}]}}]}},...HistoryEventDeepFragmentDoc.definitions]} as unknown as DocumentNode<HistoryEventGroupDeepFragment, unknown>;
export const InitialStateDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitialStateDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitialState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOrderEntries"}},{"kind":"Field","name":{"kind":"Name","value":"expandedOrderEntries"}},{"kind":"Field","name":{"kind":"Name","value":"viewId"}},{"kind":"Field","name":{"kind":"Name","value":"viewSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ghosting"}},{"kind":"Field","name":{"kind":"Name","value":"focusMode"}},{"kind":"Field","name":{"kind":"Name","value":"showLabels"}},{"kind":"Field","name":{"kind":"Name","value":"orthographicMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalAccessToken"}}]}}]} as unknown as DocumentNode<InitialStateDeepFragment, unknown>;
export const PublicInitialStateDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicInitialStateDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicInitialState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalAccessToken"}}]}}]} as unknown as DocumentNode<PublicInitialStateDeepFragment, unknown>;
export const IssueCommentDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueCommentDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]} as unknown as DocumentNode<IssueCommentDeepFragment, unknown>;
export const IssueDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"assignedTo"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"commentCount"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]} as unknown as DocumentNode<IssueDeepFragment, unknown>;
export const ModelsDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModelsDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Model"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"forgeUrn"}},{"kind":"Field","name":{"kind":"Name","value":"activeViewGuid"}},{"kind":"Field","name":{"kind":"Name","value":"availableViewGuids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifcCategories"}},{"kind":"Field","name":{"kind":"Name","value":"ifcLayers"}},{"kind":"Field","name":{"kind":"Name","value":"revitCategories"}},{"kind":"Field","name":{"kind":"Name","value":"revitLevels"}},{"kind":"Field","name":{"kind":"Name","value":"propertySets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}}]}}]}}]} as unknown as DocumentNode<ModelsDeepFragment, unknown>;
export const OrderColumnDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderColumnDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderColumn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"columnOrder"}},{"kind":"Field","name":{"kind":"Name","value":"showTotal"}}]}}]} as unknown as DocumentNode<OrderColumnDeepFragment, unknown>;
export const ColumnFilterDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColumnFilterDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ColumnFilterType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"filterValues"}}]}}]} as unknown as DocumentNode<ColumnFilterDeepFragment, unknown>;
export const OrderEntryViewDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderEntryViewDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderEntryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibleColumns"}},{"kind":"Field","name":{"kind":"Name","value":"columnFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColumnFilterDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalFilter"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}},...ColumnFilterDeepFragmentDoc.definitions]} as unknown as DocumentNode<OrderEntryViewDeepFragment, unknown>;
export const ProjectTagDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTagDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<ProjectTagDeepFragment, unknown>;
export const ProjectTemplateDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplateDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"projectTemplateOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"projectTemplateOrderEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<ProjectTemplateDeepFragment, unknown>;
export const QuantityDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuantityDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuantityType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"stringValue"}},{"kind":"Field","name":{"kind":"Name","value":"calculation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"derivedFormula"}},{"kind":"Field","name":{"kind":"Name","value":"unitFormatOverride"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"databaseLookup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"valueColumnId"}},{"kind":"Field","name":{"kind":"Name","value":"searchColumnId"}},{"kind":"Field","name":{"kind":"Name","value":"searchTerm"}},{"kind":"Field","name":{"kind":"Name","value":"lookupProfileId"}}]}}]}}]} as unknown as DocumentNode<QuantityDeepFragment, unknown>;
export const OrderEntryDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderEntryDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"usePromptForLinking"}},{"kind":"Field","name":{"kind":"Name","value":"promptForLinking"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuantityDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupByAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"elementIdentifiersDbid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelUrn"}},{"kind":"Field","name":{"kind":"Name","value":"dbIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"elementIdentifiersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predicates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predicate"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuantityDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderColumnId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderEntryCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},...QuantityDeepFragmentDoc.definitions]} as unknown as DocumentNode<OrderEntryDeepFragment, unknown>;
export const OrderDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"isAggregatedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedOrderFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}},{"kind":"Field","name":{"kind":"Name","value":"predicate"}},{"kind":"Field","name":{"kind":"Name","value":"predicateValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedOrderGrouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"areItemsFlattened"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedOrderAggregation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}},{"kind":"Field","name":{"kind":"Name","value":"aggregationValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedOrderView"}},{"kind":"Field","name":{"kind":"Name","value":"columnNameMapping"}},{"kind":"Field","name":{"kind":"Name","value":"orderColumns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"columnType"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"columnOrder"}},{"kind":"Field","name":{"kind":"Name","value":"showTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},...OrderEntryDeepFragmentDoc.definitions]} as unknown as DocumentNode<OrderDeepFragment, unknown>;
export const ProjectDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerGlobalOffset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedOrderLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedElementsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"dropdownValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"colorScheme"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translationType"}},{"kind":"Field","name":{"kind":"Name","value":"polygonCalculationLimit"}},{"kind":"Field","name":{"kind":"Name","value":"unitSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"manuallyApplyFilters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<ProjectDeepFragment, unknown>;
export const ProtanProjectStepDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProtanProjectStepDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProtanProjectStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<ProtanProjectStepDeepFragment, unknown>;
export const OrderEntryTemplateDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderEntryTemplateDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderEntryTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuantityDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"elementIdentifiersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predicates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predicate"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"elementIdentifiersDbid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelUrn"}},{"kind":"Field","name":{"kind":"Name","value":"dbIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuantityDeep"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupByAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},...QuantityDeepFragmentDoc.definitions]} as unknown as DocumentNode<OrderEntryTemplateDeepFragment, unknown>;
export const ShapeFolderDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShapeFolderDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShapeFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]} as unknown as DocumentNode<ShapeFolderDeepFragment, unknown>;
export const SharedLinkDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedLinkDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SharedLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initialStateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}}]} as unknown as DocumentNode<SharedLinkDeepFragment, unknown>;
export const SheetPageCalibrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SheetPageCalibration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SheetPageCalibration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetId"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"calibration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointB"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"destinationWidth"}},{"kind":"Field","name":{"kind":"Name","value":"destinationUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<SheetPageCalibrationFragment, unknown>;
export const SheetsDeepFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SheetsDeep"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sheet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sheetPageCalibrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetPageCalibration"}}]}}]}},...SheetPageCalibrationFragmentDoc.definitions]} as unknown as DocumentNode<SheetsDeepFragment, unknown>;
export const SparkelPropertyInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SparkelPropertyInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SparkelProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"propertySet"}},{"kind":"Field","name":{"kind":"Name","value":"propertyValue"}},{"kind":"Field","name":{"kind":"Name","value":"modelUrn"}},{"kind":"Field","name":{"kind":"Name","value":"dbId"}}]}}]} as unknown as DocumentNode<SparkelPropertyInfoFragment, unknown>;
export const GetAlgorithmGeometryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAlgorithmGeometry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"algorithmType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dbIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAlgorithmGeometry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"algorithmType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"algorithmType"}}},{"kind":"Argument","name":{"kind":"Name","value":"dbIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dbIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dbId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"triangles"}},{"kind":"Field","name":{"kind":"Name","value":"multiPolygon"}},{"kind":"Field","name":{"kind":"Name","value":"multiPolyline"}},{"kind":"Field","name":{"kind":"Name","value":"point"}},{"kind":"Field","name":{"kind":"Name","value":"plane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"b"}},{"kind":"Field","name":{"kind":"Name","value":"c"}},{"kind":"Field","name":{"kind":"Name","value":"d"}}]}}]}}]}}]} as unknown as DocumentNode<GetAlgorithmGeometryQuery, GetAlgorithmGeometryQueryVariables>;
export const CreateAutoShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAutoShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAutoShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAutoShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoShapeDeep"}}]}}]}}]}},...AutoShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateAutoShapeMutation, CreateAutoShapeMutationVariables>;
export const UpdateAutoShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAutoShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAutoShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAutoShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoShapeDeep"}}]}}]}}]}},...AutoShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateAutoShapeMutation, UpdateAutoShapeMutationVariables>;
export const DeleteAutoShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAutoShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAutoShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAutoShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAutoShapeMutation, DeleteAutoShapeMutationVariables>;
export const GetAutoShapesForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoShapesForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoShapeDeep"}}]}}]}}]}},...AutoShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetAutoShapesForProjectQuery, GetAutoShapesForProjectQueryVariables>;
export const OnAutoShapeStatusUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnAutoShapeStatusUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoShapeStatusUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoShapeDeep"}}]}}]}}]}},...AutoShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<OnAutoShapeStatusUpdatedSubscription, OnAutoShapeStatusUpdatedSubscriptionVariables>;
export const RunExternalWallFinishes3DDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunExternalWallFinishes3D"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalWallFinishes3DInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runExternalWallFinishes3D"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<RunExternalWallFinishes3DMutation, RunExternalWallFinishes3DMutationVariables>;
export const RunRoomDetection2DDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunRoomDetection2D"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomDetection2DInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runRoomDetection2D"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<RunRoomDetection2DMutation, RunRoomDetection2DMutationVariables>;
export const RunSymbolDetection2DDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunSymbolDetection2D"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SymbolDetection2DInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runSymbolDetection2D"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<RunSymbolDetection2DMutation, RunSymbolDetection2DMutationVariables>;
export const DeleteAutoShapeShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAutoShapeShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoShapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAutoShapeShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"autoShapeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoShapeId"}}}]}]}}]} as unknown as DocumentNode<DeleteAutoShapeShapesMutation, DeleteAutoShapeShapesMutationVariables>;
export const GetProjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetProjectNameQuery, GetProjectNameQueryVariables>;
export const GetOrderNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]} as unknown as DocumentNode<GetOrderNameQuery, GetOrderNameQueryVariables>;
export const CreateCommentMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCommentMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentDeep"}}]}}]}}]}},...CommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateCommentMutationMutation, CreateCommentMutationMutationVariables>;
export const UpdateCommentMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCommentMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentDeep"}}]}}]}}]}},...CommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCommentMutationMutation, UpdateCommentMutationMutationVariables>;
export const ListAllCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListAllComments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentDeep"}}]}}]}},...CommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<ListAllCommentsQuery, ListAllCommentsQueryVariables>;
export const GetCommentDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCommentDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentDeep"}}]}}]}},...CommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetCommentDeepQuery, GetCommentDeepQueryVariables>;
export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const ListCompanyDatabasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCompanyDatabases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseFields"}}]}}]}},...CompanyDatabaseFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ListCompanyDatabasesQuery, ListCompanyDatabasesQueryVariables>;
export const GetCompanyDatabaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseWithColumns"}}]}}]}},...CompanyDatabaseWithColumnsFragmentDoc.definitions]} as unknown as DocumentNode<GetCompanyDatabaseQuery, GetCompanyDatabaseQueryVariables>;
export const CreateCompanyDatabaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCompanyDatabase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCompanyDatabasisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanyDatabasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabasis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseFields"}}]}}]}}]}},...CompanyDatabaseFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CreateCompanyDatabaseMutation, CreateCompanyDatabaseMutationVariables>;
export const UpdateCompanyDatabaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyDatabase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCompanyDatabasisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyDatabasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabasis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseFields"}}]}}]}}]}},...CompanyDatabaseFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCompanyDatabaseMutation, UpdateCompanyDatabaseMutationVariables>;
export const DeleteCompanyDatabaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCompanyDatabase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCompanyDatabasisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCompanyDatabasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabasis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCompanyDatabaseMutation, DeleteCompanyDatabaseMutationVariables>;
export const CreateCompanyDatabaseColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCompanyDatabaseColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCompanyDatabaseColumnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanyDatabaseColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseColumnFields"}}]}}]}}]}},...CompanyDatabaseColumnFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CreateCompanyDatabaseColumnMutation, CreateCompanyDatabaseColumnMutationVariables>;
export const UpdateCompanyDatabaseColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyDatabaseColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCompanyDatabaseColumnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyDatabaseColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseColumnFields"}}]}}]}}]}},...CompanyDatabaseColumnFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCompanyDatabaseColumnMutation, UpdateCompanyDatabaseColumnMutationVariables>;
export const DeleteCompanyDatabaseColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCompanyDatabaseColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCompanyDatabaseColumnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCompanyDatabaseColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCompanyDatabaseColumnMutation, DeleteCompanyDatabaseColumnMutationVariables>;
export const GetCompanyDatabaseLookupProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseLookupProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseLookupProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"databaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseLookupProfileFields"}}]}}]}},...CompanyDatabaseLookupProfileFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetCompanyDatabaseLookupProfilesQuery, GetCompanyDatabaseLookupProfilesQueryVariables>;
export const LookupCompanyDatabaseValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookupCompanyDatabaseValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchColumnId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueColumnId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lookupProfileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookupCompanyDatabaseValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"databaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchColumnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchColumnId"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"valueColumnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueColumnId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lookupProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lookupProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"found"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}}]}}]}}]} as unknown as DocumentNode<LookupCompanyDatabaseValueQuery, LookupCompanyDatabaseValueQueryVariables>;
export const GetCompanyDatabaseCellValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseCellValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columnId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCompanyDatabaseCellValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"columnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columnId"}}}]}]}}]} as unknown as DocumentNode<GetCompanyDatabaseCellValueQuery, GetCompanyDatabaseCellValueQueryVariables>;
export const GetCompanyDatabaseColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCompanyDatabaseColumnQuery, GetCompanyDatabaseColumnQueryVariables>;
export const GetCompanyDatabaseRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterRowIndex"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}},"defaultValue":{"kind":"StringValue","value":"0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseRowsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"databaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rowIndex"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterRowIndex"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ROW_INDEX_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseRowFields"}},{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseCellsByRowIdConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseCellFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...CompanyDatabaseRowFieldsFragmentDoc.definitions,...CompanyDatabaseCellFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetCompanyDatabaseRowsQuery, GetCompanyDatabaseRowsQueryVariables>;
export const GetCompanyDatabaseCellsForRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseCellsForRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseCells"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rowId"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rowIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseCellFields"}}]}}]}},...CompanyDatabaseCellFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetCompanyDatabaseCellsForRowsQuery, GetCompanyDatabaseCellsForRowsQueryVariables>;
export const GetCompanyDatabaseImportJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseImportJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseImportJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"databaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"databaseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseImportJobFields"}}]}}]}},...CompanyDatabaseImportJobFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetCompanyDatabaseImportJobsQuery, GetCompanyDatabaseImportJobsQueryVariables>;
export const GetCompanyDatabaseImportJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyDatabaseImportJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseImportJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseImportJobFields"}}]}}]}},...CompanyDatabaseImportJobFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetCompanyDatabaseImportJobQuery, GetCompanyDatabaseImportJobQueryVariables>;
export const CreateCompanyDatabaseImportJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCompanyDatabaseImportJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCompanyDatabaseImportJobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanyDatabaseImportJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseImportJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseImportJobFields"}}]}}]}}]}},...CompanyDatabaseImportJobFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CreateCompanyDatabaseImportJobMutation, CreateCompanyDatabaseImportJobMutationVariables>;
export const UpdateCompanyDatabaseImportJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyDatabaseImportJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCompanyDatabaseImportJobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyDatabaseImportJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDatabaseImportJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyDatabaseImportJobFields"}}]}}]}}]}},...CompanyDatabaseImportJobFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCompanyDatabaseImportJobMutation, UpdateCompanyDatabaseImportJobMutationVariables>;
export const ImportCompanyDatabaseDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCompanyDatabaseData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportCompanyDatabaseDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCompanyDatabaseData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rowsImported"}},{"kind":"Field","name":{"kind":"Name","value":"columnsCreated"}},{"kind":"Field","name":{"kind":"Name","value":"columnIds"}}]}}]}}]} as unknown as DocumentNode<ImportCompanyDatabaseDataMutation, ImportCompanyDatabaseDataMutationVariables>;
export const ListContractorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListContractors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contractorTier"}}]}}]}}]} as unknown as DocumentNode<ListContractorsQuery, ListContractorsQueryVariables>;
export const CheckoutUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCheckoutUrl"}}]}}]} as unknown as DocumentNode<CheckoutUrlMutation, CheckoutUrlMutationVariables>;
export const GetAllCopilotExchangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCopilotExchanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copilotExchangesConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopilotExchangeDeep"}}]}}]}}]}},...CopilotExchangeDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetAllCopilotExchangesQuery, GetAllCopilotExchangesQueryVariables>;
export const AskCopilotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AskCopilot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askCopilot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopilotResultFragment"}}]}}]}}]}},...CopilotResultFragmentFragmentDoc.definitions]} as unknown as DocumentNode<AskCopilotMutation, AskCopilotMutationVariables>;
export const CreateCopilotFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCopilotFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCopilotExchangesFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCopilotExchangesFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateCopilotFeedbackMutation, CreateCopilotFeedbackMutationVariables>;
export const UpdateCopilotFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCopilotFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCopilotExchangesFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCopilotExchangesFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateCopilotFeedbackMutation, UpdateCopilotFeedbackMutationVariables>;
export const RunClassificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunClassification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runClassification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RunClassificationMutation, RunClassificationMutationVariables>;
export const DescriptionReaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"descriptionReader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDescriptionReaderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descriptionReader"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]} as unknown as DocumentNode<DescriptionReaderMutation, DescriptionReaderMutationVariables>;
export const GetExternalAwsCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalAwsCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAwsCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessKeyId"}},{"kind":"Field","name":{"kind":"Name","value":"secretAccessKey"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}}]}}]}}]} as unknown as DocumentNode<GetExternalAwsCredentialsQuery, GetExternalAwsCredentialsQueryVariables>;
export const ListFlowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListFlows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowFields"}}]}}]}},...FlowFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ListFlowsQuery, ListFlowsQueryVariables>;
export const GetFlowWithActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlowWithActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowFields"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flowMailbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailLocalPart"}},{"kind":"Field","name":{"kind":"Name","value":"emailDomain"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flowActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"POSITION_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowActionFields"}}]}}]}}]}},...FlowFieldsFragmentDoc.definitions,...FlowActionFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetFlowWithActionsQuery, GetFlowWithActionsQueryVariables>;
export const ListFlowExecutionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListFlowExecutions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"triggerType"}},{"kind":"Field","alias":{"kind":"Name","value":"flowExecutionsConnection"},"name":{"kind":"Name","value":"flowExecutionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowExecutionFields"}}]}}]}}]}}]}},...FlowExecutionFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ListFlowExecutionsQuery, ListFlowExecutionsQueryVariables>;
export const GetFlowExecutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlowExecution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flowExecution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowExecutionFields"}},{"kind":"Field","name":{"kind":"Name","value":"flow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowFields"}},{"kind":"Field","name":{"kind":"Name","value":"flowActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"POSITION_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlowActionFields"}}]}}]}}]}}]}},...FlowExecutionFieldsFragmentDoc.definitions,...FlowFieldsFragmentDoc.definitions,...FlowActionFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetFlowExecutionQuery, GetFlowExecutionQueryVariables>;
export const GetForgeAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetForgeAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgeAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode<GetForgeAccessTokenQuery, GetForgeAccessTokenQueryVariables>;
export const GetEventsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyEventsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATED_AT_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoryEventDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},...HistoryEventDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetEventsForProjectQuery, GetEventsForProjectQueryVariables>;
export const CreateHistoryEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateHistoryEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateHistoryEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createHistoryEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoryEventDeep"}}]}}]}}]}},...HistoryEventDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateHistoryEventMutation, CreateHistoryEventMutationVariables>;
export const UpdateHistoryEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHistoryEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateHistoryEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHistoryEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoryEventDeep"}}]}}]}}]}},...HistoryEventDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateHistoryEventMutation, UpdateHistoryEventMutationVariables>;
export const GetEventGroupsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventGroupsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHistoryEventGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterCursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoryEventGroupDeep"}}]}}]}},...HistoryEventGroupDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetEventGroupsForProjectQuery, GetEventGroupsForProjectQueryVariables>;
export const GetCheckpointEventsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCheckpointEventsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isCheckpoint"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATED_AT_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoryEventDeep"}}]}}]}},...HistoryEventDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetCheckpointEventsForProjectQuery, GetCheckpointEventsForProjectQueryVariables>;
export const GetInitialStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInitialState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initialStateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initialState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initialStateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitialStateDeep"}}]}}]}},...InitialStateDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetInitialStateQuery, GetInitialStateQueryVariables>;
export const GetPublicInitialStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicInitialState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initialStateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicInitialStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initialStateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicInitialStateDeep"}}]}}]}},...PublicInitialStateDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetPublicInitialStateQuery, GetPublicInitialStateQueryVariables>;
export const GetViewFromInitialStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetViewFromInitialState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initialStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"viewId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"view"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SavedViewDetails"}}]}}]}}]}},...SavedViewDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetViewFromInitialStateQuery, GetViewFromInitialStateQueryVariables>;
export const CreateInitialStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInitialState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInitialStateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInitialState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initialState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitialStateDeep"}}]}}]}}]}},...InitialStateDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateInitialStateMutation, CreateInitialStateMutationVariables>;
export const GetIssueCommentsForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssueCommentsForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issueComments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueCommentDeep"}}]}}]}}]}},...IssueCommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetIssueCommentsForIssueQuery, GetIssueCommentsForIssueQueryVariables>;
export const CreateIssueCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIssueComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueCommentDeep"}}]}}]}}]}},...IssueCommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateIssueCommentMutation, CreateIssueCommentMutationVariables>;
export const UpdateIssueCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIssueComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssueComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueCommentDeep"}}]}}]}}]}},...IssueCommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateIssueCommentMutation, UpdateIssueCommentMutationVariables>;
export const DeleteIssueCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteIssueComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteIssueCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIssueComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueCommentDeep"}}]}}]}}]}},...IssueCommentDeepFragmentDoc.definitions]} as unknown as DocumentNode<DeleteIssueCommentMutation, DeleteIssueCommentMutationVariables>;
export const GetIssuesForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssuesForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueDeep"}}]}}]}}]}},...IssueDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetIssuesForProjectQuery, GetIssuesForProjectQueryVariables>;
export const CreateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueDeep"}}]}}]}}]}},...IssueDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateIssueMutation, CreateIssueMutationVariables>;
export const UpdateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueDeep"}}]}}]}}]}},...IssueDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateIssueMutation, UpdateIssueMutationVariables>;
export const DeleteIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueDeep"}}]}}]}}]}},...IssueDeepFragmentDoc.definitions]} as unknown as DocumentNode<DeleteIssueMutation, DeleteIssueMutationVariables>;
export const GetActiveModelsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveModelsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activeModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModelsDeep"}}]}}]}}]}},...ModelsDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetActiveModelsForProjectQuery, GetActiveModelsForProjectQueryVariables>;
export const GetModelsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetModelsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"models"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"forgeUrn"}},{"kind":"Field","name":{"kind":"Name","value":"activeViewGuid"}},{"kind":"Field","name":{"kind":"Name","value":"availableViewGuids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetModelsForProjectQuery, GetModelsForProjectQueryVariables>;
export const GetNextModelVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNextModelVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNextModelVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionName"}}}]}]}}]} as unknown as DocumentNode<GetNextModelVersionQuery, GetNextModelVersionQueryVariables>;
export const ModelProcessingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"modelProcessing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelStatusUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModelsDeep"}}]}}]}}]}},...ModelsDeepFragmentDoc.definitions]} as unknown as DocumentNode<ModelProcessingSubscription, ModelProcessingSubscriptionVariables>;
export const UpdateModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeViewGuid"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateModelMutation, UpdateModelMutationVariables>;
export const DeleteModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteModelMutation, DeleteModelMutationVariables>;
export const DeleteModelVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteModelVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteModelVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"versionName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteModelVersionMutation, DeleteModelVersionMutationVariables>;
export const CreateOrderColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderColumnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderColumnDeep"}}]}}]}}]}},...OrderColumnDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateOrderColumnMutation, CreateOrderColumnMutationVariables>;
export const UpdateOrderColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderColumnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderColumnDeep"}}]}}]}}]}},...OrderColumnDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateOrderColumnMutation, UpdateOrderColumnMutationVariables>;
export const DeleteOrderColumnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrderColumn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrderColumnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrderColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderColumnDeep"}}]}}]}}]}},...OrderColumnDeepFragmentDoc.definitions]} as unknown as DocumentNode<DeleteOrderColumnMutation, DeleteOrderColumnMutationVariables>;
export const GetOrderColumnDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderColumnDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderColumnDeep"}}]}}]}},...OrderColumnDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetOrderColumnDeepQuery, GetOrderColumnDeepQueryVariables>;
export const CreateOrderEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryDeep"}}]}}]}}]}},...OrderEntryDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateOrderEntryMutation, CreateOrderEntryMutationVariables>;
export const UpdateOrderEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryDeep"}}]}}]}}]}},...OrderEntryDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateOrderEntryMutation, UpdateOrderEntryMutationVariables>;
export const MoveOrCopyOrderEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveOrCopyOrderEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveOrCopyOrderEntriesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveOrCopyOrderEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryDeep"}}]}}]}}]}},...OrderEntryDeepFragmentDoc.definitions]} as unknown as DocumentNode<MoveOrCopyOrderEntriesMutation, MoveOrCopyOrderEntriesMutationVariables>;
export const FlattenSubrowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FlattenSubrows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlattenSubrowsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flattenSubrows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryDeep"}}]}}]}}]}},...OrderEntryDeepFragmentDoc.definitions]} as unknown as DocumentNode<FlattenSubrowsMutation, FlattenSubrowsMutationVariables>;
export const ApplyPromptLinkingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyPromptLinking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromptLinkingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyPromptLinking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ApplyPromptLinkingMutation, ApplyPromptLinkingMutationVariables>;
export const CreateOrderEntryViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderEntryView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderEntryViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderEntryView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryViewDeep"}}]}}]}}]}},...OrderEntryViewDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateOrderEntryViewMutation, CreateOrderEntryViewMutationVariables>;
export const DeleteOrderEntryViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrderEntryView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrderEntryViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrderEntryView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrderEntryViewMutation, DeleteOrderEntryViewMutationVariables>;
export const UpdateOrderEntryViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderEntryView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderEntryViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderEntryView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryViewDeep"}}]}}]}}]}},...OrderEntryViewDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateOrderEntryViewMutation, UpdateOrderEntryViewMutationVariables>;
export const GetOrderEntryViewsForProjectDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderEntryViewsForProjectDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderEntryViews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryViewDeep"}}]}}]}}]}},...OrderEntryViewDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetOrderEntryViewsForProjectDeepQuery, GetOrderEntryViewsForProjectDeepQueryVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}}]}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}}]}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const DeleteOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const DuplicateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}}]}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<DuplicateOrderMutation, DuplicateOrderMutationVariables>;
export const GetOrderDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetOrderDeepQuery, GetOrderDeepQueryVariables>;
export const GetOrdersForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrdersForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetOrdersForProjectQuery, GetOrdersForProjectQueryVariables>;
export const GetOrderLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}}]}}]}}]} as unknown as DocumentNode<GetOrderLabelsQuery, GetOrderLabelsQueryVariables>;
export const GetExternalAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresIn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiresIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresIn"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode<GetExternalAccessTokenQuery, GetExternalAccessTokenQueryVariables>;
export const BulkUpsertOrderEntryCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpsertOrderEntryCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpsertOrderEntryCacheInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpsertOrderEntryCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"orderEntryId"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpsertOrderEntryCacheMutation, BulkUpsertOrderEntryCacheMutationVariables>;
export const GetSavedViewsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedViewsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCommentView"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isCommentView"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCommentView"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SavedViewDetails"}}]}}]}},...SavedViewDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetSavedViewsForProjectQuery, GetSavedViewsForProjectQueryVariables>;
export const CreateSavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSavedViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSavedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SavedViewDetails"}}]}}]}}]}},...SavedViewDetailsFragmentDoc.definitions]} as unknown as DocumentNode<CreateSavedViewMutation, CreateSavedViewMutationVariables>;
export const UpdateSavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSavedViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSavedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SavedViewDetails"}}]}}]}}]}},...SavedViewDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;
export const DeleteSavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SavedViewDetails"}}]}}]}}]}},...SavedViewDetailsFragmentDoc.definitions]} as unknown as DocumentNode<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>;
export const GetProjectTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTagsConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTagDeep"}}]}}]}}]}},...ProjectTagDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectTagsQuery, GetProjectTagsQueryVariables>;
export const CreateProjectTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectTagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTagDeep"}}]}}]}}]}},...ProjectTagDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectTagMutation, CreateProjectTagMutationVariables>;
export const UpdateProjectTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectTagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTagDeep"}}]}}]}}]}},...ProjectTagDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateProjectTagMutation, UpdateProjectTagMutationVariables>;
export const DeleteProjectTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectTagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTagDeep"}}]}}]}}]}},...ProjectTagDeepFragmentDoc.definitions]} as unknown as DocumentNode<DeleteProjectTagMutation, DeleteProjectTagMutationVariables>;
export const GetProjectTemplatesPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectTemplatesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTemplatesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplateDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},...ProjectTemplateDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectTemplatesPageQuery, GetProjectTemplatesPageQueryVariables>;
export const CreateProjectFromTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectFromTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"theProjectTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectFromTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"theProjectTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"theProjectTemplateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectDeep"}}]}}]}}]}},...ProjectDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>;
export const CreateTableFromTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTableFromTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTableFromTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ordername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"theProjectTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDeep"}}]}}]}}]}},...OrderDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateTableFromTemplateMutation, CreateTableFromTemplateMutationVariables>;
export const RenameProjectTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameProjectTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"templateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplateDeep"}}]}}]}}]}},...ProjectTemplateDeepFragmentDoc.definitions]} as unknown as DocumentNode<RenameProjectTemplateMutation, RenameProjectTemplateMutationVariables>;
export const CreateTemplateFromProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTemplateFromProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTemplateFromProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"templateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplateDeep"}}]}}]}}]}},...ProjectTemplateDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateTemplateFromProjectMutation, CreateTemplateFromProjectMutationVariables>;
export const DeleteProjectTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectTemplateMutation, DeleteProjectTemplateMutationVariables>;
export const GetOrdersForProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrdersForProjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrdersForProjectsQuery, GetOrdersForProjectsQueryVariables>;
export const GetTagsByProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTagsByProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]} as unknown as DocumentNode<GetTagsByProjectQuery, GetTagsByProjectQueryVariables>;
export const GetProjectPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATED_AT_DESC"},{"kind":"EnumValue","value":"PRIMARY_KEY_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectPageQuery, GetProjectPageQueryVariables>;
export const GetSparkelAiAnalysisByProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSparkelAiAnalysisByProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sparkelAiAnalyses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<GetSparkelAiAnalysisByProjectQuery, GetSparkelAiAnalysisByProjectQueryVariables>;
export const GetProjectSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerGlobalOffset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedOrderLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedElementsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"dropdownValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"colorScheme"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translationType"}},{"kind":"Field","name":{"kind":"Name","value":"polygonCalculationLimit"}},{"kind":"Field","name":{"kind":"Name","value":"unitSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"manuallyApplyFilters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}}]}}]} as unknown as DocumentNode<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export const GetProjectDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectDeep"}}]}}]}},...ProjectDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectDeepQuery, GetProjectDeepQueryVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectDeep"}}]}}]}}]}},...ProjectDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerGlobalOffset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedOrderLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedElementsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"dropdownValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"colorScheme"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translationType"}},{"kind":"Field","name":{"kind":"Name","value":"polygonCalculationLimit"}},{"kind":"Field","name":{"kind":"Name","value":"unitSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"rounding"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"manuallyApplyFilters"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const DuplicateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectDeep"}}]}}]}}]}},...ProjectDeepFragmentDoc.definitions]} as unknown as DocumentNode<DuplicateProjectMutation, DuplicateProjectMutationVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const CreateProjectFromDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectFromDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectFromDocumentsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectFromDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<CreateProjectFromDocumentsMutation, CreateProjectFromDocumentsMutationVariables>;
export const CreateProjectFromDocumentsStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateProjectFromDocumentsStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectFromDocumentsStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]} as unknown as DocumentNode<CreateProjectFromDocumentsStatusQuery, CreateProjectFromDocumentsStatusQueryVariables>;
export const GetProtanProjectStepsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProtanProjectStepsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"protanProjectSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProtanProjectStepDeep"}}]}}]}}]}},...ProtanProjectStepDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetProtanProjectStepsForProjectQuery, GetProtanProjectStepsForProjectQueryVariables>;
export const UpsertProtanProjectStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertProtanProjectStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertProtanProjectStepInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertProtanProjectStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"protanProjectSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProtanProjectStepDeep"}}]}}]}}]}},...ProtanProjectStepDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpsertProtanProjectStepMutation, UpsertProtanProjectStepMutationVariables>;
export const GetOrderEntryTemplatesPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderEntryTemplatesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"500"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryTemplatesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryTemplateDeep"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},...OrderEntryTemplateDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetOrderEntryTemplatesPageQuery, GetOrderEntryTemplatesPageQueryVariables>;
export const CreateTemplateFromOrderEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTemplateFromOrderEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTemplateFromOrderEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theOrderEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderEntryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"templateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryTemplateDeep"}}]}}]}}]}},...OrderEntryTemplateDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateTemplateFromOrderEntryMutation, CreateTemplateFromOrderEntryMutationVariables>;
export const CreateOrderEntryFromTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderEntryFromTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderEntryFromTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderEntryFromTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryDeep"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderColumns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderColumnDeep"}}]}}]}}]}}]}}]}},...OrderEntryDeepFragmentDoc.definitions,...OrderColumnDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateOrderEntryFromTemplateMutation, CreateOrderEntryFromTemplateMutationVariables>;
export const RenameOrderEntryTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameOrderEntryTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderEntryTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"templateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderEntryTemplateDeep"}}]}}]}}]}},...OrderEntryTemplateDeepFragmentDoc.definitions]} as unknown as DocumentNode<RenameOrderEntryTemplateMutation, RenameOrderEntryTemplateMutationVariables>;
export const DeleteOrderEntryTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrderEntryTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrderEntryTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrderEntryTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEntryTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrderEntryTemplateMutation, DeleteOrderEntryTemplateMutationVariables>;
export const CreateShapeFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShapeFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShapeFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShapeFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shapeFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeFolderDeep"}}]}}]}}]}},...ShapeFolderDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateShapeFolderMutation, CreateShapeFolderMutationVariables>;
export const UpdateShapeFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShapeFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShapeFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShapeFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shapeFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeFolderDeep"}}]}}]}}]}},...ShapeFolderDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateShapeFolderMutation, UpdateShapeFolderMutationVariables>;
export const DeleteShapeFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteShapeFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteShapeFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteShapeFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shapeFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteShapeFolderMutation, DeleteShapeFolderMutationVariables>;
export const GetShapeFoldersForProjectDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShapeFoldersForProjectDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapeFolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeFolderDeep"}}]}}]}}]}},...ShapeFolderDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetShapeFoldersForProjectDeepQuery, GetShapeFoldersForProjectDeepQueryVariables>;
export const UpdateFolderForShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFolderForShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folder"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFolderForShapesMutation, UpdateFolderForShapesMutationVariables>;
export const CreateShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeDeep"}}]}}]}}]}},...ShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateShapeMutation, CreateShapeMutationVariables>;
export const UpdateShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeDeep"}}]}}]}}]}},...ShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateShapeMutation, UpdateShapeMutationVariables>;
export const DeleteShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteShapeMutation, DeleteShapeMutationVariables>;
export const BulkDeleteShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteShapesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<BulkDeleteShapesMutation, BulkDeleteShapesMutationVariables>;
export const BulkCreateShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkCreateShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkCreateShapesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkCreateShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeDeep"}}]}}]}}]}},...ShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<BulkCreateShapesMutation, BulkCreateShapesMutationVariables>;
export const BulkUpdateShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateShapesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeDeep"}}]}}]}}]}},...ShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<BulkUpdateShapesMutation, BulkUpdateShapesMutationVariables>;
export const GetShapesForProjectDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShapesForProjectDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShapeDeep"}}]}}]}}]}},...ShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetShapesForProjectDeepQuery, GetShapesForProjectDeepQueryVariables>;
export const ExportShapesToIfcDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportShapesToIfc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportShapesToIfcInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportShapesToIfc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<ExportShapesToIfcMutation, ExportShapesToIfcMutationVariables>;
export const ExportShapesToIfcStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportShapesToIfcStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportShapesToIfcStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ExportShapesToIfcStatusQuery, ExportShapesToIfcStatusQueryVariables>;
export const GetSharedLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSharedLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initialStateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"orderIds"}}]}}]}}]} as unknown as DocumentNode<GetSharedLinksQuery, GetSharedLinksQueryVariables>;
export const GetSharedLinksForOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSharedLinksForOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<GetSharedLinksForOrderQuery, GetSharedLinksForOrderQueryVariables>;
export const DeleteSharedLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSharedLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSharedLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSharedLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSharedLinkMutation, DeleteSharedLinkMutationVariables>;
export const CreateSharedLinkWithDurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSharedLinkWithDuration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initialStateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresInSeconds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSharedLinkWithDuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"theInitialStateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initialStateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"theName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"theExpiresInSeconds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresInSeconds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"theOrderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initialStateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"orderIds"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSharedLinkWithDurationMutation, CreateSharedLinkWithDurationMutationVariables>;
export const CreateSheetShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSheetShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSheetShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSheetShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetShapeDeep"}}]}}]}}]}},...SheetShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateSheetShapeMutation, CreateSheetShapeMutationVariables>;
export const UpdateSheetShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSheetShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSheetShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSheetShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetShapeDeep"}}]}}]}}]}},...SheetShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<UpdateSheetShapeMutation, UpdateSheetShapeMutationVariables>;
export const DeleteSheetShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSheetShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSheetShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSheetShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetShape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"sheetId"}},{"kind":"Field","name":{"kind":"Name","value":"sheetPageNumber"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSheetShapeMutation, DeleteSheetShapeMutationVariables>;
export const BulkDeleteSheetShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteSheetShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteSheetShapesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteSheetShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"sheetId"}},{"kind":"Field","name":{"kind":"Name","value":"sheetPageNumber"}}]}}]}}]}}]} as unknown as DocumentNode<BulkDeleteSheetShapesMutation, BulkDeleteSheetShapesMutationVariables>;
export const BulkCreateSheetShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkCreateSheetShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkCreateSheetShapesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkCreateSheetShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetShapeDeep"}}]}}]}}]}},...SheetShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<BulkCreateSheetShapesMutation, BulkCreateSheetShapesMutationVariables>;
export const BulkUpdateSheetShapesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateSheetShapes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateSheetShapesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateSheetShapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetShapeDeep"}}]}}]}}]}},...SheetShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<BulkUpdateSheetShapesMutation, BulkUpdateSheetShapesMutationVariables>;
export const GetSheetShapesForProjectDeepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSheetShapesForProjectDeep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sheetShapes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetShapeDeep"}}]}}]}}]}},...SheetShapeDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetSheetShapesForProjectDeepQuery, GetSheetShapesForProjectDeepQueryVariables>;
export const GetMagicSheetShapeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetMagicSheetShape"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetMagicSheetShapeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMagicSheetShape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMagicSheetShapeMutation, GetMagicSheetShapeMutationVariables>;
export const GetSheetsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSheetsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetsDeep"}}]}}]}},...SheetsDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetSheetsForProjectQuery, GetSheetsForProjectQueryVariables>;
export const GetActiveSheetsForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveSheetsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activeSheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetsDeep"}}]}}]}}]}},...SheetsDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetActiveSheetsForProjectQuery, GetActiveSheetsForProjectQueryVariables>;
export const GetActiveSheetsForOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveSheetsForOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSheets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetsDeep"}}]}}]}}]}}]}},...SheetsDeepFragmentDoc.definitions]} as unknown as DocumentNode<GetActiveSheetsForOrderQuery, GetActiveSheetsForOrderQueryVariables>;
export const CreateSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSheetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetsDeep"}}]}}]}}]}},...SheetsDeepFragmentDoc.definitions]} as unknown as DocumentNode<CreateSheetMutation, CreateSheetMutationVariables>;
export const CreateCalibrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCalibration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSheetPageCalibrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSheetPageCalibration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetPageCalibration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetPageCalibration"}}]}}]}}]}},...SheetPageCalibrationFragmentDoc.definitions]} as unknown as DocumentNode<CreateCalibrationMutation, CreateCalibrationMutationVariables>;
export const UpdateCalibrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCalibration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSheetPageCalibrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSheetPageCalibration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheetPageCalibration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SheetPageCalibration"}}]}}]}}]}},...SheetPageCalibrationFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCalibrationMutation, UpdateCalibrationMutationVariables>;
export const DeleteSheetVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSheetVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSheetVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"versionName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSheetVersionMutation, DeleteSheetVersionMutationVariables>;
export const GetSparkelPropertiesForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSparkelPropertiesForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sparkelProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SparkelPropertyInfo"}}]}}]}}]}},...SparkelPropertyInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetSparkelPropertiesForProjectQuery, GetSparkelPropertiesForProjectQueryVariables>;
export const GetSparkelPropertiesForOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSparkelPropertiesForOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sparkelProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SparkelPropertyInfo"}}]}}]}}]}}]}},...SparkelPropertyInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetSparkelPropertiesForOrderQuery, GetSparkelPropertiesForOrderQueryVariables>;
export const BulkUpsertSparkelPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpsertSparkelProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpsertSparkelPropertiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpsertSparkelProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sparkelProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SparkelPropertyInfo"}}]}}]}}]}},...SparkelPropertyInfoFragmentDoc.definitions]} as unknown as DocumentNode<BulkUpsertSparkelPropertiesMutation, BulkUpsertSparkelPropertiesMutationVariables>;
export const BulkDeleteSparkelPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteSparkelProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteSparkelPropertiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteSparkelProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sparkelProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SparkelPropertyInfo"}}]}}]}}]}},...SparkelPropertyInfoFragmentDoc.definitions]} as unknown as DocumentNode<BulkDeleteSparkelPropertiesMutation, BulkDeleteSparkelPropertiesMutationVariables>;
export const ListUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"accessProjectIds"}}]}}]}}]} as unknown as DocumentNode<ListUsersQuery, ListUsersQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"password"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateAccessibleProjectsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccessibleProjectsForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccessibleProjectsForUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateAccessibleProjectsForUserMutation, UpdateAccessibleProjectsForUserMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;